const translations = {
  en: {
    home_banner_title1: 'New minibook',
    home_banner_title2: 'New event',
    home_slide_title1: 'Trending now',
    home_slide_title2: 'My taste',
    home_slide_title3: 'Hot right now',
    home_slide_title4: 'Very popular',
    home_detail_title1: 'Everyday memories',
    home_detail_title2: 'Recommended videos',
    home_detail_title3: 'If you want to know more',
    home_detail_text1: 'Minibook memo',
    home_detail_text2: 'Daily memo',
    home_setting_title: 'Setting',
    home_setting_text1: 'Pages viewed in the past 30 days',
    home_setting_text2: 'Log out',
    home_setting_text3: 'Delete account',
    home_book_banner_question: 'I am curious',
    home_book_banner_write_placeholder1: 'Enter a title',
    home_book_banner_write_placeholder2: 'Enter a post',
    home_book_banner_detail_text1: 'YouBook mentor\'s answer',
    home_book_banner_detail_text2: 'Related Minibooks',
    home_book_create_button: 'Make a Minibook',
    home_book_create_text1: 'A minibook is a short book of about 10 pages. It’s designed for those who want to read concise but essential content quickly, fitting modern reading trends.',
    home_book_create_text2: 'How to edit after publication',
    home_book_create_text3: 'Minibook, easy way to make',
    home_book_create_text4: 'How much revenue can an author earn?',
    home_book_create_text5: 'How do I connect with readers?',
    home_book_create_text6: '5 reasons why YouBook is a must-use platform',
    home_book_create_text7: 'Any other questions?',
    home_book_create_text8: 'Can I check sales in real-time?',
    home_book_create_text9: 'Let’s keep writing every day!',
    home_book_create_text10: 'Try it now!',
    home_book_category_title1: 'Today Issue and Minibook',
    home_book_category_title2: 'Trending Minibooks',
    home_book_category_title3: 'S-class Professor Minibooks',
    home_book_category_title4: 'Personalized Recommendations',
    home_book_category_title5: 'Bestseller Essentials Minibooks',
    home_book_category_title6: 'With Bookitty',
    home_book_category_title6_text1: 'Expand',
    home_book_category_title6_text2: 'Collapse',
    home_book_category_title7: 'Exploring Neural Network Pages',
    home_book_category_title8: 'Art & Emotion Showcase',
    home_book_category_title8_text1: 'Worlds in Movies & Dramas',
    home_book_category_title8_text2: 'Soul-Stirring Music & Dance',
    home_book_category_title8_text3: 'Art Beyond Borders',
    home_book_category_title8_text4: 'Wear Personality: Fashion & Style',
    home_book_category_title9: 'Culinary Culture of Taste & Leisure',
    home_book_category_title9_text1: 'Culinary Exploration of Local Dishes',
    home_book_category_title9_text2: 'Stories of Alcohol & Life',
    home_book_category_title9_text3: 'Charm of Snacks & Desserts',
    home_book_category_title9_text4: 'Nature’s Power, Plant Secrets',
    home_book_category_title10: 'Wisdom & Self-Discovery',
    home_book_category_title10_text1: 'Unique Money Management',
    home_book_category_title10_text2: 'Personal Growth Secrets',
    home_book_category_title10_text3: 'Solutions to Relationship Issues',
    home_book_category_title10_text4: 'New Discoveries & Knowledge',
    home_book_category_title11: 'Diverse perspectives and love',
    home_book_category_title11_text1: 'Stories of Their Lives',
    home_book_category_title11_text2: 'Different Philosophies & Values',
    home_book_category_title11_text3: 'Religious Beliefs & Traditions',
    home_book_category_title11_text4: 'Mysteries of Love',
    home_book_category_title12: 'Days Filled with Travel & Hobbies',
    home_book_category_title12_text1: 'Must-Visit Hidden Destinations',
    home_book_category_title12_text2: 'Joy of Life Through Hobbies',
    home_book_category_title12_text3: 'Unique Cultures Through Play',
    home_book_category_title13: 'Richness of Tradition & Stories',
    home_book_category_title13_text1: 'Local Myths & Hero Stories',
    home_book_category_title13_text2: 'Global Literary Journeys',
    home_book_category_title13_text3: 'History & Wisdom of Places',
    home_book_category_title13_text4: 'Colorful Social Narratives',
    book_create_category_option24: 'Common Sense',

    home_book_category_title1_text2: 'Bookitty’s thoughts – Want a little peek?',
    home_book_category_title1_text3: 'Worried? Curious?',
    home_book_category_title1_text4: 'Shall I recommend a minibook?',
    home_book_search_placeholder1: 'Please speak here',
    home_book_search_placeholder2: 'What\'s the keyword?',
    home_book_search_message1: 'Enter your questions',
    home_book_search_message2: 'Enter your questions again',
    home_book_search_text1: 'Why not discuss with me?',
    home_book_search_text2: 'Why not discuss with me?',
    home_book_search_text3: 'Ask',
    home_book_search_text4: 'You can save the above',
    home_book_search_text5: '(Just add keywords)',
    home_book_search_text6: 'Search',

    home_book_theme_title: 'Books by theme',
    home_instant_text1: 'Enter a keyword',
    home_instant_text2: 'Enter randomly',
    home_book_company_info: 'If you have any further inquiries, please don\'t hesitate to contact us below. We\'re here to assist you.',

    home_page_search_text1: 'Page search',
    home_page_search_text2: 'Instantly play as a video',
    home_page_search_text3: 'Advanced search',
    home_page_search_text4: 'List view',
    home_page_search_text5: 'Network view',
    home_page_explor_alert: 'No pages have been selected',
    home_page_explor_alert2: 'You have exceeded the maximum number of pages that can be viewed on one screen (150). Please place unnecessary pages in the trash..',
    home_page_explor_alert3: 'There is no more information to load',
    my_login_title: 'MY',
    my_login_text1: 'Make your profile stylishly',
    my_login_text2: 'Log in now and get smart',
    my_login_text3: 'with YouBook',
    my_login_find_password: 'Find password',
    my_guide_minibook: 'How to make a Minibook',
    my_password_reset: 'Reset password',
    my_password_reset_text1: 'Enter your previous email for LOGIN',
    my_password_reset_button1: 'Send a link for reset',
    my_password_reset_button2: 'Reset',
    my_password_reset_message1: 'Unable to find your email',
    my_password_reset_message2: 'We have sent a password reset link to the email you provided.',
    my_password_reset_message3: 'Please reset your password using the link sent to your email.',
    my_password_reset_placeholder1: 'Your email',
    my_password_reset_placeholder2: 'Enter your new password',
    my_password_reset_placeholder3: 'Re-enter your new password',
    my_password_reset_message4: 'Passwords do not match',
    my_password_reset_message5: 'The password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character',
    my_password_reset_message6: 'The password has been reset',
    my_memo_list_placeholder: 'Have an idea? Write it down now',
    my_profile_placehoder1: 'My interest',
    my_profile_placehoder2: 'My name',
    my_profile_placehoder3: 'Briefly introduce myself',
    my_profile_placehoder4: 'Additional introductions',
    my_profile_text1: 'Nationality',
    my_profile_text2: 'Language',
    my_profile_text3: 'Change ID',
    my_profile_text4: 'Current ID',
    my_profile_text5: 'New ID to change',
    my_profile_text6: 'ID change is allowed only once',
    my_menu_text1: 'My Journey',
    my_menu_text2: 'Message',
    my_menu_text3: 'Purchase & Settlement',
    my_menu_text4: 'New \nNotification',
    my_menu_text5: 'Make a \n Minibook',
    my_menu_text6: 'Minibooks \n made',
    my_menu_text7: 'Want to import posts from other apps?',
    my_menu_text8: 'You can import automatically and convert them into pages',
    my_menu_text9: 'Import',
    my_import_book_text1: 'Convert to page',
    my_import_book_text2: 'Converting ZIP file content into pages. Each takes up to 5 seconds. 10 pages take about 1 minute, 100 pages about 8 minutes. A popup will notify you when conversion is done.',
    my_import_book_text3: 'Done',
    my_import_book_text4: 'Page Conversion Complete',
    my_import_book_text5: 'All contents from the ZIP file were converted to pages. Each item is now a separate page. Check them in My Journey - Pages made. Pages are temporarily saved and can be edited.',
    my_import_book_text6: 'You can import posts from other apps and automatically convert them into pages. Then you can group the pages into a minibook.',
    my_import_book_text7: 'How to import posts from other apps using a ZIP file',
    my_import_book_text8: 'Please upload a ZIP file',
    my_import_book_text9: 'Upload Substack file',
    my_import_book_text10: 'Upload Medium file',
    my_import_book_text11: 'Search',
    my_import_book_text12: '* Each post will be converted into a separate page',
    my_import_book_text13: '* You can check this in My Page - Settings - Pages made',
    my_import_book_text14: '* Pages are temporarily saved and editable',
    my_import_book_text15: '* You can only import posts you wrote',
    my_import_book_text16: 'Publish a minibook using the converted pages',
    my_import_book_text17: 'Create the cover of the minibook',
    my_import_book_text18: 'Choose pages to add to the minibook',
    my_import_book_text19: 'Publish the minibook',
    my_import_book_text20: 'Be sure to read the instructions carefully',
    my_import_book_text21: 'Not a ZIP file',
    my_import_book_text22: 'Please upload a file',

    my_journey_title: 'Journey',
    my_journey_button_message: 'Message',
    my_journey_button_memo: 'Memo',
    my_journey_button_record: 'Record',
    my_journey_button_follow: 'Follow',
    my_journey_button_follow_cancel: 'unFollow',
    my_journey_message_text1: 'Leave a message',
    my_journey_message_placeholder: 'Enter your message',
    my_journey_message_message1: 'Unable to respond',
    my_journey_message_message2: 'Sending',
    my_journey_message_message3: 'Enter your message',

    my_journey_memo_total: 'Total',
    my_journey_record_overall: 'Influence ranking',
    my_journey_record_text1: 'Pages viewed',
    my_journey_record_text2: 'Minibooks favorite',
    my_journey_record_text3: 'Favorite Event space',
    my_journey_record_text4: 'Pages made',
    my_journey_record_text5: 'Minibooks made',
    my_journey_record_text6: 'Event space created',
    my_journey_record_text7: 'This month',
    my_journey_record_text8: 'Purchased minibook',
    my_journey_record_text9: 'Public',
    my_journey_record_text10: 'Private',
    my_journey_record_text11: 'Purchased event',
    my_journey_record_text12: 'The event I created',
    my_journey_record_text13: 'Ranked #{userRank} in {userLanguage} category',
    my_journey_record_text14: 'Shared author rights minibook',
    my_journey_record_text15: 'Do you want readers to follow a specific reading order? If so, drag the cover to change the order.',
    my_journey_record_text16: 'Support the new minibook',
    my_journey_record_text17: 'Reader support messages',
    my_journey_record_text18: 'Leave a message of support for the author',
    my_journey_record_text19: 'Supporter Level',
    my_journey_record_text20: 'Level {cheeringLevel} of 10',
    my_journey_record_text21: 'People I support',
    my_journey_record_text22: 'My supporters',
    my_journey_record_text23: 'Do you want to delete it?',
    my_journey_record_text24: 'Supporter of {userName}',
    my_journey_record_text25: 'Supported by {userName}',
    my_notice_title: 'Notification',
    my_notice_message1: 'There are no new notifications',
    my_notice_text1: 'A new Minibook Issue has arrived',
    my_notice_text2: 'A new Today Issue has arrived',
    my_notice_text3: 'A new message to My journey ',
    my_notice_text4: 'A new comment to my Memo ',
    my_notice_text5: 'A new comment to my Event space',
    my_notice_text6: 'A new comment to my Minibook cover',
    my_notice_text7: 'A new comment to my Minibook page',
    my_notice_text8: 'posted a new Memo',
    my_notice_text9: '{userName} has created a new Event space',
    my_notice_text10: 'published a new Minibook',
    my_notice_text11: 'purchased my minibook',
    my_notice_text12: '{userName} has created a <b>new event</b>',
    my_notice_text13: '{userName} has specially invited you to the <b>new event</b>. Don\'t miss out!',
    my_notice_text14: '{userName} has <b>purchased my event</b>',
    my_notice_text15: '{userName} has applied for co-authorship',
    my_notice_text16: 'The co-author application for the open minibook has been approved',
    my_notice_text17: 'A new comment has been posted by a co-author',
    my_notice_text18: 'A message has arrived to support the new minibook',
    my_notice_text19: '{userName} sponsored <b>my minibook</b>',
    my_marketing_banner_title: 'Cheer Myself On',
    my_marketing_banner_text1: 'You overcame challenges, now show your support',
    my_marketing_banner_btn: 'Cheer Now',
    my_marketing_title: 'Cheer Now',
    my_marketing_text1: 'Become an influencer with the two wings of minibook and event - fueled by step-by-step promotion',
    my_marketing_text2: 'Email to general readers',
    my_marketing_text3: 'Text to general readers',
    my_marketing_text4: 'Email to friends',
    my_marketing_text5: 'Text to friends',
    my_marketing_text6: 'Link to social media',
    my_marketing_btn: 'Start Now',
    my_marketing_minibook_step1_title: 'Minibook Support',
    my_marketing_step1_subtitle: 'Link to social media',
    my_marketing_minibook_step1_text1: 'Link your minibook to your social media and add an attractive description',
    my_marketing_minibook_text1: 'Find your minibook',
    my_marketing_step1_text1: 'Copy the link',
    my_marketing_step1_btn: 'Copy',
    my_marketing_step1_text2: 'Paste it on social media and add a description',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'Please select a minibook to share',
    my_marketing_step1_text4: 'Link copied',
    my_marketing_step1_text5: 'Please select an event to share',
    my_marketing_step1_text6: 'Find social media',
    my_marketing_event_step1_title: 'Event Support',
    my_marketing_event_step1_text1: 'Link your event to your social media and add an attractive description',
    my_marketing_event_text1: 'Find your event',
    my_marketing_event_search_title: 'Search event',
    my_marketing_minibook_step2_title: 'Minibook Step 2 Marketing',
    my_marketing_step2_subtitle: 'Text to friends',
    my_marketing_minibook_step2_text1: 'Send your friends the minibook link with a heartfelt introduction',
    my_marketing_step2_text2: 'Send your friend an introduction with the link',
    my_marketing_step2_placeholder: 'Enter an introduction',
    my_marketing_tab_text1: 'My friends',
    my_marketing_event_step2_title: 'Event Step 2 Marketing',
    my_marketing_event_step2_text1: 'Send your friends the event link with a heartfelt introduction',
    my_marketing_minibook_step3_title: 'Minibook Step 3 Marketing',
    my_marketing_step3_subtitle: 'Email to friends',
    my_marketing_minibook_step3_text1: 'Send your friends the minibook link along with the backstory',
    my_marketing_step3_text1: 'Import contact list',
    my_marketing_step3_placeholder: 'Upload csv or vcf file',
    my_marketing_step3_text2: 'Share the story with your friend along with the link',
    my_marketing_step3_text3: 'Import phone number list',
    my_marketing_step3_placeholder2: 'Share the story',
    my_marketing_event_step3_title: 'Event Step 3 Marketing',
    my_marketing_event_step3_text1: 'Send your friends the event link along with the backstory',
    my_marketing_text7: 'Import phone numbers',
    my_marketing_title2: 'Manage phone numbers',
    my_marketing_text8: 'Phone',
    my_marketing_text9: 'Count',
    my_marketing_text10: 'Import contacts',
    my_marketing_text11: 'Please upload a csv or vcf file',
    my_marketing_text12: 'How to import',
    my_marketing_text13: 'Import',
    my_marketing_title3: 'Manage contacts',
    contact_manage: 'Contact Management',
    my_marketing_text14: 'Delete selected',
    my_marketing_text15: 'Please select a friend',
    my_marketing_text16: 'You can select up to 100 friends',
    my_marketing_text17: 'Upload completed',
    my_marketing_text18: 'Character limit exceeded',
    contact_phone: 'Phone',
    contact_organization: 'Organization',
    contact_title: 'Title',
    contact_memo: 'Memo',
    my_marketing_text19: 'Edit selection',
    my_marketing_text20: 'Select label',
    my_marketing_text21: 'Add new label',
    my_marketing_text22: 'Delete selected label',
    my_marketing_text23: 'Add',
    my_marketing_btn2: 'Done editing',
    my_marketing_text24: 'Please select a contact to edit',
    my_marketing_text25: 'Please select a label to delete',
    my_marketing_text26: 'Please enter a label name',
    my_marketing_text27: 'This label already exists',
    my_marketing_text28: 'Add label',
    my_marketing_text29: 'Cancel',
    my_marketing_text30: 'Added',
    my_benefit_text1: 'You\'ve gained so far',
    my_benefit_text2: 'You\'ll gain in a year',
    my_benefit_text3: '',
    my_benefit_text4: 'the gain calculation',
    my_benefit_text5: 'the gain calculation',
    my_benefit_text6: 'Check out ',
    my_benefit_modal_text1: 'You\'ve gained so far',
    my_benefit_modal_text2: 'USD',
    my_benefit_modal_text3: '이익을 얻었습니다',
    my_benefit_modal_text4: 'Let\'s do a very simple calculation',
    my_benefit_modal_text5: 'Number of pages read so far',
    my_benefit_modal_text6: 'Price to make a page',
    my_benefit_modal_text7: 'USD',
    my_benefit_modal_text8: 'So, your gain is',
    my_benefit_modal_text9: 'Now, add benefits of discussions with',
    my_benefit_modal_text10: 'AI, and your gains will be even greater',
    my_benefit_modal_text11: 'Use it every day and reap the gains',
    my_benefit_modal_text12: 'Ok I got it',

    my_story_text1: 'What members say',
    my_story_text2: 'Realize that books are experienced, not read',
    my_story_text3: 'Amazing what happens when learn every day',
    my_story_text4: 'Hidden pitfalls of smart people, are you one?',
    my_story_text5: 'Check more of the member story',

    my_go_blog_text1: 'YouBook, News and Customer Stories',
    my_go_blog_text2: 'Discover the latest news and customer stories from YouBook',
    my_go_blog_text3: 'Read More',

    my_channel_text1: 'What do you think of YouBook?',
    my_channel_text2: 'Tell what\'s good and what we can do better',
    my_channel_text3: 'And, let us know if you have any questions',
    my_channel_text4: 'Say a word',
    my_about_youbook_text1: 'Why should use YouBook',
    my_about_youbook_text2: 'All your Q&A is here',
    my_about_youbook_text3: 'Terms of Service',
    my_app_text1: 'Youbook is a 100% beneficial app.',
    my_app_text2: 'Download it now and gain knowledge',
    my_app_text3: 'Download app',

    login_title: 'LOGIN',
    login_text1: 'LOGIN with email',
    login_text2: 'Not registered yet?',
    login_text3: 'Forgot password?',
    login_text4: 'or LOGIN with',
    login_text5: 'I Agree',
    login_placeholder1: 'Login email',
    login_placeholder2: 'Password',
    login_placeholder3: 'Profile ID',
    login_message1: 'Please enter your login email',
    login_message2: 'Enter your password',
    login_message3: 'Login successful',
    login_message4: 'Please enter your Profile ID',
    logout_message1: 'Want to log out?',
    login_link1: 'Sign up',
    login_link2: 'Find',
    login_link3: 'Terms of Service',

    register_title: 'Sign up',
    register_text1: 'Sign up with email',
    register_text2: 'Select membership type',
    register_text3: 'Personal',
    register_text4: 'Organizational',
    register_text5: 'Enter your information',
    register_text6: 'Already registered?',
    register_text7: 'Corporate registration number',
    register_text8: 'Business registration number',
    register_text9: 'Organization name',
    register_placeholder1: 'Your phone number including area code',
    register_placeholder2: '( without - )',
    register_placeholder_repassword: 'Re-enter password',
    register_message1: 'Enter your phone number',
    register_message2: 'Enter the corporate registration number',
    register_message3: 'Please enter the business registration number',
    register_message4: 'Please enter the organization name',
    register_message5: 'Invalid email format',
    register_message6: 'This email is already registered',
    register_message7: 'Please verify your email',
    register_message8: 'Please choose your nationality',
    register_message9: 'Invalid ID format',
    register_message10: 'The ID you entered is not available. Please use a suggested ID or enter a different one',
    register_message11: 'Please verify your Profile ID',
    register_message12: 'This ID is already in use. Please use a suggested ID or enter a different one',
    register_button_verify: 'Verify',
    register_button_verify_fail: 'Not Verified',
    register_button_verify_success: 'Verified',
    register_welcome_message: 'Welcome to membership',
    withdraw_text1: 'Membership Cancellation',
    withdraw_text2: 'Cancel YouBook Membership',
    withdraw_text3: 'Are you sure you want to cancel?',
    withdraw_text4: 'No',
    withdraw_text5: 'Yes',
    withdraw_text6: 'You have successfully cancelled your membership',
    home_memo_title: 'Memo',
    home_memo_subtitle: 'If don\'t take memo, you forget ',
    home_memo_text1: 'Shared together by all',
    home_memo_text2: 'Knowledge and everyday stories',
    home_memo_button: 'Leave a memo',
    home_memo_create_text1: 'Do you have a minibook to link?',
    home_memo_create_button: 'Find a minibook',
    home_memo_create_button2: 'Select',
    home_memo_click: 'Click',
    home_memo_date: 'YYYY. M. D',
    home_memo_button_askai: 'Comment / Bookitty’s thoughts',
    home_memo_view_detail: 'View details',
    home_memo_view_placeholder: 'Enter a post',
    home_memo_view_button1: 'Comment',
    home_memo_view_button2: 'Bookitty’s thoughts',
    home_memo_view_errormessage: 'Enter a post',

    memo_create_title: 'Memo',
    memo_create_category1: 'Memo',
    memo_create_category2: 'Memo',
    memo_create_private: 'Private',
    memo_create_public: 'Public',
    memo_create_placeholder1: 'Have an idea?',
    memo_create_placeholder2: 'Write it down now',
    memo_create_placeholder3: 'Keywords (a blank between them)',
    memo_create_button: 'Save',
    memo_create_error: 'Enter your memo',
    memo_attach_img: 'Upload image',
    memo_alert_rate: 'Please select your star rating',
    memo_alert_save: 'Saved. You can check it in My profile - My Journey',
    memo_input_placeholder: 'What did you learn?',
    memo_input_placeholder2: 'What are your thoughts?',
    memo_input_placeholder3: 'Share it with readers now~',
    memo_input_placeholder4: 'A memory from daily life, shall we record it?',
    memo_alert_keywords: 'Enter keywords',
    memo_related_text: 'Memo',
    memo_related_date: 'YYYY. M. D',
    memo_popup_text1: 'Nicholas Luhmann\'s story reads like a modern-day fable showing the transformative power of a simple habit.',
    memo_popup_text3: 'Initially, Luhmann was a young employee in a corporate setting, far removed from the world of academia.',
    memo_popup_text4: 'However, his voracious appetite for reading led him to an unusual practice: daily note-taking on his readings.',
    memo_popup_text5: 'This habit culminated in a paper that caught the eye of a renowned German sociologist, leading to an unexpected turn in his career.',
    memo_popup_text6: 'Luhmann was invited to join the faculty at Bielefeld University, where he eventually rose to the rank of full professor.',
    memo_popup_text7: 'Over his career, he authored an impressive 60 books and numerous articles, cementing his status as a sociology luminary.',
    memo_popup_text8: 'Luhmann attributed his intellectual prowess to his methodical note-taking, saying,',
    memo_popup_text9: '"I just kept taking notes,"',
    memo_popup_text10: 'which helped him organize his thoughts and deepen his understanding.',
    memo_popup_text11: 'This narrative serves as a reminder of the limitations of memory and the value of systematically capturing and revisiting knowledge to truly make it one\'s own.',
    memo_popup_btn: 'Yes, I can relate',
    memo_text1: 'You can save the above',
    memo_text2: '(Just add keywords)',
    memo_text3: 'Things to check when writing',
    memo_text4: 'Your post violates the content regulations in Article 2, Section 1 of the Terms of Service. It will not be published.',
    memo_text5: 'View Terms of Service',
    memo_text6: 'To leave a memo in another language,',
    memo_text7: 'please write in that language (automatic translation is not supported)',
    book_create_button: 'Make a Minibook',
    book_create_title: 'Make a cover',
    book_create_cover: 'cover',
    book_create_text1: 'Step to make a cover for a Minibook',
    book_create_text1_pc: 'Enter the title and author name',
    book_create_text2: 'No cover image you created',
    book_create_text3: '(If no cover image you\'ve created)',
    book_create_text4: 'Have a cover image you created',
    book_create_text5: 'Did you create your own cover?',
    book_create_text6: 'Please upload using the button below',
    book_create_text7: '(jpg format, under 20M in size)',
    book_create_text8: 'Right to add pages',
    book_create_text9: 'me only',
    book_create_text10: 'anybody',
    book_create_text11: 'Display Title on Image',
    book_create_text12: 'Display',
    book_create_text13: 'Do not display',
    book_create_text14: 'Select the language to translate',
    book_create_text15: 'Select All',
    book_create_text16: 'Upload cover image',
    book_create_text17: 'You can edit',
    book_create_text18: 'After editing, please click the icon at the top right to retranslate',
    book_create_text19: 'If you want to retranslate as per the original, please click the icon at the top right',
    book_create_text20: 'Retranslate',
    book_create_text21: 'Image',
    book_create_text22: 'Title',
    book_create_text23: 'Keyword',
    book_create_text24: 'Content',
    book_create_text25: 'The translation will only be updated if the image is deleted and re-uploaded',
    book_create_text26: '(The page will not be deleted)',
    book_create_text27: 'Write a brief introduction',
    book_create_text28: 'Temporary Save',
    book_create_text29: 'Temporarily Saved',
    book_create_text30: 'Items to Check',
    book_create_text31: 'The content of the text is the final version and no further modifications are needed',
    book_create_text32: 'No words or symbols that AI translation cannot understand were used',
    book_create_text33: 'The image was not copied and pasted but was uploaded as a separate file',
    book_create_text34: 'Open for applications? (Open minibook)',
    book_create_text35: 'Co-author',
    book_create_text36: 'Add manually?',
    book_create_text37: 'Add',
    book_create_text38: 'A minibook spreads wider when written together',
    book_create_text39: 'The hidden power of co-authors you didn\'t know',
    book_create_text40: 'Open for application',
    book_create_text41: 'Cancel',
    book_create_text43: 'Idea?',
    book_create_text44: 'Copy and paste content',
    book_create_text45: 'Need an idea?',
    book_create_text46: 'Sale options',
    book_create_text47: 'Free',
    book_create_text48: 'Sponsor',
    book_create_text49: 'Buy',
    book_create_text50: 'Current price',
    book_create_text51: 'Edit price',
    book_create_text52: 'Cannot set price to 0',
    book_create_text53: 'Minibooks that have been purchased or sponsored cannot have their price or sale option changed',
    book_create_text54: 'Only the author of the minibook can reply to messages',
    book_create_button_upload: 'Upload',
    book_create_button_make: 'Make',
    book_create_cover_topic_placeholder: 'Title will look like this',
    book_create_topic_placeholder: 'Enter a title',
    book_create_keyword_placeholder: 'Keywords (a blank between them)',
    book_create_category_placeholder: 'Select category',
    book_create_knowledge_placeholder: 'Write an introduction to your Minibook<br/>** Caution - Write down the details in the step to make pages',

    book_create_category_option1: 'Movies and Dramas',
    book_create_category_option2: 'Music and Dance',
    book_create_category_option3: 'Other Arts',
    book_create_category_option4: 'Fashion and Style',
    book_create_category_option5: 'Food and Cooking',
    book_create_category_option6: 'Alcohol and Drinks',
    book_create_category_option7: 'Snacks and Desserts',
    book_create_category_option8: 'Plants and Health',
    book_create_category_option9: 'Becoming Wealthy',
    book_create_category_option10: 'Self-Development',
    book_create_category_option11: 'Relationships',
    book_create_category_option12: 'New Knowledge',
    book_create_category_option13: 'Life Stories',
    book_create_category_option14: 'Philosophy and Values',
    book_create_category_option15: 'Religion and Tradition',
    book_create_category_option16: 'Love',
    book_create_category_option17: 'Travel and Attractions',
    book_create_category_option18: 'Hobbies',
    book_create_category_option19: 'Play Culture',
    book_create_category_option20: 'Myths and Heroes',
    book_create_category_option21: 'Literary Journeys',
    book_create_category_option22: 'History and Wisdom',
    book_create_category_option23: 'Social Stories',

    book_create_message1: 'Enter a title',
    book_create_message2: 'Enter an author name',
    book_create_message3: 'Enter keywords',
    book_create_message4: 'Enter more than 3 keywords',
    book_create_message5: 'Select category',
    book_create_message6: 'Make a cover image',
    book_create_message7: 'You can\'t enter special characters. A blank between keywords required.',
    book_create_message8: 'Want to delete the Minibook?',
    book_create_message9: 'You have no publishing right for this language',
    book_create_message10: 'A purchased minibook cannot be deleted',
    book_create_modal_text1: 'Please wait a moment..',
    book_create_modal_text2: 'The AI is reviewing the content, translating foreign languages, and connecting the knowledge network',
    book_create_modal_text3: 'Connecting to the knowledge base for page-by-page searching',
    book_create_modal_text4: 'The title does not appear on the cover image',
    book_create_modal_text5: '(This also applies to covers translated into foreign languages)',

    book_view_title: 'Minibook overview',
    book_view_share: 'Share',
    book_view_event_topic: 'Event topic',
    book_view_together_suggest: 'Suggest an Event space',
    book_view_together_message: 'You don\'t have a favorite Together. <br />Go to the Together menu and choose.',
    book_view_event_message: 'There are no events I have created',
    book_view_text1: 'No pages have been added.',
    book_view_text2: 'Why don\'t you add it now.',
    book_view_text3: 'Minibook does not exist. Please try again.',
    book_view_text4: 'Table of pages',
    book_view_text5: 'How about improving the translation of this minibook or promoting it and sharing the profits?',
    book_view_text6: 'Page List',
    book_view_text7: 'Modify price',
    book_view_text8: 'Cannot be modified due to an existing buyer',
    book_view_text9: 'Reader’s Gift',
    book_view_text10: 'Only the author of the minibook can reply to messages',
    book_view_modal_title: 'Translation Improvement & Promotion',
    book_view_modal_text1: 'Can you improve the translation of this minibook yourself? Or promote it?',
    book_view_modal_text2: 'Leave a message for the author',
    book_view_modal_text3: 'If the author agrees, you can share the revenue',

    book_view_write_share_title: 'Open minibook',
    book_view_write_share_text1: 'Would you like to become a co-author of this minibook?',
    book_view_write_share_text2: 'Apply for authorship',
    book_view_write_share_text3: 'Leave a simple request',
    book_view_write_share_text4: 'Send',
    book_view_write_share_list_title: 'Co-authors',
    book_view_write_share_text5: 'Manage the co-authors of the minibook',
    book_view_write_share_text6: 'Manage authors',
    book_view_write_share_text7: 'Accept',
    book_view_write_share_text8: 'Accepted',
    book_view_write_share_text9: 'The user is already registered as an author',
    book_view_write_share_text10: 'Add author manually',
    book_view_write_share_text11: 'User has already applied',
    book_view_publish_text1: 'Would you like to publish this Minibook?',
    book_view_publish_text2: 'Publishing makes it open to everyone, and you can even make money from it.',
    book_view_publish_text3: '(If you publish for sale, you can\'t include other author\'s pages)',
    book_view_publish_text4: 'Set a price',
    book_view_publish_text5: 'Publication date',
    book_view_publish_text6: 'Ask publication',
    book_view_publish_text7: 'Instant pub',
    book_view_publish_text8: 'Book pub',
    book_view_publish_text9: 'Not yet',
    book_view_publish_text10: 'In progress',
    book_view_publish_text11: 'Published',
    book_view_publish_text12: 'Things to check when publishing',
    book_view_publish_text13: 'This Minibook has never been published in YouBook before',
    book_view_publish_text14: 'This Minibook and its pages did not steal contents or other intellectual property from others',
    book_view_publish_text15: 'This Minibook does not contain profanity, excessive sexual content, slander of others, or commercial advertising, and that it does not violate Article 2, Clause 1 of the Terms of Use',
    book_view_publish_text16: 'Yes',

    book_view_publish_text17: 'Publication report',
    book_view_publish_text18: 'Published',
    book_view_publish_text19: 'Date',
    book_view_publish_text20: 'Price',
    book_view_publish_text21: 'Setting the open period',
    book_view_publish_text22: 'Open period',
    book_view_publish_text23: 'What is an open period',
    book_view_publish_text24: 'The open period refers to the time during which readers can view the content',
    book_view_publish_text25: 'This minibook contains more than 3 pages',
    book_view_publish_text26: 'This minibook does not contain more than 3 pages',
    book_view_publish_text27: 'If any violations are detected, the algorithm may adjust your search ranking. For severe issues, the Minibook will be automatically deleted',
    book_view_publish_text28: 'Set sale options',
    book_view_publish_text29: 'Purchase method',
    book_view_publish_text30: 'Support method',

    book_view_publish_message1: 'If you publish for sale, make sure that \n 1) the pages in your Minibook were made by you and \n 2) you haven\'t previously published them for a fee',
    book_view_publish_message2: 'It is not in a publishable state. Please contact the administrator for assistance',
    book_view_publish_message3: 'This Minibook has already been published',
    book_view_publish_message4: 'Please select the open period after the current time',
    book_view_publish_message5: 'Please select both date and time',
    book_view_publish_message6: 'Publication has been approved. Thank you',
    book_view_publish_message7: 'Please check the confirmation items',
    book_view_publish_message8: 'The end date cannot be earlier than the start date',
    book_view_publish_message9: 'A temporarily saved minibook cannot be published',
    book_view_publish_message10: 'This minibook has been transferred. The original publication right belongs to the author.',
    book_view_publish_message11: 'Please enter an amount of at least {minPrice}',
    book_view_button_confirm: 'Confirmed',
    book_view_button_publish: 'Publish it',
    book_view_button_order: 'Page alignment',
    book_view_button_add: 'Add a page',
    book_view_button_video: 'Play video',
    book_view_button_read: 'Read',
    book_view_button_lecture: 'Watch lecture video',
    book_view_page_add_title: 'Add a page',
    book_view_page_add_text1: 'After searching a third party’s page',
    book_view_page_add_text2: 'On the View page screen',
    book_view_page_add_text3: 'Put in my Minibook',
    book_view_page_add_text4: 'What if want to make your own page?',
    book_view_page_add_text5: 'Creating pages is only available to registered authors. <br/> If you wish to register as an author, <br/> please contact us below.',
    book_view_page_add_text6: 'Do you want to add a third party’s page?',
    book_view_page_add_text7: '* If you add a page made by a third party, \nit cannot be published as a paid minibook',
    book_view_page_add_text8: 'Do you have any pages you made before?',
    book_view_page_add_button1: 'Make it now',
    book_view_page_add_button2: 'View Pages made',
    book_view_reference_text1: 'Diversity',
    book_view_reference_text2: 'Multiple',
    book_view_reference_text3: 'Minibook author',
    book_view_reference_text4: 'Created by author',

    book_view_support_text1: 'Support you',
    book_view_support_modal_title: 'Become a supporter',
    book_view_support_modal_text1: 'No matter how good the writing is, it is difficult to spread it to the world alone.',
    book_view_support_modal_text2: 'A \'supporter\' is someone who shares the author\'s minibook with the world. A person who supports each other.',
    book_view_support_modal_text3: 'We join hands to spread the story further.',
    book_view_support_modal_text4: 'Please become a supporter of the author',
    book_view_support_modal_btn1: 'Got it',
    book_view_support_modal_text5: '"Your support means a lot to me. Thank you. I will also wholeheartedly support your journey."',
    book_view_support_modal_text6: 'Please share the minibook with the world',
    book_view_support_modal_btn2: 'How do I do it?',
    book_view_support_modal_title2: 'You made it this far, well done',
    book_view_support_modal_text7: 'Writing wasn’t easy, but I did it.',
    book_view_support_modal_text8: 'Now it’s time to trust myself and take another step forward.',
    book_view_support_modal_text9: 'Even if I feel shy or hesitant, I become my first supporter and share with the world.',
    book_view_support_modal_text10: 'Because I believe it can mean something to someone.',
    book_view_support_modal_text11: 'Please become my supporter',
    book_view_support_modal_text12: 'Writing or hosting an event wasn’t easy, but I took the challenge.',
    book_view_support_modal_btn3: 'I’ll try!',
    book_view_support_modal_title3: 'Hello, supporter',
    book_view_open_minibook_text1: 'Your Open Minibook request has been completed',
    book_view_open_minibook_text2: 'Your Open Minibook request has been canceled',

    page_create_title: 'Make a page',
    page_create_text1: 'No page image you created',
    page_create_text2: '(If no page image you\'ve created)',
    page_create_text3: 'page',
    page_create_text4: 'Have a page image you created',
    page_create_text5: 'Did you create a page image?',
    page_create_text6: 'Enter your content. \nNo more than one A4 sheet is recommended.',
    page_create_text7: 'Current bytes',
    page_create_text8: 'Recommend',
    page_create_text9: 'Any references on this page?',
    page_create_text10: 'Created by you',
    page_create_text11: 'Referenced book',
    page_create_text12: 'Referenced blog',
    page_create_text13: 'Referenced AI',
    page_create_text14: 'This is the step to create pages for the Minibook',
    page_create_text15: 'Upload page image',
    page_create_text16: 'Do you want to retranslate?',
    page_create_text17: 'If you want to retranslate, please select the target and language (if not selected, it will be saved without translation)',
    page_create_text18: 'Target for translation',
    page_create_text19: 'Language for translation',
    page_create_message1: 'It cannot be modified',
    page_create_message2: 'Enter your content',
    page_create_message3: 'Want to delete the page?',
    page_create_message4: 'The content exceeds the maximum size',
    page_create_reference_book: 'book',
    page_create_reference_blog: 'blog',
    page_create_reference_placeholder1: 'Enter the title of the ',
    page_create_reference_placeholder2: 'Related link (i.e. https://www.amazon.com/dp…)',
    page_create_reference_placeholder3: 'Publication year of the ',
    page_create_reference_placeholder4: 'Author of the ',
    page_create_title_placeholder: 'Title will look like this',
    page_create_message5: 'Translation in progress',
    page_create_message6: 'After creating the cover, you can create a page',
    page_create_modal_text1: 'The title does not appear on the page image',
    page_create_modal_text2: '(This also applies to pages translated into foreign languages)',
    page_create_modal_text3: 'Please make sure to check!',
    page_create_modal_text4: 'If the content has changed, you must Temporary Save.',
    page_create_modal_text5: 'Did you do that?',
    page_create_modal_text6: 'If the content has changed, you must Make.',

    page_view_title: 'View page',
    page_view_button_video: 'Play video',
    page_view_button_read: 'Read',
    page_view_text1: 'Put in my Minibook',
    page_view_text2: 'Auto play',
    page_view_text3: 'Reads',
    page_view_text4: 'Related page',
    page_view_text5: 'Related Minibook',
    page_view_text6: 'Reference',
    page_view_text7: 'Reference',
    page_view_text8: 'Publication',
    page_view_text9: 'Author',
    page_view_text10: 'Title',
    page_view_text11: 'All pages of this ref.',
    page_view_text12: 'Related search',
    page_view_text13: 'Page author',
    page_view_text14: 'Meet author',
    page_view_text15: 'Put in',
    page_view_reference_text1: 'Book',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'Don\'t have any Minibooks <br />created by you. <br /><br /> Please create one on your<br /> MY page.',
    page_view_pay_popup_text1: 'Did you gain something from reading? \nPlease respond with a small gift to the author.',
    page_view_pay_popup_title: 'Send a Gift',
    page_view_pay_popup_text2: 'Choose a tea to send as a gift',
    page_view_pay_popup_text3: 'Write a heartfelt message',
    page_view_pay_popup_placeholder1: 'The author’s thoughtful words and wisdom were truly helpful.',
    page_view_pay_popup_text4: 'Amount',
    page_view_pay_popup_button1: 'Buy and Send Message',
    page_view_pay_popup_text5: 'The author devoted much time and effort to write this. \n\nPlease respond with a small gift.',
    page_view_pay_popup_placeholder2: 'I believe in the author’s heartfelt insights and wisdom.',
    page_view_pay_popup_text6: 'Not interested in sending a gift?',
    page_view_pay_popup_text7: 'Prefer to watch an ad instead?',
    page_view_pay_popup_button2: 'Watch Ad to Read',
    page_sort_title: 'Page alignment',
    page_sort_subtitle: 'Drag the page to change the order',
    page_sort_text: 'Source',

    pay_button: 'Buy now',
    pay_price: 'Price',
    pay_vat_excluded: '(VAT excluded)',
    pay_message_success: 'Purchased',
    pay_message_fail: 'Failed',
    pay_currency: 'USD',
    pay_button_paid: 'Paid',
    pay_button_view_price: 'View Price',
    pay_total: 'Total',
    pay_methods: 'Payment methods',
    pay_methods_creditcard: 'Credit Card',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Continue',
    pay_text1: 'Please select a tea',
    pay_text2: 'Please enter a message',
    advertisement_button: 'Read more',
    advertisement_text1: 'You can view the content after watching Ad.',
    advertisement_text2: 'This is a page from a paid minibook. <br />Go to the cover and tap Read to purchase. <br />',
    advertisement_text3: 'You can view the content after watching Ad. The Ad can be watched in the app.',

    together_title: 'Event',
    together_subtitle: 'Meet and talk with readers',
    together_subtitle_text1: 'Meet readers online',
    together_subtitle_text2: 'Make a room and invite people',
    together_button: 'Create an Event space',
    together_case: 'Case',
    together_case1: 'I try to give it, but I keep getting it',
    together_case2: 'Never know a real example so helpful',
    together_subtitle2: 'Together I created',
    together_category1: 'Latest',
    together_category2: 'Most favorite',
    together_button_viewmore: 'More',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD. A h:mm',
    together_subtitle3: 'A space like this',
    together_subtitle3_1: 'Please make it',
    together_subtitle_text3: 'Whoever starts, I will participate',

    together_create_title: 'Create Event space',
    together_create_title2: 'Edit Event space',
    together_create_button1: 'Select',
    together_create_subtitle: 'Title',
    together_create_placeholder1: 'Enter a title',
    together_create_subtitle1: 'Brief introduction',
    together_create_placeholder2: 'Enter a brief introduction',
    together_create_subtitle2: 'Choose which tool to use',
    together_create_text1: 'Online meeting link (e.g., Zoom link)',
    together_create_placeholder3: 'Please enter the online meeting link',
    together_create_question1: 'Don\'t know zoom link?',
    together_create_text2: 'Use metaverse',
    together_create_placeholder4: 'Choose the one suits Together',
    together_create_question2: 'Don\'t know metaverse?',
    together_create_text3: 'Choose where to open',
    together_create_dropmenu1: 'Open at YB invited intellectual corner',
    together_create_dropmenu2: 'Open at authors and readers corner',
    together_create_button2: 'Save',
    together_create_button3: 'Make',
    together_create_popup_title: 'Choose the one suits Together',
    together_create_popup_alert: 'Already chosen',
    together_create_button4: 'Select',
    together_create_alert: 'Please enter the online meeting link',
    together_create_alert1: 'Enter a title',
    together_create_alert2: 'Choose the metaverse to use',
    together_create_alert3: 'Can\'t edit',
    together_create_alert4: 'Event space has been created',
    together_create_alert5: 'Error. Please try again',
    together_create_alert6: 'Failed to create Event space...',
    together_qa_popup_title1: 'Find a link to join the Zoom',
    together_qa_popup_btext1: 'Computer',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Open the Zoom program - After logging in - Click the meeting menu at the top - My personal meeting ID - Click Show meeting invitation - A link to join the Zoom meeting will appear. Copy that.',
    together_qa_popup_btext2: 'Smartphone',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Open the Zoom program - After logging in - Press the i button at the top right - Send invitation - After pressing the message - Enter your phone number - A link will appear. Copy that.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'What is the metaverse?',
    together_qa_popup_text3: 'This is a virtual meeting space.',
    together_qa_popup_text4: 'Appears in the form of an avatar',
    together_qa_popup_text5: ' you made up - Talking to your friends face to face - You can also share your screen.',
    together_qa_popup_text6: '',
    together_qa_popup_text7: 'In one meeting space',
    together_qa_popup_text8: '- 10 people can enter at the same time.',
    together_qa_popup_text9: 'No need to install a separate program',
    together_qa_popup_text10: ' or no membership registration required.',
    together_more_list_title: 'Event space',
    together_more_list_date: 'YYYY. M. D',
    together_request_list_title: 'Please create',
    together_request_list_category1: 'Most favorite',
    together_request_list_category2: 'Latest',
    together_request_list_button: 'Suggest a new space',
    together_request_popup_title: 'New space suggestion',
    together_request_popup_alert1: 'Enter a title',
    together_request_popup_alert2: 'Enter a brief introduction',
    together_request_popup_placeholder1: 'Enter a title',
    together_request_popup_placeholder2: 'Enter a brief introduction',
    together_request_popup_button: 'Save',
    together_request_detail_button: 'Make this space',
    together_detail_sns: 'Share',
    together_detail_enterbtn: 'Enter',
    together_detail_btn1: 'Event list',
    together_detail_btn2: 'Message',
    together_detail_subtitle: 'Minibook on the topic',
    together_detail_alert: 'Wait a moment..',
    together_detail_alert1: 'Event space suggestion successful!',
    together_detail_alert2: 'Failed to suggest Event space…',
    together_detail_alert3: 'Favorite / Successfully canceled favorite',
    together_detail_alert4: 'Favorite / Failed to cancel favorite',
    together_detail_alert5: 'Problem in server that please try later',
    together_detail_alert6: 'There is an issue with the online meeting link',
    together_detail_alert7: 'Fail to delete',
    together_notice_alert: 'Want to delete the announcement?',
    together_notice_list_title: 'Announcement',
    together_button_addtopic: 'Add this as a topic to the Event space',
    together_add_alert: 'Added to Event space',
    together_text1: 'Similar tastes to yours',
    together_text2: 'Do you want to delete this Event space?',
    together_event_btn: 'Create new event',
    together_event_title: 'New event',
    together_event_placeholder: 'Enter introduction',
    together_event_text1: 'Set schedule',
    together_event_text2: 'Set admission fee',
    together_event_text3: 'Set maximum capacity',
    together_event_text4: 'Schedule',
    together_event_text5: 'Admission fee',
    together_event_text6: 'Maximum capacity',
    together_event_text7: 'Notify my followers',
    together_event_text8: 'Do you want to delete the event?',
    together_event_text9: 'Please set the start time after the current time',
    together_event_text10: 'Please set the end time after the start time',
    together_event_text11: 'The start time and end time cannot be the same',
    together_event_text12: 'Add this as an event topic',
    together_event_text13: 'Added to the event',
    together_event_text14: 'The event has exceeded the maximum capacity',
    together_event_text15: 'Button becomes active 1 hour before the Event \n(if free, no need to Buy now)',
    together_event_text16: 'Button becomes active 1 hour before the Event',
    together_event_text17: 'No event exists',
    together_event_text18: 'Cannot be deleted if there is a buyer for the event',
    together_event_text19: 'Would you like to send a notification?',
    together_event_text20: 'Sent',
    together_event_text21: 'Event list',
    together_event_text22: 'View details',
    together_event_text23: 'After Sign up, please log in',
    together_event_text24: 'How to attend',
    together_event_text25: 'Event participation complete',
    together_event_text26: 'The author devoted a lot of time and care to this event.\n\nPlease respond with a small gift.',
    together_event_text27: 'The wisdom drawn from the author’s experience and deep communication was impressive',
    together_event_text28: 'Share this event with the world',
    together_event_text29: 'It wasn’t easy to open this event, but I did it.',
    together_event_text30: 'No matter how great the event is, it’s hard to spread it to the world alone.',
    together_event_text31: 'A supporter is someone who helps spread the author’s event to the world. They cheer for each other.',
    youbooker_title: 'Member',
    youbooker_subtitle: 'Meet people from around the world',
    youbooker_case: 'Case',
    youbooker_case_text1: 'Being the one who always starts',
    youbooker_case_text2: 'Compound interest effect of knowledge?',
    youbooker_translation: 'Want to meet right now?',
    youbooker_translation_text1: 'All languages',
    youbooker_category: 'Follower / Following',
    youbooker_subcategory1: 'My follower',
    youbooker_subcategory2: 'I\'m following',
    youbooker_subtitle2: 'These are following me',
    youbooker_button_follow: 'Follow',
    youbooker_message_follow: 'Follow',
    youbooker_button_follow_cancel: 'Unfollow',
    youbooker_subtitle3: 'These are users you know',
    youbooker_subtitle4: 'I\'m following them',
    youbooker_subtitle5: 'These don\'t know YB yet',
    youbooker_button_invite: 'Invite',
    youbooker_alert_invite: 'Inviting is only possible through the app.Download the app please',
    youbooker_alert: 'Only in the app. Why not download the app?',
    youbooker_alert2: 'Refresh succeeded!',
    youbooker_alert3: 'You can search on the youBooker tab',

    home_page_text1: 'Latest',
    home_page_text2: 'Influence',
    home_page_today_title: 'Today issue',
    home_page_today_subtitle: 'Related with TOP news',
    home_page_slider_date: 'YYYY.M.D',
    home_page_today_list_title: 'Today issue',
    home_page_today_detail_sns: 'Share',
    home_page_today_detail_date: 'YYYY.M.D',
    home_page_today_detail_subtitle: 'Related pages',

    home_page_explor_title: 'Page exploration',
    home_page_explor_subtitle: 'What if double click?',
    home_page_recommend_title: 'Recommendations',
    home_page_recommend_subtitle: 'Pages that may interest you',
    home_page_theysee_title: 'What do they see',
    home_page_theysee_subtitle: 'Pages readers mostly see',
    home_page_common_title: 'Common sense',
    home_page_common_subtitle: 'You\'d rather know this',
    home_page_keyw_title: 'Pages by keywords',
    home_page_keyw_subtitle: 'Find all related pages',
    home_page_random_title: 'Randomly GO',
    home_page_random_subtitle: 'Press when dazed <br />Then learn something unexpected',
    home_page_about_title: 'About YouBook',
    home_page_about_detail: 'Corporation: NICK syndicate<br />US business center: Seattle, USA<br />Other country center: Tokyo Shanghai Seoul<br />Contact: joa@academy-connect.net<br />DUNS 695937905',
    settlement_title: 'Purchase & Settlement',
    settlement_tab1: 'Order record',
    settlement_tab2: 'Account info',
    settlement_tab3: 'Settlement record',
    settlement_category1: 'My purchase record',
    settlement_category2: 'Shared author rights',
    settlement_category3: 'Minibook revenue settlement',
    settlement_category4: 'Event revenue settlement',
    settlement_category5: 'Manage account',
    settlement_text1: 'View purchase record',
    settlement_text2: 'You can share the minibook’s author rights',
    settlement_text3: 'You check record of your paid Minibook settlement.',
    settlement_text4: 'If you have any additional questions, click',
    settlement_text5: 'here',
    settlement_text6: 'Or please contact us below.',
    settlement_text7: 'joa@academy-connect.net / ',
    settlement_text8: 'Say a word',
    settlement_text9: 'Manage account for revenue payments',
    settlement_text10: 'Settle event revenue',
    settlement_purchase_text1: 'Purchase record',
    settlement_purchase_text2: 'Date',
    settlement_purchase_text3: 'Purchase amount',
    settlement_purchase_text4: 'Title',
    settlement_purchase_text5: 'Minibook',
    settlement_purchase_text6: 'Event',
    settlement_accountInfo_text1: 'Author rights of the minibook',
    settlement_accountInfo_text2: 'Minibook',
    settlement_accountInfo_text3: 'Language',
    settlement_accountInfo_text4: 'Author rights',
    settlement_accountInfo_text5: 'Author',
    settlement_accountInfo_text6: 'Third party',
    settlement_accountInfo_text7: 'Personal?',
    settlement_accountInfo_text8: 'Personal',
    settlement_accountInfo_text9: 'Corporation',
    settlement_accountInfo_text10: 'Bank name',
    settlement_accountInfo_text10_message: 'Select a Bank name',
    settlement_accountInfo_text11: 'Account holder name',
    settlement_accountInfo_text11_message: 'Enter an account holder name',
    settlement_accountInfo_text12: 'Account number',
    settlement_accountInfo_text12_message: 'Enter an account number',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Social security number',
    settlement_accountInfo_text13_message: 'Enter a social security number',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Personal address',
    settlement_accountInfo_text14_message: 'Enter a personal address',
    settlement_accountInfo_text15: 'Email',
    settlement_accountInfo_text15_message: 'Enter an email',
    settlement_accountInfo_text16: 'Save',
    settlement_accountInfo_text17: 'Employer Identification Number (EIN)',
    settlement_accountInfo_text17_message: 'Enter an EIN Number',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Corporation address',
    settlement_accountInfo_text18_message: 'Enter a corporation address',
    settlement_accountInfo_text19: 'Corporation name',
    settlement_accountInfo_text19_message: 'Enter a corporation name',
    settlement_accountInfo_text20: 'Corporation phone',
    settlement_accountInfo_text20_message: 'Enter a corporation contacts',
    settlement_accountInfo_text21: 'Third party ID',
    settlement_accountInfo_text21_placeholder: 'Email of the third party',
    settlement_accountInfo_text22: 'Account to receive payment',
    settlement_accountInfo_text23: 'Country',
    settlement_accountInfo_message1: 'Email cannot be found',
    settlement_accountInfo_message2: 'You cannot share author rights with yourself',
    settlement_accountInfo_message3: 'There are no Minibooks made',
    settlement_accountInfo_text24: 'Shared author rights',
    settlement_accountInfo_text25: 'Once you share author rights with a third party, it cannot be reversed',
    settlement_accountInfo_text26: 'Do you want to share author rights?',
    settlement_accountInfo_text27: 'Yes, I want to share',
    settlement_accountInfo_text28: 'To share author rights,<br /> 1) the pages in the minibook must be created by you, and <br /> 2) must not have been previously shared with a third party',
    settlement_accountInfo_text29: 'Ok, I will fix it',
    settlement_accountInfo_text30: 'You have shared the author rights of this minibook with a third party',
    settlement_accountInfo_text31: 'Author',
    settlement_accountInfo_text32: 'Third party',
    settlement_accountInfo_text33: 'You have received the author rights of this minibook from the author',
    settlement_accountInfo_text34: 'This is a free minibook. No account required.',
    settlement_accountInfo_text35: 'Revenue Sharing',
    settlement_accountInfo_text36: '(me)',
    settlement_accountInfo_text37: '(publishers, etc.)',
    settlement_accountInfo_text38: 'Personal account',
    settlement_accountInfo_text39: 'Corporation account',
    settlement_accountInfo_text40: 'Account management',
    settlement_accountInfo_text41: 'Save',
    settlement_accountInfo_text42: 'Bank',
    settlement_accountInfo_text43: 'Account selection',
    settlement_accountInfo_text44: 'Decide how to share revenue',
    settlement_accountInfo_text45: 'Revenue share (%)',
    settlement_accountInfo_text46: 'My ID (email)',
    settlement_accountInfo_text47: 'Third-party ID (email)',
    settlement_accountInfo_text48: 'Match the total',
    settlement_accountInfo_text49: 'Enter assignee information',
    settlement_accountInfo_text50: 'The revenue share cannot exceed 100%',
    settlement_accountInfo_text51: 'Assignor ID(email)',
    settlement_accountInfo_text52: 'Assignee ID(email)',
    settlement_earnings_text1: 'Settlement record',
    settlement_earnings_text2: 'Settlement period',
    settlement_earnings_text3: 'Minibook price',
    settlement_earnings_text4: 'Sales quantity',
    settlement_earnings_text5: 'Sale amount',
    settlement_earnings_text6: 'Deductions including taxes',
    settlement_earnings_text7: 'Deposit amount',
    settlement_earnings_text8: 'Deposit date',
    settlement_earnings_text9: 'Ad views',
    settlement_earnings_text10: 'Total amount',
    settlement_earnings_text11: 'Learn more',
    settlement_earnings_text12: 'Ad price',
    settlement_earnings_text13: 'Revenue',
    settlement_earnings_text14: 'All minibooks',
    settlement_earnings_text15: 'Select event',
    settlement_earnings_text16: 'All events',
    settlement_statistics_text1: 'Sales volume',
    settlement_statistics_text2: 'Number of readers',
    settlement_statistics_text3: '(Last)',
    settlement_statistics_text4: '1 month',
    settlement_statistics_text5: '6 months',
    settlement_statistics_text6: '1 year',
    settlement_statistics_text7: 'No data available',
    settlement_statistics_text8: 'Sales analysis',
    settlement_statistics_text9: 'Number of Ad views',
    settlement_statistics_text10: 'All languages',

    terms_title: 'Terms of Service',
    terms_text: 'The purpose of these Terms of Services is to stipulate the necessary matters between the Member and the services provider NICK syndicate (hereinafter referred to as the Company).<br/><br/>Management of Service Contents<br/>The Company shall establish and disclose the necessary matters for members to upload service contents as follows.<br/><br/><b>1. Rights of service contents uploaded by members</b><br/>The Company owns the copyright of the Service Contents (page posts, minibook introductions and cards) uploaded by the Member, and the Member is obliged not to infringe on the intellectual property rights of others when creating the contents, and the Member is responsible for this.<br/>The copyright of the general contents (comments, profile posts, photos, memos, etc.) uploaded by the Member shall belong to the Member, and the Member shall be obliged not to infringe the intellectual property rights of others when creating the contents, and the Member shall be responsible for the same.<br/><br/><b>2. Measures in case of inappropriate service contents uploaded by members</b><br/>① If the service content or general content uploaded by the member falls under any of the following contents, the company may delete the content or prevent it from being displayed through technical filtering.<br/>1. Offensive to others by invasion of privacy, defamation, swearing, or profanity<br/>2. Offends others by violating public order and morals or by denigrating a particular group, organisation or religion<br/>3. Infringing on the rights of others with unverified or unfounded content<br/>4. Infringes the copyright of others<br/>5. Contains personal information of others<br/>6. Contains advertising/promotional content<br/>7. Repeated posting of the same content<br/>8. Interferes with the smooth provision of the Company\'s services, such as malicious code<br/>9. If it is judged that it may have an unhealthy effect on the smooth use of the service by other members<br/>② The contents that the Company has restricted from displaying shall not be viewed by other persons, including Company employees. However, if the Company is requested to provide information by a court, investigative agency, or other administrative agency, or if required by other laws, the Company may allow other interested persons to view the contents.<br/>③ If a member finds the above content, he/she may report the details of the content to the Company via email or Channel Talk using text, captured screen, voice recording, etc. and the Company shall review the content within 24 hours of receiving the report and, if applicable, delete the content or take measures to prevent it from being displayed through technical filtering.<br/><br/><b>3. Use, cancellation, and refund of Service Contents purchased by Members</b><br/>① If a Member has purchased paid Service Contents, he/she may use the content freely. In this case, the purchased content cannot be canceled or refunded. If you have any inquiries regarding this, please use the following.<br/>Contact: Phone 82(country code) 070-4578-9240, email joa@academy-connect.net<br/><br/>[Addendum]<br/>1. These Terms shall take effect from 1 March 2024 and replace the previous regulations.',

    privacy_title: 'Privacy Policy',
    privacy_text: 'The purpose of these Privacy Policy is to stipulate the necessary matters for the member information when using the services provided by NICK syndicate (hereinafter referred to as the Company).<br/><br/>Protection of Personal Information<br/>In accordance with Article 30 of the Personal Information Protection Act, the Company establishes and discloses the following personal information processing guidelines in order to protect the personal information of customers and to promptly and smoothly handle grievances related thereto.<br/><br/><b>1. Purpose of processing personal information</b><br/>The Company processes personal information for the following purposes and does not use it for any purpose other than the following.<br/>- Confirmation of customer subscription intention, identification and authentication of identity in providing services to customers, maintenance and management of membership, payment for the supply of goods or services, supply and delivery of goods or services, etc.<br/><br/><b>2. Processing and retention period of personal information</b><br/>① The Company shall process and retain personal information within the period of personal information retention and use agreed upon when collecting personal information from the information subject or the period of personal information retention and use in accordance with laws and regulations.<br/>② The specific personal information processing and retention periods are as follows.<br/>- Customer subscription and management: Until the termination of the service use contract or membership cancellation, but in the case of debt and debt relations, until the settlement of such debt and debt relations<br/>- E-commerce contract, withdrawal of contract, payment, and supply records such as goods: 5 years<br/><br/><b>3. Provision of personal information to third parties</b><br/>The Company does not provide personal information to third parties except in cases falling under Article 17 of the Personal Information Protection Act, such as separate consent of the information subject or special provisions of the law.<br/><br/><b>4. Consignment of personal information processing</b><br/>① The Company may entrust the processing of personal information to an external party for the smooth processing of personal information, and in such case, the Company will notify in advance.<br/>② When entering into an entrustment contract, the Company shall specify in writing the prohibition of processing personal information other than for the purpose of performing entrusted tasks, restrictions on re-consignment, management and supervision of the entrustee, and responsibilities in accordance with Article 25 of the Personal Information Protection Act, and supervise whether the entrustee processes personal information safely.<br/><br/><b>5. Rights and obligations of information subjects and legal representatives and methods of exercise</b><br/>The customer may exercise the following personal information protection rights against the Company at any time.<br/>1. Request to view personal information<br/>2. Request for correction if there are errors in personal information<br/>3. Request for deletion<br/>4. Request for suspension of processing<br/><br/><b>6. Items of personal information to be processed</b><br/>The Company may process the following personal information items collected with the consent of the customer when necessary.<br/>- Name, date of birth, address, telephone and mobile phone numbers (including those listed in the phone book), gender, email address, credit card number, bank account number, payment information, etc.<br/><br/><b>7. Destruction of personal information</b><br/>① The Company shall destroy the personal information without delay when the personal information becomes unnecessary, such as the expiration of the retention period or the achievement of the purpose of processing.<br/>② The Company destroys personal information in the following ways<br/>- Electronic files: deleting files and formatting storage media such as discs<br/>- Handwritten documents: Shredding or incineration<br/><br/><b>8. Measures to ensure the safety of personal information</b><br/>The Company takes the following measures to ensure the safety of personal information.<br/>- Administrative measures: Establishment and implementation of internal management plans, regular training for employees and staff, etc.<br/>- Technical measures: Managing access rights such as setting passwords for personal information processing systems (or computers where personal information is stored), installing security programs such as antivirus software, and encrypting files where personal information is stored.<br/>- Physical measures: Inspection of the place where personal information is stored, access control, etc.<br/><br/><b>9. Installation, operation and rejection of automatic personal information collection devices</b><br/>① The Company uses \'cookies\' that store and retrieve usage information from time to time to provide individualised services to users.<br/>② Cookies are small amounts of information sent to the user\'s computer browser by the server (http) used to operate the website and are stored on the hard disk of the user\'s PC computer.<br/>A. Purpose of use of cookies: Cookies are used to provide optimised information to users by identifying the type of visit and use of each service and website visited by users, popular search terms, secure connection, etc.<br/>B. Installation, operation and rejection of cookies: You can reject the storage of cookies by setting the options in the Tools > Internet Options > Privacy menu at the top of your web browser.<br/>C. If you refuse to save cookies, you may experience difficulties in using personalised services.<br/><br/><b>10. Personal information protection officer</b><br/>The Company has designated a personal information protection officer as follows to take overall responsibility for the processing of personal information and to handle complaints and damage relief of information subjects related to the processing of personal information.<br/><br/>- Personal Information Protection Officer<br/> Name: Kiyun Yu &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Position: CEO<br/>Email: joa@academy-connect.net<br/>Phone: 82(country code) 070-4578-9240, <br/><br/>[Addendum]<br/>1. These Terms shall take effect from 1 March 2024 and replace the previous regulations.',

    // common text
    message_save: 'Saved',
    message_fail: 'Failed',
    message_delete: 'Deleted',
    message_report: 'Reported',
    message_search_no_result: 'No search results found',
    message_search_enter: 'Please enter a search term',
    message_error1: 'An error has occurred. Please contact the administrator',
    message_save2: 'Saved',
    message_fail2: 'Failed',
    message_login: 'You need LOGIN',
    message_service_soon: 'The service will be available soon',

    name: 'Name',
    email: 'Email',
    mobile: 'Mobile',
    list: 'List',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    report: 'Report content',
    user: 'User',
    report_type: 'Type of report',
    report_type1: 'Profanity/ Defamation',
    report_type2: 'Advertisement',
    report_type3: 'Obscenity/ Sexually explicit',
    report_type4: 'Repeat the same content',
    report_type5: 'Others',
    search_book: 'Search Minibook',
    serch_placeholder: 'Search by name or email',
    search_keyword: 'Keyword',
    search_reference: 'Reference',
    search_author: 'Author',
    search_result: 'Found it',
    button_report: 'Report to YouBook',
    button_write: 'Save',
    button_login: 'LOGIN',
    button_more: 'More',
    button_confirm: 'Confirmed',
    button_save: 'Save',
    button_crop: 'Crop',
    button_delete: 'Delete',
    button_complete: 'Done',

    colorbox_background_text1: 'Select a background color',
    colorbox_font_text1: 'Select a text color',
    menu_home: 'Home',
    menu_page: 'Page',
    menu_book: 'MiniBook',
    menu_memo: 'Memo',
    menu_together: 'Event',
    login_button: 'LOGIN',
    message_text1: 'Reply',
    message_text2: 'A reply was added to my comment',
  },
  ko: {
    home_banner_title1: '새로운 미니북',
    home_banner_title2: '새로운 강의',
    home_slide_title1: '요즘 주목',
    home_slide_title2: '내 취향',
    home_slide_title3: '지금 핫',
    home_slide_title4: '인기 많아요',
    home_detail_title1: '일상의 기억',
    home_detail_title2: '추천하는 영상',
    home_detail_title3: '더 알고 싶다면',
    home_detail_title4: '추천 영상 추가',
    home_detail_title5: 'SNS 링크 추가',
    home_detail_text1: '미니북 메모',
    home_detail_text2: '일상 메모',
    home_setting_title: '설정',
    home_setting_text1: '지난 30일간 본 페이지',
    home_setting_text2: '로그아웃',
    home_setting_text3: '회원탈퇴',
    home_book_banner_question: '이런 게 궁금해요',
    home_book_banner_write_placeholder1: '제목을 입력하세요',
    home_book_banner_write_placeholder2: '내용을 입력하세요',
    home_book_banner_write_button: '등록하기',
    home_book_banner_detail_text1: 'YouBook 멘토가 드리는 대답이예요',
    home_book_banner_detail_text2: 'YouBook에 관련된 지식이 있네요',

    home_book_create_button: '미니북, 만들어보기',
    home_book_create_text1: '미니북은 10페이지 남짓한 짧은 책이에요. 잠깐의 여유 속에서도 깊은 이야기를 전할 수 있도록 가볍지만 진심을 담아 만듭니다.',
    home_book_create_text2: '출판 후 수정하는 방법',
    home_book_create_text3: '미니북, 쉽게 만드는 방법',
    home_book_create_text4: '작가의 수익은 얼마나 될까요',
    home_book_create_text5: '독자는 어떻게 만나나요',
    home_book_create_text6: '유북을 꼭 써야할 5가지 이유',
    home_book_create_text7: '그 외 궁금한 것들은요',
    home_book_create_text8: '판매량 등을 실시간 알고 싶어요',
    home_book_create_text9: '오늘도 꾸준히 씁니다',
    home_book_create_text10: '지금, 바로 해보세요',

    home_book_category_title1: '투데이 이슈와 미니북',
    home_book_category_title2: '요즘 주목받는 미니북',
    home_book_category_title3: '새로나온 이야기',
    home_book_category_title4: '내 취향에 맞춘 미니북',
    home_book_category_title5: '모두가 좋아하는 이야기',
    home_book_category_title6: '책냥이와 함께',
    home_book_category_title6_text1: '보기',
    home_book_category_title6_text2: '접기',
    home_book_category_title7: '신경망 속 페이지 탐험',

    home_book_category_title8: '예술과 감성의 향연',
    home_book_category_title8_text1: '영화와 드라마 속에 담긴 세상',
    home_book_category_title8_text2: '영혼을 울리는 선율과 몸짓',
    home_book_category_title8_text3: '경계를 넘어선 예술 세계',
    home_book_category_title8_text4: '개성을 입다: 의상과 스타일',

    home_book_category_title9: '맛과 여유의 미식 문화',
    home_book_category_title9_text1: '미식 탐험, 현지 요리 풀어보기',
    home_book_category_title9_text2: '술과 인생의 이야기',
    home_book_category_title9_text3: '향기로운 기호식품의 매력',
    home_book_category_title9_text4: '자연이 주는 힘, 식물의 비밀',

    home_book_category_title10: '삶의 지혜와 자기 발견',
    home_book_category_title10_text1: '돈을 다루는 독특한 방법',
    home_book_category_title10_text2: '나만 아는 자기 성장 레시피',
    home_book_category_title10_text3: '사람 사이의 문제와 해결책',
    home_book_category_title10_text4: '극소수만 아는 새로운 지식',

    home_book_category_title11: '다양한 가치관과 사랑',
    home_book_category_title11_text1: '그들이 사는 이야기',
    home_book_category_title11_text2: '다른 철학, 다른 가치관',
    home_book_category_title11_text3: '종교적 믿음과 전통의 이야기',
    home_book_category_title11_text4: '사랑의 신비',

    home_book_category_title12: '여행과 취미로 채우는 하루',
    home_book_category_title12_text1: '꼭 가봐야 할 숨은 여행지',
    home_book_category_title12_text2: '취미로 엿보는 삶의 즐거움',
    home_book_category_title12_text3: '놀이로 말하는 색다른 문화',

    home_book_category_title13: '전통과 이야기의 풍요로움',
    home_book_category_title13_text1: '지역의 신화와 영웅 이야기',
    home_book_category_title13_text2: '지구촌 특별한 문학기행',
    home_book_category_title13_text3: '이곳저곳의 역사와 지혜',
    home_book_category_title13_text4: '다채로운 사회 이야기',

    home_book_category_title1_text2: '책냥이 생각 - 살짝 보실래요?',
    home_book_category_title1_text3: '고민? 궁금?',
    home_book_category_title1_text4: '미니북 추천해 드릴까요?',

    home_book_search_placeholder1: '이곳에 말씀해 주세요',
    home_book_search_placeholder2: '주제어를 알려주세요',
    home_book_search_message1: '질문을 입력해 주세요',
    home_book_search_message2: '다시 질문해 주세요',
    home_book_search_text1: '이 페이지, 저랑 토론해 보실래요?',
    home_book_search_text2: '이 미니북, 저랑 토론해 보실래요?',
    home_book_search_text3: '묻기',
    home_book_search_text4: '위 내용을 저장할 수 있어요',
    home_book_search_text5: '(Just add keywords)',
    home_book_search_text6: '찾기',

    home_book_theme_title: '테마별 보기',
    home_instant_text1: '주제어 입력',
    home_instant_text2: '랜덤으로 입력',
    home_book_company_info: '더 궁금한 게 있으신가요? 아래로 연락 주시면 친절하게 답변 드립니다.',
    home_page_search_text1: '페이지 검색하기',
    home_page_search_text2: '동영상으로 즉시 볼 수 있어요',
    home_page_search_text3: '상세검색',
    home_page_search_text4: '목록으로 보기',
    home_page_search_text5: '네크워크로 보기',
    home_page_explor_alert: '페이지가 선택되지 않았습니다',
    home_page_explor_alert2: '한 화면에서 볼 수 있는 최대 페이지 개수(150개)을 초과했습니다. 불필요한 페이지들을 휴지통에 넣어주세요.',
    home_page_explor_alert3: '더 이상 불러올 정보가 없습니다',

    my_login_title: 'MY',
    my_login_text1: '내 프로필을 멋지게 꾸며 보세요',
    my_login_text2: '지금 로그인하고',
    my_login_text3: '모든 서비스 무료로 이용하기',
    my_login_find_password: '비밀번호 찾기',
    my_minibook_list: '목록 보기',
    my_guide_minibook: '미니북 만드는 법',
    my_password_reset: '비밀번호 재설정',
    my_password_reset_text1: '가입할 때 사용한 이메일 주소를 입력해 주세요',
    my_password_reset_button1: '재설정 링크 전송',
    my_password_reset_button2: '재설정',
    my_password_reset_message1: '사용자 이메일을 찾을 수 없습니다',
    my_password_reset_message2: '입력하신 이메일로 비밀번호 재설정 링크를 보냈습니다.',
    my_password_reset_message3: '이메일로 보낸 링크를 통해 재설정 후 로그인해주세요.',
    my_password_reset_placeholder1: '이메일을 입력하세요',
    my_password_reset_placeholder2: '비밀번호를 입력하세요',
    my_password_reset_placeholder3: '비밀번호를 재입력하세요',
    my_password_reset_message4: '비밀번호가 일치하지 않습니다',
    my_password_reset_message5: '비밀번호는 최소 8자 이상이며, 최소 하나의 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다',
    my_password_reset_message6: '비밀번호를 재설정했습니다',
    my_memo_list_placeholder: '좋은 생각이 반짝 떠올랐나요? 지금 바로 메모해 보세요',

    my_profile_placehoder1: '내 관심 분야는',
    my_profile_placehoder2: '내 이름은',
    my_profile_placehoder3: '내 소개를 간단히 하면',
    my_profile_placehoder4: '추가로 소개글을 더 넣어 주세요',
    my_profile_text1: '국적',
    my_profile_text2: '언어',
    my_profile_text3: '아이디 변경하기',
    my_profile_text4: '기존 아이디',
    my_profile_text5: '변경할 아이디',
    my_profile_text6: '*아이디 변경은 1회만 가능합니다',

    my_menu_text1: '내 여행',
    my_menu_text2: '메시지 창',
    my_menu_text3: '구매 \n정산',
    my_menu_text4: '새로운 \n알림',
    my_menu_text5: '미니북 만들기',
    my_menu_text6: '직접 만든 미니북',
    my_menu_text7: '다른 앱에서 쓴 글을 가져오고 싶나요?',
    my_menu_text8: '자동으로 가져와 페이지로 변환할 수 있어요',
    my_menu_text9: '가져오기',
    my_import_book_text1: '페이지로 변환하기',
    my_import_book_text2: 'ZIP 파일을 페이지로 변환 중입니다. \n\n하나의 글을 변환하는데 \n최대 5초가 걸립니다. \n\n10개의 글은 대략 1분, \n100개의 글은 대략 8분 정도가 \n걸릴 수 있습니다. \n\n변환이 완료되면\n이를 알리는 팝업창이 나타납니다.',
    my_import_book_text3: '알겠습니다',
    my_import_book_text4: '페이지로 변환 완료',
    my_import_book_text5: 'ZIP 파일의 글을 모두 페이지로\n변환하였습니다. \n\n각각의 글은 각각 페이지로\n변환되었습니다. \n\n확인은, 내 여행 - 만든 페이지에서\n가능합니다\n\n페이지는 임시저장된 것으로서\n수정이 가능합니다.',
    my_import_book_text6: '다른 앱에서 쓴 글을 가져와 자동으로 페이지로 변환할 수 있습니다. 그 후 페이지들을 묶어 미니북을 만들 수 있습니다.',
    my_import_book_text7: '다른 앱의 글을 ZIP 파일로\n만들어 가져오는 방법',
    my_import_book_text8: 'ZIP 파일을 업로드 해주세요',
    my_import_book_text9: 'Substack의 파일을 업로드',
    my_import_book_text10: 'Medium의 파일을 업로드',
    my_import_book_text11: '찾기',
    my_import_book_text12: '* 각각의 글은 각각의 페이지로 변환됩니다',
    my_import_book_text13: '* 확인은, MY 페이지 - 설정 - 만든 페이지에서 가능합니다',
    my_import_book_text14: '* 페이지는 임시저장된 것으로 수정이 가능합니다',
    my_import_book_text15: '* 자신이 쓴 글만 가져올 수 있습니다',
    my_import_book_text16: '변환된 페이지를 이용해 미니북 출판하기',
    my_import_book_text17: '미니북의 표지를 만듭니다',
    my_import_book_text18: '페이지 중 골라서 미니북에 추가합니다',
    my_import_book_text19: '미니북을 출판합니다',
    my_import_book_text20: '자세한 설명을 꼭 읽어보세요',
    my_import_book_text21: 'ZIP 파일 형식이 아닙니다',
    my_import_book_text22: '파일을 업로드해주세요',

    my_journey_title: '내 여행',
    my_journey_button_message: '메시지',
    my_journey_button_memo: '메모',
    my_journey_button_record: '여행기록',
    my_journey_button_follow: '팔로잉 하기',
    my_journey_button_follow_cancel: '팔로잉 취소',
    my_journey_message_text1: '메시지 남기기',
    my_journey_message_placeholder: '글을 입력하세요',
    my_journey_message_message1: '응답할 수 없습니다',
    my_journey_message_message2: '전송 중입니다',
    my_journey_message_message3: '메시지를 입력하세요',
    my_journey_memo_total: '전체',
    my_journey_record_overall: '영향력 순위',
    my_journey_record_text1: '본 페이지',
    my_journey_record_text2: '좋아하는 미니북',
    my_journey_record_text3: '좋아하는 강의 공간',
    my_journey_record_text4: '만든 페이지',
    my_journey_record_text5: '만든 미니북',
    my_journey_record_text6: '만든 강의 공간',
    my_journey_record_text7: '이번달',
    my_journey_record_text8: '구매한 미니북',
    my_journey_record_text9: '공개',
    my_journey_record_text10: '비공개',
    my_journey_record_text11: '구매한 강의',
    my_journey_record_text12: '내가 만든 강의',
    my_journey_record_text13: '{userLanguage}권 {userRank}위',
    my_journey_record_text14: '저자권 공유 미니북',
    my_journey_record_text15: '독자들이 읽기를 원하는 순서가 있나요. \n그렇다면 표지를 드래그하여 순서를 변경하세요.',
    my_journey_record_text16: '새로운 미니북을 응원해 주세요',
    my_journey_record_text17: '독자의 응원글',
    my_journey_record_text18: '저자에게 응원글을 남겨주세요',
    my_journey_record_text19: '응원자 레벨',
    my_journey_record_text20: '레벨 10 중 {cheeringLevel}',
    my_journey_record_text21: '내가 응원하는 사람',
    my_journey_record_text22: '나의 응원자',
    my_journey_record_text23: '삭제 하시겠습니까?',
    my_journey_record_text24: '{userName} 님을 응원하는 사람',
    my_journey_record_text25: '{userName} 님이 응원하는 사람',

    my_notice_title: '알림',
    my_notice_message1: '새로운 알림이 없습니다',
    my_notice_text1: '새로운 미니북이 도착했습니다',
    my_notice_text2: '새로운 투데이 이슈가 도착했습니다',
    my_notice_text3: '내 홈에 <b>새로운 메시지</b>가 왔습니다',
    my_notice_text4: '내가 공유한 메모에 <b>새 댓글</b>이 달렸습니다',
    my_notice_text5: '내가 만든 강의 공간에 <b>새 댓글</b>이 달렸습니다',
    my_notice_text6: '내가 만든 미니북에 <b>새 메모</b>가 달렸습니다',
    my_notice_text7: '내가 만든 페이지에 <b>새 메모</b>가 달렸습니다',
    my_notice_text8: '님이 <b>새 메모</b>를 달았습니다',
    my_notice_text9: '{userName}님이 <b>새로운 강의 공간</b>를 개설했습니다',
    my_notice_text10: '님이 <b>새로운 미니북</b>을 출판했습니다',
    my_notice_text11: '님이 <b>내 미니북을 구매</b>했습니다',
    my_notice_text12: '{userName}님이 <b>새로운 강의</b>를 개설했습니다',
    my_notice_text13: '{userName}님이 <b>새로운 강의</b>에 특별히 당신을 초청했습니다. 꼭 방문해 보세요 ',
    my_notice_text14: '{userName}님이 <b>내 강의를 구매</b>했습니다',
    my_notice_text15: '{userName}님이 공동 저자를 신청하였습니다',
    my_notice_text16: '오픈 미니북의 공동 저자신청이 승인되었습니다',
    my_notice_text17: '공동 저자의 새 댓글이 달렸습니다',
    my_notice_text18: '새로운 미니북을 응원하는 글이 왔습니다',
    my_notice_text19: '{userName}님이 <b>내 미니북을 후원</b>했습니다',

    my_marketing_banner_title: '나를 응원해요',
    my_marketing_banner_text1: '어려움을 이겨낸 당신, 응원해 주세요',
    my_marketing_banner_btn: '지금 응원하기',
    my_marketing_title: '',
    my_marketing_text1: '미니북과 이벤트의 두 날개를 달고 - \n 단계별 홍보를 연료로 삼아 - \n 인플루언서가 되어보자',
    my_marketing_text2: '일반 독자들에게 이메일',
    my_marketing_text3: '일반 독자들에게 문자',
    my_marketing_text4: '친구들에게 이메일',
    my_marketing_text5: '친구들에게 문자',
    my_marketing_text6: '소셜미디어에 링크',

    my_marketing_btn: '지금 바로하기',
    my_marketing_minibook_step1_title: '미니북 응원',
    my_marketing_step1_subtitle: '소셜미디어에 링크',
    my_marketing_minibook_step1_text1: '당신의 소셜미디어에 미니북을 링크하고 매력적인 설명을 추가하세요',
    my_marketing_minibook_text1: '미니북을 찾으세요',
    my_marketing_step1_text1: '링크를 복사하세요',
    my_marketing_step1_btn: '복사',
    my_marketing_step1_text2: '소셜미디어에 붙여넣고 설명을 추가하세요',
    my_marketing_step1_sns1: '페이스북',
    my_marketing_step1_sns2: '인스타그램',
    my_marketing_step1_sns3: '링크드인',
    my_marketing_step1_sns4: '카카오스토리',
    my_marketing_step1_sns5: '네이버 밴드',
    my_marketing_step1_sns6: '네이버 블로그',
    my_marketing_step1_sns7: '트위터(X)',
    my_marketing_step1_sns8: '레딧',
    my_marketing_step1_sns9: '미디엄',
    my_marketing_step1_sns10: '서브스택',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: '공유할 미니북을 선택해주세요',
    my_marketing_step1_text4: '링크가 복사되었습니다',
    my_marketing_step1_text5: '공유할 강의를 선택해주세요',
    my_marketing_step1_text6: '소셜미디어 찾기',
    my_marketing_event_step1_title: '강의 응원',
    my_marketing_event_step1_text1: '당신의 소셜미디어에 강의를 링크하고 매력적인 설명을 추가하세요',
    my_marketing_event_text1: '강의를 찾으세요',
    my_marketing_event_search_title: '강의 검색',
    my_marketing_minibook_step2_title: '미니북 2단계 마케팅',
    my_marketing_step2_subtitle: '친구들에게 문자',
    my_marketing_minibook_step2_text1: '당신의 친구들에게 미니북의 링크와 함께 마음을 담은 소개글을 보내주세요',
    my_marketing_step2_text2: '친구에게 링크와 함께 소개글을 보내주세요 ',
    my_marketing_step2_placeholder: '소개 글을 입력해 주세요',
    my_marketing_tab_text1: '나의 친구들',
    my_marketing_event_step2_title: '강의 2단계 마케팅',
    my_marketing_event_step2_text1: '당신의 친구들에게 강의의 링크와 함께 마음을 담은 소개글을 보내주세요',
    my_marketing_minibook_step3_title: '미니북 3단계 마케팅',
    my_marketing_step3_subtitle: '친구들에게 이메일',
    my_marketing_minibook_step3_text1: '당신의 친구들에게 미니북의 링크와 함께 배경 이야기를 전해주세요',
    my_marketing_step3_text1: '내 주소록의 목록을 가져오세요',
    my_marketing_step3_placeholder: 'csv 또는 vcf 파일 업로드',
    my_marketing_step3_text2: '당신의 친구들에게 강의의 링크와 함께 마음을 담은 소개글을 보내주세요 ',
    my_marketing_step3_text3: '내 전화번호 목록을 가져오세요',
    my_marketing_step3_placeholder2: '이야기를 전해주세요',
    my_marketing_event_step3_title: '강의 3단계 마케팅',
    my_marketing_event_step3_text1: '당신의 친구들에게 강의의 링크와 함께 배경 이야기를 전해주세요',
    my_marketing_title2: '전화번호 관리',
    my_marketing_text7: '전화번호 가져오기',
    my_marketing_text8: '전화',
    my_marketing_text9: '횟수',
    my_marketing_text10: '주소록 가져오기',
    my_marketing_text11: 'csv 또는 vcf 파일을 업로드 해주세요',
    my_marketing_text12: '가져오는 방법',
    my_marketing_text13: '가져오기',
    my_marketing_title3: '주소록 관리',
    contact_manage: '주소록 관리',
    my_marketing_text14: '선택 삭제',
    my_marketing_text15: '친구를 선택해 주세요',
    my_marketing_text16: '최대 100명까지 선탱할 수 있습니다',
    my_marketing_text17: '업로드 되었습니다',
    my_marketing_text18: '입력 가능한 글자수가 초과되었습니다',
    contact_phone: '전화번호',
    contact_organization: '소속',
    contact_title: '직함',
    contact_memo: '메모',
    my_marketing_text19: '선택 수정',
    my_marketing_text20: '라벨 선택',
    my_marketing_text21: '새로운 라벨 추가',
    my_marketing_text22: '선택 라벨 삭제',
    my_marketing_text23: '추가',
    my_marketing_btn2: '수정 완료',
    my_marketing_text24: '수정할 연락처를 선택해 주세요',
    my_marketing_text25: '삭제할 라벨을 선택해주세요',
    my_marketing_text26: '라벨명을 입력해주세요',
    my_marketing_text27: '이미 존재하는 라벨입니다',
    my_marketing_text28: '라벨 추가',
    my_marketing_text29: '취소',
    my_marketing_text30: '추가 되었습니다',

    my_benefit_text1: '지금까지 얻은 이익',
    my_benefit_text2: '당신이 1년에 얻을 이익',
    my_benefit_text3: '',
    my_benefit_text4: '얻은 이익',
    my_benefit_text5: '얻을 이익',
    my_benefit_text6: '계산 확인해 보기',
    my_benefit_modal_text1: '당신은 지금까지',
    my_benefit_modal_text2: '원의',
    my_benefit_modal_text3: '이익을 얻었습니다',
    my_benefit_modal_text4: '아주 간단하게 \n 계산해 보겠습니다',
    my_benefit_modal_text5: '지금까지 읽은 페이지 수',
    my_benefit_modal_text6: '페이지당 생산가',
    my_benefit_modal_text7: '원',
    my_benefit_modal_text8: '결국, 얻은 이익 =',
    my_benefit_modal_text9: '여기에 AI와의 토론 혜택까지 더한다면',
    my_benefit_modal_text10: '당신의 이익은 훨씬 늘어날 것입니다',
    my_benefit_modal_text11: '매일 쓰시고 커다란 이익을 얻어보세요',
    my_benefit_modal_text12: '네, 알겠습니다',

    my_story_text1: '회원들 이야기',
    my_story_text2: '책은 읽는 게 아니라 경험하는 것이라는 사실',
    my_story_text3: '매일 새로운 지식을 배우면 놀라운 일이 생겨',
    my_story_text4: '똑똑한 사람이 겪는 숨겨진 함정, 혹시 당신도?',
    my_story_text5: '회원들 이야기 더 알아보기',

    my_go_blog_text1: 'A·Con, 소식과 고객 이야기',
    my_go_blog_text2: 'A·Con의 최신 소식과 고객들의 이야기를 알아보세요',
    my_go_blog_text3: '알아보기',

    my_channel_text1: 'A·Con, 써보니 어떠신가요?',
    my_channel_text2: '뭐가 좋은지, 뭘 개선하면 좋을지, 알려주세요',
    my_channel_text3: '물론, 궁금하신 점도 말씀해 주세요',
    my_channel_text4: '한 마디 해주기',
    my_about_youbook_text1: 'A·Con은 왜 써야 할까요',
    my_about_youbook_text2: '궁금한 것들 모두 여기에',
    my_about_youbook_text3: 'A·Con 이용약관',

    my_app_text1: 'A·Con은 100% 유익한 앱입니다.',
    my_app_text2: '지금 다운로드 하시고 지식을 얻어보세요.',
    my_app_text3: '앱 다운로드',

    mypage_support_madal_title: '나를 향한 조용하고 단단한 응원',
    mypage_support_modal_text1: '나의 지식과 생각, 그리고 성격까지 학습한 또 하나의 나. 바로 나의 디지털 쌍둥이! \n\n24시간 언제든 대화 가능한 나의 또 다른 버전.세상에 소개해 보면 어떨까요.\n\n 용기내어 해봐요. \n\n생각보다 많은 이들에게 도움이 될 수 있습니다.',
    login_title: '로그인',
    login_text1: '이메일로 로그인',
    login_text2: '아직 회원이 아니신가요?',
    login_text3: '비밀번호를 잊으셨나요?',
    login_text4: '소셜 계정 로그인',
    login_text5: '에 동의',
    login_link1: '회원가입',
    login_link2: '비밀번호 찾기',
    login_link3: '이용약관',

    login_placeholder1: '로그인용 이메일',
    login_placeholder2: '비밀번호',
    login_placeholder3: '프로필 아이디',
    login_message1: '로그인용 이메일을 입력해 주세요',
    login_message2: '비밀번호를 입력해 주세요',
    login_message3: '로그인에 성공했습니다',
    login_message4: '프로필 아이디를 입력해 주세요',
    logout_message1: '로그아웃 하시겠습니까',

    register_title: '회원가입',
    register_text1: '이메일로 회원가입',
    register_text2: '회원가입 종류를 선택하세요',
    register_text3: '개인회원',
    register_text4: '기관담당자',
    register_text5: '정보를 입력하세요',
    register_text6: '이미 회원이신가요?',
    register_text7: '법인번호',
    register_text8: '사업자 번호',
    register_text9: '기관 이름',
    register_placeholder1: '핸드폰 번호 ( - 제외하고 입력)',
    register_placeholder2: '( - 제외하고 입력)',
    register_placeholder_repassword: '비밀번호 재입력',
    register_message1: '핸드폰 번호를 입력하세요',
    register_message2: '법인 번호를 입력하세요',
    register_message3: '사업자 번호를 입력하세요',
    register_message4: '기관 이름을 입력하세요',
    register_message5: '이메일 형식이 올바르지 않습니다',
    register_message6: '이미 가입된 이메일 입니다',
    register_message7: '이메일을 인증해 주세요',
    register_message8: '국적을 선택하세요',
    register_message9: '아이디 형식이 올바르지 않습니다',
    register_message10: '입력하신 아이디는 사용할 수 없습니다. 추천 아이디를 사용하시거나, 다른 아이디를 입력해 주세요',
    register_message11: '프로필 아이디를 인증해 주세요',
    register_message12: '중복된 아이디 입니다. 추천 아이디를 사용하시거나, 다른 아이디를 입력해 주세요',
    register_button_verify: '인증',
    register_button_verify_fail: '인증불가',
    register_button_verify_success: '인증완료',
    register_welcome_message: '회원 가입을 환영합니다',

    withdraw_text1: '회원 탈퇴',
    withdraw_text2: 'Acon 회원 탈퇴',
    withdraw_text3: '정말 탈퇴하시겠습니까?',
    withdraw_text4: '아니오',
    withdraw_text5: '예',
    withdraw_text6: '탈퇴하였습니다',

    home_memo_title: '메모',
    home_memo_subtitle: '메모 안 하면 다 잊어요 아시나요',
    home_memo_text1: '모두가 함께 공유하는',
    home_memo_text2: '지식과 일상 이야기',
    home_memo_button: '메모 남기기',
    home_memo_create_text1: '링크할 미니북이 있으세요?',
    home_memo_create_button: '미니북 검색',
    home_memo_create_button2: '선택 하기',
    home_memo_click: '클릭',
    home_memo_date: 'YYYY.MM.DD',
    home_memo_button_askai: '댓글 / 책냥이 생각',
    home_memo_view_detail: '상세 내용 보기',
    home_memo_view_placeholder: '글을 입력하세요',
    home_memo_view_button1: '댓글달기',
    home_memo_view_button2: '책냥이 생각',
    home_memo_view_errormessage: '메시지를 입력하세요',

    memo_create_title: '메모',
    memo_create_category1: '메모',
    memo_create_category2: '내 메모',
    memo_create_private: '비공유',
    memo_create_public: '공유',
    memo_create_placeholder1: '좋은 생각이 반짝 떠올랐나요?',
    memo_create_placeholder2: '지금 바로 메모해 보세요',
    memo_create_placeholder3: '주제어 (사이에는 빈칸)',
    memo_create_button: '저장하기',
    memo_create_error: '내용을 입력해 주세요',
    memo_attach_img: '이미지 업로드',
    memo_alert_rate: '별점을 선택해 주세요',
    memo_alert_save: '저장하였습니다. MY - 내 여행에서 확인 가능합니다',
    memo_input_placeholder: '무엇을 새로 알게 되었나요?',
    memo_input_placeholder2: ' 내 생각은 어떤 것인가요?',
    memo_input_placeholder3: '지금 바로 독자들과 공유해 보세요~',
    memo_input_placeholder4: '일상의 기억, 남겨볼까요?',
    memo_alert_keywords: '주제어를 입력해 주세요',
    memo_related_text: '메모',
    memo_related_date: 'YYYY.MM.DD',
    memo_popup_text1: '독일의 사회학자 니콜라스 루만에게<br />일어났던 믿기 어려운 일을 소개합니다',
    memo_popup_text3: '루만은 한 회사의 행정실에서 일하던 평범한 젊은이였습니다',
    memo_popup_text4: '그는 독서를 좋아했고 매일 읽은 내용을 간단히 메모하곤 했습니다',
    memo_popup_text5: '그 내용을 정리해 독일의 유명 사회학자에게 논문으로 제출했고 그 인연으로 빌레펠트 대학의 교수로 초빙 되었습니다',
    memo_popup_text6: '루만은 그 이후 정식 교수가 되었고 은퇴할 때까지 60권의 책과 수백편의 논문을 출판했습니다 사회학의 대가가 된 것입니다',
    memo_popup_text7: '루만은 말합니다 “그저 꾸준히 메모했고 이를 틈틈히 되새기며 생각을 정리했을 뿐”이라고요',
    memo_popup_text8: '당신의 기억을 얼마나 믿으십니까',
    memo_popup_text9: '당신의 기억은 한계가 있습니다',
    memo_popup_text10: '아무리 좋은 지식도 며칠이면 다 없어집니다',
    memo_popup_text11: '꾸준한 메모와 <br />주기적으로 되새겨 보는 습관만이<br />지식을 당신의 것으로 해줍니다',
    memo_popup_btn: '네, 공감합니다',
    memo_text1: '위 내용을 저장할 수 있어요',
    memo_text2: '(주제어만 추가해 주세요)',
    memo_text3: '글 작성 시 확인할 사항',
    memo_text4: '작성하신 글은 이용약관 2조 1항의 컨텐츠 규정을 위반하였습니다. 공개가 되지 않습니다.',
    memo_text5: '이용약관 보기',
    memo_text6: '다른 언어권에 메모를 남기려면,',
    memo_text7: '그 언어로 글을 써주세요(자동 번역 안 됩니다)',
    memo_text8: '최대 5MB 이하 이미지만 첨부할 수 있습니다,',
    memo_text9: 'JPG 또는 PNG 형식의 이미지만 업로드할 수 있습니다',

    book_create_button: '미니북 만들기',
    book_create_title: '표지 만들기',
    book_create_cover: '표지',
    book_create_text1: '미니북의 표지를 만드는 단계입니다',
    book_create_text1_pc: '제목과 만든이 등을 입력하면 됩니다',
    book_create_text2: '직접 만든 표지 이미지 없을때',
    book_create_text3: '(직접 만든 표지 이미지가 없을 경우)',
    book_create_text4: '직접 만든 표지 이미지 있을때',
    book_create_text5: '표지 이미지를 직접 만드셨나요?',
    book_create_text6: '아래 버튼을 눌러 업로드 해주세요',
    book_create_text7: '(형식은 jpg, 크기는 20M 이내로)',
    book_create_text8: '페이지 추가권한',
    book_create_text9: '나만 가능',
    book_create_text10: '누구나 가능',
    book_create_text11: '이미지에 제목 표시',
    book_create_text12: '표시함',
    book_create_text13: '표시하지 않음',
    book_create_text14: '번역할 언어를 선택하세요',
    book_create_text15: '전체 선택',
    book_create_text16: '표지 이미지 업로드',
    book_create_text17: '수정할 수 있습니다',
    book_create_text18: '수정 후 다시 번역을 하시려면 우측상단의 아이콘을 눌러주세요',
    book_create_text19: '혹시 원문대로 다시 번역 하시려면 우측 상단의 아이콘을 눌러주세요',
    book_create_text20: '다시 번역하기',
    book_create_text21: '이미지',
    book_create_text22: '제목',
    book_create_text23: '주제어',
    book_create_text24: '내용',
    book_create_text25: '이미지를 삭제하고 새로 업로드한 경우에만 다시 번역이 됩니다',
    book_create_text26: '(페이지는 삭제되지 않습니다)',
    book_create_text27: '소개하는 내용을 적어주세요',
    book_create_text28: '임시 저장',
    book_create_text29: '임시 저장되었습니다',
    book_create_text30: '확인할 사항',
    book_create_text31: '글의 내용은 최종본으로서 더 이상 수정은 필요하지 않다',
    book_create_text32: '번역을 하는 AI가 이해할 수 없는 단어나 기호는 사용하지 않았다',
    book_create_text33: '사진은 복사해서 붙이지 않고 대신 별도의 파일을 입력하였다',
    book_create_text34: '공개 모집할까요? (오픈 미니북)',
    book_create_text35: '공동 저자',
    book_create_text36: '직접 추가할래요?',
    book_create_text37: '추가하기',
    book_create_text38: '같이 써서, 더 널리 퍼지는 미니북',
    book_create_text39: '당신이 모르는 공동 저자의 파워',
    book_create_text40: '모집하기',
    book_create_text41: '취소하기',
    book_create_text42: '임시저장 상태입니다. 작성 완료 후, 공동저자를 추가할 수 있습니다',
    book_create_text43: '아이디어?',
    book_create_text44: '내용 복사 및 붙여넣기',
    book_create_text45: '아이디어가 필요한가요?',
    book_create_text46: '판매 옵션',
    book_create_text47: '무료',
    book_create_text48: '후원',
    book_create_text49: '구매',
    book_create_text50: '현재 가격',
    book_create_text51: '수정할 가격',
    book_create_text52: '0원으로 수정할 수 없습니다',
    book_create_text53: '구매 혹은 후원이 이루어진 미니북은 가격이나 판매방식을 바꿀 수 없습니다',
    book_create_text54: '미니북의 저자만 메시지의 답글을 작성할 수 있습니다',

    book_create_button_upload: '업로드 하기',
    book_create_button_make: '만들기',
    book_create_cover_topic_placeholder: '제목은 이렇게 보여요',
    book_create_topic_placeholder: '제목을 입력하세요',
    book_create_keyword_placeholder: '주제어를 입력하세요(3개 이상, 주제어 사이 빈 칸)',
    book_create_category_placeholder: '카테고리를 선택하세요',
    book_create_knowledge_placeholder: '이 미니북을 소개하는 내용을 적어주세요  <br/>  ** 주의 - 더 자세한 내용은 페이지를 만드는 단계에서 적어주세요',

    book_create_category_option1: '영화와 드라마',
    book_create_category_option2: '음악과 춤',
    book_create_category_option3: '그 외 예술',
    book_create_category_option4: '의상과 스타일',
    book_create_category_option5: '음식과 요리',
    book_create_category_option6: '술과 음료',
    book_create_category_option7: '스낵과 디저트',
    book_create_category_option8: '식물과 건강',
    book_create_category_option9: '부자되기',
    book_create_category_option10: '자기개발',
    book_create_category_option11: '인간관계',
    book_create_category_option12: '새로운 지식',
    book_create_category_option13: '생활이야기',
    book_create_category_option14: '철학과 가치관',
    book_create_category_option15: '종교와 전통',
    book_create_category_option16: '사랑',
    book_create_category_option17: '여행과 명소',
    book_create_category_option18: '취미생활',
    book_create_category_option19: '놀이문화',
    book_create_category_option20: '신화와 영웅',
    book_create_category_option21: '문학기행',
    book_create_category_option22: '역사와 지혜',
    book_create_category_option23: '사회이야기',
    book_create_category_option24: '상식',

    book_create_message1: '제목을 입력해 주세요',
    book_create_message2: '만든이를 입력해 주세요',
    book_create_message3: '주제어를 입력해 주세요',
    book_create_message4: '주제어를 3개이상 입력해 주세요',
    book_create_message5: '카테고리를 선택해 주세요',
    book_create_message6: '이미지를 업로드해 주세요',
    book_create_message7: '특수 문자는 입력할 수 없습니다. 주제어 사이는 한 칸 띄어주세요',
    book_create_message8: '미니북을 삭제 하시겠습니까',
    book_create_message9: '해당 언어에 대한 출판권이 없습니다',
    book_create_message10: '구매가 발생한 미니북은 삭제할 수 없습니다',
    book_create_modal_text1: '잠시만 기다려 주세요..',
    book_create_modal_text2: 'AI가 내용 검토, 외국어 번역, 지식 신경망 연결 등의 작업을 합니다',
    book_create_modal_text3: '페이지별 검색이 되도록 지식망에 연결 중입니다',
    book_create_modal_text4: '표지 이미지에 제목이 나타나지 않습니다',
    book_create_modal_text5: '(외국어로 번역된 표지의 경우에도 동일합니다)',

    book_view_title: '미니북 소개',
    book_view_share: '친구와 공유',
    book_view_event_topic: '강의 주제로',
    book_view_together_suggest: '강의 공간 제안하기',
    book_view_together_message: '좋아하는 강의 공간이 없습니다. <br/> 강의 메뉴에 가서 골라보세요',
    book_view_event_message: '내가 만든 강의가 없습니다',
    book_view_text1: '저장된 페이지가 없습니다.',
    book_view_text2: '지금 바로 페이지를 추가해 보세요.',
    book_view_text3: '미니북이 존재하지 않습니다. 다시 시도해 주세요.',
    book_view_text4: '이 미니북의 페이지들',
    book_view_text5: '요 미니북의 번역 개선이나 홍보를 해주고 수익을 나누어 가지면 어때요?',
    book_view_text6: '페이지 목차',
    book_view_text7: '가격 수정하기',
    book_view_text8: '구매자가 있어 수정이 불가능합니다',
    book_view_text9: '독자의 선물',
    book_view_text10: '미니북의 저자만 메시지의 답글을 작성할 수 있습니다',

    book_view_modal_title: '번역 개선과 홍보',
    book_view_modal_text1: '요 미니북의 번역을 직접 개선해 줄 수 있으신가요? 또는 홍보를 해줄 수 있으신가요?',
    book_view_modal_text2: '저자에게 메시지를 남겨보세요.',
    book_view_modal_text3: '저자가 허락하면 수익을 나누어 가질 수도 있습니다.',

    book_view_write_share_title: '오픈 미니북이예요',
    book_view_write_share_text1: '이 미니북의 공동 저자가 되고 싶으신가요?',
    book_view_write_share_text2: '저자 신청하기',
    book_view_write_share_text3: '간단하게 신청글을 남겨주세요',
    book_view_write_share_text4: '보내기',
    book_view_write_share_list_title: '공동 저자들',
    book_view_write_share_text5: '미니북의 공동 저자를 관리하세요',
    book_view_write_share_text6: '저자 관리하기',
    book_view_write_share_text7: '수락',
    book_view_write_share_text8: '수락 되었습니다',
    book_view_write_share_text9: '이미 저자로 등록된 사용자 입니다',
    book_view_write_share_text10: '직접 저자 추가하기',
    book_view_write_share_text11: '이미 신청한 사용자 입니다',

    book_view_publish_text1: '이 미니북의 출판을 원하시나요?',
    book_view_publish_text2: '출판을 하면 모든 사용자에게 공개가 되며, 수익을 낼 수도 있습니다',
    book_view_publish_text3: '(유료 출판의 경우에는, 타인의 페이지가 포함되면 안 됩니다)',
    book_view_publish_text4: '가격 정하기',
    book_view_publish_text5: '출판일 정하기',
    book_view_publish_text6: '출판 요청하기',
    book_view_publish_text7: '즉시출판',
    book_view_publish_text8: '예약출판',
    book_view_publish_text9: '미출판',
    book_view_publish_text10: '출판중',
    book_view_publish_text11: '출판',
    book_view_publish_text12: '출판 시 확인할 사항',
    book_view_publish_text13: '이 미니북은 YouBook 내에서 이전에 출판된 적이 없다',
    book_view_publish_text14: '이 미니북과 페이지에서는 타인의 글이나 기타 지적재산권을 도용하지 않았다',
    book_view_publish_text15: '내용에 비속어, 지나친 성적 표현, 타인에 대한 비방, 상업용 광고 등이 없으며 이용약관의 2조 1항을 위반하지 않았다',
    book_view_publish_text16: '예',
    book_view_publish_text17: '출판 현황',
    book_view_publish_text18: '출판 완료',
    book_view_publish_text19: '출판 시간',
    book_view_publish_text20: '출판 가격',
    book_view_publish_text21: '공개 기간 정하기',
    book_view_publish_text22: '공개 기간',
    book_view_publish_text23: '공개 기간이란',
    book_view_publish_text24: '독자가 그 내용을 볼 수 있는 기간을 말합니다',
    book_view_publish_text25: '이 미니북은 3개 이상의 페이지를 포함하고 있다',
    book_view_publish_text26: '이 미니북은 3개 이상의 페이지를 포함하지 않습니다',
    book_view_publish_text27: '만일 위반사항이 있으면 알고리즘에 의해 검색 순위가 조정됩니다. 문제가 심각한 경우 미니북은 자동으로 삭제됩니다.',
    book_view_publish_text28: '판매 옵션 정하기',
    book_view_publish_text29: '구매 방식',
    book_view_publish_text30: '후원 방식',
    book_view_publish_message1: '유료 출판의 경우, \n 1) 미니북에 속한 페이지들이 내가 만든 것으로서 \n 2) 기존에 유료로 출판한 적이 없어야 합니다',
    book_view_publish_message2: '출판 가능한 상태가 아닙니다. 관리자에게 문의해 주세요',
    book_view_publish_message3: '이미 출판된 미니북 입니다',
    book_view_publish_message4: '공개 기간은 현재시간 이후로 선택해주세요',
    book_view_publish_message5: '날짜와 시간을 모두 선택해주세요',
    book_view_publish_message6: '출판이 승인되었습니다. 감사합니다',
    book_view_publish_message7: '확인사항에 체크해 주세요 ',
    book_view_publish_message8: '종료일은 시작일보다 이전일 수 없습니다',
    book_view_publish_message9: '임시 저장중인 미니북은 출판할 수 없습니다',
    book_view_publish_message10: '이 미니북은 양도받은 것입니다.                                               최초의 출판권은 작가에게 있습니다',
    book_view_publish_message11: '최소 금액 {minPrice} 이상 입력해 주세요',

    book_view_button_confirm: '확인했어요',
    book_view_button_publish: '출판해 주세요',
    book_view_button_order: '페이지 정렬',
    book_view_button_add: '페이지 추가하기',
    book_view_button_video: '동영상 보기',
    book_view_button_read: '읽어보기',
    book_view_button_lecture: '강연 영상 보기',

    book_view_page_add_title: '페이지 추가',
    book_view_page_add_text1: '<b>타인의 페이지</b>를 <b>검색</b>한 후',
    book_view_page_add_text2: '<b>페이지 내용보기</b> 화면에서',
    book_view_page_add_text3: '내 <b>미니북에 담기</b>',
    book_view_page_add_text4: '혹시 페이지를 직접 만들고 싶으신가요?',
    book_view_page_add_text5: '페이지 만들기는 <br/> 저자로 등록되신 분만 가능합니다. <br/> 저자 등록을 원하시면 <br/> 아래로 연락해 주세요 <br/>',
    book_view_page_add_text6: '혹시 타인의 페이지를 추가하고 싶으신가요?',
    book_view_page_add_text7: '* 타인이 만든 페이지를 추가한 경우, \n유료 미니북으로 출판할 수 없습니다',
    book_view_page_add_text8: '기존에 직접 만든 페이지가 있나요?',
    book_view_page_add_button1: '지금 만들기',
    book_view_page_add_button2: '직접 만든 페이지 보기',

    book_view_reference_text1: '다양함',
    book_view_reference_text2: '다수',
    book_view_reference_text3: '미니북 저자',
    book_view_reference_text4: '직접 창작',

    book_view_support_text1: '응원해요',
    book_view_support_modal_title: '응원자가 되어주세요',
    book_view_support_modal_text1: '아무리 좋은 글이라도, 혼자 힘만으로 세상에 퍼지기는 어렵습니다.',
    book_view_support_modal_text2: '\'응원자\'는 저자의 미니북을 세상에 전하는 사람입니다. 서로를 응원하는 사람입니다.',
    book_view_support_modal_text3: '함께 손을 맞잡아 이야기를 더 멀리 퍼뜨립니다.',
    book_view_support_modal_text4: '저자의 응원자가 되어주세요',
    book_view_support_modal_btn1: '네 알겠어요',
    book_view_support_modal_text5: ' "당신의 응원은 제게 큰 도움이 됩니다. \n감사합니다. 저 역시 당신의 여행길을 마음을 다해 응원하겠습니다." ',
    book_view_support_modal_text6: '저의 이야기를 세상에 전해 주세요',
    book_view_support_modal_btn2: '어떻게 하면 되나요',
    book_view_support_modal_title2: '여기까지 온 나, 수고 많았습니다',
    book_view_support_modal_text7: '글을 쓰는 게 쉽지 않았지만, 나는 해냈습니다.',
    book_view_support_modal_text8: '이제는 나 자신을 믿고, 한 걸음 더 내디딜 차례입니다.',
    book_view_support_modal_text9: '조금 쑥스럽고 망설여져도, 내가 나의 첫 번째 응원자가 되어, 세상에 소개해봅니다.',
    book_view_support_modal_text10: '누군가에게, 그 어떤 의미를 줄 수 있음을 믿기  때문입니다. ',
    book_view_support_modal_text11: '나의 응원자가 되어주세요',
    book_view_support_modal_text12: '글을 쓰거나 강의를 여는 것, 쉽지는 않았지만 나는 도전했습니다.',
    book_view_support_modal_btn3: '해볼게요!',
    book_view_support_modal_title3: '응원자님 안녕하세요',
    book_view_open_minibook_text1: '오픈 미니북 신청이 완료되었습니다',
    book_view_open_minibook_text2: '오픈 미니북 신청이 취소되었습니다',

    page_create_title: '페이지 만들기',
    page_create_text1: '직접 만든 페이지 이미지 없을때',
    page_create_text2: '(직접 만든 페이지 이미지가 없을 경우)',
    page_create_text3: '페이지',
    page_create_text4: '직접 만든 페이지 이미지 있을때',
    page_create_text5: '페이지 이미지를 직접 만드셨나요?',
    page_create_text6: '내용을 입력하세요. A4 용지 한 장 이내를 권장합니다.',
    page_create_text7: '현재 바이트 수',
    page_create_text8: '최대 크기',
    page_create_text9: '이 페이지의 참고자료가 있나요',
    page_create_text10: '직접 창작',
    page_create_text11: '책 참고',
    page_create_text12: '블로그 참고',
    page_create_text13: 'AI 참고',
    page_create_text14: '미니북의 페이지를 만드는 단계입니다 \n각각의 항목을 입력하면 됩니다',
    page_create_text15: '페이지 이미지 업로드',
    page_create_text16: '다시 번역을 원하시나요',
    page_create_text17: '다시 번역을 원하시면 대상과 언어를 선택해 주세요 (선택하지 않으면 번역하지 않은 채 저장됩니다)',
    page_create_text18: '번역할 대상',
    page_create_text19: '번역할 언어',
    page_create_message1: '수정할 수 없습니다',
    page_create_message2: '내용을 입력하세요',
    page_create_message3: '페이지를 삭제 하시겠습니까',
    page_create_message4: '내용이 최대 크기를 초과하였습니다',
    page_create_reference_book: '책',
    page_create_reference_blog: '블로그',
    page_create_reference_placeholder1: '의 제목을 입력하세요',
    page_create_reference_placeholder2: '관련 링크 (예시  https://www.kyobo.com/books/11223344)',
    page_create_reference_placeholder3: '의 출판 년도를 적어주세요',
    page_create_reference_placeholder4: '의 저자를 입력하세요',
    page_create_title_placeholder: '제목은 이렇게 보여요',
    page_create_message5: '번역 중입니다',
    page_create_message6: '표지를 만든 후에 페이지를 만들 수 있습니다',
    page_create_modal_text1: '페이지 이미지에 제목이 나타나지 않습니다',
    page_create_modal_text2: '(외국어로 번역된 페이지의 경우에도 동일합니다)',
    page_create_modal_text3: '반드시 확인하세요!',
    page_create_modal_text4: '변경된 내용이 있다면 저장을 해야 합니다 ',
    page_create_modal_text5: '그렇게 하였습니까? ',
    page_create_modal_text6: '변경된 내용이 있으면 만들기를 해야 합니다.',

    page_view_title: '페이지 보기',
    page_view_button_video: '동영상으로 보기',
    page_view_button_read: '읽어 보기',
    page_view_text1: '내 미니북에 담기',
    page_view_text2: '전체 자동 재생',
    page_view_text3: '읽은수',
    page_view_text4: '관련된 페이지',
    page_view_text5: '관련된 미니북',
    page_view_text6: '참고자료가 궁금하신가요',
    page_view_text7: '페이지 참고자료',
    page_view_text8: '출판년도',
    page_view_text9: '저자',
    page_view_text10: '제목',
    page_view_text11: '이 참고의 전체 페이지',
    page_view_text12: '관련된 자료 검색',
    page_view_text13: '페이지 저자',
    page_view_text14: '저자 만나보기',
    page_view_text15: '담기',
    page_view_reference_text1: '책',
    page_view_reference_text2: '블로그',
    page_view_popup: '내가 만든 미니북이 없습니다<br /><br /> MY 페이지에서 만들어 주세요',
    page_view_pay_popup_text1: '읽고 무엇인가를 얻었나요? \n저자에게 작은 선물로 화답해 주세요.',
    page_view_pay_popup_title: '선물하기',
    page_view_pay_popup_text2: '선물로 보낼 차를 골라 주세요',
    page_view_pay_popup_text3: '메시지를 써주세요',
    page_view_pay_popup_placeholder1: '저자의 경험에서 우러나온 지혜와 감성의 글이 도움이 되었습니다',
    page_view_pay_popup_text4: '금액',
    page_view_pay_popup_button1: '구매 및 메시지 보내기',
    page_view_pay_popup_text5: '이 글을 쓰기 위해 저자는 많은 시간과 정성을 들였습니다. \n\n작은 선물로 화답해 주세요.',
    page_view_pay_popup_placeholder2: '저자의 경험에서 우러나온 지혜와 감성의 글에 기대를 걸어봅니다',
    page_view_pay_popup_text6: '선물에 관심이 없으신가요? ',
    page_view_pay_popup_text7: '광고만 본 후 읽고 싶으신 거죠? ',
    page_view_pay_popup_button2: '광고보고 읽기',
    page_sort_title: '페이지 정렬',
    page_sort_subtitle: '페이지를 드래그하여 순서를 변경하세요',
    page_sort_text: '출처',

    pay_button: '구매하기',
    pay_price: '구매 금액',
    pay_vat_excluded: '(부가세 별도)',
    pay_message_success: '구매가 완료되었습니다',
    pay_message_fail: '구매에 실패하였습니다',
    pay_currency: '원',
    pay_button_paid: '구매완료',
    pay_button_view_price: '가격보기',
    pay_total: '구매 금액',
    pay_methods: '결제 수단',
    pay_methods_creditcard: '신용카드',
    pay_methods_paypal: '페이팔',
    pay_button_continue: '계속',
    pay_text1: '차를 선택해주세요',
    pay_text2: '메시지를 입력해 주세요',

    advertisement_button: '더 읽어보기',
    advertisement_text1: '광고를 보면 <br/> 내용을 볼 수 있습니다.',
    advertisement_text2: '유료 미니북의 페이지입니다.  <br />표지로 가서 읽어보기 누르면<br /> 구매가 가능합니다. <br />',
    advertisement_text3: '광고를 보면 내용을 볼 수 있습니다. 광고는 앱에서 볼 수 있습니다.',

    together_title: '강의',
    together_subtitle: '독자와 만나 이야기하기',
    together_subtitle_text1: '온라인에서 독자와 만나보세요',
    together_subtitle_text2: '다른 언어권에서도 할 수 있어요',
    together_button: '강의 공간 만들기',
    together_case: '운영 사례',
    together_case1: '주려고 하는데 자꾸만 받게되네요',
    together_case2: '실제 사례가 이렇게 도움이 될 줄은',
    together_subtitle2: '내가 만든 공간',
    together_category1: '최신순',
    together_category2: '좋아요순',
    together_button_viewmore: '더보기',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD A hh:mm',
    together_subtitle3: '이런 공간 ',
    together_subtitle3_1: '만들어주세요',
    together_subtitle_text3: '누가 시작하면 참여하고 싶어요',

    together_create_title: '강의 공간 만들기',
    together_create_title2: '강의 공간 수정하기',
    together_create_button1: '선택',
    together_create_subtitle: '제목',
    together_create_placeholder1: '제목을 입력하세요 (최대 20자)',
    together_create_subtitle1: '간단한 소개',
    together_create_placeholder2: '간단한 소개를 입력하세요',
    together_create_subtitle2: '어떤 도구로 강의를 할까요',
    together_create_text1: '온라인 미팅용 링크 (예: 줌 링크)',
    together_create_placeholder3: '온라인 미팅용 링크를 넣어주세요',
    together_create_question1: '줌 링크를 모른다구요?',
    together_create_q1_a_title: '줌 회의 참가 링크 찾기',
    together_create_text2: '또는, 메타버스로 하기',
    together_create_placeholder4: '강의 공간에 적합한 것을 고르세요',
    together_create_question2: '메타버스가 뭔지 모른다구요?',
    together_create_text3: '어디에 강의 공간을 개설할까요',
    together_create_dropmenu1: 'YouBook 위촉 지식인 코너에 개설',
    together_create_dropmenu2: '작가와 독자 코너에 개설',
    together_create_button2: '수정하기',
    together_create_button3: '만들기',
    together_create_popup_title: '활동 메타버스 선택',
    together_create_popup_alert: '이미 선택되었습니다',
    together_create_button4: '선택',
    together_create_alert: '온라인 미팅용 링크를 넣어 주세요',
    together_create_alert1: '제목을 입력하세요',
    together_create_alert2: '활동할 메타버스를 선택해 주세요',
    together_create_alert3: '수정할 수 없습니다',
    together_create_alert4: '강의 공간이 만들어졌습니다',
    together_create_alert5: '에러가 발생했습니다. 다시 시도해 주세요',
    together_create_alert6: '강의 공간 만들기 실패...',
    together_qa_popup_title1: '줌 회의 참가 링크 찾기',
    together_qa_popup_btext1: '컴퓨터',
    together_qa_popup_text1: ' : 줌 프로그램을 열고 - 로그인 후 -',
    together_qa_popup_text1_1: '상단의 회의 메뉴 누르고 - 내 개인회의 ID - 회의 초대 표시 누르면 - 줌 회의 참가 링크가 나옵니다. 그걸 복사해 넣습니다.',
    together_qa_popup_btext2: '스마트폰',
    together_qa_popup_text2: ': 줌 프로그램 열고 - 로그인 후 -',
    together_qa_popup_text2_1: '우 상단 i 버튼 누르고 - 초대 보내기 -',
    together_qa_popup_text2_2: '메시지를 누른 후 - 내 전화번호를 입력 -',
    together_qa_popup_text2_3: '링크가 나옵니다. 그걸 복사해 넣습니다.',
    together_qa_popup_title2: '메타버스란',
    together_qa_popup_text3: '가상의 미팅 공간 입니다.',
    together_qa_popup_text4: '내가 꾸민 아바타의 모습으로 나타나',
    together_qa_popup_text5: '친구들 얼굴 보며 이야기하고 화면도 공유할 수 있습니다',
    together_qa_popup_text7: '하나의 미팅 공간에는',
    together_qa_popup_text8: '10명이 동시에 입장할 수 있습니다.',
    together_qa_popup_text9: '별도의 프로그램 설치나',
    together_qa_popup_text10: '회원 가입이 필요 없습니다.',
    together_more_list_title: '강의 공간',
    together_more_list_date: 'YYYY.MM.DD 개설',
    together_request_list_title: '만들어 주세요',
    together_request_list_category1: '좋아요순',
    together_request_list_category2: '최신순',
    together_request_list_button: '새 공간 제안하기',
    together_request_popup_title: '새 공간 제안',
    together_request_popup_alert1: '제목을 입력하세요',
    together_request_popup_alert2: '내용을 입력하세요',
    together_request_popup_placeholder1: '제목을 입력하세요',
    together_request_popup_placeholder2: '내용을 입력하세요',
    together_request_popup_button: '등록하기',
    together_request_detail_button: '요 공간 만들기',
    together_detail_sns: ' 친구 초대',
    together_detail_enterbtn: '입장하기',
    together_detail_btn1: '강의 목록',
    together_detail_btn2: '메시지',
    together_detail_subtitle: '주제로 할 미니북',
    together_detail_alert: '잠시만 기다려 주세요!',
    together_detail_alert1: '강의 공간 제안하기 성공!',
    together_detail_alert2: '강의 공간 제안하기 실패…',
    together_detail_alert3: '공감 / 공감취소 성공!',
    together_detail_alert4: '공감 / 공감취소 실패…',
    together_detail_alert5: '서버에 문제가 발생했습니다. 잠시 후 다시 시도해 주세요',
    together_detail_alert6: '온라인 미팅을 위한 링크에 문제가 있습니다',
    together_detail_alert7: '삭제 실패하였습니다',
    together_notice_alert: '공지사항을 삭제 하시겠습니까?',
    together_notice_list_title: '공지사항',
    together_button_addtopic: '이 강의 공간에 주제로 추가',
    together_add_alert: '강의 공간에 추가 되었습니다',
    together_text1: '당신과 비슷한 취향인',
    together_text2: '강의 공간을 삭제 하시겠습니까?',

    together_event_btn: '새로운 강의 개설',
    together_event_title: '새로운 강의',
    together_event_placeholder: '소개글을 입력하세요',
    together_event_text1: '일정 정하기',
    together_event_text2: '입장료 정하기',
    together_event_text3: '최대 인원을 정하세요',
    together_event_text4: '일정',
    together_event_text5: '입장료',
    together_event_text6: '최대인원',
    together_event_text7: '나의 팔로워에게 알림',
    together_event_text8: '강의를 삭제하시겠습니까?',
    together_event_text9: '시작 시간은 현재 시간 이후로 설정해주세요',
    together_event_text10: '끝 시간은 시작 시간 이후로 설정해주세요',
    together_event_text11: '시작 시간과 끝 시간이 같을 수 없습니다',
    together_event_text12: '이 강의에 주제로 추가',
    together_event_text13: '강의에 추가 되었습니다',
    together_event_text14: '강의 최대 인원을 초과하였습니다',
    together_event_text15: '버튼은 시작 1시간 전부터 활성화 됩니다 \n(무료 또는 이미 구매한 경우 구매할 필요 없어요)',
    together_event_text16: '버튼은 시작 1시간 전부터 활성화 됩니다',
    together_event_text17: '등록된 강의가 존재하지 않습니다',
    together_event_text18: '강의의 구매자가 있는 경우 삭제할 수 없습니다',
    together_event_text19: '알림을 보내시겠습니까?',
    together_event_text20: '전송 되었습니다',
    together_event_text21: '강의 목록',
    together_event_text22: '강의',
    together_event_text23: '회원 가입 후 로그인 해주세요',
    together_event_text24: '참석 방법',
    together_event_text25: '강의 참여 완료',
    together_event_text26: '이 강의를 위해 저자는 많은 시간과 \n정성을 들였습니다. \n\n작은 선물로 화답해 주세요.',
    together_event_text27: '저자의 경험에서 우러나온 지혜와 깊은 소통이 인상 깊었습니다',
    together_event_text28: '강의를 세상에 전해 주세요',
    together_event_text29: '강의를 여는 게 쉽지 않았지만, 나는 해냈습니다.',
    together_event_text30: '아무리 좋은 강의라도, 혼자 힘만으로 세상에 퍼지기는 어렵습니다.',
    together_event_text31: '\'응원자\'는 저자의 강의를 세상에 전하는 사람입니다. 서로를 응원하는 사람입니다.',

    youbooker_title: '멤버',
    youbooker_subtitle: '세상의 다양한 사람들을 만나보세요',
    youbooker_case: '멤버 생각',
    youbooker_case_text1: '늘 시작하는 사람이 된다는 것',
    youbooker_case_text2: '지식의 복리효과, <br /> 내일은 훨씬 나은 내가 되겠죠',
    youbooker_translation: '지금, 무료로 만날 수 있어요',
    youbooker_translation_text1: '모든 언어권',
    youbooker_category: '팔로워 / 팔로잉',
    youbooker_subcategory1: '나의 팔로워',
    youbooker_subcategory2: '내가 팔로잉',
    youbooker_subtitle2: '나를 팔로잉 하는 사람이에요',
    youbooker_button_follow: '팔로잉 하기',
    youbooker_message_follow: '팔로우',
    youbooker_button_follow_cancel: '팔로잉 취소',
    youbooker_subtitle3: '아는 사람이에요. 팔로잉 해보세요',
    youbooker_subtitle4: '내가 팔로잉 하는 사람이에요',
    youbooker_subtitle5: '아는 사람인데 아직 에이콘을 몰라요',
    youbooker_button_invite: '초대하기',
    youbooker_alert_invite: '초대하기는 앱에서만 가능합니다. 앱을 다운로드 하시면 어떨까요',
    youbooker_alert: '앱에서만 가능합니다. 앱을 다운로드 하시면 어떨까요',
    youbooker_alert2: '새로고침 성공!',
    youbooker_alert3: 'youBooker에서 검색 가능합니다',

    home_page_text1: '최신순',
    home_page_text2: '영향력',
    home_page_today_title: '투데이 이슈',
    home_page_today_subtitle: '최신의 톱 뉴스 관련',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: '투데이 이슈',
    home_page_today_detail_sns: '좋은 건 친구와 공유',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: '관련된 페이지',

    home_page_explor_title: '페이지 탐험',
    home_page_explor_subtitle: '더블 클릭하면 뭐가?',
    home_page_recommend_title: '맞춤형 추천',
    home_page_recommend_subtitle: '관심이 있으신 지식을 모아봤어요',
    home_page_theysee_title: '그들은 뭘 볼까',
    home_page_theysee_subtitle: '독자들이 꼭 보는 페이지는?',
    home_page_common_title: '요런 상식 어때요',
    home_page_common_subtitle: '상식의 힘은 강합니다 올바르게 보게 해줍니다',
    home_page_keyw_title: '주제어로 보는 페이지',
    home_page_keyw_subtitle: '관련된 지식 다 찾습니다',
    home_page_random_title: '랜덤으로 GO',
    home_page_random_subtitle: '멍할때누르세요 <br />뜻하지 않은 걸 우연하게 배웁니다',
    home_page_map_title: '세계 사람들이 이용하는 미니북',
    home_page_about_title: '사업자 정보',
    home_page_about_detail: '회사명 : 주식회사 닉신디케이트<br />한국 비즈니스 센터 : 서울시 서초구 반포대로 14길 71, 엘지서초에클라트 1915호<br />대표 : 유기윤 | 개인정보관리책임자 : 유기윤<br />사업자등록번호 : 238-88-02504<br />통신사업자등록번호 : 2023-서울서초-1700<br /><br />고객상담 : joa@academy-connect.net | 내 홈 - 설정 - 한 마디 해주기<br /><span className="span">070-4578-9240</span>',

    settlement_title: '구매 정산',
    settlement_tab1: '구매이력',
    settlement_tab2: '계좌정보',
    settlement_tab3: '정산내역',
    settlement_category1: '내 구매 내역',
    settlement_category2: '저자권 공유',
    settlement_category3: '미니북 수익 정산 내역',
    settlement_category4: '강의 수익 정산 내역',
    settlement_category5: '계좌 관리',
    settlement_text1: '구매 내역을 보여드립니다',
    settlement_text2: '미니북 저자권을 공유할 수 있습니다',
    settlement_text3: '유료 미니북 판매로 얻은 수익을 정산합니다',
    settlement_text4: '추가로 궁금하신 점은',
    settlement_text5: '여기',
    settlement_text6: '에 \n 또는 아래로 문의 주시기 바랍니다',
    settlement_text7: 'joa@academy-connect.net   070-4578-9240',
    settlement_text8: '한 마디 해주기',
    settlement_text9: '수익이 있는 경우 수익금을 받을 계좌를 관리해야 합니다',
    settlement_text10: '강의로 얻은 수익을 정산합니다',

    settlement_purchase_text1: '구매 내역',
    settlement_purchase_text2: '날짜',
    settlement_purchase_text3: '구매액',
    settlement_purchase_text4: '제목',
    settlement_purchase_text5: '미니북',
    settlement_purchase_text6: '강의',

    settlement_accountInfo_text1: '미니북의 저자권',
    settlement_accountInfo_text2: '미니북 선택',
    settlement_accountInfo_text3: '언어 선택',
    settlement_accountInfo_text4: '저자권',
    settlement_accountInfo_text5: '저자',
    settlement_accountInfo_text6: '제3자',
    settlement_accountInfo_text7: '개인 여부',
    settlement_accountInfo_text8: '개인',
    settlement_accountInfo_text9: '법인',
    settlement_accountInfo_text10: '은행명',
    settlement_accountInfo_text10_message: '은행을 선택하세요',
    settlement_accountInfo_text11: '예금주 이름',
    settlement_accountInfo_text11_message: '예금주를 입력하세요',
    settlement_accountInfo_text12: '계좌 번호',
    settlement_accountInfo_text12_message: '계좌번호를 입력하세요',
    settlement_accountInfo_text12_placeholder: '예) 079-12-444987',
    settlement_accountInfo_text13: '주민등록번호',
    settlement_accountInfo_text13_message: '주민등록번호를 입력하세요',
    settlement_accountInfo_text13_placeholder: '예) 930221-1228773',
    settlement_accountInfo_text14: '주소',
    settlement_accountInfo_text14_message: '주소를 입력하세요',
    settlement_accountInfo_text14_placeholder: '주민등록상 주소',
    settlement_accountInfo_text15: '이메일',
    settlement_accountInfo_text15_message: '이메일을 입력하세요',
    settlement_accountInfo_text16: '입력완료',
    settlement_accountInfo_text17: '사업자 등록번호',
    settlement_accountInfo_text17_message: '사업자 등록번호를 입력하세요',
    settlement_accountInfo_text17_placeholder: '예) 238-88-02504',
    settlement_accountInfo_text18: '주소',
    settlement_accountInfo_text18_message: '법인 등기부의 주소를 입력하세요',
    settlement_accountInfo_text18_placeholder: '법인 등기부의 주소',
    settlement_accountInfo_text19: '법인 이름',
    settlement_accountInfo_text19_message: '법인 이름을 입력하세요',
    settlement_accountInfo_text20: '법인 연락처',
    settlement_accountInfo_text20_message: '법인 연락처를 입력하세요',
    settlement_accountInfo_text21: '제3자 ID',
    settlement_accountInfo_text21_placeholder: '제3자 이메일 주소',
    settlement_accountInfo_text22: '정산받을 계좌 정보',
    settlement_accountInfo_text23: '국가 선택',
    settlement_accountInfo_message1: '양수자의 이메일을 찾을 수 없습니다',
    settlement_accountInfo_message2: '자기 자신에게 저자권을 공유할 수 없습니다',
    settlement_accountInfo_message3: '만든 미니북이 없습니다',
    settlement_accountInfo_text24: '저자권 공유',
    settlement_accountInfo_text25: '저자권을 제3자에게 공유하면 다시 회수가 불가능합니다',
    settlement_accountInfo_text26: '저자권을 공유하시겠습니까?',
    settlement_accountInfo_text27: '네, 공유합니다.',
    settlement_accountInfo_text28: '저자권 공유의 경우,<br /> 1) 미니북에 속한 페이지들이 내가 만든 것으로서 <br /> 2) 기존에 제3자에게 공유한 적이 없어야 합니다',
    settlement_accountInfo_text29: '네, 수정하겠습니다',
    settlement_accountInfo_text30: '당신은 이 미니북의 저자권을 제3자에게 공유했습니다',
    settlement_accountInfo_text31: '저자',
    settlement_accountInfo_text32: '제3자',
    settlement_accountInfo_text33: '당신은 이 미니북의 저자권을 저자로부터 공유받았습니다',
    settlement_accountInfo_text34: '무료 미니북입니다. 정산 계좌가 필요 없습니다.',
    settlement_accountInfo_text35: '수익배분',
    settlement_accountInfo_text36: '(나)',
    settlement_accountInfo_text37: '(출판사 등)',
    settlement_accountInfo_text38: '개인계좌',
    settlement_accountInfo_text39: '법인계좌',
    settlement_accountInfo_text40: '계좌관리',
    settlement_accountInfo_text41: '선택완료',
    settlement_accountInfo_text42: '은행',
    settlement_accountInfo_text43: '계좌선택',
    settlement_accountInfo_text44: '수익을 어떻게 나눌지 정하기',
    settlement_accountInfo_text45: '수익률 (%)',
    settlement_accountInfo_text46: '내 ID(email)',
    settlement_accountInfo_text47: '제 3자 ID(email)',
    settlement_accountInfo_text48: '합계 맞추기',
    settlement_accountInfo_text49: '양수인 정보를 입력해 주세요',
    settlement_accountInfo_text50: '수익률이 100을 넘을 수 없습니다',
    settlement_accountInfo_text51: '양도인 ID(email)',
    settlement_accountInfo_text52: '양수인 ID(email)',

    settlement_earnings_text1: '정산내역 확인하기',
    settlement_earnings_text2: '정산 기간',
    settlement_earnings_text3: '판매 단가',
    settlement_earnings_text4: '판매 수량',
    settlement_earnings_text5: '판매액',
    settlement_earnings_text6: '세액 등 공제',
    settlement_earnings_text7: '입금액',
    settlement_earnings_text8: '입금일',
    settlement_earnings_text9: '광고 조회수',
    settlement_earnings_text10: '총 금액',
    settlement_earnings_text11: '더 알아보기',
    settlement_earnings_text12: '광고 단가',
    settlement_earnings_text13: '수익액',
    settlement_earnings_text14: '모든 미니북',
    settlement_earnings_text15: '강의 선택',
    settlement_earnings_text16: '모든 강의',

    settlement_statistics_text1: '판매량',
    settlement_statistics_text2: '독자수',
    settlement_statistics_text3: '(지난)',
    settlement_statistics_text4: '1개월',
    settlement_statistics_text5: '6개월',
    settlement_statistics_text6: '1년',
    settlement_statistics_text7: '조회된 데이터가 없습니다',
    settlement_statistics_text8: '판매분석',
    settlement_statistics_text9: '광고조회',
    settlement_statistics_text10: '모든 언어',

    terms_title: '이용약관',
    terms_text: '본 약관은 주식회사 닉신디케이트(이하 ‘회사’라고 함)에서 제공하는 서비스를 이용함에 있어서 회원과 회사 간에 필요한 사항을 규정하는 것을 목적으로 합니다.<br/><br/>서비스 컨텐츠의 관리<br/>회사는 회원이 서비스 컨텐츠를 업로드함에 있어서 필요한 사항을 다음과 같이 수립, 공개합니다.<br/><br/><b>1. 회원이 업로드한 서비스 컨텐츠의 권리</b><br/>① 회원이 업로드한 서비스 컨텐츠(페이지 글, 미니북 소개글과 카드)에 대한 저작권은 회사에 있으며 회원은 컨텐츠 제작 시 타인의 지적재산권을 침해하지 않을 의무가 있으며 이와 관련된 책임은 회원에게 있습니다.<br/>② 회원이 업로드한 일반 컨텐츠(댓글, 프로필 글과 사진, 메모글 등)에 대한 저작권은 해당 회원에게 있으며 회원은 컨텐츠 제작 시 타인의 지적재산권을 침해하지 않을 의무가 있으며 이와 관련된 책임은 회원에게 있습니다.<br/><br/><b>2. 회원이 업로드한 서비스 컨텐츠가 부적절한 경우의 조치</b><br/>① 회원이 업로드한 서비스 컨텐츠나 일반 컨텐츠가 다음과 같은 내용에 해당할 경우 회사는 해당 내용을 삭제하거나 기술적인 필터링을 통해 표출이 되지 않도록 할 수 있습니다.<br/>1. 사생활 침해, 명예훼손, 욕설, 비속어로 타인에게 불쾌감을 주는 경우<br/>2. 미풍양속 저해 및 특정 집단, 단체, 종교 비하로 타인에게 불쾌감을 주는 경우<br/>3. 확인되지 않거나 근거 없는 내용으로 타인의 권리를 침해하는 경우<br/>4. 타인의 저작권을 침해하는 경우<br/>5. 타인의 개인정보가 포함된 경우<br/>6. 광고/홍보 내용이 포함된 경우<br/>7. 동일 내용의 게시물을 반복 게재하는 경우<br/>8. 악성코드 등 회사의 원활한 서비스 제공을 방해하는 경우<br/>9. 기타 회원의 원활한 서비스 이용에 불건전한 영향을 미칠 수 있다고 판단되는 경우<br/>② 회사가 표출을 제한한 컨텐츠에 대해서는 회사 사원을 포함한 다른 사람이 열람할 수 없습니다. 다만, 법원, 수사기관이나 기타 행정기관으로부터 정보제공을 요청받은 경우나 기타 법률에 의해 요구되는 경우에는 이해관계가 있는 다른 사람으로 하여금 해당 컨텐츠를 열람하게 할 수 있습니다.<br/>③ 회원은 상기 컨텐츠를 발견할 경우 이를 회사에 대표 이메일이나 채널톡을 통해 해당 컨텐츠의 상세 내용을 문자, 캡쳐된 화면, 음성녹음 등을 이용해 신고할 수 있으며 회사는 동 신고를 접수받은지 24시간 이내에 심사를 통해 상기 컨텐츠에 해당되는 경우 그 내용을 삭제하거나 기술적인 필터링을 통해 표출이 되지 않도록 조치를 취해야 합니다.<br/><br/><b>3. 회원이 구매한 서비스 컨텐츠의 이용, 취소 및 환불</b><br/>① 회원이 유료 서비스 컨텐츠를 구매한 경우 동 컨텐츠를 자유롭게 사용할 수 있습니다. 이 경우 구매한 컨텐츠의 취소나 환불은 되지 않습니다. 이와 관련하여 문의가 있을 경우 아래를 이용하여 주시기 바랍니다.<br/>연락처 : 전화 070-4578-9240, 이메일 joa@academy-connect.net<br/><br/>[부칙]<br/>1. 이 약관은 2023년 2월 23일자부터 시행하며, 종전의 규정을 대체합니다.',

    privacy_title: '개인정보 처리방침',
    privacy_text: '본 약관은 주식회사 닉신디케이트(이하 ‘회사’라고 함)에서 제공하는 서비스를 이용함에 있어서 회원의 개인정보와 관련해 필요한 사항을 규정하는 것을 목적으로 합니다.<br/><br/>개인정보의 보호<br/>회사는 개인정보 보호법 제30조에 따라 고객의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립․공개합니다.<br/><br/><b>1. 개인정보의 처리목적</b><br/>회사는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.<br/>- 고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본인 식별․인증, 회원자격 유지․관리, 물품 또는 서비스 공급에 따른 금액 결제, 물품 또는 서비스의 공급․배송 등<br/><br/><b>2. 개인정보의 처리 및 보유기간</b><br/>① 회사는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유와 이용기간 또는 법령에 따른 개인정보 보유와 이용기간 내에서 개인정보를 처리․보유합니다.<br/>② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다.<br/>- 고객 가입 및 관리 : 서비스 이용계약 또는 회원가입 해지시까지, 다만 채권․채무관계 잔존시에는 해당 채권․채무관계 정산시까지<br/>- 전자상거래에서의 계약․청약철회, 대금결제, 재화 등 공급기록 : 5년<br/><br/><b>3. 개인정보의 제3자 제공</b><br/>회사는 정보주체의 별도 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우 외에는 개인정보를 제3자에게 제공하지 않습니다.<br/><br/><b>4. 개인정보처리의 위탁</b><br/>① 회사는 원활한 개인정보 업무처리를 위하여 개인정보 처리업무를 외부에 위탁할 수 있으며 그러한 경우 사전에 고시하겠습니다.<br/>② 회사는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 재위탁 제한, 수탁자에 대한 관리․감독, 책임에 관한 사항을 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하겠습니다.<br/><br/><b>5. 정보주체와 법정대리인의 권리․의무 및 행사방법</b><br/>고객은 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.<br/>1. 개인정보 열람요구<br/>2. 개인정보에 오류 등이 있을 경우 정정 요구<br/>3. 삭제요구<br/>4. 처리정지 요구<br/><br/><b>6. 처리하는 개인정보 항목</b><br/>회사는 필요 시 고객의 동의하에 수집한 다음의 개인정보 항목을 처리할 수 있습니다.<br/>- 성명, 생년월일, 주소, 전화번호 및 휴대전화번호(전화번호부 수록 포함), 성별, 이메일주소, 신용카드번호, 은행계좌번호 등 결제정보<br/><br/><b>7. 개인정보의 파기</b><br/>① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.<br/>② 회사는 다음의 방법으로 개인정보를 파기합니다.<br/>- 전자적 파일 : 파일 삭제 및 디스크 등 저장매체 포맷<br/>- 수기(手記) 문서 : 분쇄하거나 소각<br/><br/><b>8. 개인정보의 안전성 확보조치</b><br/>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.<br/>- 관리적 조치 : 내부관리계획 수립․시행, 직원․종업원 등에 대한 정기적 교육<br/>- 기술적 조치 : 개인정보처리시스템(또는 개인정보가 저장된 컴퓨터)의 비밀번호 설정 등 접근권한 <br/>관리, 백신소프트웨어 등 보안프로그램 설치, 개인정보가 저장된 파일의 암호화<br/>- 물리적 조치 : 개인정보가 저장․보관된 장소의 시건, 출입통제 등<br/><br/><b>9. 개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항</b><br/>① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠기(cookie)’를 사용합니다.<br/>② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.<br/>가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br/>나. 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.<br/>다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.<br/><br/><b>10. 개인정보 보호책임자</b><br/>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제를 처리하기 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br/>- 개인정보 보호책임자<br/>성명 : 유기윤 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;          직책 : 대표이사<br/>연락처 : 전화 070-4578-9240, 이메일 joa@academy-connect.net<br/><br/>[부칙]<br/>1. 이 약관은 2023년 2월 23일자부터 시행하며, 종전의 규정을 대체합니다.',

    // common text
    message_save: '등록 되었습니다',
    message_fail: '등록에 실패하였습니다',
    message_delete: '삭제 되었습니다',
    message_report: '신고 되었습니다',
    message_search_no_result: '검색 결과가 없습니다',
    message_search_enter: '검색어를 입력해 주세요',
    message_error1: '오류가 발생하였습니다. 관리자에게 문의해주세요',
    message_save2: '저장 되었습니다',
    message_fail2: '저장에 실패하였습니다',
    message_login: '로그인이 필요합니다',
    message_service_soon: '서비스 예정입니다',

    name: '이름',
    email: '이메일',
    mobile: '전화번호',
    list: '목록',
    edit: '수정하기',
    delete: '삭제하기',
    search: '검색',
    report: '부적절 내용 신고',
    user: '사용자',
    report_type: '신고 사유를 선택해 주세요',
    report_type1: '욕설∙명예훼손',
    report_type2: '홍보성',
    report_type3: '음란물∙선정성',
    report_type4: '같은 내용 반복',
    report_type5: '기타',
    serch_placeholder: '이름이나 이메일로 검색해 주세요',
    search_book: '미니북 검색하기',
    search_keyword: '주제어',
    search_reference: '참고자료',
    search_author: '저자명',
    search_result: '찾았어요',
    button_report: '신고하기',
    button_write: '등록하기',
    button_login: '로그인',
    button_more: '더 보기',
    button_confirm: '확인',
    button_save: '저장',
    button_crop: '선택',
    button_delete: '삭제',
    button_complete: '완료',
    colorbox_background_text1: '배경색을 선택해 주세요',
    colorbox_font_text1: '제목색을 선택해 주세요',
    menu_home: '홈',
    menu_page: '페이지',
    menu_book: '미니북',
    menu_memo: '메모',
    menu_together: '강의',
    login_button: '로그인 바로가기',
    message_text1: '답글 달기',
    message_text2: '나에게 답글이 달렸습니다',
  },
  zh: {
    home_banner_title1: '新的迷你书',
    home_banner_title2: '新活动',
    home_slide_title1: '最近热门',
    home_slide_title2: '我的喜好',
    home_slide_title3: '现在最热',
    home_slide_title4: '非常受欢迎',
    home_detail_title1: '日常记忆',
    home_detail_title2: '推荐视频',
    home_detail_title3: '如果你想了解更多',
    home_detail_text1: '迷你书备忘录',
    home_detail_text2: '日常备忘录',
    home_setting_title: '设置',
    home_setting_text1: '过去30天内查看的页面',
    home_setting_text2: '退出登录',
    home_setting_text3: '注销账户',
    home_book_banner_question: '我对这个很好奇',
    home_book_banner_write_placeholder1: '请输入标题',
    home_book_banner_write_placeholder2: '请输入内容',
    home_book_banner_write_button: '登录',
    home_book_banner_detail_text1: '这是YouBook导师给出的答案',
    home_book_banner_detail_text2: '在YouBook中有相关的知识',

    home_book_create_button: '迷你书，来创建吧',
    home_book_create_text1: '迷你书 指的是大约 10 页的短小书籍。它适合想要快速阅读 简洁但核心内容 的读者，符合现代阅读趋势。',
    home_book_create_text2: '发布后编辑的方法',
    home_book_create_text3: '迷你书，创建的简单方法',
    home_book_create_text4: '作者的收入是多少？',
    home_book_create_text5: '如何找到读者？',
    home_book_create_text6: '使用 YouBook 的 5 个必然理由',
    home_book_create_text7: '还有其他问题吗？',
    home_book_create_text8: '是否可以实时查看销量？',
    home_book_create_text9: '让我们今天也坚持写作！',
    home_book_create_text10: '现在就试试吧！',

    home_book_category_title1: '今日热点与迷你书',
    home_book_category_title2: '热门迷你书',
    home_book_category_title3: 'S级教授迷你书',
    home_book_category_title4: '个性化推荐',
    home_book_category_title5: '畅销书精华迷你书',
    home_book_category_title6: '和书喵一起',
    home_book_category_title6_text1: '展开',
    home_book_category_title6_text2: '收起',
    home_book_category_title7: '探索神经网络页面',
    home_book_category_title8: '艺术与情感盛宴',
    home_book_category_title8_text1: '电影与电视剧中的世界',
    home_book_category_title8_text2: '触动灵魂的旋律与舞蹈',
    home_book_category_title8_text3: '无界艺术',
    home_book_category_title8_text4: '穿上个性：服装与风格',
    home_book_category_title9: '美味与闲适的美食文化',
    home_book_category_title9_text1: '美食探索，本地料理解读',
    home_book_category_title9_text2: '酒与人生的故事',
    home_book_category_title9_text3: '零食与甜点的魅力',
    home_book_category_title9_text4: '大自然的力量，植物的秘密',
    home_book_category_title10: '生活智慧与自我发现',
    home_book_category_title10_text1: '独特的理财方法',
    home_book_category_title10_text2: '独特的自我成长秘诀',
    home_book_category_title10_text3: '人际问题与解决方案',
    home_book_category_title10_text4: '新发现与知识',
    home_book_category_title11: '多样的价值观与爱情',
    home_book_category_title11_text1: '他们的生活故事',
    home_book_category_title11_text2: '不同的哲学与价值观',
    home_book_category_title11_text3: '宗教信仰与传统故事',
    home_book_category_title11_text4: '爱情的奥秘',
    home_book_category_title12: '充满旅行与爱好的每一天',
    home_book_category_title12_text1: '必去的隐藏旅行地',
    home_book_category_title12_text2: '从爱好中发现生活乐趣',
    home_book_category_title12_text3: '通过游戏了解的独特文化',
    home_book_category_title13: '丰富的传统与故事',
    home_book_category_title13_text1: '地方神话与英雄故事',
    home_book_category_title13_text2: '全球文学之旅',
    home_book_category_title13_text3: '各地的历史与智慧',
    home_book_category_title13_text4: '多彩的社会故事',

    home_book_category_title1_text2: '书喵的想法—要不要偷偷看一下？',
    home_book_category_title1_text3: '困惑？好奇？',
    home_book_category_title1_text4: '要不要推荐迷你书？',
    home_book_search_placeholder1: '请在这里留言',
    home_book_search_placeholder2: '关键词是什么？',
    home_book_search_message1: '请输入您的问题',
    home_book_search_message2: '请再次提出您的问题',
    home_book_search_text1: '想要和我一起探讨一下这一页吗',
    home_book_search_text2: '想要和我一起探讨一下这本迷你书吗',
    home_book_search_text3: '提问',
    home_book_search_text4: '上面的内容可以保存',
    home_book_search_text5: '(请添加关键词)',
    home_book_search_text6: '搜索',

    home_book_theme_title: '按主题查看',
    home_instant_text1: '按关键词输入',
    home_instant_text2: '随机输入',
    home_book_company_info: '如果您还有任何问题，请通过下方的联络方式联系我们，我们将会热情回复您.',
    home_page_search_text1: '搜索页面',
    home_page_search_text2: '您可以即刻观看视频',
    home_page_search_text3: '详细搜索',
    home_page_search_text4: '以列表形式查看',
    home_page_search_text5: '在网络上查看',
    home_page_explor_alert: '未选择页面',
    home_page_explor_alert2: '您已超过一个屏幕可浏览的最大页数（150 页）。请将不必要的页面放入垃圾箱。',
    home_page_explor_alert3: '没有更多信息可加载',
    my_login_title: '我的',
    my_login_text1: '修饰我的个人资料',
    my_login_text2: '立即登录并使用YouBook',
    my_login_text3: '我要变聪明',
    my_login_find_password: '找回密码',
    my_guide_minibook: '如何制作迷你书',
    my_password_reset: '重置密码',
    my_password_reset_text1: '请输入您注册时使用的邮箱',
    my_password_reset_button1: '发送重置链接',
    my_password_reset_button2: '重置',
    my_password_reset_message1: '未找到该用户的电子邮件',
    my_password_reset_message2: '重置密码的链接已发送至您输入的电子邮件.',
    my_password_reset_message3: '请通过电子邮件发送的链接重置并登录.',
    my_password_reset_placeholder1: '请输入电子邮件',
    my_password_reset_placeholder2: '请输入密码',
    my_password_reset_placeholder3: ' 再次输入密码',
    my_password_reset_message4: '密码不匹配',
    my_password_reset_message5: '密码长度必须至少为8个字符, 且至少包含1个大写字母, 小写字母，数字和特殊字符',
    my_password_reset_message6: '您已重置密码',
    my_memo_list_placeholder: '您的脑海中闪现了一个好主意吗？现在就记下来吧',
    my_profile_placehoder1: '我感兴趣的领域是',
    my_profile_placehoder2: '我的名字是',
    my_profile_placehoder3: '如果让我简单的介绍一下自己的话',
    my_profile_placehoder4: '请补充介绍',
    my_profile_text1: '国籍',
    my_profile_text2: '语言',
    my_profile_text3: '更改账号',
    my_profile_text4: '现有账号',
    my_profile_text5: '更改账号',
    my_profile_text6: '账号只能更改一次',
    my_menu_text1: '我的旅行',
    my_menu_text2: '留言',
    my_menu_text3: '购买结算',
    my_menu_text4: '新通知',
    my_menu_text5: '创建迷你书',
    my_menu_text6: '自制迷你书',
    my_menu_text7: '想从其他应用导入文章吗？',
    my_menu_text8: '可以自动导入并转换为页面',
    my_menu_text9: '导入',
    my_import_book_text1: '转换为页面',
    my_import_book_text2: '正在将 ZIP 文件转换为页面。转换一篇文章最多可能需要 5 秒。转换 10 篇大约 1 分钟，100 篇大约 8 分钟。完成后会弹出提示窗口。',
    my_import_book_text3: '好的',
    my_import_book_text4: '页面转换完成',
    my_import_book_text5: '已将 ZIP 文件中的所有文章转换为页面。每篇文章被分别转换为一个页面。你可以在“我的旅行 - 我创建的页面”中查看。页面为临时保存状态，可进行编辑。',
    my_import_book_text6: '可以从其他应用导入文章并自动转换为页面，然后将这些页面组合成迷你书。',
    my_import_book_text7: '如何从其他应用以 ZIP 文件导入文章',
    my_import_book_text8: '请上传 ZIP 文件',
    my_import_book_text9: '上传 Substack 文件',
    my_import_book_text10: '上传 Medium 文件',
    my_import_book_text11: '搜索',
    my_import_book_text12: '* 每篇文章将转换为一个页面',
    my_import_book_text13: '* 可在 我的页面 - 设置 - 我创建的页面 中查看',
    my_import_book_text14: '* 页面为临时保存，可编辑',
    my_import_book_text15: '* 只能导入自己写的文章',
    my_import_book_text16: '使用转换后的页面发布迷你书',
    my_import_book_text17: '创建迷你书的封面',
    my_import_book_text18: '从页面中选择添加至迷你书',
    my_import_book_text19: '发布迷你书',
    my_import_book_text20: '请务必仔细阅读说明',
    my_import_book_text21: '文件不是 ZIP 格式',
    my_import_book_text22: '请上传文件',

    my_journey_title: '我的旅行',
    my_journey_button_message: '留言',
    my_journey_button_memo: '备忘录',
    my_journey_button_record: '旅行里程',
    my_journey_button_follow: '关注我们',
    my_journey_button_follow_cancel: '取消关注',
    my_journey_message_text1: '请留言',
    my_journey_message_placeholder: '请输入您的信息',
    my_journey_message_message1: '无法回复',
    my_journey_message_message2: ' 在传送中',
    my_journey_message_message3: '请输入您的信息',
    my_journey_memo_total: '全部',
    my_journey_record_overall: '影响力排名',
    my_journey_record_text1: '我浏览过的页面',
    my_journey_record_text2: '我喜欢的迷你书',
    my_journey_record_text3: '喜欢的活动空间',
    my_journey_record_text4: '自制页面',
    my_journey_record_text5: '自制迷你书',
    my_journey_record_text6: '创建的活动空间',
    my_journey_record_text7: '本月',
    my_journey_record_text8: '购买的迷你书',
    my_journey_record_text9: '公开',
    my_journey_record_text10: '私密',
    my_journey_record_text11: '购买的活动',
    my_journey_record_text12: '我创建的活动',
    my_journey_record_text13: '{userLanguage}区 第{userRank}位',
    my_journey_record_text14: '共享作者权利迷你书',
    my_journey_record_text15: '你希望读者按照特定顺序阅读吗？如果是，请拖动封面来调整顺序。',
    my_journey_record_text16: '请为新的迷你书加油',
    my_journey_record_text17: '读者的应援留言',
    my_journey_record_text18: '请给作者留言打气',
    my_journey_record_text19: '支持者等级',
    my_journey_record_text20: '{cheeringLevel}级，共10级',
    my_journey_record_text21: '我支持的人',
    my_journey_record_text22: '我的支持者',
    my_journey_record_text23: '确定要删除吗？',
    my_journey_record_text24: '支持者 {userName}',
    my_journey_record_text25: '{userName} 的支持',
    my_notice_title: '通知',
    my_notice_message1: '没有最新的通知',
    my_notice_text1: '最新迷你书到货了',
    my_notice_text2: '每日最新话题来了',
    my_notice_text3: '您的我的旅行收到了新留言',
    my_notice_text4: '一条新评论已到达我分享的笔记中',
    my_notice_text5: '我的活动空间有了新留言',
    my_notice_text6: '有人对您创建的迷你书发表了新的评论',
    my_notice_text7: '在我创建的页面有一个新的评论',
    my_notice_text8: '添加了新的注释',
    my_notice_text9: '{userName} 创建了一个新的活动空间',
    my_notice_text10: '发布了一本新迷你书',
    my_notice_text11: '购买了我的迷你书',
    my_notice_text12: '{userName} 创建了<b>新活动</b>',
    my_notice_text13: '{userName} 特别邀请您参加<b>新活动</b>，一定要来看一看！ ',
    my_notice_text14: '{userName} 已<b>购买了我的活动</b>',
    my_notice_text15: '{userName} 申请成为共同作者',
    my_notice_text16: '开放式迷你书的共同作者申请已获批准',
    my_notice_text17: '共同作者发表了新的评论',
    my_notice_text18: '我们收到了一条支持迷你书的新消息',
    my_notice_text19: '{userName} 赞助了 <b>我的迷你书</b>',
    my_marketing_banner_title: '为自己加油',
    my_marketing_banner_text1: '你已克服困难，现在为自己打气',
    my_marketing_banner_btn: '立即加油',
    my_marketing_title: '立即加油',
    my_marketing_text1: '展开迷你书和活动的双翼 - 以分阶段的宣传为燃料 - 成为一名影响者',
    my_marketing_text2: '给普通读者发送电子邮件',
    my_marketing_text3: '给普通读者发送短信',
    my_marketing_text4: '给朋友发送电子邮件',
    my_marketing_text5: '给朋友发送短信',
    my_marketing_text6: '分享到社交媒体',
    my_marketing_btn: '立即开始',
    my_marketing_minibook_step1_title: '迷你书应援',
    my_marketing_step1_subtitle: '分享到社交媒体',
    my_marketing_minibook_step1_text1: '将迷你书链接到你的社交媒体，并添加有吸引力的描述',
    my_marketing_minibook_text1: '查找迷你书',
    my_marketing_step1_text1: '复制链接',
    my_marketing_step1_btn: '复制',
    my_marketing_step1_text2: '粘贴到社交媒体并添加描述',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter（X）',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: '微博（Weibo）',
    my_marketing_step1_sns12: '小红书（Xiaohongshu）',
    my_marketing_step1_sns13: '微信 (WeChat)',
    my_marketing_step1_text3: '请选择要分享的迷你书',
    my_marketing_step1_text4: '链接已复制',
    my_marketing_step1_text5: '请选择要分享的活动',
    my_marketing_step1_text6: '查找社交媒体',
    my_marketing_event_step1_title: '活动应援',
    my_marketing_event_step1_text1: '将活动链接到你的社交媒体，并添加有吸引力的描述',
    my_marketing_event_text1: '查找活动',
    my_marketing_event_search_title: '搜索活动',
    my_marketing_minibook_step2_title: '迷你书第二阶段营销',
    my_marketing_step2_subtitle: '给朋友发送短信',
    my_marketing_minibook_step2_text1: '请向你的朋友发送迷你书链接，并附上一段真诚的介绍文字',
    my_marketing_step2_text2: '请向朋友发送链接和介绍文字',
    my_marketing_step2_placeholder: '请输入介绍文字',
    my_marketing_tab_text1: '我的朋友们',
    my_marketing_event_step2_title: '活动第二阶段营销',
    my_marketing_event_step2_text1: '请向你的朋友发送活动链接，并附上一段真诚的介绍文字',
    my_marketing_minibook_step3_title: '迷你书第三阶段营销',
    my_marketing_step3_subtitle: '给朋友发送电子邮件',
    my_marketing_minibook_step3_text1: '请向你的朋友发送迷你书链接，并讲述背景故事',
    my_marketing_step3_text1: '导入通讯录列表',
    my_marketing_step3_placeholder: '上传 csv 或 vcf 文件',
    my_marketing_step3_text2: '请向朋友发送链接和故事',
    my_marketing_step3_text3: '导入你的电话号码列表',
    my_marketing_step3_placeholder2: '讲述这个故事',
    my_marketing_event_step3_title: '活动第三阶段营销',
    my_marketing_event_step3_text1: '请向你的朋友发送活动链接，并讲述背景故事',
    my_marketing_text7: '导入电话号码',
    my_marketing_title2: '管理电话号码',
    my_marketing_text8: '电话',
    my_marketing_text9: '次数',
    my_marketing_text10: '导入联系人',
    my_marketing_text11: '请上传 csv 或 vcf 文件',
    my_marketing_text12: '导入方式',
    my_marketing_text13: '导入',
    my_marketing_title3: '管理联系人',
    contact_manage: '联系人管理',
    my_marketing_text14: '删除所选内容',
    my_marketing_text15: '请选择朋友',
    my_marketing_text16: '最多可选择100位朋友',
    my_marketing_text17: '上传完成',
    my_marketing_text18: '字符数已超出限制',
    contact_phone: '电话',
    contact_organization: '组织',
    contact_title: '职位',
    contact_memo: '备注',
    my_marketing_text19: '编辑选择',
    my_marketing_text20: '选择标签',
    my_marketing_text21: '添加新标签',
    my_marketing_text22: '删除所选标签',
    my_marketing_text23: '添加',
    my_marketing_btn2: '编辑完成',
    my_marketing_text24: '请选择要编辑的联系人',
    my_marketing_text25: '请选择要删除的标签',
    my_marketing_text26: '请输入标签名称',
    my_marketing_text27: '该标签已存在',
    my_marketing_text28: '添加标签',
    my_marketing_text29: '取消',
    my_marketing_text30: '已添加',
    my_benefit_text1: '目前为止您获得的收益',
    my_benefit_text2: '一年内您将获得的收益',
    my_benefit_text3: '',
    my_benefit_text4: '赚取利润',
    my_benefit_text5: '获得收益',
    my_benefit_text6: '让我们来计算一下',
    my_benefit_modal_text1: '到目前为止',
    my_benefit_modal_text2: '元',
    my_benefit_modal_text3: '您的获利',
    my_benefit_modal_text4: '让我们来快速计算一下',
    my_benefit_modal_text5: '目前为止已读的页数',
    my_benefit_modal_text6: '每页制作价格',
    my_benefit_modal_text7: '元',
    my_benefit_modal_text8: '最终获得的收益是',
    my_benefit_modal_text9: '如果我们将与AI讨论作为加分项的话',
    my_benefit_modal_text10: '您的收益将更大',
    my_benefit_modal_text11: '每日使用都将会有大量收获',
    my_benefit_modal_text12: '好的，我知道了',
    my_story_text1: '会员留言',
    my_story_text2: '事实上书籍不是用来阅读而是用来体验的',
    my_story_text3: '如果你每天都学习新的知识那么你将会发现神奇的事情',
    my_story_text4: '你是否和聪明人一样掉进了隐藏的陷阱?',
    my_story_text5: '阅读更多会员留言',
    my_go_blog_text1: 'YouBook，消息与客户故事',
    my_go_blog_text2: '了解YouBook的最新消息和客户故事',
    my_go_blog_text3: '了解更多',
    my_channel_text1: '您对于使用YouBook体验如何？',
    my_channel_text2: '请告诉我们哪些方面做得好，哪些方面有待改善',
    my_channel_text3: '如果您有任何问题，请随时告诉我们',
    my_channel_text4: '请说些什么吧',
    my_about_youbook_text1: '为什么使用YouBook呢',
    my_about_youbook_text2: '您想要知道的一切都在这里',
    my_about_youbook_text3: 'YouBook使用条款',
    my_app_text1: 'YouBook是一个百分百有益的健康软件.',
    my_app_text2: '立即下载并获取知识.',
    my_app_text3: '下载软件',
    login_title: '登录',
    login_text1: '请使用邮箱登录',
    login_text2: '现在还不是会员吗?',
    login_text3: '忘记密码?',
    login_text4: '登录社交账号',
    login_text5: '是的，我同意',
    login_link1: '加入会员',
    login_link2: '找回密码',
    login_link3: '使用条款',
    login_placeholder1: '登录邮箱',
    login_placeholder2: '密码',
    login_placeholder3: '账号',
    login_message1: '请输入登录邮箱',
    login_message2: '请输入您的密码',
    login_message3: '登录成功',
    login_message4: '请输入账号',
    logout_message1: '您确定要退出吗',
    register_title: '加入会员',
    register_text1: '使用电子邮件注册会员',
    register_text2: '请选择注册会员类型',
    register_text3: '个人会员',
    register_text4: '机构管理员',
    register_text5: '请输入您的信息',
    register_text6: '您已经是会员了吗?',
    register_text7: '企业注册号码',
    register_text8: '商业登记号码',
    register_text9: '机构名称',
    register_placeholder1: '电话号码(不输入 - )',
    register_placeholder2: '( 不输入- )',
    register_placeholder_repassword: '再次输入密码',
    register_message1: '请输入电话号码',
    register_message2: '请输入企业注册号码',
    register_message3: '请输入商业登记号码',
    register_message4: '请输入机构名称',
    register_message5: '电子邮件格式不正确',
    register_message6: '该邮箱已被注册',
    register_message7: '请验证您的电子邮件',
    register_message8: '请选择您的国籍',
    register_message9: '账号格式不正确',
    register_message10: '您输入的账号无法使用。请使用推荐账号，或输入其他账号',
    register_message11: '请验证账号',
    register_message12: '该账号已被使用。请使用推荐账号或输入其他账号',
    register_button_verify: '验证',
    register_button_verify_fail: '无法验证',
    register_button_verify_success: '验证完成',
    register_welcome_message: '欢迎您成为会员',
    withdraw_text1: '会员资格取消',
    withdraw_text2: '取消YouBook会员资格',
    withdraw_text3: '您确定要取消吗？',
    withdraw_text4: '否',
    withdraw_text5: '是',
    withdraw_text6: '您已成功退出会员',
    home_memo_title: '备忘录',
    home_memo_subtitle: '你知道吗，如果你不做备忘录的话，就会忘记',
    home_memo_text1: '大家共同分享的',
    home_memo_text2: '知识与日常故事',
    home_memo_button: '添加备忘录',
    home_memo_create_text1: '有想要链接的迷你书吗？',
    home_memo_create_button: '查找迷你书',
    home_memo_create_button2: '选择',
    home_memo_click: '点击',
    home_memo_date: 'YYYY.MM.DD',
    home_memo_button_askai: '评论 / 书喵的想法',
    home_memo_view_detail: '查看详细内容',
    home_memo_view_placeholder: '请输入您的文字',
    home_memo_view_button1: '发表评论',
    home_memo_view_button2: '书喵的想法',
    home_memo_view_errormessage: '请输入信息',

    memo_create_title: '备忘录',
    memo_create_category1: '备忘录',
    memo_create_category2: '备忘录',
    memo_create_private: '私有',
    memo_create_public: '共享',
    memo_create_placeholder1: '您的脑海中闪现了一个好主意吗?',
    memo_create_placeholder2: '请现在尝试做笔记吧',
    memo_create_placeholder3: '关键词 (之间有空格)',
    memo_create_button: '保存',
    memo_create_error: '请输入内容',
    memo_attach_img: '上传图片',
    memo_alert_rate: '请选择平级',
    memo_alert_save: '已保存。可在我的旅行中确认',
    memo_input_placeholder: '你学到了什么新知识呢?',
    memo_input_placeholder2: ' 我的想法是什么呢?',
    memo_input_placeholder3: '现在就与读者们一起分享吧',
    memo_input_placeholder4: '记录平凡生活的回忆，可以吗？',
    memo_alert_keywords: '请输入关键词',
    memo_related_text: '备忘录',
    memo_related_date: 'YYYY.MM.DD',
    memo_popup_text1: '介绍发生在德国社会学家尼古拉斯∙卢曼身上一件令人难以置信的事情',
    memo_popup_text3: '卢曼是一位在公司行政办公室工作的普通年轻人',
    memo_popup_text4: '因为他喜欢阅读，并且每天都会简要记录他每天阅读的内容',
    memo_popup_text5: '我总结了这些内容，并将其整理成一片论文投给了德国著名社会学家，结果被邀请去比勒费尔德大学成为教授',
    memo_popup_text6: '卢曼后来成为一名金牌教授，到退休时，他已经出版了60本书和数百篇论文，成为社会学大师。',
    memo_popup_text7: '卢曼说：“我只是不停地做笔记，时不时地反思一下，以整理我的想法和思绪。”',
    memo_popup_text8: '你对自己的记忆力有多信任呢',
    memo_popup_text9: '你的记忆力是有限的',
    memo_popup_text10: '无论你得到多好的知识，几天之内就会遗忘。',
    memo_popup_text11: '只有坚持记笔记并有定期反思的习惯才能使知识真正成为你自己的财富',
    memo_popup_btn: '是的，我也有同感',
    memo_text1: '以上的内容可以保存',
    memo_text2: '(仅添加关键词)',
    memo_text3: '写作时需要注意的事项',
    memo_text4: '您的文章违反了使用条款第2条第1款的内容规定。将不会公开。',
    memo_text5: '查看使用条款',
    memo_text6: '如需在其他语言中写备忘录，',
    memo_text7: '请使用该语言书写（不会自动翻译）',
    book_create_button: '创建迷你书',
    book_create_title: '创建封面',
    book_create_cover: '封面',
    book_create_text1: '创建迷你书封面的步骤',
    book_create_text1_pc: '只需输入标题、作者等即可',
    book_create_text2: '没有自己创建的封面图像',
    book_create_text3: '(如果您没有自己创建的封面图片)',
    book_create_text4: '有自己创建的封面图像',
    book_create_text5: '封面图是您自己制作的吗？',
    book_create_text6: '请点击下面的按钮上传',
    book_create_text7: '(格式：jpg，大小20M以内)',
    book_create_text8: '添加页面的权限',
    book_create_text9: '只有我',
    book_create_text10: '任何人都可以',
    book_create_text11: '在图像中显示标题',
    book_create_text12: '可见',
    book_create_text13: '不显示',
    book_create_text14: '请选择您想要翻译的语言',
    book_create_text15: '全选',
    book_create_text16: '上传封面图片',
    book_create_text17: '可以进行修改',
    book_create_text18: '修改后请点击右上角的图标重新翻译',
    book_create_text19: '如果需要按照原文重新翻译，请点击右上角的图标',
    book_create_text20: '重新翻译',
    book_create_text21: '图片',
    book_create_text22: '标题',
    book_create_text23: '关键词',
    book_create_text24: '内容',
    book_create_text25: '只有在删除图片并重新上传时才会重新翻译',
    book_create_text26: '(页面不会被删除)',
    book_create_text27: '请提供简要介绍',
    book_create_text28: '临时保存',
    book_create_text29: '已临时保存',
    book_create_text30: '需要确认的事项',
    book_create_text31: '文章内容已为最终版本，无需进一步修改',
    book_create_text32: '未使用 AI 翻译无法理解的单词或符号',
    book_create_text33: '图片没有复制粘贴，而是作为单独的文件输入',
    book_create_text34: '要公开招募吗？（开放式迷你书）',
    book_create_text35: '共同作者',
    book_create_text36: '要手动添加吗？',
    book_create_text37: '添加',
    book_create_text38: '一起写作，迷你书传播更广',
    book_create_text39: '你不知道的共同作者力量',
    book_create_text40: '公开招募',
    book_create_text41: '取消',
    book_create_text43: '想法？',
    book_create_text44: '复制并粘贴内容',
    book_create_text45: '需要想法吗？',
    book_create_text46: '销售选项',
    book_create_text47: '免费',
    book_create_text48: '赞助',
    book_create_text49: '购买',
    book_create_text50: '当前价格',
    book_create_text51: '修改价格',
    book_create_text52: '不能设为0元',
    book_create_text53: '已被购买或赞助的迷你书无法更改价格或销售选项',
    book_create_text54: '只有迷你书的作者可以回复消息',
    book_create_button_upload: '上传',
    book_create_button_make: '创建',
    book_create_cover_topic_placeholder: '标题看起来像这样',
    book_create_topic_placeholder: '输入标题',
    book_create_keyword_placeholder: '请输入关键词(3个或更多, 关键词之间有空格)',
    book_create_category_placeholder: '请选择一个类别',
    book_create_knowledge_placeholder: '请为这本迷你书写一个介绍 注意- 想要了解更多详情，请在创建页面阶段填写',
    book_create_category_option1: '电影和电视剧',
    book_create_category_option2: '音乐和舞蹈',
    book_create_category_option3: '其他艺术',
    book_create_category_option4: '服装和风格',
    book_create_category_option5: '食物和烹饪',
    book_create_category_option6: '酒和饮料',
    book_create_category_option7: '小吃和甜点',
    book_create_category_option8: '植物与健康',
    book_create_category_option9: '致富',
    book_create_category_option10: '自我发展',
    book_create_category_option11: '人际关系',
    book_create_category_option12: '新知识',
    book_create_category_option13: '生活故事',
    book_create_category_option14: '哲学与价值观',
    book_create_category_option15: '宗教与传统',
    book_create_category_option16: '爱情',
    book_create_category_option17: '旅行和景点',
    book_create_category_option18: '爱好生活',
    book_create_category_option19: '游戏文化',
    book_create_category_option20: '神话与英雄',
    book_create_category_option21: '文学之旅',
    book_create_category_option22: '历史与智慧',
    book_create_category_option23: '社会故事',
    book_create_category_option24: '常识',
    book_create_message1: '请输入标题',
    book_create_message2: '请输入作者',
    book_create_message3: '请输入关键词',
    book_create_message4: '请输入至少3个关键词',
    book_create_message5: '请选择一个类别',
    book_create_message6: '请创建封面图片',
    book_create_message7: '不能输入特殊字符。 请在关键字之间留一个空格',
    book_create_message8: '确定要删除这本迷你书吗',
    book_create_message9: '您没有该语言的发布权',
    book_create_message10: '已购买的迷你书无法删除',
    book_create_modal_text1: '请稍等..',
    book_create_modal_text2: 'AI正在审核内容、翻译外语，并连接知识网络',
    book_create_modal_text3: '我们正在连接到网络知识库进行逐页搜索',
    book_create_modal_text4: '封面图片上未显示标题',
    book_create_modal_text5: '(翻译成外语的封面也有同样的问题)',
    book_view_title: '迷你书 简介',
    book_view_share: '与朋友分享',
    book_view_event_topic: '活动主题',
    book_view_together_suggest: '推荐活动空间',
    book_view_together_message: '如果您没有最喜欢的 "在一起" <br/> 请进入 "在一起 "菜单选择一个',
    book_view_event_message: '我没有创建任何活动',
    book_view_text1: '没有保存的页面.',
    book_view_text2: '现在尝试添加页面.',
    book_view_text3: '迷你书不存在。请再试一次.',
    book_view_text4: '这本迷你书的页数',
    book_view_text5: '你觉得改善这本迷你书的翻译或推广，然后共享收益怎么样？',
    book_view_text6: '页面列表',
    book_view_text7: '修改价格',
    book_view_text8: '已有买家，无法修改',
    book_view_text9: '读者的礼物',
    book_view_text10: '只有迷你书的作者可以回复消息',
    book_view_modal_title: '改进翻译与推广',
    book_view_modal_text1: '您能亲自改进这本迷你书的翻译吗？或者帮忙推广？',
    book_view_modal_text2: '给作者留言',
    book_view_modal_text3: '如果作者同意，您可以分享收益',

    book_view_write_share_title: '开放式迷你书',
    book_view_write_share_text1: '你想成为这本迷你书的共同作者吗？',
    book_view_write_share_text2: '申请成为作者',
    book_view_write_share_text3: '请简单留言',
    book_view_write_share_text4: '发送',
    book_view_write_share_list_title: '共同作者',
    book_view_write_share_text5: '管理迷你书的共同作者',
    book_view_write_share_text6: '管理作者',
    book_view_write_share_text7: '接受',
    book_view_write_share_text8: '已接受',
    book_view_write_share_text9: '用户已注册为作者',
    book_view_write_share_text10: '手动添加作者',
    book_view_write_share_text11: '该用户已申请',
    book_view_publish_text1: '您想发布这本迷你书吗?',
    book_view_publish_text2: '当你发布后，所有用户都可以使用它，并且您还可以赚钱。',
    book_view_publish_text3: '(付费出版发布时，不得收录他人的页面)',
    book_view_publish_text4: '设定价格',
    book_view_publish_text5: '设定发布日期',
    book_view_publish_text6: '请求发布',
    book_view_publish_text7: '随时发布',
    book_view_publish_text8: '预约发布',
    book_view_publish_text9: '未发布',
    book_view_publish_text10: '发布中',
    book_view_publish_text11: '发布',
    book_view_publish_text12: '发布时需要检查的事项',
    book_view_publish_text13: '这本迷你书之前尚未在YouBook中发布过',
    book_view_publish_text14: '本迷你书及其页面未盗用他人的内容或其他知识产权',
    book_view_publish_text15: '这本迷你书没有包含亵渎语言、过度的性内容、他人诽谤或商业广告，并且符合使用条款的第2条第1项',
    book_view_publish_text16: '是',
    book_view_publish_text17: '发布状态',
    book_view_publish_text18: '已发布',
    book_view_publish_text19: '发布时间',
    book_view_publish_text20: '发布价格',
    book_view_publish_text21: '确定开放期',
    book_view_publish_text22: '开放期',
    book_view_publish_text23: '什么是开放期',
    book_view_publish_text24: '公开期间是指读者可以查看内容的时间',
    book_view_publish_text25: '这本迷你书包含超过3页',
    book_view_publish_text26: '这本迷你书不包含超过3页',
    book_view_publish_text27: '如果发现任何违规行为，算法可能会调整搜索排名。若问题严重，迷你书将自动删除',
    book_view_publish_text28: '设置销售选项',
    book_view_publish_text29: '购买方式',
    book_view_publish_text30: '支持方式',
    book_view_publish_message1: '在付费发布的情况下，\n1)属于迷你书中的页面必须由我创建\n2) 不得付费发布',
    book_view_publish_message2: '尚未处于可发布状态。 请联系管理员',
    book_view_publish_message3: '这是一本已经发布的迷你书',
    book_view_publish_message4: '请选择当前时间之后的开放期',
    book_view_publish_message5: '请选择日期和时间',
    book_view_publish_message6: '发布已获批准，谢谢。',
    book_view_publish_message7: '请检查确认项',
    book_view_publish_message8: '结束日期不能早于开始日期',
    book_view_publish_message9: '临时保存的迷你书无法发布',
    book_view_publish_message10: '这本 迷你书 是转让的。最初的 出版权 归作者所有。',
    book_view_publish_message11: '请输入不少于 {minPrice} 的金额',
    book_view_button_confirm: '已确认',
    book_view_button_publish: '请发布',
    book_view_button_order: '对页面进行排序',
    book_view_button_add: '添加页面',
    book_view_button_video: '观看视频',
    book_view_button_read: '阅读',
    book_view_button_lecture: '观看演讲视频',
    book_view_page_add_title: '添加页面',
    book_view_page_add_text1: '<b>第三方的</b>页面<b>搜索</b>后',
    book_view_page_add_text2: '此页面<b>查看页面内容</b>在此画面',
    book_view_page_add_text3: '<b>添加到迷你书</b>',
    book_view_page_add_text4: '您想创建自己的页面吗?',
    book_view_page_add_text5: '创建页面 <br/> 只有注册为作者的人才能这样做. <br/> 如果您想注册为作者 <br/> 请通过以下方式联系我们<br/>',
    book_view_page_add_text6: '你想添加第三方的页面吗？',
    book_view_page_add_text7: '* 如果添加了第三方创建的页面，\n则无法作为付费迷你书发布',
    book_view_page_add_text8: '你之前有创建过页面吗？',
    book_view_page_add_button1: '现在创建',
    book_view_page_add_button2: '查看我创建的页面',
    book_view_reference_text1: '多样性',
    book_view_reference_text2: '多种',
    book_view_reference_text3: '迷你书作者',
    book_view_reference_text4: '直接创建',
    book_view_support_text1: '支持你',
    book_view_support_modal_title: '成为支持者',
    book_view_support_modal_text1: '再好的文字，也难以凭一己之力传播开来。',
    book_view_support_modal_text2: '支持者是将作者迷你书传播到世界的人，是彼此支持的人。',
    book_view_support_modal_text3: '我们携手将故事传播得更远。',
    book_view_support_modal_text4: '请成为作者的支持者',
    book_view_support_modal_btn1: '知道了',
    book_view_support_modal_text5: '"你的支持对我帮助很大，谢谢你。我也会全心支持你的旅程。"',
    book_view_support_modal_text6: '请将迷你书传播到世界',
    book_view_support_modal_btn2: '该怎么做？',
    book_view_support_modal_title2: '走到这里的我，辛苦了',
    book_view_support_modal_text7: '写作并不容易，但我完成了。',
    book_view_support_modal_text8: '现在是相信自己，迈出新一步的时候了。',
    book_view_support_modal_text9: '即使有些害羞和犹豫，我也成为自己的第一个支持者，把我的心意介绍给世界。',
    book_view_support_modal_text10: '因为我相信，它对某些人可能有意义。',
    book_view_support_modal_text11: '请成为我的支持者',
    book_view_support_modal_text12: '无论是写作还是举办活动都不容易，但我勇敢尝试了。',
    book_view_support_modal_btn3: '我来试试！',
    book_view_support_modal_title3: '你好，支持者',
    book_view_open_minibook_text1: '开放式迷你书申请已完成',
    book_view_open_minibook_text2: '开放式迷你书申请已取消',
    page_create_title: '创建页面',
    page_create_text1: '没有自己创建的页面图像',
    page_create_text2: '(如果没有自己创建的页面图片)',
    page_create_text3: '页面',
    page_create_text4: '有自己创建的页面图像',
    page_create_text5: '页面图片是您自己创建的吗?',
    page_create_text6: '请输入内容。我们建议不要超过一张 A4 纸.',
    page_create_text7: '当前字节数',
    page_create_text8: '推荐',
    page_create_text9: '此页面有参考材料吗',
    page_create_text10: '自我创建',
    page_create_text11: '书籍参考',
    page_create_text12: '博客参考',
    page_create_text13: 'AI参考',
    page_create_text14: '这是创建迷你书页面的步骤\n只需输入每个项目即可。',
    page_create_text15: '上传页面图片',
    page_create_text16: '您想重新翻译吗？',
    page_create_text17: '如果您希望重新翻译，请选择目标和语言（如果不选择，将保存而不翻译）',
    page_create_text18: '要翻译的目标',
    page_create_text19: '要翻译的语言',
    page_create_message1: '无法修改',
    page_create_message2: '请输入内容',
    page_create_message3: '确定要删除此页面吗',
    page_create_message4: '内容超出最大大小',
    page_create_reference_book: '书籍',
    page_create_reference_blog: '博客',
    page_create_reference_placeholder1: '请输入标题',
    page_create_reference_placeholder2: '相关链接 (例如 https://www.kyobo.com/books/11223344)',
    page_create_reference_placeholder3: '请输入发布年份',
    page_create_reference_placeholder4: '请输入作者',
    page_create_title_placeholder: '标题看起来像这样',
    page_create_message5: '现在翻译',
    page_create_message6: '创建 封面 后，您可以创建 页面',
    page_create_modal_text1: '页面图片上未显示标题',
    page_create_modal_text2: '(翻译成外语的页面也有同样的问题)',
    page_create_modal_text3: '请务必确认！',
    page_create_modal_text4: '如果内容有更改，必须临时保存。',
    page_create_modal_text5: '你这样做了吗？',
    page_create_modal_text6: '如果内容有更改，必须创建。',
    page_view_title: '查看内容',
    page_view_button_video: '以视频形式查看',
    page_view_button_read: '阅读',
    page_view_text1: '添加至我的迷你书',
    page_view_text2: '全部自动播放',
    page_view_text3: '阅读量',
    page_view_text4: '相关页面',
    page_view_text5: '相关迷你书',
    page_view_text6: '您对参考资料有什么问题吗',
    page_view_text7: '参考页面',
    page_view_text8: '发布年份',
    page_view_text9: '作者',
    page_view_text10: '标题',
    page_view_text11: '此参考文献的完整页面',
    page_view_text12: '搜索相关材料',
    page_view_text13: '页面作者',
    page_view_text14: '认识作者',
    page_view_text15: '收藏',
    page_view_reference_text1: '书籍',
    page_view_reference_text2: '博客',
    page_view_popup: '我没有制作迷你书<br /><br /> 请在我的页面上填写',
    page_view_pay_popup_text1: '阅读后是否有所收获？\n请以一份小礼物回应作者。',
    page_view_pay_popup_title: '赠送礼物',
    page_view_pay_popup_text2: '请选择要作为礼物赠送的茶',
    page_view_pay_popup_text3: '写下你的心意',
    page_view_pay_popup_placeholder1: '作者的智慧与情感之作给予了我很大启发。',
    page_view_pay_popup_text4: '金额',
    page_view_pay_popup_button1: '购买并发送消息',
    page_view_pay_popup_text5: '为了写下这篇文章，作者倾注了大量心血与时间。\n\n请用小礼物表达感谢。',
    page_view_pay_popup_placeholder2: '我相信作者带来的智慧与感受。',
    page_view_pay_popup_text6: '不想赠送礼物吗？',
    page_view_pay_popup_text7: '想通过观看广告来阅读？',
    page_view_pay_popup_button2: '看广告后阅读',
    page_sort_title: '对页面进行排序',
    page_sort_subtitle: '拖动页面更改顺序',
    page_sort_text: '资料来源',
    pay_button: '购买',
    pay_price: '购买金额',
    pay_vat_excluded: '(附加税另算)',
    pay_message_success: '已完成够买',
    pay_message_fail: '购买失败',
    pay_currency: '元',
    pay_button_paid: '购买完成',
    pay_button_view_price: '查看价格',
    pay_total: '购买金额',
    pay_methods: '付款方式',
    pay_methods_creditcard: '信用卡',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: '继续',
    pay_text1: '请选择茶',
    pay_text2: '请输入留言',
    advertisement_button: '查看更多',
    advertisement_text1: '观看广告后可以查看内容.',
    advertisement_text2: '这是一本付费迷你书的页面。<br />前往封面并点击 \'阅读\' 即可购买。<br />',
    advertisement_text3: '观看广告后可以查看内容. 广告只能在应用程序内观看.',
    together_title: '活动',
    together_subtitle: '与读者见面并交流',
    together_subtitle_text1: '在网上与读者见面吧',
    together_subtitle_text2: '创建房间并邀请人员',
    together_button: '创建活动空间',
    together_case: '业务实例',
    together_case1: '我总是想试图给予但是却不断的得到',
    together_case2: '我从没想过现实生活中的例子会如此有帮助',
    together_subtitle2: '我创建的空间',
    together_category1: '最新的',
    together_category2: '最喜欢的',
    together_button_viewmore: '查看更多',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD A hh:mm',
    together_subtitle3: '这样的空间 ',
    together_subtitle3_1: '请创建',
    together_subtitle_text3: '无论是谁发起，我都想参与',
    together_create_title: '创建活动空间',
    together_create_title2: '编辑活动空间',
    together_create_button1: '选择',
    together_create_subtitle: '标题',
    together_create_placeholder1: '请输入标题(最多20字)',
    together_create_subtitle1: '简单介绍',
    together_create_placeholder2: '请输入一段简短的介绍',
    together_create_subtitle2: '用什么工具制作一起',
    together_create_text1: '在线会议链接 (例如：Zoom链接)',
    together_create_placeholder3: '请填写在线会议链接',
    together_create_question1: '我不知道Zoom的链接?',
    together_create_q1_a_title: '找到加入 Zoom 会议的链接',
    together_create_text2: '使用虚拟空间',
    together_create_placeholder4: '请选择最适合的在一起',
    together_create_question2: '不知道虚拟空间?',
    together_create_text3: '在哪里建立在一起',
    together_create_dropmenu1: '在YouBook开放知识角频道',
    together_create_dropmenu2: '在作者和读者角开放',
    together_create_button2: '编辑',
    together_create_button3: '创建',
    together_create_popup_title: '选择虚拟空间活动',
    together_create_popup_alert: '已选择',
    together_create_button4: '选择',
    together_create_alert: '请填写在线会议链接',
    together_create_alert1: '请输入标题',
    together_create_alert2: '选择要使用的虚拟空间活动',
    together_create_alert3: '无法编辑',
    together_create_alert4: '活动空间已创建',
    together_create_alert5: '发生错误，请再试一次',
    together_create_alert6: '创建活动空间失败…',
    together_qa_popup_title1: '找到加入 Zoom 会议的链接',
    together_qa_popup_btext1: '电脑',
    together_qa_popup_text1: ' : 打开Zoom程序 - 登录 -',
    together_qa_popup_text1_1: '点击顶部的会议菜单 - 点击我的会员ID - 点击会议邀请 - 将出现加入Zoom会议的链接. 请复制它.',
    together_qa_popup_btext2: '智能手机',
    together_qa_popup_text2: ' : 打开Zoom程序 - 登录 -',
    together_qa_popup_text2_1: '按右上角 i 按钮 - 发送邀请 -',
    together_qa_popup_text2_2: '点击消息后 - 输入我的电话号码 -',
    together_qa_popup_text2_3: '会出现一个链接。复制该链接.',
    together_qa_popup_title2: '虚拟空间',
    together_qa_popup_text3: '这是一个虚拟会议空间.',
    together_qa_popup_text4: '以我虚构的头像形式出现',
    together_qa_popup_text5: '您可以与朋友共享您的屏幕从而与朋友面对面交谈',
    together_qa_popup_text7: '是一个会议空间',
    together_qa_popup_text8: '可以十名同时入场参加.',
    together_qa_popup_text9: '安装单独的程序',
    together_qa_popup_text10: '不需要注册会员.',
    together_more_list_title: '活动空间',
    together_more_list_date: 'YYYY.MM.DD 开通',
    together_request_list_title: '请创建',
    together_request_list_category1: '最喜欢的',
    together_request_list_category2: '最新的',
    together_request_list_button: '推荐新活动空间',
    together_request_popup_title: '新空间推荐',
    together_request_popup_alert1: '请输入标题',
    together_request_popup_alert2: '请输入内容',
    together_request_popup_placeholder1: '请输入标题',
    together_request_popup_placeholder2: '请输入内容',
    together_request_popup_button: '登录',
    together_request_detail_button: '创建这个空间',
    together_detail_sns: ' 邀请朋友',
    together_detail_enterbtn: '入场',
    together_detail_btn1: '活动列表',
    together_detail_btn2: '留言',
    together_detail_subtitle: '关于该主题的迷你书',
    together_detail_alert: '请稍等一下!',
    together_detail_alert1: '成功推荐活动空间！',
    together_detail_alert2: '推荐活动空间失败…',
    together_detail_alert3: '点赞 / 点在取消 成功!',
    together_detail_alert4: '点赞 / 点在取消 失败…',
    together_detail_alert5: '服务器出现问题。 请稍后再试',
    together_detail_alert6: '在线会议链接有问题',
    together_detail_alert7: '删除失败',
    together_notice_alert: '确定要删除公告吗?',
    together_notice_list_title: '公告',
    together_button_addtopic: '将此添加为活动空间主题',
    together_add_alert: '已添加到活动空间',
    together_text1: '与您的志趣相投',
    together_text2: '是否删除该活动空间？',
    together_event_btn: '创建新活动',
    together_event_title: '新活动',
    together_event_placeholder: '请输入简介',
    together_event_text1: '设定日程',
    together_event_text2: '设定入场费',
    together_event_text3: '设定最大人数',
    together_event_text4: '日程',
    together_event_text5: '入场费',
    together_event_text6: '最大人数',
    together_event_text7: '通知我的粉丝',
    together_event_text8: '是否要删除活动？',
    together_event_text9: '请将开始时间设置为当前时间之后',
    together_event_text10: '请将结束时间设置为开始时间之后',
    together_event_text11: '开始时间和结束时间不能相同',
    together_event_text12: '将此添加为活动主题',
    together_event_text13: '已添加到活动中',
    together_event_text14: '已超出活动的最大人数',
    together_event_text15: '按钮将在活动开始前一小时启用\n（免费的情况不需要购买）',
    together_event_text16: '按钮将在活动开始前一小时启用',
    together_event_text17: '没有活动存在',
    together_event_text18: '如果有购买者，则无法删除活动',
    together_event_text19: '要发送通知吗？',
    together_event_text20: '已发送',
    together_event_text21: '活动列表',
    together_event_text22: '查看详情',
    together_event_text23: '加入会员后请登录',
    together_event_text24: '参加方式',
    together_event_text25: '已完成参与活动',
    together_event_text26: '作者为这个活动倾注了大量时间和心意。\n\n请以一份小礼物回应吧。',
    together_event_text27: '来自作者经验的智慧和深度交流令人印象深刻',
    together_event_text28: '请把这个活动分享给全世界',
    together_event_text29: '举办这个活动并不容易，但我做到了。',
    together_event_text30: '再好的活动，一个人也很难将其传播到世界各地。',
    together_event_text31: '支持者是将作者活动传播出去的人，是相互支持的人。',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: '认识来自世界各地不同的人',
    youbooker_case: 'YouBooker <br /> 想法',
    youbooker_case_text1: '永远做第一个开始的人',
    youbooker_case_text2: '知识的复利效应, <br /> 明天的我会成为更好的自己',
    youbooker_translation: '想立即见面吗？',
    youbooker_translation_text1: '所有语言',
    youbooker_category: '粉丝 /关注',
    youbooker_subcategory1: '我关注的',
    youbooker_subcategory2: '我的粉丝',
    youbooker_subtitle2: '这是关注我的人',
    youbooker_button_follow: '关注',
    youbooker_message_follow: '关注',
    youbooker_button_follow_cancel: '取消关注',
    youbooker_subtitle3: '这些是您认识的用户',
    youbooker_subtitle4: '我正在关注他们',
    youbooker_subtitle5: '这些人还不知道YouBook',
    youbooker_button_invite: '邀请',
    youbooker_alert_invite: '只能通过应用程序进行邀请，下载应用程序怎么样呢？',
    youbooker_alert: '只能在应用程序中进行. 下载应用程序怎么样呢',
    youbooker_alert2: '刷新成功!',
    youbooker_alert3: '只能在YouBooker中进行搜索',
    home_page_text1: '最新',
    home_page_text2: '影响力',
    home_page_today_title: '今日话题',
    home_page_today_subtitle: '了解最新资讯',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: '话题',
    home_page_today_detail_sns: '和朋友分',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: '相关页面',
    home_page_explor_title: '页面探索',
    home_page_explor_subtitle: '双击会发生什么呢?',
    home_page_recommend_title: '个性化推荐',
    home_page_recommend_subtitle: '我收集了您可能会感兴趣的信息。',
    home_page_theysee_title: '他们看到了什么',
    home_page_theysee_subtitle: '读者一定要看到的页面是?',
    home_page_common_title: '这个常识怎么样呢',
    home_page_common_subtitle: '积累常识可以不断的帮助我们正确的看待问题',
    home_page_keyw_title: '查看关键词页面',
    home_page_keyw_subtitle: '查找所有相关知识',
    home_page_random_title: '随机搜索 GO',
    home_page_random_subtitle: '当你头昏脑胀时，坚持下去 <br />你会在无意中学到东西',
    home_page_about_title: '商业信息',
    home_page_about_detail: '公司名称：NICK syndicate<br />中国商务中心:  上海<br />其他国家商务中心: 西雅图 东京 首尔<br />联系方式 : joa@academy-connect.net<br />DUNS 695937905',
    settlement_title: '购买结算',
    settlement_tab1: '购买记录',
    settlement_tab2: '帐户信息',
    settlement_tab3: '结算内容',
    settlement_category1: '我的购买记录',
    settlement_category2: '共享作者权利',
    settlement_category3: '迷你书收入结算记录',
    settlement_category4: '活动收入结算记录',
    settlement_category5: '账户管理',
    settlement_text1: '显示购买记录',
    settlement_text2: '可以共享迷你书的作者权利',
    settlement_text3: '我们会结算付费迷你书销售所赚取的利润。',
    settlement_text4: '还有任何的疑问吗',
    settlement_text5: '这里',
    settlement_text6: '是的\n或请通过以下方式联系我们',
    settlement_text7: 'joa@academy-connect.net',
    settlement_text8: '请说些什么吧',
    settlement_text9: '如果有收入，需要管理用于接收收益的账户',
    settlement_text10: '结算活动所得收入',
    settlement_purchase_text1: '购买记录',
    settlement_purchase_text2: '日期',
    settlement_purchase_text3: '购买金额',
    settlement_purchase_text4: '标题',
    settlement_purchase_text5: '迷你书',
    settlement_purchase_text6: '活动',
    settlement_accountInfo_text1: '迷你书的作者权利',
    settlement_accountInfo_text2: '迷你书的选择',
    settlement_accountInfo_text3: '语言选择',
    settlement_accountInfo_text4: '作者权利',
    settlement_accountInfo_text5: '作者',
    settlement_accountInfo_text6: '第三方',
    settlement_accountInfo_text7: '是否是个人',
    settlement_accountInfo_text8: '个人',
    settlement_accountInfo_text9: '公司',
    settlement_accountInfo_text10: '银行名称',
    settlement_accountInfo_text10_message: '请选择银行',
    settlement_accountInfo_text11: '账户持有人姓名',
    settlement_accountInfo_text11_message: '请输入账户持有人',
    settlement_accountInfo_text12: '账户号码',
    settlement_accountInfo_text12_message: '请输入账户号码',
    settlement_accountInfo_text12_placeholder: '如) 079-12-444987',
    settlement_accountInfo_text13: '身份证号码',
    settlement_accountInfo_text13_message: '请输入身份证号码',
    settlement_accountInfo_text13_placeholder: '如) 930221-1228773',
    settlement_accountInfo_text14: '地址',
    settlement_accountInfo_text14_message: '请输入地址',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: '邮箱',
    settlement_accountInfo_text15_message: '请输入邮箱',
    settlement_accountInfo_text16: '输入完成',
    settlement_accountInfo_text17: '统一社会信用代码',
    settlement_accountInfo_text17_message: '请输入统一社会信用代码',
    settlement_accountInfo_text17_placeholder: '如) 12345678912364243X',
    settlement_accountInfo_text18: '地址',
    settlement_accountInfo_text18_message: '请输入注册公司地址',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: '公司名',
    settlement_accountInfo_text19_message: '请输入公司名',
    settlement_accountInfo_text20: '公司联络方式',
    settlement_accountInfo_text20_message: '请输入公司联络方式',
    settlement_accountInfo_text21: '第三方 ID',
    settlement_accountInfo_text21_placeholder: '第三方 邮箱地址',
    settlement_accountInfo_text22: '接收付款的帐户',
    settlement_accountInfo_text23: '国家选择',
    settlement_accountInfo_message1: '未找到受让人电子邮件',
    settlement_accountInfo_message2: '不能将作者权利共享给自己',
    settlement_accountInfo_message3: '没有创建任何迷你书',
    settlement_accountInfo_text24: '共享作者权利',
    settlement_accountInfo_text25: '将作者权利共享给第三方后，无法再次收回',
    settlement_accountInfo_text26: '您确定要共享作者权利吗？',
    settlement_accountInfo_text27: '是的，我要共享.',
    settlement_accountInfo_text28: '在共享作者权利的情况下，<br />1) 迷你书中的页面必须是您创建的，<br />2) 并且之前未与第三方共享过',
    settlement_accountInfo_text29: '是的，确认编辑',
    settlement_accountInfo_text30: '您已将此迷你书的作者权利共享给第三方',
    settlement_accountInfo_text31: '作者',
    settlement_accountInfo_text32: '第三方',
    settlement_accountInfo_text33: '您已从作者那里共享获得此迷你书的作者权利',
    settlement_accountInfo_text34: '这是一本免费迷你书. 无需帐户.',
    settlement_accountInfo_text35: '收入共享',
    settlement_accountInfo_text36: '(我)',
    settlement_accountInfo_text37: '(出版社 等)',
    settlement_accountInfo_text38: '个人账户',
    settlement_accountInfo_text39: '公司账户',
    settlement_accountInfo_text40: '账户管理',
    settlement_accountInfo_text41: '登录',
    settlement_accountInfo_text42: '银行',
    settlement_accountInfo_text43: '账户选择',
    settlement_earnings_text1: '查看结算详情',
    settlement_earnings_text2: '结算时间',
    settlement_earnings_text3: '销售价格',
    settlement_earnings_text4: '销售数量',
    settlement_earnings_text5: '销售额',
    settlement_earnings_text6: '税收减免等',
    settlement_earnings_text7: '存款金额',
    settlement_earnings_text8: '存款日期',
    settlement_earnings_text9: '广告浏览量',
    settlement_earnings_text10: '总金额',
    settlement_earnings_text11: '了解更多信息',
    settlement_earnings_text12: '广告价格',
    settlement_earnings_text13: '收入',
    settlement_earnings_text14: '所有迷你书',
    settlement_earnings_text15: '选择活动',
    settlement_earnings_text16: '所有活动',
    settlement_statistics_text1: '销售量',
    settlement_statistics_text2: '读者数量',
    settlement_statistics_text3: '(上个)',
    settlement_statistics_text4: '一个月',
    settlement_statistics_text5: '六个月',
    settlement_statistics_text6: '一年',
    settlement_statistics_text7: '没有查询到数据',
    settlement_statistics_text8: '销售分析',
    settlement_statistics_text9: '广告观看',
    settlement_statistics_text10: '所有语言',
    terms_title: '使用条款',
    terms_text: '本服务条款旨在规定会员与服务提供商NICK syndicate（以下简称“公司”）之间的必要事项。<br/><br/>服务内容的管理<br/>公司应 规定并公开会员上传服务内容所需事项如下。<br/><br/><b>1． 会员上传的服务内容的权利</b><br/>本公司拥有会员上传的服务内容（版面帖子、迷你书介绍、卡片）的版权，会员有义务不侵犯其知识产权。 <br/>会员上传的一般内容（评论、个人资料、照片、备忘录等）的版权归会员所有，并且 会员创作内容有义务不侵犯他人知识产权，并自行承担责任。<br/><br/><b>2． 会员上传不当服务内容时的处理措施</b><br/>①会员上传的服务内容或一般内容属于下列内容之一的，公司可以删除该内容或阻止其显示 通过技术过滤。<br/>1. 通过侵犯隐私、诽谤、咒骂或亵渎来冒犯他人<br/>2。 通过违反公共秩序和道德或诽谤特定群体、组织或宗教来冒犯他人<br/>3. 以未经证实或毫无根据的内容侵犯他人权利<br/>4. 侵犯他人版权<br/>5. 包含他人的个人信息<br/>6. 包含广告/促销内容<br/>7. 重复发布相同内容<br/>8. 恶意代码等干扰公司服务顺利提供的行为<br/>9. 如果判断可能对其他会员顺利使用服务造成不良影响<br/>② 公司限制显示的内容不得被其他人（包括公司员工）观看。 但是，如果法院、调查机构或其他行政机关要求公司提供信息，或者其他法律有要求，公司可以允许其他利害关系人查看该内容。<br/>③如果会员发现 对于上述内容，他/她可以通过电子邮件或Channel Talk以文字、截屏、录音等方式向公司报告该内容的详细情况，公司将在收到报告后24小时内审核该内容，如果 适用时，删除该内容或通过技术过滤采取措施阻止其显示。<br/><br/><b>3. 会员购买的服务内容的使用、取消和退款</b><br/>①会员购买了付费服务内容，可以免费使用该内容。 在这种情况下，购买的内容无法取消或退款。 如果您对此有任何疑问，请使用以下方式。<br/>联系方式：电话 82（国家/地区代码）070-4578-9240，电子邮件 joa@academy-connect.net<br/><br/>[附录]<br />1. 本条款自2024年3月1日起生效并取代之前的规定。.',
    privacy_title: '隐私政策',
    privacy_text: '本隐私政策的目的是规定会员在使用NICK syndicate（以下简称“公司”）提供的服务时所需注意的事项。<br/><br/>个人信息的保护<br/> 根据个人信息保护法第30条的规定，为了保护客户的个人信息并及时顺利地处理与之相关的申诉，本公司制定并公开以下个人信息处理准则。<br/><br/>< b>1。 处理个人信息的目的</b><br/>本公司出于以下目的处理个人信息，并且不会将其用于以下目的以外的任何目的。<br/>- 确认客户订阅意向、识别和认证 向顾客提供服务时的身份识别、会员资格的维护和管理、提供商品或服务的付款、提供和交付商品或服务等。<br/><br/><b>2． 个人信息的处理和保留期限</b><br/>①公司应在向信息主体收集个人信息时约定的个人信息保留和使用期限或个人信息保留期限内处理和保留个人信息 <br/>② 具体个人信息处理及保留期限如下。<br/>- 客户订阅和管理：直至服务使用合同终止或会员资格取消为止，但在 存在债务及债务关系的，直至该债务及债务关系解决<br/>-电子商务合同、解除合同、付款、商品等供货记录：5年<br/><br/> <b>3. 向第三方提供个人信息</b><br/>除信息主体另行同意或特别规定等个人信息保护法第17条规定的情况外，本公司不会向第三方提供个人信息。 法律。<br/><br/><b>4。 个人信息的委托处理</b><br/>①为了顺利处理个人信息，公司可以将个人信息的处理委托给外部机构，在此情况下，公司将提前通知。<br/ >② 公司在签订委托合同时，应以书面形式明确禁止以执行委托任务以外的目的处理个人信息、限制再委托、管理和监督受托人以及根据第 1 条规定的责任。 个人资料保护法第二十五条规定，监督受托人处理个人资料是否安全。<br/><br/><b>5． 信息主体及法定代表人的权利义务及行使方式</b><br/>客户可以随时向本公司行使以下个人信息保护权利。<br/>1． 请求查看个人信息<br/>2. 个人信息如有错误，要求更正<br/>3. 请求删除<br/>4. 请求暂停处理<br/><br/><b>6. 处理的个人信息项目</b><br/>必要时，经客户同意，公司可能会处理以下收集的个人信息项目。<br/>-姓名、出生日期、地址、电话和手机 电话号码（包括电话簿中列出的电话号码）、性别、电子邮件地址、信用卡号、银行帐号、付款信息等<br/><br/><b>7. 个人信息的销毁</b><br/>①当个人信息超过保存期限或达到处理目的等不再需要时，公司将立即销毁个人信息。<br/> ② 公司通过以下方式销毁个人信息<br/>- 电子文件：删除文件、格式化光盘等存储介质<br/>- 手写文件：粉碎或焚烧<br/><br/><b>8 。 确保个人信息安全的措施</b><br/>公司采取以下措施确保个人信息安全。<br/>- 管理措施：建立和实施内部管理计划、定期对员工进行培训 <br/>- 技术措施：对个人信息处理系统（或存储个人信息的计算机）设置密码等访问权限管理、安装防病毒软件等安全程序、对存储个人信息的文件进行加密等 <br/>- 物理措施：检查个人信息存储地点、访问控制等<br/><br/><b>9. 自动个人信息收集装置的安装、运行和拒绝</b><br/>① 本公司使用 "cookies "不时地存储和检索使用信息，以便向用户提供个性化服务。<br/>② Cookies 是用于运行网站的服务器（http）向用户计算机浏览器发送的少量信息，并存储在用户 PC 计算机的硬盘上。使用 Cookies 的目的： Cookies 用于通过识别用户访问的每项服务和网站的访问和使用类型、常用搜索词、安全连接等，向用户提供优化信息。安装、运行和拒绝 Cookie： 您可以在网络浏览器顶部的 "工具">"Internet 选项">"隐私 "菜单中设置选项，拒绝 Cookie 的存储。如果您拒绝保存 cookie，您在使用个性化服务时可能会遇到困难。个人信息保护官</b><br/>本公司指定了以下个人信息保护官，全面负责个人信息的处理，并处理信息主体有关个人信息处理的投诉和损害救济： 柳冀潤  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 职位： 首席执行官<br/>电子邮件 joa@academy-connect.net<br/> 电话：82（国家/地区代码）070-4578-9240，<br/><br/>[附录]<br/>1. 本条款自 2024 年 3 月 1 日起生效，并取代之前的规定、',
    // common text
    message_save: '以登录完成',
    message_fail: '登录失败',
    message_delete: '已删除',
    message_report: '举报成功',
    message_search_no_result: '找不到与您的搜索相关的结果',
    message_search_enter: '请输入您的搜索词',
    message_error1: '发生了错误。 请联系管理员',
    message_save2: '已保存',
    message_fail2: '保存失败',
    message_login: '需要登录',
    name: '姓名',
    email: '电子邮件',
    mobile: '电话号码',
    list: '列表',
    edit: '编辑',
    delete: '删除',
    search: '搜索',
    report: '举报不当内容',
    user: '使用者',
    report_type: ' 请选择举报内容',
    report_type1: '亵渎和诽谤',
    report_type2: '宣传',
    report_type3: '色情/淫荡',
    report_type4: '重复相同内容',
    report_type5: '其他',
    serch_placeholder: '请搜索姓名或电子邮件',
    search_book: '搜索迷你书',
    search_keyword: '关键词',
    search_reference: '参考文献',
    search_author: '作者姓名',
    search_result: '已找到',
    button_report: '举报',
    button_write: '登录',
    button_login: '登录',
    button_more: '查看更多',
    button_confirm: '确认',
    button_save: '保存',
    button_crop: '选择',
    button_delete: '删除',
    button_complete: '完成',
    colorbox_background_text1: '请选择背景颜色',
    colorbox_font_text1: '请选择标题颜色',
    menu_home: '首页',
    menu_page: '页面',
    menu_book: '迷你书',
    menu_memo: '备忘录',
    menu_together: '活动',
    login_button: '登录',
    message_text1: '回复',
    message_text2: '有人回复我的评论啦',
  },
  de: {
    home_banner_title1: 'Neues Minibook',
    home_banner_title2: 'Neues Ereignis',
    home_slide_title1: 'Gerade angesagt',
    home_slide_title2: 'Mein Geschmack',
    home_slide_title3: 'Derzeit im Trend',
    home_slide_title4: 'Sehr beliebt',
    home_detail_title1: 'Alltägliche Erinnerungen',
    home_detail_title2: 'Empfohlene Videos',
    home_detail_title3: 'Wenn du mehr wissen willst',
    home_detail_text1: 'Minibook Notiz',
    home_detail_text2: 'Tägliche Notiz',
    home_setting_title: 'Einstellungen',
    home_setting_text1: 'Seiten der letzten 30 Tage',
    home_setting_text2: 'Abmelden',
    home_setting_text3: 'Konto löschen',
    home_book_banner_question: 'Interesse geweckt?',
    home_book_banner_write_placeholder1: 'Einen Titel eingeben',
    home_book_banner_write_placeholder2: 'Beitrag eingeben',
    home_book_banner_write_button: 'Speichern',
    home_book_banner_detail_text1: 'Antwort des YouBook-Mentors',
    home_book_banner_detail_text2: 'Verwandte Minibooks',
    home_book_create_button: 'Minibook, erstelle dein eigenes',
    home_book_create_text1: 'Ein Minibook ist ein kurzes Buch mit etwa 10 Seiten. Es ist perfekt für den aktuellen Trend, Inhalte schnell und prägnant zu lesen.',
    home_book_create_text2: 'Wie man nach der Veröffentlichung bearbeitet',
    home_book_create_text3: 'Minibook, einfacher Weg zum Erstellen',
    home_book_create_text4: 'Wie viel kann ein Autor verdienen?',
    home_book_create_text5: 'Wie finde ich Leser?',
    home_book_create_text6: '5 Gründe, YouBook zu nutzen',
    home_book_create_text7: 'Noch weitere Fragen?',
    home_book_create_text8: 'Kann ich meine Verkaufszahlen in Echtzeit sehen?',
    home_book_create_text9: 'Lass uns jeden Tag fleißig schreiben!',
    home_book_create_text10: 'Starte jetzt sofort!',
    home_book_category_title1: 'Heutige Themen und Minibuch',
    home_book_category_title2: 'Beliebte Minibooks',
    home_book_category_title3: 'S-Klasse Professor Minibooks',
    home_book_category_title4: 'Individuelle Empfehlungen',
    home_book_category_title5: 'Bestseller-Essentials Minibooks',
    home_book_category_title6: 'Mit Büchermiez',
    home_book_category_title6_text1: 'Anzeigen',
    home_book_category_title6_text2: 'Einklappen',
    home_book_category_title7: 'Seiten im neuronalen Netzwerk erkunden',
    home_book_category_title8: 'Kunst- und Emotionen-Festival',
    home_book_category_title8_text1: 'Die Welt in Filmen und Dramen',
    home_book_category_title8_text2: 'Bewegende Melodien und Bewegungen',
    home_book_category_title8_text3: 'Kunst ohne Grenzen',
    home_book_category_title8_text4: 'Individualität tragen: Mode und Stil',
    home_book_category_title9: 'Kulinarische Kultur und Entspannung',
    home_book_category_title9_text1: 'Kulinarische Erkundungen, lokale Küche',
    home_book_category_title9_text2: 'Geschichten über Alkohol und Leben',
    home_book_category_title9_text3: 'Reiz von Snacks und Desserts',
    home_book_category_title9_text4: 'Die Kraft der Natur, Geheimnisse der Pflanzen',
    home_book_category_title10: 'Lebensweisheit und Selbstentdeckung',
    home_book_category_title10_text1: 'Einzigartige Geldverwaltung',
    home_book_category_title10_text2: 'Rezepte für persönliches Wachstum',
    home_book_category_title10_text3: 'Beziehungsprobleme und Lösungen',
    home_book_category_title10_text4: 'Neue Entdeckungen und Wissen',
    home_book_category_title11: 'Vielfalt der Werte und Liebe',
    home_book_category_title11_text1: 'Geschichten ihres Lebens',
    home_book_category_title11_text2: 'Verschiedene Philosophien und Werte',
    home_book_category_title11_text3: 'Religiöse Überzeugungen und Traditionen',
    home_book_category_title11_text4: 'Das Geheimnis der Liebe',
    home_book_category_title12: 'Ein Tag voller Reisen und Hobbys',
    home_book_category_title12_text1: 'Versteckte Reiseziele, die man besuchen muss',
    home_book_category_title12_text2: 'Lebensfreude durch Hobbys',
    home_book_category_title12_text3: 'Einzigartige Kultur durch Spiel',
    home_book_category_title13: 'Reichtum an Traditionen und Geschichten',
    home_book_category_title13_text1: 'Lokale Mythen und Heldengeschichten',
    home_book_category_title13_text2: 'Literarische Weltreisen',
    home_book_category_title13_text3: 'Geschichte und Weisheit der Orte',
    home_book_category_title13_text4: 'Bunte gesellschaftliche Geschichten',

    home_book_category_title1_text2: 'Gedanken von Büchermiez – Willst du mal kurz reinschauen?',
    home_book_category_title1_text3: 'Sorgen? Neugierig?',
    home_book_category_title1_text4: 'Soll ich ein Minibook empfehlen?',
    home_book_search_placeholder1: 'Bitte hier sprechen',
    home_book_search_placeholder2: 'Was ist das Schlüsselwort?',

    home_book_search_message1: 'Geben Sie Ihre Fragen ein',
    home_book_search_message2: 'Geben Sie Ihre Fragen erneut ein',
    home_book_search_text1: 'Diskutiere mit mir.',
    home_book_search_text2: 'Diskutiere mit mir.',
    home_book_search_text3: 'Fragen',
    home_book_search_text4: 'Sie können die obigen Fragen speichern',
    home_book_search_text5: '(Schlüsselwörter hinzufügen)',
    home_book_search_text6: 'Suchen',

    home_book_theme_title: 'Minibooks nach Thema',
    home_instant_text1: 'Ein Schlüsselwort eingeben',
    home_instant_text2: 'Zufällige Suche',
    home_book_company_info: 'Haben Sie weitere Fragen? Zögern Sie nicht, uns zu kontaktieren. Wir helfen Ihnen gerne.',
    home_page_search_text1: 'Seite durchsuchen',
    home_page_search_text2: 'Sofort als Video abspielen',
    home_page_search_text3: 'Erweiterte Suche',
    home_page_search_text4: 'Listenansicht',
    home_page_search_text5: 'Netzwerk-Ansicht',
    home_page_explor_alert: 'Es wurden keine Seiten ausgewählt',
    home_page_explor_alert2: 'Sie haben die maximale Anzahl von Seiten überschritten, die auf einem Bildschirm angezeigt werden können (150). Bitte legen Sie nicht benötigte Seiten in den Papierkorb.',
    home_page_explor_alert3: 'Es gibt keine weiteren Informationen zu laden',
    my_login_title: 'MEIN',
    my_login_text1: 'Gestalten Sie Ihr Profil, nach Ihren Wünschen',
    my_login_text2: 'Jetzt anmelden und schlau werden',
    my_login_text3: 'mit YouBook',
    my_login_find_password: 'Passwort vergessen?',
    my_guide_minibook: 'Wie man ein Minibook erstellt',
    my_password_reset: 'Passwort zurücksetzen',
    my_password_reset_text1: 'Geben Sie die mit diesem Konto verknüpfte E-Mail-Adresse ein.',
    my_password_reset_button1: 'Link zum Zurücksetzen senden',
    my_password_reset_button2: 'Zurücksetzen',
    my_password_reset_message1: 'Wir können Ihre E-Mail nicht finden',
    my_password_reset_message2: 'Wir haben einen Link zum Zurücksetzen des Passworts an die von Ihnen angegebene E-Mail-Adresse gesendet.',
    my_password_reset_message3: 'Bitte setzen Sie Ihr Passwort zurück, indem Sie den an Ihre E-Mail gesendeten Link verwenden.',
    my_password_reset_placeholder1: 'Ihre E-Mail-Adresse',
    my_password_reset_placeholder2: 'Geben Sie Ihr neues Passwort ein.',
    my_password_reset_placeholder3: 'Geben Sie Ihr neues Passwort erneut ein',
    my_password_reset_message4: 'Passwörter stimmen nicht überein',
    my_password_reset_message5: 'Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',
    my_password_reset_message6: 'Das Passwort wurde erfolgreich zurückgesetzt.',
    my_memo_list_placeholder: 'Sie haben eine Idee? Schreiben Sie sie jetzt auf.',
    my_profile_placehoder1: 'Mein Interesse',
    my_profile_placehoder2: 'Mein Name',
    my_profile_placehoder3: 'Stellen Sie sich kurz vor',
    my_profile_placehoder4: 'Weitere Infos zu Ihrer Person',
    my_profile_text1: 'Nationalität',
    my_profile_text2: 'Sprache',
    my_profile_text3: 'ID ändern',
    my_profile_text4: 'Aktuelle ID',
    my_profile_text5: 'Neue ID zum Ändern',
    my_profile_text6: 'Eine ID-Änderung ist nur einmal möglich',
    my_menu_text1: 'Meine Reise',
    my_menu_text2: 'Nachricht',
    my_menu_text3: 'Kauf & Abrechnung',
    my_menu_text4: 'Neue Benach-\nrichtigung',
    my_menu_text5: 'Ein Minibook erstellen',
    my_menu_text6: 'Erstellte Minibooks',
    my_menu_text7: 'Möchtest du Beiträge aus anderen Apps importieren?',
    my_menu_text8: 'Du kannst sie automatisch importieren und in Seiten umwandeln',
    my_menu_text9: 'Importieren',
    my_import_book_text1: 'In Seite umwandeln',
    my_import_book_text2: 'ZIP-Datei wird in Seiten umgewandelt. Die Umwandlung eines Beitrags kann bis zu 5 Sekunden dauern. 10 Beiträge dauern etwa 1 Minute, 100 Beiträge rund 8 Minuten. Nach Abschluss der Umwandlung erscheint ein Pop-up.',
    my_import_book_text3: 'Verstanden',
    my_import_book_text4: 'Seitenumwandlung abgeschlossen',
    my_import_book_text5: 'Alle Beiträge aus der ZIP-Datei wurden in Seiten umgewandelt. Jeder Beitrag wurde in eine eigene Seite umgewandelt. Du kannst sie unter Meine Reise – Erstellte Seiten einsehen. Die Seiten wurden temporär gespeichert und können bearbeitet werden.',
    my_import_book_text6: 'Du kannst Beiträge aus anderen Apps importieren und automatisch in Seiten umwandeln. Danach kannst du sie zu einem Minibook zusammenstellen.',
    my_import_book_text7: 'So importierst du Beiträge aus anderen Apps als ZIP-Datei',
    my_import_book_text8: 'Bitte lade eine ZIP-Datei hoch',
    my_import_book_text9: 'Substack-Datei hochladen',
    my_import_book_text10: 'Medium-Datei hochladen',
    my_import_book_text11: 'Suchen',
    my_import_book_text12: '* Jeder Beitrag wird in eine eigene Seite umgewandelt',
    my_import_book_text13: '* Sie können dies unter Meine Seite - Einstellungen - Erstellte Seiten überprüfen',
    my_import_book_text14: '* Die Seiten sind temporär gespeichert und bearbeitbar',
    my_import_book_text15: '* Es können nur eigene Beiträge importiert werden',
    my_import_book_text16: 'Ein Minibook mit umgewandelten Seiten veröffentlichen',
    my_import_book_text17: 'Erstelle das Cover des Minibooks',
    my_import_book_text18: 'Wähle Seiten aus und füge sie dem Minibook hinzu',
    my_import_book_text19: 'Veröffentliche das Minibook',
    my_import_book_text20: 'Bitte lies die Anleitung sorgfältig durch',
    my_import_book_text21: 'Keine ZIP-Datei',
    my_import_book_text22: 'Bitte lade eine Datei hoch',
    my_journey_title: 'Meine Reise',
    my_journey_button_message: 'Nachrichten',
    my_journey_button_memo: 'Notiz',
    my_journey_button_record: 'Aufzeichnung',
    my_journey_button_follow: 'Folgen',
    my_journey_button_follow_cancel: 'Entfolgen',
    my_journey_message_text1: 'Hinterlassen Sie eine Nachricht',
    my_journey_message_placeholder: 'Ihre Nachricht eingeben',
    my_journey_message_message1: 'Kann nicht antworten',
    my_journey_message_message2: 'Senden von',
    my_journey_message_message3: 'Ihre Nachricht eingeben',
    my_journey_memo_total: 'Gesamt',
    my_journey_record_overall: 'Einfluss-Rangliste',
    my_journey_record_text1: 'Aufgerufene Seiten',
    my_journey_record_text2: 'Minibooks Favoriten',
    my_journey_record_text3: 'Lieblings-Veranstaltungsraum',
    my_journey_record_text4: 'Erstellte Seiten',
    my_journey_record_text5: 'Erstellte Minibooks',
    my_journey_record_text6: 'Erstellter Veranstaltungsraum',
    my_journey_record_text7: 'Diesen Monat',
    my_journey_record_text8: 'Gekauftes Minibuch',
    my_journey_record_text9: 'Öffentlich',
    my_journey_record_text10: 'Privat',
    my_journey_record_text11: 'Gekaufte Ereignisse',
    my_journey_record_text12: 'Das von mir erstellte Ereignis',
    my_journey_record_text13: 'Platz #{userRank} in der {userLanguage}-Kategorie',
    my_journey_record_text14: 'Minibook mit geteiltem Autorenrecht',
    my_journey_record_text15: 'Möchten Sie, dass die Leser in einer bestimmten Reihenfolge lesen? Wenn ja, ziehen Sie das Cover, um die Reihenfolge zu ändern.',
    my_journey_record_text16: 'Unterstütze das neue Minibook',
    my_journey_record_text17: 'Unterstützungsnachrichten von Lesern',
    my_journey_record_text18: 'Hinterlasse dem Autor eine Nachricht zur Unterstützung',
    my_journey_record_text19: 'Unterstützerlevel',
    my_journey_record_text20: 'Level {cheeringLevel} von 10',
    my_journey_record_text21: 'Personen, die ich unterstütze',
    my_journey_record_text22: 'Meine Unterstützer',
    my_journey_record_text23: 'Möchten Sie das löschen?',
    my_journey_record_text24: 'Unterstützer von {userName}',
    my_journey_record_text25: 'Unterstützt von {userName}',
    my_notice_title: 'Benachrichtigung',
    my_notice_message1: 'Es gibt keine neuen Benachrichtigungen',
    my_notice_text1: 'Eine neue Minibook-Ausgabe ist eingetroffen',
    my_notice_text2: 'Ein neues heutiges Thema ist eingetroffen',
    my_notice_text3: 'Eine neue Nachricht zu Meine Reise',
    my_notice_text4: 'Ein neuer Kommentar zu meiner Notiz',
    my_notice_text5: 'Neuer Kommentar zu meinem Veranstaltungsraum',
    my_notice_text6: 'Ein neuer Kommentar zu meinem Minibook-Cover',
    my_notice_text7: 'Ein neuer Kommentar zu meiner Minibook-Seite',
    my_notice_text8: 'Eine neue Notiz veröffentlicht',
    my_notice_text9: '{userName} hat einen neuen Veranstaltungsraum erstellt',
    my_notice_text10: 'Ein neues Minibook veröffentlicht',
    my_notice_text11: 'hat mein minibuch gekauft',
    my_notice_text12: '{userName} hat ein <b>neues Ereignis</b> erstellt',
    my_notice_text13: '{userName} hat dich speziell zu <b>diesem neuen Ereignis</b> eingeladen. Schau unbedingt vorbei! ',
    my_notice_text14: '{userName} hat <b>mein Ereignis gekauft</b>',
    my_notice_text15: '{userName} hat sich als Mitautor beworben',
    my_notice_text16: 'Die Mitautoren-Bewerbung für das offene Minibook wurde genehmigt',
    my_notice_text17: 'Ein neuer Kommentar wurde von einem Mitautor veröffentlicht',
    my_notice_text18: 'Eine Nachricht zur Unterstützung des neuen Minibooks ist eingegangen',
    my_notice_text19: '{userName} hat <b>mein Minibook</b> gesponsert',
    my_marketing_banner_title: 'Sich selbst anfeuern',
    my_marketing_banner_text1: 'Du hast Herausforderungen gemeistert – unterstütze dich jetzt',
    my_marketing_banner_btn: 'Jetzt anfeuern',
    my_marketing_title: 'Jetzt anfeuern',
    my_marketing_text1: 'Spanne die zwei Flügel des Minibook und des Ereignis aus – nutze stufenweises Marketing als Treibstoff – und werde Influencer',
    my_marketing_text2: 'E-Mail an normale Leser senden',
    my_marketing_text3: 'SMS an normale Leser senden',
    my_marketing_text4: 'E-Mail an Freunde senden',
    my_marketing_text5: 'SMS an Freunde senden',
    my_marketing_text6: 'Link in sozialen Medien teilen',
    my_marketing_btn: 'Jetzt starten',
    my_marketing_minibook_step1_title: 'Minibook-Unterstützung',
    my_marketing_step1_subtitle: 'Link in sozialen Medien teilen',
    my_marketing_minibook_step1_text1: 'Füge den Link deines Minibook in deine sozialen Medien ein und ergänze eine ansprechende Beschreibung',
    my_marketing_minibook_text1: 'Finde das Minibook',
    my_marketing_step1_text1: 'Link kopieren',
    my_marketing_step1_btn: 'Kopieren',
    my_marketing_step1_text2: 'Füge ihn in deine sozialen Medien ein und ergänze eine Beschreibung',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter (X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo (微博)',
    my_marketing_step1_sns12: 'Xiaohongshu (小红书)',
    my_marketing_step1_sns13: 'WeChat (微信)',
    my_marketing_step1_text3: 'Bitte wählen Sie ein Minibook zum Teilen aus',
    my_marketing_step1_text4: 'Link kopiert',
    my_marketing_step1_text5: 'Bitte wählen Sie eine Veranstaltung zum Teilen aus',
    my_marketing_step1_text6: 'Soziale Medien finden',
    my_marketing_event_step1_title: 'Event-Unterstützung',
    my_marketing_event_step1_text1: 'Füge den Link des Ereignisses in deine sozialen Medien ein und ergänze eine ansprechende Beschreibung',
    my_marketing_event_text1: 'Finde das Ereignis',
    my_marketing_event_search_title: 'Ereignis durchsuchen',
    my_marketing_minibook_step2_title: 'Minibook Marketing – Stufe 2',
    my_marketing_step2_subtitle: 'SMS an Freunde senden',
    my_marketing_minibook_step2_text1: 'Sende deinen Freunden den Link zum Minibook mit einem persönlichen Einführungstext',
    my_marketing_step2_text2: 'Sende deinem Freund einen Link mit Einführungstext',
    my_marketing_step2_placeholder: 'Bitte Einführungstext eingeben',
    my_marketing_tab_text1: 'Meine Freunde',
    my_marketing_event_step2_title: 'Ereignis Marketing – Stufe 2',
    my_marketing_event_step2_text1: 'Sende deinen Freunden den Link zum Ereignis mit einem persönlichen Einführungstext',
    my_marketing_minibook_step3_title: 'Minibook Marketing – Stufe 3',
    my_marketing_step3_subtitle: 'E-Mail an Freunde senden',
    my_marketing_minibook_step3_text1: 'Sende deinen Freunden den Link zum Minibook mit einer Hintergrundgeschichte',
    my_marketing_step3_text1: 'Kontaktliste importieren',
    my_marketing_step3_placeholder: 'CSV- oder VCF-Datei hochladen',
    my_marketing_step3_text2: 'Sende deinem Freund den Link mit der Geschichte',
    my_marketing_step3_text3: 'Importieren Sie Ihre Telefonnummernliste',
    my_marketing_step3_placeholder2: 'Erzähle die Geschichte',
    my_marketing_event_step3_title: 'Ereignis Marketing – Stufe 3',
    my_marketing_event_step3_text1: 'Sende deinen Freunden den Link zum Ereignis mit einer Hintergrundgeschichte',
    my_marketing_text7: 'Telefonnummern importieren',
    my_marketing_title2: 'Telefonnummern verwalten',
    my_marketing_text8: 'Telefon',
    my_marketing_text9: 'Anzahl',
    my_marketing_text10: 'Kontakte importieren',
    my_marketing_text11: 'Bitte laden Sie eine CSV- oder VCF-Datei hoch',
    my_marketing_text12: 'Importmethode',
    my_marketing_text13: 'Importieren',
    my_marketing_title3: 'Kontakte verwalten',
    contact_manage: 'Kontaktverwaltung',
    my_marketing_text14: 'Auswahl löschen',
    my_marketing_text15: 'Bitte wählen Sie einen Freund aus',
    my_marketing_text16: 'Sie können bis zu 100 Freunde auswählen',
    my_marketing_text17: 'Hochladen abgeschlossen',
    my_marketing_text18: 'Zeichenanzahl überschritten',
    contact_phone: 'Telefon',
    contact_organization: 'Organisation',
    contact_title: 'Titel',
    contact_memo: 'Notiz',
    my_marketing_text19: 'Auswahl bearbeiten',
    my_marketing_text20: 'Etikett auswählen',
    my_marketing_text21: 'Neues Etikett hinzufügen',
    my_marketing_text22: 'Ausgewähltes Etikett löschen',
    my_marketing_text23: 'Hinzufügen',
    my_marketing_btn2: 'Bearbeitung abgeschlossen',
    my_marketing_text24: 'Bitte wählen Sie einen Kontakt zum Bearbeiten aus',
    my_marketing_text25: 'Bitte wählen Sie ein Etikett zum Löschen aus',
    my_marketing_text26: 'Bitte geben Sie einen Etikettennamen ein',
    my_marketing_text27: 'Dieses Etikett existiert bereits',
    my_marketing_text28: 'Etikett hinzufügen',
    my_marketing_text29: 'Abbrechen',
    my_marketing_text30: 'Hinzugefügt',
    my_benefit_text1: 'Sie haben bis jetzt verdient',
    my_benefit_text2: 'Sie werden in einem Jahr verdienen',
    my_benefit_text3: '',
    my_benefit_text4: 'die Gewinnberechnung',
    my_benefit_text5: 'die Gewinnberechnung',
    my_benefit_text6: 'Prüfen Sie',
    my_benefit_modal_text1: 'Ihr bisheriger Gewinn',
    my_benefit_modal_text2: 'EUR',
    my_benefit_modal_text3: 'Sie haben Gewinn gemacht.',
    my_benefit_modal_text4: 'Lassen Sie uns eine sehr einfache Berechnung durchführen',
    my_benefit_modal_text5: 'Seiten die bisher gelesen wurden',
    my_benefit_modal_text6: 'Preis für die Erstellung einer Seite',
    my_benefit_modal_text7: 'EUR',
    my_benefit_modal_text8: 'Ihr Gewinn ist also',
    my_benefit_modal_text9: 'Fügen Sie nun die Vorteile von Diskussionen mit',
    my_benefit_modal_text10: 'KI und Ihr Gewinn wird noch größer sein',
    my_benefit_modal_text11: 'Verwenden Sie es jeden Tag und ernten Sie die Gewinne',
    my_benefit_modal_text12: 'OK, Ich habe verstanden',
    my_story_text1: 'Was Mitglieder sagen',
    my_story_text2: 'Erkenntniss, dass Bücher nicht gelesen, sondern erlebt werden',
    my_story_text3: 'Erstaunlich, was passiert, wenn man jeden Tag lernt',
    my_story_text4: 'Versteckte Gefahren kluger Menschen - gehören Sie dazu?',
    my_story_text5: 'Lesen Sie mehr von der Geschichte der Mitglieder',
    my_go_blog_text1: 'YouBook, Nachrichten und Kundengeschichten',
    my_go_blog_text2: 'Entdecken Sie die neuesten Nachrichten und Kundengeschichten von YouBook',
    my_go_blog_text3: 'Mehr erfahren',
    my_channel_text1: 'Was halten Sie von YouBook?',
    my_channel_text2: 'Geben Sie uns ein Feedback.',
    my_channel_text3: 'Und lassen Sie uns Ihre Fragen wissen.',
    my_channel_text4: 'Tragen Sie etwas bei.',
    my_about_youbook_text1: 'Warum sollten Sie YouBook benutzen?',
    my_about_youbook_text2: 'Alle Ihre Fragen und Antworten finden Sie hier',
    my_about_youbook_text3: 'Bedingungen für den Service',
    my_app_text1: 'YouBook ist eine 100% nützliche Anwendung.',
    my_app_text2: 'Laden Sie es jetzt herunter und gewinnen Wissen',
    my_app_text3: 'App herunterladen',
    login_title: 'EINLOGGEN',
    login_text1: 'Einloggen mit E-Mail',
    login_text2: 'Noch nicht registriert?',
    login_text3: 'Passwort vergessen?',
    login_text4: 'oder Einloggen mit',
    login_text5: 'Ich stimme zu',
    login_placeholder1: 'Login-E-Mail',
    login_placeholder2: 'Passwort',
    login_placeholder3: 'ID',
    login_message1: 'Bitte geben Sie Ihre Login-E-Mail ein',
    login_message2: 'Geben Sie Ihr Passwort ein',
    login_message3: 'Einloggen erfolgreich',
    login_message4: 'Bitte geben Sie Ihre ID ein',
    logout_message1: 'Möchten Sie sich abmelden?',
    login_link1: 'Registrieren Sie sich',
    login_link2: 'finden',
    login_link3: 'Bedingungen für den Service',
    register_title: 'Registrieren Sie sich',
    register_text1: 'Registrieren Sie sich mit ihrer E-Mail-Adresse',
    register_text2: 'Wählen Sie die Art der Mitgliedschaft',
    register_text3: 'Persönlich',
    register_text4: 'Organisatorisch',
    register_text5: 'Geben Sie Ihre Informationen ein',
    register_text6: 'Bereits registriert?',
    register_text7: 'Nummer der Unternehmensregistrierung',
    register_text8: 'Handelsregisternummer',
    register_text9: 'Name des Unternehmens',
    register_placeholder1: 'Ihre Telefonnummer mit Vorwahl',
    register_placeholder2: '( ohne - )',
    register_placeholder_repassword: 'Passwort erneut eingeben',
    register_message1: 'Geben Sie Ihre Telefonnummer ein',
    register_message2: 'Eingabe der Nummer der Unternehmensregistierung',
    register_message3: 'Bitte geben Sie die Handelsregisternummer ein',
    register_message4: 'Bitte geben Sie den Namen der Organisation ein',
    register_message5: 'Ungültiges E-Mail-Format',
    register_message6: 'Diese E-Mail ist bereits registriert',
    register_message7: 'Bitte verifizieren Sie Ihre E-Mail',
    register_message8: 'Bitte wählen Sie Ihre Nationalität',
    register_message9: 'Ungültiges ID-Format',
    register_message10: 'Die eingegebene ID ist nicht verfügbar. Bitte verwenden Sie eine empfohlene ID oder geben Sie eine andere ein',
    register_message11: 'Bitte bestätigen Sie Ihre ID',
    register_message12: 'Diese ID wird bereits verwendet. Bitte verwenden Sie eine empfohlene ID oder geben Sie eine andere ein',
    register_button_verify: 'Prüfen',
    register_button_verify_fail: 'Nicht verifiziert',
    register_button_verify_success: 'Verifiziert',
    register_welcome_message: 'Willkommen zur Mitgliedschaft',
    withdraw_text1: 'Mitgliedschaft kündigen',
    withdraw_text2: 'YouBook-Mitgliedschaft kündigen',
    withdraw_text3: 'Sind Sie sicher, dass Sie kündigen möchten?',
    withdraw_text4: 'Nein',
    withdraw_text5: 'Ja',
    withdraw_text6: 'Sie haben Ihre Mitgliedschaft erfolgreich gekündigt',
    home_memo_title: 'Notiz',
    home_memo_subtitle: 'Wenn Sie keine Notiz machen, vergisst man schneller.',
    home_memo_text1: 'Von allen gemeinsam geteilt',
    home_memo_text2: 'Wissen und Alltagsgeschichten',
    home_memo_button: 'Notiz hinterlassen',
    home_memo_create_text1: 'Hast du ein Minibook zum Verlinken?',
    home_memo_create_button: 'Minibook suchen',
    home_memo_create_button2: 'Auswählen',
    home_memo_click: 'Klicken Sie auf .',
    home_memo_date: 'DD.MM.YYYY',
    home_memo_button_askai: 'Kommentar / Gedanken von Büchermiez',
    home_memo_view_detail: 'Details anzeigen',
    home_memo_view_placeholder: 'Einen Beitrag schreiben',
    home_memo_view_button1: 'Kommentar',
    home_memo_view_button2: 'Gedanken von Büchermiez',
    home_memo_view_errormessage: 'Einen Beitrag schreiben',

    memo_create_title: 'Notiz',
    memo_create_category1: 'Notiz',
    memo_create_category2: 'Notiz',
    memo_create_private: 'Privat',
    memo_create_public: 'Öffentlich',
    memo_create_placeholder1: 'Sie haben eine Idee?',
    memo_create_placeholder2: 'Schreiben Sie sie jetzt auf',
    memo_create_placeholder3: 'Schlüsselwörter (durch Leerzeichen trennen)',
    memo_create_button: 'Speichern',
    memo_create_error: 'Ihre Notiz eingeben',
    memo_attach_img: 'Bild hochladen',
    memo_alert_rate: 'Bitte wählen Sie Ihre Sternebewertung',
    memo_alert_save: 'Gespeichert. Sie können es in \'Mein Profil - Meine Reise" überprüfen',
    memo_input_placeholder: 'Was haben Sie gelernt?',
    memo_input_placeholder2: 'Was sind Ihre Gedanken?',
    memo_input_placeholder3: 'Teilen Sie sie jetzt mit den Lesern~',
    memo_input_placeholder4: 'Eine Erinnerung aus dem Alltag – wollen wir sie festhalten?',
    memo_alert_keywords: 'Schlüsselwörter eingeben',
    memo_related_text: 'Notiz',
    memo_related_date: 'DD.MM.YYYY',
    memo_popup_text1: 'Die Geschichte von Nicholas Luhmann liest sich wie eine moderne Fabel, die die transformative Kraft einer einfachen Gewohnheit zeigt.',
    memo_popup_text3: 'Ursprünglich war Luhmann ein junger Angestellter in einem Unternehmen, das weit von der Welt der Wissenschaft entfernt war.',
    memo_popup_text4: 'Seine unersättliche Freude am Lesen führte ihn jedoch zu einer ungewöhnlichen Praxis: Er machte sich täglich Notizen zu seinen Lektüren.',
    memo_popup_text5: 'Diese Angewohnheit gipfelte in einem Aufsatz, der die Aufmerksamkeit eines renommierten deutschen Soziologen erregte und eine unerwartete Wende in seiner Karriere einleitete.',
    memo_popup_text6: 'Luhmann wurde in den Lehrkörper der Universität Bielefeld berufen, wo er schließlich zum ordentlichen Professor aufstieg.',
    memo_popup_text7: 'Im Laufe seiner Karriere verfasste er beeindruckende 60 Bücher und zahlreiche Artikel, die seinen Status als Koryphäe der Soziologie festigten.',
    memo_popup_text8: 'Luhmann führte seine intellektuellen Fähigkeiten auf sein methodisches Notieren zurück und sagte',
    memo_popup_text9: 'Ich habe mir einfach ständig Notizen gemacht, erzählte er.',
    memo_popup_text10: 'Dies half ihm, seine Gedanken zu ordnen und sein Verständnis zu vertiefen.',
    memo_popup_text11: 'Diese Erzählung erinnert an die Grenzen des Gedächtnisses und an den Wert des systematischen Erfassens und Wiederholens von Wissen, um es sich wirklich zu eigen zu machen.',
    memo_popup_btn: 'Ja, das kann ich nachvollziehen',
    memo_text1: 'Sie können das oben Gesagte speichern',
    memo_text2: '(Fügen Sie einfach Schlüsselwörter hinzu)',
    memo_text3: 'Dinge, die beim Schreiben zu beachten sind',
    memo_text4: 'Ihr Beitrag verstößt gegen die Inhaltsrichtlinien gemäß Artikel 2, Abschnitt 1 der Bedingungen der Dienstleistung. Er wird nicht veröffentlicht.',
    memo_text5: 'Bedingungen der Dienstleistung ansehen',
    memo_text6: 'Um eine Notiz in einer anderen Sprache zu hinterlassen, ',
    memo_text7: 'schreibe bitte in dieser Sprache (keine automatische Übersetzung)',
    book_create_button: 'Ein Minibuch erstellen',
    book_create_title: 'Ein cover erstellen',
    book_create_cover: 'cover',
    book_create_text1: 'Schrittweise Anleitung für die Erstellung eines Covers für ein Minibook',
    book_create_text1_pc: 'Geben Sie den Titel und den Autorennamen ein',
    book_create_text2: 'Bild für das Cover ist nicht vorhanden',
    book_create_text3: '',
    book_create_text4: 'Bild für das Cover wurde erstellt',
    book_create_text5: 'Haben Sie Ihr eigenes Cover erstellt?',
    book_create_text6: 'Bitte laden Sie es über die unten stehende Schaltfläche hoch',
    book_create_text7: '(jpg-Format unter 20MB Größe)',
    book_create_text8: 'Recht zum Hinzufügen von Seiten',
    book_create_text9: 'Nur ich',
    book_create_text10: 'Jeder',
    book_create_text11: 'Anzeige von Titeln in Bildern',
    book_create_text12: 'Anzeigen',
    book_create_text13: 'Nicht anzeigen',
    book_create_text14: 'Wählen Sie die zu übersetzende Sprache aus',
    book_create_text15: 'Alles auswählen',
    book_create_text16: 'Cover-Bild hochladen',
    book_create_text17: 'Sie können es bearbeiten',
    book_create_text18: 'Klicken Sie nach der Bearbeitung auf das Symbol oben rechts, um es erneut zu übersetzen',
    book_create_text19: 'Wenn Sie es wie im Original erneut übersetzen möchten, klicken Sie oben rechts auf das Symbol',
    book_create_text20: 'Erneut übersetzen',
    book_create_text21: 'Bild',
    book_create_text22: 'Titel',
    book_create_text23: 'Schlüsselwort',
    book_create_text24: 'Inhalt',
    book_create_text25: 'Die Übersetzung wird nur aktualisiert, wenn das Bild gelöscht und erneut hochgeladen wird',
    book_create_text26: '(Die Seite wird nicht gelöscht)',
    book_create_text27: 'Geben Sie eine kurze Einführung ein',
    book_create_text28: 'Temporäre Speicherung',
    book_create_text29: 'Temporär gespeichert',
    book_create_text30: 'Zu überprüfende Punkte',
    book_create_text31: 'Der Inhalt des Textes ist die endgültige Version und benötigt keine weiteren Änderungen',
    book_create_text32: 'Es wurden keine Wörter oder Zeichen verwendet, die die KI-Übersetzung nicht versteht',
    book_create_text33: 'Das Bild wurde nicht kopiert und eingefügt, sondern als separate Datei hochgeladen',
    book_create_text34: 'Öffentlich rekrutieren? (Offenes Minibook)',
    book_create_text35: 'Mitautoren',
    book_create_text36: 'Möchten Sie manuell hinzufügen?',
    book_create_text37: 'Hinzufügen',
    book_create_text38: 'Ein Minibook, das sich gemeinsam geschrieben weiter verbreitet',
    book_create_text39: 'Die Kraft der Mitautoren, die Sie nicht kannten',
    book_create_text40: 'Rekrutierung öffnen',
    book_create_text41: 'Abbrechen',
    book_create_text43: 'Idee?',
    book_create_text44: 'Inhalt kopieren und einfügen',
    book_create_text45: 'Brauchst du eine Idee?',
    book_create_text46: 'Verkaufsoptionen',
    book_create_text47: 'Kostenlos',
    book_create_text48: 'Sponsor',
    book_create_text49: 'Kaufen',
    book_create_text50: 'Aktueller Preis',
    book_create_text51: 'Preis bearbeiten',
    book_create_text52: '0 ist nicht erlaubt',
    book_create_text53: 'Minibooks, die gekauft oder gesponsert wurden, können Preis oder Verkaufsoptionen nicht ändern',
    book_create_text54: 'Nur der Autor des Minibooks kann auf Nachrichten antworten',
    book_create_button_upload: 'Hochladen',
    book_create_button_make: 'Erstellen',
    book_create_cover_topic_placeholder: 'Titelvorschau',
    book_create_topic_placeholder: 'Einen Titel eingeben',
    book_create_keyword_placeholder: 'Schlüsselwörter (durch Leerzeichen trennen)',
    book_create_category_placeholder: 'Kategorie auswählen',
    book_create_knowledge_placeholder: 'Schreiben Sie eine Einleitung zu Ihrem Minibook  ** Achtung - Schreiben Sie die Details in den Schritt, um Seiten zu erstellen',

    book_create_category_option1: 'Filme und Dramen',
    book_create_category_option2: 'Musik und Tanz',
    book_create_category_option3: 'Andere Kunst',
    book_create_category_option4: 'Kleidung und Stil',
    book_create_category_option5: 'Essen und Kochen',
    book_create_category_option6: 'Alkohol und Getränke',
    book_create_category_option7: 'Snacks und Desserts',
    book_create_category_option8: 'Pflanzen und Gesundheit',
    book_create_category_option9: 'Reich werden',
    book_create_category_option10: 'Selbstentwicklung',
    book_create_category_option11: 'Beziehungen',
    book_create_category_option12: 'Neues Wissen',
    book_create_category_option13: 'Lebensgeschichten',
    book_create_category_option14: 'Philosophie und Werte',
    book_create_category_option15: 'Religion und Tradition',
    book_create_category_option16: 'Liebe',
    book_create_category_option17: 'Reisen und Attraktionen',
    book_create_category_option18: 'Hobbys',
    book_create_category_option19: 'Spielkultur',
    book_create_category_option20: 'Mythen und Helden',
    book_create_category_option21: 'Literarische Reisen',
    book_create_category_option22: 'Geschichte und Weisheit',
    book_create_category_option23: 'Soziale Geschichten',
    book_create_category_option24: 'Allgemeinwissen',

    book_create_message1: 'Einen Titel eingeben',
    book_create_message2: 'Einen Autorennamen eingeben',
    book_create_message3: 'Schlüsselwörter eingeben',
    book_create_message4: 'Mehr als 3 Schlüsselwörter eingeben',
    book_create_message5: 'Kategorie auswählen',
    book_create_message6: 'Ein Bild für das Cover erstellen',
    book_create_message7: 'Sie können keine Sonderzeichen eingeben. Ein Leerzeichen zwischen den Schlüsselwörtern ist erforderlich.',
    book_create_message8: 'Möchten Sie das Minibook löschen?',
    book_create_message9: 'Sie haben keine Veröffentlichungsrechte für diese Sprache',
    book_create_message10: 'Ein gekauftes Minibook kann nicht gelöscht werden',
    book_create_modal_text1: 'Bitte warten Sie einen Moment..',
    book_create_modal_text2: 'Die KI überprüft den Inhalt, übersetzt Fremdsprachen und verbindet das Wissensnetzwerk',
    book_create_modal_text3: 'Verbindung zur Wissensdatenbank für seitenweises Suchen',
    book_create_modal_text4: 'Der Titel erscheint nicht auf dem Cover-Bild',
    book_create_modal_text5: '(Dies gilt auch für Cover, die in Fremdsprachen übersetzt wurden)',
    book_view_title: 'Minibook-Übersicht',
    book_view_share: 'Teilen',
    book_view_event_topic: 'Thema der Veranstaltung',
    book_view_together_suggest: 'Veranstaltungsraum vorschlagen',
    book_view_together_message: 'Wenn Sie kein favorisiertes Miteinander haben, <br /> gehen Sie zum Menü Miteinander und wählen Sie eines aus',
    book_view_event_message: 'Es gibt keine Ereignisse, die ich erstellt habe',
    book_view_text1: 'Es wurden noch keine Seiten hinzugefügt.',
    book_view_text2: 'Warum fügen Sie sie nicht jetzt hinzu.',
    book_view_text3: 'Das Minibook existiert nicht. Bitte versuchen Sie es erneut.',
    book_view_text4: 'Tabellenansicht',
    book_view_text5: 'Wie wäre es, die Übersetzung dieses Minibuchs zu verbessern oder es zu bewerben und die Einnahmen zu teilen?',
    book_view_text6: 'Seitenliste',
    book_view_text7: 'Preisänderung',
    book_view_text8: 'Änderung nicht möglich, da bereits ein Käufer vorhanden ist',
    book_view_text9: 'Geschenk vom Leser',
    book_view_text10: 'Nur der Autor des Minibooks kann auf Nachrichten antworten',
    book_view_modal_title: 'Übersetzungsverbesserung & Werbung',
    book_view_modal_text1: 'Können Sie die Übersetzung dieses Minibooks selbst verbessern? Oder es bewerben?',
    book_view_modal_text2: 'Hinterlassen Sie eine Nachricht für den Autor',
    book_view_modal_text3: 'Wenn der Autor zustimmt, können Sie die Einnahmen teilen',

    book_view_write_share_title: 'Offenes Minibook',
    book_view_write_share_text1: 'Möchtest du Co-Autor dieses Minibooks werden?',
    book_view_write_share_text2: 'Autor beantragen',
    book_view_write_share_text3: 'Hinterlasse eine einfache Anfrage',
    book_view_write_share_text4: 'Senden',
    book_view_write_share_list_title: 'Mitautoren',
    book_view_write_share_text5: 'Verwalte die Co-Autoren des Minibooks',
    book_view_write_share_text6: 'Autoren verwalten',
    book_view_write_share_text7: 'Akzeptieren',
    book_view_write_share_text8: 'Akzeptiert',
    book_view_write_share_text9: 'Der Benutzer ist bereits als Autor registriert',
    book_view_write_share_text10: 'Autor manuell hinzufügen',
    book_view_write_share_text11: 'Benutzer hat sich bereits beworben',
    book_view_publish_text1: 'Möchten Sie dieses Minibook veröffentlichen?',
    book_view_publish_text2: 'Wenn Sie es veröffentlichen, ist es für jeden zugänglich und Sie können sogar Geld damit verdienen.',
    book_view_publish_text3: '(Wenn Sie es zum Verkauf veröffentlichen, können Sie andere Seiten des Autors nicht einbeziehen)',
    book_view_publish_text4: 'Legen Sie einen Preis fest',
    book_view_publish_text5: 'Datum der Veröffentlichung',
    book_view_publish_text6: 'Veröffentlichung anfragen',
    book_view_publish_text7: 'Blitzveröffentlichung',
    book_view_publish_text8: 'Reservierung',
    book_view_publish_text9: 'Noch nicht veröffentlicht',
    book_view_publish_text10: 'In Arbeit',
    book_view_publish_text11: 'Veröffentlicht',
    book_view_publish_text12: 'Was beim Veröffentlichen zu beachten ist',
    book_view_publish_text13: 'Dieses Minibook ist noch nie in YouBook veröffentlicht worden',
    book_view_publish_text14: 'Dieses Minibook und seine Seiten haben keine Inhalte oder anderes geistiges Eigentum von anderen gestohlen',
    book_view_publish_text15: 'Dieses minibook enthält keine vulgäre Sprache, übermäßige sexuelle Inhalte, Verleumdungen anderer Personen oder Werbung und entspricht Artikel 2, Absatz 1 der Nutzungsbedingungen',
    book_view_publish_text16: 'Ja',
    book_view_publish_text17: 'Bericht über die Veröffentlichung',
    book_view_publish_text18: 'Veröffentlicht',
    book_view_publish_text19: 'Datum',
    book_view_publish_text20: 'Preis',
    book_view_publish_text21: 'Festlegung der offenen Periode',
    book_view_publish_text22: 'Offene Periode',
    book_view_publish_text23: 'Was ist eine offene Periode',
    book_view_publish_text24: 'Die offene Periode bezieht sich auf den Zeitraum, in dem die Leser den Inhalt einsehen können',
    book_view_publish_text25: 'Dieses minibook enthält mehr als 3 Seiten',
    book_view_publish_text26: 'Dieses minibook enthält nicht mehr als 3 Seiten',
    book_view_publish_text27: 'Bei Verstößen kann der Algorithmus das Suchranking anpassen. Bei schwerwiegenden Problemen wird das minibook automatisch gelöscht',
    book_view_publish_text28: 'Verkaufsoptionen festlegen',
    book_view_publish_text29: 'Kaufmethode',
    book_view_publish_text30: 'Unterstützungsmethode',
    book_view_publish_message1: 'Wenn Sie für den Verkauf veröffentlichen, stellen Sie sicher, dass 1) die Seiten in Ihrem Minibook von Ihnen erstellt wurden und 2) Sie sie nicht zuvor gegen eine Gebühr woanders veröffentlicht haben',
    book_view_publish_message2: 'Es befindet sich nicht in einem veröffentlichungsfähigen Zustand. Bitte wenden Sie sich an den Administrator, um Hilfe zu erhalten.',
    book_view_publish_message3: 'Dieses Minibook wurde bereits veröffentlicht',
    book_view_publish_message4: 'Bitte wählen Sie die offene Periode nach der aktuellen Zeit aus',
    book_view_publish_message5: 'Bitte wählen Sie sowohl Datum als auch Uhrzeit',
    book_view_publish_message6: 'Die Veröffentlichung wurde genehmigt. Dankeschön',
    book_view_publish_message7: 'Bitte überprüfen Sie die Bestätigungsangaben',
    book_view_publish_message8: 'Das Enddatum kann nicht vor dem Startdatum liegen',
    book_view_publish_message9: 'Ein temporär gespeichertes Minibook kann nicht veröffentlicht werden',
    book_view_publish_message10: 'Dieses Minibook wurde übertragen. Das ursprüngliche Veröffentlichungsrecht gehört dem Autor.',
    book_view_publish_message11: 'Bitte geben Sie einen Betrag von mindestens {minPrice} ein',
    book_view_button_confirm: 'Bestätigt',
    book_view_button_publish: 'Veröffentlichen',
    book_view_button_order: 'Seitenausrichtung',
    book_view_button_add: 'Eine Seite hinzufügen',
    book_view_button_video: 'Abspielen',
    book_view_button_read: 'Lesen',
    book_view_button_lecture: 'Vortragsvideo ansehen',
    book_view_page_add_title: 'Seite hinzufügen',
    book_view_page_add_text1: 'Nach der Suche nach einer Seite von Dritter',
    book_view_page_add_text2: 'Auf dem Bildschirm Seite anzeigen',
    book_view_page_add_text3: 'In mein Minibook eintragen',
    book_view_page_add_text4: 'Was, wenn Sie Ihre eigene Seite erstellen möchten?',
    book_view_page_add_text5: 'Das Erstellen von Seiten ist nur für registrierte Autoren möglich.  Wenn Sie sich als Autor registrieren möchten, kontaktieren Sie uns bitte unten.',
    book_view_page_add_text6: 'Möchtest du eine Seite von Dritter hinzufügen?',
    book_view_page_add_text7: '* Wenn du eine Seite von Dritter hinzufügst, \nkann sie nicht als kostenpflichtiges Minibook veröffentlicht werden',
    book_view_page_add_text8: 'Hast du zuvor Seiten erstellt?',
    book_view_page_add_button1: 'Jetzt erstellen',
    book_view_page_add_button2: 'Erstellte Seiten anzeigen',
    book_view_reference_text1: 'Vielfalt',
    book_view_reference_text2: 'Mehrere',
    book_view_reference_text3: 'Minibook-Autor',
    book_view_reference_text4: 'Erstellt vom Autor',
    book_view_support_text1: 'Ich unterstütze dich',
    book_view_support_modal_title: 'Werde ein Unterstützer',
    book_view_support_modal_text1: 'Selbst guter Text verbreitet sich nicht allein in der Welt.',
    book_view_support_modal_text2: 'Ein Unterstützer ist jemand, der das Minibook des Autors mit der Welt teilt und andere unterstützt.',
    book_view_support_modal_text3: 'Gemeinsam bringen wir die Geschichte weiter hinaus.',
    book_view_support_modal_text4: 'Bitte unterstütze den Autor',
    book_view_support_modal_btn1: 'Verstanden',
    book_view_support_modal_text5: '"Deine Unterstützung bedeutet mir viel. Danke. Ich unterstütze auch deine Reise von Herzen."',
    book_view_support_modal_text6: 'Bitte teile das Minibook mit der Welt',
    book_view_support_modal_btn2: 'Wie geht das?',
    book_view_support_modal_title2: 'Bis hierhin geschafft – gut gemacht',
    book_view_support_modal_text7: 'Es war nicht einfach zu schreiben, aber ich habe es geschafft.',
    book_view_support_modal_text8: 'Jetzt ist es an der Zeit, an mich selbst zu glauben und einen weiteren Schritt zu gehen.',
    book_view_support_modal_text9: 'Auch wenn ich mich schäme oder zögere, bin ich mein erster Unterstützer und öffne mich der Welt.',
    book_view_support_modal_text10: 'Weil ich glaube, dass es für jemanden eine Bedeutung haben kann.',
    book_view_support_modal_text11: 'Bitte werde mein Unterstützer',
    book_view_support_modal_text12: 'Schreiben oder ein Event zu veranstalten war nicht einfach, aber ich habe es gewagt.',
    book_view_support_modal_btn3: 'Ich versuche es!',
    book_view_support_modal_title3: 'Hallo, Unterstützer',
    book_view_open_minibook_text1: 'Die Anfrage für das offene Minibook wurde abgeschlossen',
    book_view_open_minibook_text2: 'Die Anfrage für das offene Minibook wurde storniert',
    page_create_title: 'Seite erstellen',
    page_create_text1: 'Bild für Seite nicht vorhanden',
    page_create_text2: '',
    page_create_text3: 'Seite',
    page_create_text4: 'Du hast ein Bild für Seite erstellt',
    page_create_text5: 'Haben Sie ein eigenes Seitenbild erstellt?',
    page_create_text6: 'Geben Sie Ihren Inhalt ein. Es wird empfohlen, nicht mehr als ein A4-Blatt zu verwenden.',
    page_create_text7: 'Aktuelle Bytes',
    page_create_text8: 'Empfohlen',
    page_create_text9: 'Gibt es Empfehlungen zu dieser Seite?',
    page_create_text10: 'Von Ihnen erstellt',
    page_create_text11: 'Auf Buch verwiesen',
    page_create_text12: 'Verweist auf Blog',
    page_create_text13: 'KI wurde herangezogen',
    page_create_text14: 'Dies ist der Schritt, um Seiten für das Minibook zu erstellen',
    page_create_text15: 'Seite-Bild hochladen',
    page_create_text16: 'Möchten Sie erneut übersetzen?',
    page_create_text17: 'Wenn Sie eine erneute Übersetzung wünschen, wählen Sie bitte das Ziel und die Sprache aus (wenn nicht ausgewählt, wird es ohne Übersetzung gespeichert)',
    page_create_text18: 'Übersetzungsziel',
    page_create_text19: 'Übersetzungssprache',
    page_create_message1: 'Es kann nicht geändert werden',
    page_create_message2: 'Geben Sie Ihren Inhalt ein',
    page_create_message3: 'Möchten Sie die Seite löschen?',
    page_create_message4: 'Der Inhalt überschreitet die maximale Größe',
    page_create_reference_book: 'Buch',
    page_create_reference_blog: 'Blog',
    page_create_reference_placeholder1: 'Geben Sie den Titel des',
    page_create_reference_placeholder2: 'Zugehöriger Link (z.B. https://www.amazon.com/dp...)',
    page_create_reference_placeholder3: 'Erscheinungsjahr des',
    page_create_reference_placeholder4: 'Autor des',
    page_create_title_placeholder: 'Der Titel wird wie folgt aussehen',
    page_create_message5: 'Übersetzung in Arbeit',
    page_create_message6: 'Nachdem Sie das Cover erstellt haben, können Sie eine Seite erstellen',
    page_create_modal_text1: 'Der Titel erscheint nicht auf dem Seitenbild',
    page_create_modal_text2: '(Dies gilt auch für Seiten, die in Fremdsprachen übersetzt wurden)',
    page_create_modal_text3: 'Bitte unbedingt überprüfen!',
    page_create_modal_text4: 'Falls sich der Inhalt geändert hat, müssen Sie temporäre Speicherung durchführen.',
    page_create_modal_text5: 'Haben Sie das getan?',
    page_create_modal_text6: 'Falls sich der Inhalt geändert hat, müssen Sie Erstellen.',

    page_view_title: 'Seite ansehen',
    page_view_button_video: 'Abspielen',
    page_view_button_read: 'Lesen',
    page_view_text1: 'Meinem Minibook hinzufügen',
    page_view_text2: 'Automatisch abspielen',
    page_view_text3: 'Gelesen',
    page_view_text4: 'Verwandte Seite',
    page_view_text5: 'Zugehöriges Minibook',
    page_view_text6: 'Empfehlungen',
    page_view_text7: 'Empfehlungen',
    page_view_text8: 'Veröffentlichung',
    page_view_text9: 'Autor',
    page_view_text10: 'Titel',
    page_view_text11: 'Alle Seiten dieser Empfehlung',
    page_view_text12: 'Verwandte Suche',
    page_view_text13: 'Seite des Autors',
    page_view_text14: 'Autor treffen',
    page_view_text15: 'Einstellen',
    page_view_reference_text1: 'Buch',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'Sie haben noch keine Minibooks erstellt.  Bitte erstellen Sie eines auf Ihrer MY Seite.',
    page_view_pay_popup_text1: 'Hat Ihnen das Lesen etwas gebracht? \nZeigen Sie Ihre Wertschätzung mit einem kleinen Geschenk an den Autor.',
    page_view_pay_popup_title: 'Geschenk senden',
    page_view_pay_popup_text2: 'Wählen Sie einen Tee als Geschenk aus',
    page_view_pay_popup_text3: 'Schreiben Sie eine herzliche Nachricht',
    page_view_pay_popup_placeholder1: 'Die Worte und Weisheit des Autors haben mir wirklich geholfen.',
    page_view_pay_popup_text4: 'Betrag',
    page_view_pay_popup_button1: 'Kaufen und Nachricht senden',
    page_view_pay_popup_text5: 'Der Autor hat viel Zeit und Mühe in diesen Text investiert.\n\nBitte antworten Sie mit einem kleinen Geschenk.',
    page_view_pay_popup_placeholder2: 'Ich vertraue auf die Weisheit und Erfahrung des Autors.',
    page_view_pay_popup_text6: 'Möchten Sie kein Geschenk senden?',
    page_view_pay_popup_text7: 'Lieber eine Anzeige ansehen?',
    page_view_pay_popup_button2: 'Anzeige ansehen, um zu lesen',
    page_sort_title: 'Seitenausrichtung',
    page_sort_subtitle: 'Ziehen Sie die Seite, um die Reihenfolge zu ändern',
    page_sort_text: 'Quelle',
    pay_button: 'Jetzt kaufen',
    pay_price: 'Preis',
    pay_vat_excluded: '(ohne Mehrwertsteuer)',
    pay_message_success: 'Gekauft',
    pay_message_fail: 'Fehlgeschlagen',
    pay_currency: 'EUR',
    pay_button_paid: 'Bezahlt',
    pay_button_view_price: 'Preis anzeigen',
    pay_total: 'Gesamt',
    pay_methods: 'Zahlungsarten',
    pay_methods_creditcard: 'Kreditkarte',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Weiter',
    pay_text1: 'Bitte wählen Sie einen Tee',
    pay_text2: 'Bitte geben Sie eine Nachricht ein',
    advertisement_button: 'Mehr lesen',
    advertisement_text1: 'Du kannst den Inhalt ansehen, nachdem du die Werbung angeschaut hast',
    advertisement_text2: 'Dies ist eine Seite aus einem kostenpflichtigen Minibuch. <br />Gehen Sie zur Titelseite und tippen Sie auf Lesen, um zu kaufen. <br />',
    advertisement_text3: 'Du kannst den Inhalt ansehen, nachdem du die Werbung angeschaut hast. Die Werbung kann nur in der App angesehen werden.',
    together_title: 'Ereignis',
    together_subtitle: 'Treffe Leser und sprich mit ihnen',
    together_subtitle_text1: 'Treffe Leser online',
    together_subtitle_text2: 'Schaffen Sie einen Raum und laden Sie Leute ein',
    together_button: 'Veranstaltungsraum erstellen',
    together_case: 'Beispiel',
    together_case1: 'Ich versuche etwas, aber es wird immer falsch verstanden',
    together_case2: 'Ich habe noch nie ein so hilfreiches Beispiel erlebt',
    together_subtitle2: 'Erstellter Raum',
    together_category1: 'Neueste',
    together_category2: 'Am meisten favorisiert',
    together_button_viewmore: 'Mehr',
    together_list_date: 'DD.MM.YYYY',
    together_list_date2: 'DD.MM.YYYY A hh:mm',
    together_subtitle3: 'So ein Raum',
    together_subtitle3_1: 'Bitte erstellen',
    together_subtitle_text3: 'Wer auch immer anfängt, ich werde teilnehmen',
    together_create_title: 'Veranstaltungsraum erstellen',
    together_create_title2: 'Veranstaltungsraum bearbeiten',
    together_create_button1: 'Auswählen',
    together_create_subtitle: 'Titel',
    together_create_placeholder1: 'Einen Titel eingeben',
    together_create_subtitle1: 'Kurze Einführung',
    together_create_placeholder2: 'Eine kurze Einführung eingeben',
    together_create_subtitle2: 'Wählen Sie das zu verwendende Werkzeug',
    together_create_text1: 'Online-Meeting-Link (z. B. Zoom-Link)',
    together_create_placeholder3: 'Bitte geben Sie den Online-Meeting-Link ein',
    together_create_question1: 'Kennen Sie den Zoom-Link nicht?',
    together_create_q1_a_title: 'Finden Sie einen Link, um Zoom beizutreten',
    together_create_text2: 'Metaversum verwenden',
    together_create_placeholder4: 'Wählen Sie das passende Miteinander',
    together_create_question2: 'Kennen Sie das Metaversum nicht?',
    together_create_text3: 'Wählen Sie den Ort der Eröffnung',
    together_create_dropmenu1: 'In der YB-Ecke für Intellektuelle öffnen',
    together_create_dropmenu2: 'Öffnen Sie in der Autoren- und Leseecke',
    together_create_button2: 'Speichern',
    together_create_button3: 'Erstellen',
    together_create_popup_title: 'Wählen Sie das passende Miteinander',
    together_create_popup_alert: 'Bereits ausgewählt',
    together_create_button4: 'Wählen Sie',
    together_create_alert: 'Bitte geben Sie den Link für das Online-Meeting ein',
    together_create_alert1: 'Einen Titel eingeben',
    together_create_alert2: 'Wählen Sie das zu verwendende Metaversum',
    together_create_alert3: 'Bearbeiten',
    together_create_alert4: 'Veranstaltungsraum wurde erstellt',
    together_create_alert5: 'Fehler. Bitte versuchen Sie es erneut',
    together_create_alert6: 'Erstellen des Veranstaltungsraums fehlgeschlagen...',
    together_qa_popup_title1: 'Finden Sie einen Link, um Zoom beizutreten',
    together_qa_popup_btext1: 'Computer',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Öffnen Sie Zoom, nach dem Einloggen - Klicken Sie oben auf das Meeting-Menü - Meine persönliche Meeting-ID - Klicken Sie auf Meeting-Einladung anzeigen - Ein Link zum Beitritt zum Zoom-Meeting wird angezeigt. Kopieren Sie diesen.',
    together_qa_popup_btext2: 'Smartphone',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Öffnen Sie Zoom, nach dem Einloggen - Drücken Sie die i-Taste oben rechts - Einladung senden - Nach dem Drücken der Nachricht - Geben Sie Ihre Telefonnummer ein - Ein Link wird angezeigt. Kopieren Sie diesen.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'Was ist das Metaversum?',
    together_qa_popup_text3: 'Dies ist ein virtueller Begegnungsraum.',
    together_qa_popup_text4: 'Sie erscheinen in Form eines Avatars',
    together_qa_popup_text5: 'Sie können mit Ihren Freunden von Angesicht zu Angesicht sprechen - Sie können auch Ihren Bildschirm teilen.',
    together_qa_popup_text7: 'In einem Begegnungsraum',
    together_qa_popup_text8: '- 10 Personen können gleichzeitig teilnehmen.',
    together_qa_popup_text9: 'Sie müsssen kein separates Programm installieren',
    together_qa_popup_text10: 'Auch eine Registrierung für die Mitgliedschaft ist nicht erforderlich.',
    together_more_list_title: 'Veranstaltungsraum',
    together_more_list_date: 'DD.MM.YYYY',
    together_request_list_title: 'Bitte erstellen',
    together_request_list_category1: 'Am meisten favorisiert',
    together_request_list_category2: 'Letzte',
    together_request_list_button: 'Neuen Raum vorschlagen',
    together_request_popup_title: 'Vorschlag für neuen Raum',
    together_request_popup_alert1: 'Einen Titel eingeben',
    together_request_popup_alert2: 'Eine kurze Einführung eingeben',
    together_request_popup_placeholder1: 'Titel eingeben',
    together_request_popup_placeholder2: 'Eine kurze Einführung eingeben',
    together_request_popup_button: 'Speichern',
    together_request_detail_button: 'Diesen Raum erstellen',
    together_detail_sns: 'Teilen',
    together_detail_enterbtn: 'Eingeben',
    together_detail_btn1: 'Veranstaltungsliste',
    together_detail_btn2: 'Nachrichten',
    together_detail_subtitle: 'Minibook zum Thema',
    together_detail_alert: 'Warten Sie einen Moment...',
    together_detail_alert1: 'Veranstaltungsraum erfolgreich vorgeschlagen!',
    together_detail_alert2: 'Vorschlag für Veranstaltungsraum fehlgeschlagen…',
    together_detail_alert3: 'Favorit / Erfolgreich gelöschter Favorit',
    together_detail_alert4: 'Favorit / Favorit konnte nicht gelöscht werden',
    together_detail_alert5: 'Problem mit dem Server, bitte versuchen Sie es später',
    together_detail_alert6: 'Es gibt ein Problem mit dem Online-Meeting-Link',
    together_detail_alert7: 'Löschen fehlgeschlagen',
    together_notice_alert: 'Möchten Sie die Ankündigung löschen?',
    together_notice_list_title: 'Ankündigung',
    together_button_addtopic: 'Als Thema zu diesem Veranstaltungsraum hinzufügen',
    together_add_alert: 'Zum Veranstaltungsraum hinzugefügt',
    together_text1: 'Ähnliche Vorlieben wie Sie',
    together_text2: 'Möchtest du diesen Veranstaltungsraum löschen?',
    together_event_btn: 'Neues Ereignis erstellen',
    together_event_title: 'Neues Ereignis',
    together_event_placeholder: 'Bitte geben Sie eine Beschreibung ein',
    together_event_text1: 'Legen Sie den Zeitplan fest',
    together_event_text2: 'Legen Sie die Eintrittsgebühr fest',
    together_event_text3: 'Legen Sie die Maximalzahl fest',
    together_event_text4: 'Zeitplan',
    together_event_text5: 'Eintrittsgebühr',
    together_event_text6: 'Maximale Personenanzahl',
    together_event_text7: 'Meine Follower benachrichtigen',
    together_event_text8: 'Möchten Sie das Ereignis löschen?',
    together_event_text9: 'Bitte setzen Sie die Startzeit nach der aktuellen Zeit',
    together_event_text10: 'Bitte setzen Sie die Endzeit nach der Startzeit',
    together_event_text11: 'Die Startzeit und die Endzeit dürfen nicht gleich sein',
    together_event_text12: 'Dies als Veranstaltungsthema hinzufügen',
    together_event_text13: 'Zum Ereignis hinzugefügt',
    together_event_text14: 'Die maximale Teilnehmerzahl der Veranstaltung wurde überschritten',
    together_event_text15: 'Schaltfläche wird eine Stunde vor dem Ereignis aktiviert \n(bei kostenlos kein Jetzt kaufen nötig)',
    together_event_text16: 'Schaltfläche wird eine Stunde vor dem Ereignis aktiviert',
    together_event_text17: 'Es gibt kein Ereignis',
    together_event_text18: 'Kann nicht gelöscht werden, wenn es einen Käufer für das Ereignis gibt',
    together_event_text19: 'Möchten Sie eine Benachrichtigung senden?',
    together_event_text20: 'Gesendet',
    together_event_text21: 'Ereignisliste',
    together_event_text22: 'Details anzeigen',
    together_event_text23: 'Nach Registrieren Sie sich bitte anmelden',
    together_event_text24: 'Teilnahmemethode',
    together_event_text25: 'Teilnahme am Ereignis abgeschlossen',
    together_event_text26: 'Der Autor hat viel Zeit und Sorgfalt in dieses Ereignis investiert.\n\nBitte antworten Sie mit einem kleinen Geschenk.',
    together_event_text27: 'Die Weisheit aus der Erfahrung des Autors und die tiefe Kommunikation waren beeindruckend',
    together_event_text28: 'Teile dieses Ereignis mit der Welt',
    together_event_text29: 'Es war nicht einfach, dieses Ereignis zu starten, aber ich habe es geschafft.',
    together_event_text30: 'Egal wie gut ein Ereignis ist, allein lässt es sich schwer in die Welt tragen.',
    together_event_text31: 'Ein Unterstützer ist jemand, der das Ereignis des Autors in die Welt trägt. Jemand, der andere unterstützt.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Treffen Sie Menschen aus der ganzen Welt',
    youbooker_case: 'YouBookers Gedanken',
    youbooker_case_text1: 'Derjenige sein, der immer anfängt',
    youbooker_case_text2: 'Zinseszins-Effekt von Wissen?',
    youbooker_translation: 'Möchtest du jetzt sofort treffen?',
    youbooker_translation_text1: 'Alle Sprachen',
    youbooker_category: 'Follower / Gefolgt',
    youbooker_subcategory1: 'Meine Follower',
    youbooker_subcategory2: 'Ich folge',
    youbooker_subtitle2: 'Wer mir folgt',
    youbooker_button_follow: 'Folgen',
    youbooker_message_follow: 'Folgen',
    youbooker_button_follow_cancel: 'Entfolgen',
    youbooker_subtitle3: 'Diese Benutzer kennen Sie',
    youbooker_subtitle4: 'Ich folge ihnen',
    youbooker_subtitle5: 'Wer YB noch nicht kennt',
    youbooker_button_invite: 'Einladen',
    youbooker_alert_invite: 'Einladen ist nur über die App möglich, bitte laden Sie die App herunter.',
    youbooker_alert: 'Nur in der App. Warum nicht die App herunterladen?',
    youbooker_alert2: 'Aktualisieren gelungen!',
    youbooker_alert3: 'Sie können auf dem YouBooker-Tab suchen',
    home_page_text1: 'Neueste',
    home_page_text2: 'Einfluss',
    home_page_today_title: 'Heutiges Thema',
    home_page_today_subtitle: 'Verbunden mit TOP Nachrichten',
    home_page_slider_date: 'DD.MM.YYYY',
    home_page_today_list_title: 'Heutiges Thema',
    home_page_today_detail_sns: 'Teilen',
    home_page_today_detail_date: 'DD.MM.YYYY',
    home_page_today_detail_subtitle: 'Verwandte Seiten',
    home_page_explor_title: 'Seite erforschen',
    home_page_explor_subtitle: 'Was ist, wenn man doppelt klickt?',
    home_page_recommend_title: 'Empfehlungen',
    home_page_recommend_subtitle: 'Seiten, die Sie interessieren könnten',
    home_page_theysee_title: 'Was sehen Sie',
    home_page_theysee_subtitle: 'Seiten, die Leser am häufigsten sehen',
    home_page_common_title: 'Gesunder Menschenverstand',
    home_page_common_subtitle: 'Das sollten Sie lieber wissen',
    home_page_keyw_title: 'Seiten nach Schlüsselwörtern',
    home_page_keyw_subtitle: 'Alle verwandten Seiten finden',
    home_page_random_title: 'Zufällige Suche',
    home_page_random_subtitle: 'Klicken Sie hier, wenn Sie noch unschlüsslig sind und erfahren so etwas Neues',
    home_page_about_title: 'Über YouBook',
    home_page_about_detail: 'Korporation: NICK syndicate / Deutscher Geschäftssitz: Frankfurt / Andere Länderzentren: Tokio, Shanghai, Seattle, Seoul / Kontakt: joa@academy-connect.net/DUNS 695937905',
    settlement_title: 'Kauf & Abrechnung',
    settlement_tab1: 'Datensatz bestellen',
    settlement_tab2: 'Konto-Informationen',
    settlement_tab3: 'Abrechnungsdatensatz',
    settlement_category1: 'Meine Kaufhistorie',
    settlement_category2: 'Geteiltes Autorenrecht',
    settlement_category3: 'Abrechnung der Minibook-Einnahmen',
    settlement_category4: 'Abrechnung der Ereignis-Einnahmen',
    settlement_category5: 'Kontoverwaltung',
    settlement_text1: 'Ihre Kaufhistorie wird angezeigt',
    settlement_text2: 'Sie können das Autorenrecht des Minibooks teilen',
    settlement_text3: 'Sie prüfen die Abrechnung Ihres bezahlten Minibooks.',
    settlement_text4: 'Falls Sie weitere Fragen haben, klicken Sie',
    settlement_text5: 'hier',
    settlement_text6: 'Oder kontaktieren Sie uns bitte unten.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Sagen Sie ein Wort',
    settlement_text9: 'Wenn Sie Einnahmen haben, müssen Sie Ihr Konto für die Auszahlung verwalten',
    settlement_text10: 'Die Einnahmen aus dem Ereignis werden abgerechnet',
    settlement_purchase_text1: 'Kaufhistorie',
    settlement_purchase_text2: 'Datum',
    settlement_purchase_text3: 'Kaufbetrag',
    settlement_purchase_text4: 'Titel',
    settlement_purchase_text5: 'Minibook',
    settlement_purchase_text6: 'Ereignis',
    settlement_accountInfo_text1: 'Autorenrecht des Minibooks',
    settlement_accountInfo_text2: 'Minibook',
    settlement_accountInfo_text3: 'Sprache',
    settlement_accountInfo_text4: 'Autorenrecht',
    settlement_accountInfo_text5: 'Autor',
    settlement_accountInfo_text6: 'Dritter',
    settlement_accountInfo_text7: 'Persönlich?',
    settlement_accountInfo_text8: 'Persönlich',
    settlement_accountInfo_text9: 'Korporation',
    settlement_accountInfo_text10: 'Name der Bank',
    settlement_accountInfo_text10_message: 'Wählen Sie einen Banknamen',
    settlement_accountInfo_text11: 'Name des Kontoinhabers',
    settlement_accountInfo_text11_message: 'Name des Kontoinhabers eingeben',
    settlement_accountInfo_text12: 'Kontonummer',
    settlement_accountInfo_text12_message: 'Eine Kontonummer eingeben',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Sozialversicherungsnummer',
    settlement_accountInfo_text13_message: 'Eine Sozialversicherungsnummer eingeben',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Persönliche Adresse',
    settlement_accountInfo_text14_message: 'Persönliche Adresse eingeben',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'E-Mail',
    settlement_accountInfo_text15_message: 'Eine E-Mail eingeben',
    settlement_accountInfo_text16: 'Speichern',
    settlement_accountInfo_text17: 'Identifikationsnummer des Arbeitgebers(IDN)',
    settlement_accountInfo_text17_message: 'IDN-Nummer eingeben',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Adresse der Korporation(en)',
    settlement_accountInfo_text18_message: 'Adresse der Korporation eingeben',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'Name der Korporation',
    settlement_accountInfo_text19_message: 'Name der Korporation eingeben',
    settlement_accountInfo_text20: 'Telefon der Korporation',
    settlement_accountInfo_text20_message: 'Kontakte der Korporation eingeben',
    settlement_accountInfo_text21: 'ID der dritten Partei',
    settlement_accountInfo_text21_placeholder: 'E-Mail des Drittanbieters',
    settlement_accountInfo_text22: 'Konto für den Zahlungseingang',
    settlement_accountInfo_text23: 'Land',
    settlement_accountInfo_message1: 'E-Mail kann nicht gefunden werden',
    settlement_accountInfo_message2: 'Sie können das Autorenrecht nicht mit sich selbst teilen',
    settlement_accountInfo_message3: 'Es sind keine Minibooks erstellt',
    settlement_accountInfo_text24: 'Geteiltes Autorenrecht',
    settlement_accountInfo_text25: 'Wenn Sie das Autorenrecht an einen Dritten übertragen, kann es nicht zurückgenommen werden',
    settlement_accountInfo_text26: 'Möchten Sie das Autorenrecht teilen?',
    settlement_accountInfo_text27: 'Ja, ich teile es',
    settlement_accountInfo_text28: 'Beim Teilen des Autorenrechts gilt: <br />1) Die Seiten im Minibook müssen von Ihnen erstellt worden sein und <br /> 2) dürfen noch nicht an Dritte weitergegeben worden sein',
    settlement_accountInfo_text29: 'OK Ich werde es korrigieren',
    settlement_accountInfo_text30: 'Sie haben das Autorenrecht dieses Minibooks an einen Dritten weitergegeben',
    settlement_accountInfo_text31: 'Autor',
    settlement_accountInfo_text32: 'Dritter',
    settlement_accountInfo_text33: 'Sie haben das Autorenrecht dieses Minibooks vom Autor erhalten',
    settlement_accountInfo_text34: 'Dies ist ein kostenloses Minibook. Kein Konto erforderlich.',
    settlement_accountInfo_text35: 'Einnahmebeteiligung',
    settlement_accountInfo_text36: '(me)',
    settlement_accountInfo_text37: '(Verlage, etc.)',
    settlement_accountInfo_text38: 'Persönliches Konto',
    settlement_accountInfo_text39: 'Körperschaftskonto',
    settlement_accountInfo_text40: 'Verwaltung des Kontos',
    settlement_accountInfo_text41: 'Speichern',
    settlement_accountInfo_text42: 'Bank',
    settlement_accountInfo_text43: 'Kontenauswahl',
    settlement_accountInfo_text44: 'Festlegen, wie die Einnahmen aufgeteilt werden',
    settlement_accountInfo_text45: 'Einnahmen-Rate (%) (%)',
    settlement_accountInfo_text46: 'Meine ID (email)',
    settlement_accountInfo_text47: 'Dritter ID (email)',
    settlement_accountInfo_text48: 'Gesamtzahl abgleichen',
    settlement_accountInfo_text49: 'Bitte geben Sie die Zessionar-Informationen ein',
    settlement_accountInfo_text50: 'Die Einnahmen-Rate darf 100 nicht überschreiten',
    settlement_accountInfo_text51: 'Zedent ID(email)',
    settlement_accountInfo_text52: 'Zessionar ID(email)',
    settlement_earnings_text1: 'Verrechnungssatz',
    settlement_earnings_text2: 'Abrechnungszeitraum',
    settlement_earnings_text3: 'Preis des Minibooks',
    settlement_earnings_text4: 'Verkaufsmenge',
    settlement_earnings_text5: 'Verkaufsbetrag',
    settlement_earnings_text6: 'Abzüge einschließlich Steuern',
    settlement_earnings_text7: 'Einzahlungsbetrag',
    settlement_earnings_text8: 'Datum der Einzahlung',
    settlement_earnings_text9: 'Anzeigenaufrufe',
    settlement_earnings_text10: 'Gesamtbetrag',
    settlement_earnings_text11: 'Mehr erfahren',
    settlement_earnings_text12: 'Preis der Anzeige',
    settlement_earnings_text13: 'Einnahmen',
    settlement_earnings_text14: 'Alle Minibücher',
    settlement_earnings_text15: 'Ereignis auswählen',
    settlement_earnings_text16: 'Alle Ereignisse',
    settlement_statistics_text1: 'Verkaufsvolumen',
    settlement_statistics_text2: 'Anzahl der Leser',
    settlement_statistics_text3: '(Letzter)',
    settlement_statistics_text4: '1 Monat',
    settlement_statistics_text5: '6 Monate',
    settlement_statistics_text6: '1 Jahr',
    settlement_statistics_text7: 'Keine Daten gefunden',
    settlement_statistics_text8: 'Verkaufsanalyse',
    settlement_statistics_text9: 'Anzahl der Werbeaufrufe',
    settlement_statistics_text10: 'Alle Sprachen',
    terms_title: 'Bedingungen der Dienstleistung',
    terms_text: '',
    privacy_title: 'Datenschutzbestimmungen',
    privacy_text: '',
    // common text
    message_save: 'Gespeichert',
    message_fail: 'Gescheitert',
    message_delete: 'Gelöscht',
    message_report: 'Gemeldet',
    message_search_no_result: 'Keine Suchergebnisse gefunden',
    message_search_enter: 'Bitte geben Sie einen Suchbegriff ein',
    message_error1: 'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator',
    message_save2: 'Gespeichert',
    message_fail2: 'Fehlgeschlagen',
    message_login: 'Sie müssen sich einloggen',
    name: 'Name',
    email: 'E-Mail',
    mobile: 'Handy',
    list: 'Liste',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    search: 'Suche',
    report: 'Inhalt melden',
    user: 'Benutzer',
    report_type: 'Art der Meldung',
    report_type1: 'Beleidigung/ Verleumdung',
    report_type2: 'Werbung',
    report_type3: 'Obszönität/Sexuell explizit',
    report_type4: 'Wiederholung desselben Inhalts',
    report_type5: 'Andere',
    search_book: 'Minibook suchen',
    serch_placeholder: 'Suche nach Name oder E-Mail',
    search_keyword: 'Schlüsselwort',
    search_reference: 'Empfehlungen',
    search_author: 'Autor',
    search_result: 'Gefunden',
    button_report: 'An YouBook melden',
    button_write: 'Speichern',
    button_login: 'EINLOGGEN',
    button_more: 'Mehr',
    button_confirm: 'Bestätigt',
    button_save: 'Speichern',
    button_crop: 'Zuschneiden',
    button_delete: 'Löschen',
    button_complete: 'vollständig',
    colorbox_background_text1: 'Wählen Sie eine Hintergrundfarbe',
    colorbox_font_text1: 'Wählen Sie eine Textfarbe',
    menu_home: 'Startseite',
    menu_page: 'Seite',
    menu_book: 'Minibook',
    menu_memo: 'Notiz',
    menu_together: 'Ereignis',
    login_button: 'EINLOGGEN',
    message_text1: 'Antworten',
    message_text2: 'Eine Antwort wurde zu meinem Kommentar hinzugefügt',
  },
  fr: {
    home_banner_title1: 'Nouveau minilivre',
    home_banner_title2: 'Nouvel événement',
    home_slide_title1: 'Tendance actuelle',
    home_slide_title2: 'Mon goût',
    home_slide_title3: 'À la une',
    home_slide_title4: 'Très populaire',
    home_detail_title1: 'Souvenirs du quotidien',
    home_detail_title2: 'Vidéos recommandées',
    home_detail_title3: 'Si vous voulez en savoir plus',
    home_detail_text1: 'Note minilivre',
    home_detail_text2: 'Note quotidienne',
    home_setting_title: 'Paramètres',
    home_setting_text1: 'Pages vues au cours des 30 derniers jours',
    home_setting_text2: 'Se déconnecter',
    home_setting_text3: 'Supprimer le compte',
    home_book_banner_question: 'Je suis curieux',
    home_book_banner_write_placeholder1: 'Entrer un titre',
    home_book_banner_write_placeholder2: 'Entrer un message',
    home_book_banner_write_button: 'Sauvegarder',
    home_book_banner_detail_text1: 'Réponse du mentor de YouBook',
    home_book_banner_detail_text2: 'Minilivres associés',

    home_book_create_button: 'Minilivre, créez le vôtre',
    home_book_create_text1: 'Un minilivre est un petit livre d’environ 10 pages. Il est conçu pour répondre à la tendance actuelle de lecture rapide et efficace de contenus courts mais essentiels.',
    home_book_create_text2: 'Comment modifier après publication',
    home_book_create_text3: 'Minilivre, méthode de création facile',
    home_book_create_text4: 'Combien peut gagner un auteur ?',
    home_book_create_text5: 'Comment rencontrer des lecteurs ?',
    home_book_create_text6: '5 raisons d’utiliser YouBook',
    home_book_create_text7: 'D’autres questions ?',
    home_book_create_text8: 'Puis-je suivre les ventes en temps réel ?',
    home_book_create_text9: 'Écrivons avec régularité chaque jour !',
    home_book_create_text10: 'Lancez-vous dès maintenant !',

    home_book_category_title1: 'Actualités du jour et minilivre',
    home_book_category_title2: 'Minilivres populaires',
    home_book_category_title3: 'Minilivres de professeur S-class',
    home_book_category_title4: 'Recommandations personnalisées',
    home_book_category_title5: 'Minilivres essentiels des best-sellers',
    home_book_category_title6: 'Avec Minou Livre',
    home_book_category_title6_text1: 'Afficher',
    home_book_category_title6_text2: 'Réduire',
    home_book_category_title7: 'Explorer les pages du réseau neuronal',
    home_book_category_title8: 'Festival d’art et d’émotion',
    home_book_category_title8_text1: 'Monde du cinéma et des séries',
    home_book_category_title8_text2: 'Mélodies et mouvements émouvants',
    home_book_category_title8_text3: 'L\'art sans frontières',
    home_book_category_title8_text4: 'Exprimer sa personnalité : Mode et Style',
    home_book_category_title9: 'Culture gastronomique et détente',
    home_book_category_title9_text1: 'Exploration culinaire, cuisine locale',
    home_book_category_title9_text2: 'Histoires de boissons et de vie',
    home_book_category_title9_text3: 'Charme des snacks et desserts',
    home_book_category_title9_text4: 'Pouvoir de la nature, secrets des plantes',
    home_book_category_title10: 'Sagesse de vie et découverte de soi',
    home_book_category_title10_text1: 'Méthodes uniques de gestion de l’argent',
    home_book_category_title10_text2: 'Recettes de croissance personnelle',
    home_book_category_title10_text3: 'Problèmes relationnels et solutions',
    home_book_category_title10_text4: 'Nouvelles découvertes et savoirs',
    home_book_category_title11: 'Diversité des valeurs et amour',
    home_book_category_title11_text1: 'Histoires de vie',
    home_book_category_title11_text2: 'Philosophies et valeurs différentes',
    home_book_category_title11_text3: 'Croyances religieuses et traditions',
    home_book_category_title11_text4: 'Mystère de l’amour',
    home_book_category_title12: 'Journée de voyages et loisirs',
    home_book_category_title12_text1: 'Destinations cachées à visiter',
    home_book_category_title12_text2: 'Joie de vivre à travers les loisirs',
    home_book_category_title12_text3: 'Culture unique par le jeu',
    home_book_category_title13: 'Richesse de traditions et d’histoires',
    home_book_category_title13_text1: 'Mythes locaux et histoires de héros',
    home_book_category_title13_text2: 'Voyages littéraires mondiaux',
    home_book_category_title13_text3: 'Histoire et sagesse des lieux',
    home_book_category_title13_text4: 'Histoires sociales variées',

    home_book_category_title1_text2: 'Les pensées de Minou Livre – Tu veux jeter un coup d\'œil ?',
    home_book_category_title1_text3: 'Des soucis ? Des questions ?',
    home_book_category_title1_text4: 'Souhaitez-vous une recommandation de minilivre ?',
    home_book_search_placeholder1: 'Parlez ici',
    home_book_search_placeholder2: 'Quel est le mot-clé ?',

    home_book_search_message1: 'Entrez vos questions',
    home_book_search_message2: 'Entrez à nouveau vos questions',
    home_book_search_text1: 'Pourquoi ne pas discuter avec moi ?',
    home_book_search_text2: 'Contactez-moi',
    home_book_search_text3: 'Demander',
    home_book_search_text4: 'Vous pouvez sauvegarder les informations ci-dessus',
    home_book_search_text5: '(Ajouter des mots-clés)',
    home_book_search_text6: 'Rechercher',

    home_book_theme_title: 'Livres par thème',
    home_instant_text1: 'Entrez un mot-clé',
    home_instant_text2: 'Entrez au hasard',
    home_book_company_info: 'Si vous avez d\'autres questions, n\'hésitez pas à nous contacter ci-dessous. Nous sommes là pour vous aider.',
    home_page_search_text1: 'Recherche par page',
    home_page_search_text2: 'Jouer instantanément comme une vidéo',
    home_page_search_text3: 'Recherche avancée',
    home_page_search_text4: 'Vue de la liste',
    home_page_search_text5: 'Vue du réseau',
    home_page_explor_alert: 'Aucune page n\'a été sélectionnée',
    home_page_explor_alert2: 'Vous avez dépassé le nombre maximum de pages pouvant être visualisées sur un écran (150). Veuillez mettre les pages inutiles à la poubelle.',
    home_page_explor_alert3: 'Il n\'y a plus d\'informations à charger',
    my_login_title: 'MON',
    my_login_text1: 'Créez votre profil avec style',
    my_login_text2: 'Connectez-vous maintenant et participez',
    my_login_text3: 'avec YouBook',
    my_login_find_password: 'Trouver le mot de passe',
    my_guide_minibook: 'Comment créer un Minilivre',
    my_password_reset: 'Réinitialiser le mot de passe',
    my_password_reset_text1: 'Entrez votre ancien email pour la connexion',
    my_password_reset_button1: 'Envoyer un lien pour réinitialiser',
    my_password_reset_button2: 'Réinitialiser',
    my_password_reset_message1: 'Impossible de trouver votre adresse électronique',
    my_password_reset_message2: 'Nous avons envoyé un lien de réinitialisation du mot de passe à l\'adresse électronique que vous avez fournie.',
    my_password_reset_message3: 'Veuillez réinitialiser votre mot de passe en utilisant le lien envoyé à votre courriel.',
    my_password_reset_placeholder1: 'Votre adresse e-mail',
    my_password_reset_placeholder2: 'Entrez votre nouveau mot de passe',
    my_password_reset_placeholder3: 'Entrez à nouveau votre nouveau mot de passe',
    my_password_reset_message4: 'Le mot de passe ne correspond pas',
    my_password_reset_message5: 'Le mot de passe doit comporter au moins 8 caractères, dont une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.',
    my_password_reset_message6: 'Le mot de passe a été réinitialisé',
    my_memo_list_placeholder: 'Vous avez une idée ? Notez-la maintenant',
    my_profile_placehoder1: 'Mes intérêts',
    my_profile_placehoder2: 'Mon nom',
    my_profile_placehoder3: 'Me présenter brièvement',
    my_profile_placehoder4: 'Autres présentations',
    my_profile_text1: 'Nationalité',
    my_profile_text2: 'Langue',
    my_profile_text3: 'Modifier l’identifiant',
    my_profile_text4: 'Identifiant actuel',
    my_profile_text5: 'Nouvel identifiant',
    my_profile_text6: 'Vous ne pouvez le modifier qu’une seule fois',
    my_menu_text1: 'Mon Voyage',
    my_menu_text2: 'Message',
    my_menu_text3: 'Achat et règlement',
    my_menu_text4: 'Nouvelle notification',
    my_menu_text5: 'Écrire un minilivre',
    my_menu_text6: 'Minilivres \ncréés',
    my_menu_text7: 'Vous souhaitez importer des publications depuis d\'autres applications ?',
    my_menu_text8: 'Vous pouvez les importer automatiquement et les convertir en page',
    my_menu_text9: 'Importer',
    my_import_book_text1: 'Convertir en page',
    my_import_book_text2: 'Conversion du fichier ZIP en pages en cours. La conversion d’un texte peut prendre jusqu’à 5 secondes. Environ 1 minute pour 10 textes, 8 minutes pour 100. Une fenêtre contextuelle apparaîtra une fois la conversion terminée.',
    my_import_book_text3: 'D’accord',
    my_import_book_text4: 'Conversion en page terminée',
    my_import_book_text5: 'Tous les textes du fichier ZIP ont été convertis en pages. Chaque texte a été transformé en une page distincte. Vous pouvez les consulter dans Mon Voyage - Pages créées. Les pages sont enregistrées temporairement et peuvent être modifiées.',
    my_import_book_text6: 'Vous pouvez importer automatiquement des textes depuis d\'autres applications et les convertir en pages. Ensuite, vous pouvez regrouper ces pages dans un minilivre.',
    my_import_book_text7: 'Comment importer des textes d’autres applications via un fichier ZIP',
    my_import_book_text8: 'Veuillez téléverser un fichier ZIP',
    my_import_book_text9: 'Téléverser un fichier Substack',
    my_import_book_text10: 'Téléverser un fichier Medium',
    my_import_book_text11: 'Rechercher',
    my_import_book_text12: '* Chaque texte sera converti en page distincte',
    my_import_book_text13: '* Vous pouvez vérifier cela dans Ma page - Paramètres - Pages créées',
    my_import_book_text14: '* Les pages sont enregistrées temporairement et peuvent être modifiées',
    my_import_book_text15: '* Vous ne pouvez importer que vos propres textes',
    my_import_book_text16: 'Publier un minilivre avec les pages converties',
    my_import_book_text17: 'Créez la couverture du minilivre',
    my_import_book_text18: 'Sélectionnez les pages à ajouter au minilivre',
    my_import_book_text19: 'Publiez le minilivre',
    my_import_book_text20: 'Veuillez lire attentivement les instructions',
    my_import_book_text21: 'Le fichier n’est pas au format ZIP',
    my_import_book_text22: 'Veuillez téléverser un fichier',

    my_journey_title: 'Mon Voyage',
    my_journey_button_message: 'Message',
    my_journey_button_memo: 'Note',
    my_journey_button_record: 'Enregistrement',
    my_journey_button_follow: 'Suivre',
    my_journey_button_follow_cancel: 'Se désabonner',
    my_journey_message_text1: 'Laisser un message',
    my_journey_message_placeholder: 'Entrez votre message',
    my_journey_message_message1: 'Impossible de répondre',
    my_journey_message_message2: 'Envoi',
    my_journey_message_message3: 'Entrer votre message',
    my_journey_memo_total: 'Total',
    my_journey_record_overall: 'Classement d’influence',
    my_journey_record_text1: 'Pages vues',
    my_journey_record_text2: 'Minilivres favoris',
    my_journey_record_text3: 'Espace événementiel préféré',
    my_journey_record_text4: 'Pages créées',
    my_journey_record_text5: 'Minilivres créés',
    my_journey_record_text6: 'Espace événementiel créé',
    my_journey_record_text7: 'Ce mois-ci',
    my_journey_record_text8: 'Minilivre acheté',
    my_journey_record_text9: 'Public',
    my_journey_record_text10: 'Privé',
    my_journey_record_text11: 'Événements achetés',
    my_journey_record_text12: 'L\'événement que j\'ai créé',
    my_journey_record_text13: 'Classé #{userRank} dans la catégorie {userLanguage}',
    my_journey_record_text14: 'Minilivre de partage des droits d’auteur',
    my_journey_record_text15: 'Souhaitez-vous que les lecteurs lisent dans un certain ordre ? Si oui, faites glisser la couverture pour modifier l\'ordre.',
    my_journey_record_text16: 'Soutenez le nouveau minilivre',
    my_journey_record_text17: 'Messages de soutien des lecteurs',
    my_journey_record_text18: 'Laissez un message de soutien à l’auteur',
    my_journey_record_text19: 'Niveau de soutien',
    my_journey_record_text20: 'Niveau {cheeringLevel} sur 10',
    my_journey_record_text21: 'Personnes que je soutiens',
    my_journey_record_text22: 'Mes soutiens',
    my_journey_record_text23: 'Souhaitez-vous supprimer ?',
    my_journey_record_text24: 'soutien de {userName}',
    my_journey_record_text25: 'soutenu par {userName}',
    my_notice_title: 'Notification',
    my_notice_message1: 'Il n\'y a pas de nouvelles notifications',
    my_notice_text1: 'Un nouveau sujet de Minilivre est arrivé',
    my_notice_text2: 'Un nouveau Sujet du Jour est arrivé',
    my_notice_text3: 'Un nouveau message à Mon Voyage',
    my_notice_text4: 'Un nouveau commentaire à ma Note',
    my_notice_text5: 'Nouveau commentaire sur mon espace événementiel',
    my_notice_text6: 'Un nouveau commentaire sur la couverture de mon Minilivre',
    my_notice_text7: 'Un nouveau commentaire sur la page de mon Minilivre',
    my_notice_text8: 'a publié une nouvelle Note',
    my_notice_text9: '{userName} a créé un nouvel espace événementiel',
    my_notice_text10: 'publié un nouveau Minilivre',
    my_notice_text11: 'a acheté mon minibook',
    my_notice_text12: '{userName} a créé un <b>nouvel événement</b>',
    my_notice_text13: '{userName} vous a spécialement invité(e) à <b>cet nouvel événement</b>. Ne le manquez pas ! ',
    my_notice_text14: '{userName} a <b>acheté mon événement</b>',
    my_notice_text15: '{userName} a demandé à être auteur co-partage',
    my_notice_text16: 'La demande de co-auteur pour le minilivre ouvert a été approuvée',
    my_notice_text17: 'Un nouveau commentaire a été publié par un co-auteur',
    my_notice_text18: 'Un message est arrivé pour soutenir le nouveau minilivre',
    my_notice_text19: '{userName} a sponsorisé <b>mon minilivre</b>',
    my_marketing_banner_title: 'Encouragez-vous',
    my_marketing_banner_text1: 'Vous avez surmonté des difficultés, soutenez-vous maintenant',
    my_marketing_banner_btn: 'Encourager maintenant',
    my_marketing_title: 'Encourager maintenant',
    my_marketing_text1: 'Déployez les ailes du minilivre et de l\'événement - alimentez-les avec une promotion étape par étape - devenez un influenceur',
    my_marketing_text2: 'Envoyer un e-mail aux lecteurs ordinaires',
    my_marketing_text3: 'Envoyer un SMS aux lecteurs ordinaires',
    my_marketing_text4: 'Envoyer un e-mail aux amis',
    my_marketing_text5: 'Envoyer un SMS aux amis',
    my_marketing_text6: 'Lien vers les réseaux sociaux',
    my_marketing_btn: 'Commencer maintenant',
    my_marketing_minibook_step1_title: 'Soutien au minilivre',
    my_marketing_step1_subtitle: 'Lien vers les réseaux sociaux',
    my_marketing_minibook_step1_text1: 'Ajoutez le lien du minilivre sur vos réseaux sociaux et insérez une description attrayante',
    my_marketing_minibook_text1: 'Trouvez le minilivre',
    my_marketing_step1_text1: 'Copiez le lien',
    my_marketing_step1_btn: 'Copier',
    my_marketing_step1_text2: 'Collez sur les réseaux sociaux et ajoutez une description',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter (X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo (微博)',
    my_marketing_step1_sns12: 'Xiaohongshu (小红书)',
    my_marketing_step1_sns13: 'WeChat (微信)',
    my_marketing_step1_text3: 'Veuillez sélectionner le minilivre à partager',
    my_marketing_step1_text4: 'Lien copié',
    my_marketing_step1_text5: 'Veuillez sélectionner l\'événement à partager',
    my_marketing_step1_text6: 'Rechercher sur les réseaux sociaux',
    my_marketing_event_step1_title: 'Soutien à l’événement',
    my_marketing_event_step1_text1: 'Ajoutez le lien de l\'événement sur vos réseaux sociaux et insérez une description attrayante',
    my_marketing_event_text1: 'Trouvez l\'événement',
    my_marketing_event_search_title: 'Recherche d\'événement',
    my_marketing_minibook_step2_title: 'Marketing du minilivre - Étape 2',
    my_marketing_step2_subtitle: 'Envoyer un SMS aux amis',
    my_marketing_minibook_step2_text1: 'Envoyez à vos amis le lien du minilivre avec un message sincère',
    my_marketing_step2_text2: 'Envoyez à un ami un lien avec un message de présentation',
    my_marketing_step2_placeholder: 'Veuillez saisir votre message de présentation',
    my_marketing_tab_text1: 'Mes amis',
    my_marketing_event_step2_title: 'Marketing de l\'événement - Étape 2',
    my_marketing_event_step2_text1: 'Envoyez à vos amis le lien de l\'événement avec un message sincère',
    my_marketing_minibook_step3_title: 'Marketing du minilivre - Étape 3',
    my_marketing_step3_subtitle: 'Envoyer un e-mail aux amis',
    my_marketing_minibook_step3_text1: 'Envoyez à vos amis le lien du minilivre accompagné de l’histoire en arrière-plan',
    my_marketing_step3_text1: 'Importer une liste de contacts',
    my_marketing_step3_placeholder: 'Télécharger un fichier csv ou vcf',
    my_marketing_step3_text2: 'Envoyez l’histoire à vos amis avec le lien',
    my_marketing_step3_text3: 'Importer votre liste de numéros de téléphone',
    my_marketing_step3_placeholder2: 'Partagez l’histoire',
    my_marketing_event_step3_title: 'Marketing de l\'événement - Étape 3',
    my_marketing_event_step3_text1: 'Envoyez à vos amis le lien de l’événement accompagné de l’histoire en arrière-plan',
    my_marketing_text7: 'Importer des numéros de téléphone',
    my_marketing_title2: 'Gérer les numéros de téléphone',
    my_marketing_text8: 'Téléphone',
    my_marketing_text9: 'Nombre de fois',
    my_marketing_text10: 'Importer des contacts',
    my_marketing_text11: 'Veuillez télécharger un fichier csv ou vcf',
    my_marketing_text12: 'Comment importer',
    my_marketing_text13: 'Importer',
    my_marketing_title3: 'Gérer les contacts',
    contact_manage: 'Gestion des contacts',
    my_marketing_text14: 'Supprimer la sélection',
    my_marketing_text15: 'Veuillez sélectionner un ami',
    my_marketing_text16: 'Vous pouvez sélectionner jusqu’à 100 amis',
    my_marketing_text17: 'Téléchargement terminé',
    my_marketing_text18: 'Limite de caractères dépassée',
    contact_phone: 'Téléphone',
    contact_organization: 'Organisation',
    contact_title: 'Titre',
    contact_memo: 'Mémo',
    my_marketing_text19: 'Modifier la sélection',
    my_marketing_text20: 'Choisir une étiquette',
    my_marketing_text21: 'Ajouter une nouvelle étiquette',
    my_marketing_text22: 'Supprimer l’étiquette sélectionnée',
    my_marketing_text23: 'Ajouter',
    my_marketing_btn2: 'Modification terminée',
    my_marketing_text24: 'Veuillez sélectionner un contact à modifier',
    my_marketing_text25: 'Veuillez sélectionner une étiquette à supprimer',
    my_marketing_text26: 'Veuillez saisir un nom d’étiquette',
    my_marketing_text27: 'Cette étiquette existe déjà',
    my_marketing_text28: 'Ajouter une étiquette',
    my_marketing_text29: 'Annuler',
    my_marketing_text30: 'Ajouté',
    my_benefit_text1: 'Ce que vous avez gagné jusqu\'à présent',
    my_benefit_text2: 'Ce que vous gagnerez dans un an',
    my_benefit_text3: '',
    my_benefit_text4: 'le calcul du gain',
    my_benefit_text5: 'le calcul du profit',
    my_benefit_text6: 'Vérifier',
    my_benefit_modal_text1: 'Ce que vous avez acquis jusqu\'à présent',
    my_benefit_modal_text2: 'EUR',
    my_benefit_modal_text3: 'Vous avez gagné',
    my_benefit_modal_text4: 'Faisons un calcul très simple',
    my_benefit_modal_text5: 'Nombre de pages lues jusqu\'à présent',
    my_benefit_modal_text6: 'Prix pour créer une page',
    my_benefit_modal_text7: 'EUR',
    my_benefit_modal_text8: 'Votre gain est donc de',
    my_benefit_modal_text9: 'Ajoutez maintenant les avantages des discussions avec l',
    my_benefit_modal_text10: 'IA et vos gains seront encore plus importants.',
    my_benefit_modal_text11: 'Utilisez-le tous les jours et récoltez des bénéfices',
    my_benefit_modal_text12: 'OK, j\'ai compris',
    my_story_text1: 'Ce que disent les membres',
    my_story_text2: 'Réaliser que les livres sont vécus et non pas lus',
    my_story_text3: 'Ce qui se passe lorsque l\'on apprend tous les jours est étonnant',
    my_story_text4: 'Les pièges cachés des personnes intelligentes. Êtes-vous l\'un d\'entre eux ?',
    my_story_text5: 'Lire d\'autres témoignages de membres',
    my_go_blog_text1: 'YouBook, Nouvelles et Histoires de Clients',
    my_go_blog_text2: 'Découvrez les dernières nouvelles et histoires de clients de YouBook',
    my_go_blog_text3: 'En savoir plus',
    my_channel_text1: 'Que pensez-vous de YouBook ?',
    my_channel_text2: 'Dites-nous ce qui est bien et ce que nous pouvons améliorer.',
    my_channel_text3: 'Et dites-nous si vous avez des questions',
    my_channel_text4: 'Dites-nous un mot',
    my_about_youbook_text1: 'Pourquoi utiliser YouBook ?',
    my_about_youbook_text2: 'Toutes vos questions et réponses sont ici',
    my_about_youbook_text3: 'Conditions d\'utilisation',
    my_app_text1: 'YouBook est une application 100% bénéfique.',
    my_app_text2: 'Téléchargez-la maintenant et acquérez des connaissances',
    my_app_text3: 'Télécharger l\'application',
    login_title: 'CONNEXION',
    login_text1: 'Connexion avec email',
    login_text2: 'Vous n\'êtes pas encore inscrit ?',
    login_text3: 'Mot de passe oublié ?',
    login_text4: 'ou Connexion avec',
    login_text5: 'J\'accepte',
    login_placeholder1: 'Email de connexion',
    login_placeholder2: 'Mot de passe',
    login_placeholder3: 'identifiant',
    login_message1: 'Veuillez entrer votre email de connexion',
    login_message2: 'Entrez votre mot de passe',
    login_message3: 'Connexion réussie',
    login_message4: 'Veuillez entrer votre identifiant',
    logout_message1: 'Voulez-vous vous déconnecter ?',
    login_link1: 'S\'inscrire',
    login_link2: 'Trouver',
    login_link3: 'Conditions d\'utilisation',
    register_title: 'S\'inscrire',
    register_text1: 'S\'inscrire par courriel',
    register_text2: 'Sélectionner le type d\'adhésion',
    register_text3: 'Personnelle',
    register_text4: 'Organisationnel',
    register_text5: 'Entrez vos informations',
    register_text6: 'Déjà inscrit ?',
    register_text7: 'Numéro d\'enregistrement de la société',
    register_text8: 'Numéro d\'immatriculation de l\'entreprise',
    register_text9: 'Nom de l\'organisation',
    register_placeholder1: 'Votre numéro de téléphone, y compris l\'indicatif régional',
    register_placeholder2: '( sans - )',
    register_placeholder_repassword: 'Saisissez à nouveau le mot de passe',
    register_message1: 'Entrez votre numéro de téléphone',
    register_message2: 'Entrez le numéro d\'enregistrement de la société',
    register_message3: 'Veuillez entrer le numéro d\'immatriculation de l\'entreprise',
    register_message4: 'Veuillez entrer le nom de l\'organisation',
    register_message5: 'Format d\'email invalide',
    register_message6: 'Cet email est déjà enregistré',
    register_message7: 'Veuillez vérifier votre adresse électronique',
    register_message8: 'Veuillez sélectionner votre nationalité',
    register_message9: 'Format d\'identifiant incorrect',
    register_message10: 'L\'identifiant saisi est indisponible. Utilisez un identifiant suggéré ou saisissez-en un autre',
    register_message11: 'Veuillez vérifier votre identifiant',
    register_message12: 'Cet identifiant est déjà utilisé. Veuillez en choisir un autre ou utiliser un identifiant suggéré',
    register_button_verify: 'Vérifier',
    register_button_verify_fail: 'Non vérifié',
    register_button_verify_success: 'Vérifié',
    register_welcome_message: 'Bienvenue à l\'adhésion',
    withdraw_text1: 'Annulation de l\'abonnement',
    withdraw_text2: 'Annuler l\'abonnement YouBook',
    withdraw_text3: 'Êtes-vous sûr de vouloir annuler ?',
    withdraw_text4: 'Non',
    withdraw_text5: 'Oui',
    withdraw_text6: 'Votre abonnement a été annulé avec succès',
    home_memo_title: 'Note',
    home_memo_subtitle: 'Si vous ne faites pas de note, vous l\'oubliez.',
    home_memo_text1: 'Partagé ensemble par tous',
    home_memo_text2: 'Connaissances et histoires du quotidien',
    home_memo_button: 'Ajouter une note',
    home_memo_create_text1: 'Vous avez un minilivre à lier ?',
    home_memo_create_button: 'Trouver un minilivre',
    home_memo_create_button2: 'Sélectionner',
    home_memo_click: 'Cliquez sur',
    home_memo_date: 'YYYY. MM. DD',
    home_memo_button_askai: 'Commentaire / Pensées de Minou Livre',
    home_memo_view_detail: 'Voir les détails',
    home_memo_view_placeholder: 'Ecrire un post',
    home_memo_view_button1: 'Commentaire',
    home_memo_view_button2: 'Pensées de Minou Livre',
    home_memo_view_errormessage: 'Entrer un message',

    memo_create_title: 'Note',
    memo_create_category1: 'Note',
    memo_create_category2: 'Note',
    memo_create_private: 'Privé',
    memo_create_public: 'Publics',
    memo_create_placeholder1: 'Vous avez une idée ?',
    memo_create_placeholder2: 'Notez-la maintenant',
    memo_create_placeholder3: 'Mots-clés (laisser un espace entre les deux mots)',
    memo_create_button: 'Sauvegarder',
    memo_create_error: 'Entrez votre note',
    memo_attach_img: 'Télécharger l’image',
    memo_alert_rate: 'Veuillez sélectionner votre classement par étoiles',
    memo_alert_save: 'Sauvegardé. Vous pouvez la vérifier dans Mon profil - Mon Voyage',
    memo_input_placeholder: 'Qu\'avez-vous appris ?',
    memo_input_placeholder2: 'Qu\'en pensez-vous ? Quels sont vos avis?',
    memo_input_placeholder3: 'Partagez-les avec vos lecteurs dès maintenant~',
    memo_input_placeholder4: 'Un souvenir du quotidien, on le garde ?',
    memo_alert_keywords: 'Entrer les mots-clés',
    memo_related_text: 'Note',
    memo_related_date: 'YYYY.MM.DD',
    memo_popup_text1: 'L\'histoire de Nicholas Luhmann se lit comme une fable moderne montrant le pouvoir de transformation d\'une simple habitude.',
    memo_popup_text3: 'Au départ, Luhmann était un jeune employé dans une société très éloignée du monde scolaire.',
    memo_popup_text4: 'Cependant, sa passion pour la lecture l\'a conduit à une pratique inhabituelle : la prise de notes quotidienne sur ses lectures.',
    memo_popup_text5: 'Cette habitude a abouti à un article qui a attiré l\'attention d\'un sociologue allemand de renom, ce qui a donné un tournant inattendu à sa carrière.',
    memo_popup_text6: 'Luhmann a été invité à rejoindre l\'Université de Bielefeld, où il a fini par accéder au rang de professeur titulaire.',
    memo_popup_text7: 'Au cours de sa carrière, il est l\'auteur d\'une soixantaine de livres et de nombreux articles, ce qui lui vaut d\'être considéré comme une sommité en matière de sociologie.',
    memo_popup_text8: 'Luhmann attribue ses prouesses intellectuelles',
    memo_popup_text9: '"Je n\'arrêtais pas de prendre des notes"',

    memo_popup_text10: 'ce qui l\'a aidé à organiser ses pensées et à approfondir sa compréhension.',
    memo_popup_text11: 'Ce récit nous rappelle les limites de la mémoire et la valeur de la saisie systématique et du réexamen des connaissances pour se les approprier véritablement.',
    memo_popup_btn: 'Oui, je peux m\'identifier',
    memo_text1: 'Vous pouvez sauvegarder le contenu ci-dessus',
    memo_text2: '(Ajouter certains mots-clés)',
    memo_text3: 'Choses à vérifier lors de l\'écriture',
    memo_text4: 'Votre publication enfreint les règles de contenu de l\'article 2, section 1 des conditions d\'utilisation. Elle ne sera pas publiée.',
    memo_text5: 'Voir les conditions d\'utilisation',
    memo_text6: 'Pour laisser une note dans une autre langue, ',
    memo_text7: 'veuillez écrire dans cette langue (pas de traduction automatique)',
    book_create_button: 'Ecrire un minilivre',
    book_create_title: 'Ecrire un couverture',
    book_create_cover: 'couverture',
    book_create_text1: 'Etape pour créer une couverture pour un Minilivre',
    book_create_text1_pc: 'Entrez le titre et le nom de l\'auteur',
    book_create_text2: 'Il n\'y pas d\'image de couverture que vous avez créée',
    book_create_text3: '',
    book_create_text4: 'Vous avez créé une image de couverture',
    book_create_text5: 'Avez-vous créé votre propre couverture ?',
    book_create_text6: 'Veuillez la télécharger en utilisant le bouton ci-dessous',
    book_create_text7: '(format jpg d\'une taille inférieure à 20M)',
    book_create_text8: 'Droit d\'ajouter des pages',
    book_create_text9: 'moi seulement',
    book_create_text10: 'tout le monde',
    book_create_text11: 'Titre sur image',
    book_create_text12: 'Afficher',
    book_create_text13: 'Ne pas afficher',
    book_create_text14: 'Sélectionnez les langues à traduire',
    book_create_text15: 'Tout sélectionner',
    book_create_text16: 'Télécharger l\'image de couverture',
    book_create_text17: 'Vous pouvez modifier',
    book_create_text18: 'Après modification, cliquez sur l\'icône en haut à droite pour retraduire',
    book_create_text19: 'Si vous souhaitez retraduire selon l\'original, cliquez sur l\'icône en haut à droite',
    book_create_text20: 'Retraduire',
    book_create_text21: 'Image',
    book_create_text22: 'Titre',
    book_create_text23: 'Mot-clé',
    book_create_text24: 'Contenu',
    book_create_text25: 'La traduction ne sera mise à jour que si l\'image est supprimée et rechargée',
    book_create_text26: '(La page ne sera pas supprimée)',
    book_create_text27: 'Veuillez fournir une brève introduction',
    book_create_text28: 'Sauvegarde temporaire',
    book_create_text29: 'Sauvegardé temporairement',
    book_create_text30: 'Points à vérifier',
    book_create_text31: 'Le contenu du texte est la version finale et ne nécessite plus de modifications',
    book_create_text32: 'Aucun mot ou symbole incompréhensible pour l\'IA de traduction n\'a été utilisé',
    book_create_text33: 'L\'image n\'a pas été copiée-collée, mais a été ajoutée sous forme de fichier séparé',
    book_create_text34: 'Ouvrir à la candidature ? (Minilivre ouvert)',
    book_create_text35: 'Auteurs co-partage',
    book_create_text36: 'Souhaitez-vous ajouter manuellement ?',
    book_create_text37: 'Ajouter',
    book_create_text38: 'Un minilivre qui se diffuse plus largement grâce à l\'écriture collective',
    book_create_text39: 'La puissance des auteurs co-partage que vous ignorez',
    book_create_text40: 'Ouvrir aux candidatures',
    book_create_text41: 'Annuler',
    book_create_text43: 'Une idée ?',
    book_create_text44: 'Copier-coller le contenu',
    book_create_text45: 'Besoin d’une idée ?',
    book_create_text46: 'Options de vente',
    book_create_text47: 'Gratuit',
    book_create_text48: 'Sponsor',
    book_create_text49: 'Acheter',
    book_create_text50: 'Prix actuel',
    book_create_text51: 'Modifier le prix',
    book_create_text52: 'Impossible de définir à 0',
    book_create_text53: 'Les minilivres achetés ou sponsorisés ne peuvent pas modifier le prix ou les options de vente',
    book_create_text54: 'Seul l’auteur du minilivre peut répondre aux messages',
    book_create_button_upload: 'Télécharger',
    book_create_button_make: 'Créer',
    book_create_cover_topic_placeholder: 'Le titre ressemblera à ceci',
    book_create_topic_placeholder: 'Entrez un titre',
    book_create_keyword_placeholder: 'Mot-clé (un blanc entre eux)',
    book_create_category_placeholder: 'Sélectionnez une catégorie',
    book_create_knowledge_placeholder: 'Rédigez une introduction à votre Minilivre ** Attention - Notez les détails dans les étapes, pour faire des pages',
    book_create_category_option1: 'Films et Drames',
    book_create_category_option2: 'Musique et Danse',
    book_create_category_option3: 'Autres Arts',
    book_create_category_option4: 'Vêtements et Style',
    book_create_category_option5: 'Cuisine et Nourriture',
    book_create_category_option6: 'Alcool et Boissons',
    book_create_category_option7: 'Snacks et Desserts',
    book_create_category_option8: 'Plantes et Santé',
    book_create_category_option9: 'Devenir Riche',
    book_create_category_option10: 'Développement Personnel',
    book_create_category_option11: 'Relations Humaines',
    book_create_category_option12: 'Nouveaux Savoirs',
    book_create_category_option13: 'Histoires de Vie',
    book_create_category_option14: 'Philosophie et Valeurs',
    book_create_category_option15: 'Religion et Tradition',
    book_create_category_option16: 'Amour',
    book_create_category_option17: 'Voyages et Attractions',
    book_create_category_option18: 'Loisirs',
    book_create_category_option19: 'Culture Ludique',
    book_create_category_option20: 'Mythes et Héros',
    book_create_category_option21: 'Voyages Littéraires',
    book_create_category_option22: 'Histoire et Sagesse',
    book_create_category_option23: 'Histoires Sociales',
    book_create_category_option24: 'Culture Générale',
    book_create_message1: 'Entrez un titre',
    book_create_message2: 'Entrer un nom d\'auteur',
    book_create_message3: 'Entrer quelques mots-clés',
    book_create_message4: 'Entrer plus de 3 mots-clés',
    book_create_message5: 'Sélectionner une catégorie',
    book_create_message6: 'Créer une image de couverture',
    book_create_message7: 'Vous ne pouvez pas entrer de caractères spéciaux. Un espace entre les mots-clés est nécessaire.',
    book_create_message8: 'Vous souhaitez supprimer le Minilivre ?',
    book_create_message9: 'Vous n\'avez pas de droit de publication pour cette langue',
    book_create_message10: 'Un minilivre acheté ne peut pas être supprimé',
    book_create_modal_text1: 'Veuillez patienter un instant..',
    book_create_modal_text2: 'L\'IA examine le contenu, traduit des langues étrangères et connecte le réseau de connaissances.',
    book_create_modal_text3: 'Connexion à la base de données pour une recherche page par page',
    book_create_modal_text4: 'Le titre n\'apparaît pas sur l\'image de la couverture',
    book_create_modal_text5: '(Cela s\'applique également aux couvertures traduites dans d\'autres langues)',
    book_view_title: 'Aperçu du minilivre',
    book_view_share: 'Partager',
    book_view_event_topic: 'Sujet de l\'événement',
    book_view_together_suggest: 'Suggérer un espace événementiel',
    book_view_together_message: 'Vous n\'avez pas de favori pour Ensemble, <br /> allez dans le menu Ensemble et choisissez-en un.',
    book_view_event_message: 'Il n\'y a aucun événement que j\'ai créé',
    book_view_text1: 'Aucune page n\'a été ajoutée.',
    book_view_text2: 'Pourquoi ne pas l\'ajouter maintenant ?',
    book_view_text3: 'Le minilivre n\'existe pas. Veuillez réessayer.',
    book_view_text4: 'Sommaire',
    book_view_text5: 'Que diriez-vous d\'améliorer la traduction de ce minilivre ou de le promouvoir et de partager les bénéfices ?',
    book_view_text6: 'Liste des pages',
    book_view_text7: 'Modification du prix',
    book_view_text8: 'Impossible de modifier car un acheteur est déjà présent',
    book_view_text9: 'Cadeau du lecteur',
    book_view_text10: 'Seul l’auteur du minilivre peut répondre aux messages',
    book_view_modal_title: 'Amélioration de la traduction et promotion',
    book_view_modal_text1: 'Pouvez-vous améliorer vous-même la traduction de ce minilivre ? Ou le promouvoir ?',
    book_view_modal_text2: 'Laissez un message à l\'auteur',
    book_view_modal_text3: 'Si l\'auteur accepte, vous pouvez partager les revenus',

    book_view_write_share_title: 'Minilivre ouvert',
    book_view_write_share_text1: 'Voulez-vous devenir co-auteur de ce minilivre ?',
    book_view_write_share_text2: 'Demander l\'auteur',
    book_view_write_share_text3: 'Laissez une demande simple',
    book_view_write_share_text4: 'Envoyer',
    book_view_write_share_list_title: 'Auteurs co-partage',
    book_view_write_share_text5: 'Gérer les co-auteurs du minilivre',
    book_view_write_share_text6: 'Gérer les auteurs',
    book_view_write_share_text7: 'Accepter',
    book_view_write_share_text8: 'Accepté',
    book_view_write_share_text9: 'L\'utilisateur est déjà enregistré en tant qu\'auteur',
    book_view_write_share_text10: 'Ajouter l’auteur manuellement',
    book_view_write_share_text11: 'L’utilisateur a déjà postulé',
    book_view_publish_text1: 'Souhaitez-vous publier ce Minilivre ?',
    book_view_publish_text2: 'Publier le rend accessible à tous et vous pouvez même gagner de l\'argent avec.',
    book_view_publish_text3: '(Si vous publiez pour la vente, vous ne pouvez pas inclure les pages d\'autres auteurs).',
    book_view_publish_text4: 'Fixer un prix',
    book_view_publish_text5: 'Date de publication',
    book_view_publish_text6: 'Demander la publication',
    book_view_publish_text7: 'Pub instantanée',
    book_view_publish_text8: 'Réservation',
    book_view_publish_text9: 'Pas encore publié',
    book_view_publish_text10: 'En cours',
    book_view_publish_text11: 'Publié',
    book_view_publish_text12: 'Choses à vérifier lors de la publication',
    book_view_publish_text13: 'Ce Minilivre n\'a jamais été publié dans YouBook auparavant',
    book_view_publish_text14: 'Ce minilivre et ses pages n\'ont pas plagié de contenus ni enfreint les droits de propriété intellectuelle d\'autrui',
    book_view_publish_text15: 'Ce minilivre ne contient pas de langage vulgaire, de contenu sexuel excessif, de diffamation envers autrui, ni de publicité commerciale, et respecte l\'article 2, clause 1 des conditions d\'utilisation',
    book_view_publish_text16: 'Oui',
    book_view_publish_text17: 'Rapport de publication',
    book_view_publish_text18: 'Publié',
    book_view_publish_text19: 'Date de publication',
    book_view_publish_text20: 'Prix',
    book_view_publish_text21: 'Définir la période ouverte',
    book_view_publish_text22: 'Période ouverte',
    book_view_publish_text23: 'Qu\'est-ce qu\'une période ouverte',
    book_view_publish_text24: 'La période ouverte désigne la période pendant laquelle les lecteurs peuvent consulter le contenu',
    book_view_publish_text25: 'Ce minilivre contient plus de 3 pages',
    book_view_publish_text26: 'Ce minilivre ne contient pas plus de 3 pages',
    book_view_publish_text27: 'Si des violations sont détectées, l\'algorithme peut ajuster le classement de recherche. En cas de problème grave, le minilivre sera automatiquement supprimé',
    book_view_publish_text28: 'Définir les options de vente',
    book_view_publish_text29: 'Mode d’achat',
    book_view_publish_text30: 'Mode de soutien',
    book_view_publish_message1: 'Si vous publiez pour la vente, assurez-vous que 1) les pages de votre Minilivre ont été créées par vous et 2) que vous ne les avez pas déjà publiées à titre onéreux.',
    book_view_publish_message2: 'Il n\'est pas en état d\'être publié. Veuillez contacter l\'administrateur pour obtenir de l\'aide',
    book_view_publish_message3: 'Ce minilivre a déjà été publié.',
    book_view_publish_message4: 'Veuillez sélectionner la période ouverte après l\'heure actuelle',
    book_view_publish_message5: 'Veuillez sélectionner la date et l\'heure',
    book_view_publish_message6: 'La publication a été approuvée. Nous vous remercions de votre attention.',
    book_view_publish_message7: 'Veuillez vérifier les éléments de confirmation',
    book_view_publish_message8: 'La date de fin ne peut pas être antérieure à la date de début',
    book_view_publish_message9: 'Un minilivre en sauvegarde temporaire ne peut pas être publié',
    book_view_publish_message10: 'Ce minilivre a reçu le partage des droits d’auteur. Le droit de publication initial appartient à l’auteur.',
    book_view_publish_message11: 'Veuillez saisir un montant d’au moins {minPrice}',
    book_view_button_confirm: 'Confirmé',
    book_view_button_publish: 'Publier',
    book_view_button_order: 'Alignement des pages',
    book_view_button_add: 'Ajouter une page',
    book_view_button_video: 'Lire la vidéo',
    book_view_button_read: 'Lire',
    book_view_button_lecture: 'Regarder la vidéo de la conférence',
    book_view_page_add_title: 'Ajouter une page',
    book_view_page_add_text1: 'Après avoir recherché une page de tiers',
    book_view_page_add_text2: 'Dans l\'écran Afficher la page',
    book_view_page_add_text3: 'Mettre dans mon Minilivre',
    book_view_page_add_text4: 'Et si vous voulez créer votre propre page ?',
    book_view_page_add_text5: 'La création de pages n\'est accessible qu\'aux auteurs enregistrés.  Si vous souhaitez vous inscrire en tant qu\'auteur, veuillez nous contacter ci-dessous.',
    book_view_page_add_text6: 'Souhaitez-vous ajouter une page de tiers ?',
    book_view_page_add_text7: '* Si vous ajoutez une page créée par un tiers, \nelle ne peut pas être publiée comme un minilivre payant',
    book_view_page_add_text8: 'Avez-vous déjà créé des pages ?',
    book_view_page_add_button1: 'Créer une page',
    book_view_page_add_button2: 'Voir les Pages créées',
    book_view_reference_text1: 'Diversité',
    book_view_reference_text2: 'Multiple',
    book_view_reference_text3: 'Auteur du minilivre',
    book_view_reference_text4: 'Créé par l\'auteur',
    book_view_support_text1: 'Je te soutiens',
    book_view_support_modal_title: 'Devenez un soutien',
    book_view_support_modal_text1: 'Même un bon texte a du mal à se diffuser seul.',
    book_view_support_modal_text2: 'Un soutien est celui qui transmet le minilivre de l’auteur au monde. C’est une personne qui soutient les autres.',
    book_view_support_modal_text3: 'Ensemble, faisons voyager cette histoire plus loin.',
    book_view_support_modal_text4: 'Soutenez l’auteur, s’il vous plaît',
    book_view_support_modal_btn1: 'Compris',
    book_view_support_modal_text5: '"Votre soutien m’est très précieux. Merci. Je soutiendrai aussi votre voyage de tout cœur."',
    book_view_support_modal_text6: 'Partagez le minilivre avec le monde',
    book_view_support_modal_btn2: 'Comment faire ?',
    book_view_support_modal_title2: 'Jusqu’ici, bravo à moi-même',
    book_view_support_modal_text7: 'Écrire n’a pas été facile, mais j’y suis parvenu.',
    book_view_support_modal_text8: 'Il est temps maintenant de croire en moi et de faire un pas de plus.',
    book_view_support_modal_text9: 'Même avec un peu de gêne ou d’hésitation, je deviens mon premier soutien et je me dévoile au monde.',
    book_view_support_modal_text10: 'Parce que je crois que cela peut signifier quelque chose pour quelqu’un.',
    book_view_support_modal_text11: 'S’il te plaît, deviens mon soutien',
    book_view_support_modal_text12: 'Écrire ou organiser un événement n’était pas facile, mais j’ai relevé le défi.',
    book_view_support_modal_btn3: 'Je vais essayer !',
    book_view_support_modal_title3: 'Bonjour, cher soutien',
    book_view_open_minibook_text1: 'La demande de Minilivre ouvert a été complétée',
    book_view_open_minibook_text2: 'La demande de Minilivre ouvert a été annulée',
    page_create_title: 'Rédiger une page',
    page_create_text1: 'Pas d\'image de la page que vous avez créée',
    page_create_text2: '',
    page_create_text3: 'page',
    page_create_text4: 'Lorsqu\'il y a une image sur la page que vous avez crée',
    page_create_text5: 'Avez-vous créé une image de page ?',
    page_create_text6: 'Entrez votre contenu. Il est recommandé de ne pas dépasser une feuille A4.',
    page_create_text7: 'Octets actuels',
    page_create_text8: 'Recommander',
    page_create_text9: 'Il y a-t-il des références sur cette page?',
    page_create_text10: 'Créée par vous',
    page_create_text11: 'Livre référencé',
    page_create_text12: 'Blog référencé',
    page_create_text13: 'AI référencé',
    page_create_text14: 'Il s\'agit de l\'étape de création des pages du minilivre.',
    page_create_text15: 'Télécharger l\'image de page',
    page_create_text16: 'Voulez-vous retraduire ?',
    page_create_text17: 'Si vous souhaitez retraduire, veuillez sélectionner la cible et la langue (si vous ne sélectionnez pas, cela sera enregistré sans traduction)',
    page_create_text18: 'Cible de traduction',
    page_create_text19: 'Langue de traduction',
    page_create_message1: 'Il ne peut pas être modifié',
    page_create_message2: 'Entrez votre contenu',
    page_create_message3: 'Vous voulez supprimer la page ?',
    page_create_message4: 'Le contenu dépasse la taille maximale',
    page_create_reference_book: 'livre',
    page_create_reference_blog: 'blog',
    page_create_reference_placeholder1: 'Entrez le titre du',
    page_create_reference_placeholder2: 'Lien connexe (i.e. https://www.amazon.com/dp...)',
    page_create_reference_placeholder3: 'Année de publication du',
    page_create_reference_placeholder4: 'Auteur du',
    page_create_title_placeholder: 'Le titre ressemblera à ceci',
    page_create_message5: 'Traduction en cours',
    page_create_message6: 'Après avoir créé la couverture, vous pouvez créer une page',
    page_create_modal_text1: 'Le titre n\'apparaît pas sur l\'image de la page',
    page_create_modal_text2: '(Cela s\'applique également aux pages traduites dans d\'autres langues)',
    page_create_modal_text3: 'Veuillez vérifier impérativement !',
    page_create_modal_text4: 'Si le contenu a été modifié, vous devez sauvegarde temporaire.',
    page_create_modal_text5: 'L\'avez-vous fait ?',
    page_create_modal_text6: 'Si le contenu a été modifié, vous devez Créer.',
    page_view_title: 'Voir la page',
    page_view_button_video: 'Regarder la vidéo',
    page_view_button_read: 'Lire',
    page_view_text1: 'Ajouter à mon minilivre',
    page_view_text2: 'Lecture automatique',
    page_view_text3: 'Lectures',
    page_view_text4: 'Page associée',
    page_view_text5: 'Minilivre associé',
    page_view_text6: 'Référence',
    page_view_text7: 'Source',
    page_view_text8: 'Publication',
    page_view_text9: 'Auteur',
    page_view_text10: 'Titre',
    page_view_text11: 'Toutes les pages de cette réf.',
    page_view_text12: 'Recherche associée',
    page_view_text13: 'Page auteur',
    page_view_text14: 'Rencontrer l\'auteur',
    page_view_text15: 'Mettre en ligne',
    page_view_reference_text1: 'Livre',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'Vous n\'avez pas encore créé de Minilivres. Veuillez en créer un sur Ma Page.',
    page_view_pay_popup_text1: 'La lecture vous a-t-elle apporté quelque chose ? \nRépondez avec un petit cadeau à l’auteur.',
    page_view_pay_popup_title: 'Envoyer un cadeau',
    page_view_pay_popup_text2: 'Choisissez un thé à offrir en cadeau',
    page_view_pay_popup_text3: 'Écrivez un message sincère',
    page_view_pay_popup_placeholder1: 'Les mots et la sagesse de l’auteur m’ont profondément aidé.',
    page_view_pay_popup_text4: 'Montant',
    page_view_pay_popup_button1: 'Acheter et envoyer le message',
    page_view_pay_popup_text5: 'L’auteur a consacré beaucoup de temps et d’efforts à l’écriture de ce texte.\n\nMerci de répondre avec un petit cadeau.',
    page_view_pay_popup_placeholder2: 'Je fais confiance à la sagesse et à la sensibilité de l’auteur.',
    page_view_pay_popup_text6: 'Pas envie d’envoyer de cadeau ?',
    page_view_pay_popup_text7: 'Préférez-vous regarder une pub à la place ?',
    page_view_pay_popup_button2: 'Regarder une pub pour lire',
    page_sort_title: 'Alignement des pages',
    page_sort_subtitle: 'Faites glisser la page pour modifier l\'ordre',
    page_sort_text: 'Source',
    pay_button: 'Acheter maintenant',
    pay_price: 'Prix',
    pay_vat_excluded: '(hors TVA)',
    pay_message_success: 'Acheté',
    pay_message_fail: 'Échec',
    pay_currency: 'EUR',
    pay_button_paid: 'Payé',
    pay_button_view_price: 'Voir le prix',
    pay_total: 'Total',
    pay_methods: 'Modes de paiement',
    pay_methods_creditcard: 'Carte de crédit',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Continuer',
    pay_text1: 'Veuillez choisir un thé',
    pay_text2: 'Veuillez saisir un message',
    advertisement_button: 'Lire la suite',
    advertisement_text1: 'Vous pouvez voir le contenu après avoir regardé la publicité.',
    advertisement_text2: 'Ceci est une page d’un minilivre payant. <br />Allez à la couverture et appuyez sur Lire pour acheter. <br />',
    advertisement_text3: 'Vous pouvez voir le contenu après avoir regardé la publicité. La publicité ne peut être visionnée que dans l\'application.',
    together_title: 'Événement',
    together_subtitle: 'Rencontrez vos lecteurs et discutez',
    together_subtitle_text1: 'Rencontrez vos lecteurs en ligne',
    together_subtitle_text2: 'Créez une salle et invitez des gens',
    together_button: 'Créer un espace événementiel',
    together_case: 'Affaire',
    together_case1: 'J\'essaie de donner mais je ne fais que recevoir',
    together_case2: 'Jamais un exemple réel n\'a été aussi utile',
    together_subtitle2: 'Espace que j’ai créé',
    together_category1: 'Les plus récents',
    together_category2: 'Les plus lus',
    together_button_viewmore: 'Plus d\'informations',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD A hh:mm',
    together_subtitle3: 'Un espace comme celui-ci',
    together_subtitle3_1: 'Veuillez le créer',
    together_subtitle_text3: 'Si quelqu\'un commence, je veux participer ',
    together_create_title: 'Créer un espace événementiel',
    together_create_title2: 'Modifier l’espace événementiel',
    together_create_button1: 'Sélectionner',
    together_create_subtitle: 'Titre',
    together_create_placeholder1: 'Entrer un titre',
    together_create_subtitle1: 'Brève introduction',
    together_create_placeholder2: 'Ecrivez une brève introduction',
    together_create_subtitle2: 'Choisir l\'outil à utiliser',
    together_create_text1: 'Lien de réunion en ligne (par exemple, lien Zoom)',
    together_create_placeholder3: 'Veuillez entrer le lien de réunion en ligne',
    together_create_question1: 'Vous ne connaissez pas le lien du zoom ?',
    together_create_q1_a_title: 'Trouver un lien pour rejoindre le zoom',
    together_create_text2: 'Utiliser le métavers',
    together_create_placeholder4: 'Choisissez celui qui convient à Ensemble',
    together_create_question2: 'Vous ne connaissez pas le métavers ?',
    together_create_text3: 'Choisir où ouvrir',
    together_create_dropmenu1: 'Ouvrir au coin des intellectuels invités par le YB',
    together_create_dropmenu2: 'Ouvrir au coin des auteurs et des lecteurs',
    together_create_button2: 'Sauvegarder',
    together_create_button3: 'Faire',
    together_create_popup_title: 'Choisissez celui qui convient à Ensemble',
    together_create_popup_alert: 'Déjà choisi',
    together_create_button4: 'Sélectionner',
    together_create_alert: 'Veuillez entrer le lien de la réunion en ligne',
    together_create_alert1: 'Rentrez un titre',
    together_create_alert2: 'Choisir le métavers à utiliser',
    together_create_alert3: 'Impossible d\'éditer',
    together_create_alert4: 'Espace événementiel créé',
    together_create_alert5: 'Erreur. Veuillez réessayer',
    together_create_alert6: 'Échec de la création de l’espace événementiel...',
    together_qa_popup_title1: 'Trouver un lien pour rejoindre le zoom',
    together_qa_popup_btext1: 'Ordinateur',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Ouvrez le programme Zoom - Après vous être connecté - Cliquez sur le menu réunion en haut - Mon identifiant personnel de réunion - Cliquez sur Afficher l\'invitation à la réunion - Un lien pour rejoindre la réunion Zoom apparaîtra. Copiez-le.',
    together_qa_popup_btext2: 'Smartphone',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Ouvrez le programme Zoom - Après vous être connecté - Appuyez sur le bouton i en haut à droite - Envoyer une invitation - Après avoir appuyé sur le message - Entrez votre numéro de téléphone - Un lien apparaît. Copiez-le.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'Qu\'est-ce que le métavers ?',
    together_qa_popup_text3: 'C\'est un espace de rencontre virtuel.',
    together_qa_popup_text4: 'Il se présente sous la forme d\'un avatar',
    together_qa_popup_text5: 'que vous avez créé - Vous parlez à vos amis face à face - Vous pouvez aussi partager votre écran.',
    together_qa_popup_text7: 'Dans un espace de rencontre',
    together_qa_popup_text8: '- 10 personnes peuvent entrer en même temps.',
    together_qa_popup_text9: 'Pas besoin d\'installer un programme séparé',
    together_qa_popup_text10: 'et aucune inscription n\'est nécessaire.',
    together_more_list_title: 'Espace événementiel',
    together_more_list_date: 'YYYY.MM.DD',
    together_request_list_title: 'Veuillez créer',
    together_request_list_category1: 'Les favoris',
    together_request_list_category2: 'Le plus récent',
    together_request_list_button: 'Suggérer un nouvel espace',
    together_request_popup_title: 'Suggestion d’un nouvel espace',
    together_request_popup_alert1: 'Entrez un titre',
    together_request_popup_alert2: 'Entrer une brève introduction',
    together_request_popup_placeholder1: 'Mettre un titre',
    together_request_popup_placeholder2: 'Redigez une brève introduction',
    together_request_popup_button: 'Sauvegarder',
    together_request_detail_button: 'Créer cet espace',
    together_detail_sns: 'Partager',
    together_detail_enterbtn: 'Entrer',
    together_detail_btn1: 'Liste des événements',
    together_detail_btn2: 'Message',
    together_detail_subtitle: 'Minilivre sur le sujet',
    together_detail_alert: 'Attendez un peu...',
    together_detail_alert1: 'Suggestion d’espace événementiel réussie !',
    together_detail_alert2: 'Échec de la suggestion d’espace événementiel…',
    together_detail_alert3: 'Favori / Annulation réussie du favori',
    together_detail_alert4: 'Favori / Echec de l\'annulation du favori',
    together_detail_alert5: 'Problème de serveur, veuillez réessayer plus tard',
    together_detail_alert6: 'Il y a un problème avec le lien de réunion en ligne',
    together_detail_alert7: 'Échec de la suppression',
    together_notice_alert: 'Voulez-vous supprimer l\'annonce ?',
    together_notice_list_title: 'Annonce',
    together_button_addtopic: 'Ajouter ceci comme sujet à l’espace événementiel',
    together_add_alert: 'Ajouté à l’espace événementiel',
    together_text1: 'Des goûts similaires aux vôtres',
    together_text2: 'Voulez-vous supprimer cet espace événementiel ?',
    together_event_btn: 'Créer un nouvel événement',
    together_event_title: 'Nouvel événement',
    together_event_placeholder: 'Entrez une description',
    together_event_text1: 'Définissez le calendrier',
    together_event_text2: 'Définissez les frais d\'entrée',
    together_event_text3: 'Définissez la capacité maximale',
    together_event_text4: 'Calendrier',
    together_event_text5: 'Frais d\'entrée',
    together_event_text6: 'Capacité maximale',
    together_event_text7: 'Notifier mes abonnés',
    together_event_text8: 'Voulez-vous supprimer l\'événement ?',
    together_event_text9: 'Veuillez définir l\'heure de début après l\'heure actuelle',
    together_event_text10: 'Veuillez définir l\'heure de fin après l\'heure de début',
    together_event_text11: 'L\'heure de début et l\'heure de fin ne peuvent pas être identiques',
    together_event_text12: 'Ajouter ceci comme sujet de l\'événement',
    together_event_text13: 'Ajouté à l\'événement',
    together_event_text14: 'La capacité maximale de l\'événement a été dépassée',
    together_event_text15: 'Bouton s’active 1 heure avant l’Événement \n(si gratuit pas besoin d’Acheter maintenant)',
    together_event_text16: 'Bouton s’active 1 heure avant l’Événement',
    together_event_text17: 'Aucun événement n\'existe',
    together_event_text18: 'Impossible de supprimer s\'il y a un acheteur pour l\'événement',
    together_event_text19: 'Souhaitez-vous envoyer une notification ?',
    together_event_text20: 'Envoyé',
    together_event_text21: 'Liste des événements',
    together_event_text22: 'Voir les détails',
    together_event_text23: 'Après S\'inscrire, connectez-vous',
    together_event_text24: 'Méthode de participation',
    together_event_text25: 'Participation à l’événement terminée',
    together_event_text26: 'L’auteur a consacré beaucoup de temps et de soin à cet événement.\n\nRépondez par un petit cadeau.',
    together_event_text27: 'La sagesse tirée de l’expérience de l’auteur et la profondeur de la communication étaient marquantes',
    together_event_text28: 'Partagez cet événement avec le monde',
    together_event_text29: 'Organiser cet événement n’a pas été facile, mais je l’ai fait.',
    together_event_text30: 'Peu importe la qualité d’un événement, il est difficile de le faire connaître seul.',
    together_event_text31: 'Un soutien est une personne qui partage l’événement de l’auteur avec le monde. C’est quelqu’un qui encourage les autres.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Rencontrez des gens du monde entier',
    youbooker_case: 'Pensée',
    youbooker_case_text1: 'Être celui qui commence toujours',
    youbooker_case_text2: 'Plus on apprend plus le développement personnel peut être grand',
    youbooker_translation: 'Envie de rencontrer maintenant ?',
    youbooker_translation_text1: 'Toutes les langues',
    youbooker_category: 'Abonnés / Suivre',
    youbooker_subcategory1: 'Mon abonné(e)',
    youbooker_subcategory2: 'Je suis abonné(e)',
    youbooker_subtitle2: 'Ceux qui me suivent',
    youbooker_button_follow: 'Suivre',
    youbooker_message_follow: 'Suivre',
    youbooker_button_follow_cancel: 'Se désabonner',
    youbooker_subtitle3: 'Voici les utilisateurs que vous connaissez',
    youbooker_subtitle4: 'Je les suis',
    youbooker_subtitle5: 'Ces utilisateurs ne connaissent pas encore YB',
    youbooker_button_invite: 'Inviter',
    youbooker_alert_invite: 'L\'invitation n\'est possible que par l\'intermédiaire de l\'application.',
    youbooker_alert: 'Seulement dans l\'application. Pourquoi ne pas télécharger l\'application ?',
    youbooker_alert2: 'Actualisation réussi !',
    youbooker_alert3: 'Vous pouvez effectuer une recherche sur l\'onglet YouBook.',
    home_page_text1: 'Les plus récents',
    home_page_text2: 'Influence',
    home_page_today_title: 'Sujet du Jour',
    home_page_today_subtitle: 'En rapport avec les actualités TOP',
    home_page_slider_date: 'YYYY. MM. DD',
    home_page_today_list_title: 'Sujet du Jour',
    home_page_today_detail_sns: 'Partager',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: 'Pages connexes',
    home_page_explor_title: 'Exploration des pages',
    home_page_explor_subtitle: 'Que faire en cas de double clic ?',
    home_page_recommend_title: 'Recommandations',
    home_page_recommend_subtitle: 'Pages susceptibles de vous intéresser',
    home_page_theysee_title: 'Que voient-ils ?',
    home_page_theysee_subtitle: 'Pages que les lecteurs voient le plus souvent',
    home_page_common_title: 'Le bon sens',
    home_page_common_subtitle: 'Il est préférable de savoir ceci',
    home_page_keyw_title: 'Pages par mot-clé',
    home_page_keyw_subtitle: 'Trouver toutes les pages connexes',
    home_page_random_title: 'ALLER au hasard',
    home_page_random_subtitle: 'Appuyez quand vous êtes stupéfait et apprenez quelque chose d\'inattendu',
    home_page_about_title: 'À propos de YouBook',
    home_page_about_detail: 'Société : NICK syndicate /French business center : Paris /Autre métropole : Tokyo, Shanghai, Séoul, Seattle/Contact : joa@academy-connect.net/DUNS 695937905',
    settlement_title: 'Achat et règlement',
    settlement_tab1: 'Enregistrement de la commande',
    settlement_tab2: 'Informations du compte',
    settlement_tab3: 'Détails du règlement',
    settlement_category1: 'Mon historique d\'achat',
    settlement_category2: 'Partage des droits d’auteur',
    settlement_category3: 'Historique de règlement des revenus du minilivre',
    settlement_category4: 'Historique de règlement des revenus des événements',
    settlement_category5: 'Gestion du compte',
    settlement_text1: 'Affichage de l\'historique d\'achat',
    settlement_text2: 'Vous pouvez partager les droits d’auteur du minilivre',
    settlement_text3: 'Vous vérifiez l\'enregistrement de votre règlement de Minilivre payé.',
    settlement_text4: 'Si vous avez des questions supplémentaires, cliquez',
    settlement_text5: 'ici',
    settlement_text6: 'Ou contactez-nous ci-dessous.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Dites un mot',
    settlement_text9: 'En cas de revenus, vous devez gérer le compte pour recevoir les paiements',
    settlement_text10: 'Règlement des revenus générés par l\'événement',
    settlement_purchase_text1: 'Historique d\'achat',
    settlement_purchase_text2: 'Date',
    settlement_purchase_text3: 'Montant d\'achat',
    settlement_purchase_text4: 'Titre',
    settlement_purchase_text5: 'Minilivre',
    settlement_purchase_text6: 'Événement',
    settlement_accountInfo_text1: 'Droits d’auteur du minilivre',
    settlement_accountInfo_text2: 'Minilivre',
    settlement_accountInfo_text3: 'Langue',
    settlement_accountInfo_text4: 'Droit d’auteur',
    settlement_accountInfo_text5: 'Auteur',
    settlement_accountInfo_text6: 'Tiers',
    settlement_accountInfo_text7: 'Personnel ?',
    settlement_accountInfo_text8: 'Personnel',
    settlement_accountInfo_text9: 'Société',
    settlement_accountInfo_text10: 'Nom de la banque',
    settlement_accountInfo_text10_message: 'Sélectionnez un nom de banque',
    settlement_accountInfo_text11: 'Nom du titulaire du compte',
    settlement_accountInfo_text11_message: 'Entrer un nom de titulaire de compte',
    settlement_accountInfo_text12: 'Numéro de compte',
    settlement_accountInfo_text12_message: 'Entrer un numéro de compte',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Numéro de sécurité sociale',
    settlement_accountInfo_text13_message: 'Entrez un numéro de sécurité sociale',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Adresse de domicile',
    settlement_accountInfo_text14_message: 'Entrer une adresse de domicile',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'Courriel',
    settlement_accountInfo_text15_message: 'Entrer une adresse électronique',
    settlement_accountInfo_text16: 'Sauvegarder',
    settlement_accountInfo_text17: 'Numéro d\'identification de l\'employeur (NIE)',
    settlement_accountInfo_text17_message: 'Entrer un numéro NIE',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Adresse de la société',
    settlement_accountInfo_text18_message: 'Entrer une adresse de société',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'Nom de l\'entreprise',
    settlement_accountInfo_text19_message: 'Entrer le nom de l\'entreprise',
    settlement_accountInfo_text20: 'Téléphone de la société',
    settlement_accountInfo_text20_message: 'Entrer les coordonnées de la société',
    settlement_accountInfo_text21: 'Identifiant du tiers',
    settlement_accountInfo_text21_placeholder: 'Email du tiers',
    settlement_accountInfo_text22: 'Compte pour recevoir le paiement',
    settlement_accountInfo_text23: 'Pays',
    settlement_accountInfo_message1: 'Email introuvable',
    settlement_accountInfo_message2: 'Vous ne pouvez pas partager les droits d’auteur avec vous-même',
    settlement_accountInfo_message3: 'Il n\'y a pas de minilivres créés',
    settlement_accountInfo_text24: 'Partage des droits d’auteur',
    settlement_accountInfo_text25: 'Une fois les droits d’auteur partagés avec un tiers, ils ne peuvent pas être récupérés',
    settlement_accountInfo_text26: 'Souhaitez-vous partager les droits d’auteur ?',
    settlement_accountInfo_text27: 'Oui, je partage',
    settlement_accountInfo_text28: ' Pour partager les droits d’auteur,<br /> 1) les pages du minilivre doivent être créées par vous, et <br /> 2) ne doivent pas avoir été partagées avec un tiers',
    settlement_accountInfo_text29: 'OK, je corrige le problème.',
    settlement_accountInfo_text30: 'Vous avez partagé les droits d’auteur de ce minilivre avec un tiers',
    settlement_accountInfo_text31: 'Auteur',
    settlement_accountInfo_text32: 'Tiers',
    settlement_accountInfo_text33: 'Vous avez reçu les droits d’auteur de ce minilivre de l’auteur',
    settlement_accountInfo_text34: 'Ce minilivre est gratuit. Aucun compte n\'est requis.',
    settlement_accountInfo_text35: 'Partage des recettes',
    settlement_accountInfo_text36: '(moi)',
    settlement_accountInfo_text37: '(éditeurs, etc.)',
    settlement_accountInfo_text38: 'Compte personnel',
    settlement_accountInfo_text39: 'Compte société',
    settlement_accountInfo_text40: 'Gestion du compte',
    settlement_accountInfo_text41: 'Sauvegarder',
    settlement_accountInfo_text42: 'Banque',
    settlement_accountInfo_text43: 'Sélection du compte',
    settlement_accountInfo_text44: 'Déterminer comment partager les revenus',
    settlement_accountInfo_text45: 'Taux de revenus (%)',
    settlement_accountInfo_text46: 'Mon ID (email)',
    settlement_accountInfo_text47: 'ID du tiers (email)',
    settlement_accountInfo_text48: 'Faire correspondre le total',
    settlement_accountInfo_text49: 'euillez saisir les informations du cessionnaire',
    settlement_accountInfo_text50: 'Le taux de revenus ne peut pas dépasser 100',
    settlement_accountInfo_text51: 'Cédant ID(email)',
    settlement_accountInfo_text52: 'Cessionnaire ID(email)',
    settlement_earnings_text1: 'Détails du règlement',
    settlement_earnings_text2: 'Période de règlement',
    settlement_earnings_text3: 'Prix du minilivre',
    settlement_earnings_text4: 'Quantité vendue',
    settlement_earnings_text5: 'Montant des ventes',
    settlement_earnings_text6: 'Déductions comprenant les taxes',
    settlement_earnings_text7: 'Montant du dépôt',
    settlement_earnings_text8: 'Date de dépôt',
    settlement_earnings_text9: 'Vues de publicité',
    settlement_earnings_text10: 'Montant total',
    settlement_earnings_text11: 'En savoir plus',
    settlement_earnings_text12: 'Prix de la publicité',
    settlement_earnings_text13: 'Revenus',
    settlement_earnings_text14: 'Tous les minilivres',
    settlement_earnings_text15: 'Sélectionner un événement',
    settlement_earnings_text16: 'Tous les événements',
    settlement_statistics_text1: 'Volume des ventes',
    settlement_statistics_text2: 'Nombre de lecteurs',
    settlement_statistics_text3: '(Le dernier)',
    settlement_statistics_text4: '1 mois',
    settlement_statistics_text5: '6 mois',
    settlement_statistics_text6: '1 an',
    settlement_statistics_text7: 'Aucune donnée trouvée',
    settlement_statistics_text8: 'Analyse des ventes',
    settlement_statistics_text9: 'Vues de publicité',
    settlement_statistics_text10: 'Toutes les langues',
    terms_title: 'Conditions d\'utilisation',
    terms_text: '',
    privacy_title: 'Politique de confidentialité',
    privacy_text: '',
    // common text
    message_save: 'Sauvegardé',
    message_fail: 'Échec',
    message_delete: 'Supprimé',
    message_report: 'Signalé',
    message_search_no_result: 'Aucun résultat de recherche trouvé',
    message_search_enter: 'Veuillez entrer un terme de recherche',
    message_error1: 'Une erreur s\'est produite. Veuillez contacter l\'administrateur',
    message_save2: 'Sauvegardé',
    message_fail2: 'Échec',
    message_login: 'Vous avez besoin d\'une connexion',
    name: 'Nom de l\'utilisateur',
    email: 'Mail',
    mobile: 'Numéro de téléphone',
    list: 'Liste',
    edit: 'Modifier',
    delete: 'Supprimer',
    search: 'Rechercher',
    report: 'Signaler du contenu inapproprié ou incorrect',
    user: 'Utilisateur',
    report_type: 'Choississez le type de signalisation',
    report_type1: 'Profanation/ Diffamation',
    report_type2: 'Publicité',
    report_type3: 'Obscénité/ Sexuellement explicite',
    report_type4: 'Répétition du même contenu',
    report_type5: 'Autres',
    search_book: 'Recherche dans le minilivre',
    serch_placeholder: 'Recherche par nom ou email',
    search_keyword: 'Mot-clé',
    search_reference: 'Référence',
    search_author: 'Auteur',
    search_result: 'Trouvé',
    button_report: 'Signaler à YouBook',
    button_write: 'Sauvegarder',
    button_login: 'CONNEXION',
    button_more: 'Plus d\'informations',
    button_confirm: 'Confirmé',
    button_save: 'Sauvegarder',
    button_crop: 'Choix',
    button_delete: 'Supprimer',
    button_complete: 'complet',
    colorbox_background_text1: 'Sélectionner une couleur d\'arrière-plan',
    colorbox_font_text1: 'Sélectionner une couleur de texte',
    menu_home: 'Accueil',
    menu_page: 'Page',
    menu_book: 'Minilivre',
    menu_memo: 'Note',
    menu_together: 'Événement',
    login_button: 'CONNEXION',
    message_text1: 'Répondre',
    message_text2: 'Une réponse a été ajoutée à mon commentaire',
  },
  id: {
    home_banner_title1: 'Buku mini baru',
    home_banner_title2: 'Acara baru',
    home_slide_title1: 'Sedang tren',
    home_slide_title2: 'Selera saya',
    home_slide_title3: 'Sedang hangat',
    home_slide_title4: 'Sangat populer',
    home_detail_title1: 'Kenangan sehari-hari',
    home_detail_title2: 'Video yang direkomendasikan',
    home_detail_title3: 'Jika kamu ingin tahu lebih banyak',
    home_detail_text1: 'Memo Buku Mini',
    home_detail_text2: 'Memo harian',
    home_setting_title: 'Pengaturan',
    home_setting_text1: 'Halaman yang dilihat dalam 30 hari terakhir',
    home_setting_text2: 'Keluar',
    home_setting_text3: 'Hapus akun',
    home_book_banner_question: 'Aku Ingin Tahu',
    home_book_banner_write_placeholder1: 'Ketik judul',
    home_book_banner_write_placeholder2: 'Masukkan postingan/kiriman',
    home_book_banner_write_button: 'Simpan',
    home_book_banner_detail_text1: 'Jawaban mentor YouBook',
    home_book_banner_detail_text2: 'Buku Mini Terkait',

    home_book_create_button: 'Buku Mini, Coba Buat Sekarang',
    home_book_create_text1: 'Buku mini adalah buku pendek sekitar 10 halaman. Buku ini dibuat sesuai dengan tren membaca cepat yang ringkas namun tetap menyampaikan inti dari isi.',
    home_book_create_text2: 'Cara edit setelah publikasi',
    home_book_create_text3: 'Buku mini, cara membuat yang mudah',
    home_book_create_text4: 'Berapa banyak keuntungan yang bisa diperoleh penulis?',
    home_book_create_text5: 'Bagaimana cara bertemu pembaca?',
    home_book_create_text6: '5 alasan untuk menggunakan YouBook',
    home_book_create_text7: 'Pertanyaan lainnya?',
    home_book_create_text8: 'Bisakah saya melihat jumlah penjualan secara real-time?',
    home_book_create_text9: 'Mari kita terus menulis setiap hari!',
    home_book_create_text10: 'Ayo mulai sekarang juga!',

    home_book_category_title1: 'Isu Hari Ini dan Buku Mini',
    home_book_category_title2: 'Buku Mini Populer',
    home_book_category_title3: 'Buku Mini Profesor S-class',
    home_book_category_title4: 'Rekomendasi Pribadi',
    home_book_category_title5: 'Minibuku Inti Bestseller',
    home_book_category_title6: 'Bersama Kucing Buku',
    home_book_category_title6_text1: 'Lihat',
    home_book_category_title6_text2: 'Tutup',
    home_book_category_title7: 'Menjelajahi Halaman Jaringan Saraf',
    home_book_category_title8: 'Festival Seni dan Emosi',
    home_book_category_title8_text1: 'Dunia dalam Film dan Drama',
    home_book_category_title8_text2: 'Melodi dan Gerakan Menggetarkan Jiwa',
    home_book_category_title8_text3: 'Seni Tanpa Batas',
    home_book_category_title8_text4: 'Memakai Kepribadian: Busana dan Gaya',
    home_book_category_title9: 'Budaya Kuliner dan Kenyamanan',
    home_book_category_title9_text1: 'Eksplorasi Kuliner, Masakan Lokal',
    home_book_category_title9_text2: 'Cerita tentang Alkohol dan Kehidupan',
    home_book_category_title9_text3: 'Daya Tarik Camilan dan Makanan Penutup',
    home_book_category_title9_text4: 'Kekuatan Alam, Rahasia Tumbuhan',
    home_book_category_title10: 'Kebijaksanaan Hidup dan Penemuan Diri',
    home_book_category_title10_text1: 'Cara Unik Mengelola Uang',
    home_book_category_title10_text2: 'Resep Pertumbuhan Diri',
    home_book_category_title10_text3: 'Masalah dan Solusi Hubungan',
    home_book_category_title10_text4: 'Penemuan dan Pengetahuan Baru',
    home_book_category_title11: 'Keberagaman Nilai dan Cinta',
    home_book_category_title11_text1: 'Cerita Hidup Mereka',
    home_book_category_title11_text2: 'Filosofi dan Nilai Berbeda',
    home_book_category_title11_text3: 'Kepercayaan dan Tradisi Religius',
    home_book_category_title11_text4: 'Misteri Cinta',
    home_book_category_title12: 'Hari Penuh Perjalanan dan Hobi',
    home_book_category_title12_text1: 'Destinasi Tersembunyi yang Wajib Dikunjungi',
    home_book_category_title12_text2: 'Kebahagiaan Hidup Melalui Hobi',
    home_book_category_title12_text3: 'Budaya Unik Lewat Permainan',
    home_book_category_title13: 'Kekayaan Tradisi dan Cerita',
    home_book_category_title13_text1: 'Mitos dan Kisah Pahlawan Lokal',
    home_book_category_title13_text2: 'Perjalanan Sastra Global',
    home_book_category_title13_text3: 'Sejarah dan Kebijaksanaan Tempat-Tempat',
    home_book_category_title13_text4: 'Cerita Sosial Berwarna-Warni',

    home_book_category_title1_text2: 'Pemikiran Kucing Buku – Mau intip sebentar?',
    home_book_category_title1_text3: 'Bingung? Penasaran?',
    home_book_category_title1_text4: 'Ingin saya rekomendasikan buku mini?',
    home_book_search_placeholder1: 'Silakan bicara di sini',
    home_book_search_placeholder2: 'Apa kata kuncinya?',

    home_book_search_message1: 'Silahkan Ketik Pertanyaan',
    home_book_search_message2: 'Ketikkan pertanyaan lagi',
    home_book_search_text1: 'Mengapa tidak mendiskusikan denganku?',
    home_book_search_text2: 'Mengapa tidak mendiskusikan denganku?',
    home_book_search_text3: 'Tanya',
    home_book_search_text4: 'Kamu bisa menyimpan pertanyaan di atas',
    home_book_search_text5: '(hanya tambahkan kata kunci)',
    home_book_search_text6: 'Cari',
    home_book_theme_title: 'Buku berdasarkan genre',
    home_instant_text1: 'Tuliskan kata kunci',
    home_instant_text2: 'Tuliskan secara acak',
    home_book_company_info: 'Jika ada pertanyaan yang lain, jangan ragu untuk menghubungi  kami di bawah ini. Kami siap membantu Anda.',
    home_page_search_text1: 'Penelusuran halaman',
    home_page_search_text2: 'Mainkan Video',
    home_page_search_text3: 'Penelusuran lanjutan',
    home_page_search_text4: 'Tampilan daftar',
    home_page_search_text5: 'Tampilan jaringan',
    home_page_explor_alert: 'Tidak ada halaman yang dipilih',
    home_page_explor_alert2: 'Anda telah melampaui jumlah maksimum halaman yang dapat dilihat pada satu layar (150). Buang halaman yang tidak diperlukan ke tempat sampah.',
    home_page_explor_alert3: 'Tidak ada lagi informasi yang dapat dimuat',
    my_login_title: 'SAYA',
    my_login_text1: 'Buat profil custommu',
    my_login_text2: 'Masuklah sekarang dan jadilah bagian dari kebersamaan yang cerdas',
    my_login_text3: 'bersama YouBook',
    my_login_find_password: 'Temukan kata sandi',
    my_guide_minibook: 'Cara membuat Buku  Mini',
    my_password_reset: 'Atur ulang kata sandi',
    my_password_reset_text1: 'Masukkan email Anda sebelumnya untuk LOGIN',
    my_password_reset_button1: 'Kirim tautan untuk mengatur ulang',
    my_password_reset_button2: 'Atur ulang',
    my_password_reset_message1: 'Tidak dapat menemukan email Anda',
    my_password_reset_message2: 'Kami telah mengirimkan tautan pengaturan ulang kata sandi ke email yang Anda berikan.',
    my_password_reset_message3: 'Silakan atur ulang kata sandi Anda menggunakan tautan yang dikirimkan ke email Anda.',
    my_password_reset_placeholder1: 'Email Anda',
    my_password_reset_placeholder2: 'Masukkan kata sandi baru Anda',
    my_password_reset_placeholder3: 'Masukkan kembali kata sandi anda yang baru',
    my_password_reset_message4: 'Kata sandi tidak sesuai',
    my_password_reset_message5: 'Kata sandi harus terdiri dari setidaknya 8 karakter dan mencakup setidaknya satu huruf besar, satu huruf kecil, satu angka, dan satu karakter khusus',
    my_password_reset_message6: 'Kata sandi telah diatur ulang',
    my_memo_list_placeholder: 'Punya ide? Tulis sekarang',
    my_profile_placehoder1: 'Kesukaan saya',
    my_profile_placehoder2: 'Nama pengguna',
    my_profile_placehoder3: 'Perkenalkan diriku secara singkat',
    my_profile_placehoder4: 'Informasi tambahan',
    my_profile_text1: 'Kebangsaan',
    my_profile_text2: 'Bahasa',
    my_profile_text3: 'Ubah ID',
    my_profile_text4: 'ID saat ini',
    my_profile_text5: 'ID baru untuk diubah',
    my_profile_text6: 'Perubahan ID hanya dapat dilakukan satu kali',
    my_menu_text1: 'Perjalananku',
    my_menu_text2: 'Pesan',
    my_menu_text3: 'Pembelian &\nPenyelesaian\ntransaksi',
    my_menu_text4: 'Notifikasi baru',
    my_menu_text5: 'Buatlah sebuah \nBuku Mini',
    my_menu_text6: 'Buku Mini \nyang dibuat',
    my_menu_text7: 'Ingin mengimpor tulisan dari aplikasi lain?',
    my_menu_text8: 'Kamu bisa mengimpornya secara otomatis dan mengubahnya menjadi halaman',
    my_menu_text9: 'Impor',
    my_import_book_text1: 'Ubah menjadi halaman',
    my_import_book_text2: 'Sedang mengubah file ZIP menjadi halaman. Mengubah satu tulisan membutuhkan waktu hingga 5 detik. Sekitar 1 menit untuk 10 tulisan, dan 8 menit untuk 100 tulisan. Akan muncul pop-up setelah proses selesai.',
    my_import_book_text3: 'Mengerti',
    my_import_book_text4: 'Konversi halaman selesai',
    my_import_book_text5: 'Semua tulisan dalam file ZIP telah diubah menjadi halaman. Setiap tulisan diubah menjadi satu halaman. Kamu bisa mengeceknya di Perjalananku - Halaman yang dibuat. Halaman disimpan sementara dan bisa diedit.',
    my_import_book_text6: 'Kamu bisa mengimpor tulisan dari aplikasi lain dan secara otomatis mengubahnya menjadi halaman. Lalu kumpulkan halaman tersebut menjadi buku mini.',
    my_import_book_text7: 'Cara mengimpor tulisan dari aplikasi lain dalam format ZIP',
    my_import_book_text8: 'Silakan unggah file ZIP',
    my_import_book_text9: 'Unggah file dari Substack',
    my_import_book_text10: 'Unggah file dari Medium',
    my_import_book_text11: 'Cari',
    my_import_book_text12: '* Setiap tulisan akan diubah menjadi satu halaman',
    my_import_book_text13: '* Anda dapat memeriksanya di Halaman Saya - Pengaturan - Halaman yang dibuat',
    my_import_book_text14: '* Halaman disimpan sementara dan bisa diedit',
    my_import_book_text15: '* Hanya bisa mengimpor tulisan buatan sendiri',
    my_import_book_text16: 'Publikasikan buku mini dari halaman yang telah diubah',
    my_import_book_text17: 'Buat sampul buku mini',
    my_import_book_text18: 'Pilih halaman untuk ditambahkan ke buku mini',
    my_import_book_text19: 'Publikasikan buku mini',
    my_import_book_text20: 'Baca panduan dengan seksama',
    my_import_book_text21: 'Bukan format ZIP',
    my_import_book_text22: 'Silakan unggah file',

    my_journey_title: 'Perjalananku',
    my_journey_button_message: 'Pesan',
    my_journey_button_memo: 'Memo',
    my_journey_button_record: 'Rekam',
    my_journey_button_follow: 'Mengikuti',
    my_journey_button_follow_cancel: 'berhenti',
    my_journey_message_text1: 'Tinggalkan pesan',
    my_journey_message_placeholder: 'Tuliskan pesan Anda',
    my_journey_message_message1: 'Tidak dapat menjawab',
    my_journey_message_message2: 'Mengirim',
    my_journey_message_message3: 'Tuliskan pesan Anda',
    my_journey_memo_total: 'Total',
    my_journey_record_overall: 'Peringkat pengaruh',
    my_journey_record_text1: 'Halaman yang dilihat',
    my_journey_record_text2: 'Buku Mini favorit',
    my_journey_record_text3: 'Ruang acara favorit',
    my_journey_record_text4: 'Halaman yang dibuat',
    my_journey_record_text5: 'Buku  Mini yang dibuat',
    my_journey_record_text6: 'Ruang acara yang saya buat',
    my_journey_record_text7: 'Bulan ini',
    my_journey_record_text8: 'Buku mini yang dibelik',
    my_journey_record_text9: 'Publik',
    my_journey_record_text10: 'Pribadi',
    my_journey_record_text11: 'Acara yang dibeli',
    my_journey_record_text12: 'Acara yang saya buat',
    my_journey_record_text13: 'Peringkat #{userRank} di kategori {userLanguage}',
    my_journey_record_text14: 'Buku mini berbagi hak penulis',
    my_journey_record_text15: 'Apakah Anda ingin pembaca membaca sesuai urutan tertentu? Jika ya, seret hanya aku untuk mengubah urutannya.',
    my_journey_record_text16: 'Dukung buku mini baru',
    my_journey_record_text17: 'Pesan dukungan dari pembaca',
    my_journey_record_text18: 'Tinggalkan pesan dukungan untuk penulis',
    my_journey_record_text19: 'Level pendukung',
    my_journey_record_text20: 'Level {cheeringLevel} dari 10',
    my_journey_record_text21: 'Orang yang saya dukung',
    my_journey_record_text22: 'Pendukung saya',
    my_journey_record_text23: 'Apakah Anda ingin menghapusnya?',
    my_journey_record_text24: 'pendukung {userName}',
    my_journey_record_text25: 'didukung oleh {userName}',
    my_notice_title: 'Pemberitahuan',
    my_notice_message1: 'Tidak ada pemberitahuan baru',
    my_notice_text1: 'Terbitan baru telah tiba',
    my_notice_text2: 'Topik yang baru telah tiba',
    my_notice_text3: 'Pesan baru untuk Perjalananku saya',
    my_notice_text4: 'Komentar baru untuk Memo saya',
    my_notice_text5: 'Komentar baru di ruang acara saya',
    my_notice_text6: 'Komentar baru untuk sampul Buku  Miniku',
    my_notice_text7: 'Komentar baru di halaman Buku Miniku',
    my_notice_text8: 'memposting Memo baru',
    my_notice_text9: '{userName} telah membuat ruang acara baru',
    my_notice_text10: 'menerbitkan Buku  Mini baru',
    my_notice_text11: 'membeli minibook saya',
    my_notice_text12: '{userName} telah membuat <b>acara baru</b>',
    my_notice_text13: '{userName} secara khusus mengundang Anda ke <b>acara baru</b>. Jangan lewatkan! ',
    my_notice_text14: '{userName} telah <b>membeli acara saya</b>',
    my_notice_text15: '{userName} telah mengajukan sebagai penulis bersama',
    my_notice_text16: 'Permohonan penulis bersama untuk buku mini terbuka telah disetujui',
    my_notice_text17: 'Komentar baru telah diposting oleh rekan penulis',
    my_notice_text18: 'Sebuah pesan telah datang untuk mendukung buku mini yang baru',
    my_notice_text19: '{userName} telah mensponsori <b>Buku MiniKu</b>',
    my_marketing_banner_title: 'Dukung Diri Sendiri',
    my_marketing_banner_text1: 'Kamu telah melewati kesulitan, sekarang saatnya mendukung diri sendiri',
    my_marketing_banner_btn: 'Dukung Sekarang',
    my_marketing_title: 'Dukung Sekarang',
    my_marketing_text1: 'Pasang dua sayap acara dan buku mini – isi bahan bakarnya dengan promosi bertahap – dan jadilah influencer',
    my_marketing_text2: 'Email ke pembaca umum',
    my_marketing_text3: 'Pesan teks ke pembaca umum',
    my_marketing_text4: 'Email ke teman',
    my_marketing_text5: 'Pesan teks ke teman',
    my_marketing_text6: 'Tautkan ke media sosial',
    my_marketing_btn: 'Mulai sekarang',
    my_marketing_minibook_step1_title: 'Dukung Buku Mini',
    my_marketing_step1_subtitle: 'Tautkan ke media sosial',
    my_marketing_minibook_step1_text1: 'Tautkan buku mini ke media sosialmu dan tambahkan deskripsi yang menarik',
    my_marketing_minibook_text1: 'Temukan buku mini',
    my_marketing_step1_text1: 'Salin tautan',
    my_marketing_step1_btn: 'Salin',
    my_marketing_step1_text2: 'Tempelkan ke media sosial dan tambahkan deskripsi',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'Pilih buku mini untuk dibagikan',
    my_marketing_step1_text4: 'Tautan telah disalin',
    my_marketing_step1_text5: 'Pilih acara untuk dibagikan',
    my_marketing_step1_text6: 'Cari media sosial',
    my_marketing_event_step1_title: 'Dukung Acara',
    my_marketing_event_step1_text1: 'Tautkan acara ke media sosialmu dan tambahkan deskripsi yang menarik',
    my_marketing_event_text1: 'Temukan acara',
    my_marketing_event_search_title: 'Cari acara',
    my_marketing_minibook_step2_title: 'Pemasaran Buku Mini Tahap 2',
    my_marketing_step2_subtitle: 'Pesan teks ke teman',
    my_marketing_minibook_step2_text1: 'Kirimkan tautan buku mini dan pesan pengantar yang tulus ke teman-temanmu',
    my_marketing_step2_text2: 'Kirimkan pengantar dan tautan ke teman',
    my_marketing_step2_placeholder: 'Silakan tulis pengantar',
    my_marketing_tab_text1: 'Teman-temanku',
    my_marketing_event_step2_title: 'Pemasaran Acara Tahap 2',
    my_marketing_event_step2_text1: 'Kirimkan tautan acara dan pesan pengantar yang tulus ke teman-temanmu',
    my_marketing_minibook_step3_title: 'Pemasaran Buku Mini Tahap 3',
    my_marketing_step3_subtitle: 'Email ke teman',
    my_marketing_minibook_step3_text1: 'Ceritakan latar belakang buku mini dengan mengirimkan tautan ke teman-temanmu',
    my_marketing_step3_text1: 'Impor daftar kontak',
    my_marketing_step3_placeholder: 'Unggah file csv atau vcf',
    my_marketing_step3_text2: 'Kirimkan cerita dan tautan ke teman',
    my_marketing_step3_text3: 'Impor daftar nomor telepon Anda',
    my_marketing_step3_placeholder2: 'Ceritakan kisahnya',
    my_marketing_event_step3_title: 'Pemasaran Acara Tahap 3',
    my_marketing_event_step3_text1: 'Ceritakan latar belakang acara dengan mengirimkan tautan ke teman-temanmu',
    my_marketing_text7: 'Impor nomor telepon',
    my_marketing_title2: 'Kelola nomor telepon',
    my_marketing_text8: 'Telepon',
    my_marketing_text9: 'Jumlah',
    my_marketing_text10: 'Impor kontak',
    my_marketing_text11: 'Silakan unggah file csv atau vcf',
    my_marketing_text12: 'Cara mengimpor',
    my_marketing_text13: 'Impor',
    my_marketing_title3: 'Kelola kontak',
    contact_manage: 'Manajemen Kontak',
    my_marketing_text14: 'Hapus yang dipilih',
    my_marketing_text15: 'Pilih teman',
    my_marketing_text16: 'Anda dapat memilih hingga 100 teman',
    my_marketing_text17: 'Unggahan selesai',
    my_marketing_text18: 'Jumlah karakter melebihi batas',
    contact_phone: 'Telepon',
    contact_organization: 'Organisasi',
    contact_title: 'Jabatan',
    contact_memo: 'Memo',
    my_marketing_text19: 'Edit pilihan',
    my_marketing_text20: 'Pilih label',
    my_marketing_text21: 'Tambahkan label baru',
    my_marketing_text22: 'Hapus label yang dipilih',
    my_marketing_text23: 'Tambah',
    my_marketing_btn2: 'Selesai diedit',
    my_marketing_text24: 'Pilih kontak yang ingin diedit',
    my_marketing_text25: 'Pilih label yang ingin dihapus',
    my_marketing_text26: 'Masukkan nama label',
    my_marketing_text27: 'Label ini sudah ada',
    my_marketing_text28: 'Tambah label',
    my_marketing_text29: 'Batal',
    my_marketing_text30: 'Berhasil ditambahkan',
    my_benefit_text1: 'Kamu telah mendapatkan sejauh ini',
    my_benefit_text2: 'Kamu akan mendapatkan dalam setahun',
    my_benefit_text3: '',
    my_benefit_text4: 'estimasi keuntungan',
    my_benefit_text5: 'estimasi keuntungan',
    my_benefit_text6: 'Lihatlah',
    my_benefit_modal_text1: 'Keuntungan yang Anda peroleh sejauh ini',
    my_benefit_modal_text2: 'Rp',
    my_benefit_modal_text3: 'Anda telah mendapatkan',
    my_benefit_modal_text4: 'Ayo kita lakukan perhitungan yang sangat sederhana',
    my_benefit_modal_text5: 'Jumlah halaman yang telah dibaca sejauh ini',
    my_benefit_modal_text6: 'Biaya untuk membuat sebuah halaman',
    my_benefit_modal_text7: 'Rp',
    my_benefit_modal_text8: 'Jadi keuntungan Anda adalah',
    my_benefit_modal_text9: 'Sekarang tambahkan keuntungan diskusi dengan',
    my_benefit_modal_text10: 'AI dan keuntungan Anda akan semakin besar',
    my_benefit_modal_text11: 'Gunakan setiap hari dan peroleh keuntungannya',
    my_benefit_modal_text12: 'Mengerti',
    my_story_text1: 'Apa yang dikatakan anggota',
    my_story_text2: 'Sadarilah bahwa buku itu pengalaman bukan bacaan',
    my_story_text3: 'Menakjubkan! segala hal yang terjadi ketika belajar setiap hari',
    my_story_text4: 'Jebakan tersembunyi dari orang yang cerdas apakah kamu salah satunya?',
    my_story_text5: 'Lihat lebih banyak cerita anggota lainnya',
    my_go_blog_text1: 'YouBook, Berita dan Kisah Pelanggan',
    my_go_blog_text2: 'Temukan berita terbaru dan kisah pelanggan dari YouBook',
    my_go_blog_text3: 'Pelajari lebih lanjut',
    my_channel_text1: 'Apa pendapatmu tentang YouBook?',
    my_channel_text2: 'Beri tahu apa yang sudah baik dan apa yang perlu kami lakukan supaya lebih baik',
    my_channel_text3: 'Dan beri tahu kami jika kamu mempunyai pertanyaan',
    my_channel_text4: 'Katakan sesuatu',
    my_about_youbook_text1: 'Alasan kenapa harus menggunakan YouBook',
    my_about_youbook_text2: 'Bantuan dan umpan balik disini',
    my_about_youbook_text3: 'Ketentuan Layanan',
    my_app_text1: 'Youbook adalah aplikasi yang 100% sangat bermanfaat.',
    my_app_text2: 'Unduh sekarang dan kembangkan cakrawala pengetahuan',
    my_app_text3: 'Unduh aplikasi',
    login_title: 'GABUNG',
    login_text1: 'Gabung dengan alamat email',
    login_text2: 'Belum terdaftar?',
    login_text3: 'Lupa kata sandi?',
    login_text4: 'atau Gabung melalui',
    login_text5: 'Saya setuju',
    login_placeholder1: 'Email masuk',
    login_placeholder2: 'Kata sandi',
    login_placeholder3: 'ID',
    login_message1: 'Silakan masukkan email masuk Anda',
    login_message2: 'Masukkan kata sandi Anda',
    login_message3: 'Berhasil bergabung',
    login_message4: 'Silakan masukkan ID Anda',
    logout_message1: 'Apakah anda Ingin keluar?',
    login_link1: 'Daftar',
    login_link2: 'Temukan',
    login_link3: 'Ketentuan Layanan',
    register_title: 'Daftar',
    register_text1: 'Daftar dengan email',
    register_text2: 'Pilih jenis keanggotaan',
    register_text3: 'Pribadi',
    register_text4: 'Organisasi',
    register_text5: 'Masukkan informasi Anda',
    register_text6: 'Sudah terdaftar?',
    register_text7: 'Nomor registrasi perusahaan/korporasi',
    register_text8: 'Nomor registrasi usaha',
    register_text9: 'Nama organisasi',
    register_placeholder1: 'Nomor telepon Anda termasuk dalam kode area',
    register_placeholder2: '(tanpa -)',
    register_placeholder_repassword: 'Masukkan ulang kata sandi',
    register_message1: 'Masukkan nomor telepon Anda',
    register_message2: 'Masukkan nomor registrasi perusahaan/korporasi',
    register_message3: 'Masukkan nomor registrasi usaha',
    register_message4: 'Masukkan nama organisasi',
    register_message5: 'Format email tidak valid',
    register_message6: 'Email ini sudah terdaftar',
    register_message7: 'Harap verifikasi email Anda',
    register_message8: 'Pilih kebangsaan Anda',
    register_message9: 'Format ID tidak valid',
    register_message10: 'ID yang Anda masukkan tidak tersedia. Gunakan ID yang disarankan atau masukkan ID lain',
    register_message11: 'Silakan verifikasi ID Anda',
    register_message12: 'ID ini sudah digunakan. Gunakan ID yang disarankan atau masukkan ID lain',
    register_button_verify: 'Verifikasi',
    register_button_verify_fail: 'Tidak Terverifikasi',
    register_button_verify_success: 'Terverifikasi',
    register_welcome_message: 'Selamat bergabung sebagai anggota',
    withdraw_text1: 'Pembatalan Keanggotaan',
    withdraw_text2: 'Batalkan Keanggotaan YouBook',
    withdraw_text3: 'Apakah Anda yakin ingin membatalkan?',
    withdraw_text4: 'Tidak',
    withdraw_text5: 'Ya',
    withdraw_text6: 'Keanggotaan Anda telah berhasil dibatalkan',
    home_memo_title: 'Memo',
    home_memo_subtitle: 'Jika tidak mengambil memo yang Anda lupa',
    home_memo_text1: 'Dibagikan bersama oleh semua orang',
    home_memo_text2: 'Pengetahuan dan cerita sehari-hari',
    home_memo_button: 'Tinggalkan memo',
    home_memo_create_text1: 'Punya buku mini yang ingin ditautkan?',
    home_memo_create_button: 'Cari buku mini',
    home_memo_create_button2: 'Pilih',
    home_memo_click: 'Klik',
    home_memo_date: 'DD.MM.YYYY',
    home_memo_button_askai: 'Komentar / Pemikiran Kucing Buku',
    home_memo_view_detail: 'Lihat detail',
    home_memo_view_placeholder: 'Masukkan sebuah tulisan',
    home_memo_view_button1: 'Komentar',
    home_memo_view_button2: 'Pemikiran Kucing Buku',
    home_memo_view_errormessage: 'Masukkan postingan',

    memo_create_title: 'Memo',
    memo_create_category1: 'Memo',
    memo_create_category2: 'Memo',
    memo_create_private: 'Pribadi',
    memo_create_public: 'Publik',
    memo_create_placeholder1: 'Punya ide?',
    memo_create_placeholder2: 'Tulis sekarang',
    memo_create_placeholder3: 'Kata kunci (kosongkan di antaranya)',
    memo_create_button: 'Simpan',
    memo_create_error: 'Masukkan memo Anda',
    memo_attach_img: 'Unggah gambar',
    memo_alert_rate: 'Pilih peringkat bintang Anda',
    memo_alert_save: 'Tersimpan. Anda dapat melihatnya di Profil saya - Perjalananku',
    memo_input_placeholder: 'Apa yang telah Kamu pelajari?',
    memo_input_placeholder2: 'Apa pendapatmu?',
    memo_input_placeholder3: 'Bagikan dengan pembaca sekarang~',
    memo_input_placeholder4: 'Kenangan dari kehidupan sehari-hari, dicatat yuk?',
    memo_alert_keywords: 'Masukkan kata kunci',
    memo_related_text: 'Memo',
    memo_related_date: 'DD.MM.YYYY',
    memo_popup_text1: 'Kisah Nicholas Luhmann ibarat dongeng di era moderen yang menunjukkan kekuatan perubahan dari sebuah kebiasaan  yang sederhana.',
    memo_popup_text3: 'Pada awalnya Luhmann merupakan seorang karyawan muda yang bekerja di sebuah perusahaan yang jauh dari kehidupan akademik.',
    memo_popup_text4: 'Namun, hobinya membaca membawanya pada sebuah kebiasaan yang sangat tidak biasa: membuat catatan harian atas apapun yang dibacanya.',
    memo_popup_text5: 'Kebiasaan ini berujung pada sebuah karya tulis yang menarik perhatian seorang sosiolog Jerman terkenal yang kemudian membawanya pada perubahan tak terduga dalam kariernya.',
    memo_popup_text6: 'Luhmann diundang untuk bergabung dengan sebuah Fakultas di Universitas Bielefeld yang mana di universitas tersebut ia diangkat menjadi seorang profesor.',
    memo_popup_text7: 'Sepanjang kiprahnya, ia telah menulis 60 buku serta berbagai artikel yang mengukuhkan predikatnya sebagai tokoh sosiologi.',
    memo_popup_text8: 'Luhmann mengaitkan kemampuan intelektualnya dengan metode pencatatannya yang mengatakan',
    memo_popup_text9: '“Saya terus mencatat”',
    memo_popup_text10: 'yang membantunya mengatur pola pikirnya serta memperdalam pemahamannya.',
    memo_popup_text11: 'Narasi ini berfungsi sebagai pengingat bahwa daya ingat mempunyai keterbatasan dan perlu diingat bahwa kemampuan untuk menangkap serta mereview kembali informasi secara sistematis untuk benar-benar melekat dalam ingatan kita memerlukan waktu',
    memo_popup_btn: 'Ya, saya dapat memahami',
    memo_text1: 'Simpan yang di atas',
    memo_text2: '(Cukup tambahkan kata kunci)',
    memo_text3: 'Hal yang harus diperiksa saat menulis',
    memo_text4: 'Postingan Anda melanggar aturan konten pada Pasal 2, Ayat 1 dari Ketentuan Layanan. Tidak akan dipublikasikan.',
    memo_text5: 'Lihat Ketentuan Layanan',
    memo_text6: 'Untuk meninggalkan memo dalam bahasa lain, ',
    memo_text7: 'silakan tulis dalam bahasa tersebut (tidak ada terjemahan otomatis)',
    book_create_button: 'Buatlah sebuah Buku Mini',
    book_create_title: 'Membuat sampul',
    book_create_cover: 'sampul',
    book_create_text1: 'Langkah-langkah untuk membuat sampul Buku  Mini',
    book_create_text1_pc: 'Masukkan judul dan nama penulis',
    book_create_text2: 'Anda belum membuat gambar sampul apa pun',
    book_create_text3: '',
    book_create_text4: 'Apakah kamu sudah membuat gambar sampul?',
    book_create_text5: 'Apakah Kamu membuat gambar sampulmu sendiri?',
    book_create_text6: 'Silakan unggah menggunakan tombol di bawah ini',
    book_create_text7: '(format jpg dengan ukuran maksimal 20MB)',
    book_create_text8: 'Klik Kanan untuk menambah halaman',
    book_create_text9: 'hanya aku',
    book_create_text10: 'siapa saja',
    book_create_text11: 'Tampilkan judul di gambar',
    book_create_text12: 'Tampilkan',
    book_create_text13: 'Jangan tampilkan',
    book_create_text14: 'Silakan pilih bahasa untuk diterjemahkan',
    book_create_text15: 'Pilih Semua',
    book_create_text16: 'Unggah gambar sampul',
    book_create_text17: 'Anda dapat mengedit',
    book_create_text18: 'Setelah diedit, klik ikon di kanan atas untuk menerjemahkan ulang',
    book_create_text19: 'Jika ingin menerjemahkan ulang sesuai aslinya, klik ikon di kanan atas',
    book_create_text20: 'Terjemahkan ulang',
    book_create_text21: 'Gambar',
    book_create_text22: 'Judul',
    book_create_text23: 'Kata kunci',
    book_create_text24: 'Konten',
    book_create_text25: 'Terjemahan hanya akan diperbarui jika gambar dihapus dan diunggah ulang',
    book_create_text26: '(Halaman tidak akan dihapus)',
    book_create_text27: 'Tuliskan pengantar singkat',
    book_create_text28: 'Simpan sementara',
    book_create_text29: 'Telah disimpan sementara',
    book_create_text30: 'Hal-hal yang perlu diperiksa',
    book_create_text31: 'Isi tulisan ini adalah versi final dan tidak memerlukan revisi lebih lanjut',
    book_create_text32: 'Tidak ada kata atau simbol yang tidak dapat dimengerti oleh AI penerjemah',
    book_create_text33: 'Gambar tidak disalin dan ditempel, tetapi dimasukkan sebagai file terpisah',
    book_create_text34: 'Mau buka perekrutan? (Buku mini terbuka)',
    book_create_text35: 'Penulis bersama',
    book_create_text36: 'Mau tambah secara manual?',
    book_create_text37: 'Tambah',
    book_create_text38: 'Buku mini yang menyebar lebih luas jika ditulis bersama',
    book_create_text39: 'Kekuatan penulis bersama yang belum Anda ketahui',
    book_create_text40: 'Buka perekrutan',
    book_create_text41: 'Batalkan',
    book_create_text43: 'Ide?',
    book_create_text44: 'Salin dan tempel konten',
    book_create_text45: 'Perlu ide?',
    book_create_text46: 'Opsi penjualan',
    book_create_text47: 'Gratis',
    book_create_text48: 'Sponsor',
    book_create_text49: 'Beli',
    book_create_text50: 'Harga saat ini',
    book_create_text51: 'Ubah harga',
    book_create_text52: 'Tidak dapat diubah ke 0',
    book_create_text53: 'Buku mini yang telah dibeli atau disponsori tidak dapat mengubah harga atau opsi penjualan',
    book_create_text54: 'Hanya penulis buku mini yang dapat membalas pesan',
    book_create_button_upload: 'Unggah',
    book_create_button_make: 'Membuat',
    book_create_cover_topic_placeholder: 'Judul akan terlihat seperti ini',
    book_create_topic_placeholder: 'Masukkan judul',
    book_create_keyword_placeholder: 'Kata kunci (kosongkan di antara keduanya)',
    book_create_category_placeholder: 'Pilih kategori',
    book_create_knowledge_placeholder: 'Tuliskan kata pengantar untuk Buku  Mini anda  ** Perhatian - Tuliskan detail langkah-langkah dalam membuat halaman per halaman',
    book_create_category_option1: 'Film dan Drama',
    book_create_category_option2: 'Musik dan Tari',
    book_create_category_option3: 'Seni Lainnya',
    book_create_category_option4: 'Pakaian dan Gaya',
    book_create_category_option5: 'Makanan dan Memasak',
    book_create_category_option6: 'Alkohol dan Minuman',
    book_create_category_option7: 'Camilan dan Makanan Penutup',
    book_create_category_option8: 'Tumbuhan dan Kesehatan',
    book_create_category_option9: 'Menjadi Kaya',
    book_create_category_option10: 'Pengembangan Diri',
    book_create_category_option11: 'Hubungan',
    book_create_category_option12: 'Pengetahuan Baru',
    book_create_category_option13: 'Cerita Kehidupan',
    book_create_category_option14: 'Filsafat dan Nilai',
    book_create_category_option15: 'Agama dan Tradisi',
    book_create_category_option16: 'Cinta',
    book_create_category_option17: 'Perjalanan dan Tempat Menarik',
    book_create_category_option18: 'Hobi',
    book_create_category_option19: 'Budaya Bermain',
    book_create_category_option20: 'Mitos dan Pahlawan',
    book_create_category_option21: 'Perjalanan Sastra',
    book_create_category_option22: 'Sejarah dan Kebijaksanaan',
    book_create_category_option23: 'Cerita Sosial',
    book_create_category_option24: 'Pengetahuan Umum',
    book_create_message1: 'Masukkan judul',
    book_create_message2: 'Masukkan nama penulis',
    book_create_message3: 'Masukkan kata kunci',
    book_create_message4: 'Masukkan lebih dari 3 kata kunci',
    book_create_message5: 'Pilih kategori',
    book_create_message6: 'Membuat gambar sampul',
    book_create_message7: 'Anda tidak dapat memasukkan karakter khusus. Diperlukan spasi di antara kata kunci.',
    book_create_message8: 'Apakah Kamu ingin menghapus Buku  Mini?',
    book_create_message9: 'Anda tidak memiliki hak cipta untuk pilihan bahasa ini',
    book_create_message10: 'Buku mini yang sudah dibeli tidak dapat dihapus',
    book_create_modal_text1: 'Mohon tunggu sebentar..',
    book_create_modal_text2: 'AI sedang meninjau konten, menerjemahkan bahasa asing, dan menghubungkan jaringan pengetahuan',
    book_create_modal_text3: 'Menghubungkan ke basis pengetahuan untuk pencarian halaman demi halaman',
    book_create_modal_text4: 'Judul tidak muncul di gambar sampul',
    book_create_modal_text5: '(Hal ini juga berlaku untuk sampul yang diterjemahkan ke bahasa asing)',
    book_view_title: 'Tinjauan singkat Buku  Mini',
    book_view_share: 'Berbagi',
    book_view_event_topic: 'Topik acara',
    book_view_together_suggest: 'Usulkan ruang acara',
    book_view_together_message: 'Anda tidak memiliki Bersama favorit, <br /> buka menu Bersama dan pilih satu',
    book_view_event_message: 'Saya belum membuat acara apa pun',
    book_view_text1: 'Tidak ada halaman yang ditambahkan.',
    book_view_text2: 'Mengapa Kamu tidak menambahkannya sekarang.',
    book_view_text3: 'Buku  Mini tidak ditemukan. Silakan coba lagi.',
    book_view_text4: 'Daftar Isi',
    book_view_text5: 'Bagaimana jika kita meningkatkan terjemahan buku mini ini atau mempromosikannya dan berbagi keuntungan?',
    book_view_text6: 'Daftar Halaman',
    book_view_text7: 'Mengubah harga',
    book_view_text8: 'Tidak dapat diedit karena sudah ada pembeli',
    book_view_text9: 'Hadiah dari pembaca',
    book_view_text10: 'Hanya penulis buku mini yang dapat membalas pesan',
    book_view_modal_title: 'Peningkatan Terjemahan & Promosi',
    book_view_modal_text1: 'Bisakah Anda memperbaiki terjemahan buku mini ini sendiri? Atau mempromosikannya?',
    book_view_modal_text2: 'Tinggalkan pesan untuk penulis',
    book_view_modal_text3: 'Jika penulis setuju, Anda bisa berbagi pendapatan',

    book_view_write_share_title: 'Buku mini terbuka',
    book_view_write_share_text1: 'Apakah Anda ingin menjadi penulis bersama buku mini ini??',
    book_view_write_share_text2: 'Ajukan sebagai penulis',
    book_view_write_share_text3: 'Tinggalkan permintaan singkat',
    book_view_write_share_text4: 'Kirim',
    book_view_write_share_list_title: 'Penulis bersama',
    book_view_write_share_text5: 'Kelola penulis bersama buku mini',
    book_view_write_share_text6: 'Kelola penulis',
    book_view_write_share_text7: 'Terima',
    book_view_write_share_text8: 'Diterima',
    book_view_write_share_text9: 'Pengguna sudah terdaftar sebagai penulis',
    book_view_write_share_text10: 'Tambah penulis secara manual',
    book_view_write_share_text11: 'Pengguna sudah mengajukan permohonan',
    book_view_publish_text1: 'Apakah Anda ingin menerbitkan Buku  Mini ini?',
    book_view_publish_text2: 'Menerbitkannya membuat itu terbuka untuk semua orang dan Anda bahkan dapat menghasilkan uang dari itu.',
    book_view_publish_text3: '(Jika Anda menerbitkan untuk dijual, Anda tidak dapat mengikutsertakan penulis lainnya)',
    book_view_publish_text4: 'Tentukan harga',
    book_view_publish_text5: 'Tanggal penerbitan',
    book_view_publish_text6: 'Mohon untuk diterbitkan',
    book_view_publish_text7: 'Publikasi Cepat',
    book_view_publish_text8: 'Jadwal Publikasi',
    book_view_publish_text9: 'Belum',
    book_view_publish_text10: 'Sedang dalam proses',
    book_view_publish_text11: 'Sudah diterbitkan',
    book_view_publish_text12: 'Hal-hal yang perlu diperiksa saat menerbitkan',
    book_view_publish_text13: 'Buku  Mini ini belum pernah diterbitkan di YouBook sebelumnya',
    book_view_publish_text14: 'Buku mini ini dan halamannya tidak mencuri konten atau hak kekayaan intelektual dari orang lain',
    book_view_publish_text15: 'Buku mini ini tidak mengandung kata-kata kasar, konten seksual berlebihan, fitnah terhadap orang lain, atau iklan komersial, dan mematuhi Pasal 2 Ayat 1 dalam Ketentuan Penggunaan',
    book_view_publish_text16: 'Ya',
    book_view_publish_text17: 'Laporan publikasi',
    book_view_publish_text18: 'Sudah diterbitkan',
    book_view_publish_text19: 'Tanggal',
    book_view_publish_text20: 'Harga',
    book_view_publish_text21: 'Menetapkan periode terbuka',
    book_view_publish_text22: 'Periode terbuka',
    book_view_publish_text23: 'Apa itu periode terbuka',
    book_view_publish_text24: 'Periode terbuka merujuk pada waktu di mana pembaca dapat melihat konten tersebut',
    book_view_publish_text25: 'Buku mini ini berisi lebih dari 3 halaman',
    book_view_publish_text26: 'Buku mini ini tidak berisi lebih dari 3 halaman',
    book_view_publish_text27: 'Jika terdapat pelanggaran, algoritma dapat menyesuaikan peringkat pencarian. Untuk masalah serius, buku mini akan dihapus secara otomatis',
    book_view_publish_text28: 'Atur opsi penjualan',
    book_view_publish_text29: 'Metode pembelian',
    book_view_publish_text30: 'Metode dukungan',
    book_view_publish_message1: 'Jika Anda menerbitkan untuk dijual, pastikan terlebih dahulu bahwa 1) halaman-halaman dalam Buku MiniAnda dibuat oleh Anda sendiri dan 2) Anda belum pernah menerbitkannya dengan memasang harga',
    book_view_publish_message2: 'Buku tersebut tidak tersedia dalam kondisi dapat diterbitkan. Silakan menghubungi administrator untuk memperoleh bantuan',
    book_view_publish_message3: 'Buku  Mini ini telah diterbitkan',
    book_view_publish_message4: 'Silakan pilih periode terbuka setelah waktu saat ini',
    book_view_publish_message5: 'Silakan pilih tanggal dan waktu',
    book_view_publish_message6: 'Permohonan publikasi telah disetujui. Terima kasih',
    book_view_publish_message7: 'Silakan periksa item yang telah dikonfirmasi',
    book_view_publish_message8: 'Tanggal selesai tidak boleh lebih awal dari tanggal mulai',
    book_view_publish_message9: 'Buku mini yang disimpan sementara tidak dapat dipublikasikan',
    book_view_publish_message10: 'Buku mini ini telah dialihkan. Hak publikasi awal dimiliki oleh penulis.',
    book_view_publish_message11: 'Silakan masukkan jumlah minimal {minPrice}',
    book_view_button_confirm: 'Dikonfirmasi',
    book_view_button_publish: 'Publikasikan',
    book_view_button_order: 'Penyelarasan halaman',
    book_view_button_add: 'Tambah halaman',
    book_view_button_video: 'Putar video',
    book_view_button_read: 'Baca',
    book_view_button_lecture: 'Tonton video perkuliahan',
    book_view_page_add_title: 'Tambah halaman',
    book_view_page_add_text1: 'Setelah mencari halaman Pihak ketiga',
    book_view_page_add_text2: 'Lihat pada tampilan layar',
    book_view_page_add_text3: 'Tambah ke Buku  Mini',
    book_view_page_add_text4: 'Bagaimana jika kamu ingin membuat halamanmu sendiri?',
    book_view_page_add_text5: 'Membuat halaman sendiri hanya tersedia untuk penulis yang sudah terdaftar.  Jika Anda ingin mendaftar sebagai penulis, silakan hubungi kami di bawah ini.',
    book_view_page_add_text6: 'Apakah kamu ingin menambahkan halaman Pihak ketiga?',
    book_view_page_add_text7: '* Jika kamu menambahkan halaman yang dibuat oleh Pihak ketiga, \nmaka tidak dapat diterbitkan sebagai Buku Mini berbayar',
    book_view_page_add_text8: 'Apakah kamu sudah pernah membuat halaman sebelumnya?',
    book_view_page_add_button1: 'Buat sekarang',
    book_view_page_add_button2: 'Lihat Halaman yang dibuat',
    book_view_reference_text1: 'Keberagaman',
    book_view_reference_text2: 'Banyak',
    book_view_reference_text3: 'Penulis Buku  Mini',
    book_view_reference_text4: 'Dibuat oleh penulis',
    book_view_support_text1: 'Saya mendukungmu',
    book_view_support_modal_title: 'Jadilah pendukung',
    book_view_support_modal_text1: 'Bahkan tulisan yang bagus pun sulit menyebar sendirian.',
    book_view_support_modal_text2: 'Pendukung adalah orang yang membagikan buku mini penulis kepada dunia dan saling mendukung.',
    book_view_support_modal_text3: 'Mari kita sebarkan cerita ini lebih jauh bersama-sama.',
    book_view_support_modal_text4: 'Mohon dukung penulisnya',
    book_view_support_modal_btn1: 'Mengerti',
    book_view_support_modal_text5: '"Dukunganmu sangat berarti bagi saya. Terima kasih. Saya juga akan mendukung perjalananmu sepenuh hati."',
    book_view_support_modal_text6: 'Bagikan buku mini ini kepada dunia',
    book_view_support_modal_btn2: 'Bagaimana caranya?',
    book_view_support_modal_title2: 'Terima kasih untuk diriku yang sudah sampai sejauh ini',
    book_view_support_modal_text7: 'Menulis tidak mudah, tetapi saya berhasil.',
    book_view_support_modal_text8: 'Sekarang saatnya percaya pada diri sendiri dan melangkah lebih jauh.',
    book_view_support_modal_text9: 'Meski sedikit malu dan ragu, saya tetap mendukung diri sendiri dan membagikan perasaan saya kepada dunia.',
    book_view_support_modal_text10: 'Karena saya percaya ini bisa berarti bagi seseorang.',
    book_view_support_modal_text11: 'Mohon jadi pendukungku',
    book_view_support_modal_text12: 'Menulis atau menyelenggarakan acara itu tidak mudah, tapi saya telah mencobanya.',
    book_view_support_modal_btn3: 'Saya akan coba!',
    book_view_support_modal_title3: 'Halo, pendukung',
    book_view_open_minibook_text1: 'Permintaan Buku Mini Terbuka Anda telah selesai',
    book_view_open_minibook_text2: 'Permintaan Buku Mini Terbuka Anda telah dibatalkan',
    page_create_title: 'Membuat halaman',
    page_create_text1: ' Kamu belum membuat gambar halaman apa pun',
    page_create_text2: '',
    page_create_text3: 'halaman',
    page_create_text4: 'Sudahkah kamu menciptakan gambar halaman?',
    page_create_text5: 'Apakah Anda sudah membuat gambar halaman?',
    page_create_text6: 'Masukkan kontenmu. Disarankan tidak lebih dari satu lembar A4.',
    page_create_text7: 'Ukuran byte sekarang',
    page_create_text8: 'Merekomendasikan',
    page_create_text9: 'Ada referensi di halaman ini?',
    page_create_text10: 'Dibuat olehmu',
    page_create_text11: 'Referensi buku',
    page_create_text12: 'Referensi blog',
    page_create_text13: 'AI yang dirujuk',
    page_create_text14: 'Ini adalah langkah untuk membuat halaman untuk Buku  Mini',
    page_create_text15: 'Unggah gambar halaman',
    page_create_text16: 'Apakah Anda ingin menerjemahkan ulang?',
    page_create_text17: 'Jika Anda ingin menerjemahkan ulang, silakan pilih target dan bahasa (jika tidak dipilih, akan disimpan tanpa terjemahan)',
    page_create_text18: 'Target terjemahan',
    page_create_text19: 'Bahasa terjemahan',
    page_create_message1: 'Tidak dapat dimodifikasi',
    page_create_message2: 'Masukkan konten Anda',
    page_create_message3: 'Ingin hapus halaman?',
    page_create_message4: 'Konten melebihi ukuran maksimum',
    page_create_reference_book: 'buku',
    page_create_reference_blog: 'blog',
    page_create_reference_placeholder1: 'Masukkan judul dari',
    page_create_reference_placeholder2: 'Tautan terkait (mis. https://www.amazon.com/dp...)',
    page_create_reference_placeholder3: 'Tahun publikasi dari',
    page_create_reference_placeholder4: 'Penulis dari',
    page_create_title_placeholder: 'Judul akan terlihat seperti ini',
    page_create_message5: 'Proses penerjemahan sedang berlangsung',
    page_create_message6: 'Setelah membuat hanya aku, Anda dapat membuat halaman',
    page_create_modal_text1: 'Judul tidak muncul di gambar halaman',
    page_create_modal_text2: '(Hal ini juga berlaku untuk halaman yang diterjemahkan ke bahasa asing)',
    page_create_modal_text3: 'Harap pastikan untuk memeriksa!',
    page_create_modal_text4: 'Jika konten telah berubah, Anda harus simpan sementara.',
    page_create_modal_text5: 'Apakah Anda sudah melakukannya?',
    page_create_modal_text6: 'Jika konten telah berubah, Anda harus membuat.',
    page_view_title: 'Lihat halaman',
    page_view_button_video: 'Putar video',
    page_view_button_read: 'Baca',
    page_view_text1: 'Buku MiniKu',
    page_view_text2: 'Putar otomatis',
    page_view_text3: 'Dibaca',
    page_view_text4: 'Halaman terkait',
    page_view_text5: 'Buku  Mini terkait',
    page_view_text6: 'Referensi',
    page_view_text7: 'Referensi',
    page_view_text8: 'Publikasi',
    page_view_text9: 'Penulis',
    page_view_text10: 'Judul',
    page_view_text11: 'Semua halaman dari referensi ini',
    page_view_text12: 'Pencarian terkait',
    page_view_text13: 'Halaman tentang Penulis',
    page_view_text14: 'Hubungi penulis',
    page_view_text15: 'Masukkan',
    page_view_reference_text1: 'Buku',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'Tidak ada Buku Mini yang dibuat olehmu.  Silakan buat satu di halamanku.',
    page_view_pay_popup_text1: 'Apakah kamu mendapatkan sesuatu dari bacaan ini? \nTunjukkan apresiasimu dengan hadiah kecil untuk penulis.',
    page_view_pay_popup_title: 'Kirim Hadiah',
    page_view_pay_popup_text2: 'Pilih teh untuk dikirim sebagai hadiah',
    page_view_pay_popup_text3: 'Tulis pesan dari hati',
    page_view_pay_popup_placeholder1: 'Kata-kata dan kebijaksanaan penulis sangat membantu saya.',
    page_view_pay_popup_text4: 'Jumlah',
    page_view_pay_popup_button1: 'Beli & Kirim Pesan',
    page_view_pay_popup_text5: 'Penulis menghabiskan banyak waktu dan usaha untuk menulis ini.\n\nBalaslah dengan hadiah kecil.',
    page_view_pay_popup_placeholder2: 'Saya percaya pada kebijaksanaan dan ketulusan penulis.',
    page_view_pay_popup_text6: 'Tidak ingin mengirim hadiah?',
    page_view_pay_popup_text7: 'Ingin menonton iklan sebagai gantinya?',
    page_view_pay_popup_button2: 'Tonton iklan untuk membaca',
    page_sort_title: 'Penyelarasan halaman',
    page_sort_subtitle: 'Seret halaman untuk mengubah urutan',
    page_sort_text: 'Sumber',
    pay_button: 'Beli sekarang',
    pay_price: 'Harga',
    pay_vat_excluded: '(Belum termasuk PPN)',
    pay_message_success: 'Dibeli',
    pay_message_fail: 'Gagal',
    pay_currency: 'Rp',
    pay_button_paid: 'Dibayar',
    pay_button_view_price: 'Lihat Harga',
    pay_total: 'Total',
    pay_methods: 'Metode pembayaran',
    pay_methods_creditcard: 'Kartu kredit',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Lanjutkan',
    pay_text1: 'Silakan pilih teh',
    pay_text2: 'Silakan masukkan pesan',
    advertisement_button: 'Baca selengkapnya',
    advertisement_text1: 'Anda dapat melihat konten setelah menonton iklan.',
    advertisement_text2: 'Ini adalah halaman dari buku mini berbayar. <br />Pergi ke sampul dan tekan Baca untuk membeli. <br />',
    advertisement_text3: 'Anda dapat melihat konten setelah menonton iklan. Iklan hanya dapat ditonton di dalam aplikasi.',
    together_title: 'Acara',
    together_subtitle: 'Temui dan berbicara dengan pembaca',
    together_subtitle_text1: 'Temui pembaca secara online',
    together_subtitle_text2: 'Buatlah grup dan undanglah yang lain',
    together_button: 'Buat ruang acara',
    together_case: 'Kasus',
    together_case1: 'Saya mencoba memberikannya kepada seseorang tetapi saya terus memperolehnya',
    together_case2: 'Belum pernah mengetahui contoh nyata yang sangat membantu',
    together_subtitle2: 'Ruang yang saya buat',
    together_category1: 'Terbaru',
    together_category2: 'Paling favorit',
    together_button_viewmore: 'Lainnya',
    together_list_date: 'DD.MM.YYYY',
    together_list_date2: 'DD.MM.YYYY A hh:mm',
    together_subtitle3: 'Ruang seperti ini',
    together_subtitle3_1: 'Tolong buatkan',
    together_subtitle_text3: 'Siapapun yang memulai, saya akan berpartisipasi',
    together_create_title: 'Buat ruang acara',
    together_create_title2: 'Edit ruang acara',
    together_create_button1: 'Pilih',
    together_create_subtitle: 'Judul',
    together_create_placeholder1: 'Ketik judul',
    together_create_subtitle1: 'Kata Pengantar',
    together_create_placeholder2: 'Masukkan kata pengantar',
    together_create_subtitle2: 'Pilih mode yang akan digunakan',
    together_create_text1: 'Tautan pertemuan online (misalnya, tautan Zoom)',
    together_create_placeholder3: 'Silakan masukkan tautan pertemuan online',
    together_create_question1: 'Tidak mengetahui tautan zoom?',
    together_create_q1_a_title: 'Temukan tautan untuk bergabung dengan zoom',
    together_create_text2: 'Gunakan metaverse',
    together_create_placeholder4: 'Pilih satu yang paling cocok Bersama-sama',
    together_create_question2: 'Tidak tahu metaverse?',
    together_create_text3: 'Pilih dimana untuk membuka',
    together_create_dropmenu1: 'Buka di YB pojok intelektual',
    together_create_dropmenu2: 'Buka di pojok penulis dan pembaca',
    together_create_button2: 'Menyimpan',
    together_create_button3: 'Membuat',
    together_create_popup_title: 'Pilih satu yang paling cocok Bersama-sama',
    together_create_popup_alert: 'Sudah dipilih',
    together_create_button4: 'Pilih',
    together_create_alert: 'Harap masukkan tautan rapat online',
    together_create_alert1: 'Ketik judul',
    together_create_alert2: 'Pilih metaverse yang akan digunakan',
    together_create_alert3: 'Tidak dapat mengedit',
    together_create_alert4: 'Ruang acara berhasil dibuat',
    together_create_alert5: 'ada kesalahan, coba lagi',
    together_create_alert6: 'Gagal membuat ruang acara...',
    together_qa_popup_title1: 'Menemukan tautan untuk bergabung dengan Zoom',
    together_qa_popup_btext1: 'Komputer',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Buka aplikasi Zoom - Setelah log in - Klik menu rapat di bagian atas - ID rapat pribadi saya - Klik Tampilkan undangan rapat - Tautan untuk bergabung dengan rapat Zoom akan muncul. Salin tautan tersebut.',
    together_qa_popup_btext2: 'Ponsel cerdas',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Buka aplikasi Zoom - Setelah log in - Tekan tombol i di kanan atas - Kirim undangan - Setelah menekan pesan - Masukkan nomor telepon Anda - Tautan akan muncul. Salin itu.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'Apa itu metaverse?',
    together_qa_popup_text3: 'Ini adalah ruang virtual.',
    together_qa_popup_text4: 'Muncul dalam bentuk avatar',
    together_qa_popup_text5: 'yang Anda buat - Berbicara dengan teman Anda secara langsung - Kamu juga bisa berbagi layar.',
    together_qa_popup_text7: 'Dalam satu ruang pertemuan',
    together_qa_popup_text8: '- 10 orang dapat masuk pada waktu yang sama.',
    together_qa_popup_text9: 'Tidak perlu menginstal program yang terpisah',
    together_qa_popup_text10: 'atau tidak memerlukan registrasi keanggotaan.',
    together_more_list_title: 'Ruang acara',
    together_more_list_date: 'DD.MM.YYYY',
    together_request_list_title: 'Tolong buatkan',
    together_request_list_category1: 'Paling favorit',
    together_request_list_category2: 'Terbaru',
    together_request_list_button: 'Usulkan ruang baru',
    together_request_popup_title: 'Saran ruang baru',
    together_request_popup_alert1: 'Ketik judul',
    together_request_popup_alert2: 'Masukkan kata pengantar',
    together_request_popup_placeholder1: 'Ketik judul',
    together_request_popup_placeholder2: 'Masukkan kata pengantar',
    together_request_popup_button: 'Simpan',
    together_request_detail_button: 'Buat ruang ini',
    together_detail_sns: 'Bagikan',
    together_detail_enterbtn: 'Masukkan',
    together_detail_btn1: 'Daftar acara',
    together_detail_btn2: 'Pesan',
    together_detail_subtitle: 'Buku Mini tentang topik ini',
    together_detail_alert: 'Tunggu sebentar..',
    together_detail_alert1: 'Berhasil mengusulkan ruang acara!',
    together_detail_alert2: 'Gagal mengusulkan ruang acara…',
    together_detail_alert3: 'Favorit / Berhasil membatalkan favorit',
    together_detail_alert4: 'Favorit / Gagal membatalkan favorit',
    together_detail_alert5: 'Permasalahan pada server, silakan coba nanti',
    together_detail_alert6: 'Ada masalah dengan tautan pertemuan online',
    together_detail_alert7: 'Gagal hapus',
    together_notice_alert: 'Ingin menghapus pengumuman?',
    together_notice_list_title: 'Pengumuman',
    together_button_addtopic: 'Tambahkan ini sebagai topik ke ruang acara',
    together_add_alert: 'Berhasil ditambahkan ke ruang acara',
    together_text1: 'Selera yang mungkin mirip denganmu',
    together_text2: 'Apakah Anda ingin menghapus ruang acara ini?',
    together_event_btn: 'Buat acara baru',
    together_event_title: 'Acara baru',
    together_event_placeholder: 'Masukkan deskripsi',
    together_event_text1: 'Tentukan jadwal',
    together_event_text2: 'Tentukan biaya masuk',
    together_event_text3: 'Tentukan kapasitas maksimum',
    together_event_text4: 'Jadwal',
    together_event_text5: 'Biaya Masuk',
    together_event_text6: 'Kapasitas Maksimum',
    together_event_text7: 'Beri tahu pengikut saya',
    together_event_text8: 'Apakah Anda ingin menghapus acara?',
    together_event_text9: 'Harap atur waktu mulai setelah waktu saat ini',
    together_event_text10: 'Harap atur waktu selesai setelah waktu mulai',
    together_event_text11: 'Waktu mulai dan waktu selesai tidak boleh sama',
    together_event_text12: 'Tambahkan ini sebagai topik acara',
    together_event_text13: 'Telah ditambahkan ke acara',
    together_event_text14: 'Acara telah melebihi kapasitas maksimum',
    together_event_text15: 'Tombol akan aktif 1 jam sebelum Acara \n(jika gratis tidak perlu Beli sekarang)',
    together_event_text16: 'Tombol akan aktif 1 jam sebelum Acara',
    together_event_text17: 'Tidak ada acara',
    together_event_text18: 'Tidak dapat dihapus jika ada pembeli untuk acara tersebut',
    together_event_text19: 'Apakah Anda ingin mengirim pemberitahuan?',
    together_event_text20: 'Terkirim',
    together_event_text21: 'Daftar acara',
    together_event_text22: 'Lihat detail',
    together_event_text23: 'Setelah Daftar silakan masuk',
    together_event_text24: 'Cara hadir',
    together_event_text25: 'Partisipasi acara selesai',
    together_event_text26: 'Penulis telah mencurahkan banyak waktu dan perhatian untuk acara ini.\n\nSilakan balas dengan hadiah kecil.',
    together_event_text27: 'Kebijaksanaan dari pengalaman penulis dan komunikasi yang mendalam sangat mengesankan',
    together_event_text28: 'Bagikan acara ini ke seluruh dunia',
    together_event_text29: 'Membuka acara ini tidaklah mudah, tapi saya berhasil.',
    together_event_text30: 'Sebagus apa pun acaranya, sulit untuk menyebarkannya ke dunia sendirian.',
    together_event_text31: 'Seorang pendukung adalah orang yang membantu menyebarkan acara penulis ke dunia. Mereka saling mendukung.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Bertemu orang-orang dari seluruh dunia',
    youbooker_case: 'Kasus',
    youbooker_case_text1: 'Selalu menjadi orang yang pertama memulainya',
    youbooker_case_text2: 'Efek atau kepentingan yang berpengaruh pada ilmu pengetahuan?',
    youbooker_translation: 'Mau bertemu sekarang juga?',
    youbooker_translation_text1: 'Semua bahasa',
    youbooker_category: 'Pengikut / Mengikuti',
    youbooker_subcategory1: 'Pengikut saya',
    youbooker_subcategory2: 'Saya mengikuti',
    youbooker_subtitle2: 'Ini yang mengikuti saya',
    youbooker_button_follow: 'Mengikuti',
    youbooker_message_follow: 'Mengikuti',
    youbooker_button_follow_cancel: 'Berhenti mengikuti',
    youbooker_subtitle3: 'Ini adalah pengguna yang Anda kenal',
    youbooker_subtitle4: 'Saya mengikuti',
    youbooker_subtitle5: 'Mereka ini yang belum mengenal YB',
    youbooker_button_invite: 'Mengundang',
    youbooker_alert_invite: 'Mengundang hanya dapat dilakukan melalui aplikasi, silakan unduh aplikasinya',
    youbooker_alert: 'Hanya tersedia di aplikasi. Mengapa tidak mengunduh aplikasi?',
    youbooker_alert2: 'Penyegaran berhasil!',
    youbooker_alert3: 'Anda dapat mencari di tab youBooker',
    home_page_text1: 'Terbaru',
    home_page_text2: 'Pengaruh',
    home_page_today_title: 'Topik hari ini',
    home_page_today_subtitle: 'berkaitan dengan berita utama',
    home_page_slider_date: 'DD.MM.YYYY',
    home_page_today_list_title: 'Topik hari ini',
    home_page_today_detail_sns: 'Bagikan',
    home_page_today_detail_date: 'DD.MM.YYYY',
    home_page_today_detail_subtitle: 'Halaman terkait',
    home_page_explor_title: 'Jelajahi halaman',
    home_page_explor_subtitle: 'Bagaimana jika klik dua kali?',
    home_page_recommend_title: 'Rekomendasi',
    home_page_recommend_subtitle: 'Halaman yang mungkin menarik bagi Anda',
    home_page_theysee_title: 'Apa sajakah yang mereka lihat',
    home_page_theysee_subtitle: 'Halaman yang paling sering dilihat pembaca',
    home_page_common_title: 'Akal sehat',
    home_page_common_subtitle: 'Kamu lebih baik mengetahui ini',
    home_page_keyw_title: 'Halaman berdasarkan kata kunci',
    home_page_keyw_subtitle: 'Temukan semua halaman terkait',
    home_page_random_title: 'telusuri secara acak',
    home_page_random_subtitle: 'Tekan saat mengalami kebingungan Lalu temukan sesuatu yang tidak disangka-sangka',
    home_page_about_title: 'Tentang YouBook',
    home_page_about_detail: 'Perusahaan NICK syndicate / pusat bisnis Indonesia: Jakarta / Pusat negara lain: Tokyo Shanghai Seoul Seattle / Kontak: joa@academy-connect.net / DUNS 695937905',
    settlement_title: 'Pembelian & Penyelesaian transaksi',
    settlement_tab1: 'Catatan pesanan',
    settlement_tab2: 'Info akun',
    settlement_tab3: 'Catatan penyelesaian',
    settlement_category1: 'Catatan Pembelian Saya',
    settlement_category2: 'Berbagi hak penulis',
    settlement_category3: 'Catatan penyelesaian pendapatan buku mini',
    settlement_category4: 'Catatan penyelesaian pendapatan acara',
    settlement_category5: 'Kelola rekening',
    settlement_text1: 'Riwayat pembelian Anda ditampilkan',
    settlement_text2: 'Anda dapat berbagi hak penulis dari buku mini',
    settlement_text3: 'Anda memeriksa catatan penyelesaian Buku  Mini berbayar Anda.',
    settlement_text4: 'Jika Anda memiliki pertanyaan tambahan, klik',
    settlement_text5: 'di sini',
    settlement_text6: 'Atau silakan hubungi kami di bawah ini.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Katakan sesuatu',
    settlement_text9: 'Jika ada pendapatan, Anda harus mengelola rekening untuk menerima pembayaran',
    settlement_text10: 'Pendapatan dari acara akan diselesaikan',
    settlement_purchase_text1: 'Catatan Pembelian',
    settlement_purchase_text2: 'Tanggal',
    settlement_purchase_text3: 'Jumlah Pembelian',
    settlement_purchase_text4: 'Judul',
    settlement_purchase_text5: 'Buku Mini',
    settlement_purchase_text6: 'Acara',
    settlement_accountInfo_text1: 'Hak penulis dari buku mini',
    settlement_accountInfo_text2: 'Buku  Mini',
    settlement_accountInfo_text3: 'Bahasa',
    settlement_accountInfo_text4: 'Hak penulis',
    settlement_accountInfo_text5: 'Penulis',
    settlement_accountInfo_text6: 'Pihak ketiga',
    settlement_accountInfo_text7: 'Pribadi?',
    settlement_accountInfo_text8: 'Pribadi',
    settlement_accountInfo_text9: 'Perusahaan',
    settlement_accountInfo_text10: 'Nama bank',
    settlement_accountInfo_text10_message: 'Pilih nama Bank',
    settlement_accountInfo_text11: 'Nama pemilik rekening',
    settlement_accountInfo_text11_message: 'Masukkan nama pemilik rekening',
    settlement_accountInfo_text12: 'Nomor rekening',
    settlement_accountInfo_text12_message: 'Masukkan nomor rekening',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Nomor kartu BPJS',
    settlement_accountInfo_text13_message: 'Masukkan nomor BPJS',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Alamat pribadi',
    settlement_accountInfo_text14_message: 'Masukkan alamat pribadi',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'Email',
    settlement_accountInfo_text15_message: 'Masukkan email',
    settlement_accountInfo_text16: 'Simpan',
    settlement_accountInfo_text17: 'Nomor kartu kuning (kartu mencari Kerja',
    settlement_accountInfo_text17_message: 'Masukkan Nomor kartu kuning (kartu pencari kerja) ',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Alamat perusahaan',
    settlement_accountInfo_text18_message: 'Masukkan alamat perusahaan',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'Nama perusahaan',
    settlement_accountInfo_text19_message: 'Masukkan nama perusahaan',
    settlement_accountInfo_text20: 'Telepon perusahaan',
    settlement_accountInfo_text20_message: 'Masukkan kontak perusahaan',
    settlement_accountInfo_text21: 'ID pihak ketiga',
    settlement_accountInfo_text21_placeholder: 'Email pihak ketiga',
    settlement_accountInfo_text22: 'Akun untuk menerima pembayaran',
    settlement_accountInfo_text23: 'Negara',
    settlement_accountInfo_message1: 'Email tidak dapat ditemukan',
    settlement_accountInfo_message2: 'Anda tidak dapat berbagi hak penulis dengan diri sendiri',
    settlement_accountInfo_message3: 'Tidak ada Buku Mini yang dibuat',
    settlement_accountInfo_text24: 'Berbagi hak penulis',
    settlement_accountInfo_text25: 'Jika Anda berbagi hak penulis dengan pihak ketiga, maka tidak dapat dibatalkan',
    settlement_accountInfo_text26: 'Apakah Anda ingin berbagi hak penulis?',
    settlement_accountInfo_text27: 'Ya, saya berbagi',
    settlement_accountInfo_text28: 'Dalam berbagi hak penulis,<br /> 1) halaman dalam buku mini harus dibuat oleh Anda dan <br /> 2) belum pernah dibagikan ke pihak ketiga',
    settlement_accountInfo_text29: 'Baik, saya akan memperbaikinya',
    settlement_accountInfo_text30: 'Anda telah membagikan hak penulis buku mini ini ke pihak ketiga',
    settlement_accountInfo_text31: 'Penulis',
    settlement_accountInfo_text32: 'Pihak ketiga',
    settlement_accountInfo_text33: 'Anda telah menerima hak penulis buku mini ini dari penulis',
    settlement_accountInfo_text34: 'Ini adalah buku  Mini gratis. Tidak memerlukan akun.',
    settlement_accountInfo_text35: 'Bagi Hasil',
    settlement_accountInfo_text36: '(saya)',
    settlement_accountInfo_text37: '(penerbit, dll.)',
    settlement_accountInfo_text38: 'Rekening pribadi',
    settlement_accountInfo_text39: 'Rekening perusahaan',
    settlement_accountInfo_text40: 'Manajemen rekening',
    settlement_accountInfo_text41: 'Simpan',
    settlement_accountInfo_text42: 'Bank',
    settlement_accountInfo_text43: 'Pemilihan rekening',
    settlement_accountInfo_text44: 'Tentukan cara membagi pendapatan',
    settlement_accountInfo_text45: 'Tingkat pendapatan (%)',
    settlement_accountInfo_text46: 'ID saya (email)',
    settlement_accountInfo_text47: 'ID pihak ketiga (email)',
    settlement_accountInfo_text48: 'Sesuaikan total',
    settlement_accountInfo_text49: 'Silakan masukkan informasi penerima hak',
    settlement_accountInfo_text50: 'Tingkat pendapatan tidak boleh melebihi 100',
    settlement_accountInfo_text51: 'Pemberi hak ID(email)',
    settlement_accountInfo_text52: 'Penerima hak ID(email)',
    settlement_earnings_text1: 'Catatan penyelesaian',
    settlement_earnings_text2: 'Periode penyelesaian',
    settlement_earnings_text3: 'Harga Buku  Mini',
    settlement_earnings_text4: 'Jumlah penjualan',
    settlement_earnings_text5: 'Jumlah penjualan',
    settlement_earnings_text6: 'Potongan termasuk pajak',
    settlement_earnings_text7: 'Jumlah setoran',
    settlement_earnings_text8: 'Tanggal penyetoran',
    settlement_earnings_text9: 'Tayangan iklan',
    settlement_earnings_text10: 'Jumlah total',
    settlement_earnings_text11: 'Pelajari lebih lanjut',
    settlement_earnings_text12: 'Harga iklan',
    settlement_earnings_text13: 'Pendapatan',
    settlement_earnings_text14: 'Semua buku mini',
    settlement_earnings_text15: 'Pilih Acara',
    settlement_earnings_text16: 'Semua Acara',
    settlement_statistics_text1: 'Volume penjualan',
    settlement_statistics_text2: 'Jumlah pembaca',
    settlement_statistics_text3: '(lalu)',
    settlement_statistics_text4: '1 bulan',
    settlement_statistics_text5: '6 bulan',
    settlement_statistics_text6: '1 tahun',
    settlement_statistics_text7: 'Tidak ada data yang ditemukan',
    settlement_statistics_text8: 'Analisis penjualan',
    settlement_statistics_text9: 'Tampilan iklan',
    settlement_statistics_text10: 'Semua bahasa',
    terms_title: 'Ketentuan Layanan',
    terms_text: '',
    privacy_title: 'Kebijakan Privasi',
    privacy_text: '',
    // common text
    message_save: 'Tersimpan',
    message_fail: 'Gagal',
    message_delete: 'Dihapus',
    message_report: 'Dilaporkan',
    message_search_no_result: 'Tidak ditemukan hasil pencairan',
    message_search_enter: 'Silakan masukkan topik pencarian',
    message_error1: 'Telah terjadi kesalahan. Silakan hubungi administrator',
    message_save2: 'Disimpan',
    message_fail2: 'Gagal',
    message_login: 'Anda perlu LOGIN',
    name: 'Nama',
    email: 'Email',
    mobile: 'Ponsel',
    list: 'Daftar',
    edit: 'Edit',
    delete: 'Hapus',
    search: 'Cari',
    report: 'Laporkan konten',
    user: 'Pengguna',
    report_type: 'Jenis laporan',
    report_type1: 'Kata-kata tidak senonoh/Pencemaran nama baik',
    report_type2: 'Iklan',
    report_type3: 'Kecabulan/ Eksplisit secara seksual',
    report_type4: 'Mengulang kembali konten yang sama',
    report_type5: 'Lainnya',
    search_book: 'Cari Buku  Mini',
    serch_placeholder: 'Cari berdasarkan nama atau email',
    search_keyword: 'Kata kunci',
    search_reference: 'Referensi',
    search_author: 'Penulis',
    search_result: 'Menemukannya',
    button_report: 'Laporkan ke YouBook',
    button_write: 'Simpan',
    button_login: 'MASUK',
    button_more: 'Lainnya',
    button_confirm: 'Dikonfirmasi',
    button_save: 'Simpan',
    button_crop: 'Pangkas',
    button_delete: 'Hapus',
    button_complete: 'menyelesaikan',
    colorbox_background_text1: 'Memilih warna latar belakang',
    colorbox_font_text1: 'Memilih warna teks',
    menu_home: 'Beranda',
    menu_page: 'Halaman',
    menu_book: 'Buku  Mini',
    menu_memo: 'Memo',
    menu_together: 'Acara',
    login_button: 'MASUK',
    message_text1: 'Balas',
    message_text2: 'Ada balasan di komentar saya nih',
  },
  it: {
    home_banner_title1: 'Nuovo minilibro',
    home_banner_title2: 'Nuovo evento',
    home_slide_title1: 'Di tendenza ora',
    home_slide_title2: 'Il mio gusto',
    home_slide_title3: 'Attualmente caldo',
    home_slide_title4: 'Molto popolare',
    home_detail_title1: 'Ricordi quotidiani',
    home_detail_title2: 'Video consigliati',
    home_detail_title3: 'Se vuoi saperne di più',
    home_detail_text1: 'Memo minilibro',
    home_detail_text2: 'Memo giornaliero',
    home_setting_title: 'Impostazioni',
    home_setting_text1: 'Pagine viste negli ultimi 30 giorni',
    home_setting_text2: 'Esci',
    home_setting_text3: 'Elimina account',
    home_book_banner_question: 'Sono curioso',
    home_book_banner_write_placeholder1: 'Inserire un titolo',
    home_book_banner_write_placeholder2: 'Inserire un post',
    home_book_banner_write_button: 'Salvare',
    home_book_banner_detail_text1: 'Risposta del mentore di YouBook',
    home_book_banner_detail_text2: 'Minilibri correlati',

    home_book_create_button: 'Minilibro, Prova a Crearlo',
    home_book_create_text1: 'Un minilibro è un libro breve di circa 10 pagine. È perfetto per chi vuole leggere contenuti essenziali in modo rapido e conciso, seguendo le tendenze attuali.',
    home_book_create_text2: 'Come modificare dopo la pubblicazione',
    home_book_create_text3: 'Minilibro, modo semplice per creare',
    home_book_create_text4: 'Quanto può guadagnare un autore?',
    home_book_create_text5: 'Come posso incontrare i lettori?',
    home_book_create_text6: '5 motivi per usare YouBook',
    home_book_create_text7: 'Altre domande?',
    home_book_create_text8: 'Posso vedere le vendite in tempo reale?',
    home_book_create_text9: 'Scriviamo con costanza ogni giorno!',
    home_book_create_text10: 'Inizia subito, adesso!',

    home_book_category_title1: 'Problemi di oggi e minilibro',
    home_book_category_title2: 'Minilibri popolari',
    home_book_category_title3: 'Minilibri del professore S-class',
    home_book_category_title4: 'Raccomandazioni personalizzate',
    home_book_category_title5: 'Minilibri essenziali dei bestseller',
    home_book_category_title6: 'Con Gattolibro',
    home_book_category_title6_text1: 'Mostra',
    home_book_category_title6_text2: 'Nascondi',
    home_book_category_title7: 'Esplorazione delle pagine della rete neurale',
    home_book_category_title8: 'Festival di arte ed emozione',
    home_book_category_title8_text1: 'Il mondo nel cinema e nelle serie',
    home_book_category_title8_text2: 'Melodie e movimenti emozionanti',
    home_book_category_title8_text3: 'Arte senza confini',
    home_book_category_title8_text4: 'Indossa la personalità: moda e stile',
    home_book_category_title9: 'Cultura gastronomica e relax',
    home_book_category_title9_text1: 'Esplorazione culinaria, cucina locale',
    home_book_category_title9_text2: 'Storie di alcol e vita',
    home_book_category_title9_text3: 'Fascino di snack e dolci',
    home_book_category_title9_text4: 'Il potere della natura, segreti delle piante',
    home_book_category_title10: 'Saggezza della vita e scoperta di sé',
    home_book_category_title10_text1: 'Modi unici di gestire il denaro',
    home_book_category_title10_text2: 'Ricette per la crescita personale',
    home_book_category_title10_text3: 'Problemi e soluzioni nelle relazioni',
    home_book_category_title10_text4: 'Nuove scoperte e conoscenze',
    home_book_category_title11: 'Diversità di valori e amore',
    home_book_category_title11_text1: 'Storie della loro vita',
    home_book_category_title11_text2: 'Filosofie e valori diversi',
    home_book_category_title11_text3: 'Credenze religiose e tradizioni',
    home_book_category_title11_text4: 'Il mistero dell’amore',
    home_book_category_title12: 'Giornate piene di viaggi e hobby',
    home_book_category_title12_text1: 'Destinazioni nascoste da visitare',
    home_book_category_title12_text2: 'Gioia di vivere attraverso gli hobby',
    home_book_category_title12_text3: 'Cultura unica attraverso i giochi',
    home_book_category_title13: 'Ricchezza di tradizioni e storie',
    home_book_category_title13_text1: 'Miti locali e storie di eroi',
    home_book_category_title13_text2: 'Viaggi letterari globali',
    home_book_category_title13_text3: 'Storia e saggezza dei luoghi',
    home_book_category_title13_text4: 'Storie sociali variopinte',

    home_book_category_title1_text2: 'I pensieri di Gattolibro – Vuoi dare una sbirciatina?',
    home_book_category_title1_text3: 'Dubbi? Curiosità?',
    home_book_category_title1_text4: 'Vuoi che ti consigli un minilibro?',
    home_book_search_placeholder1: 'Parla qui',
    home_book_search_placeholder2: 'Qual è la parola chiave?',

    home_book_search_message1: 'Inserisci le tue domande',
    home_book_search_message2: 'Inserisci nuovamente le tue domande',
    home_book_search_text1: 'Perché non parlarne con me?',
    home_book_search_text2: 'Perché non parlarne con me?',
    home_book_search_text3: 'Chiedi',
    home_book_search_text4: 'Puoi salvare quanto sopra',
    home_book_search_text5: '(Aggiungi semplicemente parole chiave)',

    home_book_theme_title: 'Libri divisi per tema',
    home_instant_text1: 'Inserisci una parola chiave',
    home_instant_text2: 'Inserisci casualmente',
    home_book_company_info: 'Se hai altre domande, non esitare a contattarci qui sotto. Siamo qui per aiutarti.',
    home_page_search_text1: 'Ricerca nella pagina',
    home_page_search_text2: 'Riproduzione istantanea come video',
    home_page_search_text3: 'Ricerca avanzata',
    home_page_search_text4: 'Vista elenco',
    home_page_search_text5: 'Vista rete',
    home_page_explor_alert: 'Nessuna pagina è stata selezionata',
    home_page_explor_alert2: 'È stato superato il numero massimo di pagine visualizzabili in una schermata (150). Le pagine non necessarie vanno cestinate.',
    home_page_explor_alert3: 'Non ci sono più informazioni da caricare',
    my_login_title: 'MIO',
    my_login_text1: 'Crea il tuo profilo con stile',
    my_login_text2: 'Accedi ora e diventa intelligente',
    my_login_text3: 'con YouBook',
    my_login_find_password: 'Trova password',
    my_guide_minibook: 'Come creare un Minilibro',
    my_password_reset: 'Reimposta password',
    my_password_reset_text1: 'Inserisci la tua e-mail precedente per il LOGIN',
    my_password_reset_button1: 'Invia un link per il reset',
    my_password_reset_button2: 'Resetta',
    my_password_reset_message1: 'Impossibile trovare l\'e-mail',
    my_password_reset_message2: 'Abbiamo inviato un link per il reset della password all\'e-mail fornita.',
    my_password_reset_message3: 'La preghiamo di reimpostare la password utilizzando il link inviato alla tua e-mail.',
    my_password_reset_placeholder1: 'Il tuo indirizzo e-mail',
    my_password_reset_placeholder2: 'Inserisci la tua nuova password',
    my_password_reset_placeholder3: 'Reinserisci la tua nuova parola d\'ordine',
    my_password_reset_message4: 'Le password non corrispondono',
    my_password_reset_message5: 'La password deve essere lunga almeno 8 caratteri e includere almeno una lettera maiuscola, una lettera minuscola, un numero, e un carattere speciale.',
    my_password_reset_message6: 'La password è stata ripristinata',
    my_memo_list_placeholder: 'Hai un\'idea? Scrivila qui ora',
    my_profile_placehoder1: 'I miei interessi',
    my_profile_placehoder2: 'Il mio nome',
    my_profile_placehoder3: 'Mi presento brevemente',
    my_profile_placehoder4: 'Presentazioni aggiuntive',
    my_profile_text1: 'Nazionalità',
    my_profile_text2: 'Lingua',
    my_profile_text3: 'Modifica ID',
    my_profile_text4: 'ID attuale',
    my_profile_text5: 'Nuovo ID da modificare',
    my_profile_text6: 'La modifica dell\'ID è consentita solo una volta',
    my_menu_text1: 'Il Mio \nViaggio',
    my_menu_text2: 'Messaggio',
    my_menu_text3: 'Acquisto e \ntransazione',
    my_menu_text4: 'Nuova notifica',
    my_menu_text5: 'Creare un \nMinilibro',
    my_menu_text6: 'MiniLibri \ncreati',
    my_menu_text7: 'Vuoi importare contenuti da altre app?',
    my_menu_text8: 'Puoi importarli automaticamente e convertirli in pagina',
    my_menu_text9: 'Importa',
    my_import_book_text1: 'Converti in pagina',
    my_import_book_text2: 'Conversione del file ZIP in corso. Ogni contenuto richiede fino a 5 secondi per essere convertito. Circa 1 minuto per 10 contenuti, circa 8 minuti per 100. Al termine apparirà una finestra popup.',
    my_import_book_text3: 'Ok',
    my_import_book_text4: 'Conversione in pagina completata',
    my_import_book_text5: 'Tutti i contenuti del file ZIP sono stati convertiti in pagine. Ogni contenuto è stato trasformato in una pagina separata. Puoi verificarli in Il Mio Viaggio - Pagine create. Le pagine sono salvate temporaneamente e possono essere modificate.',
    my_import_book_text6: 'Puoi importare contenuti da altre app e convertirli automaticamente in pagine. Poi puoi raccoglierle in un minilibro.',
    my_import_book_text7: 'Come importare contenuti da altre app tramite file ZIP',
    my_import_book_text8: 'Carica un file ZIP',
    my_import_book_text9: 'Carica file da Substack',
    my_import_book_text10: 'Carica file da Medium',
    my_import_book_text11: 'Cerca',
    my_import_book_text12: '* Ogni contenuto verrà convertito in una pagina',
    my_import_book_text13: '* Puoi verificarlo su La mia pagina - Impostazioni - Pagine create',
    my_import_book_text14: '* Le pagine sono temporaneamente salvate e modificabili',
    my_import_book_text15: '* Puoi importare solo i tuoi contenuti',
    my_import_book_text16: 'Pubblica un minilibro utilizzando le pagine convertite',
    my_import_book_text17: 'Crea la copertina del minilibro',
    my_import_book_text18: 'Seleziona le pagine da aggiungere al minilibro',
    my_import_book_text19: 'Pubblica il minilibro',
    my_import_book_text20: 'Leggi attentamente le istruzioni',
    my_import_book_text21: 'Il file non è in formato ZIP',
    my_import_book_text22: 'Carica un file',

    my_journey_title: 'Il Mio Viaggio',
    my_journey_button_message: 'Messaggio',
    my_journey_button_memo: 'Memo',
    my_journey_button_record: 'Registra',
    my_journey_button_follow: 'Segui',
    my_journey_button_follow_cancel: 'Annulla segui',
    my_journey_message_text1: 'Lascia un messaggio',
    my_journey_message_placeholder: 'Inserire il tuo messaggio',
    my_journey_message_message1: 'Impossibile rispondere',
    my_journey_message_message2: 'Invio',
    my_journey_message_message3: 'Inserisci il tuo messaggio',
    my_journey_memo_total: 'Totale',
    my_journey_record_overall: 'Classifica di influenza',
    my_journey_record_text1: 'Pagine visualizzate',
    my_journey_record_text2: 'MiniLibri preferiti',
    my_journey_record_text3: 'Spazio evento preferito',
    my_journey_record_text4: 'Pagine create',
    my_journey_record_text5: 'MiniLibri creati',
    my_journey_record_text6: 'Spazio evento creato',
    my_journey_record_text7: 'Questo mese',
    my_journey_record_text8: 'Minilibro acquistato',
    my_journey_record_text9: 'Pubblico',
    my_journey_record_text10: 'Privato',
    my_journey_record_text11: 'Evento acquistato',
    my_journey_record_text12: 'L\'evento che ho creato',
    my_journey_record_text13: 'Classificato #{userRank} nella categoria {userLanguage}',
    my_journey_record_text14: 'Minilibro per la condivisione dei diritti d’autore',
    my_journey_record_text15: 'Vuoi che i lettori leggano in un ordine specifico? In tal caso, trascina la copertina per modificarne l’ordine.',
    my_journey_record_text16: 'Sostieni il nuovo minilibro',
    my_journey_record_text17: 'Messaggi di supporto dai lettori',
    my_journey_record_text18: 'Lascia un messaggio di supporto per l\'autore',
    my_journey_record_text19: 'Livello di supporto',
    my_journey_record_text20: 'Livello {cheeringLevel} su 10',
    my_journey_record_text21: 'Persone che supporto',
    my_journey_record_text22: 'I miei sostenitori',
    my_journey_record_text23: 'Vuoi eliminarlo?',
    my_journey_record_text24: 'sostenitore di {userName}',
    my_journey_record_text25: 'supportato da {userName}',
    my_notice_title: 'Notifiche',
    my_notice_message1: 'Non ci sono nuove notifiche',
    my_notice_text1: 'È arrivato un nuovo numero di Minilibro',
    my_notice_text2: 'È arrivato un nuovo Tema del giorno',
    my_notice_text3: 'Un nuovo messaggio a Il Mio Viaggio',
    my_notice_text4: 'Un nuovo commento a Il mio Memo',
    my_notice_text5: 'Nuovo commento nel mio spazio evento',
    my_notice_text6: 'Un nuovo commento alla copertina del mio Minilibro',
    my_notice_text7: 'Un nuovo commento alla pagina del mio Minilibro',
    my_notice_text8: 'ha pubblicato un nuovo Memo',
    my_notice_text9: '{userName} ha creato un nuovo spazio evento',
    my_notice_text10: 'Ha pubblicato un nuovo Minilibro',
    my_notice_text11: 'ha acquistato il mio minibook',
    my_notice_text12: '{userName} ha creato un <b>nuovo evento</b>',
    my_notice_text13: '{userName} ti ha invitato/a personalmente a <b>questo nuovo evento</b>. Non perderlo! ',
    my_notice_text14: '{userName} ha <b>acquistato il mio evento</b>',
    my_notice_text15: '{userName} ha richiesto di diventare co-autore',
    my_notice_text16: 'La richiesta di co-autore per il minilibro aperto è stata approvata',
    my_notice_text17: 'Un nuovo commento è stato pubblicato da un coautore',
    my_notice_text18: 'È arrivato un messaggio per supportare il nuovo minilibro',
    my_notice_text19: '{userName} ha sponsorizzato <b>il mio minilibro</b>',
    my_marketing_banner_title: 'Fai il tifo per te stesso',
    my_marketing_banner_text1: 'Hai superato le difficoltà, ora supportati',
    my_marketing_banner_btn: 'Fai il tifo ora',
    my_marketing_title: 'Fai il tifo ora',
    my_marketing_text1: 'Metti le ali del minilibro e dell’evento – con la promozione a tappe come carburante – e diventa un influencer',
    my_marketing_text2: 'Email ai lettori generici',
    my_marketing_text3: 'Messaggio ai lettori generici',
    my_marketing_text4: 'Email agli amici',
    my_marketing_text5: 'Messaggio agli amici',
    my_marketing_text6: 'Link sui social media',
    my_marketing_btn: 'Inizia ora',
    my_marketing_minibook_step1_title: 'Supporto al Minilibro',
    my_marketing_step1_subtitle: 'Link sui social media',
    my_marketing_minibook_step1_text1: 'Collega il minilibro ai tuoi social media e aggiungi una descrizione accattivante',
    my_marketing_minibook_text1: 'Trova il minilibro',
    my_marketing_step1_text1: 'Copia il link',
    my_marketing_step1_btn: 'Copia',
    my_marketing_step1_text2: 'Incolla sui social media e aggiungi una descrizione',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'Seleziona il minilibro da condividere',
    my_marketing_step1_text4: 'Link copiato',
    my_marketing_step1_text5: 'Seleziona l\'evento da condividere',
    my_marketing_step1_text6: 'Cerca sui social media',
    my_marketing_event_step1_title: 'Supporto all’Evento',
    my_marketing_event_step1_text1: 'Collega l’evento ai tuoi social media e aggiungi una descrizione accattivante',
    my_marketing_event_text1: 'Trova l’evento',
    my_marketing_event_search_title: 'Cerca evento',
    my_marketing_minibook_step2_title: 'Marketing Minilibro Fase 2',
    my_marketing_step2_subtitle: 'Messaggio agli amici',
    my_marketing_minibook_step2_text1: 'Invia ai tuoi amici il link del minilibro con un messaggio personale',
    my_marketing_step2_text2: 'Invia il link e un messaggio introduttivo all’amico',
    my_marketing_step2_placeholder: 'Inserisci il messaggio introduttivo',
    my_marketing_tab_text1: 'I miei amici',
    my_marketing_event_step2_title: 'Marketing Evento Fase 2',
    my_marketing_event_step2_text1: 'Invia ai tuoi amici il link dell’evento con un messaggio personale',
    my_marketing_minibook_step3_title: 'Marketing Minilibro Fase 3',
    my_marketing_step3_subtitle: 'Email agli amici',
    my_marketing_minibook_step3_text1: 'Racconta ai tuoi amici la storia dietro il minilibro inviando il link',
    my_marketing_step3_text1: 'Importa lista de contactos',
    my_marketing_step3_placeholder: 'Carica file csv o vcf',
    my_marketing_step3_text2: 'Invia la storia e il link all’amico',
    my_marketing_step3_text3: 'Importa la tua lista di numeri di telefono',
    my_marketing_step3_placeholder2: 'Racconta la storia',
    my_marketing_event_step3_title: 'Marketing Evento Fase 3',
    my_marketing_event_step3_text1: 'Racconta ai tuoi amici la storia dietro l’evento inviando il link',
    my_marketing_text7: 'Importa numeri di telefono',
    my_marketing_title2: 'Gestisci numeri di telefono',
    my_marketing_text8: 'Telefono',
    my_marketing_text9: 'Conteggio',
    my_marketing_text10: 'Importa contatti',
    my_marketing_text11: 'Per favore carica un file csv o vcf',
    my_marketing_text12: 'Come importare',
    my_marketing_text13: 'Importa',
    my_marketing_title3: 'Gestisci contatti',
    contact_manage: 'Gestione Contatti',
    my_marketing_text14: 'Elimina selezionati',
    my_marketing_text15: 'Seleziona un amico',
    my_marketing_text16: 'Puoi selezionare fino a 100 amici',
    my_marketing_text17: 'Caricamento completato',
    my_marketing_text18: 'Limite di caratteri superato',
    contact_phone: 'Telefono',
    contact_organization: 'Organizzazione',
    contact_title: 'Titolo',
    contact_memo: 'Memo',
    my_marketing_text19: 'Modifica selezione',
    my_marketing_text20: 'Seleziona etichetta',
    my_marketing_text21: 'Aggiungi nuova etichetta',
    my_marketing_text22: 'Elimina etichetta selezionata',
    my_marketing_text23: 'Aggiungi',
    my_marketing_btn2: 'Modifica completata',
    my_marketing_text24: 'Seleziona un contatto da modificare',
    my_marketing_text25: 'Seleziona un’etichetta da eliminare',
    my_marketing_text26: 'Inserisci un nome per l’etichetta',
    my_marketing_text27: 'Questa etichetta esiste già',
    my_marketing_text28: 'Aggiungi etichetta',
    my_marketing_text29: 'Annulla',
    my_marketing_text30: 'Aggiunto',
    my_benefit_text1: 'Hai guadagnato finora',
    my_benefit_text2: 'Guadagnerai in un anno',
    my_benefit_text3: '',
    my_benefit_text4: 'il calcolo del guadagno',
    my_benefit_text5: 'il calcolo del guadagno',
    my_benefit_text6: 'Controlla',
    my_benefit_modal_text1: 'Hai guadagnato finora',
    my_benefit_modal_text2: 'EUR',
    my_benefit_modal_text3: 'Hai guadagnato',
    my_benefit_modal_text4: 'Facciamo un calcolo molto semplice',
    my_benefit_modal_text5: 'Numero di pagine lette finora',
    my_benefit_modal_text6: 'Prezzo per fare una pagina',
    my_benefit_modal_text7: 'EUR',
    my_benefit_modal_text8: 'Quindi il tuo guadagno è',
    my_benefit_modal_text9: 'Ora aggiungi i benefici delle discussioni con',
    my_benefit_modal_text10: 'L\'IA e i tuoi guadagni saranno ancora maggiori.',
    my_benefit_modal_text11: 'Utilizzalo ogni giorno e prendi i tuoi guadagni',
    my_benefit_modal_text12: 'Ok, ho capito',
    my_story_text1: 'Cosa dicono i membri',
    my_story_text2: 'Realizza che i libri si vivono, non si leggono',
    my_story_text3: 'Incredibile cosa accade quando si impara ogni giorno',
    my_story_text4: 'Le insidie nascoste delle persone intelligenti, sei uno di loro?',
    my_story_text5: 'Guarda altre storie dei membri',
    my_go_blog_text1: 'YouBook, Notizie e Storie dei Clienti',
    my_go_blog_text2: 'Scopri le ultime notizie e storie dei clienti di YouBook',
    my_go_blog_text3: 'Scopri di più',
    my_channel_text1: 'Cosa ne pensi di YouBook?',
    my_channel_text2: 'Dicci cosa è  buono e cosa possiamo migliorare.',
    my_channel_text3: 'E facci sapere se hai qualche domanda',
    my_channel_text4: 'Dì una parola',
    my_about_youbook_text1: 'Perché usare YouBook',
    my_about_youbook_text2: 'Tutte le tue domande e risposte sono qui',
    my_about_youbook_text3: 'Termini di servizio',
    my_app_text1: 'YouBook è un\'applicazione completamente vantaggiosa al 100%.',
    my_app_text2: 'Scaricala subito e acquisita conoscenza',
    my_app_text3: 'Scarica l\'app',
    login_title: 'Accedi',
    login_text1: 'Accedi con l\'e-mail',
    login_text2: 'Non sei ancora registrato?',
    login_text3: 'Hai dimenticato la password?',
    login_text4: 'o accedi con',
    login_text5: 'Accetto',
    login_placeholder1: 'Email di accesso',
    login_placeholder2: 'Password',
    login_placeholder3: 'ID',
    login_message1: 'Inserisci la tua email di accesso',
    login_message2: 'Inserisci la tua password',
    login_message3: 'Accesso riuscito',
    login_message4: 'Inserisci il tuo ID',
    logout_message1: 'Vuoi uscire?',
    login_link1: 'Iscriviti',
    login_link2: 'Trova',
    login_link3: 'Condizioni di servizio',
    register_title: 'Iscriviti',
    register_text1: 'Iscriviti con l\'e-mail',
    register_text2: 'Seleziona il tipo di abbonamento',
    register_text3: 'Personale',
    register_text4: 'Organizzativo',
    register_text5: 'Inserisci le tue informazioni',
    register_text6: 'Già registrato?',
    register_text7: 'Numero di registrazione dell\'organizzazione',
    register_text8: 'Numero di registrazione aziendale',
    register_text9: 'Nome dell\'organizzazione',
    register_placeholder1: 'Numero di telefono compreso il prefisso',
    register_placeholder2: '( senza - )',
    register_placeholder_repassword: 'Reinserisci la password',
    register_message1: 'Inserisci il tuo numero di telefono',
    register_message2: 'Accedere al numero di registrazione dell\'organizzazione',
    register_message3: 'Inserisci il numero di registrazione aziendale',
    register_message4: 'Inserisci il nome dell\'organizzazione',
    register_message5: 'Formato e-mail non valido',
    register_message6: 'Questa email è già registrata',
    register_message7: 'Si prega di verificare l\'e-mail',
    register_message8: 'Seleziona la tua nazionalità',
    register_message9: 'Formato ID non valido',
    register_message10: 'L\'ID inserito non è disponibile. Utilizza un ID suggerito o inseriscine un altro',
    register_message11: 'Verifica il tuo ID',
    register_message12: 'Questo ID è già in uso. Usa un ID suggerito o inseriscine un altro',
    register_button_verify: 'Verifica',
    register_button_verify_fail: 'Non verificato',
    register_button_verify_success: 'Verificato',
    register_welcome_message: 'Benvenuto tra i membri',
    withdraw_text1: 'Annullamento dell\'abbonamento',
    withdraw_text2: 'Annulla l\'abbonamento YouBook',
    withdraw_text3: 'Sei sicuro di voler annullare?',
    withdraw_text4: 'No',
    withdraw_text5: 'Sì',
    withdraw_text6: 'La tua iscrizione è stata annullata con successo',
    home_memo_title: 'Memo',
    home_memo_subtitle: 'Se non si prende nota, lo dimentichi',
    home_memo_text1: 'Condiviso insieme da tutti',
    home_memo_text2: 'Conoscenza e storie quotidiane',
    home_memo_button: 'Lascia un memo',
    home_memo_create_text1: 'Hai un minilibro da collegare?',
    home_memo_create_button: 'Trova un minilibro',
    home_memo_create_button2: 'Seleziona',
    home_memo_click: 'Clicca',
    home_memo_date: 'YYYY. MM. DD',
    home_memo_button_askai: 'Commento / Pensieri di Gattolibro',
    home_memo_view_detail: 'Visualizza i dettagli',
    home_memo_view_placeholder: 'Inserisci un post',
    home_memo_view_button1: 'Commento',
    home_memo_view_button2: 'Pensieri di Gattolibro',
    home_memo_view_errormessage: 'Inserisci a un post',

    memo_create_title: 'Memo',
    memo_create_category1: 'Memo',
    memo_create_category2: 'Memo',
    memo_create_private: 'Privato',
    memo_create_public: 'Pubblico',
    memo_create_placeholder1: 'Hai un\'idea?',
    memo_create_placeholder2: 'Scrivila ora',
    memo_create_placeholder3: 'Parole chiave (uno spazio vuoto tra di esse)',
    memo_create_button: 'Salva',
    memo_create_error: 'Inserisci il tuo Memo',
    memo_attach_img: 'Carica immagine',
    memo_alert_rate: 'Seleziona il punteggio in stelle',
    memo_alert_save: 'Salvato. Puoi controllarlo nel Il mio profilo - Il mio Viaggio',
    memo_input_placeholder: 'Cosa hai imparato?',
    memo_input_placeholder2: 'Quali sono i tuoi pensieri?',
    memo_input_placeholder3: 'Condividilo con i lettori ora!',
    memo_input_placeholder4: 'Un ricordo della vita quotidiana, lo registriamo?',
    memo_alert_keywords: 'Inserisci la parole chiave',
    memo_related_text: 'Memo',
    memo_related_date: 'YYYY. MM. DD',
    memo_popup_text1: 'La storia di Nicholas Luhmann sembra una favola moderna che mostra il potere transformativo di una semplice abitudine.',
    memo_popup_text3: 'Inizialmente Luhmann era un giovane impiegato in un contesto aziendale, lontano dal mondo accademico.',
    memo_popup_text4: 'Tuttavia, la sua vorace voglia di leggere lo ha portato a una pratica insolita: prendere appunti giornalieri sulle sue letture.',
    memo_popup_text5: 'Questa abitudine è culminata in un lavoro che ha attirato l\'attenzione di un rinomato sociologo tedesco, dando una svolta inaspettata alla sua carriera.',
    memo_popup_text6: 'Luhmann fu invitato a far parte della facoltà dell\'Università di Bielefeld, dove arrivò a ricoprire il ruolo di professore ordinario.',
    memo_popup_text7: 'Nel corso della sua carriera ha scritto ben 60 libri e numerosi articoli, consolidando il suo status di luminare della sociologia.',
    memo_popup_text8: 'Luhmann attribuiva la sua genialità intellettuale al suo metodo di prendere appunti metodico, dicendo',
    memo_popup_text9: '"Ho continuato a prendere appunti"',
    memo_popup_text10: 'che lo ha aiutato a organizzare i suoi pensieri e approfondire la sua comprensione.',
    memo_popup_text11: 'Questo racconto serve a ricordare i limiti della memoria e del valore di catturare e rivisitare sistematicamente le conoscenze per renderla veramente proprie.',
    memo_popup_btn: 'Sì, posso capirlo',
    memo_text1: 'È possibile salvare quanto sopra',
    memo_text2: '(Basta aggiungere parole chiave)',
    memo_text3: 'Cose da controllare durante la scrittura',
    memo_text4: 'Il tuo post viola le normative sui contenuti dell\'articolo 2, sezione 1 delle Condizioni di Servizio. Non sarà pubblicato.',
    memo_text5: 'Visualizza le Condizioni di Servizio',
    memo_text6: 'Per lasciare un memo in un\'altra lingua, ',
    memo_text7: 'scrivi in quella lingua (nessuna traduzione automatica)',
    book_create_button: 'Creare un Minilibro',
    book_create_title: 'Crea un copertina',
    book_create_cover: 'copertina',
    book_create_text1: 'Passaggio per creare una copertina per un Minilibro',
    book_create_text1_pc: 'Inserisci il titolo e il nome dell\'autore',
    book_create_text2: 'Nessuna immagine di copertina creata',
    book_create_text3: '',
    book_create_text4: 'Hai un\'immagine di copertina creata da te',
    book_create_text5: 'Hai creato la tua copertina?',
    book_create_text6: 'Si prega di caricare utilizzando il pulsante qui sotto',
    book_create_text7: '(formato jpg di dimensioni inferiori a 20M)',
    book_create_text8: 'Diritto di aggiungere pagine',
    book_create_text9: 'solo io',
    book_create_text10: 'Chiunque',
    book_create_text11: 'Titoli nelle immagini',
    book_create_text12: 'Visualizza',
    book_create_text13: 'Non visualizzare',
    book_create_text14: 'Seleziona le lingue che desideri tradurre',
    book_create_text15: 'Seleziona tutto',
    book_create_text16: 'Carica immagine della copertina',
    book_create_text17: 'Puoi modificare',
    book_create_text18: 'Dopo la modifica, fai clic sull\'icona in alto a destra per ritradurre',
    book_create_text19: 'Se desideri ritradurre come nell\'originale, fai clic sull\'icona in alto a destra',
    book_create_text20: 'Ritraduci',
    book_create_text21: 'Immagine',
    book_create_text22: 'Titolo',
    book_create_text23: 'Parola chiave',
    book_create_text24: 'Contenuto',
    book_create_text25: 'La traduzione verrà aggiornata solo se l\'immagine viene eliminata e ricaricata',
    book_create_text26: '(La pagina non verrà eliminata)',
    book_create_text27: 'Scrivi una breve introduzione',
    book_create_text28: 'Salvataggio temporaneo',
    book_create_text29: 'Salvato temporaneamente',
    book_create_text30: 'Elementi da verificare',
    book_create_text31: 'Il contenuto del testo è la versione finale e non necessita di ulteriori modifiche',
    book_create_text32: 'Non sono stati utilizzati termini o simboli incomprensibili per l\'IA di traduzione다',
    book_create_text33: 'L\'immagine non è stata copiata e incollata, ma inserita come file separato',
    book_create_text34: 'Aprire le candidature? (Minilibro aperto)',
    book_create_text35: 'Co-autori',
    book_create_text36: 'Vuoi aggiungere manualmente?',
    book_create_text37: 'Aggiungi',
    book_create_text38: 'Un minilibro che si diffonde di più quando è scritto insieme',
    book_create_text39: 'La potenza dei co-autori che non conoscevi',
    book_create_text40: 'Apri le candidature',
    book_create_text41: 'Annulla',
    book_create_text43: 'Idea?',
    book_create_text44: 'Copia e incolla il contenuto',
    book_create_text45: 'Hai bisogno di un\'idea?',
    book_create_text46: 'Opzioni di vendita',
    book_create_text47: 'Gratuito',
    book_create_text48: 'Sponsor',
    book_create_text49: 'Acquista',
    book_create_text50: 'Prezzo attuale',
    book_create_text51: 'Modifica prezzo',
    book_create_text52: 'Non può essere impostato a 0',
    book_create_text53: 'I minilibri acquistati o sponsorizzati non possono cambiare prezzo o opzioni di vendita',
    book_create_text54: 'Solo l’autore del minilibro può rispondere ai messaggi',
    book_create_button_upload: 'Carica',
    book_create_button_make: 'Crea',
    book_create_cover_topic_placeholder: 'Il titolo apparirà così',
    book_create_topic_placeholder: 'Inserisci un titolo',
    book_create_keyword_placeholder: 'Parole chiave (lascia uno spazio vuoto tra di esse)',
    book_create_category_placeholder: 'Seleziona categoria',
    book_create_knowledge_placeholder: 'Scrivi un\'introduzione per il tuo Minilibro** Attenzione - Scrivi i dettagli nel passaggio per creare le pagine',
    book_create_category_option1: 'Film e Dramma',
    book_create_category_option2: 'Musica e Danza',
    book_create_category_option3: 'Altre Arti',
    book_create_category_option4: 'Abbigliamento e Stile',
    book_create_category_option5: 'Cibo e Cucina',
    book_create_category_option6: 'Alcol e Bevande',
    book_create_category_option7: 'Snack e Dolci',
    book_create_category_option8: 'Piante e Salute',
    book_create_category_option9: 'Diventare Ricco',
    book_create_category_option10: 'Sviluppo Personale',
    book_create_category_option11: 'Relazioni Umane',
    book_create_category_option12: 'Nuove Conoscenze',
    book_create_category_option13: 'Storie di Vita',
    book_create_category_option14: 'Filosofia e Valori',
    book_create_category_option15: 'Religione e Tradizioni',
    book_create_category_option16: 'Amore',
    book_create_category_option17: 'Viaggi e Luoghi',
    book_create_category_option18: 'Hobby',
    book_create_category_option19: 'Cultura del Gioco',
    book_create_category_option20: 'Miti ed Eroi',
    book_create_category_option21: 'Viaggi Letterari',
    book_create_category_option22: 'Storia e Saggezza',
    book_create_category_option23: 'Storie Sociali',
    book_create_category_option24: 'Conoscenza Generale',
    book_create_message1: 'Inserisci un titolo',
    book_create_message2: 'Inserisci il nome dell\'autore',
    book_create_message3: 'Inserisci parole chiave',
    book_create_message4: 'Inserisci più di 3 parole chiave',
    book_create_message5: 'Seleziona una categoria',
    book_create_message6: 'Crea un\'immagine di copertina',
    book_create_message7: 'Non è possibile inserire caratteri speciali. È necessario inserire uno spazio vuoto tra le parole chiave.',
    book_create_message8: 'Vuoi eliminare il Minilibro?',
    book_create_message9: 'Non hai il diritto di pubblicazione per questa lingua',
    book_create_message10: 'Un minilibro acquistato non può essere eliminato',
    book_create_modal_text1: 'Attendere un momento..',
    book_create_modal_text2: 'L\'IA sta esaminando il contenuto, traducendo lingue straniere e collegando la rete di conoscenza',
    book_create_modal_text3: 'Collegamento alla base di conoscenza per la ricerca pagina dopo pagina',
    book_create_modal_text4: 'Il titolo non appare sull\'immagine della copertina',
    book_create_modal_text5: '(Questo vale anche per le copertine tradotte in lingue straniere)',
    book_view_title: 'Panoramica del Minilibro',
    book_view_share: 'Condividi',
    book_view_event_topic: 'Argomento dell\'evento',
    book_view_together_suggest: 'Suggerisci uno spazio evento',
    book_view_together_message: 'Se non avete un Insieme preferito, <br /> andate nel menu Insieme e sceglietelo.',
    book_view_event_message: 'Non ho creato alcun evento',
    book_view_text1: 'Non sono state aggiunte pagine.',
    book_view_text2: 'Perché non lo aggiungi ora?',
    book_view_text3: 'Il Minilibro non esiste. Perfavore riprova.',
    book_view_text4: 'Indice delle pagine',
    book_view_text5: 'Che ne dici di migliorare la traduzione di questo minilibro o promuoverlo e condividere i profitti?',
    book_view_text6: 'Elenco delle pagine',
    book_view_text7: 'Modifica del prezzo',
    book_view_text8: 'Impossibile modificare: è già presente un acquirente',
    book_view_text9: 'Regalo del lettore',
    book_view_text10: 'Solo l’autore del minilibro può rispondere ai messaggi',
    book_view_modal_title: 'Miglioramento della Traduzione & Promozione',
    book_view_modal_text1: 'Puoi migliorare la traduzione di questo minilibro da solo? Oppure promuoverlo?',
    book_view_modal_text2: 'Lascia un messaggio all\'autore',
    book_view_modal_text3: 'Se l\'autore accetta, puoi condividere i guadagni',

    book_view_write_share_title: 'Minilibro aperto',
    book_view_write_share_text1: 'Vuoi diventare co-autore di questo minilibro?',
    book_view_write_share_text2: 'Richiedi la co-autoria',
    book_view_write_share_text3: 'Lascia una richiesta semplice',
    book_view_write_share_text4: 'Invia',
    book_view_write_share_list_title: 'Co-autori',
    book_view_write_share_text5: 'Gestisci i co-autori del minilibro',
    book_view_write_share_text6: 'Gestisci autori',
    book_view_write_share_text7: 'Accetta',
    book_view_write_share_text8: 'Accettato',
    book_view_write_share_text9: 'L\'utente è già registrato come autore',
    book_view_write_share_text10: 'Aggiungi autore manualmente',
    book_view_write_share_text11: 'L\'utente ha già fatto domanda',
    book_view_publish_text1: 'Vorresti pubblicare questo Minilibro?',
    book_view_publish_text2: 'La pubblicazione lo rende accessibile a tutti e puoi persino guadagnarci.',
    book_view_publish_text3: '(Se si pubblica per la vendita, non puoi includere pagine di altri autori).',
    book_view_publish_text4: 'Imposta un prezzo',
    book_view_publish_text5: 'Data di pubblicazione',
    book_view_publish_text6: 'Richiedi la pubblicazione',
    book_view_publish_text7: 'Pubblicazione immediata',
    book_view_publish_text8: 'Pubblicazione del libro',
    book_view_publish_text9: 'Non ancora',
    book_view_publish_text10: 'In corso',
    book_view_publish_text11: 'Pubblicato',
    book_view_publish_text12: 'Cose da controllare prima di pubblicare',
    book_view_publish_text13: 'Questo Minilibro non è mai stato pubblicato su YouBook prima d\'ora',
    book_view_publish_text14: 'Questo minilibro e le sue pagine non hanno rubato contenuti o altri diritti di proprietà intellettuale di terzi',
    book_view_publish_text15: 'Questo minilibro non contiene parolacce, contenuti sessuali eccessivi, diffamazione verso altri o pubblicità commerciale e rispetta l\'articolo 2, clausola 1 dei Termini di Utilizzo',
    book_view_publish_text16: 'Sì',
    book_view_publish_text17: 'Rapporto di pubblicazione',
    book_view_publish_text18: 'Pubblicato',
    book_view_publish_text19: 'Data di pubblicazione',
    book_view_publish_text20: 'Prezzo',
    book_view_publish_text21: 'Definire il periodo aperto',
    book_view_publish_text22: 'Periodo aperto',
    book_view_publish_text23: 'Cos\'è un periodo aperto',
    book_view_publish_text24: 'Il periodo aperto si riferisce al tempo durante il quale i lettori possono visualizzare il contenuto',
    book_view_publish_text25: 'Questo minilibro contiene più di 3 pagine',
    book_view_publish_text26: 'Questo minilibro non contiene più di 3 pagine',
    book_view_publish_text27: 'In caso di violazioni, l\'algoritmo può modificare il ranking di ricerca. In caso di problemi gravi, il minilibro verrà automaticamente eliminato',
    book_view_publish_text28: 'Imposta opzioni di vendita',
    book_view_publish_text29: 'Metodo di acquisto',
    book_view_publish_text30: 'Metodo di supporto',
    book_view_publish_message1: 'Se pubblichi per la vendita, assicurati che 1) le pagine del tuo Minilibro siano state realizzate da te e che 2) tu non le abbia precedentemente pubblicate a pagamento.',
    book_view_publish_message2: 'Non è in uno stato pubblicabile. Si prega di contattare l\'amministratore per assistenza',
    book_view_publish_message3: 'Questo Minilibro è già stato pubblicato.',
    book_view_publish_message4: 'Si prega di selezionare il periodo aperto dopo l\'ora attuale',
    book_view_publish_message5: 'Si prega di selezionare sia la data che l\'ora',
    book_view_publish_message6: 'La pubblicazione è stata approvata. Grazie',
    book_view_publish_message7: 'Si prega di controllare gli elementi di conferma',
    book_view_publish_message8: 'La data di fine non può essere precedente alla data di inizio',
    book_view_publish_message9: 'Un minilibro salvato temporaneamente non può essere pubblicato',
    book_view_publish_message10: 'Questo minilibro è stato trasferito. Il diritto di pubblicazione originale appartiene all\'autore.',
    book_view_publish_message11: 'Inserisci un importo minimo di {minPrice}',
    book_view_button_confirm: 'Confermato',
    book_view_button_publish: 'Pubblica',
    book_view_button_order: 'Allineamento della pagina',
    book_view_button_add: 'Aggiungi una pagina',
    book_view_button_video: 'Riproduci video',
    book_view_button_read: 'Leggi',
    book_view_button_lecture: 'Guarda il video della lezione',
    book_view_page_add_title: 'Aggiungere una pagina',
    book_view_page_add_text1: 'Dopo aver cercato una pagina di Terze parti',
    book_view_page_add_text2: 'Nella schermata Visualizza pagina',
    book_view_page_add_text3: 'Inserire nel mio Minilibro',
    book_view_page_add_text4: 'Cosa fare se si vuole creare una propria pagina?',
    book_view_page_add_text5: 'La creazione di pagine è disponibile solo per gli autori registrati.  Se desideri registrarti come autore, contattaci qui sotto.',
    book_view_page_add_text6: 'Vuoi aggiungere una pagina di Terze parti?',
    book_view_page_add_text7: '* Se aggiungi una pagina creata da Terze parti, \nnon può essere pubblicata come Minilibro a pagamento',
    book_view_page_add_text8: 'Hai già creato delle pagine?',
    book_view_page_add_button1: 'Crea ora',
    book_view_page_add_button2: 'Visualizza Pagine create',
    book_view_reference_text1: 'Diversità',
    book_view_reference_text2: 'Multiplo',
    book_view_reference_text3: 'Autore del Minilibro',
    book_view_reference_text4: 'Creato dall\'autore',
    book_view_support_text1: 'Ti sostengo',
    book_view_support_modal_title: 'Diventa un sostenitore',
    book_view_support_modal_text1: 'Anche un buon testo difficilmente si diffonde da solo.',
    book_view_support_modal_text2: 'Un sostenitore è chi condivide il minilibro dell’autore con il mondo e sostiene gli altri.',
    book_view_support_modal_text3: 'Diffondiamo insieme questa storia ancora più lontano.',
    book_view_support_modal_text4: 'Per favore, sostieni l’autore',
    book_view_support_modal_btn1: 'Capito',
    book_view_support_modal_text5: '"Il tuo sostegno significa molto per me. Grazie. Sosterrò anche il tuo viaggio con tutto il cuore."',
    book_view_support_modal_text6: 'Condividi il minilibro con il mondo',
    book_view_support_modal_btn2: 'Come si fa?',
    book_view_support_modal_title2: 'Complimenti a me per essere arrivato fin qui',
    book_view_support_modal_text7: 'Scrivere non è stato facile, ma ce l’ho fatta.',
    book_view_support_modal_text8: 'Ora è il momento di credere in me stesso e fare un altro passo avanti.',
    book_view_support_modal_text9: 'Anche se sono un po’ timido o esitante, divento il mio primo sostenitore e mi apro al mondo.',
    book_view_support_modal_text10: 'Perché credo che possa significare qualcosa per qualcuno.',
    book_view_support_modal_text11: 'Per favore, diventa il mio sostenitore',
    book_view_support_modal_text12: 'Scrivere o organizzare un evento non è stato facile, ma ho accettato la sfida.',
    book_view_support_modal_btn3: 'Ci provo!',
    book_view_support_modal_title3: 'Ciao, sostenitore',
    book_view_open_minibook_text1: 'La richiesta di Minilibro aperto è stata completata',
    book_view_open_minibook_text2: 'La richiesta di Minilibro aperto è stata annullata',
    page_create_title: 'Crea una pagina',
    page_create_text1: 'Nessuna immagine di pagina creata dall\'autore',
    page_create_text2: '',
    page_create_text3: 'pagina',
    page_create_text4: 'Hai un\'immagine di pagina creata da te',
    page_create_text5: 'Hai creato un\'immagine della pagina?',
    page_create_text6: 'Accedere al contenuto. Non si consiglia di utilizzare più di un foglio A4.',
    page_create_text7: 'Byte attuali',
    page_create_text8: 'Raccomandare',
    page_create_text9: 'Ci sono riferimenti a questa pagina?',
    page_create_text10: 'Creato da voi',
    page_create_text11: 'Libro di riferimento',
    page_create_text12: 'Blog di riferimento',
    page_create_text13: 'AI di riferimento',
    page_create_text14: 'Questo è il passaggio per creare le pagine del Minilibro.',
    page_create_text15: 'Carica immagine della pagina',
    page_create_text16: 'Vuoi ritradurre?',
    page_create_text17: 'Se desideri ritradurre, seleziona l\'obiettivo e la lingua (se non selezionato, verrà salvato senza traduzione)',
    page_create_text18: 'Obiettivo della traduzione',
    page_create_text19: 'Lingua della traduzione',
    page_create_message1: 'Non può essere modificato',
    page_create_message2: 'Accedi al contenuto',
    page_create_message3: 'Vuoi cancellare la pagina?',
    page_create_message4: 'Il contenuto supera la dimensione massima',
    page_create_reference_book: 'libro',
    page_create_reference_blog: 'blog',
    page_create_reference_placeholder1: 'Accedi al titolo del',
    page_create_reference_placeholder2: 'Link correlato (ad es. https://www.amazon.com/dp...)',
    page_create_reference_placeholder3: 'Anno di pubblicazione del libro',
    page_create_reference_placeholder4: 'Autore del',
    page_create_title_placeholder: 'Il titolo avrà il seguente aspetto',
    page_create_message5: 'Traduzione in corso',
    page_create_message6: 'Dopo aver creato la copertina, puoi creare una pagina',
    page_create_modal_text1: 'Il titolo non appare sull\'immagine della pagina',
    page_create_modal_text2: '(Questo vale anche per le pagine tradotte in lingue straniere)',
    page_create_modal_text3: 'Assicurati di controllare!',
    page_create_modal_text4: 'Se il contenuto è stato modificato, è necessario salvataggio temporaneo.',
    page_create_modal_text5: 'L\'hai fatto?',
    page_create_modal_text6: 'Se il contenuto è stato modificato, è necessario creare.',
    page_view_title: 'Visualizza pagina',
    page_view_button_video: 'Riproduci video',
    page_view_button_read: 'Leggi',
    page_view_text1: 'MiniLibroIn',
    page_view_text2: 'Riproduci auto',
    page_view_text3: 'Letture',
    page_view_text4: 'Pagina correlata',
    page_view_text5: 'Minilibro correlato',
    page_view_text6: 'Riferimento',
    page_view_text7: 'Riferimento',
    page_view_text8: 'Pubblicazione',
    page_view_text9: 'Autore',
    page_view_text10: 'Titolo',
    page_view_text11: 'Tutte le pagine di questo riferimento',
    page_view_text12: 'Ricerca correlata',
    page_view_text13: 'Pagina autore',
    page_view_text14: 'Conosci l\'autore',
    page_view_text15: 'Inserisci',
    page_view_reference_text1: 'Libro',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'Non ci sono Minilibri creati da te.  Creane uno sulla tua pagina.',
    page_view_pay_popup_text1: 'Hai trovato qualcosa di utile nella lettura? \nRispondi con un piccolo regalo per l’autore.',
    page_view_pay_popup_title: 'Invia un regalo',
    page_view_pay_popup_text2: 'Scegli un tè da inviare come regalo',
    page_view_pay_popup_text3: 'Scrivi un messaggio dal cuore',
    page_view_pay_popup_placeholder1: 'Le parole e la saggezza dell’autore mi hanno davvero aiutato.',
    page_view_pay_popup_text4: 'Importo',
    page_view_pay_popup_button1: 'Acquista e invia messaggio',
    page_view_pay_popup_text5: 'L’autore ha dedicato molto tempo e impegno a scrivere questo.\n\nRispondi con un piccolo regalo.',
    page_view_pay_popup_placeholder2: 'Mi affido all’esperienza e alla sensibilità dell’autore.',
    page_view_pay_popup_text6: 'Non vuoi inviare un regalo?',
    page_view_pay_popup_text7: 'Preferisci guardare una pubblicità?',
    page_view_pay_popup_button2: 'Guarda un annuncio per leggere',
    page_sort_title: 'Allineamento della pagina',
    page_sort_subtitle: 'Trascinare la pagina per modificare l\'ordine',
    page_sort_text: 'Fonte',
    pay_button: 'Acquista ora',
    pay_price: 'Prezzo',
    pay_vat_excluded: '(IVA esclusa)',
    pay_message_success: 'Acquistato',
    pay_message_fail: 'Fallito',
    pay_currency: 'EUR',
    pay_button_paid: 'Pagato',
    pay_button_view_price: 'Visualizza il prezzo',
    pay_total: 'Totale',
    pay_methods: 'Metodi di pagamento',
    pay_methods_creditcard: 'Carta di credito',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Continua',
    pay_text1: 'Seleziona un tè',
    pay_text2: 'Inserisci un messaggio',
    advertisement_button: 'Leggi di più',
    advertisement_text1: 'Puoi visualizzare il contenuto dopo aver guardato la pubblicità.',
    advertisement_text2: 'Questa è una pagina di un minilibro a pagamento. <br />Vai alla copertina e tocca Leggi per acquistare. <br />',
    advertisement_text3: 'Puoi visualizzare il contenuto dopo aver guardato la pubblicità. La pubblicità può essere vista solo nell\'app.',
    together_title: 'Evento',
    together_subtitle: 'Incontra e parla con i lettori',
    together_subtitle_text1: 'Incontra i lettori online',
    together_subtitle_text2: 'Crea una stanza e invita le persone',
    together_button: 'Crea uno spazio evento',
    together_case: 'Caso',
    together_case1: 'Cerco di darlo ma continuo a riceverlo',
    together_case2: 'Non ho mai conosciuto un esempio reale così utile',
    together_subtitle2: 'Spazio creato da me',
    together_category1: 'Ultimo',
    together_category2: 'I più preferiti',
    together_button_viewmore: 'Di più',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD. A hh:mm',
    together_subtitle3: 'Uno spazio come questo',
    together_subtitle3_1: 'Per favore crealo',
    together_subtitle_text3: 'Chiunque inizi parteciperà',
    together_create_title: 'Crea uno spazio evento',
    together_create_title2: 'Modifica lo spazio evento',
    together_create_button1: 'Seleziona',
    together_create_subtitle: 'Titolo',
    together_create_placeholder1: 'Inserire un titolo',
    together_create_subtitle1: 'Breve introduzione',
    together_create_placeholder2: 'Inserire una breve introduzione',
    together_create_subtitle2: 'Scegli lo strumento da utilizzare',
    together_create_text1: 'Link per riunione online (ad esempio, link Zoom)',
    together_create_placeholder3: 'Inserisci il link per la riunione online',
    together_create_question1: 'Non conosci il link alla chiamara zoom?',
    together_create_q1_a_title: 'Trova un link per unirti alla chiamata zoom',
    together_create_text2: 'Usa il metaverso',
    together_create_placeholder4: 'Scegli quello più adatto all\' Insieme',
    together_create_question2: 'Non conosci il metaverso?',
    together_create_text3: 'Scegliere dove aprire',
    together_create_dropmenu1: 'Aprire nell\'angolo degli intellettuali invitati di YB',
    together_create_dropmenu2: 'Aprire nell\'angolo degli autori e dei lettori',
    together_create_button2: 'Salvs',
    together_create_button3: 'Crea',
    together_create_popup_title: 'Scegli quello che si adatta a Insieme',
    together_create_popup_alert: 'Già selezionato',
    together_create_button4: 'Seleziona',
    together_create_alert: 'Si prega di inserire il link per la riunione online',
    together_create_alert1: 'Inserisci un titolo',
    together_create_alert2: 'Scegliere il metaverso da utilizzare',
    together_create_alert3: 'Impossibile modificare',
    together_create_alert4: 'Spazio evento creato',
    together_create_alert5: 'Errore. Riprova',
    together_create_alert6: 'Creazione dello spazio evento non riuscita...',
    together_qa_popup_title1: 'Trova un link per unirti alla chiamata Zoom',
    together_qa_popup_btext1: 'Computer',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Apri il programma Zoom - Dopo aver effettuato l\'accesso - Fai clic sul menu riunioni in alto - ID riunione personale - Fai clic su Mostra invito alla riunione - Apparirà un link per partecipare alla riunione Zoom - Fai clic sul menu riunioni in alto - ID riunione personale - Fai clic su Mostra invito a riunione - Apparirà un link per partecipare alla riunione Zoom. Copialo.',
    together_qa_popup_btext2: 'Smartphone',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Apri il programma Zoom - Dopo aver effettuato l\'accesso - Premi il pulsante i in alto a destra - Premi il pulsante i in alto a destra - Invia invito - Dopo aver premuto il messaggio - Inserisci numero di telefono - Apparirà un link. Copialo.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'Cos\'è il metaverso?',
    together_qa_popup_text3: 'Si tratta di uno spazio di incontro virtuale.',
    together_qa_popup_text4: 'Appare sotto forma di un avatar che avete creato',
    together_qa_popup_text5: 'Parlare con i propri amici faccia a faccia - Puoi anche condividere il tuo schermo.',
    together_qa_popup_text7: 'In uno spazio di incontro',
    together_qa_popup_text8: '- 10 persone possono accedere contemporaneamente.',
    together_qa_popup_text9: 'Non è necessario installare un programma separato',
    together_qa_popup_text10: 'o non è richiesta la registrazione di un membro.',
    together_more_list_title: 'Spazio evento',
    together_more_list_date: 'YYYY. MM. DD',
    together_request_list_title: 'Per favore crealo',
    together_request_list_category1: 'I più preferiti',
    together_request_list_category2: 'Ultimi',
    together_request_list_button: 'Suggerisci un nuovo spazio',
    together_request_popup_title: 'Suggerimento nuovo spazio',
    together_request_popup_alert1: 'Inserisci un titolo',
    together_request_popup_alert2: 'Inserisci una breve introduzione',
    together_request_popup_placeholder1: 'Inserisci un titolo',
    together_request_popup_placeholder2: 'Inserisci una breve introduzione',
    together_request_popup_button: 'Salva',
    together_request_detail_button: 'Crea questo spazio',
    together_detail_sns: 'Condividi',
    together_detail_enterbtn: 'Accedi',
    together_detail_btn1: 'Elenco eventi',
    together_detail_btn2: 'Messaggio',
    together_detail_subtitle: 'Minilibro sull\'argomento',
    together_detail_alert: 'Attendere un momento...',
    together_detail_alert1: 'Spazio evento suggerito con successo!',
    together_detail_alert2: 'Impossibile suggerire lo spazio evento…',
    together_detail_alert3: 'Preferito / Annullato con successo il preferito',
    together_detail_alert4: 'Preferito / Impossibile annullare il preferito',
    together_detail_alert5: 'Problema nel server, riprova più tardi',
    together_detail_alert6: 'C\'è un problema con il link per riunione online',
    together_detail_alert7: 'Impossibile eliminare',
    together_notice_alert: 'Vuoi eliminare l\'annuncio?',
    together_notice_list_title: 'Annuncio',
    together_button_addtopic: 'Aggiungi questo come argomento allo spazio evento',
    together_add_alert: 'Aggiunto allo spazio evento',
    together_text1: 'Gusti simili ai tuoi',
    together_text2: 'Vuoi eliminare questo spazio evento?',
    together_event_btn: 'Crea un nuovo evento',
    together_event_title: 'Nuovo evento',
    together_event_placeholder: 'Inserisci un\'introduzione',
    together_event_text1: 'Imposta il programma',
    together_event_text2: 'Imposta la tariffa d\'ingresso',
    together_event_text3: 'Imposta la capienza massima',
    together_event_text4: 'Programma',
    together_event_text5: 'Tariffa d\'ingresso',
    together_event_text6: 'Capienza massima',
    together_event_text7: 'Notifica ai miei follower',
    together_event_text8: 'Vuoi eliminare l\'evento?',
    together_event_text9: 'Imposta l\'orario di inizio dopo l\'orario attuale',
    together_event_text10: 'Imposta l\'orario di fine dopo l\'orario di inizio',
    together_event_text11: 'L\'orario di inizio e l\'orario di fine non possono essere uguali',
    together_event_text12: 'Aggiungi questo come argomento dell\'evento',
    together_event_text13: 'Aggiunto all\'evento',
    together_event_text14: 'L\'evento ha superato la capienza massima',
    together_event_text15: 'Pulsante si attiva 1 ora prima dell\'Evento \n(se gratuito non serve Acquista ora)',
    together_event_text16: 'Pulsante si attiva 1 ora prima dell\'Evento',
    together_event_text17: 'Nessun evento esistente',
    together_event_text18: 'Non può essere eliminato se c\'è un acquirente per l\'evento',
    together_event_text19: 'Vuoi inviare una notifica?',
    together_event_text20: 'Inviato',
    together_event_text21: 'Elenco degli eventi',
    together_event_text22: 'Vedi dettagli',
    together_event_text23: 'Dopo Registrarsi accedi',
    together_event_text24: 'Modalità di partecipazione',
    together_event_text25: 'Partecipazione all’evento completata',
    together_event_text26: 'L’autore ha dedicato molto tempo e cura a questo evento.\n\nRispondi con un piccolo regalo.',
    together_event_text27: 'La saggezza derivata dall’esperienza dell’autore e la comunicazione profonda sono state impressionanti',
    together_event_text28: 'Condividi questo evento con il mondo',
    together_event_text29: 'Non è stato facile organizzare questo evento, ma ce l’ho fatta.',
    together_event_text30: 'Per quanto possa essere bello un evento, è difficile diffonderlo da soli.',
    together_event_text31: 'Un sostenitore è colui che diffonde l’evento dell’autore nel mondo. È qualcuno che incoraggia gli altri.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Incontra persone da tutto il mondo',
    youbooker_case: 'Caso',
    youbooker_case_text1: 'Essere il primo che inizia sempre',
    youbooker_case_text2: 'Qual è l\'effetto dell\'interesse composto della conoscenza?',
    youbooker_translation: 'Vuoi incontrare subito?',
    youbooker_translation_text1: 'Tutte le lingue',
    youbooker_category: 'Follower / Seguiti',
    youbooker_subcategory1: 'Il mio follower',
    youbooker_subcategory2: 'Io seguo',
    youbooker_subtitle2: 'Questi mi stanno seguendo',
    youbooker_button_follow: 'Segui',
    youbooker_message_follow: 'Segui',
    youbooker_button_follow_cancel: 'Smetti di seguire',
    youbooker_subtitle3: 'Questi sono gli utenti che conosci',
    youbooker_subtitle4: 'Li sto seguendo',
    youbooker_subtitle5: 'Questi non conoscono ancora YB',
    youbooker_button_invite: 'Invita',
    youbooker_alert_invite: 'L\'invito è possibile solo attraverso l\'app.Scarica l\'app per favore',
    youbooker_alert: 'Solo nell\'app. Perché non scaricare l\'app?',
    youbooker_alert2: 'Aggiornamento riuscito!',
    youbooker_alert3: 'Puoi cercare cercare nella scheda YouBooker',
    home_page_text1: 'Più recenti',
    home_page_text2: 'Influenza',
    home_page_today_title: 'Tema del giorno',
    home_page_today_subtitle: 'Correlato alle notizie TOP',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: 'Tema del giorno',
    home_page_today_detail_sns: 'Condividi',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: 'Pagine correlate',
    home_page_explor_title: 'Esplora la pagina',
    home_page_explor_subtitle: 'Cosa succede se si fa doppio clic?',
    home_page_recommend_title: 'Raccomandazioni',
    home_page_recommend_subtitle: 'Pagine che possono interessanti',
    home_page_theysee_title: 'Cosa vedono i lettori',
    home_page_theysee_subtitle: 'Pagine che i lettori vedono di più',
    home_page_common_title: 'Sensibilità comune',
    home_page_common_subtitle: 'Preferisci sapere questo',
    home_page_keyw_title: 'Pagine per parole chiave',
    home_page_keyw_subtitle: 'Trova tutte le pagine correlate',
    home_page_random_title: 'Invia a caso',
    home_page_random_subtitle: 'Premi quando sei stordito e scopri qualcosa di inaspettato',
    home_page_about_title: 'Informazioni su YouBook',
    home_page_about_detail: 'Società: NICK syndicate /Sede: Milano / Filiali: Tokyo Shanghai Seoul Seattle /Contatto: joa@academy-connect.net/DUNS 695937905',
    settlement_title: 'Acquisto e transazione',
    settlement_tab1: 'Registro ordini',
    settlement_tab2: 'Informazioni sull\'conto bancario',
    settlement_tab3: 'Registro della transazione',
    settlement_category1: 'Il mio registro degli acquisti',
    settlement_category2: 'Condivisione dei diritti d’autore',
    settlement_category3: 'Registro dei ricavi del minilibro',
    settlement_category4: 'Registro dei ricavi dell\'evento',
    settlement_category5: 'Gestisci conto',
    settlement_text1: 'Mostra il registro degli acquisti',
    settlement_text2: 'Puoi condividere i diritti d’autore del minilibro',
    settlement_text3: 'Controlla il record della liquidazione del Minilibro pagato.',
    settlement_text4: 'Se avete altre domande, cliccate',
    settlement_text5: 'qui',
    settlement_text6: 'Oppure contattateci qui sotto.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Dite una parola',
    settlement_text9: 'Se hai ricavi, devi gestire il conto per ricevere i pagamenti',
    settlement_text10: 'Regola i ricavi ottenuti dagli eventi',
    settlement_purchase_text1: 'Registro degli acquisti',
    settlement_purchase_text2: 'Data',
    settlement_purchase_text3: 'Importo dell\'acquisto',
    settlement_purchase_text4: 'Titolo',
    settlement_purchase_text5: 'Minilibro',
    settlement_purchase_text6: 'Evento',
    settlement_accountInfo_text1: 'Diritti d’autore del minilibro',
    settlement_accountInfo_text2: 'Minilibro',
    settlement_accountInfo_text3: 'Lingua',
    settlement_accountInfo_text4: 'Diritti d’autore',
    settlement_accountInfo_text5: 'Autore',
    settlement_accountInfo_text6: 'Terze parti',
    settlement_accountInfo_text7: 'Personale?',
    settlement_accountInfo_text8: 'Personale',
    settlement_accountInfo_text9: 'Organizzazione',
    settlement_accountInfo_text10: 'Nome della banca',
    settlement_accountInfo_text10_message: 'Seleziona il nome della banca',
    settlement_accountInfo_text11: 'Nome del titolare del conto bancario',
    settlement_accountInfo_text11_message: 'Inserisci il nome del titolare del conto bancario',
    settlement_accountInfo_text12: 'Numero del conto bancario',
    settlement_accountInfo_text12_message: 'Inserisci il numero del conto bancario',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Numero del codice fiscale',
    settlement_accountInfo_text13_message: 'Inserisci il numero del codice fiscale',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Indirizzo personale',
    settlement_accountInfo_text14_message: 'Inserire un indirizzo personale',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'Indirizzo e-mail',
    settlement_accountInfo_text15_message: 'Inserisci un\'e-mail',
    settlement_accountInfo_text16: 'Salva',
    settlement_accountInfo_text17: 'Numero di identificazione del datore di lavoro (EIN)',
    settlement_accountInfo_text17_message: 'Inserisci il numero EIN',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Indirizzo della corporazione',
    settlement_accountInfo_text18_message: 'Inserisci l\' indirizzo dell\'organizzazione',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'Nome dell\'organizzazione',
    settlement_accountInfo_text19_message: 'Inserisci il nome dell\'organizzazione',
    settlement_accountInfo_text20: 'Numero di telefono dell\'organizzazione',
    settlement_accountInfo_text20_message: 'Inserisci i contatti dell\'organizzazione',
    settlement_accountInfo_text21: 'ID della terza parte',
    settlement_accountInfo_text21_placeholder: 'Email della terza parte',
    settlement_accountInfo_text22: 'Conto bancario per ricevere il pagamento',
    settlement_accountInfo_text23: 'Paese',
    settlement_accountInfo_message1: 'Impossibile trovare l\'e-mail',
    settlement_accountInfo_message2: 'Non puoi condividere i diritti d’autore con te stesso',
    settlement_accountInfo_message3: 'Non ci sono Minilibri creati',
    settlement_accountInfo_text24: 'Condivisione dei diritti d’autore',
    settlement_accountInfo_text25: 'Una volta condivisi i diritti d’autore con terze parti, non è possibile revocarli',
    settlement_accountInfo_text26: 'Vuoi condividere i diritti d’autore?',
    settlement_accountInfo_text27: 'Sì, condivido',
    settlement_accountInfo_text28: 'Per condividere i diritti d’autore,<br /> 1) le pagine del minilibro devono essere create da te e <br /> 2) non devono essere state condivise in precedenza con terze parti',
    settlement_accountInfo_text29: 'Va bene, lo sistemerò',
    settlement_accountInfo_text30: 'Hai condiviso i diritti d’autore di questo minilibro con terze parti',
    settlement_accountInfo_text31: 'Autore',
    settlement_accountInfo_text32: 'Terze parti',
    settlement_accountInfo_text33: 'Hai ricevuto i diritti d’autore di questo minilibro dall’autore',
    settlement_accountInfo_text34: 'Questo è un minilibro gratuito. Non è richiesto alcun conto bancario.',
    settlement_accountInfo_text35: 'Condivisione dei ricavi',
    settlement_accountInfo_text36: '(io)',
    settlement_accountInfo_text37: '(editori, ecc.)',
    settlement_accountInfo_text38: 'Conto personale',
    settlement_accountInfo_text39: 'Conto società',
    settlement_accountInfo_text40: 'Gestione del conto',
    settlement_accountInfo_text41: 'Salva',
    settlement_accountInfo_text42: 'Banca',
    settlement_accountInfo_text43: 'Selezione del conto',
    settlement_accountInfo_text44: 'Decidere come dividere i ricavi',
    settlement_accountInfo_text45: 'Tasso di ricavi (%)',
    settlement_accountInfo_text46: 'Il mio ID (email)',
    settlement_accountInfo_text47: 'ID del terzo (email)',
    settlement_accountInfo_text48: 'Abbina il totale',
    settlement_accountInfo_text49: 'Inserisci le informazioni del cessionario',
    settlement_accountInfo_text50: 'Il tasso di ricavi non può superare 100',
    settlement_accountInfo_text51: 'Cedente ID(email)',
    settlement_accountInfo_text52: 'Cessionario ID(email)',
    settlement_earnings_text1: 'Registrazione del regolamento',
    settlement_earnings_text2: 'Periodo di regolamento',
    settlement_earnings_text3: 'Prezzo del Minilibro',
    settlement_earnings_text4: 'Quantità di vendita',
    settlement_earnings_text5: 'Importo delle vendite',
    settlement_earnings_text6: 'Detrazioni, comprese le tasse',
    settlement_earnings_text7: 'Importo del deposito',
    settlement_earnings_text8: 'Data del deposito',
    settlement_earnings_text9: 'Visualizzazioni annuncio',
    settlement_earnings_text10: 'Importo totale',
    settlement_earnings_text11: 'Scopri di più',
    settlement_earnings_text12: 'Prezzo dell\'annuncio',
    settlement_earnings_text13: 'Ricavi',
    settlement_earnings_text14: 'Tutti i minilibri',
    settlement_earnings_text15: 'Seleziona evento',
    settlement_earnings_text16: 'Tutti gli eventi',
    settlement_statistics_text1: 'Volume di vendite',
    settlement_statistics_text2: 'Numero di lettori',
    settlement_statistics_text3: '(Ultimo)',
    settlement_statistics_text4: '1 mese',
    settlement_statistics_text5: '6 mesi',
    settlement_statistics_text6: '1 anno',
    settlement_statistics_text7: 'Nessun dato trovato',
    settlement_statistics_text8: 'Analisi delle vendite',
    settlement_statistics_text9: 'Visualizzazioni pubblicitarie',
    settlement_statistics_text10: 'Tutte le lingue',
    terms_title: 'Condizioni di servizio',
    terms_text: ' ',
    privacy_title: 'Informativa sulla privacy',
    privacy_text: '',
    // common text
    message_save: 'Salvato',
    message_fail: 'Non riuscito',
    message_delete: 'Eliminato',
    message_report: 'Segnalato',
    message_search_no_result: 'Nessun risultato di ricerca trovato',
    message_search_enter: 'Inserisci un termine di ricerca',
    message_error1: 'Si è verificato un errore. Contatta l\'amministratore',
    message_save2: 'Salvato',
    message_fail2: 'Non riuscito',
    message_login: 'È necessario effettuare il LOGIN',
    name: 'Nome e cognome',
    email: 'Indirizzo e-mail',
    mobile: 'Cellulare',
    list: 'Elenco',
    edit: 'Modifica',
    delete: 'Elimina',
    search: 'Ricerca',
    report: 'Segnala il contenuto',
    user: 'Utente',
    report_type: 'Tipo di segnalazione',
    report_type1: 'Profanazione/diffamazione',
    report_type2: 'Pubblicità',
    report_type3: 'Oscenità/ Contenuto sessualmente esplicito',
    report_type4: 'Ripetizione dello stesso contenuto',
    report_type5: 'Altro',
    search_book: 'Cerca Minilibro',
    serch_placeholder: 'Cerca per nome o e-mail',
    search_keyword: 'Parola chiave',
    search_reference: 'Riferimento',
    search_author: 'Autore',
    search_result: 'Trovato',
    button_report: 'Segnala a YouBook',
    button_write: 'Salva',
    button_login: 'LOGIN',
    button_more: 'Altro',
    button_confirm: 'Confermato',
    button_save: 'Salva',
    button_crop: 'Ritaglia',
    button_delete: 'Elimina',
    button_complete: 'completare',
    colorbox_background_text1: 'Seleziona un colore di sfondo',
    colorbox_font_text1: 'Selezionare un colore del testo',
    menu_home: 'Home',
    menu_page: 'Pagina',
    menu_book: 'Minilibro',
    menu_memo: 'Memo',
    menu_together: 'Evento',
    login_button: 'LOGIN',
    message_text1: 'Rispondi',
    message_text2: 'Una risposta è stata aggiunta al mio commento',
  },
  ja: {
    home_banner_title1: '新しいミニブック',
    home_banner_title2: '新しいイベント',
    home_slide_title1: '今注目',
    home_slide_title2: '私の好み',
    home_slide_title3: '今ホット',
    home_slide_title4: 'とても人気',
    home_detail_title1: '日常の記憶',
    home_detail_title2: 'おすすめの動画',
    home_detail_title3: 'もっと知りたいなら',
    home_detail_text1: 'ミニブックメモ',
    home_detail_text2: '日常メモ',
    home_setting_title: '設定',
    home_setting_text1: '過去30日間に見たページ',
    home_setting_text2: 'ログアウト',
    home_setting_text3: 'アカウント削除',
    home_book_banner_question: '気になるところ',
    home_book_banner_write_placeholder1: 'タイトルを入力してください。',
    home_book_banner_write_placeholder2: '内容を入力してください。',
    home_book_banner_write_button: '保存',
    home_book_banner_detail_text1: 'YouBookメンターの回答',
    home_book_banner_detail_text2: '関連するミニブックを見る。',
    home_book_create_button: 'ミニブック、作ってみよう',
    home_book_create_text1: 'ミニブックとは、約10ページの短い本のことです。短くても重要な内容を素早く読める、新しいトレンドに合わせた本です。',
    home_book_create_text2: '出版後に編集する方法',
    home_book_create_text3: 'ミニブック、簡単に作成する方法',
    home_book_create_text4: '著者の収益はどれくらい？',
    home_book_create_text5: '読者と出会うには？',
    home_book_create_text6: 'YouBookを使うべき5つの理由',
    home_book_create_text7: 'その他の疑問は？',
    home_book_create_text8: '販売数をリアルタイムで確認できる？',
    home_book_create_text9: '毎日コツコツと書き続けましょう！',
    home_book_create_text10: '今すぐ始めてみよう！',
    home_book_category_title1: '今日の話題とミニブック',
    home_book_category_title2: '話題のミニブック',
    home_book_category_title3: 'S級教授のミニブック',
    home_book_category_title4: 'パーソナライズ推薦',
    home_book_category_title5: 'ベストセラーの核心を抽出したミニブック',
    home_book_category_title6: 'ほんにゃんと一緒に',
    home_book_category_title6_text1: '表示',
    home_book_category_title6_text2: '閉じる',
    home_book_category_title7: 'ニューラルネットのページ探索',
    home_book_category_title8: '芸術と感性の祭典',
    home_book_category_title8_text1: '映画とドラマの世界',
    home_book_category_title8_text2: '心を揺さぶるメロディと動き',
    home_book_category_title8_text3: '境界を越えた芸術',
    home_book_category_title8_text4: '個性を着る: 衣装とスタイル',
    home_book_category_title9: '味と余裕の美食文化',
    home_book_category_title9_text1: '美食探検、地元料理を知る',
    home_book_category_title9_text2: '酒と人生の物語',
    home_book_category_title9_text3: 'スナックとデザートの魅力',
    home_book_category_title9_text4: '自然の力、植物の秘密',
    home_book_category_title10: '人生の知恵と自己発見',
    home_book_category_title10_text1: 'ユニークなお金の扱い方',
    home_book_category_title10_text2: '自分だけの成長レシピ',
    home_book_category_title10_text3: '人間関係の問題と解決策',
    home_book_category_title10_text4: '新たな発見と知識',
    home_book_category_title11: '多様な価値観と愛',
    home_book_category_title11_text1: '彼らの生活の物語',
    home_book_category_title11_text2: '異なる哲学、異なる価値観',
    home_book_category_title11_text3: '宗教的信仰と伝統の物語',
    home_book_category_title11_text4: '愛の神秘',
    home_book_category_title12: '旅行と趣味で満たす一日',
    home_book_category_title12_text1: '必見の隠れた旅行地',
    home_book_category_title12_text2: '趣味から見える人生の楽しみ',
    home_book_category_title12_text3: '遊びで語るユニークな文化',
    home_book_category_title13: '伝統と物語の豊かさ',
    home_book_category_title13_text1: '地域の神話と英雄の物語',
    home_book_category_title13_text2: '世界の文学旅',
    home_book_category_title13_text3: '各地の歴史と知恵',
    home_book_category_title13_text4: '多彩な社会の物語',

    home_book_category_title1_text2: 'ほんにゃんの考えだよ〜ちょっと見る？',
    home_book_category_title1_text3: '悩み？気になる？',
    home_book_category_title1_text4: 'ミニブックをおすすめしましょうか？',
    home_book_search_placeholder1: 'こちらにお話しください',
    home_book_search_placeholder2: 'キーワードを教えてください',
    home_book_search_message1: '質問を入力してください。',
    home_book_search_message2: 'もう一度質問を入力してください',
    home_book_search_text1: '私と議論してみませんか？',
    home_book_search_text2: '私と議論してみませんか？',
    home_book_search_text3: '聞く',
    home_book_search_text4: '上記の内容を保存できます。',
    home_book_search_text5: '(キーワードを追加してください）',
    home_book_search_text6: '検索',
    home_book_theme_title: 'テーマ別に見る',
    home_instant_text1: 'キーワードを入力する',
    home_instant_text2: 'ランダムに入力する',
    home_book_company_info: 'ご不明な点がございましたら、お気軽に下記までお問い合わせください。お待ちしております。',
    home_page_search_text1: 'ページ検索',
    home_page_search_text2: '動画ですぐ見ることができます。',
    home_page_search_text3: '詳細検索',
    home_page_search_text4: '一覧表示',
    home_page_search_text5: 'ネットワークビュー',
    home_page_explor_alert: 'ページが選択されていません',
    home_page_explor_alert2: '1画面に表示できる最大ページ数（150ページ）を超えました。不要なページはゴミ箱に入れてください。',
    home_page_explor_alert3: '読み込む情報がなくなりました',
    my_login_title: 'MY',
    my_login_text1: 'プロフィールをスタイリッシュにしてみよう。',
    my_login_text2: '今すぐログインしてYouBookと始めよう',
    my_login_text3: 'YouBookでスマートに',
    my_login_find_password: 'パスワードを探す',
    my_guide_minibook: 'ミニブックの作り方',
    my_password_reset: 'パスワードを再設定する',
    my_password_reset_text1: '登録したメールアドレスを入力してください。',
    my_password_reset_button1: 'パスワードを再設定するためのリンクを送信する。',
    my_password_reset_button2: '再設定',
    my_password_reset_message1: 'メールアドレスが見つかりません。',
    my_password_reset_message2: 'ご入力いただいたメールアドレスに、パスワード再設定のリンクを送信しました。',
    my_password_reset_message3: '送信されたリンクからパスワードを再設定後、再度ログインしてください。',
    my_password_reset_placeholder1: 'あなたのメールアドレス',
    my_password_reset_placeholder2: '新しいパスワードを入力してください',
    my_password_reset_placeholder3: '新しいパスワードを再入力してください',
    my_password_reset_message4: 'パスワードが一致しません',
    my_password_reset_message5: 'パスワードは少なくとも8文字以上で、少なくとも1つの大文字、1つの小文字、1つの数字、1つの特殊文字を含む必要があります',
    my_password_reset_message6: 'パスワードの再設定が完了しました。',
    my_memo_list_placeholder: 'いいアイディアが浮かんだら、今すぐメモしてみましょう。',
    my_profile_placehoder1: '関心分野',
    my_profile_placehoder2: '名前',
    my_profile_placehoder3: '簡単な自己紹介',
    my_profile_placehoder4: 'その他',
    my_profile_text1: '国籍',
    my_profile_text2: '言語',
    my_profile_text3: 'IDを変更する',
    my_profile_text4: '現在のID',
    my_profile_text5: '変更するID',
    my_profile_text6: 'IDの変更は1回のみ可能です',
    my_menu_text1: '私の旅行',
    my_menu_text2: 'メッセージ',
    my_menu_text3: '購入と決済',
    my_menu_text4: '新しい\nお知らせ',
    my_menu_text5: 'ミニブックを\n作成する',
    my_menu_text6: '作成した\nミニブック',
    my_menu_text7: '他のアプリで書いた記事をインポートしますか？',
    my_menu_text8: '自動でインポートし、ページに変換できます',
    my_menu_text9: 'インポート',
    my_import_book_text1: 'ページに変換する',
    my_import_book_text2: 'ZIPファイルをページに変換中です。1つの記事につき最大5秒かかります。10件で約1分、100件で約8分かかる可能性があります。変換が完了すると、ポップアップが表示されます。',
    my_import_book_text3: '了解',
    my_import_book_text4: 'ページ変換が完了しました',
    my_import_book_text5: 'ZIPファイル内のすべての記事がページに変換されました。各記事は個別のページに変換されました。確認は「私の旅行 - 作成したページ」から可能です。ページは一時保存されており、編集可能です。',
    my_import_book_text6: '他のアプリで書いた記事をインポートし、自動でページに変換できます。その後、ページをまとめてミニブックを作成できます。',
    my_import_book_text7: '他のアプリの記事をZIPファイルでインポートする方法',
    my_import_book_text8: 'ZIPファイルをアップロードしてください',
    my_import_book_text9: 'Substackファイルをアップロード',
    my_import_book_text10: 'Mediumファイルをアップロード',
    my_import_book_text11: '検索',
    my_import_book_text12: '* 各記事はそれぞれページに変換されます',
    my_import_book_text13: '* マイページ - 設定 - 作成したページ で確認できます',
    my_import_book_text14: '* ページは一時保存されており、編集可能です',
    my_import_book_text15: '* 自分が書いた記事のみインポートできます',
    my_import_book_text16: '変換されたページでミニブックを出版する',
    my_import_book_text17: 'ミニブックの表紙を作成する',
    my_import_book_text18: 'ページを選んでミニブックに追加する',
    my_import_book_text19: 'ミニブックを出版する',
    my_import_book_text20: '説明を必ず読んでください',
    my_import_book_text21: 'ZIP形式ではありません',
    my_import_book_text22: 'ファイルをアップロードしてください',
    my_journey_title: '私の旅行',
    my_journey_button_message: 'メッセージ',
    my_journey_button_memo: 'メモ',
    my_journey_button_record: '旅行の記録',
    my_journey_button_follow: 'フォロー',
    my_journey_button_follow_cancel: 'アンフォロー',
    my_journey_message_text1: 'メッセージを残す',
    my_journey_message_placeholder: '文章を入力してください。',
    my_journey_message_message1: '返信できません',
    my_journey_message_message2: '送信',
    my_journey_message_message3: 'メッセージを入力してください。',
    my_journey_memo_total: '合計',
    my_journey_record_overall: '影響力ランキング',
    my_journey_record_text1: '閲覧ページ',
    my_journey_record_text2: 'お気に入りのミニブック',
    my_journey_record_text3: 'お気に入りのイベントスペース',
    my_journey_record_text4: '作成したページ',
    my_journey_record_text5: '作成したミニブック',
    my_journey_record_text6: '私が作成したイベントスペース',
    my_journey_record_text7: '今月',
    my_journey_record_text8: '購入したミニブック',
    my_journey_record_text9: '公開',
    my_journey_record_text10: '非公開',
    my_journey_record_text11: '購入したイベント',
    my_journey_record_text12: '私が作成したイベント',
    my_journey_record_text13: '{userLanguage}圏 第{userRank}位',
    my_journey_record_text14: '著者権の共有ミニブック',
    my_journey_record_text15: '読者に特定の順番で読んでほしいですか？そうであれば、表紙をドラッグして順番を変更してください。',
    my_journey_record_text16: '新しいミニブックを応援してください',
    my_journey_record_text17: '読者からの応援メッセージ',
    my_journey_record_text18: '著者に応援メッセージを残してください',
    my_journey_record_text19: 'サポーターのレベル',
    my_journey_record_text20: '全10レベル中の{cheeringLevel}',
    my_journey_record_text21: '私がサポートしている人',
    my_journey_record_text22: '私のサポーター',
    my_journey_record_text23: '削除しますか？',
    my_journey_record_text24: '{userName} のサポーター',
    my_journey_record_text25: '{userName} によるサポート',
    my_notice_title: 'お知らせ',
    my_notice_message1: '新しいお知らせはありません',
    my_notice_text1: '新しいミニブックが届きました',
    my_notice_text2: '新しい今日のイシューが届きました',
    my_notice_text3: '私の旅行に新しいメッセージが届きました',
    my_notice_text4: '私が共有したメモに新しいコメントがつきました',
    my_notice_text5: '自分のイベントスペースに新しいコメントがあります',
    my_notice_text6: '私が作成したミニブックの表紙に新しいコメントがつきました',
    my_notice_text7: '私が作成したページに新しいコメントがつきました',
    my_notice_text8: 'さんが新しいメモを投稿しました',
    my_notice_text9: '{userName}さんが新しいイベントスペースを作成しました',
    my_notice_text10: 'さんが新しいミニブックを出版しました',
    my_notice_text11: 'が私のミニブックを購入しました',
    my_notice_text12: '{userName}が<b>新しいイベント</b>を作成しました',
    my_notice_text13: '{userName}が特別にあなたを<b>新しいイベント</b>に招待しました。ぜひチェックしてみてください！ ',
    my_notice_text14: '{userName}が<b>私のイベントを購入しました</b>',
    my_notice_text15: '{userName}が共同著者を申請しました',
    my_notice_text16: 'オープンミニブックの共同著者申請が承認されました',
    my_notice_text17: '共同著者によって新しいコメントが投稿されました',
    my_notice_text18: '新しいミニブックを応援するメッセージが届きました',
    my_notice_text19: '{userName}が<b>私のミニブック</b>をスポンサーしました',
    my_marketing_banner_title: '自分を応援しよう',
    my_marketing_banner_text1: '困難を乗り越えたあなた、自分を応援して',
    my_marketing_banner_btn: '今すぐ応援',
    my_marketing_title: '今すぐ応援',
    my_marketing_text1: 'ミニブックとイベントという2つの翼をつけて、段階的なプロモーションを燃料にし、インフルエンサーになろう',
    my_marketing_text2: '一般読者にメール',
    my_marketing_text3: '一般読者にメッセージ',
    my_marketing_text4: '友だちにメール',
    my_marketing_text5: '友だちにメッセージ',
    my_marketing_text6: 'SNSにリンク',
    my_marketing_btn: '今すぐ始める',
    my_marketing_minibook_step1_title: 'ミニブック応援',
    my_marketing_step1_subtitle: 'SNSにリンク',
    my_marketing_minibook_step1_text1: 'あなたのSNSにミニブックをリンクし、魅力的な説明を追加してください',
    my_marketing_minibook_text1: 'ミニブックを探してください',
    my_marketing_step1_text1: 'リンクをコピーしてください',
    my_marketing_step1_btn: 'コピー',
    my_marketing_step1_text2: 'SNSに貼り付けて説明を追加してください',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'カカオストーリー',
    my_marketing_step1_sns5: 'ネイバーバンド',
    my_marketing_step1_sns6: 'ネイバーブログ',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小紅書）',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: '共有するミニブックを選択してください',
    my_marketing_step1_text4: 'リンクがコピーされました',
    my_marketing_step1_text5: '共有するイベントを選択してください',
    my_marketing_step1_text6: 'ソーシャルメディアを探す',
    my_marketing_event_step1_title: 'イベント応援',
    my_marketing_event_step1_text1: 'あなたのSNSにイベントをリンクし、魅力的な説明を追加してください',
    my_marketing_event_text1: 'イベントを探してください',
    my_marketing_event_search_title: 'イベント検索',
    my_marketing_minibook_step2_title: 'ミニブック第2段階マーケティング',
    my_marketing_step2_subtitle: '友だちにメッセージ',
    my_marketing_minibook_step2_text1: '友だちにミニブックのリンクと心のこもった紹介文を送りましょう',
    my_marketing_step2_text2: '友だちにリンクと一緒に紹介文を送りましょう',
    my_marketing_step2_placeholder: '紹介文を入力してください',
    my_marketing_tab_text1: '私の友だち',
    my_marketing_event_step2_title: 'イベント第2段階マーケティング',
    my_marketing_event_step2_text1: '友だちにイベントのリンクと心のこもった紹介文を送りましょう',
    my_marketing_minibook_step3_title: 'ミニブック第3段階マーケティング',
    my_marketing_step3_subtitle: '友だちにメール',
    my_marketing_minibook_step3_text1: '友だちにミニブックのリンクと一緒に背景ストーリーを伝えましょう',
    my_marketing_step3_text1: '連絡先リストをインポートしてください',
    my_marketing_step3_placeholder: 'csv または vcf ファイルをアップロード',
    my_marketing_step3_text2: '友だちにリンクと一緒にストーリーを伝えましょう',
    my_marketing_step3_text3: '電話番号リストをインポートしてください',
    my_marketing_step3_placeholder2: 'ストーリーを伝えてください',
    my_marketing_event_step3_title: 'イベント第3段階マーケティング',
    my_marketing_event_step3_text1: '友だちにイベントのリンクと一緒に背景ストーリーを伝えましょう',
    my_marketing_text7: '電話番号をインポート',
    my_marketing_title2: '電話番号を管理',
    my_marketing_text8: '電話',
    my_marketing_text9: '回数',
    my_marketing_text10: '連絡先をインポート',
    my_marketing_text11: 'csv または vcf ファイルをアップロードしてください',
    my_marketing_text12: 'インポート方法',
    my_marketing_text13: 'インポート',
    my_marketing_title3: '連絡先を管理',
    contact_manage: '連絡先管理',
    my_marketing_text14: '選択項目を削除',
    my_marketing_text15: '友達を選択してください',
    my_marketing_text16: '最大100人の友達を選択できます',
    my_marketing_text17: 'アップロードされました',
    my_marketing_text18: '入力可能な文字数を超えました',
    contact_phone: '電話',
    contact_organization: '所属',
    contact_title: '役職',
    contact_memo: 'メモ',
    my_marketing_text19: '選択を編集',
    my_marketing_text20: 'ラベルを選択',
    my_marketing_text21: '新しいラベルを追加',
    my_marketing_text22: '選択したラベルを削除',
    my_marketing_text23: '追加',
    my_marketing_btn2: '編集完了',
    my_marketing_text24: '編集する連絡先を選択してください',
    my_marketing_text25: '削除するラベルを選択してください',
    my_marketing_text26: 'ラベル名を入力してください',
    my_marketing_text27: 'このラベルはすでに存在します',
    my_marketing_text28: 'ラベルを追加',
    my_marketing_text29: 'キャンセル',
    my_marketing_text30: '追加されました',
    my_benefit_text1: 'これまでに得た利益',
    my_benefit_text2: 'あなたが1年間に得た利益',
    my_benefit_text3: '',
    my_benefit_text4: '得た利益',
    my_benefit_text5: 'これから得る利益',
    my_benefit_text6: '内訳を確認する',
    my_benefit_modal_text1: 'あなたは今まで',
    my_benefit_modal_text2: '円',
    my_benefit_modal_text3: '利益を得ました',
    my_benefit_modal_text4: '簡略に計算してみます。',
    my_benefit_modal_text5: 'これまでに読まれたページ数',
    my_benefit_modal_text6: 'ページごとの作成価格',
    my_benefit_modal_text7: '円',
    my_benefit_modal_text8: 'つまり、あなたが得た利益は',
    my_benefit_modal_text9: 'ここに AIとの議論による特典を加えると、',
    my_benefit_modal_text10: 'あなたが得る利益はさらに増えます',
    my_benefit_modal_text11: '毎日使ってさらに利益を得ましょう',
    my_benefit_modal_text12: 'わかりました',
    my_story_text1: '会員の声',
    my_story_text2: '本は読むものではなく、経験するものだという事実',
    my_story_text3: '毎日新たな知識を得ることで、驚くべきことが起きます',
    my_story_text4: '賢い人が経験する隠れた落とし穴、あなたも経験してませんか？',
    my_story_text5: '会員の声をもっと聞く',
    my_go_blog_text1: 'YouBook、ニュースとお客様の声',
    my_go_blog_text2: 'YouBookの最新ニュースとお客様の声をご覧ください',
    my_go_blog_text3: 'もっと見る',
    my_channel_text1: 'YouBookを使ってみて、どう思いますか？',
    my_channel_text2: '良い点や改善点を教えてください。',
    my_channel_text3: 'また、気になる点などがあればぜひお聞かせください。',
    my_channel_text4: '一言',
    my_about_youbook_text1: 'YouBookを利用すべき理由',
    my_about_youbook_text2: 'すべてのQ&Aはこちら',
    my_about_youbook_text3: '利用規約',
    my_app_text1: 'YouBookは100％有益なアプリです。',
    my_app_text2: '今すぐダウンロードして知識を身につけましょう',
    my_app_text3: 'アプリをダウンロード',
    login_title: 'ログイン',
    login_text1: 'メールアドレスでログイン',
    login_text2: 'まだ登録していませんか？',
    login_text3: 'パスワードをお忘れですか？',
    login_text4: '他のSNSアカウントでログイン（ソーシャルログイン）',
    login_text5: 'はい、同意します',
    login_placeholder1: 'ログイン用メールアドレス',
    login_placeholder2: 'パスワード',
    login_placeholder3: 'ID',
    login_message1: 'ログイン用メールアドレスを入力してください',
    login_message2: 'パスワードを入力してください。',
    login_message3: 'ログイン成功',
    login_message4: 'プロフィールIDを入力してください',
    logout_message1: 'ログアウトしますか？',
    login_link1: '登録',
    login_link2: '検索',
    login_link3: '利用規約',
    register_title: '会員登録',
    register_text1: 'メールアドレスで登録',
    register_text2: '会員タイプを選択',
    register_text3: '個人',
    register_text4: '機関会員',
    register_text5: '情報を入力してください。',
    register_text6: 'すでに会員登録済みですか？',
    register_text7: '法人登録番号',
    register_text8: '事業者登録番号',
    register_text9: '機関名',
    register_placeholder1: '電話番号（国コードを含む）',
    register_placeholder2: '（ -（ハイフン）を除く ）',
    register_placeholder_repassword: 'パスワードを再入力してください',
    register_message1: '電話番号を入力してください',
    register_message2: '法人登録番号を入力してください',
    register_message3: '事業者登録番号を入力してください',
    register_message4: '機関名を入力してください',
    register_message5: 'メール形式が無効です',
    register_message6: 'このメールアドレスはすでに登録されています。',
    register_message7: 'メールアドレスを認証してください。',
    register_message8: '国籍を選択してください',
    register_message9: 'IDの形式が正しくありません',
    register_message10: '入力したIDは使用できません。おすすめのIDを使うか、別のIDを入力してください',
    register_message11: 'プロフィールIDを認証してください',
    register_message12: 'このIDはすでに使用されています。提案されたIDを使うか、別のIDを入力してください',
    register_button_verify: '認証する',
    register_button_verify_fail: '認証できませんでした。',
    register_button_verify_success: '認証完了',
    register_welcome_message: '会員登録へようこそ',
    withdraw_text1: 'メンバーシップのキャンセル',
    withdraw_text2: 'YouBookメンバーシップのキャンセル',
    withdraw_text3: '本当にキャンセルしますか？',
    withdraw_text4: 'いいえ',
    withdraw_text5: 'はい',
    withdraw_text6: 'メンバーシップを退会しました',
    home_memo_title: 'メモ',
    home_memo_subtitle: 'メモを取らないと忘れてしまいます',
    home_memo_text1: 'みんなで共有する',
    home_memo_text2: '知識と日常の話',
    home_memo_button: 'メモを残す',
    home_memo_create_text1: 'リンクしたいミニブックがありますか？',
    home_memo_create_button: 'ミニブックを探す',
    home_memo_create_button2: '選択する',
    home_memo_click: 'クリック',
    home_memo_date: 'YYYY. MM. DD',
    home_memo_button_askai: 'コメント / ほんにゃんの考え',
    home_memo_view_detail: '詳細を見る',
    home_memo_view_placeholder: '本文を入力してください',
    home_memo_view_button1: 'コメント',
    home_memo_view_button2: 'ほんにゃんの考え',
    home_memo_view_errormessage: 'コメントを書く',

    memo_create_title: 'メモ',
    memo_create_category1: 'メモ',
    memo_create_category2: 'メモ',
    memo_create_private: '非公開',
    memo_create_public: '公開',
    memo_create_placeholder1: 'いいアイディアが浮かびましたか？',
    memo_create_placeholder2: '今すぐメモしてみましょう',
    memo_create_placeholder3: 'キーワード（間に空白を入れる）',
    memo_create_button: '保存',
    memo_create_error: '内容を入力してください。',
    memo_attach_img: '画像をアップロード',
    memo_alert_rate: '星の評価を選択してください。',
    memo_alert_save: '保存しました。プロフィール - 私の旅行で確認できます。',
    memo_input_placeholder: '新たに何を学びましたか？',
    memo_input_placeholder2: 'あなたの考えは？',
    memo_input_placeholder3: '今すぐ読者と共有しましょう',
    memo_input_placeholder4: '日常の思い出、残してみませんか？',
    memo_alert_keywords: 'キーワードを入力してください。',
    memo_related_text: 'メモ',
    memo_related_date: 'YYYY M. D',
    memo_popup_text1: 'ドイツの社会学者ニコラス・ルーマンに起きた信じがたいことを紹介します。',
    memo_popup_text3: 'ルーマンは当初、学問の世界とはかけ離れた会社で働く平凡な若者でした。',
    memo_popup_text4: '彼は読書が好きで、毎日読んだ内容を簡単によくメモしていました。',
    memo_popup_text5: 'その内容を整理し、ドイツの有名な社会学者に論文として提出し、その縁からビーレフェルト大学の教員として招かれました。',
    memo_popup_text6: 'ルーマンはその後、正教授になり、引退するまで６０巻の書籍と、数百編にわたる論文を出版しました。こうして彼は、社会学の大家になったのです。',
    memo_popup_text7: 'ルーマンは次のように語っています。『ただ根気強くメモをとり、それを繰り返し思い返しながら整理しただけ』であると。',
    memo_popup_text8: 'あなたの記憶はどれだけ信頼に足りますか？',
    memo_popup_text9: 'あなたの記憶には限界があります。',
    memo_popup_text10: 'どんなに素晴らしい知識も、何日か経つと消え去ってしまいます。',
    memo_popup_text11: '継続的なメモの習慣とそれを振り返る作業だけが、知識をあなたのものにします。',
    memo_popup_btn: '共感できる',
    memo_text1: '上記の内容を保存できます。',
    memo_text2: '（キーワードを追加してください）',
    memo_text3: '執筆時に確認する事項',
    memo_text4: 'あなたの投稿は利用条件第2条第1項のコンテンツ規定に違反しています。公開されません。',
    memo_text5: '利用条件を見る',
    memo_text6: '他の言語でメモを残すには、',
    memo_text7: 'その言語で記入してください（自動翻訳されません）',
    book_create_button: 'ミニブックを作成する',
    book_create_title: '表紙を作る',
    book_create_cover: '表紙',
    book_create_text1: 'ミニブックの表紙を作成する手順',
    book_create_text1_pc: 'タイトルと著者名を入る',
    book_create_text2: '表紙画像を作成していない場合',
    book_create_text3: '',
    book_create_text4: '表紙画像を作成した場合',
    book_create_text5: '自分で表紙を作成しましたか？',
    book_create_text6: '以下のボタンからアップロードしてください',
    book_create_text7: '(20M以下のjpg形式)',
    book_create_text8: 'ページ追加権限',
    book_create_text9: '私のみ',
    book_create_text10: '誰でも',
    book_create_text11: '画像にタイトルを表示',
    book_create_text12: '表示する',
    book_create_text13: '表示しない',
    book_create_text14: '翻訳する言語を選択してください',
    book_create_text15: 'すべて選択',
    book_create_text16: '表紙画像をアップロード',
    book_create_text17: '修正できます',
    book_create_text18: '修正後、右上のアイコンをクリックして再翻訳してください',
    book_create_text19: '原文のまま再翻訳したい場合は、右上のアイコンをクリックしてください',
    book_create_text20: '再翻訳',
    book_create_text21: '画像',
    book_create_text22: 'タイトル',
    book_create_text23: 'キーワード',
    book_create_text24: '内容',
    book_create_text25: '画像を削除して再アップロードした場合のみ、再翻訳が行われます',
    book_create_text26: '(ページは削除されません)',
    book_create_text27: '簡単な紹介文を入力してください',
    book_create_text28: '一時保存',
    book_create_text29: '一時保存されました',
    book_create_text30: '確認事項',
    book_create_text31: '文章の内容は最終版であり、これ以上の修正は不要です',
    book_create_text32: '翻訳AIが理解できない単語や記号は使用していません',
    book_create_text33: '画像はコピー＆ペーストせず、別のファイルとして入力しました',
    book_create_text34: '一般募集にしますか？（オープンミニブック）',
    book_create_text35: '共同著者',
    book_create_text36: '手動で追加しますか？',
    book_create_text37: '追加する',
    book_create_text38: '一緒に書けば広がるミニブック',
    book_create_text39: 'あなたが知らない共同著者の力',
    book_create_text40: '一般募集を開始する',
    book_create_text41: 'キャンセルする',
    book_create_text43: 'アイデア？',
    book_create_text44: 'コンテンツをコピー＆ペースト',
    book_create_text45: 'アイデアが必要ですか？',
    book_create_text46: '販売オプション',
    book_create_text47: '無料',
    book_create_text48: 'スポンサー',
    book_create_text49: '購入',
    book_create_text50: '現在の価格',
    book_create_text51: '価格を編集',
    book_create_text52: '0円には設定できません',
    book_create_text53: '購入またはスポンサーされたミニブックは価格や販売オプションを変更できません',
    book_create_text54: 'ミニブックの著者のみがメッセージに返信できます',
    book_create_button_upload: 'アップロード',
    book_create_button_make: '作成',
    book_create_cover_topic_placeholder: 'タイトルはこのように見えます。',
    book_create_topic_placeholder: 'タイトルを入力する',
    book_create_keyword_placeholder: 'キーワード（間に空白を入れる）',
    book_create_category_placeholder: 'カテゴリーを選択してください。',
    book_create_knowledge_placeholder: 'ミニブックの紹介文を書く  ** 注意 - ページを作成する段階で詳細を記入してください。',
    book_create_category_option1: '映画とドラマ',
    book_create_category_option2: '音楽とダンス',
    book_create_category_option3: 'その他の芸術',
    book_create_category_option4: '服装とスタイル',
    book_create_category_option5: '食べ物と料理',
    book_create_category_option6: 'お酒と飲み物',
    book_create_category_option7: 'スナックとデザート',
    book_create_category_option8: '植物と健康',
    book_create_category_option9: 'お金持ちになる',
    book_create_category_option10: '自己開発',
    book_create_category_option11: '人間関係',
    book_create_category_option12: '新しい知識',
    book_create_category_option13: '生活の話',
    book_create_category_option14: '哲学と価値観',
    book_create_category_option15: '宗教と伝統',
    book_create_category_option16: '愛',
    book_create_category_option17: '旅行と観光地',
    book_create_category_option18: '趣味',
    book_create_category_option19: '遊びの文化',
    book_create_category_option20: '神話と英雄',
    book_create_category_option21: '文学の旅',
    book_create_category_option22: '歴史と知恵',
    book_create_category_option23: '社会の話',
    book_create_category_option24: '常識',
    book_create_message1: 'タイトルを入力してください。',
    book_create_message2: '著者名を入力してください。',
    book_create_message3: 'キーワードを入力してください。',
    book_create_message4: 'キーワードを3つ以上入力してください。',
    book_create_message5: 'カテゴリーを選択してください。',
    book_create_message6: '表紙画像を作成してください。',
    book_create_message7: '特殊文字は入力できません。キーワードとキーワードの間に空白が必要です。',
    book_create_message8: 'ミニブックを削除しますか？',
    book_create_message9: 'この言語に関する出版権がありません。',
    book_create_message10: '購入されたミニブックは削除できません',
    book_create_modal_text1: '少々お待ちください..',
    book_create_modal_text2: 'AIが内容を確認し、外国語の翻訳を行い、知識ネットワークを接続しています。',
    book_create_modal_text3: 'ページごとの検索を可能にするためにナレッジベースに接続中です。',
    book_create_modal_text4: '表紙画像にタイトルが表示されません',
    book_create_modal_text5: '(外国語に翻訳された表紙も同様です)',
    book_view_title: 'ミニブックの紹介',
    book_view_share: '友達に共有する',
    book_view_event_topic: 'イベントのテーマ',
    book_view_together_suggest: 'イベントスペースを提案する',
    book_view_together_message: 'お気に入りのTogetherがない場合は、<br />Togetherメニューから選んでください',
    book_view_event_message: '作成したイベントはありません',
    book_view_text1: '保存されたページがありません。',
    book_view_text2: '今すぐページを追加してください。',
    book_view_text3: 'ミニブックが存在しません。もう一度お試しください。',
    book_view_text4: 'ミニブックのページ一覧',
    book_view_text5: 'このミニブックの翻訳を改善したり、宣伝して収益を分け合うのはどうですか？',
    book_view_text6: 'ページ一覧',
    book_view_text7: '価格の修正',
    book_view_text8: '購入者がいるため、編集できません',
    book_view_text9: '読者からのギフト',
    book_view_text10: 'ミニブックの著者のみがメッセージに返信できます',
    book_view_modal_title: '翻訳改善とプロモーション',
    book_view_modal_text1: 'このミニブックの翻訳を自分で改善できますか？または宣伝できますか？',
    book_view_modal_text2: '著者にメッセージを残しましょう',
    book_view_modal_text3: '著者が許可すれば、収益を分け合うことも可能です',

    book_view_write_share_title: 'オープンミニブック',
    book_view_write_share_text1: 'このミニブックの共同著者になりたいですか？',
    book_view_write_share_text2: '著者申請する',
    book_view_write_share_text3: '簡単に申請メッセージを残してください',
    book_view_write_share_text4: '送信',
    book_view_write_share_list_title: '共同著者',
    book_view_write_share_text5: 'ミニブックの共同著者を管理する',
    book_view_write_share_text6: '著者を管理する',
    book_view_write_share_text7: '承認',
    book_view_write_share_text8: '承認されました',
    book_view_write_share_text9: 'ユーザーはすでに著者として登録されています',
    book_view_write_share_text10: '著者を手動で追加する',
    book_view_write_share_text11: 'このユーザーは既に申請済みです',
    book_view_publish_text1: 'このミニブックを出版しませんか？',
    book_view_publish_text2: '出版することで、全ての使用者にオープンになり、収益を得ることができます。',
    book_view_publish_text3: '(販売目的で出版する場合、他の著者のページを含めることはできません）',
    book_view_publish_text4: '価格を設定する',
    book_view_publish_text5: '出版日を設定する',
    book_view_publish_text6: '出版を依頼する',
    book_view_publish_text7: '即時出版',
    book_view_publish_text8: '予約出版',
    book_view_publish_text9: '未出版',
    book_view_publish_text10: '進行中',
    book_view_publish_text11: '出版済み',
    book_view_publish_text12: '出版時の確認事項',
    book_view_publish_text13: 'このミニブックは過去にYouBookで出版されたことはありません。',
    book_view_publish_text14: 'このミニブックおよびそのページは、他者のコンテンツや知的財産を盗用していません',
    book_view_publish_text15: 'このニブックには、暴言、過度な性的内容、他人への誹謗中傷、商業広告は含まれておらず、利用規約第2条第1項に違反していません',
    book_view_publish_text16: 'はい',
    book_view_publish_text17: '出版状況',
    book_view_publish_text18: '出版完了',
    book_view_publish_text19: '出版時刻',
    book_view_publish_text20: '出版価格',
    book_view_publish_text21: 'オープン期間を設定する',
    book_view_publish_text22: 'オープン期間',
    book_view_publish_text23: 'オープン期間とは何ですか',
    book_view_publish_text24: 'オープン期間とは、読者がその内容を閲覧できる期間を指します',
    book_view_publish_text25: 'このニブックは3ページ以上含まれています',
    book_view_publish_text26: 'このニブックは3ページ以上含まれていません',
    book_view_publish_text27: '違反が検出された場合、アルゴリズムによって検索順位が調整されます。問題が深刻な場合、ニブックは自動的に削除されます',
    book_view_publish_text28: '販売オプションを設定',
    book_view_publish_text29: '購入方法',
    book_view_publish_text30: 'サポート方法',
    book_view_publish_message1: '販売目的で出版する場合、1)ミニブックのページがあなたによって作成されたものであること、2)過去に有料で出版したことがないことを確認してください。',
    book_view_publish_message2: '出版可能な状態ではありません。管理者にお問い合わせください。',
    book_view_publish_message3: 'このミニブックはすでに出版されています。',
    book_view_publish_message4: '現在の時刻以降のオープン期間を選択してください',
    book_view_publish_message5: '日時の両方を選択してください。',
    book_view_publish_message6: '出版が承認されました。ありがとうございました。',
    book_view_publish_message7: '確認項目をチェックしてください。',
    book_view_publish_message8: '終了日は開始日より前にすることはできません',
    book_view_publish_message9: '一時保存されたミニブックは出版できません',
    book_view_publish_message10: 'この ミニブック は譲渡されました。元の 出版権 は 著者 にあります。',
    book_view_publish_message11: '最低金額 {minPrice} 以上を入力してください',
    book_view_button_confirm: '確認しました。',
    book_view_button_publish: '出版してください',
    book_view_button_order: 'ページ配置',
    book_view_button_add: 'ページを追加する',
    book_view_button_video: '動画を見る',
    book_view_button_read: '読む',
    book_view_button_lecture: '講義動画を見る',
    book_view_page_add_title: 'ページを追加する',
    book_view_page_add_text1: '第三者のページを検索した後',
    book_view_page_add_text2: 'ページを見る画面で',
    book_view_page_add_text3: '私のミニブックに入れる',
    book_view_page_add_text4: '自分のページを作りたい場合は？',
    book_view_page_add_text5: 'ページの作成は、著者登録された方のみ可能です。 著者登録をご希望の方は、下記よりお問い合わせください。',
    book_view_page_add_text6: '第三者のページを追加しますか？',
    book_view_page_add_text7: '* 第三者が作成したページを追加した場合、\n有料のミニブックとして出版できません',
    book_view_page_add_text8: '以前に作成したページはありますか？',
    book_view_page_add_button1: '今すぐ作る',
    book_view_page_add_button2: '作成したページを見る',
    book_view_reference_text1: '多様性',
    book_view_reference_text2: 'マルチプル',
    book_view_reference_text3: 'ミニブック著者',
    book_view_reference_text4: 'オリジナル創作',
    book_view_support_text1: '応援します',
    book_view_support_modal_title: 'サポーターになってください',
    book_view_support_modal_text1: 'どんなに良い文章でも、一人ではなかなか広まりません。',
    book_view_support_modal_text2: 'サポーターとは、著者のミニブックを世界に届け、互いに応援し合う人です。',
    book_view_support_modal_text3: '一緒に手を取り合って、この物語をもっと遠くへ広めましょう。',
    book_view_support_modal_text4: '著者のサポーターになってください',
    book_view_support_modal_btn1: 'わかりました',
    book_view_support_modal_text5: '"あなたの応援は私にとって大きな力になります。ありがとうございます。私も心を込めてあなたの旅を応援します。"',
    book_view_support_modal_text6: 'ミニブックを世界に届けてください',
    book_view_support_modal_btn2: 'どうすればいいの？',
    book_view_support_modal_title2: 'ここまで来た私、お疲れさまでした',
    book_view_support_modal_text7: '書くのは簡単ではなかったけど、私はやり遂げました。',
    book_view_support_modal_text8: '今こそ自分を信じて、もう一歩踏み出す時です。',
    book_view_support_modal_text9: '少し恥ずかしくて迷っていても、私は自分を信じて、世界に向けて一歩を踏み出します。',
    book_view_support_modal_text10: '誰かにとって、何か意味を持つと信じているからです。',
    book_view_support_modal_text11: '私のサポーターになってください',
    book_view_support_modal_text12: '文章を書くこともイベントを開くことも簡単ではなかったけれど、私は挑戦しました。',
    book_view_support_modal_btn3: 'やってみます！',
    book_view_support_modal_title3: 'こんにちは、サポーターさん',
    book_view_open_minibook_text1: 'オープンミニブックの申請が完了しました',
    book_view_open_minibook_text2: 'オープンミニブックの申請がキャンセルされました',
    page_create_title: 'ページを作成する',
    page_create_text1: 'ページ画像を作成していない場合',
    page_create_text2: '',
    page_create_text3: 'ページ',
    page_create_text4: 'ページ画像を作成した場合',
    page_create_text5: 'ページ画像を作成しましたか？',
    page_create_text6: '内容を入力してください。A4サイズ1枚以内を推奨します。',
    page_create_text7: '現在のバイト数',
    page_create_text8: '推奨サイズ',
    page_create_text9: 'このページで参考にしたものはありますか？',
    page_create_text10: '本人が直接作成',
    page_create_text11: '参考書籍',
    page_create_text12: '参考ブログ',
    page_create_text13: '参考AI',
    page_create_text14: 'ここはミニブックのページを作成するためのステップです',
    page_create_text15: 'ページ画像をアップロード',
    page_create_text16: '再翻訳をご希望ですか？',
    page_create_text17: '再翻訳を希望する場合は、対象と言語を選択してください（選択しない場合は翻訳されずに保存されます）',
    page_create_text18: '翻訳対象',
    page_create_text19: '翻訳言語',
    page_create_message1: '変更はできません',
    page_create_message2: '内容を入力してください',
    page_create_message3: 'ページを削除しますか？',
    page_create_message4: '内容が最大サイズを超えました',
    page_create_reference_book: '書籍',
    page_create_reference_blog: 'ブログ',
    page_create_reference_placeholder1: 'のタイトルを入力してください。',
    page_create_reference_placeholder2: '関連リンク（例：https://www.amazon.com/dp...）',
    page_create_reference_placeholder3: 'の出版年を記入してください',
    page_create_reference_placeholder4: 'の著者名を記入してください',
    page_create_title_placeholder: 'タイトルは次のようになります',
    page_create_message5: '翻訳中',
    page_create_message6: '表紙 を作成した後に ページ を作成できます',
    page_create_modal_text1: 'ページ画像にタイトルが表示されません',
    page_create_modal_text2: '(外国語に翻訳されたページも同様です)',
    page_create_modal_text3: '必ず確認してください！',
    page_create_modal_text4: '内容が変更された場合、一時保存する必要があります。',
    page_create_modal_text5: 'そうしましたか？',
    page_create_modal_text6: '内容が変更された場合、作成する必要があります。',
    page_view_title: 'ページを見る',
    page_view_button_video: '動画再生',
    page_view_button_read: '読む',
    page_view_text1: '私のミニブックに入れる',
    page_view_text2: '自動再生',
    page_view_text3: '読了数',
    page_view_text4: '関連ページ',
    page_view_text5: '関連ミニブック',
    page_view_text6: '参考にした資料が気になりますか？',
    page_view_text7: 'ページ参考資料',
    page_view_text8: '出版年度',
    page_view_text9: '著者名',
    page_view_text10: 'タイトル',
    page_view_text11: 'この参考資料の全ページ',
    page_view_text12: '関連資料検索',
    page_view_text13: 'ページ著者',
    page_view_text14: '著者に会う',
    page_view_text15: '入れる',
    page_view_reference_text1: '書籍',
    page_view_reference_text2: 'ブログ',
    page_view_popup: 'あなたが作成したミニブックはありません。 MYページから作成してください。',
    page_view_pay_popup_text1: '読んで何かを得られましたか？\n小さなギフトで著者に感謝を伝えてください。',
    page_view_pay_popup_title: 'ギフトを贈る',
    page_view_pay_popup_text2: 'ギフトとして贈るお茶を選んでください',
    page_view_pay_popup_text3: '心を込めたメッセージを書いてください',
    page_view_pay_popup_placeholder1: '著者の経験から生まれた知恵と感性にとても助けられました。',
    page_view_pay_popup_text4: '金額',
    page_view_pay_popup_button1: '購入してメッセージ送信',
    page_view_pay_popup_text5: 'この文章のために著者は多くの時間と労力をかけました。\n\n小さなギフトで感謝を伝えてください。',
    page_view_pay_popup_placeholder2: '著者の経験と感性に期待を寄せています。',
    page_view_pay_popup_text6: 'ギフトに興味がないですか？',
    page_view_pay_popup_text7: '広告を見て読みたいですか？',
    page_view_pay_popup_button2: '広告を見て読む',
    page_sort_title: 'ページ配置',
    page_sort_subtitle: 'ページをドラッグして順番を変える',
    page_sort_text: '出典',
    pay_button: '今すぐ購入',
    pay_price: '価格',
    pay_vat_excluded: '（消費税別）',
    pay_message_success: '購入が完了しました。',
    pay_message_fail: '購入に失敗しました。',
    pay_currency: '円',
    pay_button_paid: '購入完了',
    pay_button_view_price: '価格を見る',
    pay_total: '購入金額合計',
    pay_methods: '支払い方法',
    pay_methods_creditcard: 'クレジットカード',
    pay_methods_paypal: 'ペイパル（PayPal）',
    pay_button_continue: '続ける',
    pay_text1: 'お茶を選択してください',
    pay_text2: 'メッセージを入力してください',
    advertisement_button: 'もっと読む',
    advertisement_text1: '広告を見た後にコンテンツを閲覧できます。',
    advertisement_text2: 'これは有料ミニブックのページです。<br />表紙に移動して「読む」をタップすると購入できます。<br />',
    advertisement_text3: '広告を見た後にコンテンツを閲覧できます. 広告はアプリ内でのみ視聴可能です.',
    together_title: 'イベント',
    together_subtitle: '読者と会って話そう',
    together_subtitle_text1: 'オンラインで読者と会おう',
    together_subtitle_text2: 'ルームを作り、人を招待する',
    together_button: 'イベントスペースを作成',
    together_case: '運営事例',
    together_case1: '知識の消費者から生産者へ',
    together_case2: '実例がこんなに参考になるとは思わなかった',
    together_subtitle2: '自分が作成したスペース',
    together_category1: '最新',
    together_category2: 'お気に入り',
    together_button_viewmore: 'もっと見る',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD A hh:mm',
    together_subtitle3: 'こんなスペース',
    together_subtitle3_1: '作ってください',
    together_subtitle_text3: '他の人が始めたら、私も参加してみましょう',
    together_create_title: 'イベントスペースを作成',
    together_create_title2: 'イベントスペースを編集',
    together_create_button1: '選択',
    together_create_subtitle: 'タイトル',
    together_create_placeholder1: 'タイトルを入力してください',
    together_create_subtitle1: '簡単な紹介',
    together_create_placeholder2: '簡単な紹介文を入力する',
    together_create_subtitle2: '使用するツールを選択',
    together_create_text1: 'オンライン会議リンク（例：Zoomリンク）',
    together_create_placeholder3: 'オンライン会議のリンクを入力してください',
    together_create_question1: 'Zoomリンクが分かりませんか？',
    together_create_q1_a_title: 'Zoomミーティングへ参加するためのリンクを探す',
    together_create_text2: 'メタバースを使う',
    together_create_placeholder4: 'Togetherに適しているメタバースを選んでください',
    together_create_question2: 'メタバースが何なのか知っていますか？',
    together_create_text3: 'どこにTogetherを開設しますか',
    together_create_dropmenu1: 'YouBookが招待した知識人コーナーで開設する',
    together_create_dropmenu2: '作家・読者コーナーで開設する',
    together_create_button2: '保存する',
    together_create_button3: '作成する',
    together_create_popup_title: '適切なメタバースをメタバースを選択してください',
    together_create_popup_alert: 'すでに選択済みです',
    together_create_button4: '選択',
    together_create_alert: 'オンライン会議用のリンクを入力してくださいい',
    together_create_alert1: 'タイトルを入力してください',
    together_create_alert2: '使用するメタバースを選択',
    together_create_alert3: '編集できません',
    together_create_alert4: 'イベントスペースが作成されました',
    together_create_alert5: 'エラーが発生しました。再度お試しください。',
    together_create_alert6: 'イベントスペースの作成に失敗しました…',
    together_qa_popup_title1: 'Zoomミーティングに参加するためのリンクを探す。',
    together_qa_popup_btext1: 'コンピューター',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Zoomプログラムを開く-ログイン後- - 上のミーティングメニューをクリック - マイ個人ミーティングID - ミーティングの招待状を表示するをクリック - Zoomミーティングに参加するためのリンクが表示されます。そちらをコピーしてください。',
    together_qa_popup_btext2: 'スマートフォン',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Zoomを開く-ログイン後 - 右上のiボタンを押す - 招待状を送信する - メッセージを押した後 - 電話番号を入力する - リンクが表示されます。それをコピーする。',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'メタバースとは何ですか？',
    together_qa_popup_text3: 'バーチャルな会議スペースです。',
    together_qa_popup_text4: '自分が作成したアバターの姿で現れて',
    together_qa_popup_text5: '友達と顔を合わせて話して、画面を共有することもできます。',
    together_qa_popup_text7: 'ひとつのミーティングスペースに',
    together_qa_popup_text8: '- 同時に10人まで入ることができます。',
    together_qa_popup_text9: '別途プログラムをインストールしたり',
    together_qa_popup_text10: '会員登録したりする必要はありません。',
    together_more_list_title: 'イベントスペース',
    together_more_list_date: 'YYYY. MM. DD',
    together_request_list_title: '作ってください',
    together_request_list_category1: '共感順',
    together_request_list_category2: '最新順',
    together_request_list_button: '新しいスペースを提案する',
    together_request_popup_title: '新スペースの提案',
    together_request_popup_alert1: 'タイトルを入力してください',
    together_request_popup_alert2: '簡単な紹介文を入力してください',
    together_request_popup_placeholder1: 'タイトルを入力してください',
    together_request_popup_placeholder2: '簡単な紹介文を入力してください',
    together_request_popup_button: '保存',
    together_request_detail_button: 'このスペースを作成',
    together_detail_sns: '共有する',
    together_detail_enterbtn: '入る',
    together_detail_btn1: 'イベント一覧',
    together_detail_btn2: 'メッセージ',
    together_detail_subtitle: '話題のミニブック',
    together_detail_alert: '少々お持ちください',
    together_detail_alert1: 'イベントスペースの提案が成功しました！',
    together_detail_alert2: 'イベントスペースの提案に失敗しました…',
    together_detail_alert3: 'お気に入り登録／お気に入り登録解除成功',
    together_detail_alert4: 'お気に入り / お気に入り登録のキャンセルに失敗しました',
    together_detail_alert5: 'サーバーに問題が発生しました。少し経ってから再度行ってください。',
    together_detail_alert6: 'オンライン会議リンクに問題があります',
    together_detail_alert7: '削除に失敗しました',
    together_notice_alert: 'お知らせを削除しますか？',
    together_notice_list_title: 'お知らせ',
    together_button_addtopic: 'このイベントスペースにトピックとして追加',
    together_add_alert: 'イベントスペースに追加されました',
    together_text1: 'あなたと似た好み',
    together_text2: 'このイベントスペースを削除しますか？',
    together_event_btn: '新しいイベントを作成',
    together_event_title: '新しいイベント',
    together_event_placeholder: '紹介文を入力してください',
    together_event_text1: 'スケジュールを設定してください',
    together_event_text2: '入場料を設定してください',
    together_event_text3: '最大人数を設定してください',
    together_event_text4: 'スケジュール',
    together_event_text5: '入場料',
    together_event_text6: '最大人数',
    together_event_text7: 'フォロワーに通知',
    together_event_text8: 'イベントを削除しますか？',
    together_event_text9: '開始時間を現在の時間以降に設定してください',
    together_event_text10: '終了時間を開始時間以降に設定してください',
    together_event_text11: '開始時間と終了時間は同じにできません',
    together_event_text12: 'このイベントのテーマとして追加',
    together_event_text13: 'イベントに追加されました',
    together_event_text14: 'イベントの最大人数を超えました',
    together_event_text15: 'ボタンはイベントの1時間前から有効になります\n（無料の場合は今すぐ購入不要）',
    together_event_text16: 'ボタンはイベントの1時間前から有効になります',
    together_event_text17: 'イベントが存在しません',
    together_event_text18: '購入者がいる場合、削除できません',
    together_event_text19: 'お知らせを送信しますか？',
    together_event_text20: '送信されました',
    together_event_text21: 'イベントリスト',
    together_event_text22: '詳細を見る',
    together_event_text23: '登録後にログインしてください',
    together_event_text24: '参加方法',
    together_event_text25: 'イベント参加完了',
    together_event_text26: 'このイベントのために著者は多くの時間と心を込めました。\n\n小さな贈り物で応えてください。',
    together_event_text27: '著者の経験からにじみ出た知恵と深いコミュニケーションが印象的でした',
    together_event_text28: 'このイベントを世界に広めてください',
    together_event_text29: 'イベントを開くのは簡単ではありませんでしたが、私はやり遂げました。',
    together_event_text30: 'どんなに素晴らしいイベントでも、一人の力だけでは世界に広めるのは難しい。',
    together_event_text31: 'サポーターとは、著者のイベントを世界に広める人であり、互いに応援し合う存在です。',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: '世界中の人々と出会おう',
    youbooker_case: 'ケース',
    youbooker_case_text1: 'いつも始める人であるということ',
    youbooker_case_text2: '知識の複利効果？明日の私がより成長した自分に！',
    youbooker_translation: '今すぐ会ってみませんか？',
    youbooker_translation_text1: 'すべての言語',
    youbooker_category: 'フォロワー／フォロー中',
    youbooker_subcategory1: '私のフォロワー',
    youbooker_subcategory2: '私がフォロー中',
    youbooker_subtitle2: '私をフォロー中の人',
    youbooker_button_follow: 'フォロー',
    youbooker_message_follow: 'フォロー',
    youbooker_button_follow_cancel: 'アンフォロー',
    youbooker_subtitle3: 'あなたが知っているユーザーです',
    youbooker_subtitle4: '私がフォロー中の人',
    youbooker_subtitle5: '知り合いの中でYouBookを知らない人',
    youbooker_button_invite: '招待する',
    youbooker_alert_invite: '招待はアプリからのみ可能です。アプリをダウンロードしてください。',
    youbooker_alert: 'アプリでのみ可能です。アプリをダウンロードしましょう！',
    youbooker_alert2: 'リフレッシュ成功',
    youbooker_alert3: 'YouBookerタブで検索できます',
    home_page_text1: '最新',
    home_page_text2: '影響力',
    home_page_today_title: '今日のイシュー',
    home_page_today_subtitle: 'TOPニュース関連',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: '今日のイシュー',
    home_page_today_detail_sns: '共有する',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: '関連ページ',
    home_page_explor_title: 'ページ探索',
    home_page_explor_subtitle: 'もしダブルクリックしたら何が起こるでしょう？',
    home_page_recommend_title: 'おすすめ',
    home_page_recommend_subtitle: '興味のありそうなページ',
    home_page_theysee_title: '他の人たちは何を見てるのでしょうか',
    home_page_theysee_subtitle: '読者がよく見るページ',
    home_page_common_title: '常識',
    home_page_common_subtitle: 'これだけは知っておきたい',
    home_page_keyw_title: 'キーワード別ページ',
    home_page_keyw_subtitle: '関連ページを探す',
    home_page_random_title: 'ランダムにGO',
    home_page_random_subtitle: 'ボーっとしてるときに押すと、意外なことを学べます',
    home_page_about_title: 'YouBookについて',
    home_page_about_detail: '株式会社 NICK syndicate  日本ビジネスセンター: 東京  海外支店： シアトル 上海 ソウル  Contact： joa@academy-connect.net DUNS 695937905',
    settlement_title: '購入と決済',
    settlement_tab1: '注文記録',
    settlement_tab2: '口座情報',
    settlement_tab3: '決済記録',
    settlement_category1: '私の購入履歴',
    settlement_category2: '著者権の共有',
    settlement_category3: 'ミニブック収益の決済履歴',
    settlement_category4: 'イベント収益の決済履歴',
    settlement_category5: '口座管理',
    settlement_text1: '購入履歴を表示します',
    settlement_text2: 'ミニブックの著者権を共有できます',
    settlement_text3: '支払い済みのミニブックの決済記録を確認できます。',
    settlement_text4: 'その他ご不明な点がございましたら',
    settlement_text5: 'こちら',
    settlement_text6: 'または下記よりお問い合わせください。',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: '一言',
    settlement_text9: '収益がある場合、受け取り用の口座を管理する必要があります',
    settlement_text10: 'イベントで得た収益を決済します',
    settlement_purchase_text1: '購入履歴',
    settlement_purchase_text2: '日付',
    settlement_purchase_text3: '購入金額',
    settlement_purchase_text4: 'タイトル',
    settlement_purchase_text5: 'ミニブック',
    settlement_purchase_text6: 'イベント',
    settlement_accountInfo_text1: 'ミニブックの著者権',
    settlement_accountInfo_text2: 'ミニブック',
    settlement_accountInfo_text3: '言語',
    settlement_accountInfo_text4: '著者の権利',
    settlement_accountInfo_text5: '著者',
    settlement_accountInfo_text6: '第三者',
    settlement_accountInfo_text7: '個人かどうか',
    settlement_accountInfo_text8: '個人',
    settlement_accountInfo_text9: '法人',
    settlement_accountInfo_text10: '銀行名',
    settlement_accountInfo_text10_message: '銀行名を選択してください',
    settlement_accountInfo_text11: '口座名義',
    settlement_accountInfo_text11_message: '口座名義人を入力してください',
    settlement_accountInfo_text12: '口座番号',
    settlement_accountInfo_text12_message: '口座番号を入力してください',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'マイナンバー（個人番号）',
    settlement_accountInfo_text13_message: 'マイナンバー（個人番号）を入力してください。',
    settlement_accountInfo_text13_placeholder: '1234-5678-9012',
    settlement_accountInfo_text14: '住所',
    settlement_accountInfo_text14_message: '住所を入力する',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'メールアドレス',
    settlement_accountInfo_text15_message: 'メールアドレスを入力する',
    settlement_accountInfo_text16: '保存',
    settlement_accountInfo_text17: '登録番号・法人番号',
    settlement_accountInfo_text17_message: '登録番号・法人番号を入力する',
    settlement_accountInfo_text17_placeholder: 'T1234567890123',
    settlement_accountInfo_text18: '法人住所',
    settlement_accountInfo_text18_message: '法人の住所を入力してください',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: '法人名',
    settlement_accountInfo_text19_message: '法人名を入力してください',
    settlement_accountInfo_text20: '法人電話番号',
    settlement_accountInfo_text20_message: '法人の連絡先を入力してください',
    settlement_accountInfo_text21: '第三者ID',
    settlement_accountInfo_text21_placeholder: '第三者のメールアドレス',
    settlement_accountInfo_text22: '支払先口座',
    settlement_accountInfo_text23: '国名',
    settlement_accountInfo_message1: 'メールアドレスが見つかりません',
    settlement_accountInfo_message2: '自分自身に著者の権利を共有することはできません',
    settlement_accountInfo_message3: '作成されたミニブックはありません',
    settlement_accountInfo_text24: '著者権の共有',
    settlement_accountInfo_text25: '著者権を第三者に共有すると、再び回収することはできません',
    settlement_accountInfo_text26: '著者権を共有しますか？',
    settlement_accountInfo_text27: 'はい、共有します',
    settlement_accountInfo_text28: '著者権を共有するには、<br />1) ミニブック内のページがあなたが作成したものであり、<br />2) 過去に第三者に共有されていない必要があります',
    settlement_accountInfo_text29: 'わかりました。',
    settlement_accountInfo_text30: 'あなたはこのミニブックの著者権を第三者に共有しました',
    settlement_accountInfo_text31: '著者',
    settlement_accountInfo_text32: '第三者',
    settlement_accountInfo_text33: 'あなたはこのミニブックの著者権を著者から共有されました',
    settlement_accountInfo_text34: 'このミニブックは無料です。決済口座は必要ありません.',
    settlement_accountInfo_text35: '収入共有する',
    settlement_accountInfo_text36: '(私)',
    settlement_accountInfo_text37: '(出版社など)',
    settlement_accountInfo_text38: '個人口座',
    settlement_accountInfo_text39: '法人口座',
    settlement_accountInfo_text40: '口座管理',
    settlement_accountInfo_text41: '保存',
    settlement_accountInfo_text42: '銀行',
    settlement_accountInfo_text43: '口座選択',
    settlement_accountInfo_text44: '収益の分配方法を決める',
    settlement_accountInfo_text45: '収益率 (%)',
    settlement_accountInfo_text46: '自分のID (email)',
    settlement_accountInfo_text47: '第三者のID (email)',
    settlement_accountInfo_text48: '合計を合わせる',
    settlement_accountInfo_text49: '譲受人の情報を入力してください',
    settlement_accountInfo_text50: '収益率は100を超えることはできません',
    settlement_accountInfo_text51: '譲渡人 ID(email)',
    settlement_accountInfo_text52: '譲受人 ID(email)',
    settlement_earnings_text1: '決済記録',
    settlement_earnings_text2: '決済期間',
    settlement_earnings_text3: 'ミニブックの価格',
    settlement_earnings_text4: '販売数量',
    settlement_earnings_text5: '販売額',
    settlement_earnings_text6: '税込み控除額',
    settlement_earnings_text7: '入金額',
    settlement_earnings_text8: '入金日',
    settlement_earnings_text9: '広告の視聴数',
    settlement_earnings_text10: '合計金額',
    settlement_earnings_text11: 'さらに詳しく',
    settlement_earnings_text12: '広告価格',
    settlement_earnings_text13: '収益',
    settlement_earnings_text14: 'すべてのミニブック',
    settlement_earnings_text15: 'イベントを選択',
    settlement_earnings_text16: 'すべてのイベント',
    settlement_statistics_text1: '販売量',
    settlement_statistics_text2: '読者数',
    settlement_statistics_text3: '(先月)',
    settlement_statistics_text4: '1ヶ月',
    settlement_statistics_text5: '6ヶ月',
    settlement_statistics_text6: '1年',
    settlement_statistics_text7: 'データが見つかりませんでした',
    settlement_statistics_text8: '売上分析',
    settlement_statistics_text9: '広告の視聴',
    settlement_statistics_text10: 'すべての言語',
    terms_title: 'ご利用条件',
    terms_text: '',
    privacy_title: '個人情報保護方針',
    privacy_text: '',
    // common text
    message_save: '保存',
    message_fail: '保存に失敗しました',
    message_delete: '削除',
    message_report: '報告済み',
    message_search_no_result: '検索結果が見つかりません',
    message_search_enter: '検索語を入力してください。',
    message_error1: 'エラーが発生しました。管理者に連絡してください。',
    message_save2: '保存',
    message_fail2: '保存に失敗しました',
    message_login: 'ログインが必要です。',
    name: 'お名前',
    email: 'メールアドレス',
    mobile: '携帯電話番号',
    list: 'リスト',
    edit: '編集',
    delete: '削除',
    search: '検索',
    report: '報告内容',
    user: 'ユーザー',
    report_type: '報告の種類',
    report_type1: '誹謗/中傷',
    report_type2: '広告',
    report_type3: 'わいせつ/ 性的表現',
    report_type4: '同じ内容の繰り返し',
    report_type5: 'その他',
    search_book: 'ミニブック検索',
    serch_placeholder: '名前またはメールアドレスで検索',
    search_keyword: 'キーワード',
    search_reference: '参考文献',
    search_author: '著者名',
    search_result: '見つけました',
    button_report: 'YouBookに報告する',
    button_write: '保存',
    button_login: 'ログイン',
    button_more: 'もっと見る',
    button_confirm: '確認済み',
    button_save: '保存',
    button_crop: '選択',
    button_delete: '削除',
    button_complete: '完了',
    colorbox_background_text1: '背景色を選択してください。',
    colorbox_font_text1: '文字色を選択してください。',
    menu_home: 'ホーム',
    menu_page: 'ページ',
    menu_book: 'ミニブック',
    menu_memo: 'メモ',
    menu_together: 'イベント',
    login_button: 'ログイン',
    message_text1: '返信',
    message_text2: '私のコメントに返信がつきました',
  },
  ru: {
    home_banner_title1: 'Новая мини-книга',
    home_banner_title2: 'Новое событие',
    home_slide_title1: 'Актуально сейчас',
    home_slide_title2: 'Мой вкус',
    home_slide_title3: 'Сейчас в тренде',
    home_slide_title4: 'Очень популярно',
    home_detail_title1: 'Повседневные воспоминания',
    home_detail_title2: 'Рекомендуемые видео',
    home_detail_title3: 'Если вы хотите узнать больше',
    home_detail_text1: 'Мини-книга записка',
    home_detail_text2: 'Ежедневная записка',
    home_setting_title: 'Настройки',
    home_setting_text1: 'Страницы, просмотренные за последние 30 дней',
    home_setting_text2: 'Выйти',
    home_setting_text3: 'Удалить аккаунт',
    home_book_banner_question: 'Я ищу...',
    home_book_banner_write_placeholder1: 'Введите заголовок',
    home_book_banner_write_placeholder2: 'Опубликовать',
    home_book_banner_write_button: 'Сохранить',
    home_book_banner_detail_text1: 'Ответ от YouBook',
    home_book_banner_detail_text2: 'С этой книгой читают',

    home_book_create_button: 'Мини-книга, создайте свою',
    home_book_create_text1: 'Мини-книга — это короткая книга примерно на 10 страниц. Она соответствует современному тренду — читать краткие, но содержательные тексты быстро и удобно.',
    home_book_create_text2: 'Как редактировать после публикации',
    home_book_create_text3: 'Мини-книга, простой способ создать',
    home_book_create_text4: 'Сколько может заработать автор?',
    home_book_create_text5: 'Как найти своих читателей?',
    home_book_create_text6: '5 причин использовать YouBook',
    home_book_create_text7: 'Остались вопросы?',
    home_book_create_text8: 'Можно ли отслеживать продажи в реальном времени?',
    home_book_create_text9: 'Давайте писать регулярно каждый день!',
    home_book_create_text10: 'Начните прямо сейчас!',

    home_book_category_title1: 'Темы дня и мини-книга',
    home_book_category_title2: 'Популярные мини-книги',
    home_book_category_title3: 'Мини-книги профессора S-класса',
    home_book_category_title4: 'Персональные рекомендации',
    home_book_category_title5: 'Мини-книги с сутью бестселлеров',
    home_book_category_title6: 'С Книгокотом',
    home_book_category_title6_text1: 'Развернуть',
    home_book_category_title6_text2: 'Свернуть',
    home_book_category_title7: 'Исследование страниц нейросети',
    home_book_category_title8: 'Фестиваль искусства и эмоций',
    home_book_category_title8_text1: 'Мир в кино и сериалах',
    home_book_category_title8_text2: 'Трогательные мелодии и движения',
    home_book_category_title8_text3: 'Искусство без границ',
    home_book_category_title8_text4: 'Выражение индивидуальности: мода и стиль',
    home_book_category_title9: 'Культура вкуса и отдыха',
    home_book_category_title9_text1: 'Кулинарные исследования, местная кухня',
    home_book_category_title9_text2: 'Истории о спиртном и жизни',
    home_book_category_title9_text3: 'Очарование закусок и десертов',
    home_book_category_title9_text4: 'Сила природы, секреты растений',
    home_book_category_title10: 'Мудрость жизни и самопознание',
    home_book_category_title10_text1: 'Уникальные способы управления деньгами',
    home_book_category_title10_text2: 'Рецепты личного роста',
    home_book_category_title10_text3: 'Проблемы и решения в отношениях',
    home_book_category_title10_text4: 'Новые открытия и знания',
    home_book_category_title11: 'Разнообразие ценностей и любви',
    home_book_category_title11_text1: 'Истории их жизни',
    home_book_category_title11_text2: 'Разные философии и ценности',
    home_book_category_title11_text3: 'Религиозные верования и традиции',
    home_book_category_title11_text4: 'Тайны любви',
    home_book_category_title12: 'День, наполненный путешествиями и хобби',
    home_book_category_title12_text1: 'Скрытые места, которые стоит посетить',
    home_book_category_title12_text2: 'Радость жизни через хобби',
    home_book_category_title12_text3: 'Уникальная культура через игры',
    home_book_category_title13: 'Богатство традиций и историй',
    home_book_category_title13_text1: 'Местные мифы и истории о героях',
    home_book_category_title13_text2: 'Литературные путешествия мира',
    home_book_category_title13_text3: 'История и мудрость мест',
    home_book_category_title13_text4: 'Разнообразные социальные истории',

    home_book_category_title1_text2: 'Мысли Книгокота — хочешь заглянуть?',
    home_book_category_title1_text3: 'Есть сомнения или вопросы?',
    home_book_category_title1_text4: 'Рекомендовать мини-книгу?',
    home_book_search_placeholder1: 'Говорите здесь',
    home_book_search_placeholder2: 'Ключевое слово?',

    home_book_search_message1: 'Ввести вопрос',
    home_book_search_message2: 'Введите вопрос еще раз',
    home_book_search_text1: 'Хотите обсудить эту страницу?',
    home_book_search_text2: 'Хотите обсудить эту Мини-книгу?',
    home_book_search_text3: 'Спросить',
    home_book_search_text4: 'Сохранить все',
    home_book_search_text5: '(Добавить ключевые слова)',
    home_book_search_text6: 'Найти',

    home_book_theme_title: 'Книги по темам',
    home_instant_text1: 'Я ищу',
    home_instant_text2: 'Случайная книга',
    home_book_company_info: 'Остались вопросы? Свяжитесь с нами. Мы всегда готовы помочь.',
    home_page_search_text1: 'Поиск по странице',
    home_page_search_text2: 'Воспроизвести видео',
    home_page_search_text3: 'Расширенный поиск',
    home_page_search_text4: 'Содержание',
    home_page_search_text5: 'Просмотреть онлайн',
    home_page_explor_alert: 'Страница не выбрана',
    home_page_explor_alert2: 'Вы превысили максимальное количество страниц, которые можно просматривать на одном экране (150). Пожалуйста, поместите ненужные страницы в корзину',
    home_page_explor_alert3: 'Больше нет информации для загрузки',
    my_login_title: 'МОЙ',
    my_login_text1: 'Оформление профиля',
    my_login_text2: 'Войдите в Youbook',
    my_login_text3: 'чтобы стать лучше уже сегодня',
    my_login_find_password: 'Забыли пароль?',
    my_guide_minibook: 'Как создать Мини-книгу',
    my_password_reset: 'Сбросить пароль',
    my_password_reset_text1: 'Введите адрес электронной почты',
    my_password_reset_button1: 'Отправить ссылку для сброса',
    my_password_reset_button2: 'Сбросить',
    my_password_reset_message1: 'Указанный адрес не найден',
    my_password_reset_message2: 'Мы отправили ссылку для сброса пароля на указанный вами адрес электронной почты.',
    my_password_reset_message3: 'Пожалуйста, перейдите по ссылке, отправленную на ваш адрес электронной почты.',
    my_password_reset_placeholder1: 'Ваш e-mail',
    my_password_reset_placeholder2: 'Введите новый пароль',
    my_password_reset_placeholder3: 'Повторите пароль',
    my_password_reset_message4: 'Пароли не совпадают',
    my_password_reset_message5: 'Пароль должен состоять не менее чем из 8 символов и включать как минимум одну заглавную букву, одну строчную букву, одну цифру и один специальный символ',
    my_password_reset_message6: 'Пароль был сброшен',
    my_memo_list_placeholder: 'Пришла хорошая идея? Запишите ее прямо сейчас!',
    my_profile_placehoder1: 'Мои интересы',
    my_profile_placehoder2: 'Меня зовут',
    my_profile_placehoder3: 'Обо мне',
    my_profile_placehoder4: 'Пожалуйста, добавьте еще немного о себе',
    my_profile_text1: 'Национальность',
    my_profile_text2: 'Язык',
    my_profile_text3: 'Изменить ID',
    my_profile_text4: 'Текущий ID',
    my_profile_text5: 'Новый ID для изменения',
    my_profile_text6: 'Изменение ID возможно только один раз',
    my_menu_text1: 'Моё путешествие',
    my_menu_text2: 'Сообщения',
    my_menu_text3: 'Покупка и оплата',
    my_menu_text4: 'Новое уведомление',
    my_menu_text5: 'Создать \nмини-книгу',
    my_menu_text6: 'Мои \nмини-книги',
    my_menu_text7: 'Хотите импортировать записи из других приложений?',
    my_menu_text8: 'Вы можете автоматически импортировать и преобразовать их в страницы',
    my_menu_text9: 'Импорт',
    my_import_book_text1: 'Преобразовать в страницу',
    my_import_book_text2: 'ZIP-файл преобразуется в страницы. Преобразование одного текста занимает до 5 секунд. 10 записей — примерно 1 минута, 100 — около 8 минут. После завершения появится всплывающее окно.',
    my_import_book_text3: 'Понял',
    my_import_book_text4: 'Преобразование завершено',
    my_import_book_text5: 'Все записи из ZIP-файла были преобразованы в страницы. Каждая запись стала отдельной страницей. Их можно просмотреть в Моё путешествие — Мои заметки. Страницы временно сохранены и доступны для редактирования.',
    my_import_book_text6: 'Вы можете импортировать записи из других приложений и автоматически преобразовать их в страницы. Затем можно объединить страницы в мини-книгу.',
    my_import_book_text7: 'Как импортировать записи из других приложений в формате ZIP',
    my_import_book_text8: 'Загрузите ZIP-файл',
    my_import_book_text9: 'Загрузить файл из Substack',
    my_import_book_text10: 'Загрузить файл из Medium',
    my_import_book_text11: 'Поиск',
    my_import_book_text12: '* Каждая запись преобразуется в отдельную страницу',
    my_import_book_text13: '* Вы можете проверить это в Моя страница - Настройки - Мои заметки',
    my_import_book_text14: '* Страницы временно сохранены и доступны для редактирования',
    my_import_book_text15: '* Можно импортировать только свои записи',
    my_import_book_text16: 'Опубликуйте мини-книгу из преобразованных страниц',
    my_import_book_text17: 'Создайте обложку мини-книги',
    my_import_book_text18: 'Выберите страницы для добавления в мини-книгу',
    my_import_book_text19: 'Опубликуйте мини-книгу',
    my_import_book_text20: 'Обязательно прочитайте инструкцию',
    my_import_book_text21: 'Файл не в формате ZIP',
    my_import_book_text22: 'Пожалуйста, загрузите файл',
    my_journey_title: 'Моё путешествие',
    my_journey_button_message: 'Сообщения',
    my_journey_button_memo: 'Заметки',
    my_journey_button_record: 'Запись',
    my_journey_button_follow: 'Подписаться',
    my_journey_button_follow_cancel: 'Отписаться',
    my_journey_message_text1: 'Оставить сообщение',
    my_journey_message_placeholder: 'Введите сообщение',
    my_journey_message_message1: 'Невозможно отправить',
    my_journey_message_message2: 'Отправка',
    my_journey_message_message3: 'Введите сообщение',
    my_journey_memo_total: 'Всего',
    my_journey_record_overall: 'Рейтинг влияния',
    my_journey_record_text1: 'Просмотренная страница',
    my_journey_record_text2: 'Избранные Мини-книги',
    my_journey_record_text3: 'Любимое пространство для события',
    my_journey_record_text4: 'Мои cтраница',
    my_journey_record_text5: 'Мои Mини-книги',
    my_journey_record_text6: 'Созданное мной пространство для события',
    my_journey_record_text7: 'В этом месяце',
    my_journey_record_text8: 'Купленная мини-книга',
    my_journey_record_text9: 'Открытый',
    my_journey_record_text10: 'Закрытый',
    my_journey_record_text11: 'Купленные события',
    my_journey_record_text12: 'Событие, которое я создал(а)',
    my_journey_record_text13: 'Топ #{userRank} в категории {userLanguage}',
    my_journey_record_text14: 'Мини-книга с совместным авторским правом',
    my_journey_record_text15: 'Вы хотите, чтобы читатели читали в определённом порядке? Тогда перетащите Обложка, чтобы изменить порядок.',
    my_journey_record_text16: 'Поддержите новую мини-книгу',
    my_journey_record_text17: 'Сообщения поддержки от читателей',
    my_journey_record_text18: 'Оставьте сообщение поддержки автору',
    my_journey_record_text19: 'Уровень поддерживающего',
    my_journey_record_text20: '{cheeringLevel} уровень из 10',
    my_journey_record_text21: 'Те, кого я поддерживаю',
    my_journey_record_text22: 'Мои поддерживающие',
    my_journey_record_text23: 'Вы хотите удалить?',
    my_journey_record_text24: 'поддерживающий {userName}',
    my_journey_record_text25: 'при поддержке {userName}',
    my_notice_title: 'Уведомления',
    my_notice_message1: 'Нет новых уведомлений',
    my_notice_text1: 'Горячие новинки',
    my_notice_text2: 'Новые главы',
    my_notice_text3: 'Новое сообщение',
    my_notice_text4: 'Новый комментарий ваших заметок',
    my_notice_text5: 'Новый комментарий к моему пространству события',
    my_notice_text6: 'Новый комментарий вашей страницы',
    my_notice_text7: 'Новый комментарий вашей Мини-книги',
    my_notice_text8: 'опубликовал новую заметку',
    my_notice_text9: '{userName} создал новое пространство для события',
    my_notice_text10: 'опубликована новая Мини-книга',
    my_notice_text11: 'купил мою миникнигу',
    my_notice_text12: '{userName} создал <b>новое событие</b>',
    my_notice_text13: '{userName} специально пригласил вас на <b>новое событие</b>. Обязательно заходите! ',
    my_notice_text14: '{userName} <b>купил мое событие</b>',
    my_notice_text15: '{userName} подал заявку на соавторство',
    my_notice_text16: 'Заявка на соавторство в открытой мини-книге была одобрена',
    my_notice_text17: 'Новый комментарий был оставлен соавтором',
    my_notice_text18: 'Поступило сообщение в поддержку новой мини-книги',
    my_notice_text19: '{userName} стал спонсором <b>моей мини-книги</b>',
    my_marketing_banner_title: 'Поддержи себя',
    my_marketing_banner_text1: 'Ты преодолел трудности — теперь поддержи себя',
    my_marketing_banner_btn: 'Поддержать сейчас',
    my_marketing_title: 'Поддержать сейчас',
    my_marketing_text1: 'Прикрепите два крыла мини-книги и события – используйте пошаговое продвижение как топливо – и станьте инфлюенсером',
    my_marketing_text2: 'Отправить email обычным читателям',
    my_marketing_text3: 'Отправить сообщение обычным читателям',
    my_marketing_text4: 'Отправить email друзьям',
    my_marketing_text5: 'Отправить сообщение друзьям',
    my_marketing_text6: 'Ссылка в соцсети',
    my_marketing_btn: 'Начать сейчас',
    my_marketing_minibook_step1_title: 'Поддержка мини-книги',
    my_marketing_step1_subtitle: 'Ссылка в соцсети',
    my_marketing_minibook_step1_text1: 'Разместите мини-книгу в своих соцсетях и добавьте привлекательное описание',
    my_marketing_minibook_text1: 'Найдите мини-книгу',
    my_marketing_step1_text1: 'Скопируйте ссылку',
    my_marketing_step1_btn: 'Копировать',
    my_marketing_step1_text2: 'Вставьте в соцсети и добавьте описание',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'Выберите мини-книгу для обмена',
    my_marketing_step1_text4: 'Ссылка скопирована',
    my_marketing_step1_text5: 'Выберите событие для обмена',
    my_marketing_step1_text6: 'Найти социальные сети',
    my_marketing_event_step1_title: 'Поддержка события',
    my_marketing_event_step1_text1: 'Разместите событие в своих соцсетях и добавьте привлекательное описание',
    my_marketing_event_text1: 'Найдите событие',
    my_marketing_event_search_title: 'Поиск события',
    my_marketing_minibook_step2_title: 'Маркетинг Мини-книги: Этап 2',
    my_marketing_step2_subtitle: 'Отправить сообщение друзьям',
    my_marketing_minibook_step2_text1: 'Отправьте друзьям ссылку на мини-книгу и тёплое приветственное сообщение',
    my_marketing_step2_text2: 'Отправьте сообщение и ссылку другу',
    my_marketing_step2_placeholder: 'Введите приветственное сообщение',
    my_marketing_tab_text1: 'Мои друзья',
    my_marketing_event_step2_title: 'Маркетинг События: Этап 2',
    my_marketing_event_step2_text1: 'Отправьте друзьям ссылку на событие и тёплое приветственное сообщение',
    my_marketing_minibook_step3_title: 'Маркетинг Мини-книги: Этап 3',
    my_marketing_step3_subtitle: 'Отправить email друзьям',
    my_marketing_minibook_step3_text1: 'Поделитесь с друзьями ссылкой на мини-книгу и её историей',
    my_marketing_step3_text1: 'Импортируйте список контактов',
    my_marketing_step3_placeholder: 'Загрузить файл csv или vcf',
    my_marketing_step3_text2: 'Отправьте другу историю и ссылку',
    my_marketing_step3_text3: 'Импортируйте список своих телефонных номеров',
    my_marketing_step3_placeholder2: 'Поделитесь историей',
    my_marketing_event_step3_title: 'Маркетинг События: Этап 3',
    my_marketing_event_step3_text1: 'Поделитесь с друзьями ссылкой на событие и его историей',
    my_marketing_text7: 'Импорт номеров телефонов',
    my_marketing_title2: 'Управление номерами телефонов',
    my_marketing_text8: 'Телефон',
    my_marketing_text9: 'Количество',
    my_marketing_text10: 'Импорт контактов',
    my_marketing_text11: 'Пожалуйста, загрузите файл csv или vcf',
    my_marketing_text12: 'Как импортировать',
    my_marketing_text13: 'Импорт',
    my_marketing_title3: 'Управление контактами',
    contact_manage: 'Управление контактами',
    my_marketing_text14: 'Удалить выбранное',
    my_marketing_text15: 'Пожалуйста, выберите друга',
    my_marketing_text16: 'Вы можете выбрать до 100 друзей',
    my_marketing_text17: 'Загрузка завершена',
    my_marketing_text18: 'Превышено допустимое количество символов',
    contact_phone: 'Телефон',
    contact_organization: 'Организация',
    contact_title: 'Должность',
    contact_memo: 'Заметка',
    my_marketing_text19: 'Редактировать выбор',
    my_marketing_text20: 'Выбрать метку',
    my_marketing_text21: 'Добавить новую метку',
    my_marketing_text22: 'Удалить выбранную метку',
    my_marketing_text23: 'Добавить',
    my_marketing_btn2: 'Редактирование завершено',
    my_marketing_text24: 'Выберите контакт для редактирования',
    my_marketing_text25: 'Выберите метку для удаления',
    my_marketing_text26: 'Введите название метки',
    my_marketing_text27: 'Эта метка уже существует',
    my_marketing_text28: 'Добавить метку',
    my_marketing_text29: 'Отмена',
    my_marketing_text30: 'Добавлено',
    my_benefit_text1: 'На текущий момент вы заработали',
    my_benefit_text2: 'Через год ваша прибыль составит',
    my_benefit_text3: '',
    my_benefit_text4: 'Полученная прибыль',
    my_benefit_text5: 'Полученная прибыль',
    my_benefit_text6: 'Проверить',
    my_benefit_modal_text1: 'Суммарный доход',
    my_benefit_modal_text2: '₽',
    my_benefit_modal_text3: 'Всего',
    my_benefit_modal_text4: 'Давайте сделаем очень простой расчет',
    my_benefit_modal_text5: 'Количество прочитанных страниц на данный момент',
    my_benefit_modal_text6: 'Стоимость за одну страницу',
    my_benefit_modal_text7: '₽',
    my_benefit_modal_text8: 'Итак, ваша выгода составляет',
    my_benefit_modal_text9: 'Теперь добавьте преимущества обсуждений с',
    my_benefit_modal_text10: 'AI, и ваша выгода возрастет.',
    my_benefit_modal_text11: 'Используйте каждый день и наслаждайтесь результатами',
    my_benefit_modal_text12: 'Ясно.',
    my_story_text1: 'Комментарии читателей',
    my_story_text2: 'Книги нужно не читать, а проживать',
    my_story_text3: 'Когда начинаешь читать на регулярной основе, в твоей жизни начинают происходить невероятные изменения',
    my_story_text4: 'Ловушки, в которые попадают умные люди. Вы один из них?',
    my_story_text5: 'Ознакомьтесь с историями других пользователей',
    my_go_blog_text1: 'YouBook, Новости и Истории Клиентов',
    my_go_blog_text2: 'Узнайте последние новости и истории клиентов YouBook',
    my_go_blog_text3: 'Узнать больше',
    my_channel_text1: 'Что вы думаете о YouBook?',
    my_channel_text2: 'Поделитесь, что вам больше всего понравилось и что мы можем улучшить',
    my_channel_text3: 'А также задавайте интересующие вас вопросы.',
    my_channel_text4: 'Написать отзыв',
    my_about_youbook_text1: 'Почему стоит использовать YouBook',
    my_about_youbook_text2: 'Ответы на часто задаваемые вопросы',
    my_about_youbook_text3: 'Условия предоставления услуг',
    my_app_text1: 'YouBook - это приложение полезно на все 100%.',
    my_app_text2: 'Скачайте приложение и откройте целый мир прямо сейчас!',
    my_app_text3: 'Скачать',
    login_title: 'Войти',
    login_text1: 'Вход с помощью электронной почты',
    login_text2: 'Еще не зарегистрированы?',
    login_text3: 'Забыли пароль?',
    login_text4: 'или Войти с помощью',
    login_text5: 'Я согласен',
    login_placeholder1: 'Электронная почта для входа',
    login_placeholder2: 'Пароль',
    login_placeholder3: 'ID',
    login_message1: 'Пожалуйста, введите электронную почту для входа',
    login_message2: 'Пароль',
    login_message3: 'Вход выполнен',
    login_message4: 'Пожалуйста, введите ваш ID',
    logout_message1: 'Хотите выйти из системы?',
    login_link1: 'Войти',
    login_link2: 'Поиск',
    login_link3: 'Пользовательское соглашение',
    register_title: 'Создать аккаунт',
    register_text1: 'Зарегистрироваться с помощью электронной почты',
    register_text2: 'Выберите тип подписки',
    register_text3: 'Личный аккаунт',
    register_text4: 'Корпоративный аккаунт',
    register_text5: 'Войдите в систему',
    register_text6: 'Уже зарегистрированы?',
    register_text7: 'Регистрационный номер корпорации',
    register_text8: 'Регистрационный номер бизнеса',
    register_text9: 'Название организации',
    register_placeholder1: 'Ваш номер телефона, включая код города',
    register_placeholder2: '( Введите без - )',
    register_placeholder_repassword: 'Повторите пароль',
    register_message1: 'Введите свой номер телефона',
    register_message2: 'Введите регистрационный номер корпорации',
    register_message3: 'Введите номер регистрации бизнеса',
    register_message4: 'Введите название организации',
    register_message5: 'Неверный формат электронной почты',
    register_message6: 'Этот e-mail уже зарегистрирован',
    register_message7: 'Пожалуйста, подтвердите вашу электронную почту',
    register_message8: 'Выберите свою национальность',
    register_message9: 'Неверный формат ID',
    register_message10: 'Введенный вами ID недоступен. Пожалуйста, используйте предложенный ID или введите другой',
    register_message11: 'Пожалуйста, подтвердите ваш ID',
    register_message12: 'Этот ID уже используется. Пожалуйста, используйте предложенный или введите другой',
    register_button_verify: 'Подтвердить',
    register_button_verify_fail: 'Не подтверждено',
    register_button_verify_success: 'Подтверждено',
    register_welcome_message: 'Добро пожаловать в ряды наших участников',
    withdraw_text1: 'Отмена членства',
    withdraw_text2: 'Отменить членство YouBook',
    withdraw_text3: 'Вы действительно хотите отменить?',
    withdraw_text4: 'Нет',
    withdraw_text5: 'Да',
    withdraw_text6: 'Ваше членство успешно отменено',
    home_memo_title: 'Заметки',
    home_memo_subtitle: 'Зачем делать заметки?',
    home_memo_text1: 'Общее для всех',
    home_memo_text2: 'Знания и повседневные истории',
    home_memo_button: 'Оставить записку',
    home_memo_create_text1: 'Есть мини-книга для ссылки?',
    home_memo_create_button: 'Найти мини-книгу',
    home_memo_create_button2: 'Выбрать',
    home_memo_click: 'Перейди и узнай',
    home_memo_date: 'DD.MM.YYYY',
    home_memo_button_askai: 'Комментарий / Мысли Книгокота',
    home_memo_view_detail: 'Подробнее',
    home_memo_view_placeholder: 'Опубликовать',
    home_memo_view_button1: 'Комментарии',
    home_memo_view_button2: 'Мысли Книгокота',
    home_memo_view_errormessage: 'Опубликовать',

    memo_create_title: 'Заметки',
    memo_create_category1: 'Записка',
    memo_create_category2: 'Записка',
    memo_create_private: 'Личные',
    memo_create_public: 'Публичные',
    memo_create_placeholder1: 'Появилась идея?',
    memo_create_placeholder2: 'Запишите ее прямо сейчас',
    memo_create_placeholder3: 'Ключевые слова (разделяйте пробелом)',
    memo_create_button: 'Сохранить',
    memo_create_error: 'Открыть заметки',
    memo_attach_img: 'Загрузить изображение',
    memo_alert_rate: 'Оцените',
    memo_alert_save: 'Изменения сохранены. Проверьте в разделе Мой профиль - Моё путешествие',
    memo_input_placeholder: 'Что вы узнали?',
    memo_input_placeholder2: 'Какие у вас мысли на этот счет?',
    memo_input_placeholder3: 'Поделитесь с вашими читателями прямо сейчас~',
    memo_input_placeholder4: 'Воспоминание из повседневной жизни – сохранить?',
    memo_alert_keywords: 'Введите ключевые слова',
    memo_related_text: 'Записка',
    memo_related_date: 'DD.MM.YYYY',
    memo_popup_text1: 'История Николаса Лумана напоминает нам современную басню, иллюстрирующую, как обычные привычки могут изменить нашу жизнь.',
    memo_popup_text3: 'Изначально Луман был обычным сотрудником в крупной компании, далеким от мира науки.',
    memo_popup_text4: 'Однако, его страсть к чтению привела к необычной привычке: ежедневному ведению заметок по прочитанным материалам.',
    memo_popup_text5: 'Результатом этой привычки стала статья, которая привлекла внимание известного немецкого социолога и, в результате, полностью изменила его жизнь.',
    memo_popup_text6: 'Луманна пригласили на работу в Билефельдский университет, где со временем он получил звание профессора.',
    memo_popup_text7: 'За свою карьеру он стал автором 60 книг и многочисленных статей, закрепивших за ним статус выдающегося социолога.',
    memo_popup_text8: 'Свои невероятные достижения Луман объяснял тем, что методично вел заметки, отмечая',
    memo_popup_text9: 'такой подход.',
    memo_popup_text10: 'помогал систематизировать полученные знания и глубже понимать суть.',
    memo_popup_text11: 'Подобные истории показывают, насколько важно осознавать ограничения нашей памяти и ценить систематический подход и повторение материала для полноценного усвоения новых знаний.',
    memo_popup_btn: 'Мне это знакомо',
    memo_text1: 'Добавить в избранное',
    memo_text2: '(Добавить ключевые слова)',
    memo_text3: 'Что проверить при написании',
    memo_text4: 'Ваш пост нарушает правила контента, указанные в статье 2, пункте 1 Условий предоставления услуг. Он не будет опубликован.',
    memo_text5: 'Просмотреть Условия предоставления услуг',
    memo_text6: 'Чтобы оставить записку на другом языке, ',
    memo_text7: 'напишите на этом языке (автоматический перевод не поддерживается)',
    book_create_button: 'Создать Мини-книгу',
    book_create_title: 'Создать обложка',
    book_create_cover: 'Обложка книги',
    book_create_text1: 'Шаги по созданию обложки для мини-книги',
    book_create_text1_pc: 'Введите название и имя автора',
    book_create_text2: 'Обложка не создана',
    book_create_text3: '',
    book_create_text4: 'Уже созданные обложки',
    book_create_text5: 'Есть готовая обложка?',
    book_create_text6: 'Для загрузки, пожалуйста, воспользуйтесь кнопкой ниже',
    book_create_text7: '(формат jpg размером не более 20M)',
    book_create_text8: 'Право добавлять страницы',
    book_create_text9: 'только я',
    book_create_text10: 'любой',
    book_create_text11: 'Отображать название на обложке',
    book_create_text12: 'Показать',
    book_create_text13: 'Не показывать',
    book_create_text14: 'Выберите языки для перевода',
    book_create_text15: 'Выбрать все',
    book_create_text16: 'Загрузить изображение обложки',
    book_create_text17: 'Можно отредактировать',
    book_create_text18: 'После редактирования нажмите значок в правом верхнем углу для повторного перевода',
    book_create_text19: 'Если хотите перевести по оригиналу, нажмите значок в правом верхнем углу',
    book_create_text20: 'Перевести заново',
    book_create_text21: 'Изображение',
    book_create_text22: 'Название',
    book_create_text23: 'Ключевое слово',
    book_create_text24: 'Текст',
    book_create_text25: 'Перевод будет обновлен только в случае удаления изображения и его повторной загрузки',
    book_create_text26: '(Страница не будет удалена)',
    book_create_text27: 'Напишите краткое введение',
    book_create_text28: 'Временное сохранение',
    book_create_text29: 'Временно сохранено',
    book_create_text30: 'Важные моменты для проверки',
    book_create_text31: 'Содержание текста является окончательной версией и не требует дальнейших исправлений',
    book_create_text32: 'Не использовались слова или символы, непонятные для ИИ-переводчика',
    book_create_text33: 'Изображение не было скопировано и вставлено, а добавлено как отдельный файл',
    book_create_text34: 'Открыть набор? (Открытая мини-книга)',
    book_create_text35: 'Соавторы',
    book_create_text36: 'Добавить вручную?',
    book_create_text37: 'Добавить',
    book_create_text38: 'Мини-книга, которая распространяется шире, когда мы пишем вместе',
    book_create_text39: 'Сила соавторов, о которой вы не знали',
    book_create_text40: 'Открыть набор',
    book_create_text41: 'Отменить',
    book_create_text43: 'Идея?',
    book_create_text44: 'Скопировать и вставить контент',
    book_create_text45: 'Нужна идея?',
    book_create_text46: 'Варианты продажи',
    book_create_text47: 'Бесплатно',
    book_create_text48: 'Спонсор',
    book_create_text49: 'Купить',
    book_create_text50: 'Текущая цена',
    book_create_text51: 'Изменить цену',
    book_create_text52: 'Нельзя установить 0',
    book_create_text53: 'Мини-книги, купленные или спонсированные, не могут менять цену или параметры продажи',
    book_create_text54: 'Только автор мини-книги может отвечать на сообщения',
    book_create_button_upload: 'Загрузить',
    book_create_button_make: 'Создать',
    book_create_cover_topic_placeholder: 'Заголовок будет выглядеть так',
    book_create_topic_placeholder: 'Введите заголовок',
    book_create_keyword_placeholder: 'Ключевые слова (пробел между ними)',
    book_create_category_placeholder: 'Выберите категорию',
    book_create_knowledge_placeholder: 'Напишите введение к вашей мини-книге ** Внимание - Запишите детали в шагах для создания страниц',
    book_create_category_option1: 'Фильмы и Драмы',
    book_create_category_option2: 'Музыка и Танцы',
    book_create_category_option3: 'Другие Искусства',
    book_create_category_option4: 'Одежда и Стиль',
    book_create_category_option5: 'Еда и Кулинария',
    book_create_category_option6: 'Алкоголь и Напитки',
    book_create_category_option7: 'Закуски и Десерты',
    book_create_category_option8: 'Растения и Здоровье',
    book_create_category_option9: 'Разбогатеть',
    book_create_category_option10: 'Саморазвитие',
    book_create_category_option11: 'Отношения',
    book_create_category_option12: 'Новые Знания',
    book_create_category_option13: 'Жизненные Истории',
    book_create_category_option14: 'Философия и Ценности',
    book_create_category_option15: 'Религия и Традиции',
    book_create_category_option16: 'Любовь',
    book_create_category_option17: 'Путешествия и Места',
    book_create_category_option18: 'Хобби',
    book_create_category_option19: 'Культура Игры',
    book_create_category_option20: 'Мифы и Герои',
    book_create_category_option21: 'Литературные Путешествия',
    book_create_category_option22: 'История и Мудрость',
    book_create_category_option23: 'Социальные Истории',
    book_create_category_option24: 'Общие Знания',
    book_create_message1: 'Введите заголовок',
    book_create_message2: 'Введите имя автора',
    book_create_message3: 'Введите ключевые слова',
    book_create_message4: 'Введите как минимум 3 ключевых слова',
    book_create_message5: 'Выберите категорию',
    book_create_message6: 'Создать обложку',
    book_create_message7: 'Нельзя использовать специальные символы. Между ключевыми словами должен быть пробел.',
    book_create_message8: 'Хотите удалить Мини-книгу?',
    book_create_message9: 'У вас нет прав на публикацию на этом языке',
    book_create_message10: 'Приобретённый мини-книга не может быть удалён',
    book_create_modal_text1: 'Пожалуйста, подождите немного..',
    book_create_modal_text2: 'ИИ проверяет содержание, переводит иностранные языки и подключает сеть знаний',
    book_create_modal_text3: 'Подключение к базе знаний для постраничного поиска',
    book_create_modal_text4: 'Заголовок не отображается на изображении обложки',
    book_create_modal_text5: '(Это также относится к обложкам, переведенным на иностранные языки)',
    book_view_title: 'Обзор Мини-книги',
    book_view_share: 'Поделиться',
    book_view_event_topic: 'Тема события',
    book_view_together_suggest: 'Предложить пространство для события',
    book_view_together_message: 'Если у вас нет избранного сообщество,<br/>перейдите в меню Сообщество и выберите его.',
    book_view_event_message: 'Я не создал(а) ни одного события',
    book_view_text1: 'Еще не добавлено ни одной страницы.',
    book_view_text2: 'Предложить обсуждение',
    book_view_text3: 'Такая Мини-книга не существует. Пожалуйста, попробуйте еще раз.',
    book_view_text4: 'Содержание',
    book_view_text5: 'Как насчет того, чтобы улучшить перевод этой мини-книги или продвигать её и делить прибыль?',
    book_view_text6: 'Список страниц',
    book_view_text7: 'Изменение цены',
    book_view_text8: 'Невозможно изменить, так как уже есть покупатель',
    book_view_text9: 'Подарок от читателя',
    book_view_text10: 'Только автор мини-книги может отвечать на сообщения',
    book_view_modal_title: 'Улучшение перевода и продвижение',
    book_view_modal_text1: 'Вы можете самостоятельно улучшить перевод этой мини-книги? Или продвигать её?',
    book_view_modal_text2: 'Оставьте сообщение автору',
    book_view_modal_text3: 'Если автор согласится, можно делить доход',

    book_view_write_share_title: 'Открытая мини-книга',
    book_view_write_share_text1: 'Хотите стать соавтором этой мини-книги?',
    book_view_write_share_text2: 'Подать заявку на авторство',
    book_view_write_share_text3: 'Оставьте простую заявку',
    book_view_write_share_text4: 'Отправить',
    book_view_write_share_list_title: 'Соавторы',
    book_view_write_share_text5: 'Управляйте соавторами мини-книги',
    book_view_write_share_text6: 'Управление авторами',
    book_view_write_share_text7: 'Принять',
    book_view_write_share_text8: 'Принято',
    book_view_write_share_text9: 'Пользователь уже зарегистрирован как автор',
    book_view_write_share_text10: 'Добавить автора вручную',
    book_view_write_share_text11: 'Пользователь уже подал заявку',
    book_view_publish_text1: 'Вы хотите опубликовать эту Мини-книгу?',
    book_view_publish_text2: 'Публикация сделает ее открытой для всех, и вы даже сможете заработать на ней деньги.',
    book_view_publish_text3: '(Если вы публикуете книгу для продажи, вы не можете включать в нее страницы других авторов)',
    book_view_publish_text4: 'Установите цену',
    book_view_publish_text5: 'Дата публикации',
    book_view_publish_text6: 'Подать запрос на публикацию',
    book_view_publish_text7: 'Мгновенная публикация',
    book_view_publish_text8: 'Запланировать публикацию',
    book_view_publish_text9: 'Неопубликованное',
    book_view_publish_text10: 'В процессе',
    book_view_publish_text11: 'Опубликовано',
    book_view_publish_text12: 'Что нужно знать перед публикацией',
    book_view_publish_text13: 'Эта Мини-книга никогда ранее не публиковалась в YouBook',
    book_view_publish_text14: 'Эта мини-книга и её страницы не содержат украденного контента или другого интеллектуального имущества',
    book_view_publish_text15: 'Эта мини-книга не содержит ненормативной лексики, чрезмерного сексуального содержания, оскорблений в адрес других лиц или коммерческой рекламы и соответствует статье 2, пункту 1 Условий использования',
    book_view_publish_text16: 'Да',
    book_view_publish_text17: 'Отчет о публикации',
    book_view_publish_text18: 'Опубликовано',
    book_view_publish_text19: 'Дата',
    book_view_publish_text20: 'Цена',
    book_view_publish_text21: 'Установление открытого периода',
    book_view_publish_text22: 'Открытый период',
    book_view_publish_text23: 'Что такое открытый период',
    book_view_publish_text24: 'Открытый период означает время, в течение которого читатели могут просматривать содержание',
    book_view_publish_text25: 'Эта мини-книга содержит более 3 страниц',
    book_view_publish_text26: 'Эта мини-книга не содержит более 3 страниц',
    book_view_publish_text27: 'В случае выявления нарушений алгоритм может скорректировать рейтинг поиска. При серьезных нарушениях мини-книга будет автоматически удалена',
    book_view_publish_text28: 'Установить параметры продажи',
    book_view_publish_text29: 'Способ покупки',
    book_view_publish_text30: 'Способ поддержки',
    book_view_publish_message1: 'Если вы публикуете на продажу, убедитесь, 1) что страницы вашей мини-книги были написаны вами, 2) что вы ранее не публиковали их за плату.',
    book_view_publish_message2: 'Книга не пригодна для публикации. Пожалуйста, обратитесь к администратору за помощью',
    book_view_publish_message3: 'Эта мини-книга уже была опубликована',
    book_view_publish_message4: 'Пожалуйста, выберите открытый период после текущего времени',
    book_view_publish_message5: 'Пожалуйста, выберите дату и время',
    book_view_publish_message6: 'Публикация одобрена. Спасибо',
    book_view_publish_message7: 'Пожалуйста, проверьте пункты подтверждения',
    book_view_publish_message8: 'Дата окончания не может быть раньше даты начала',
    book_view_publish_message9: 'Временно сохранённую мини-книгу нельзя опубликовать',
    book_view_publish_message10: 'Эта мини-книга была передана. Первоначальное право на публикацию принадлежит автору.',
    book_view_publish_message11: 'Пожалуйста, введите сумму не менее {minPrice}',
    book_view_button_confirm: 'Подтверждено',
    book_view_button_publish: 'Опубликовать',
    book_view_button_order: 'Выравнивание страницы',
    book_view_button_add: 'Добавить страницу',
    book_view_button_video: 'Старт',
    book_view_button_read: 'Читать',
    book_view_button_lecture: 'Смотреть видео лекции',
    book_view_page_add_title: 'Добавить страницу',
    book_view_page_add_text1: 'После поиска страницы Третья сторона',
    book_view_page_add_text2: 'На просматриваемой странице',
    book_view_page_add_text3: 'Добавить в мою Мини-книгу',
    book_view_page_add_text4: 'Хотите создать свою страницу?',
    book_view_page_add_text5: 'Создание страниц доступно только для зарегистрированных авторов.  Если вы хотите зарегистрироваться в качестве автора, пожалуйста, свяжитесь с нами ниже.',
    book_view_page_add_text6: 'Вы хотите добавить страницу Третья сторона?',
    book_view_page_add_text7: '* Если вы добавите страницу, созданную Третья сторона, \nеё нельзя опубликовать как платную мини-книгу',
    book_view_page_add_text8: 'У вас уже есть созданные страницы?',
    book_view_page_add_button1: 'Создать сейчас',
    book_view_page_add_button2: 'Посмотреть Мои заметки',
    book_view_reference_text1: 'Тематика',
    book_view_reference_text2: 'Количество',
    book_view_reference_text3: 'Автор:',
    book_view_reference_text4: 'Под авторством',
    book_view_support_text1: 'Я поддерживаю тебя',
    book_view_support_modal_title: 'Стань поддерживающим',
    book_view_support_modal_text1: 'Даже хороший текст сложно распространить в одиночку.',
    book_view_support_modal_text2: 'Поддерживающий — это тот, кто делится мини-книгой автора с миром и поддерживает других.',
    book_view_support_modal_text3: 'Давайте вместе распространим эту историю дальше.',
    book_view_support_modal_text4: 'Пожалуйста, поддержите автора',
    book_view_support_modal_btn1: 'Понял',
    book_view_support_modal_text5: '"Ваша поддержка очень важна для меня. Спасибо. Я также от всего сердца поддержу ваше путешествие."',
    book_view_support_modal_text6: 'Пожалуйста, поделитесь мини-книгой с миром',
    book_view_support_modal_btn2: 'Как это сделать?',
    book_view_support_modal_title2: 'Я дошёл до этого места, молодец',
    book_view_support_modal_text7: 'Писать было нелегко, но я справился.',
    book_view_support_modal_text8: 'Теперь пришло время поверить в себя и сделать ещё один шаг вперёд.',
    book_view_support_modal_text9: 'Даже если мне немного стыдно или я сомневаюсь, я становлюсь своим первым поддерживающим и открываюсь миру.',
    book_view_support_modal_text10: 'Потому что я верю, что это может что-то значить для кого-то.',
    book_view_support_modal_text11: 'Пожалуйста, станьте моим поддерживающим',
    book_view_support_modal_text12: 'Писать или проводить мероприятие было нелегко, но я решился на это.',
    book_view_support_modal_btn3: 'Попробую!',
    book_view_support_modal_title3: 'Здравствуйте, поддерживающий',
    book_view_open_minibook_text1: 'Запрос на открытие мини-книги был выполнен',
    book_view_open_minibook_text2: 'Запрос на открытие мини-книги был отменен',
    page_create_title: 'Создать страницу',
    page_create_text1: 'Изображение не добавлено ',
    page_create_text2: '',
    page_create_text3: 'страница',
    page_create_text4: 'Изображение добавлено',
    page_create_text5: 'Добавить изображение?',
    page_create_text6: 'Введите текст. Не рекомендуется использовать более одного листа формата A4.',
    page_create_text7: 'Текущий размер файла',
    page_create_text8: 'Рекомендуемый размер текста',
    page_create_text9: 'Добавить ссылку?',
    page_create_text10: 'Авторская работа',
    page_create_text11: 'Список использованной литературы',
    page_create_text12: 'Список использованных блогов',
    page_create_text13: 'Обращались к AI',
    page_create_text14: 'Это обязательный пункт для создания Мини-книги',
    page_create_text15: 'Загрузить изображение страницы',
    page_create_text16: 'Хотите перевести заново?',
    page_create_text17: 'Если вы хотите перевести заново, выберите цель и язык (если не выбрано, будет сохранено без перевода)',
    page_create_text18: 'Объект перевода',
    page_create_text19: 'Язык перевода',
    page_create_message1: 'Внесение изменений невозможно',
    page_create_message2: 'Введите ваш текст',
    page_create_message3: 'Хотите удалить страницу?',
    page_create_message4: 'Содержание превышает максимальный размер',
    page_create_reference_book: 'книга',
    page_create_reference_blog: 'блог',
    page_create_reference_placeholder1: 'Введите заголовок',
    page_create_reference_placeholder2: 'Связанная ссылка (например, https://www.amazon.com/dp...)',
    page_create_reference_placeholder3: 'Год публикации',
    page_create_reference_placeholder4: 'Автор',
    page_create_title_placeholder: 'Название будет выглядеть так',
    page_create_message5: 'Идет перевод содержимого',
    page_create_message6: 'После создания обложки можно создать страницу.',
    page_create_modal_text1: 'Заголовок не отображается на изображении страницы',
    page_create_modal_text2: '(Это также относится к страницам, переведенным на иностранные языки)',
    page_create_modal_text3: 'Обязательно проверьте!',
    page_create_modal_text4: 'Если текст изменился, необходимо временное сохранение.',
    page_create_modal_text5: 'Вы это сделали?',
    page_create_modal_text6: 'Если текст изменился, необходимо создать.',
    page_view_title: 'Просмотреть страницу',
    page_view_button_video: 'Старт',
    page_view_button_read: 'Читать',
    page_view_text1: 'МиниКнига',
    page_view_text2: 'Автовоспроизведение',
    page_view_text3: 'Чтения',
    page_view_text4: 'Связанные страницы',
    page_view_text5: 'Связанные Мини-книги',
    page_view_text6: 'Источники',
    page_view_text7: 'Ссылки',
    page_view_text8: 'Год издания',
    page_view_text9: 'Автор',
    page_view_text10: 'Название',
    page_view_text11: 'Посмотреть полный текст',
    page_view_text12: 'Поиск связанных материалов',
    page_view_text13: 'Автор страницы',
    page_view_text14: 'Связаться с автором',
    page_view_text15: 'Добавить',
    page_view_reference_text1: 'Книга',
    page_view_reference_text2: 'Блог',
    page_view_popup: 'У вас нет созданных мини-книг.  Пожалуйста, создайте ее на вашей странице MY.',
    page_view_pay_popup_text1: 'Вы что-то получили от чтения? \nПоблагодарите автора маленьким подарком.',
    page_view_pay_popup_title: 'Отправить подарок',
    page_view_pay_popup_text2: 'Выберите чай для подарка',
    page_view_pay_popup_text3: 'Напишите тёплое сообщение',
    page_view_pay_popup_placeholder1: 'Слова и мудрость автора действительно помогли мне.',
    page_view_pay_popup_text4: 'Сумма',
    page_view_pay_popup_button1: 'Купить и отправить сообщение',
    page_view_pay_popup_text5: 'Автор вложил много времени и усилий в написание этого текста.\n\nПожалуйста, поблагодарите небольшим подарком.',
    page_view_pay_popup_placeholder2: 'Я доверяю мудрости и чувствам автора.',
    page_view_pay_popup_text6: 'Не хотите отправлять подарок?',
    page_view_pay_popup_text7: 'Предпочитаете посмотреть рекламу?',
    page_view_pay_popup_button2: 'Смотреть рекламу, чтобы читать',
    page_sort_title: 'Выравнивание страницы',
    page_sort_subtitle: 'Перетащите страницу, чтобы изменить порядок',
    page_sort_text: 'Источник',
    pay_button: 'Купить сейчас',
    pay_price: 'Цена',
    pay_vat_excluded: '(без НДС)',
    pay_message_success: 'Покупка произведена',
    pay_message_fail: 'Покупка не произведена',
    pay_currency: '₽',
    pay_button_paid: 'Оплачено',
    pay_button_view_price: 'Посмотреть цену',
    pay_total: 'Всего',
    pay_methods: 'Способы оплаты',
    pay_methods_creditcard: 'Кредитная карта',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Продолжить',
    pay_text1: 'Пожалуйста, выберите чай',
    pay_text2: 'Пожалуйста, введите сообщение',
    advertisement_button: 'Читать далее',
    advertisement_text1: 'Вы можете просмотреть контент после просмотра рекламы.',
    advertisement_text2: 'Это страница из платной мини-книги. <br />Перейдите к обложке и нажмите Читать, чтобы купить. <br />',
    advertisement_text3: 'Вы можете просмотреть контент после просмотра рекламы. Рекламу можно посмотреть только в приложении.',
    together_title: 'Событие',
    together_subtitle: 'Встреться с читателями и пообщайся',
    together_subtitle_text1: 'Встреться с читателями онлайн',
    together_subtitle_text2: 'Создайте свое сообщество и пригласите людей',
    together_button: 'Создать пространство для события',
    together_case: 'Кейс',
    together_case1: 'Я пытаюсь делиться, но продолжаю только получать.',
    together_case2: 'Как оказалось на реальных примерах быстро учишься',
    together_subtitle2: 'Моё пространство',
    together_category1: 'Обновления',
    together_category2: 'Избранное',
    together_button_viewmore: 'Ещё',
    together_list_date: 'DD.MM.YYYY',
    together_list_date2: 'DD.MM.YYYY. A hh:mm',
    together_subtitle3: 'Такое пространство',
    together_subtitle3_1: 'Пожалуйста, создайте',
    together_subtitle_text3: 'Присоединиться',
    together_create_title: 'Создать пространство для события',
    together_create_title2: 'Редактировать пространство события',
    together_create_button1: 'Выбрать',
    together_create_subtitle: 'Заголовок',
    together_create_placeholder1: 'Введите заголовок',
    together_create_subtitle1: 'Описание',
    together_create_placeholder2: 'Напишите краткое описание группы',
    together_create_subtitle2: 'Выберите необходимые опции',
    together_create_text1: 'Ссылка на онлайн-встречу (например, ссылка Zoom)',
    together_create_placeholder3: 'Пожалуйста, введите ссылку на онлайн-встречу',
    together_create_question1: 'Не знаете ссылку на zoom?',
    together_create_q1_a_title: 'Найти ссылку, чтобы присоединиться к zoom',
    together_create_text2: 'Использовать metaverse',
    together_create_placeholder4: 'Выберите дополнительные опции',
    together_create_question2: 'Что такое, метаверс?',
    together_create_text3: 'Выбрать тип сообщества',
    together_create_dropmenu1: 'Интеллектуальный уголок только для приглашенных участников YB',
    together_create_dropmenu2: 'Уголок авторов и читателей',
    together_create_button2: 'Сохранить',
    together_create_button3: 'Создать',
    together_create_popup_title: 'Выберите тип сообщества',
    together_create_popup_alert: 'Выбрано',
    together_create_button4: 'Выбрать',
    together_create_alert: 'Пожалуйста, введите ссылку для онлайн-встреч',
    together_create_alert1: 'Введите заголовок',
    together_create_alert2: 'Выберите metaverse для размещения',
    together_create_alert3: 'Внесение изменений невозможно',
    together_create_alert4: 'Пространство события создано',
    together_create_alert5: 'Ошибка. Пожалуйста, попробуйте еще раз',
    together_create_alert6: 'Не удалось создать пространство события...',
    together_qa_popup_title1: 'Найти ссылку, чтобы присоединиться к Zoom',
    together_qa_popup_btext1: 'Мой компьютер',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Откройте программу Zoom - После входа в систему - Нажмите на меню совещаний вверху - Мой личный ID совещания - Нажмите Показать приглашение на совещание - Появится ссылка для присоединения к совещанию Zoom. Скопируйте ее.',
    together_qa_popup_btext2: 'Мой телефон',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Откройте программу Zoom - После входа в систему - Нажмите кнопку i в правом верхнем углу - Отправить приглашение - После нажатия на сообщение - Войдите в программу и введите свой номер телефона - Появится ссылка. Скопируйте ее.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'Что такое metaverse?',
    together_qa_popup_text3: 'Это виртуальное пространство для встреч.',
    together_qa_popup_text4: 'Появляется в виде аватара',
    together_qa_popup_text5: 'созданного вами - Общение с друзьями лицом к лицу - Вы также можете делиться своим экраном.',
    together_qa_popup_text7: 'В одно пространство для встреч',
    together_qa_popup_text8: '- одновременно могут войти до 10 человек.',
    together_qa_popup_text9: 'Не нужно устанавливать дополнительную программу',
    together_qa_popup_text10: 'и не требуется регистрация участников.',
    together_more_list_title: 'Пространство события',
    together_more_list_date: 'DD. MM. YYYY',
    together_request_list_title: 'Пожалуйста, создайте',
    together_request_list_category1: 'Избранное',
    together_request_list_category2: 'Обновления',
    together_request_list_button: 'Предложить новое пространство',
    together_request_popup_title: 'Предложение нового пространства',
    together_request_popup_alert1: 'Введите заголовок',
    together_request_popup_alert2: 'Введите краткое описание',
    together_request_popup_placeholder1: 'Введите заголовок',
    together_request_popup_placeholder2: 'Введите краткое описание',
    together_request_popup_button: 'Сохранить',
    together_request_detail_button: 'Создать это пространство',
    together_detail_sns: 'Поделиться',
    together_detail_enterbtn: 'Войти',
    together_detail_btn1: 'Список событий',
    together_detail_btn2: 'Сообщения',
    together_detail_subtitle: 'Мини-книга по теме',
    together_detail_alert: 'Подождите минутку...',
    together_detail_alert1: 'Предложение пространства события успешно!',
    together_detail_alert2: 'Не удалось предложить пространство события…',
    together_detail_alert3: 'Добавить в избранное/ Удалить из избранного',
    together_detail_alert4: 'Не удалось добавить в избранное/удалить из избранного',
    together_detail_alert5: 'Проблема на сервере, пожалуйста, попробуйте позже',
    together_detail_alert6: 'Есть проблема со ссылкой на онлайн-встречу',
    together_detail_alert7: 'Не удалось удалить',
    together_notice_alert: 'Хотите удалить объявление?',
    together_notice_list_title: 'Объявление',
    together_button_addtopic: 'Добавить это как тему к пространству события',
    together_add_alert: 'Добавлено в пространство события',
    together_text1: 'Люди с похожими интересами',
    together_text2: 'Удалить это пространство события?',
    together_event_btn: 'Создать новое событие',
    together_event_title: 'Новое событие',
    together_event_placeholder: 'Введите описание',
    together_event_text1: 'Укажите расписание',
    together_event_text2: 'Укажите входную плату',
    together_event_text3: 'Укажите максимум человек',
    together_event_text4: 'Расписание',
    together_event_text5: 'Входная плата',
    together_event_text6: 'Максимум человек',
    together_event_text7: 'Уведомить моих подписчиков',
    together_event_text8: 'Вы хотите удалить событие?',
    together_event_text9: 'Пожалуйста, установите время начала после текущего времени',
    together_event_text10: 'Пожалуйста, установите время окончания после времени начала',
    together_event_text11: 'Время начала и окончания не могут совпадать',
    together_event_text12: 'Добавить это как тему события',
    together_event_text13: 'Добавлено в событие',
    together_event_text14: 'Превышено максимальное количество участников события',
    together_event_text15: 'Кнопка активируется за 1 час до Событие \n(если бесплатно, Купить сейчас не нужно)',
    together_event_text16: 'Кнопка активируется за 1 час до Событие',
    together_event_text17: 'Событие не существует',
    together_event_text18: 'Невозможно удалить, если есть покупатель события',
    together_event_text19: 'Хотите отправить уведомление?',
    together_event_text20: 'Отправлено',
    together_event_text21: 'Список событий',
    together_event_text22: 'Посмотреть детали',
    together_event_text23: 'После Зарегистрируйтесь войдите',
    together_event_text24: 'Как принять участие',
    together_event_text25: 'Участие в событии завершено',
    together_event_text26: 'Автор вложил много времени и заботы в это событие.\n\nПожалуйста, ответьте маленьким подарком.',
    together_event_text27: 'Мудрость, исходящая из опыта автора, и глубокое общение произвели впечатление',
    together_event_text28: 'Поделитесь этим событием с миром',
    together_event_text29: 'Открыть это событие было непросто, но я справился.',
    together_event_text30: 'Как бы ни было прекрасно событие, одному трудно донести его до мира.',
    together_event_text31: 'Поддерживающий — это тот, кто распространяет событие автора. Это человек, который поддерживает других.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Встречайте разных людей со всего мира',
    youbooker_case: 'Кейс',
    youbooker_case_text1: 'Стать человеком, с которого все началось',
    youbooker_case_text2: 'Какой эффект от знаний?',
    youbooker_translation: 'Хотите встретиться прямо сейчас?',
    youbooker_translation_text1: 'Все языки',
    youbooker_category: 'Подписчики / Подписки',
    youbooker_subcategory1: 'Мои подписчики',
    youbooker_subcategory2: 'Я подписан',
    youbooker_subtitle2: 'Люди, которые подписаны на меня',
    youbooker_button_follow: 'Подписаться',
    youbooker_message_follow: 'Подписаться',
    youbooker_button_follow_cancel: 'Отписаться',
    youbooker_subtitle3: 'Вы знаете этого человека? Подпишитесь!',
    youbooker_subtitle4: 'Люди, на которых я подписан',
    youbooker_subtitle5: 'Вы знаете этого человека, но он еще не знает о YouBook',
    youbooker_button_invite: 'Пригласить',
    youbooker_alert_invite: 'Приглашение возможно только через приложение. Хотите скачать приложение?',
    youbooker_alert: 'Доступно только в приложении. Хотите скачать приложение?',
    youbooker_alert2: 'Обновление успешно!',
    youbooker_alert3: 'Вы можете найти на YouBooker',
    home_page_text1: 'Последние',
    home_page_text2: 'Влияние',
    home_page_today_title: 'Тема дня',
    home_page_today_subtitle: 'Свежая подборка новостей',
    home_page_slider_date: 'YYYY. MM. DD',
    home_page_today_list_title: 'Сегодняшняя тема',
    home_page_today_detail_sns: 'Поделиться',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: 'Похожие страницы',
    home_page_explor_title: 'Поиск страницы',
    home_page_explor_subtitle: 'Что произойдет, если кликнуть дважды?',
    home_page_recommend_title: 'Рекомендации',
    home_page_recommend_subtitle: 'Страницы, которые могут вас заинтересовать',
    home_page_theysee_title: 'Режим просмотра',
    home_page_theysee_subtitle: 'Страницы, обязательные для посещения читателей',
    home_page_common_title: 'Хотите узнать кое-что интересное?',
    home_page_common_subtitle: 'Умение мыслить здраво — это сила, которая помогает увидеть истину',
    home_page_keyw_title: 'Страницы по ключевым словам',
    home_page_keyw_subtitle: 'Найти все похожие страницы',
    home_page_random_title: 'Случайный выбор',
    home_page_random_subtitle: 'Нажмите, если заскучали и узнайте что-то новое',
    home_page_about_title: 'Иноформация о YouBook',
    home_page_about_detail: 'Корпорация: syndicate NICK /Российский бизнес-центр: Москва /Другие страны центр: Сиэтл Сеул Токио Шанхай /Контакт: joa@academy-connect.net/DUNS 695937905',
    settlement_title: 'Покупка и оплата',
    settlement_tab1: 'История заказов',
    settlement_tab2: 'Информация о расчетном счете',
    settlement_tab3: 'Информация об оплате',
    settlement_category1: 'Моя запись о покупке',
    settlement_category2: 'Совместное авторское право',
    settlement_category3: 'Запись о доходе мини-книги',
    settlement_category4: 'Запись о доходе события',
    settlement_category5: 'Управление счётом',
    settlement_text1: 'Отображение записи о покупке',
    settlement_text2: 'Вы можете поделиться авторским правом на мини-книгу',
    settlement_text3: 'Расчет доходов от продаж Мини-книг.',
    settlement_text4: 'Если у вас возникли дополнительные вопросы, нажмите',
    settlement_text5: 'здесь',
    settlement_text6: 'Или свяжитесь с нами по следующему адресу.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Введите текст сообщения',
    settlement_text9: 'Если есть доход, необходимо управлять счётом для получения выплат',
    settlement_text10: 'Доход от события будет рассчитан',
    settlement_purchase_text1: 'Запись о покупке',
    settlement_purchase_text2: 'Дата',
    settlement_purchase_text3: 'Сумма покупки',
    settlement_purchase_text4: 'Название',
    settlement_purchase_text5: 'Мини-книга',
    settlement_purchase_text6: 'Событие',
    settlement_accountInfo_text1: 'Авторское право на мини-книгу',
    settlement_accountInfo_text2: 'Мини-книга',
    settlement_accountInfo_text3: 'Язык',
    settlement_accountInfo_text4: 'Права автора',
    settlement_accountInfo_text5: 'Автор',
    settlement_accountInfo_text6: 'Третья сторона',
    settlement_accountInfo_text7: 'Личное?',
    settlement_accountInfo_text8: 'Личное',
    settlement_accountInfo_text9: 'Компания',
    settlement_accountInfo_text10: 'Название банка',
    settlement_accountInfo_text10_message: 'Выберите название банка',
    settlement_accountInfo_text11: 'Имя владельца счета',
    settlement_accountInfo_text11_message: 'Введите имя владельца счета',
    settlement_accountInfo_text12: 'Номер банковского счета',
    settlement_accountInfo_text12_message: 'Введите номер банковского счета',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'ИНН',
    settlement_accountInfo_text13_message: 'Введите ИНН',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Адрес',
    settlement_accountInfo_text14_message: 'Введите адрес',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'Электронная почта',
    settlement_accountInfo_text15_message: 'Введите адресс электронной почты',
    settlement_accountInfo_text16: 'Сохранить',
    settlement_accountInfo_text17: 'Основной государственный регистрационный номер (ОГРН)',
    settlement_accountInfo_text17_message: 'Введите ОГРН компании',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Корпоративный адрес',
    settlement_accountInfo_text18_message: 'Введите корпоративный адрес',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'Название компании',
    settlement_accountInfo_text19_message: 'Войдите в название компании',
    settlement_accountInfo_text20: 'Корпоративный номер',
    settlement_accountInfo_text20_message: 'Введите корпоративный номер',
    settlement_accountInfo_text21: 'ID третьей стороны',
    settlement_accountInfo_text21_placeholder: 'Электронная почта третьей стороны',
    settlement_accountInfo_text22: 'Счет для получения платежа',
    settlement_accountInfo_text23: 'Страна',
    settlement_accountInfo_message1: 'Электронная почта не найдена',
    settlement_accountInfo_message2: 'Вы не можете делиться авторским правом с самим собой',
    settlement_accountInfo_message3: 'Нет созданных Мини-книг',
    settlement_accountInfo_text24: 'Совместное авторское право',
    settlement_accountInfo_text25: 'Если вы поделитесь авторским правом с третьей стороной, его невозможно будет вернуть',
    settlement_accountInfo_text26: 'Вы хотите поделиться авторским правом?',
    settlement_accountInfo_text27: 'Да, поделиться',
    settlement_accountInfo_text28: 'Чтобы поделиться авторским правом: <br />1) страницы в мини-книге должны быть созданы вами и<br /> 2) они не должны были быть ранее переданы третьей стороне',
    settlement_accountInfo_text29: 'Я это исправлю',
    settlement_accountInfo_text30: 'Вы поделились авторским правом на эту мини-книгу с третьей стороной',
    settlement_accountInfo_text31: 'Автор',
    settlement_accountInfo_text32: 'Третья сторона',
    settlement_accountInfo_text33: 'Вы получили авторское право на эту мини-книгу от автора',
    settlement_accountInfo_text34: 'Это бесплатная мини-книга. Оплата не требуется.',
    settlement_accountInfo_text35: 'Делиться доходами',
    settlement_accountInfo_text36: '(мне)',
    settlement_accountInfo_text37: '(издатели и т.д.)',
    settlement_accountInfo_text38: 'Личный счет',
    settlement_accountInfo_text39: 'Корпоративный счет',
    settlement_accountInfo_text40: 'Управление счетом',
    settlement_accountInfo_text41: 'Сохранить',
    settlement_accountInfo_text42: 'Банк',
    settlement_accountInfo_text43: 'Выбор счета',
    settlement_accountInfo_text44: 'Определить, как разделить доход',
    settlement_accountInfo_text45: 'Ставка дохода (%)',
    settlement_accountInfo_text46: 'Мой ID (email)',
    settlement_accountInfo_text47: 'ID третьей стороны (email)',
    settlement_accountInfo_text48: 'Согласовать итог',
    settlement_accountInfo_text49: 'Введите информацию о цессионарии',
    settlement_accountInfo_text50: 'Ставка дохода не может превышать 100',
    settlement_accountInfo_text51: 'Цедент ID(email)',
    settlement_accountInfo_text52: 'Цессионарий ID(email)',
    settlement_earnings_text1: 'Информацию об оплате',
    settlement_earnings_text2: 'Расчетный период',
    settlement_earnings_text3: 'Цена Мини-книги',
    settlement_earnings_text4: 'Количество продаж',
    settlement_earnings_text5: 'Сумма продаж',
    settlement_earnings_text6: 'Сумма, включая налоги',
    settlement_earnings_text7: 'Сумма оплаты',
    settlement_earnings_text8: 'Дата оплаты',
    settlement_earnings_text9: 'Просмотры pекламы',
    settlement_earnings_text10: 'Общая cумма',
    settlement_earnings_text11: 'Узнать больше',
    settlement_earnings_text12: 'Цена рекламы',
    settlement_earnings_text13: 'Доход',
    settlement_earnings_text14: 'Все мини-книги',
    settlement_earnings_text15: 'Выбрать событие',
    settlement_earnings_text16: 'Все события',
    settlement_statistics_text1: 'Объем продаж',
    settlement_statistics_text2: 'Число читателей',
    settlement_statistics_text3: '(Прошлый)',
    settlement_statistics_text4: '1 месяц',
    settlement_statistics_text5: '6 месяцев',
    settlement_statistics_text6: '1 год',
    settlement_statistics_text7: 'Данные не найдены',
    settlement_statistics_text8: 'Анализ продаж',
    settlement_statistics_text9: 'Просмотры рекламы',
    settlement_statistics_text10: 'Все языки',
    terms_title: 'Условия предоставления услуг',
    terms_text: '',
    privacy_title: 'Политика конфиденциальности',
    privacy_text: '',
    // common text
    message_save: 'Сохранено',
    message_fail: 'Ошибка',
    message_delete: 'Сообщение удалено',
    message_report: 'Сообщение отправленно',
    message_search_no_result: 'Результаты поиска не найдены',
    message_search_enter: 'Введите запрос в поисковую строку',
    message_error1: 'Произошла ошибка. Пожалуйста, свяжитесь с администратором',
    message_save2: 'Сообщение сохранено',
    message_fail2: 'Ошибка при отправке сообщения',
    message_login: 'Вам нужно войти в систему',
    name: 'Имя',
    email: 'Электронная почта',
    mobile: 'Мобильный',
    list: 'Список',
    edit: 'Редактировать',
    delete: 'Удалить',
    search: 'Поиск',
    report: 'Тип отзывов',
    user: 'Пользователь',
    report_type: 'Тип отзывов',
    report_type1: 'Нецензурная лексика',
    report_type2: 'Реклама',
    report_type3: 'Непристойное содержание',
    report_type4: 'Повторение одного и того же содержания',
    report_type5: 'Прочее',
    search_book: 'Поиск по Мини-книге',
    serch_placeholder: 'Поиск по имени или электронной почте',
    search_keyword: 'Ключевое слово',
    search_reference: 'Ссылка',
    search_author: 'Автор',
    search_result: 'Найдено',
    button_report: 'Пожаловаться',
    button_write: 'Сохранить',
    button_login: 'ВХОД',
    button_more: 'Ещё',
    button_confirm: 'Подтвердить',
    button_save: 'Сохранить',
    button_crop: 'Обрезать',
    button_delete: 'Удалить',
    button_complete: 'полный',
    colorbox_background_text1: 'Выберите цвет фона',
    colorbox_font_text1: 'Выберите цвет текста',
    menu_home: 'Главная',
    menu_page: 'Страница',
    menu_book: 'Мини-книга',
    menu_memo: 'Заметки',
    menu_together: 'Событие',
    login_button: 'ВХОД',
    message_text1: 'Ответить',
    message_text2: 'На мой комментарий оставили ответ',
  },
  es: {
    home_banner_title1: 'Nuevo minilibro',
    home_banner_title2: 'Nuevo evento',
    home_slide_title1: 'Tendencia actual',
    home_slide_title2: 'Mi gusto',
    home_slide_title3: 'Caliente ahora',
    home_slide_title4: 'Muy popular',
    home_detail_title1: 'Recuerdos cotidianos',
    home_detail_title2: 'Videos recomendados',
    home_detail_title3: 'Si quieres saber más',
    home_detail_text1: 'Minilibro memo',
    home_detail_text2: 'Memo diario',
    home_setting_title: 'Configuración',
    home_setting_text1: 'Páginas vistas en los últimos 30 días',
    home_setting_text2: 'Cerrar sesión',
    home_setting_text3: 'Eliminar cuenta',
    home_book_banner_question: 'Tengo curiosidad',
    home_book_banner_write_placeholder1: 'Ingrese un título',
    home_book_banner_write_placeholder2: 'Ingrese un mensaje',
    home_book_banner_write_button: 'Guardar',
    home_book_banner_detail_text1: 'Respuesta del mentor de Youbook ',
    home_book_banner_detail_text2: 'Minilibros relacionados',
    home_book_create_button: 'Minilibro, ¡Crea el tuyo',
    home_book_create_text1: 'Un minilibro es un libro corto de aproximadamente 10 páginas. Está diseñado para quienes quieren leer contenido breve pero esencial de manera rápida y efectiva.',
    home_book_create_text2: 'Cómo editar después de la publicación',
    home_book_create_text3: 'Minilibro, forma fácil de crear',
    home_book_create_text4: '¿Cuánto puede ganar un autor?요',
    home_book_create_text5: '¿Cómo puedo conectar con los lectores?',
    home_book_create_text6: '5 razones para usar YouBook',
    home_book_create_text7: '¿Tienes más preguntas?',
    home_book_create_text8: '¿Puedo ver las ventas en tiempo real?',
    home_book_create_text9: '¡Escribamos con constancia todos los días!',
    home_book_create_text10: '¡Empieza ahora mismo!',
    home_book_category_title1: 'Temas de hoy y minilibroy',
    home_book_category_title2: 'Minilibros Populares',
    home_book_category_title3: 'Minilibros del Profesor S-class',
    home_book_category_title4: 'Recomendaciones Personalizadas',
    home_book_category_title5: 'Minilibros Esenciales de Bestsellers',
    home_book_category_title6: 'Con Gatito Libro',
    home_book_category_title6_text1: 'Ver',
    home_book_category_title6_text2: 'Ocultar',
    home_book_category_title7: 'Exploración de Páginas de Redes Neuronales',
    home_book_category_title8: 'Festival de Arte y Emoción',
    home_book_category_title8_text1: 'Mundos en Películas y Series',
    home_book_category_title8_text2: 'Melodías y Movimientos Emotivos',
    home_book_category_title8_text3: 'Arte sin Fronteras',
    home_book_category_title8_text4: 'Vistiendo Personalidad: Moda y Estilo',
    home_book_category_title9: 'Cultura Gastronómica de Sabor y Relajación',
    home_book_category_title9_text1: 'Exploración Gastronómica de Cocina Local',
    home_book_category_title9_text2: 'Historias de Alcohol y Vida',
    home_book_category_title9_text3: 'Encanto de Bocadillos y Postres',
    home_book_category_title9_text4: 'El Poder de la Naturaleza, Secretos de las Plantas',
    home_book_category_title10: 'Sabiduría y Autodescubrimiento',
    home_book_category_title10_text1: 'Formas Únicas de Manejar el Dinero',
    home_book_category_title10_text2: 'Recetas de Crecimiento Personal',
    home_book_category_title10_text3: 'Problemas y Soluciones en las Relaciones',
    home_book_category_title10_text4: 'Nuevos Descubrimientos y Conocimientos',
    home_book_category_title11: 'Diversidad de Valores y Amor',
    home_book_category_title11_text1: 'Historias de sus Vidas',
    home_book_category_title11_text2: 'Filosofías y Valores Diferentes',
    home_book_category_title11_text3: 'Creencias Religiosas y Tradiciones',
    home_book_category_title11_text4: 'El Misterio del Amor',
    home_book_category_title12: 'Días Llenos de Viajes y Aficiones',
    home_book_category_title12_text1: 'Destinos Ocultos que Debes Visitar',
    home_book_category_title12_text2: 'Alegría de la Vida a Través de Pasatiempos',
    home_book_category_title12_text3: 'Cultura Única a Través del Juego',
    home_book_category_title13: 'Riqueza de Tradición e Historias',
    home_book_category_title13_text1: 'Mitos Locales e Historias de Héroes',
    home_book_category_title13_text2: 'Viajes Literarios Globales',
    home_book_category_title13_text3: 'Historia y Sabiduría de Lugares',
    home_book_category_title13_text4: 'Narrativas Sociales Coloridas',

    home_book_category_title1_text2: 'Los pensamientos de Gatito Libro – ¿Quieres echar un vistazo?',
    home_book_category_title1_text3: '¿Preocupado? ¿Curioso?',
    home_book_category_title1_text4: '¿Quieres que te recomiende un minilibro?',
    home_book_search_placeholder1: 'Habla aquí',
    home_book_search_placeholder2: '¿Palabra clave?',

    home_book_search_message1: 'Ingrese sus preguntas',
    home_book_search_message2: 'Vuelve a ingresar tus preguntas',
    home_book_search_text1: '¿Por qué no discutir conmigo?',
    home_book_search_text2: '¿Por qué no discutir conmigo?',
    home_book_search_text3: 'Preguntar',
    home_book_search_text4: 'Puedes guardar lo anterior',
    home_book_search_text5: '(Sólo tienes que añadir las palabras clave)',
    home_book_search_text6: 'Buscar',

    home_book_theme_title: 'Libros por tema',
    home_instant_text1: 'Ingrese una palabra clave',
    home_instant_text2: 'Ingrese al azar',
    home_book_company_info: 'Si tiene alguna pregunta, no dude en ponerse en contacto con nosotros. Estamos a su disposición.',
    home_page_search_text1: 'Búsqueda por página',
    home_page_search_text2: 'Reproducir instantáneamente como vídeo',
    home_page_search_text3: 'Búsqueda avanzada',
    home_page_search_text4: 'Ver lista',
    home_page_search_text5: 'Ver red',
    home_page_explor_alert: 'No se han seleccionado páginas',
    home_page_explor_alert2: 'Ha superado el número máximo de páginas que pueden verse en una pantalla (150). Por favor, coloque las páginas innecesarias en la papelera.',
    home_page_explor_alert3: 'No hay más información para cargar',
    my_login_title: 'MI',
    my_login_text1: 'Crea tu perfil con estilo',
    my_login_text2: 'Entra ahora y hazte notar',
    my_login_text3: 'con YouBook',
    my_login_find_password: 'Buscar contraseña',
    my_guide_minibook: 'Cómo hacer un Minilibro',
    my_password_reset: 'Restablecer contraseña',
    my_password_reset_text1: 'Ingrese su correo electrónico anterior para el INICIO sesión',
    my_password_reset_button1: 'Enviar un enlace para restablecer',
    my_password_reset_button2: 'Restablecer',
    my_password_reset_message1: 'No se ha encontrado su dirección de correo electrónico',
    my_password_reset_message2: 'Hemos enviado un enlace para restablecer la contraseña a la dirección de correo electrónico indicada.',
    my_password_reset_message3: 'Por favor, restablezca su contraseña utilizando el enlace enviado a su correo electrónico.',
    my_password_reset_placeholder1: 'Tu correo electrónico',
    my_password_reset_placeholder2: 'Ingrese su nueva contraseña',
    my_password_reset_placeholder3: 'Vuelva a ingresar su nueva contraseña',
    my_password_reset_message4: 'Las contraseñas no coinciden',
    my_password_reset_message5: 'La contraseña debe tener al menos 8 caracteres e incluir al menos una letra mayúscula, una letra minúscula, un número y un carácter especial.',
    my_password_reset_message6: 'Se ha restablecido la contraseña',
    my_memo_list_placeholder: '¿Tiene alguna idea? Escríbela ahora',
    my_profile_placehoder1: 'Me interesa',
    my_profile_placehoder2: 'Mi nombre',
    my_profile_placehoder3: 'Incluye una breve presentación',
    my_profile_placehoder4: 'Presentaciones adicionales',
    my_profile_text1: 'Nacionalidad',
    my_profile_text2: 'Idioma',
    my_profile_text3: 'Cambiar ID',
    my_profile_text4: 'ID actual',
    my_profile_text5: 'Nuevo ID para cambiar',
    my_profile_text6: 'El cambio de ID solo es posible una vez',
    my_menu_text1: 'Mi Viaje',
    my_menu_text2: 'Mensajería',
    my_menu_text3: 'Compra y liquidación',
    my_menu_text4: 'Nueva notificación',
    my_menu_text5: 'Hacer un Minilibro',
    my_menu_text6: 'Minilibros escritos',
    my_menu_text7: '¿Quieres importar escritos desde otras apps?',
    my_menu_text8: 'Puedes importarlos automáticamente y convertirlos en página',
    my_menu_text9: 'Importar',
    my_import_book_text1: 'Convertir en página',
    my_import_book_text2: 'Se está convirtiendo el archivo ZIP en páginas. Puede tardar hasta 5 segundos por texto. Aproximadamente 1 minuto por 10 textos, y 8 minutos por 100. Al finalizar, aparecerá una ventana emergente.',
    my_import_book_text3: 'Entendido',
    my_import_book_text4: 'Conversión en página completada',
    my_import_book_text5: 'Todos los textos del archivo ZIP se han convertido en páginas. Cada texto fue transformado en una página individual. Puedes consultarlas en Mi Viaje - Páginas escritas. Las páginas están guardadas temporalmente y pueden editarse.',
    my_import_book_text6: 'Puedes importar textos desde otras apps y convertirlos automáticamente en páginas. Luego puedes agruparlas en un minilibro.',
    my_import_book_text7: 'Cómo importar textos desde otras apps en archivo ZIP',
    my_import_book_text8: 'Sube un archivo ZIP',
    my_import_book_text9: 'Subir archivo de Substack',
    my_import_book_text10: 'Subir archivo de Medium',
    my_import_book_text11: 'Buscar',
    my_import_book_text12: '* Cada texto se convierte en una página individual',
    my_import_book_text13: '* Puedes verificarlo en Mi página - Configuración - Páginas escritas',
    my_import_book_text14: '* Las páginas están guardadas temporalmente y pueden editarse',
    my_import_book_text15: '* Solo puedes importar escritos propios',
    my_import_book_text16: 'Publicar un minilibro con las páginas convertidas',
    my_import_book_text17: 'Crea la portada del minilibro',
    my_import_book_text18: 'Elige las páginas que deseas añadir',
    my_import_book_text19: 'Publica el minilibro',
    my_import_book_text20: 'Lee las instrucciones cuidadosamente',
    my_import_book_text21: 'El archivo no es ZIP',
    my_import_book_text22: 'Sube un archivo',
    my_journey_title: 'Mi Viaje',
    my_journey_button_message: 'Mensaje',
    my_journey_button_memo: 'Memo',
    my_journey_button_record: 'Guardar',
    my_journey_button_follow: 'Seguir',
    my_journey_button_follow_cancel: 'dejar de Seguir',
    my_journey_message_text1: 'Dejar un mensaje',
    my_journey_message_placeholder: 'Ingrese su mensaje',
    my_journey_message_message1: 'No se puede responder',
    my_journey_message_message2: 'Enviar',
    my_journey_message_message3: 'Ingrese su mensaje',
    my_journey_memo_total: 'Total',
    my_journey_record_overall: 'Clasificación de influencia',
    my_journey_record_text1: 'Páginas vistas',
    my_journey_record_text2: 'Minilibros favoritos',
    my_journey_record_text3: 'Espacio para eventos favorito',
    my_journey_record_text4: 'Páginas escritas',
    my_journey_record_text5: 'Minilibros escritos',
    my_journey_record_text6: 'Espacio para eventos que creé',
    my_journey_record_text7: 'Este mes',
    my_journey_record_text8: 'Minilibro comprado',
    my_journey_record_text9: 'Público',
    my_journey_record_text10: 'Privado',
    my_journey_record_text11: 'Evento comprado',
    my_journey_record_text12: 'El evento que creé',
    my_journey_record_text13: 'uesto #{userRank} en la categoría {userLanguage}',
    my_journey_record_text14: 'Minilibro con derechos de publicación',
    my_journey_record_text15: '¿Quieres que los lectores lean en un orden específico? Si es así, arrastra la portada para cambiar el orden.',
    my_journey_record_text16: 'Apoya el nuevo minilibro',
    my_journey_record_text17: 'Mensajes de apoyo de los lectores',
    my_journey_record_text18: 'Deja un mensaje de apoyo para el autor',
    my_journey_record_text19: 'Nivel de apoyo',
    my_journey_record_text20: 'Nivel {cheeringLevel} de 10',
    my_journey_record_text21: 'Personas a las que apoyo',
    my_journey_record_text22: 'Mis seguidores',
    my_journey_record_text23: '¿Deseas borrarlo?',
    my_journey_record_text24: 'seguidor de {userName}',
    my_journey_record_text25: 'apoyado por {userName}',
    my_notice_title: 'Notificación',
    my_notice_message1: 'No hay nuevas notificaciones',
    my_notice_text1: 'Ha sido publicado un nuevo Minilibro',
    my_notice_text2: 'Hay un nuevo Tema del día',
    my_notice_text3: 'Un nuevo mensaje a Mi viaje',
    my_notice_text4: 'Un nuevo comentario a mi Memo',
    my_notice_text5: 'Nuevo comentario en mi espacio para eventos',
    my_notice_text6: 'Un nuevo comentario a mi portada del Minilibro',
    my_notice_text7: 'Un nuevo comentario a mi página Minilibro',
    my_notice_text8: 'publicó un nuevo Memo',
    my_notice_text9: '{userName} ha creado un nuevo espacio para eventos',
    my_notice_text10: 'publicó un nuevo Minilibro',
    my_notice_text11: 'compró mi minibook',
    my_notice_text12: '{userName} ha creado un <b>nuevo evento</b>',
    my_notice_text13: '{userName} te ha invitado especialmente a <b>este nuevo evento</b>. ¡No te lo pierdas! ',
    my_notice_text14: '{userName} ha <b>comprado mi evento</b>',
    my_notice_text15: '{userName} ha solicitado ser coautor',
    my_notice_text16: 'La solicitud de coautoría para el minilibro abierto ha sido aprobada',
    my_notice_text17: 'Un nuevo comentario ha sido publicado por un coautor',
    my_notice_text18: 'Ha llegado un mensaje para apoyar el nuevo minilibro',
    my_notice_text19: '{userName} patrocinó <b>mi minilibro</b>',
    my_marketing_banner_title: 'Anímate',
    my_marketing_banner_text1: 'Has superado dificultades, ahora apóyate',
    my_marketing_banner_btn: 'Anímate ahora',
    my_marketing_title: 'Anímate ahora',
    my_marketing_text1: 'Coloca dos alas: el minilibro y el evento – y usa la promoción por etapas como combustible – conviértete en influencer',
    my_marketing_text2: 'Correo electrónico a lectores generales',
    my_marketing_text3: 'Mensaje de texto a lectores generales',
    my_marketing_text4: 'Correo electrónico a amigos',
    my_marketing_text5: 'Mensaje de texto a amigos',
    my_marketing_text6: 'Enlace en redes sociales',
    my_marketing_btn: 'Empezar ahora',
    my_marketing_minibook_step1_title: 'Apoyo al Minilibro',
    my_marketing_step1_subtitle: 'Enlace en redes sociales',
    my_marketing_minibook_step1_text1: 'Enlaza tu minilibro en tus redes sociales y añade una descripción atractiva',
    my_marketing_minibook_text1: 'Busca el minilibro',
    my_marketing_step1_text1: 'Copia el enlace',
    my_marketing_step1_btn: 'Copiar',
    my_marketing_step1_text2: 'Pega en redes sociales y añade una descripción',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'Seleccione el minilibro para compartir',
    my_marketing_step1_text4: 'Enlace copiado',
    my_marketing_step1_text5: 'Seleccione el evento para compartir',
    my_marketing_step1_text6: 'Buscar en redes sociales',
    my_marketing_event_step1_title: 'Apoyo al Evento',
    my_marketing_event_step1_text1: 'Enlaza tu evento en tus redes sociales y añade una descripción atractiva',
    my_marketing_event_text1: 'Busca el evento',
    my_marketing_event_search_title: 'Buscar evento',
    my_marketing_minibook_step2_title: 'Marketing de Minilibro: Paso 2',
    my_marketing_step2_subtitle: 'Mensaje de texto a amigos',
    my_marketing_minibook_step2_text1: 'Envía a tus amigos el enlace del minilibro con una presentación personal',
    my_marketing_step2_text2: 'Envía una presentación con el enlace al amigo',
    my_marketing_step2_placeholder: 'Escribe tu presentación',
    my_marketing_tab_text1: 'Mis amigos',
    my_marketing_event_step2_title: 'Marketing de Evento: Paso 2',
    my_marketing_event_step2_text1: 'Envía a tus amigos el enlace del evento con una presentación personal',
    my_marketing_minibook_step3_title: 'Marketing de Minilibro: Paso 3',
    my_marketing_step3_subtitle: 'Correo electrónico a amigos',
    my_marketing_minibook_step3_text1: 'Comparte con tus amigos el enlace del minilibro junto con su historia de fondo',
    my_marketing_step3_text1: 'Importa lista de contactos',
    my_marketing_step3_placeholder: 'Subir archivo csv o vcf',
    my_marketing_step3_text2: 'Comparte la historia y el enlace con tu amigo',
    my_marketing_step3_text3: 'Importa tu lista de números de teléfono',
    my_marketing_step3_placeholder2: 'Comparte la historia',
    my_marketing_event_step3_title: 'Marketing de Evento: Paso 3',
    my_marketing_event_step3_text1: 'Comparte con tus amigos el enlace del evento junto con su historia de fondo',
    my_marketing_text7: 'Importar números de teléfono',
    my_marketing_title2: 'Gestionar números de teléfono',
    my_marketing_text8: 'Teléfono',
    my_marketing_text9: 'Veces',
    my_marketing_text10: 'Importar contactos',
    my_marketing_text11: 'Por favor, sube un archivo csv o vcf',
    my_marketing_text12: 'Cómo importar',
    my_marketing_text13: 'Importar',
    my_marketing_title3: 'Gestionar contactos',
    contact_manage: 'Gestión de Contactos',
    my_marketing_text14: 'Eliminar seleccionados',
    my_marketing_text15: 'Selecciona un amigo',
    my_marketing_text16: 'Puedes seleccionar hasta 100 amigos',
    my_marketing_text17: 'Carga completada',
    my_marketing_text18: 'Se superó el límite de caracteres',
    contact_phone: 'Teléfono',
    contact_organization: 'Organización',
    contact_title: 'Cargo',
    contact_memo: 'Nota',
    my_marketing_text19: 'Editar selección',
    my_marketing_text20: 'Seleccionar etiqueta',
    my_marketing_text21: 'Añadir nueva etiqueta',
    my_marketing_text22: 'Eliminar etiqueta seleccionada',
    my_marketing_text23: 'Añadir',
    my_marketing_btn2: 'Edición completada',
    my_marketing_text24: 'Selecciona un contacto para editar',
    my_marketing_text25: 'Selecciona una etiqueta para eliminar',
    my_marketing_text26: 'Introduce un nombre de etiqueta',
    my_marketing_text27: 'Esta etiqueta ya existe',
    my_marketing_text28: 'Agregar etiqueta',
    my_marketing_text29: 'Cancelar',
    my_marketing_text30: 'Agregado',
    my_benefit_text1: 'Has ganado hasta ahora',
    my_benefit_text2: 'Ganarás en un año',
    my_benefit_text3: '',
    my_benefit_text4: 'Cálculo de ganancias',
    my_benefit_text5: 'Cálculo de ganancias',
    my_benefit_text6: '¿Desea comprobarlo?',
    my_benefit_modal_text1: 'Lo que ha ganado hasta ahora',
    my_benefit_modal_text2: 'EUR',
    my_benefit_modal_text3: 'Usted ha ganado',
    my_benefit_modal_text4: 'Hagamos un cálculo muy simple',
    my_benefit_modal_text5: 'Número de páginas leídas hasta ahora',
    my_benefit_modal_text6: 'Precio de cada página',
    my_benefit_modal_text7: 'EUR',
    my_benefit_modal_text8: 'Así que su ganancia es',
    my_benefit_modal_text9: 'Ahora añada los beneficios de las conversaciones con la',
    my_benefit_modal_text10: 'IA y sus ganancias serán aún mayores',
    my_benefit_modal_text11: 'Úselo todos los días y colecte las ganancias',
    my_benefit_modal_text12: 'OK, entendido',
    my_story_text1: 'Lo que dicen los miembros',
    my_story_text2: 'Darse cuenta de que los libros se experimentan, no se leen',
    my_story_text3: 'Es increíble lo que sucede cuando se aprende todos los días',
    my_story_text4: 'Las trampas ocultas de la gente inteligente ¿eres uno de ellos?',
    my_story_text5: 'Ver más de la historia de los miembros',
    my_go_blog_text1: 'YouBook, Noticias y Historias de Clientes',
    my_go_blog_text2: 'Descubre las últimas noticias y historias de clientes de YouBook',
    my_go_blog_text3: 'Ver más',
    my_channel_text1: '¿Qué opinas de YouBook?',
    my_channel_text2: 'Dinos qué es bueno y qué podemos mejorar',
    my_channel_text3: 'Y dinos si tienes alguna pregunta',
    my_channel_text4: 'Dinos algo',
    my_about_youbook_text1: 'Por qué usar YouBook',
    my_about_youbook_text2: 'Todas tus preguntas y respuestas',
    my_about_youbook_text3: 'Condiciones del servicio',
    my_app_text1: 'YouBook es una aplicación 100% provechosa.',
    my_app_text2: 'Descárgatela ahora y adquiere conocimientos',
    my_app_text3: 'Descargar app',
    login_title: 'INICIO SESIÓN',
    login_text1: 'INICIO sesión con email',
    login_text2: '¿Aún no estás registrado?',
    login_text3: '¿Ha olvidado su contraseña?',
    login_text4: 'o INICIAR SESIÓN con',
    login_text5: 'Acepto',
    login_placeholder1: 'Correo electrónico de inicio de sesión',
    login_placeholder2: 'Contraseña',
    login_placeholder3: 'ID',
    login_message1: 'Por favor, introduce tu correo electrónico',
    login_message2: 'Ingrese su contraseña',
    login_message3: 'Inicio sesión correcto',
    login_message4: 'Por favor, introduce tu ID',
    logout_message1: '¿Desea cerrar sesión?',
    login_link1: 'Registrarse',
    login_link2: 'Encontrar',
    login_link3: 'Condiciones de uso',
    register_title: 'Registrarse',
    register_text1: 'Registrarse con correo electrónico',
    register_text2: 'Seleccione el tipo de afiliación',
    register_text3: 'Personal',
    register_text4: 'Organización',
    register_text5: 'Ingrese sus datos',
    register_text6: '¿Ya está registrado?',
    register_text7: 'Número de registro de la corporación',
    register_text8: 'Número de registro empresarial',
    register_text9: 'Nombre de la organización',
    register_placeholder1: 'Su número de teléfono, incluido el prefijo',
    register_placeholder2: '( sin - )',
    register_placeholder_repassword: 'Reingresa la contraseña',
    register_message1: 'Ingrese su número de teléfono',
    register_message2: 'Ingrese el número de registro de la corporación',
    register_message3: 'Ingrese el número de registro empresarial',
    register_message4: 'Por favor ingrese el nombre de la organización',
    register_message5: 'Formato de correo electrónico no válido',
    register_message6: 'Este correo electrónico ya está registrado',
    register_message7: 'Por favor, verifique su correo electrónico',
    register_message8: 'Seleccione su nacionalidad',
    register_message9: 'Formato de ID no válido',
    register_message10: 'El ID ingresado no está disponible. Usa uno sugerido o ingresa otro',
    register_message11: 'Por favor, verifica tu ID',
    register_message12: 'Este ID ya está en uso. Usa un ID sugerido o introduce uno diferente',
    register_button_verify: 'Verificar',
    register_button_verify_fail: 'No verificado',
    register_button_verify_success: 'Verificado',
    register_welcome_message: 'Bienvenido a su membresía',
    withdraw_text1: 'Cancelación de Membresía',
    withdraw_text2: 'Cancelar Membresía de YouBook',
    withdraw_text3: '¿Estás seguro de que deseas cancelar?',
    withdraw_text4: 'No',
    withdraw_text5: 'Sí',
    withdraw_text6: 'Ha cancelado su membresía con éxito',
    home_memo_title: 'Memo',
    home_memo_subtitle: 'Si no escribes un memo, te olvidas',
    home_memo_text1: 'Compartido juntos por todos',
    home_memo_text2: 'Conocimiento e historias cotidianas',
    home_memo_button: 'Dejar memo',
    home_memo_create_text1: '¿Tienes un minilibro para enlazar?',
    home_memo_create_button: 'Buscar minilibro',
    home_memo_create_button2: 'Seleccionar',
    home_memo_click: 'Haga clic en',
    home_memo_date: 'YYYY. MM. DD',
    home_memo_button_askai: 'Comentario / Pensamientos de Gatito Libro',
    home_memo_view_detail: 'Ver detalles',
    home_memo_view_placeholder: 'Ingresar un post',
    home_memo_view_button1: 'Comentar',
    home_memo_view_button2: 'Pensamientos de Gatito Libro',
    home_memo_view_errormessage: 'Ingresar un mensaje',

    memo_create_title: 'Memo',
    memo_create_category1: 'Memo',
    memo_create_category2: 'Memo',
    memo_create_private: 'Privado',
    memo_create_public: 'Público',
    memo_create_placeholder1: '¿Tienes una idea?',
    memo_create_placeholder2: 'Escríbela ahora',
    memo_create_placeholder3: 'Palabras clave (coloca un espacio en blanco entre ellas)',
    memo_create_button: 'Guardar',
    memo_create_error: 'Ingrese su memo',
    memo_attach_img: 'Subir imagen',
    memo_alert_rate: 'Seleccione su clasificación por estrellas',
    memo_alert_save: 'Guardado. Puedes comprobarlo en Mi perfil - Mi viaje',
    memo_input_placeholder: '¿Qué has aprendido?',
    memo_input_placeholder2: '¿Qué piensas?',
    memo_input_placeholder3: 'Compártelo con tus lectores~',
    memo_input_placeholder4: '¿Un recuerdo de la vida diaria, lo guardamos?',
    memo_alert_keywords: 'Ingresar palabras clave',
    memo_related_text: 'Memo',
    memo_related_date: 'YYYY. MM. DD',
    memo_popup_text1: 'La historia de Nicholas Luhmann parece una fábula moderna que muestra el poder transformador de un simple hábito.',
    memo_popup_text3: 'Al principio, Luhmann era un joven empleado en una corporación alejada del mundo académico.',
    memo_popup_text4: 'Sin embargo, su voraz apetito por la lectura le llevó a una práctica poco habitual: tomar notas diariamente de sus lecturas.',
    memo_popup_text5: 'Este hábito culminó en un artículo que llamó la atención de un reputado sociólogo Alemán y que dio un giro inesperado a su carrera.',
    memo_popup_text6: 'Luhmann fue invitado a formar parte del profesorado de la Universidad de Bielefeld, donde llegó a ser catedrático.',
    memo_popup_text7: 'A lo largo de su carrera escribió la impresionante cifra de 60 libros y numerosos artículos que consolidaron su estatus de luminaria de la sociología.',
    memo_popup_text8: 'Luhmann atribuía sus proezas intelectuales a su metódico hábito de tomar apuntes.',
    memo_popup_text9: 'No paraba de tomar notas',
    memo_popup_text10: 'lo que le ayudó a organizar sus pensamientos y profundizar en sus conocimientos.',
    memo_popup_text11: 'Este relato nos recuerda las limitaciones de la memoria y el valor de capturar y revisar sistemáticamente los conocimientos para hacerlos realmente propios.',
    memo_popup_btn: 'Sí, me identifico',
    memo_text1: 'Puede guardar lo anterior',
    memo_text2: '(Sólo tiene que añadir palabras clave)',
    memo_text3: 'Cosas a verificar al escribir',
    memo_text4: 'Tu publicación viola las regulaciones de contenido del Artículo 2, Sección 1 de las Condiciones del servicio. No será publicada.',
    memo_text5: 'Ver las Condiciones del servicio',
    memo_text6: 'Para dejar un memo en otro idioma, ',
    memo_text7: 'escribe en ese idioma (no se traduce automáticamente)',
    book_create_button: 'Hacer un Minilibro',
    book_create_title: 'Hacer un portada',
    book_create_cover: 'portada',
    book_create_text1: 'Paso para hacer una portada para un Minilibro',
    book_create_text1_pc: 'Ingrese el título y el nombre del autor',
    book_create_text2: 'Todavía no has creado una imagen de portada',
    book_create_text3: '',
    book_create_text4: 'Acá tienes la imagen de portada que has creado',
    book_create_text5: '¿Has creado su propia portada?',
    book_create_text6: 'Por favor, cárguela utilizando el botón de abajo',
    book_create_text7: '(formato jpg de menos de 20M de tamaño)',
    book_create_text8: 'Derecho a añadir páginas',
    book_create_text9: 'sólo yo',
    book_create_text10: 'cualquiera',
    book_create_text11: 'Añadir títulos a imágenes',
    book_create_text12: 'Mostrar',
    book_create_text13: 'No mostrar',
    book_create_text14: 'Seleccione los idiomas que desea traducir',
    book_create_text15: 'Seleccionar todo',
    book_create_text16: 'Subir imagen de portada',
    book_create_text17: 'Se puede modificar',
    book_create_text18: 'Después de modificar, haga clic en el ícono en la parte superior derecha para volver a traducir',
    book_create_text19: 'Si desea volver a traducir según el original, haga clic en el ícono en la parte superior derecha',
    book_create_text20: 'Volver a traducir',
    book_create_text21: 'Imagen',
    book_create_text22: 'Título',
    book_create_text23: 'Palabra clave',
    book_create_text24: 'Contenido',
    book_create_text25: 'La traducción solo se actualizará si la imagen se elimina y se vuelve a cargar',
    book_create_text26: '(La página no se eliminará)',
    book_create_text27: 'Escriba una breve introducción',
    book_create_text28: 'Guardado temporal',
    book_create_text29: 'Guardado temporalmente',
    book_create_text30: 'Elementos a revisar',
    book_create_text31: 'El contenido del texto es la versión final y no necesita más modificaciones',
    book_create_text32: 'No se han utilizado palabras o símbolos que la IA de traducción no pueda entender',
    book_create_text33: 'La imagen no se copió ni pegó, sino que se ingresó como un archivo separado',
    book_create_text34: '¿Abrir convocatoria? (Minilibro abierto)',
    book_create_text35: 'Coautores',
    book_create_text36: '¿Agregar manualmente?',
    book_create_text37: 'Añadir',
    book_create_text38: 'Un minilibro que se difunde más cuando se escribe juntos',
    book_create_text39: 'El poder de los coautores que no conocías',
    book_create_text40: 'Abrir convocatoria',
    book_create_text41: 'Cancelar',
    book_create_text43: '¿Idea?',
    book_create_text44: 'Copiar y pegar contenido',
    book_create_text45: '¿Necesitas una idea?',
    book_create_text46: 'Opciones de venta',
    book_create_text47: 'Gratis',
    book_create_text48: 'Patrocinador',
    book_create_text49: 'Comprar',
    book_create_text50: 'Precio actual',
    book_create_text51: 'Editar precio',
    book_create_text52: 'No se puede establecer en 0',
    book_create_text53: 'Los minilibros comprados o patrocinados no pueden cambiar precio u opciones de venta',
    book_create_text54: 'Solo el autor del minilibro puede responder a los mensajes',
    book_create_button_upload: 'Cargar',
    book_create_button_make: 'Crear',
    book_create_cover_topic_placeholder: 'El título tendrá este aspecto',
    book_create_topic_placeholder: 'Ingrese un título',
    book_create_keyword_placeholder: 'Palabras clave (coloca un espacio en blanco entre ellas)',
    book_create_category_placeholder: 'Seleccionar categoría',
    book_create_knowledge_placeholder: 'Escriba una introducción a su Minilibro   ** Atención - Escriba los detalles en el paso para hacer páginas',
    book_create_category_option1: 'Películas y Dramas',
    book_create_category_option2: 'Música y Baile',
    book_create_category_option3: 'Otras Artes',
    book_create_category_option4: 'Vestuario y Estilo',
    book_create_category_option5: 'Comida y Cocina',
    book_create_category_option6: 'Alcohol y Bebidas',
    book_create_category_option7: 'Snacks y Postres',
    book_create_category_option8: 'Plantas y Salud',
    book_create_category_option9: 'Hacerse Rico',
    book_create_category_option10: 'Desarrollo Personal',
    book_create_category_option11: 'Relaciones',
    book_create_category_option12: 'Nuevos Conocimientos',
    book_create_category_option13: 'Historias de Vida',
    book_create_category_option14: 'Filosofía y Valores',
    book_create_category_option15: 'Religión y Tradiciones',
    book_create_category_option16: 'Amor',
    book_create_category_option17: 'Viajes y Atracciones',
    book_create_category_option18: 'Hobbies',
    book_create_category_option19: 'Cultura de Juegos',
    book_create_category_option20: 'Mitos y Héroes',
    book_create_category_option21: 'Viajes Literarios',
    book_create_category_option22: 'Historia y Sabiduría',
    book_create_category_option23: 'Historias Sociales',
    book_create_category_option24: 'Conocimientos Generales',
    book_create_message1: 'Ingrese un título',
    book_create_message2: 'Ingrese el nombre de un autor',
    book_create_message3: 'Ingrese palabras clave',
    book_create_message4: 'Ingrese más de 3 palabras clave',
    book_create_message5: 'Seleccionar categoría',
    book_create_message6: 'Crear una portada',
    book_create_message7: 'No puede ingresar caracteres especiales. Se requiere un espacio en blanco entre palabras clave.',
    book_create_message8: '¿Desea borrar el Minilibro?',
    book_create_message9: 'No tiene derecho a publicar este idioma',
    book_create_message10: 'Un minilibro comprado no se puede eliminar',
    book_create_modal_text1: 'Por favor, espere un momento..',
    book_create_modal_text2: 'La IA está revisando el contenido, traduciendo idiomas extranjeros y conectando la red de conocimiento',
    book_create_modal_text3: 'Conexión a la base de conocimientos para la búsqueda página por página',
    book_create_modal_text4: 'El título no aparece en la imagen de portada',
    book_create_modal_text5: '(Esto también se aplica a las portadas traducidas a otros idiomas)',
    book_view_title: 'Vista general del Minilibro',
    book_view_share: 'Compartir',
    book_view_event_topic: 'Tema del evento',
    book_view_together_suggest: 'Sugerir espacio para eventos',
    book_view_together_message: 'Si no tiene un Juntos favorito,<br />vaya al menú Juntos y elija uno',
    book_view_event_message: 'No he creado ningún evento',
    book_view_text1: 'No se ha añadido ninguna página.',
    book_view_text2: '¿Quisieras añadir una ahora?',
    book_view_text3: 'El Minilibro no existe. Por favor, inténtalo de nuevo.',
    book_view_text4: 'Tabla de páginas',
    book_view_text5: 'Qué te parece mejorar la traducción de este minilibro o promocionarlo y compartir las ganancias?',
    book_view_text6: 'Lista de páginas',
    book_view_text7: 'Modificar el precio',
    book_view_text8: 'No se puede modificar porque ya hay un comprador',
    book_view_text9: 'Regalo del lector',
    book_view_text10: 'Solo el autor del minilibro puede responder a los mensajes',
    book_view_modal_title: 'Mejora de Traducción y Promoción',
    book_view_modal_text1: '¿Puedes mejorar la traducción de este minilibro por tu cuenta? ¿O promocionarlo?',
    book_view_modal_text2: 'Deja un mensaje al autor',
    book_view_modal_text3: 'Si el autor lo permite, pueden compartir los ingresos',

    book_view_write_share_title: 'Minilibro abierto',
    book_view_write_share_text1: '¿Quieres ser coautor de este minilibro?',
    book_view_write_share_text2: 'Solicitar autoría',
    book_view_write_share_text3: 'Deja una solicitud sencilla',
    book_view_write_share_text4: 'Enviar',
    book_view_write_share_list_title: 'Coautores',
    book_view_write_share_text5: 'Gestiona los coautores del minilibro',
    book_view_write_share_text6: 'Gestionar autores',
    book_view_write_share_text7: 'Aceptar',
    book_view_write_share_text8: 'Aceptado',
    book_view_write_share_text9: 'El usuario ya está registrado como autor',
    book_view_write_share_text10: 'Agregar autor manualmente',
    book_view_write_share_text11: 'El usuario ya ha solicitado',
    book_view_publish_text1: '¿Le gustaría publicar este Minilibro?',
    book_view_publish_text2: 'Publicarlo lo hace accesible a todo el mundo e incluso puedes ganar dinero con él.',
    book_view_publish_text3: '(Si publica para la venta no puede incluir otras páginas del autor)',
    book_view_publish_text4: 'Fije un precio',
    book_view_publish_text5: 'Fecha de publicación',
    book_view_publish_text6: 'Solicitar publicación',
    book_view_publish_text7: 'Pub instantánea',
    book_view_publish_text8: 'Reservas',
    book_view_publish_text9: 'Solicitud',
    book_view_publish_text10: 'En curso',
    book_view_publish_text11: 'Publicado',
    book_view_publish_text12: 'Cosas a comprobar al publicar',
    book_view_publish_text13: 'Este Minilibro nunca ha sido publicado antes en YouBook',
    book_view_publish_text14: 'Este minilibro y sus páginas no han robado contenido ni infringido la propiedad intelectual de otros',
    book_view_publish_text15: 'Este minilibro no contiene lenguaje vulgar, contenido sexual excesivo, difamación hacia otros ni publicidad comercial y cumple con el Artículo 2, Cláusula 1 de los Términos de Uso',
    book_view_publish_text16: 'Sí',
    book_view_publish_text17: 'Informe de publicación',
    book_view_publish_text18: 'Publicado',
    book_view_publish_text19: 'Fecha',
    book_view_publish_text20: 'Precio',
    book_view_publish_text21: 'Definir el período abierto',
    book_view_publish_text22: 'Período abierto',
    book_view_publish_text23: '¿Qué es un período abierto',
    book_view_publish_text24: 'El período abierto se refiere al tiempo durante el cual los lectores pueden ver el contenido',
    book_view_publish_text25: 'Este minilibro contiene más de 3 páginas',
    book_view_publish_text26: 'Este minilibro no contiene más de 3 páginas',
    book_view_publish_text27: 'Si se detectan infracciones, el algoritmo puede ajustar la clasificación de búsqueda. En casos graves, el minilibro se eliminará automáticamente',
    book_view_publish_text28: 'Establecer opciones de venta',
    book_view_publish_text29: 'Método de compra',
    book_view_publish_text30: 'Método de patrocinio',
    book_view_publish_message1: 'Si publica para la venta asegúrese de que  1) las páginas de su Minilibro han sido realizadas por usted y  2) no las ha publicado previamente por un precio.',
    book_view_publish_message2: 'No está en estado publicable. Póngase en contacto con el administrador para obtener ayuda',
    book_view_publish_message3: 'Este Minilibro ya ha sido publicado',
    book_view_publish_message4: 'Por favor, seleccione el período abierto después de la hora actual',
    book_view_publish_message5: 'Por favor, seleccione tanto la fecha como la hora',
    book_view_publish_message6: 'La publicación ha sido aprobada. Muchas gracias',
    book_view_publish_message7: 'Compruebe los elementos de confirmación',
    book_view_publish_message8: 'La fecha de finalización no puede ser anterior a la fecha de inicio',
    book_view_publish_message9: 'Un minilibro guardado temporalmente no se puede publicar',
    book_view_publish_message10: 'Este minilibro ha sido transferido. El derecho de publicación original pertenece al autor.',
    book_view_publish_message11: 'Por favor, ingrese una cantidad mínima de {minPrice}',
    book_view_button_confirm: 'Confirmado',
    book_view_button_publish: 'Publicar',
    book_view_button_order: 'Alineación de página',
    book_view_button_add: 'Añadir una página',
    book_view_button_video: 'Ver vídeo',
    book_view_button_read: 'Leer',
    book_view_button_lecture: 'Ver vídeo de conferencia',
    book_view_page_add_title: 'Añadir una página',
    book_view_page_add_text1: 'Después de buscar una página de Tercero',
    book_view_page_add_text2: 'En la pantalla Ver página',
    book_view_page_add_text3: 'Poner en mi Minilibro',
    book_view_page_add_text4: '¿Y si quieres crear tu propia página?',
    book_view_page_add_text5: 'La creación de páginas sólo está disponible para autores registrados.  Si desea registrarse como autor, póngase en contacto con nosotros.',
    book_view_page_add_text6: '¿Deseas añadir una página de Tercero?',
    book_view_page_add_text7: '* Si añades una página creada por un Tercero, \nno se puede publicar como un minilibro de pago',
    book_view_page_add_text8: '¿Ya has creado páginas antes?',
    book_view_page_add_button1: 'Crear ahora',
    book_view_page_add_button2: 'Ver Páginas escritas',
    book_view_reference_text1: 'Diversidad',
    book_view_reference_text2: 'Varios',
    book_view_reference_text3: 'Autor del Minilibro',
    book_view_reference_text4: 'Creado por el autor',
    book_view_support_text1: 'Te apoyo',
    book_view_support_modal_title: 'Conviértete en un apoyo',
    book_view_support_modal_text1: 'Incluso un buen texto es difícil de difundir por sí solo.',
    book_view_support_modal_text2: 'Un apoyo es alguien que comparte el minilibro del autor con el mundo y apoya a los demás.',
    book_view_support_modal_text3: 'Juntos podemos hacer que esta historia llegue más lejos.',
    book_view_support_modal_text4: 'Por favor, apoya al autor',
    book_view_support_modal_btn1: 'Entendido',
    book_view_support_modal_text5: '"Tu apoyo significa mucho para mí. Gracias. Yo también apoyaré tu viaje con todo mi corazón."',
    book_view_support_modal_text6: 'Por favor, comparte el minilibro con el mundo',
    book_view_support_modal_btn2: '¿Cómo lo hago?',
    book_view_support_modal_title2: 'Hasta aquí llegué, buen trabajo',
    book_view_support_modal_text7: 'No fue fácil escribir, pero lo logré.',
    book_view_support_modal_text8: 'Ahora es momento de confiar en mí mismo y dar un paso más.',
    book_view_support_modal_text9: 'Aunque me sienta tímido o dudoso, me convierto en mi primer apoyo y me abro al mundo.',
    book_view_support_modal_text10: 'Porque creo que puede significar algo para alguien.',
    book_view_support_modal_text11: 'Por favor, conviértete en mi apoyo',
    book_view_support_modal_text12: 'Escribir o hacer un evento no fue fácil, pero acepté el reto.',
    book_view_support_modal_btn3: '¡Lo intentaré!',
    book_view_support_modal_title3: 'Hola, seguidor',
    book_view_open_minibook_text1: 'La solicitud de Minilibro abierto se ha completado',
    book_view_open_minibook_text2: 'La solicitud de Minilibro abierto ha sido cancelada',
    page_create_title: 'Crear una página',
    page_create_text1: 'No has creado ninguna imagen de página',
    page_create_text2: '',
    page_create_text3: 'página',
    page_create_text4: 'Acá tiene la imagen de página creada',
    page_create_text5: '¿Ha creado una imagen de página?',
    page_create_text6: 'Ingrese su contenido.\nNo se recomienda más de una hoja A4.',
    page_create_text7: 'Bytes actuales',
    page_create_text8: 'Recomendar',
    page_create_text9: '¿Alguna referencia en esta página?',
    page_create_text10: 'Creada por usted',
    page_create_text11: 'Libro referenciado',
    page_create_text12: 'Blog de referencia',
    page_create_text13: 'Se consultó IA',
    page_create_text14: 'Este es el paso para crear páginas para el Minilibro',
    page_create_text15: 'Subir imagen de página',
    page_create_text16: '¿Quieres volver a traducir?',
    page_create_text17: 'Si deseas volver a traducir, selecciona el objetivo y el idioma (si no se selecciona, se guardará sin traducción)',
    page_create_text18: 'Objetivo de la traducción',
    page_create_text19: 'Idioma de la traducción',
    page_create_message1: 'No se puede modificar',
    page_create_message2: 'Ingrese su contenido',
    page_create_message3: '¿Quieres borrar la página?',
    page_create_message4: 'El contenido excede el tamaño máximo',
    page_create_reference_book: 'libro',
    page_create_reference_blog: 'blog',
    page_create_reference_placeholder1: 'Ingrese el título del',
    page_create_reference_placeholder2: 'Enlace relacionado (por ejemplo, https://www.amazon.com/dp...)',
    page_create_reference_placeholder3: 'Año de publicación',
    page_create_reference_placeholder4: 'Autor del',
    page_create_title_placeholder: 'El título tendrá este aspecto',
    page_create_message5: 'Traducción en curso',
    page_create_message6: 'Después de crear la portada, puedes crear una página',
    page_create_modal_text1: 'El título no aparece en la imagen de la página',
    page_create_modal_text2: '(Esto también se aplica a las páginas traducidas a otros idiomas)',
    page_create_modal_text3: '¡Por favor, asegúrate de revisar!',
    page_create_modal_text4: 'Si el contenido ha cambiado, debe guardado temporal.',
    page_create_modal_text5: '¿Lo hiciste?',
    page_create_modal_text6: 'Si el contenido ha cambiado, debe crear.',
    page_view_title: 'Ver página',
    page_view_button_video: 'Ver vídeo',
    page_view_button_read: 'Leer',
    page_view_text1: 'MiniLibroIn',
    page_view_text2: 'Reproducción automática',
    page_view_text3: 'Lecturas',
    page_view_text4: 'Página relacionada',
    page_view_text5: 'Minilibro relacionado',
    page_view_text6: 'Referencia',
    page_view_text7: 'Referencia',
    page_view_text8: 'Publicación',
    page_view_text9: 'Autor',
    page_view_text10: 'Título',
    page_view_text11: 'Todas las páginas de esta ref.',
    page_view_text12: 'Búsqueda relacionada',
    page_view_text13: 'Autor de la página',
    page_view_text14: 'Conocer al autor',
    page_view_text15: 'Poner en',
    page_view_reference_text1: 'Libro',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'No tienes ningún Minilibro creado por ti. Puedes crear uno en MI página.',
    page_view_pay_popup_text1: '¿Obtuviste algo al leer? \nResponde con un pequeño regalo para el autor.',
    page_view_pay_popup_title: 'Enviar un regalo',
    page_view_pay_popup_text2: 'Elige un té para enviar como regalo',
    page_view_pay_popup_text3: 'Escribe un mensaje con el corazón',
    page_view_pay_popup_placeholder1: 'Las palabras y la sabiduría del autor me ayudaron de verdad.',
    page_view_pay_popup_text4: 'Monto',
    page_view_pay_popup_button1: 'Comprar y enviar mensaje',
    page_view_pay_popup_text5: 'El autor dedicó mucho tiempo y esfuerzo para escribir esto.\n\nPor favor, responde con un pequeño regalo.',
    page_view_pay_popup_placeholder2: 'Confío en la experiencia y sensibilidad del autor.',
    page_view_pay_popup_text6: '¿No quieres enviar un regalo?',
    page_view_pay_popup_text7: '¿Prefieres ver un anuncio en su lugar?',
    page_view_pay_popup_button2: 'Ver anuncio para leer',
    page_sort_title: 'Alineación de página',
    page_sort_subtitle: 'Arrastre la página para cambiar el orden',
    page_sort_text: 'Fuente',
    pay_button: 'Comprar ahora',
    pay_price: 'Precio',
    pay_vat_excluded: '(IVA no incluido)',
    pay_message_success: 'Comprado',
    pay_message_fail: 'Fallido',
    pay_currency: 'EUR',
    pay_button_paid: 'Pagado',
    pay_button_view_price: 'Ver precio',
    pay_total: 'Total',
    pay_methods: 'Formas de pago',
    pay_methods_creditcard: 'Tarjeta de crédito',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Continuar',
    pay_text1: 'Por favor, selecciona un té',
    pay_text2: 'Por favor, introduce un mensaje',
    advertisement_button: 'Leer más',
    advertisement_text1: 'Puedes ver el contenido después de ver el anuncio.',
    advertisement_text2: 'Esta es una página de un minilibro de pago. <br />Ve a la portada y toca Leer para comprar. <br />',
    advertisement_text3: 'Puedes ver el contenido después de ver el anuncio. El anuncio solo se puede ver en la aplicación.',
    together_title: 'Evento',
    together_subtitle: 'Reúnete y habla con los lectores',
    together_subtitle_text1: 'Conoce a los lectores en línea',
    together_subtitle_text2: 'Crea una sala e invita a la gente',
    together_button: 'Crear espacio para eventos',
    together_case: 'Caso',
    together_case1: 'Intento darlo pero me lo siguen dando',
    together_case2: 'Nunca conocí un ejemplo real tan útil',
    together_subtitle2: 'Espacio que creé',
    together_category1: 'Últimos',
    together_category2: 'Favoritos',
    together_button_viewmore: 'Más',
    together_list_date: 'YYYY.MM.DD',
    together_list_date2: 'YYYY.MM.DD A hh:mm',
    together_subtitle3: 'Un espacio así',
    together_subtitle3_1: 'Por favor créalo',
    together_subtitle_text3: 'Quien empiece yo participaré',
    together_create_title: 'Crear espacio para eventos',
    together_create_title2: 'Editar espacio para eventos',
    together_create_button1: 'Seleccione',
    together_create_subtitle: 'Título',
    together_create_placeholder1: 'Ingrese un título',
    together_create_subtitle1: 'Breve introducción',
    together_create_placeholder2: 'Ingrese una breve introducción',
    together_create_subtitle2: 'Elija qué herramienta utilizar',
    together_create_text1: 'Enlace de reunión en línea (por ejemplo, enlace de Zoom)',
    together_create_placeholder3: 'Por favor, ingrese el enlace de la reunión en línea',
    together_create_question1: '¿No tiene el enlace del zoom?',
    together_create_q1_a_title: 'Buscar un enlace para unirse al zoom',
    together_create_text2: 'Utilizar el metaverso',
    together_create_placeholder4: 'Elige el que mejor se adapte a Juntos',
    together_create_question2: '¿No conoce el metaverso?',
    together_create_text3: 'Elija dónde abrir',
    together_create_dropmenu1: 'Abrir en el rincón intelectual invitado de YB',
    together_create_dropmenu2: 'Abrir en el rincón de autores y lectores',
    together_create_button2: 'Guardar',
    together_create_button3: 'Hacer',
    together_create_popup_title: 'Elija el que mejor se adapte a Juntos',
    together_create_popup_alert: 'Ya elegido',
    together_create_button4: 'Seleccione',
    together_create_alert: 'Por favor, introduzca el enlace para la reunión en línea',
    together_create_alert1: 'Ingrese un título',
    together_create_alert2: 'Elige el metaverso a utilizar',
    together_create_alert3: 'No se puede editar',
    together_create_alert4: 'Espacio para eventos creado',
    together_create_alert5: 'Error. Vuelva a intentarlo',
    together_create_alert6: 'Error al crear el espacio para eventos...',
    together_qa_popup_title1: 'Encuentra un enlace para unirte al Zoom',
    together_qa_popup_btext1: 'Ordenador',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Abra el programa Zoom - Después de iniciar sesión - Haga clic en el menú de la reunión en la parte superior - Mi ID de reunión personal - Haga clic en Mostrar invitación a la reunión - Aparecerá un enlace para unirse a la reunión de Zoom. Cópielo.',
    together_qa_popup_btext2: 'Smartphone',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Abra el programa Zoom - Después de iniciar sesión - Pulsa el botón i en la parte superior derecha - Enviar invitación - Después de pulsar el mensaje - Ingrese su número de teléfono - Aparecerá un enlace. Cópielo.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: '¿Qué es el metaverso?',
    together_qa_popup_text3: 'Es un espacio de encuentro virtual.',
    together_qa_popup_text4: 'Aparece en forma de un avatar',
    together_qa_popup_text5: 'que te has inventado - Habla con tus amigos cara a cara - También puedes compartir tu pantalla.',
    together_qa_popup_text7: 'En un espacio de reunión',
    together_qa_popup_text8: '- Pueden ingresar 10 personas al mismo tiempo.',
    together_qa_popup_text9: 'No es necesario instalar un programa aparte',
    together_qa_popup_text10: 'ni es necesario registrarse.',
    together_more_list_title: 'Espacio para eventos',
    together_more_list_date: 'YYYY. MM. DD',
    together_request_list_title: 'Por favor créalo',
    together_request_list_category1: 'Más favorito',
    together_request_list_category2: 'Último',
    together_request_list_button: 'Sugerir nuevo espacio',
    together_request_popup_title: 'Sugerencia de espacio nuevo',
    together_request_popup_alert1: 'Ingrese un título',
    together_request_popup_alert2: 'Ingrese una breve introducción',
    together_request_popup_placeholder1: 'Ingrese un título',
    together_request_popup_placeholder2: 'Ingrese una breve introducción',
    together_request_popup_button: 'Guardar',
    together_request_detail_button: 'Crear este espacio',
    together_detail_sns: 'Compartir',
    together_detail_enterbtn: 'Ingresar',
    together_detail_btn1: 'Lista de eventos',
    together_detail_btn2: 'Mensaje',
    together_detail_subtitle: 'Minilibro sobre el tema',
    together_detail_alert: 'Espera un momento..',
    together_detail_alert1: '¡Sugerencia de espacio para eventos exitosa!',
    together_detail_alert2: 'Error al sugerir espacio para eventos…',
    together_detail_alert3: 'Favorito / Cancelado favorito con éxito',
    together_detail_alert4: 'Favorito / Error al cancelar favorito',
    together_detail_alert5: 'Problema en el servidor.Por favor intente más tarde',
    together_detail_alert6: 'Hay un problema con el enlace de reunión en línea',
    together_detail_alert7: 'Fallo al borrar',
    together_notice_alert: '¿Quieres borrar el anuncio?',
    together_notice_list_title: 'Anuncio',
    together_button_addtopic: 'Agregar esto como tema del espacio para eventos',
    together_add_alert: 'Agregado al espacio para eventos',
    together_text1: 'Gustos similares a los tuyos',
    together_text2: '¿Deseas eliminar este espacio para eventos?',
    together_event_btn: 'Crear nuevo evento',
    together_event_title: 'Nuevo evento',
    together_event_placeholder: 'Introduce una descripción',
    together_event_text1: 'Establece el horario',
    together_event_text2: 'Establece la tarifa de entrada',
    together_event_text3: 'Establece la capacidad máxima',
    together_event_text4: 'Horario',
    together_event_text5: 'Tarifa de entrada',
    together_event_text6: 'Capacidad máxima',
    together_event_text7: 'Notificar a mis seguidores',
    together_event_text8: '¿Quieres eliminar el evento?',
    together_event_text9: 'Por favor, establece la hora de inicio después de la hora actual',
    together_event_text10: 'Por favor, establece la hora de finalización después de la hora de inicio',
    together_event_text11: 'La hora de inicio y la hora de finalización no pueden ser iguales',
    together_event_text12: 'Agregar esto como tema del evento',
    together_event_text13: 'Agregado al evento',
    together_event_text14: 'El evento ha superado la capacidad máxima',
    together_event_text15: 'Botón se activa 1 hora antes del Evento \n(si es gratis no es necesario Comprar ahora)',
    together_event_text16: 'Botón se activa 1 hora antes del Evento',
    together_event_text17: 'No existe ningún evento',
    together_event_text18: 'No se puede eliminar si hay un comprador para el evento',
    together_event_text19: '¿Quieres enviar una notificación?',
    together_event_text20: 'Enviado',
    together_event_text21: 'Lista de eventos',
    together_event_text22: 'Ver detalles',
    together_event_text23: 'Después de Registrarse inicia sesión',
    together_event_text24: 'Cómo asistir',
    together_event_text25: 'Participación en el evento completada',
    together_event_text26: 'El autor dedicó mucho tiempo y cuidado a este evento.\n\nResponde con un pequeño regalo.',
    together_event_text27: 'La sabiduría del autor y su comunicación profunda fueron impresionantes',
    together_event_text28: 'Comparte este evento con el mundo',
    together_event_text29: 'No fue fácil organizar este evento, pero lo logré.',
    together_event_text30: 'Por muy bueno que sea el evento, es difícil difundirlo solo.',
    together_event_text31: 'Un seguidor es quien transmite el evento del autor al mundo. Son personas que se apoyan entre sí.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Conoce a gente de todo el mundo',
    youbooker_case: 'Caso',
    youbooker_case_text1: 'Ser el que siempre empieza',
    youbooker_case_text2: '¿Efecto de interés compuesto del conocimiento?',
    youbooker_translation: '¿Te gustaría conocer ahora mismo?',
    youbooker_translation_text1: 'Todos los idiomas',
    youbooker_category: 'Me siguen / Yo sigo',
    youbooker_subcategory1: 'Mi seguidor',
    youbooker_subcategory2: 'Estoy siguiendo',
    youbooker_subtitle2: 'Me estan siguiendo',
    youbooker_button_follow: 'Seguir',
    youbooker_message_follow: 'Seguir',
    youbooker_button_follow_cancel: 'Dejar de seguir',
    youbooker_subtitle3: 'Estos son los usuarios que conoces',
    youbooker_subtitle4: 'Estoy siguiendo',
    youbooker_subtitle5: 'Estos aún no conocen a YB',
    youbooker_button_invite: 'Invita a',
    youbooker_alert_invite: 'Invitar sólo es posible a través de la app. Descárgate la app por favor',
    youbooker_alert: 'Sólo en la app. ¿Por qué no descargar la aplicación?',
    youbooker_alert2: '¡Refrescar con éxito!',
    youbooker_alert3: 'Puedes buscar en la pestaña youBooker',
    home_page_text1: 'Más recientes',
    home_page_text2: 'Influencia',
    home_page_today_title: 'Tema del día',
    home_page_today_subtitle: 'Relacionado con noticias TOP',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: 'Tema del día',
    home_page_today_detail_sns: 'Compartir',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: 'Páginas relacionadas',
    home_page_explor_title: 'Exploración de páginas',
    home_page_explor_subtitle: '¿Y si hacemos doble clic?',
    home_page_recommend_title: 'Recomendaciones',
    home_page_recommend_subtitle: 'Páginas que pueden interesarle',
    home_page_theysee_title: 'Qué ven',
    home_page_theysee_subtitle: 'Páginas que más ven los lectores',
    home_page_common_title: 'Sentido común',
    home_page_common_subtitle: 'Preferirías saber esto',
    home_page_keyw_title: 'Páginas por palabras clave',
    home_page_keyw_subtitle: 'Buscar todas las páginas relacionadas',
    home_page_random_title: 'Entrar al azar',
    home_page_random_subtitle: 'Presiona acá si quieres aprender algo nuevo e inesperado',
    home_page_about_title: 'Acerca de YouBook',
    home_page_about_detail: 'Corporación: NICK syndicate  Centro de negocios español: Barcelona   Centro de otros idiomas: Seattle Tokio Shangai Seúl   Contacto: joa@academy-connect.net   DUNS 695937905',
    settlement_title: 'Compra y liquidación',
    settlement_tab1: 'Registro de órdenes',
    settlement_tab2: 'Información de la cuenta',
    settlement_tab3: 'Registro de liquidación',
    settlement_category1: 'Mi registro de compras',
    settlement_category2: 'Compartir derechos de autor',
    settlement_category3: 'Registro de ingresos del minilibro',
    settlement_category4: 'Registro de ingresos del evento',
    settlement_category5: 'Gestión de cuenta',
    settlement_text1: 'Se muestra el registro de compras',
    settlement_text2: 'Puedes compartir los derechos de autor del minilibro',
    settlement_text3: 'Compruebe el registro de liquidación de su Minilibro pagado.',
    settlement_text4: 'Si tiene más preguntas, haga clic',
    settlement_text5: 'aquí',
    settlement_text6: 'O póngase en contacto con nosotros a continuación.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Diga una palabra',
    settlement_text9: 'Si tienes ingresos, debes gestionar tu cuenta para recibir pagos',
    settlement_text10: 'Se liquidan los ingresos obtenidos del evento',
    settlement_purchase_text1: 'Registro de compras',
    settlement_purchase_text2: 'Fecha',
    settlement_purchase_text3: 'Importe de compra',
    settlement_purchase_text4: 'Título',
    settlement_purchase_text5: 'Minilibro',
    settlement_purchase_text6: 'Evento',
    settlement_accountInfo_text1: 'Derechos de autor del minilibro',
    settlement_accountInfo_text2: 'Minilibro',
    settlement_accountInfo_text3: 'Idioma',
    settlement_accountInfo_text4: 'Derechos de autor',
    settlement_accountInfo_text5: 'Autor',
    settlement_accountInfo_text6: 'Tercero',
    settlement_accountInfo_text7: '¿Personal?',
    settlement_accountInfo_text8: 'Personal',
    settlement_accountInfo_text9: 'Corporativo',
    settlement_accountInfo_text10: 'Nombre del banco',
    settlement_accountInfo_text10_message: 'Seleccione un nombre de banco',
    settlement_accountInfo_text11: 'Nombre del titular de la cuenta',
    settlement_accountInfo_text11_message: 'Ingrese el nombre del titular de la cuenta',
    settlement_accountInfo_text12: 'Número de cuenta',
    settlement_accountInfo_text12_message: 'Ingrese un número de cuenta',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Número de la seguridad social',
    settlement_accountInfo_text13_message: 'Ingrese un número de seguridad social',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Dirección personal',
    settlement_accountInfo_text14_message: 'Ingrese una dirección personal',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'Correo electrónico',
    settlement_accountInfo_text15_message: 'Ingrese un correo electrónico',
    settlement_accountInfo_text16: 'Guardar',
    settlement_accountInfo_text17: 'Número de identificación del empleador',
    settlement_accountInfo_text17_message: 'Ingrese un número de identificación del empleador',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Dirección de la corporación',
    settlement_accountInfo_text18_message: 'Ingrese la dirección del empleador',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'Nombre de la corporación',
    settlement_accountInfo_text19_message: 'Ingrese el nombre de la corporación',
    settlement_accountInfo_text20: 'Teléfono de la corporación',
    settlement_accountInfo_text20_message: 'Ingrese los contactos de la corporación',
    settlement_accountInfo_text21: 'ID del tercero',
    settlement_accountInfo_text21_placeholder: 'Correo electrónico del tercero',
    settlement_accountInfo_text22: 'Cuenta para recibir el pago',
    settlement_accountInfo_text23: 'País',
    settlement_accountInfo_message1: 'No se encuentra el correo electrónico',
    settlement_accountInfo_message2: 'No puedes compartir los derechos de autor contigo mismo',
    settlement_accountInfo_message3: 'No hay Minilibros creados',
    settlement_accountInfo_text24: 'Compartir derechos de autor',
    settlement_accountInfo_text25: 'Si compartes los derechos de autor con un tercero, no podrás recuperarlos',
    settlement_accountInfo_text26: '¿Quieres compartir los derechos de autor?',
    settlement_accountInfo_text27: 'Sí, comparto',
    settlement_accountInfo_text28: 'Para compartir derechos de autor,<br /> 1) las páginas del minilibro deben ser creadas por ti y <br />2) no deben haber sido compartidas anteriormente con terceros',
    settlement_accountInfo_text29: 'OK, lo arreglaré',
    settlement_accountInfo_text30: 'Has compartido los derechos de autor de este minilibro con un tercero',
    settlement_accountInfo_text31: 'Autor',
    settlement_accountInfo_text32: 'Tercero',
    settlement_accountInfo_text33: 'Has recibido los derechos de autor de este minilibro del autor.',
    settlement_accountInfo_text34: 'Este es un Minilibro gratuito. No requiere cuenta.',
    settlement_accountInfo_text35: 'Ingresos compartidos',
    settlement_accountInfo_text36: '(yo)',
    settlement_accountInfo_text37: '(editores, etc.)',
    settlement_accountInfo_text38: 'Cuenta personal',
    settlement_accountInfo_text39: 'Cuenta corporación',
    settlement_accountInfo_text40: 'Gestión de cuentas',
    settlement_accountInfo_text41: 'Guardar',
    settlement_accountInfo_text42: 'Banco',
    settlement_accountInfo_text43: 'Selección de cuenta',
    settlement_accountInfo_text44: 'Decidir cómo repartir los ingresos',
    settlement_accountInfo_text45: 'Tasa de ingresos (%)',
    settlement_accountInfo_text46: 'Mi ID (email)',
    settlement_accountInfo_text47: 'ID del tercero (email)',
    settlement_accountInfo_text48: 'Ajustar el total',
    settlement_accountInfo_text49: 'Ingrese la información del cesionario',
    settlement_accountInfo_text50: 'La tasa de ingresos no puede superar 100',
    settlement_accountInfo_text51: 'Cedente ID(email)',
    settlement_accountInfo_text52: 'Cesionario ID(email)',
    settlement_earnings_text1: 'Registro de liquidación',
    settlement_earnings_text2: 'Periodo de liquidación',
    settlement_earnings_text3: 'Precio del Minilibro',
    settlement_earnings_text4: 'Cantidad vendida',
    settlement_earnings_text5: 'Importe de ventas',
    settlement_earnings_text6: 'Deducciones, impuestos incluidos',
    settlement_earnings_text7: 'Importe del depósito',
    settlement_earnings_text8: 'Fecha de depósito',
    settlement_earnings_text9: 'Vistas de anuncios',
    settlement_earnings_text10: 'Importe total',
    settlement_earnings_text11: 'Saber más',
    settlement_earnings_text12: 'Precio del anuncio',
    settlement_earnings_text13: 'Ingresos',
    settlement_earnings_text14: 'Todos los minilibros',
    settlement_earnings_text15: 'Seleccionar evento',
    settlement_earnings_text16: 'Todos los eventos',
    settlement_statistics_text1: 'Volumen de ventas',
    settlement_statistics_text2: 'Número de lectores',
    settlement_statistics_text3: '(El último)',
    settlement_statistics_text4: '1 mes',
    settlement_statistics_text5: '6 meses',
    settlement_statistics_text6: '1 año',
    settlement_statistics_text7: 'No se encontraron datos',
    settlement_statistics_text8: 'Análisis de ventas',
    settlement_statistics_text9: 'Vistas de anuncios',
    settlement_statistics_text10: 'Todos los idiomas',
    terms_title: 'Términos y condiciones del servicio',
    terms_text: '',
    privacy_title: 'Política de privacidad',
    privacy_text: '',
    // common text
    message_save: 'Guardado',
    message_fail: 'Fallido',
    message_delete: 'Borrado',
    message_report: 'Informado',
    message_search_no_result: 'No se han encontrado resultados',
    message_search_enter: 'Por favor, ingrese un término de búsqueda',
    message_error1: 'Se ha producido un error. Póngase en contacto con el administrador',
    message_save2: 'Guardado',
    message_fail2: 'Error',
    message_login: 'Necesita INICIAR SESIÓN',
    name: 'Nombre',
    email: 'Correo electrónico',
    mobile: 'Móvil',
    list: 'Lista',
    edit: 'Editar',
    delete: 'Borrar',
    search: 'Buscar',
    report: 'Reportar contenido',
    user: 'Usuario',
    report_type: 'Tipo de denuncia',
    report_type1: 'Profanidad/ Difamación',
    report_type2: 'Publicidad',
    report_type3: 'Obscenidad/ Sexualmente explícito',
    report_type4: 'Repetición del mismo contenido',
    report_type5: 'Otros',
    search_book: 'Buscar en Minilibro',
    serch_placeholder: 'Buscar por nombre o correo electrónico',
    search_keyword: 'Palabra clave',
    search_reference: 'Referencia',
    search_author: 'Autor',
    search_result: 'Encontrado',
    button_report: 'Informar a YouBook',
    button_write: 'Guardar',
    button_login: 'INICIAR SESIÓN',
    button_more: 'Más',
    button_confirm: 'Confirmado',
    button_save: 'Guardar',
    button_crop: 'Recortar',
    button_delete: 'Borrar',
    button_complete: 'completo',
    colorbox_background_text1: 'Seleccione un color de fondo',
    colorbox_font_text1: 'Seleccione un color de texto',
    menu_home: 'Inicio',
    menu_page: 'Página',
    menu_book: 'Minilibro',
    menu_memo: 'Memo',
    menu_together: 'Evento',
    login_button: 'INICIAR SESIÓN',
    message_text1: 'Responder',
    message_text2: '¡Han respondido a mi comentario!',
  },
  th: {
    home_banner_title1: 'หนังสือเล่มเล็กใหม่',
    home_banner_title2: 'อีเวนต์ใหม่',
    home_slide_title1: 'กำลังเป็นที่นิยม',
    home_slide_title2: 'รสนิยมของฉัน',
    home_slide_title3: 'กำลังร้อนแรง',
    home_slide_title4: 'เป็นที่นิยมมาก',
    home_detail_title1: 'ความทรงจำในแต่ละวัน',
    home_detail_title2: 'วิดีโอที่แนะนำ',
    home_detail_title3: 'ถ้าอยากรู้มากกว่านี้',
    home_detail_text1: 'บันทึกหนังสือเล่มเล็ก',
    home_detail_text2: 'บันทึกประจำวัน',
    home_setting_title: 'การตั้งค่า',
    home_setting_text1: 'หน้าเพจที่ดูในช่วง 30 วันที่ผ่านมา',
    home_setting_text2: 'ออกจากระบบ',
    home_setting_text3: 'ลบบัญชีผู้ใช้',
    home_book_banner_question: 'ฉันอยากรู้',
    home_book_banner_write_placeholder1: 'ระบุชื่อเรื่อง',
    home_book_banner_write_placeholder2: 'ระบุโพสต์',
    home_book_banner_write_button: 'บันทึก',
    home_book_banner_detail_text1: 'คำตอบของเมนเทอร์ YouBook',
    home_book_banner_detail_text2: 'หนังสือเล่มเล็กที่เกี่ยวข้อง',
    home_book_create_button: 'หนังสือเล่มเล็ก สร้างของคุณเอง',
    home_book_create_text1: 'หนังสือเล่มเล็ก คือหนังสือขนาดสั้นประมาณ 10 หน้า ถูกออกแบบมาให้เหมาะกับเทรนด์การอ่านที่ต้องการเนื้อหาสำคัญอย่างกระชับและรวดเร็ว',
    home_book_create_text2: 'วิธีแก้ไขหลังการเผยแพร่',
    home_book_create_text3: 'หนังสือเล่มเล็ก วิธีสร้างง่ายๆ',
    home_book_create_text4: 'ผู้เขียนสามารถทำรายได้เท่าไร?',
    home_book_create_text5: 'จะเจอผู้อ่านได้อย่างไร?',
    home_book_create_text6: '5 เหตุผลที่ต้องใช้ YouBook',
    home_book_create_text7: 'มีคำถามอื่นอีกไหม?',
    home_book_create_text8: 'สามารถดูยอดขายแบบเรียลไทม์ได้ไหม?',
    home_book_create_text9: 'มาเขียนกันทุกวันอย่างสม่ำเสมอ!',
    home_book_create_text10: 'เริ่มเลย ตอนนี้!',
    home_book_category_title1: 'ประเด็นวันนี้และหนังสือเล่มเล็ก',
    home_book_category_title2: 'หนังสือเล่มเล็กที่น่าจับตามอง',
    home_book_category_title3: 'หนังสือเล่มเล็กของศาสตราจารย์ S-class',
    home_book_category_title4: 'แนะนำเฉพาะบุคคล',
    home_book_category_title5: 'หนังสือเล่มเล็กที่สกัดแก่นจากหนังสือขายดี',
    home_book_category_title6: 'กับแมวหนังสือ',
    home_book_category_title6_text1: 'แสดง',
    home_book_category_title6_text2: 'พับเก็บ',
    home_book_category_title7: 'สำรวจหน้าภายในเครือข่ายประสาท',
    home_book_category_title8: 'งานศิลปะและความรู้สึก',
    home_book_category_title8_text1: 'โลกในภาพยนตร์และละคร',
    home_book_category_title8_text2: 'ท่วงทำนองและการเคลื่อนไหวที่สะเทือนใจ',
    home_book_category_title8_text3: 'ศิลปะไร้พรมแดน',
    home_book_category_title8_text4: 'สวมบุคลิก: แฟชั่นและสไตล์',
    home_book_category_title9: 'วัฒนธรรมอาหารและการพักผ่อน',
    home_book_category_title9_text1: 'สำรวจอาหารท้องถิ่น',
    home_book_category_title9_text2: 'เรื่องราวของเหล้าและชีวิต',
    home_book_category_title9_text3: 'เสน่ห์ของขนมขบเคี้ยวและของหวาน',
    home_book_category_title9_text4: 'พลังจากธรรมชาติ ความลับของพืช',
    home_book_category_title10: 'ปัญญาชีวิตและการค้นพบตัวเอง',
    home_book_category_title10_text1: 'วิธีการจัดการเงินที่ไม่เหมือนใคร',
    home_book_category_title10_text2: 'สูตรการเติบโตส่วนบุคคล',
    home_book_category_title10_text3: 'ปัญหาและทางแก้ไขในความสัมพันธ์',
    home_book_category_title10_text4: 'การค้นพบและความรู้ใหม่',
    home_book_category_title11: 'ความหลากหลายของค่านิยมและความรัก',
    home_book_category_title11_text1: 'เรื่องราวชีวิตของพวกเขา',
    home_book_category_title11_text2: 'ปรัชญาและค่านิยมที่แตกต่าง',
    home_book_category_title11_text3: 'ความเชื่อทางศาสนาและประเพณี',
    home_book_category_title11_text4: 'ความลึกลับของความรัก',
    home_book_category_title12: 'วันแห่งการเดินทางและงานอดิเรก',
    home_book_category_title12_text1: 'จุดหมายที่ต้องไปเยือน',
    home_book_category_title12_text2: 'ความสุขในชีวิตผ่านงานอดิเรก',
    home_book_category_title12_text3: 'วัฒนธรรมที่แปลกใหม่ผ่านการเล่น',
    home_book_category_title13: 'ความอุดมสมบูรณ์ของประเพณีและเรื่องราว',
    home_book_category_title13_text1: 'ตำนานและวีรบุรุษท้องถิ่น',
    home_book_category_title13_text2: 'การเดินทางวรรณกรรมโลก',
    home_book_category_title13_text3: 'ประวัติศาสตร์และภูมิปัญญาของสถานที่',
    home_book_category_title13_text4: 'เรื่องราวทางสังคมที่หลากหลาย',

    home_book_category_title1_text2: 'ความคิดของแมวหนังสือ—อยากดูนิดหน่อยไหม?',
    home_book_category_title1_text3: 'สงสัย? อยากรู้?',
    home_book_category_title1_text4: 'ให้แนะนำหนังสือเล่มเล็กไหม',
    home_book_search_placeholder1: 'พูดที่นี่',
    home_book_search_placeholder2: 'คำหลักคืออะไร',

    home_book_search_message1: 'ระบุคำถามของคุณ',
    home_book_search_message2: 'ระบุคำถามของคุณอีกครั้ง',
    home_book_search_text1: 'ทำไมไม่ลองคุยกับฉันล่ะ?',
    home_book_search_text2: 'ทำไมไม่ลองคุยกับฉันล่ะ?',
    home_book_search_text3: 'ถาม',
    home_book_search_text4: 'คุณสามารถบันทึกข้างต้นได้',
    home_book_search_text5: '(เพิ่มคำหลัก)',
    home_book_search_text6: 'ค้นหา',
    home_book_theme_title: 'หนังสือตามธีม',
    home_instant_text1: 'ระบุคำหลัก',
    home_instant_text2: 'ระบุแบบสุ่ม',
    home_book_company_info: 'หากคุณมีคำถามเพิ่มเติม โปรดติดต่อเราตามข้อมูลด้านล่าง เราพร้อมที่จะให้ความช่วยเหลือคุณ',
    home_page_search_text1: 'ค้นหาหน้าเพจ',
    home_page_search_text2: 'เล่นวิดีโอทันที',
    home_page_search_text3: 'ค้นหาขั้นสูง',
    home_page_search_text4: 'มุมมองรายการ',
    home_page_search_text5: 'มุมมองเครือข่าย',
    home_page_explor_alert: 'ไม่มีหน้าเพจที่ถูกเลือก',
    home_page_explor_alert2: 'คุณมีจำนวนหน้าเว็บเกินจำนวนสูงสุดที่สามารถดูได้บนหน้าจอเดียว (150) กรุณาวางหน้าที่ไม่จำเป็นลงในถังขยะ',
    home_page_explor_alert3: 'ไม่มีข้อมูลเพิ่มเติมให้โหลด',
    my_login_title: 'ของฉัน',
    my_login_text1: 'สร้างโปรไฟล์ของคุณให้มีสไตล์',
    my_login_text2: 'เข้าสู่ระบบตอนนี้และเพื่อเพื่มการเรียนรู้',
    my_login_text3: 'กับ YouBook',
    my_login_find_password: 'ค้นหารหัสผ่าน',
    my_guide_minibook: 'วิธีสร้างหนังสือเล่มเล็ก',
    my_password_reset: 'รีเซ็ตรหัสผ่าน',
    my_password_reset_text1: 'ใส่อีเมลก่อนหน้าของคุณสำหรับการเข้าสู่ระบบ',
    my_password_reset_button1: 'ส่งลิงก์สำหรับรีเซ็ต',
    my_password_reset_button2: 'รีเซ็ต',
    my_password_reset_message1: 'ไม่พบอีเมลของคุณ',
    my_password_reset_message2: 'เราได้ส่งลิงก์รีเซ็ตรหัสผ่านไปยังอีเมลของคุณแล้ว',
    my_password_reset_message3: 'โปรดรีเซ็ตรหัสผ่านของคุณโดยใช้ลิงก์ที่ส่งไปยังอีเมลของคุณ',
    my_password_reset_placeholder1: 'อีเมลของคุณ',
    my_password_reset_placeholder2: 'ใส่รหัสผ่านใหม่ของคุณ',
    my_password_reset_placeholder3: 'ใส่รหัสผ่านใหม่ของคุณอีกครั้ง',
    my_password_reset_message4: 'รหัสผ่านไม่ตรงกัน',
    my_password_reset_message5: 'รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวพิมพ์ใหญ่อย่างน้อย 1 ตัว ตัวพิมพ์เล็กอย่างน้อย 1 ตัว ตัวเลขอย่างน้อย 1 ตัว และอักขระพิเศษอย่างน้อย 1 ตัว',
    my_password_reset_message6: 'รหัสผ่านถูกรีเซ็ตแล้ว',
    my_memo_list_placeholder: 'คุณคิดอะไรออก? จดไว้เลยตอนนี้',
    my_profile_placehoder1: 'ความสนใจของฉัน',
    my_profile_placehoder2: 'ชื่อของฉัน',
    my_profile_placehoder3: 'แนะนำตัวเองอย่างย่อ',
    my_profile_placehoder4: 'แนะนำเพิ่มเติม',
    my_profile_text1: 'สัญชาติ',
    my_profile_text2: 'ภาษา',
    my_profile_text3: 'เปลี่ยนไอดี',
    my_profile_text4: 'ไอดีปัจจุบัน',
    my_profile_text5: 'เปลี่ยนไอดีใหม่',
    my_profile_text6: 'สามารถเปลี่ยนไอดีได้เพียงครั้งเดียวเท่านั้น',
    my_menu_text1: 'การเดินทาง\nของฉัน',
    my_menu_text2: 'ข้อความ',
    my_menu_text3: 'การซื้อและ\nการชำระเงิน',
    my_menu_text4: 'การแจ้งเตือนใหม่',
    my_menu_text5: 'สร้างหนังสือ\nเล่มเล็ก',
    my_menu_text6: 'หนังสือเล่มเล็กที่\nสร้างขึ้น',
    my_menu_text7: 'คุณต้องการนำเข้าข้อความจากแอปอื่นหรือไม่?',
    my_menu_text8: 'สามารถนำเข้าโดยอัตโนมัติและแปลงเป็นหน้าเพจได้',
    my_menu_text9: 'นำเข้า',
    my_import_book_text1: 'แปลงเป็นหน้าเพจ',
    my_import_book_text2: 'กำลังแปลงไฟล์ ZIP เป็นหน้าเพจ อาจใช้เวลาสูงสุด 5 วินาทีต่อหนึ่งข้อความ 10 ข้อความใช้เวลาประมาณ 1 นาที 100 ข้อความใช้เวลาประมาณ 8 นาที จะมีหน้าต่างป๊อปอัปแจ้งเมื่อแปลงเสร็จ',
    my_import_book_text3: 'เข้าใจแล้ว',
    my_import_book_text4: 'แปลงเป็นหน้าเพจเสร็จสิ้น',
    my_import_book_text5: 'ข้อความในไฟล์ ZIP ถูกแปลงเป็นหน้าเพจทั้งหมดแล้ว ข้อความแต่ละรายการถูกแปลงเป็นหน้าเพจแยกกัน ตรวจสอบได้ที่ การเดินทางของฉัน - หน้าเพจที่สร้างแล้ว หน้าเพจถูกบันทึกแบบชั่วคราวและสามารถแก้ไขได้',
    my_import_book_text6: 'สามารถนำเข้าข้อความจากแอปอื่นและแปลงเป็นหน้าเพจโดยอัตโนมัติ จากนั้นรวบรวมเป็นหนังสือเล่มเล็กได้',
    my_import_book_text7: 'วิธีนำเข้าข้อความจากแอปอื่นในรูปแบบ ZIP',
    my_import_book_text8: 'กรุณาอัปโหลดไฟล์ ZIP',
    my_import_book_text9: 'อัปโหลดไฟล์จาก Substack',
    my_import_book_text10: 'อัปโหลดไฟล์จาก Medium',
    my_import_book_text11: 'ค้นหา',
    my_import_book_text12: '* ข้อความแต่ละรายการจะถูกแปลงเป็นหน้าเพจแยก',
    my_import_book_text13: '* คุณสามารถตรวจสอบได้ที่ หน้าของฉัน - การตั้งค่า - หน้าเพจที่สร้างแล้ว',
    my_import_book_text14: '* หน้าเพจถูกบันทึกแบบชั่วคราวและสามารถแก้ไขได้',
    my_import_book_text15: '* สามารถนำเข้าเฉพาะข้อความที่เขียนเองเท่านั้น',
    my_import_book_text16: 'เผยแพร่หนังสือเล่มเล็กด้วยหน้าเพจที่แปลงแล้ว',
    my_import_book_text17: 'สร้างปกหนังสือเล่มเล็ก',
    my_import_book_text18: 'เลือกหน้าเพจที่จะเพิ่ม',
    my_import_book_text19: 'เผยแพร่หนังสือเล่มเล็ก',
    my_import_book_text20: 'โปรดอ่านคำแนะนำอย่างละเอียด',
    my_import_book_text21: 'ไฟล์ไม่ใช่รูปแบบ ZIP',
    my_import_book_text22: 'กรุณาอัปโหลดไฟล์',
    my_journey_title: 'การเดินทางของฉัน',
    my_journey_button_message: 'ข้อความ',
    my_journey_button_memo: 'บันทึก',
    my_journey_button_record: 'ประวัติบันทึก',
    my_journey_button_follow: 'ติดตาม',
    my_journey_button_follow_cancel: 'เลิกติดตาม',
    my_journey_message_text1: 'ฝากข้อความ',
    my_journey_message_placeholder: 'ระบุข้อความของคุณ',
    my_journey_message_message1: 'ไม่สามารถตอบกลับได้',
    my_journey_message_message2: 'ส่ง',
    my_journey_message_message3: 'ระบุข้อความของคุณ',
    my_journey_memo_total: 'ทั้งหมด',
    my_journey_record_overall: 'อันดับอิทธิพล',
    my_journey_record_text1: 'หน้าเพจที่เคยดู',
    my_journey_record_text2: 'หนังสือเล่มเล็กที่ชื่นชอบ',
    my_journey_record_text3: 'พื้นที่อีเวนต์ที่ชอบ',
    my_journey_record_text4: 'หน้าเพจที่สร้างแล้ว',
    my_journey_record_text5: 'หนังสือเล่มเล็กที่สร้างแล้ว',
    my_journey_record_text6: 'พื้นที่อีเวนต์ที่ฉันสร้าง',
    my_journey_record_text7: 'เดือนนี้',
    my_journey_record_text8: 'หนังสือเล่มเล็กที่ซื้อมา',
    my_journey_record_text9: 'สาธารณะ',
    my_journey_record_text10: 'ส่วนตัว',
    my_journey_record_text11: 'อีเวนต์ที่ซื้อ',
    my_journey_record_text12: 'อีเวนต์ที่ฉันสร้าง',
    my_journey_record_text13: 'อันดับ #{userRank} ในหมวดหมู่ {userLanguage}',
    my_journey_record_text14: 'หนังสือเล่มเล็กสำหรับการแบ่งปันสิทธิ์ของผู้เขียน',
    my_journey_record_text15: 'คุณต้องการให้ผู้อ่านอ่านตามลำดับที่คุณกำหนดหรือไม่? ถ้าใช่ ให้ลากปกเพื่อเปลี่ยนลำดับ',
    my_journey_record_text16: 'ให้กำลังใจหนังสือเล่มเล็กเล่มใหม่',
    my_journey_record_text17: 'ข้อความให้กำลังใจจากผู้อ่าน',
    my_journey_record_text18: 'ฝากข้อความให้กำลังใจถึงผู้เขียน',
    my_journey_record_text19: 'ระดับผู้สนับสนุน',
    my_journey_record_text20: 'ระดับที่ {cheeringLevel} จากทั้งหมด 10',
    my_journey_record_text21: 'คนที่ฉันสนับสนุน',
    my_journey_record_text22: 'ผู้สนับสนุนของฉัน',
    my_journey_record_text23: 'คุณต้องการลบหรือไม่?',
    my_journey_record_text24: 'ผู้สนับสนุนของ {userName}',
    my_journey_record_text25: 'ได้รับการสนับสนุนโดย {userName}',
    my_notice_title: 'การแจ้งเตือน',
    my_notice_message1: 'ไม่มีการแจ้งเตือนใหม่',
    my_notice_text1: 'มีหนังสือเล่มเล็กมาใหม่',
    my_notice_text2: 'มีหัวข้อวันนี้มาใหม่',
    my_notice_text3: 'คุณได้รับข้อความใหม่ในการเดินทางของฉัน',
    my_notice_text4: 'มีความคิดเห็นใหม่ถึงบันทึกของฉัน',
    my_notice_text5: 'มีความคิดเห็นใหม่ในพื้นที่อีเวนต์ของฉัน',
    my_notice_text6: 'มีความคิดเห็นใหม่ถึงปกหนังสือเล่มเล็กของฉัน',
    my_notice_text7: 'มีความคิดเห็นใหม่ถึงหน้าเพจหนังสือเล่มเล็กของฉัน',
    my_notice_text8: 'โพสต์บันทึกใหม่แล้ว',
    my_notice_text9: '{userName} ได้สร้างพื้นที่อีเวนต์ใหม่แล้ว',
    my_notice_text10: 'เผยแพร่หนังสือเล่มเล็กใหม่แล้ว',
    my_notice_text11: 'ได้ซื้อสมุดมินิบุ๊กของฉัน',
    my_notice_text12: '{userName} ได้สร้าง<b>อีเวนต์ใหม่</b>',
    my_notice_text13: '{userName} ได้เชิญคุณเป็นพิเศษให้เข้าร่วม<b>อีเวนต์ใหม่</b> ห้ามพลาด! ',
    my_notice_text14: '{userName} ได้<b>ซื้ออีเวนต์ของฉัน</b>',
    my_notice_text15: '{userName} ได้สมัครเป็นผู้เขียนร่วม',
    my_notice_text16: 'คำขอเป็นผู้เขียนร่วมของหนังสือเล่มเล็กแบบเปิดได้รับการอนุมัติแล้ว',
    my_notice_text17: 'มีความคิดเห็นใหม่จากผู้เขียนร่วม',
    my_notice_text18: 'มีข้อความเข้ามาเพื่อสนับสนุนหนังสือเล่มเล็กเล่มใหม่',
    my_notice_text19: '{userName} เป็นสปอนเซอร์ให้กับ <b>หนังสือเล่มเล็กของฉัน</b>',
    my_marketing_banner_title: 'ให้กำลังใจตัวเอง',
    my_marketing_banner_text1: 'คุณผ่านความยากลำบากมาได้ ตอนนี้ให้กำลังใจตัวเอง',
    my_marketing_banner_btn: 'ให้กำลังใจตอนนี้',
    my_marketing_title: 'ให้กำลังใจตอนนี้',
    my_marketing_text1: 'ติดปีกให้หนังสือเล่มเล็กและอีเวนต์ ใช้การโปรโมตแบบเป็นขั้นตอนเป็นเชื้อเพลิง แล้วกลายเป็นอินฟลูเอนเซอร์',
    my_marketing_text2: 'อีเมลถึงผู้อ่านทั่วไป',
    my_marketing_text3: 'ข้อความถึงผู้อ่านทั่วไป',
    my_marketing_text4: 'อีเมลถึงเพื่อน',
    my_marketing_text5: 'ข้อความถึงเพื่อน',
    my_marketing_text6: 'ลิงก์ในโซเชียลมีเดีย',
    my_marketing_btn: 'เริ่มตอนนี้',
    my_marketing_minibook_step1_title: 'ให้กำลังใจหนังสือเล่มเล็ก',
    my_marketing_step1_subtitle: 'ลิงก์ในโซเชียลมีเดีย',
    my_marketing_minibook_step1_text1: 'วางลิงก์หนังสือเล่มเล็กในโซเชียลมีเดียของคุณ แล้วเพิ่มคำอธิบายที่น่าสนใจ',
    my_marketing_minibook_text1: 'ค้นหาหนังสือเล่มเล็ก',
    my_marketing_step1_text1: 'คัดลอกลิงก์',
    my_marketing_step1_btn: 'คัดลอก',
    my_marketing_step1_text2: 'วางในโซเชียลมีเดียและเพิ่มคำอธิบาย',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'กรุณาเลือกหนังสือเล่มเล็กที่ต้องการแชร์',
    my_marketing_step1_text4: 'คัดลอกลิงก์แล้ว',
    my_marketing_step1_text5: 'กรุณาเลือกอีเวนต์ที่ต้องการแชร์',
    my_marketing_step1_text6: 'ค้นหาโซเชียลมีเดีย',
    my_marketing_event_step1_title: 'ให้กำลังใจอีเวนต์',
    my_marketing_event_step1_text1: 'วางลิงก์อีเวนต์ในโซเชียลมีเดียของคุณ แล้วเพิ่มคำอธิบายที่น่าสนใจ',
    my_marketing_event_text1: 'ค้นหาอีเวนต์',
    my_marketing_event_search_title: 'ค้นหาอีเวนต์',
    my_marketing_minibook_step2_title: 'การตลาดหนังสือเล่มเล็ก ขั้นที่ 2',
    my_marketing_step2_subtitle: 'ข้อความถึงเพื่อน',
    my_marketing_minibook_step2_text1: 'ส่งลิงก์หนังสือเล่มเล็กพร้อมข้อความแนะนำที่อบอุ่นให้เพื่อนของคุณ',
    my_marketing_step2_text2: 'ส่งข้อความแนะนำพร้อมลิงก์ให้เพื่อน',
    my_marketing_step2_placeholder: 'กรอกข้อความแนะนำ',
    my_marketing_tab_text1: 'เพื่อนของฉัน',
    my_marketing_event_step2_title: 'การตลาดอีเวนต์ ขั้นที่ 2',
    my_marketing_event_step2_text1: 'ส่งลิงก์อีเวนต์พร้อมข้อความแนะนำที่อบอุ่นให้เพื่อนของคุณ',
    my_marketing_minibook_step3_title: 'การตลาดหนังสือเล่มเล็ก ขั้นที่ 3',
    my_marketing_step3_subtitle: 'อีเมลถึงเพื่อน',
    my_marketing_minibook_step3_text1: 'ส่งลิงก์หนังสือเล่มเล็กพร้อมเรื่องราวเบื้องหลังให้เพื่อนของคุณ',
    my_marketing_step3_text1: 'นำเข้ารายชื่อผู้ติดต่อ',
    my_marketing_step3_placeholder: 'อัปโหลดไฟล์ csv หรือ vcf',
    my_marketing_step3_text2: 'ส่งเรื่องราวพร้อมลิงก์ให้เพื่อนของคุณ',
    my_marketing_step3_text3: 'นำเข้ารายการเบอร์โทรศัพท์ของคุณ',
    my_marketing_step3_placeholder2: 'แชร์เรื่องราว',
    my_marketing_event_step3_title: 'การตลาดอีเวนต์ ขั้นที่ 3',
    my_marketing_event_step3_text1: 'ส่งลิงก์อีเวนต์พร้อมเรื่องราวเบื้องหลังให้เพื่อนของคุณ',
    my_marketing_text7: 'นำเข้าหมายเลขโทรศัพท์',
    my_marketing_title2: 'จัดการหมายเลขโทรศัพท์',
    my_marketing_text8: 'โทรศัพท์',
    my_marketing_text9: 'จำนวนครั้ง',
    my_marketing_text10: 'นำเข้ารายชื่อติดต่อ',
    my_marketing_text11: 'โปรดอัปโหลดไฟล์ csv หรือ vcf',
    my_marketing_text12: 'วิธีนำเข้า',
    my_marketing_text13: 'นำเข้า',
    my_marketing_title3: 'จัดการรายชื่อติดต่อ',
    contact_manage: 'การจัดการรายชื่อติดต่อ',
    my_marketing_text14: 'ลบรายการที่เลือก',
    my_marketing_text15: 'กรุณาเลือกเพื่อน',
    my_marketing_text16: 'สามารถเลือกเพื่อนได้สูงสุด 100 คน',
    my_marketing_text17: 'อัปโหลดเสร็จสิ้น',
    my_marketing_text18: 'เกินจำนวนอักขระที่ป้อน',
    contact_phone: 'โทรศัพท์',
    contact_organization: 'องค์กร',
    contact_title: 'ตำแหน่ง',
    contact_memo: 'บันทึก',
    my_marketing_text19: 'แก้ไขการเลือก',
    my_marketing_text20: 'เลือกป้ายกำกับ',
    my_marketing_text21: 'เพิ่มป้ายกำกับใหม่',
    my_marketing_text22: 'ลบป้ายกำกับที่เลือก',
    my_marketing_text23: 'เพิ่ม',
    my_marketing_btn2: 'แก้ไขเสร็จสิ้น',
    my_marketing_text24: 'โปรดเลือกผู้ติดต่อที่จะแก้ไข',
    my_marketing_text25: 'โปรดเลือกป้ายกำกับที่ต้องการลบ',
    my_marketing_text26: 'กรุณากรอกชื่อป้ายกำกับ',
    my_marketing_text27: 'ป้ายกำกับนี้มีอยู่แล้ว',
    my_marketing_text28: 'เพิ่มป้ายกำกับ',
    my_marketing_text29: 'ยกเลิก',
    my_marketing_text30: 'เพิ่มแล้ว',
    my_benefit_text1: 'คุณได้รับมาจนถึงตอนนี้',
    my_benefit_text2: 'คุณจะได้รับในหนึ่งปี',
    my_benefit_text3: '',
    my_benefit_text4: 'การคำนวณผลกำไร',
    my_benefit_text5: 'การคำนวณผลกำไร',
    my_benefit_text6: 'ตรวจสอบ',
    my_benefit_modal_text1: 'คุณได้รับมาจนถึงตอนนี้',
    my_benefit_modal_text2: 'บาท',
    my_benefit_modal_text3: 'คุณได้รับแล้ว',
    my_benefit_modal_text4: 'ลองคำนวณอย่างง่าย',
    my_benefit_modal_text5: 'จำนวนหน้าที่อ่านจนถึงตอนนี้',
    my_benefit_modal_text6: 'ราคาในการสร้างหน้าเพจ',
    my_benefit_modal_text7: 'บาท',
    my_benefit_modal_text8: 'ดังนั้นผลกำไรของคุณคือ',
    my_benefit_modal_text9: 'ตอนนี้ เพิ่มกำไรจากการสนทนากับ',
    my_benefit_modal_text10: 'AI และผลกำไรของคุณเพิ่มขึ้น',
    my_benefit_modal_text11: 'ใช้ทุกวันและรับผลตอบแทน',
    my_benefit_modal_text12: 'ตกลง ฉันเข้าใจแล้ว',
    my_story_text1: 'สิ่งที่สมาชิกพูดถึง',
    my_story_text2: 'ตระหนักว่าหนังสือคือประสบการณ์ ไม่ใช่เพียงแค่การอ่าน',
    my_story_text3: 'น่าทึ่งกับสิ่งที่เกิดขึ้นเมื่อได้เรียนรู้ในทุกวัน',
    my_story_text4: 'กับดักซ่อนอยู่ของคนฉลาด คุณเป็นหนึ่งในนั้นหรือไม่?',
    my_story_text5: 'ตรวจสอบเรื่องราวของสมาชิกเพิ่มเติม',
    my_go_blog_text1: 'YouBook, ข่าวสารและเรื่องราวลูกค้า',
    my_go_blog_text2: 'ค้นพบข่าวสารล่าสุดและเรื่องราวจากลูกค้าของ YouBook',
    my_go_blog_text3: 'ดูเพิ่มเติม',
    my_channel_text1: 'คุณคิดอย่างไรกับ YouBook?',
    my_channel_text2: 'บอกสิ่งที่ดีและสิ่งที่เราสามารถทำได้ดีขึ้น',
    my_channel_text3: 'และแจ้งให้เราทราบหากคุณมีคำถามใด ๆ',
    my_channel_text4: 'อยากบอกอะไรไหม',
    my_about_youbook_text1: 'ทำไมควรใช้ YouBook',
    my_about_youbook_text2: 'ที่นี่มีคำถามและคำตอบของคุณทั้งหมด',
    my_about_youbook_text3: 'เงื่อนไขการให้บริการ',
    my_app_text1: 'YouBook เป็นแอปพลิเคชันที่มีประโยชน์ 100%',
    my_app_text2: 'ดาวน์โหลดตอนนี้และได้รับความรู้ได้เลย',
    my_app_text3: 'ดาวน์โหลดแอปพลิเคชั่น',
    login_title: 'เข้าสู่ระบบ',
    login_text1: 'เข้าสู่ระบบด้วยอีเมล',
    login_text2: 'ยังไม่ได้ลงทะเบียน?',
    login_text3: 'ลืมรหัสผ่าน?',
    login_text4: 'หรือเข้าสู่ระบบด้วย',
    login_text5: 'ฉันตกลง',
    login_placeholder1: 'อีเมลเข้าสู่ระบบ',
    login_placeholder2: 'รหัสผ่าน',
    login_placeholder3: 'ไอดี',
    login_message1: 'กรุณาใส่อีเมลเข้าสู่ระบบของคุณ',
    login_message2: 'ใส่รหัสผ่านของคุณ',
    login_message3: 'เข้าสู่ระบบสำเร็จ',
    login_message4: 'กรุณาใส่ไอดีของคุณ',
    logout_message1: 'ต้องการออกจากระบบหรือไม่?',
    login_link1: 'สมัครสมาชิก',
    login_link2: 'ค้นหา',
    login_link3: 'เงื่อนไขการให้บริการ',
    register_title: 'สมัครสมาชิก',
    register_text1: 'สมัครสมาชิกด้วยอีเมล',
    register_text2: 'เลือกประเภทสมาชิก',
    register_text3: 'ส่วนบุคคล',
    register_text4: 'องค์กร',
    register_text5: 'ระบุข้อมูลของคุณ',
    register_text6: 'ลงทะเบียนแล้วหรือยัง?',
    register_text7: 'เลขประจำตัวผู้เสียภาษีนิติบุคคล',
    register_text8: 'เลขทะเบียนพาณิชย์',
    register_text9: 'ชื่อองค์กร',
    register_placeholder1: 'หมายเลขโทรศัพท์ของคุณรวมถึงรหัสพื้นที่',
    register_placeholder2: '(ไม่มีเครื่องหมายขีด)',
    register_placeholder_repassword: 'ใส่รหัสผ่านอีกครั้ง',
    register_message1: 'ใส่หมายเลขโทรศัพท์ของคุณ',
    register_message2: 'ระบุเลขประจำตัวผู้เสียภาษีนิติบุคคล',
    register_message3: 'กรุณาระบุเลขทะเบียนพาณิชย์',
    register_message4: 'กรุณาระบุชื่อองค์กร',
    register_message5: 'รูปแบบอีเมลไม่ถูกต้อง',
    register_message6: 'อีเมลนี้ได้ถูกลงทะเบียนแล้ว',
    register_message7: 'โปรดยืนยันอีเมลของคุณ',
    register_message8: 'กรุณาเลือกสัญชาติของคุณ',
    register_message9: 'รูปแบบไอดีไม่ถูกต้อง',
    register_message10: 'ไม่สามารถใช้ไอดีที่คุณป้อนได้ กรุณาใช้ไอดีที่แนะนำหรือป้อนไอดีอื่น',
    register_message11: 'กรุณายืนยันไอดีของคุณ',
    register_message12: 'ไอดีนี้ถูกใช้ไปแล้ว กรุณาใช้ไอดีที่แนะนำหรือไอดีอื่น',
    register_button_verify: 'ยืนยัน',
    register_button_verify_fail: 'ยังไม่ได้รับการยืนยัน',
    register_button_verify_success: 'ได้รับการยืนยันแล้ว',
    register_welcome_message: 'ยินดีต้อนรับสู่การเป็นสมาชิก',
    withdraw_text1: 'การยกเลิกสมาชิก',
    withdraw_text2: 'ยกเลิกสมาชิก YouBook',
    withdraw_text3: 'คุณแน่ใจหรือว่าต้องการยกเลิก?',
    withdraw_text4: 'ไม่ใช่',
    withdraw_text5: 'ใช่',
    withdraw_text6: 'คุณได้ยกเลิกสมาชิกเรียบร้อยแล้วค่ะ',
    home_memo_title: 'บันทึก',
    home_memo_subtitle: 'หากไม่จดบันทึก คุณจะลืม',
    home_memo_text1: 'แบ่งปันร่วมกันโดยทุกคน',
    home_memo_text2: 'ความรู้และเรื่องราวในชีวิตประจำวัน',
    home_memo_button: 'เขียนบันทึก',
    home_memo_create_text1: 'คุณมีหนังสือเล่มเล็กที่ต้องการเชื่อมโยงไหม?',
    home_memo_create_button: 'ค้นหาหนังสือเล่มเล็ก',
    home_memo_create_button2: 'เลือก',
    home_memo_click: 'คลิก',
    home_memo_date: 'YYYY. MM.DD',
    home_memo_button_askai: 'ความคิดเห็น / ความคิดของแมวหนังสือ',
    home_memo_view_detail: 'ดูรายละเอียด',
    home_memo_view_placeholder: 'ระบุโพสต์',
    home_memo_view_button1: 'ความคิดเห็น',
    home_memo_view_button2: 'ความคิดของแมวหนังสือ',
    home_memo_view_errormessage: 'ระบุโพสต์',

    memo_create_title: 'บันทึก',
    memo_create_category1: 'บันทึก',
    memo_create_category2: 'บันทึก',
    memo_create_private: 'ส่วนตัว',
    memo_create_public: 'สาธารณะ',
    memo_create_placeholder1: 'มีไอเดียหรือ?',
    memo_create_placeholder2: 'จดไว้เลยตอนนี้',
    memo_create_placeholder3: 'คำหลัก (มีช่องว่างระหว่างคำ)',
    memo_create_button: 'บันทึก',
    memo_create_error: 'ระบุบันทึกของคุณ',
    memo_attach_img: 'อัปโหลดภาพ',
    memo_alert_rate: 'โปรดเลือกการให้คะแนนดาวของคุณ',
    memo_alert_save: 'บันทึกแล้ว คุณสามารถตรวจสอบได้ในโปรไฟล์ของฉัน - การเดินทางของฉัน',
    memo_input_placeholder: 'คุณได้เรียนรู้อะไรบ้าง?',
    memo_input_placeholder2: 'คุณคิดเห็นอย่างไรบ้าง?',
    memo_input_placeholder3: 'แชร์กับผู้อ่านตอนนี้เลย~',
    memo_input_placeholder4: 'ความทรงจำในชีวิตประจำวัน บันทึกไว้ดีไหม?',
    memo_alert_keywords: 'ระบุคำหลัก',
    memo_related_text: 'บันทึก',
    memo_related_date: 'YYYY. MM.DD',
    memo_popup_text1: 'เรื่องราวของการอ่านของนิโคลัส ลุห์มันน์ ที่แสดงถึงการแปลงเปลี่ยนนิสัยไปอย่างง่ายดาย',
    memo_popup_text3: 'ในตอนแรก ลุห์มันน์เป็นพนักงานหนุ่มในบริษัทแห่งหนึ่ง โดยที่เขาไม่คุ้นชินกับการอ่านและโลกวิชาการมากนัก',
    memo_popup_text4: 'อย่างไรก็ตาม ความอยากรู้อยากเห็นในการอ่านของเขานำไปสู่พฤติกรรมที่เปลี่ยนแปลงไป: การจดบันทึกทุกวันเกี่ยวกับสิ่งที่เขาอ่าน',
    memo_popup_text5: 'นิสัยการจดบันทึกในเอกสารนี้เป็นที่สนใจของนักสังคมวิทยาชาวเยอรมัน ซึ่งนำไปสู่การเปลี่ยนแปลงในอาชีพของเขาอย่างไม่คาดคิด',
    memo_popup_text6: 'ลุห์มันน์ได้รับเชิญให้เข้าร่วมเป็นอาจารย์ที่มหาวิทยาลัย Bielefeld ซึ่งทำให้เขาเติบโตจนได้รับตำแหน่งศาสตราจารย์',
    memo_popup_text7: 'ตลอดอาชีพของเขา เขาได้เขียนหนังสือที่น่าประทับใจ 60 เล่มและบทความจำนวนมาก ซึ่งทำให้เขาได้รับการขนานนามว่าเป็นดาวรุ่งในวงการสังคมวิทยา',
    memo_popup_text8: 'ลุห์มันน์กล่าวถึงความสามารถของเขาในการจดบันทึกอย่างมีระเบียบวินัยโดยกล่าวว่า',
    memo_popup_text9: '"ฉันแค่จดบันทึกเรื่อยๆ"',
    memo_popup_text10: 'ซึ่งช่วยเขาจัดระเบียบความคิดและเพิ่มความเข้าใจ',
    memo_popup_text11: 'เรื่องราวนี้เป็นการย้ำเตือนถึงข้อจำกัดของความจำ และคุณค่าของการจดบันทึกและทบทวนความรู้อย่างเป็นระบบ ในแบบของตัวเองจริง',
    memo_popup_btn: 'ใช่ ฉันเข้าใจ',
    memo_text1: 'คุณสามารถบันทึกข้างต้นได้',
    memo_text2: '(เพียงเพิ่มคำหลัก)',
    memo_text3: 'สิ่งที่ต้องตรวจสอบเมื่อเขียน',
    memo_text4: 'โพสต์ของคุณละเมิดข้อกำหนดเกี่ยวกับเนื้อหาในข้อ 2 ส่วนที่ 1 ของเงื่อนไขการให้บริการ จะไม่ได้รับการเผยแพร่',
    memo_text5: 'ดูเงื่อนไขการให้บริการ',
    memo_text6: 'หากต้องการบันทึกในภาษาอื่น',
    memo_text7: 'กรุณาเขียนเป็นภาษานั้น(ไม่มีการแปลอัตโนมัติ)',
    book_create_button: 'สร้างหนังสือเล่มเล็ก',
    book_create_title: 'สร้างปก',
    book_create_cover: 'ปก',
    book_create_text1: 'ขั้นตอนสร้างปกสำหรับหนังสือเล่มเล็ก',
    book_create_text1_pc: 'ระบุชื่อเรื่องและชื่อผู้เขียน',
    book_create_text2: 'คุณยังไม่ได้สร้างภาพปก',
    book_create_text3: '',
    book_create_text4: 'คุณได้สร้างภาพปกแล้ว',
    book_create_text5: 'คุณสร้างได้ปกแล้วหรือไม่?',
    book_create_text6: 'โปรดอัปโหลดโดยใช้ปุ่มด้านล่าง',
    book_create_text7: '(รูปแบบ jpg ขนาดไม่เกิน 20M)',
    book_create_text8: 'สิทธิ์ในการเพิ่มหน้าเพจ',
    book_create_text9: 'ฉันเท่านั้น',
    book_create_text10: 'ใครก็ได้',
    book_create_text11: 'แสดงชื่อบนภาพ',
    book_create_text12: 'แสดงผล',
    book_create_text13: 'ไม่ต้องแสดง',
    book_create_text14: 'กรุณาเลือกภาษาที่คุณต้องการแปล',
    book_create_text15: 'เลือกทั้งหมด',
    book_create_text16: 'อัปโหลดภาพปก',
    book_create_text17: 'สามารถแก้ไขได้',
    book_create_text18: 'หลังจากแก้ไขให้คลิกที่ไอคอนด้านขวาบนเพื่อแปลใหม่',
    book_create_text19: 'หากต้องการแปลตามต้นฉบับอีกครั้ง ให้คลิกที่ไอคอนด้านขวาบน',
    book_create_text20: 'แปลใหม่',
    book_create_text21: 'ภาพ',
    book_create_text22: 'ชื่อ',
    book_create_text23: 'คำหลัก',
    book_create_text24: 'เนื้อหา',
    book_create_text25: 'การแปลจะอัปเดตเฉพาะในกรณีที่ลบรูปภาพแล้วอัปโหลดใหม่เท่านั้น',
    book_create_text26: '(หน้าเพจจะไม่ถูกลบ)',
    book_create_text27: 'กรุณาเขียนคำแนะนำสั้นๆ',
    book_create_text28: 'บันทึกชั่วคราว',
    book_create_text29: 'บันทึกชั่วคราวแล้ว',
    book_create_text30: 'รายการที่ต้องตรวจสอบ',
    book_create_text31: 'เนื้อหาของข้อความเป็นฉบับสุดท้ายและไม่ต้องแก้ไขเพิ่มเติม',
    book_create_text32: 'ไม่มีการใช้คำหรือสัญลักษณ์ที่ AI แปลไม่สามารถเข้าใจได้',
    book_create_text33: 'รูปภาพไม่ได้คัดลอกและวาง แต่ถูกอัปโหลดเป็นไฟล์แยกต่างหาก',
    book_create_text34: 'เปิดรับสมัครไหม? (หนังสือเล่มเล็กแบบเปิด)',
    book_create_text35: 'ผู้เขียนร่วม',
    book_create_text36: 'เพิ่มเองไหม?',
    book_create_text37: 'เพิ่ม',
    book_create_text38: 'หนังสือเล่มเล็กที่กระจายได้ไกลขึ้นเมื่อเขียนร่วมกัน',
    book_create_text39: 'พลังของผู้เขียนร่วมที่คุณไม่เคยรู้',
    book_create_text40: 'เริ่มเปิดรับสมัคร',
    book_create_text41: 'ยกเลิก',
    book_create_text43: 'ไอเดีย?',
    book_create_text44: 'คัดลอกและวางเนื้อหา',
    book_create_text45: 'ต้องการไอเดียไหม?',
    book_create_text46: 'ตัวเลือกการขาย',
    book_create_text47: 'ฟรี',
    book_create_text48: 'สปอนเซอร์',
    book_create_text49: 'ซื้อ',
    book_create_text50: 'ราคาปัจจุบัน',
    book_create_text51: 'แก้ไขราคา',
    book_create_text52: 'ไม่สามารถตั้งราคาเป็น 0 ได้',
    book_create_text53: 'ไม่สามารถเปลี่ยนแปลงราคา หรือรูปแบบการขายของหนังสือเล่มเล็กที่ซื้อหรือได้รับการสนับสนุนแล้วได้',
    book_create_text54: 'มีเพียงผู้เขียนหนังสือเล่มเล็กเท่านั้นที่สามารถตอบกลับข้อความได้',
    book_create_button_upload: 'อัปโหลด',
    book_create_button_make: 'สร้าง',
    book_create_cover_topic_placeholder: 'ชื่อจะปรากฏเช่นนี้',
    book_create_topic_placeholder: 'ระบุชื่อ',
    book_create_keyword_placeholder: 'คำหลัก (มีช่องว่างระหว่างคำ)',
    book_create_category_placeholder: 'เลือกหมวดหมู่',
    book_create_knowledge_placeholder: 'เขียนบทนำสำหรับหนังสือเล่มเล็กของคุณ **ระวัง - จดรายละเอียดในขั้นตอนการสร้างหน้าเพจ',
    book_create_category_option1: 'ภาพยนตร์และละคร',
    book_create_category_option2: 'ดนตรีและการเต้นรำ',
    book_create_category_option3: 'ศิลปะอื่นๆ',
    book_create_category_option4: 'เครื่องแต่งกายและสไตล์',
    book_create_category_option5: 'อาหารและการทำอาหาร',
    book_create_category_option6: 'เครื่องดื่มแอลกอฮอล์และเครื่องดื่ม',
    book_create_category_option7: 'ของว่างและขนมหวาน',
    book_create_category_option8: 'พืชและสุขภาพ',
    book_create_category_option9: 'การเป็นเศรษฐี',
    book_create_category_option10: 'การพัฒนาตนเอง',
    book_create_category_option11: 'ความสัมพันธ์',
    book_create_category_option12: 'ความรู้ใหม่',
    book_create_category_option13: 'เรื่องราวชีวิต',
    book_create_category_option14: 'ปรัชญาและค่านิยม',
    book_create_category_option15: 'ศาสนาและประเพณี',
    book_create_category_option16: 'ความรัก',
    book_create_category_option17: 'การท่องเที่ยวและสถานที่ท่องเที่ยว',
    book_create_category_option18: 'งานอดิเรก',
    book_create_category_option19: 'วัฒนธรรมการเล่น',
    book_create_category_option20: 'ตำนานและวีรบุรุษ',
    book_create_category_option21: 'ทริปวรรณกรรม',
    book_create_category_option22: 'ประวัติศาสตร์และปัญญา',
    book_create_category_option23: 'เรื่องราวสังคม',
    book_create_category_option24: 'ความรู้ทั่วไป',
    book_create_message1: 'ระบุชื่อ',
    book_create_message2: 'ระบุชื่อผู้เขียน',
    book_create_message3: 'ระบุคำหลัก',
    book_create_message4: 'ระบุคำหลักมากกว่า 3 คำ',
    book_create_message5: 'เลือกหมวดหมู่',
    book_create_message6: 'สร้างภาพปก',
    book_create_message7: 'คุณไม่สามารถใส่อักขระพิเศษได้ และต้องมีช่องว่างระหว่างคำหลัก',
    book_create_message8: 'ต้องการลบหนังสือเล่มเล็กหรือไม่?',
    book_create_message9: 'คุณไม่มีสิทธิ์ในการเผยแพร่ในภาษานี้',
    book_create_message10: 'หนังสือเล่มเล็กที่ซื้อแล้วไม่สามารถลบได้',
    book_create_modal_text1: 'กรุณารอสักครู่..',
    book_create_modal_text2: 'AI กำลังตรวจสอบเนื้อหา แปลภาษา และเชื่อมโยงเครือข่ายความรู้',
    book_create_modal_text3: 'กำลังเชื่อมต่อกับฐานความรู้เพื่อค้นหาแต่ละหน้าเพจ',
    book_create_modal_text4: 'ไม่มีชื่อปรากฏบนภาพปก',
    book_create_modal_text5: '(ใช้ได้กับปกที่แปลเป็นภาษาต่างประเทศด้วยเช่นกัน)',
    book_view_title: 'ภาพรวมหนังสือเล่มเล็ก',
    book_view_share: 'แชร์',
    book_view_event_topic: 'หัวข้ออีเวนต์',
    book_view_together_suggest: 'เสนอพื้นที่อีเวนต์',
    book_view_together_message: 'คุณไม่มี "ร่วมกัน" ที่ชื่นชอบ<br />ไปที่เมนู "ร่วมกัน" และเลือกหนึ่ง',
    book_view_event_message: 'ไม่มีอีเวนต์ที่ฉันสร้าง',
    book_view_text1: 'ยังไม่มีหน้าเพจที่ถูกเพิ่ม',
    book_view_text2: 'ทำไมคุณไม่เพิ่มตอนนี้',
    book_view_text3: 'ไม่มีหนังสือเล่มเล็กนี้ โปรดลองอีกครั้ง',
    book_view_text4: 'ตารางหน้าเพจ',
    book_view_text5: 'คุณคิดอย่างไรกับการปรับปรุงการแปลของหนังสือเล่มเล็กนี้หรือโปรโมตและแบ่งปันรายได้?',
    book_view_text6: 'รายการหน้า',
    book_view_text7: 'การแก้ไขราคา',
    book_view_text8: 'ไม่สามารถแก้ไขได้เนื่องจากมีผู้ซื้อแล้ว',
    book_view_text9: 'ของขวัญจากผู้อ่าน',
    book_view_text10: 'เฉพาะผู้เขียนหนังสือเล่มเล็กเท่านั้นที่สามารถตอบกลับข้อความได้',
    book_view_modal_title: 'ปรับปรุงการแปลและโปรโมชัน',
    book_view_modal_text1: 'คุณสามารถปรับปรุงการแปลของหนังสือเล่มเล็กนี้เองได้หรือไม่? หรือช่วยโปรโมทได้หรือไม่?',
    book_view_modal_text2: 'ฝากข้อความถึงผู้เขียน',
    book_view_modal_text3: 'หากผู้เขียนอนุญาต คุณสามารถแบ่งปันรายได้ได้',

    book_view_write_share_title: 'หนังสือเล่มเล็กแบบเปิด',
    book_view_write_share_text1: 'คุณต้องการเป็นผู้เขียนร่วมของหนังสือเล่มเล็กนี้หรือไม่?',
    book_view_write_share_text2: 'สมัครเป็นผู้เขียน',
    book_view_write_share_text3: 'กรุณาฝากข้อความสมัครง่าย ๆ',
    book_view_write_share_text4: 'ส่ง',
    book_view_write_share_list_title: 'ผู้เขียนร่วม',
    book_view_write_share_text5: 'จัดการผู้เขียนร่วมของหนังสือเล่มเล็ก',
    book_view_write_share_text6: 'จัดการผู้เขียน',
    book_view_write_share_text7: 'ยอมรับ',
    book_view_write_share_text8: 'ยอมรับแล้ว',
    book_view_write_share_text9: 'ผู้ใช้ได้ลงทะเบียนเป็นผู้เขียนแล้ว',
    book_view_write_share_text10: 'เพิ่มผู้เขียนด้วยตนเอง',
    book_view_write_share_text11: 'ผู้ใช้ได้สมัครแล้ว',
    book_view_publish_text1: 'คุณต้องการเผยแพร่หนังสือเล่มเล็กนี้หรือไม่?',
    book_view_publish_text2: 'การเผยแพร่ทำให้ทุกคนสามารถเข้าถึงได้และคุณสามารถสร้างรายได้จากมันได้ด้วย',
    book_view_publish_text3: '(หากคุณเผยแพร่เพื่อขาย คุณไม่สามารถรวมหน้าของผู้เขียนคนอื่นได้)',
    book_view_publish_text4: 'กำหนดราคา',
    book_view_publish_text5: 'วันที่เผยแพร่',
    book_view_publish_text6: 'ขออนุญาตเผยแพร่',
    book_view_publish_text7: 'เผยแพร่ทันที',
    book_view_publish_text8: 'ระบุวันเผยแพร่',
    book_view_publish_text9: 'ยังไม่ได้',
    book_view_publish_text10: 'กำลังดำเนินการ',
    book_view_publish_text11: 'เผยแพร่แล้ว',
    book_view_publish_text12: 'สิ่งที่ต้องตรวจสอบเมื่อเผยแพร่',
    book_view_publish_text13: 'หนังสือเล่มเล็กนี้ไม่เคยถูกเผยแพร่ใน YouBook มาก่อน',
    book_view_publish_text14: 'หนังสือเล่มเล็กและหน้าเพจนี้ไม่มีการละเมิดเนื้อหาหรือทรัพย์สินทางปัญญาของผู้อื่น',
    book_view_publish_text15: 'หนังสือเล่มเล็กนี้ไม่มีถ้อยคำหยาบคาย เนื้อหาทางเพศที่มากเกินไป การหมิ่นประมาทผู้อื่น หรือโฆษณาเชิงพาณิชย์ และเป็นไปตามข้อกำหนดการใช้งานข้อ 2 วรรค 1',
    book_view_publish_text16: 'ใช่',
    book_view_publish_text17: 'รายงานการเผยแพร่',
    book_view_publish_text18: 'เผยแพร่แล้ว',
    book_view_publish_text19: 'วันที่',
    book_view_publish_text20: 'ราคา',
    book_view_publish_text21: 'การกำหนดระยะเวลาเปิด',
    book_view_publish_text22: 'ระยะเวลาเปิด',
    book_view_publish_text23: 'ระยะเวลาเปิดคืออะไร',
    book_view_publish_text24: 'ระยะเวลาเปิดหมายถึงช่วงเวลาที่ผู้อ่านสามารถดูเนื้อหาได้',
    book_view_publish_text25: 'หนังสือเล่มเล็กนี้มีมากกว่า 3 หน้า',
    book_view_publish_text26: 'หนังสือเล่มเล็กนี้มีไม่เกิน 3 หน้า',
    book_view_publish_text27: 'หากตรวจพบการละเมิด อัลกอริทึมอาจปรับอันดับการค้นหา หากปัญหาร้ายแรง หนังสือเล่มเล็กจะถูกลบโดยอัตโนมัติ',
    book_view_publish_text28: 'ตั้งค่าตัวเลือกการขาย',
    book_view_publish_text29: 'วิธีการซื้อ',
    book_view_publish_text30: 'วิธีการสนับสนุน',
    book_view_publish_message1: 'หากคุณเผยแพร่เพื่อขาย โปรดแน่ใจว่า 1) เนื้อหาหน้าเพจในหนังสือเล่มเล็กของคุณถูกเป็นของคุณเอง และ 2) คุณไม่เคยเผยแพร่เพื่อขายมาก่อน',
    book_view_publish_message2: 'ไม่อยู่ในสถานะที่สามารถเผยแพร่ได้ โปรดติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
    book_view_publish_message3: 'หนังสือเล่มเล็กนี้ได้ถูกเผยแพร่แล้ว',
    book_view_publish_message4: 'โปรดเลือกระยะเวลาเปิดหลังจากเวลาปัจจุบัน',
    book_view_publish_message5: 'โปรดเลือกทั้งวันที่และเวลา',
    book_view_publish_message6: 'การเผยแพร่ได้รับการยืนยันแล้ว ขอบคุณ',
    book_view_publish_message7: 'โปรดตรวจสอบรายการยืนยัน',
    book_view_publish_message8: 'วันที่สิ้นสุดไม่สามารถมาก่อนวันที่เริ่มต้นได้',
    book_view_publish_message9: 'หนังสือเล่มเล็กที่บันทึกชั่วคราวไม่สามารถเผยแพร่ได้',
    book_view_publish_message10: 'หนังสือเล่มเล็กนี้ได้รับการโอนสิทธิ์ สิทธิ์การเผยแพร่ แรกเป็นของ ผู้เขียน',
    book_view_publish_message11: 'กรุณากรอกจำนวนเงินอย่างน้อย {minPrice}',
    book_view_button_confirm: 'ยืนยันแล้ว',
    book_view_button_publish: 'เผยแพร่เลย',
    book_view_button_order: 'การจัดตำแหน่งหน้า',
    book_view_button_add: 'เพิ่มหน้าเพจ',
    book_view_button_video: 'เล่นวิดีโอ',
    book_view_button_read: 'อ่าน',
    book_view_button_lecture: 'ดูวิดีโอบรรยาย',
    book_view_page_add_title: 'เพิ่มหน้าเพจ',
    book_view_page_add_text1: 'หลังจากค้นหาหน้าเพจของ บุคคลที่สาม',
    book_view_page_add_text2: 'ในหน้าแสดงผล',
    book_view_page_add_text3: 'ใส่ในหนังสือเล่มเล็กของฉัน',
    book_view_page_add_text4: 'ถ้าคุณอยากสร้างหน้าเพจของคุณเองล่ะ?',
    book_view_page_add_text5: 'การสร้างหน้าเพจทำได้เฉพาะกับผู้ที่ลงทะเบียนแล้วเท่านั้น หากคุณต้องการลงทะเบียนเป็นผู้เขียน โปรดติดต่อเราที่ด้านล่าง',
    book_view_page_add_text6: 'คุณต้องการเพิ่มหน้าเพจของ บุคคลที่สาม หรือไม่?',
    book_view_page_add_text7: '* หากคุณเพิ่มหน้าเพจที่สร้างโดย บุคคลที่สาม \nจะไม่สามารถเผยแพร่เป็นหนังสือเล่มเล็กแบบมีค่าใช้จ่ายได้',
    book_view_page_add_text8: 'คุณเคยสร้างหน้าเพจไว้แล้วหรือไม่?',
    book_view_page_add_button1: 'สร้างตอนนี้เลย',
    book_view_page_add_button2: 'ดูหน้าเพจที่สร้างแล้ว',
    book_view_reference_text1: 'ความหลากหลาย',
    book_view_reference_text2: 'หลายอย่าง',
    book_view_reference_text3: 'ผู้เขียนหนังสือเล่มเล็ก',
    book_view_reference_text4: 'สร้างโดยผู้เขียน',
    book_view_support_text1: 'ฉันสนับสนุนคุณ',
    book_view_support_modal_title: 'โปรดเป็นผู้สนับสนุน',
    book_view_support_modal_text1: 'แม้แต่งานเขียนที่ดีก็ยากที่จะเผยแพร่ได้ด้วยตัวคนเดียว',
    book_view_support_modal_text2: 'ผู้สนับสนุนคือผู้ที่แบ่งปันหนังสือเล่มเล็กของผู้เขียนสู่โลก และคอยสนับสนุนซึ่งกันและกัน',
    book_view_support_modal_text3: 'เราจะร่วมกันส่งต่อเรื่องราวนี้ไปให้ไกลยิ่งขึ้น',
    book_view_support_modal_text4: 'กรุณาสนับสนุนผู้เขียน',
    book_view_support_modal_btn1: 'เข้าใจแล้ว',
    book_view_support_modal_text5: '"การสนับสนุนของคุณมีความหมายกับฉันมาก ขอบคุณค่ะ ฉันเองก็จะสนับสนุนการเดินทางของคุณด้วยหัวใจทั้งหมดของฉันเช่นกัน"',
    book_view_support_modal_text6: 'โปรดแบ่งปันหนังสือเล่มเล็กนี้กับโลก',
    book_view_support_modal_btn2: 'ต้องทำอย่างไร?',
    book_view_support_modal_title2: 'ฉันที่เดินทางมาถึงตรงนี้ เก่งมากเลย',
    book_view_support_modal_text7: 'การเขียนไม่ใช่เรื่องง่าย แต่ฉันก็ทำได้สำเร็จ',
    book_view_support_modal_text8: 'ตอนนี้ถึงเวลาที่จะเชื่อมั่นในตัวเอง และก้าวไปอีกขั้น',
    book_view_support_modal_text9: 'แม้จะรู้สึกเขินหรือลังเล ฉันก็ยังเลือกที่จะสนับสนุนตัวเองเป็นคนแรก และเปิดใจให้โลกได้รับรู้',
    book_view_support_modal_text10: 'เพราะฉันเชื่อว่ามันอาจจะมีความหมายสำหรับใครบางคน',
    book_view_support_modal_text11: 'กรุณาเป็นผู้สนับสนุนของฉัน',
    book_view_support_modal_text12: 'การเขียนหรือจัดกิจกรรมไม่ใช่เรื่องง่าย แต่ฉันก็กล้าทำมัน',
    book_view_support_modal_btn3: 'จะลองดู!',
    book_view_support_modal_title3: 'สวัสดี ผู้สนับสนุน',
    book_view_open_minibook_text1: 'คำขอหนังสือเล่มเล็กแบบเปิดเสร็จสมบูรณ์แล้ว',
    book_view_open_minibook_text2: 'คำขอหนังสือเล่มเล็กแบบเปิดถูกยกเลิกแล้ว',
    page_create_title: 'สร้างหน้าเพจ',
    page_create_text1: 'คุณยังไม่ได้สร้างภาพหน้าเพจ',
    page_create_text2: ' ',
    page_create_text3: 'หน้าเพจ',
    page_create_text4: 'ภาพหน้าเพจที่คุณสร้างแล้ว',
    page_create_text5: 'คุณสร้างภาพหน้าเพจแล้วหรือไม่?',
    page_create_text6: 'ใส่เนื้อหาของคุณ\nแนะนำไม่เกินหนึ่งหน้า A4',
    page_create_text7: 'ไบต์ปัจจุบัน',
    page_create_text8: 'แนะนำ',
    page_create_text9: 'มีอ้างอิงในหน้าเพจนี้หรือไม่?',
    page_create_text10: 'สร้างโดยคุณ',
    page_create_text11: 'หนังสือที่อ้างอิง',
    page_create_text12: 'บล็อกที่อ้างอิง',
    page_create_text13: 'อ้างอิง AI แล้ว',
    page_create_text14: 'นี่คือขั้นตอนในการสร้างหน้าเพจสำหรับหนังสือเล่มเล็ก',
    page_create_text15: 'อัปโหลดภาพหน้าเพจ',
    page_create_text16: 'คุณต้องการแปลใหม่หรือไม่?',
    page_create_text17: 'หากคุณต้องการแปลใหม่ โปรดเลือกเป้าหมายและภาษา (หากไม่ได้เลือก จะถูกบันทึกโดยไม่แปล)',
    page_create_text18: 'เป้าหมายการแปล',
    page_create_text19: 'ภาษาที่จะแปล',
    page_create_message1: 'ไม่สามารถแก้ไขได้',
    page_create_message2: 'ระบุเนื้อหาของคุณ',
    page_create_message3: 'ต้องการลบหน้าเพจหรือไม่?',
    page_create_message4: 'เนื้อหาเกินขนาดสูงสุด',
    page_create_reference_book: 'หนังสือ',
    page_create_reference_blog: 'บล็อก',
    page_create_reference_placeholder1: 'ระบุชื่อของ',
    page_create_reference_placeholder2: 'ลิงก์ที่เกี่ยวข้อง (เช่น https://www.amazon.com/dp…)',
    page_create_reference_placeholder3: 'ปีที่เผยแพร่ของ',
    page_create_reference_placeholder4: 'ผู้เขียนของ',
    page_create_title_placeholder: 'ชื่อจะปรากฏเช่นนี้',
    page_create_message5: 'กำลังแปล',
    page_create_message6: 'หลังจากสร้าง ปก แล้ว คุณสามารถสร้าง หน้าเพจ ได้',
    page_create_modal_text1: 'ไม่มีชื่อปรากฏบนภาพหน้าเพจ',
    page_create_modal_text2: '(ใช้ได้กับหน้าเพจที่แปลเป็นภาษาต่างประเทศด้วยเช่นกัน)',
    page_create_modal_text3: 'กรุณาตรวจสอบให้แน่ใจ!',
    page_create_modal_text4: 'หาก เนื้อหา มีการเปลี่ยนแปลง ต้อง บันทึกชั่วคราว',
    page_create_modal_text5: 'คุณได้ทำเช่นนั้นหรือไม่?',
    page_create_modal_text6: 'หาก เนื้อหา มีการเปลี่ยนแปลง ต้อง สร้าง',
    page_view_title: 'ดูหน้าเพจ',
    page_view_button_video: 'เล่นวิดีโอ',
    page_view_button_read: 'อ่าน',
    page_view_text1: 'หนังสือเล่มเล็ก',
    page_view_text2: 'เล่นอัตโนมัติ',
    page_view_text3: 'การอ่าน',
    page_view_text4: 'หน้าเพจที่เกี่ยวข้อง',
    page_view_text5: 'หนังสือเล่มเล็กที่เกี่ยวข้อง',
    page_view_text6: 'อ้างอิง',
    page_view_text7: 'อ้างอิง',
    page_view_text8: 'การเผยแพร่',
    page_view_text9: 'ผู้เขียน',
    page_view_text10: 'ชื่อเรื่อง',
    page_view_text11: 'ทุกหน้าเพจของการอ้างอิงนี้',
    page_view_text12: 'การค้นหาที่เกี่ยวข้อง',
    page_view_text13: 'หน้าเพจของผู้เขียน',
    page_view_text14: 'พบปะผู้เขียน',
    page_view_text15: 'เพิ่มเติม',
    page_view_reference_text1: 'หนังสือ',
    page_view_reference_text2: 'บล็อก',
    page_view_popup: 'คุณยังไม่มีหนังสือเล่มเล็กที่คุณสร้างเอง โปรดสร้างในหน้าเพจของฉัน',
    page_view_pay_popup_text1: 'คุณได้รับบางสิ่งจากการอ่านใช่ไหม? \nกรุณาตอบกลับผู้เขียนด้วยของขวัญเล็กๆ',
    page_view_pay_popup_title: 'ส่งของขวัญ',
    page_view_pay_popup_text2: 'เลือกชาเพื่อส่งเป็นของขวัญ',
    page_view_pay_popup_text3: 'เขียนข้อความจากใจ',
    page_view_pay_popup_placeholder1: 'คำพูดและความรู้ของผู้เขียนช่วยฉันได้มากจริงๆ',
    page_view_pay_popup_text4: 'จำนวนเงิน',
    page_view_pay_popup_button1: 'ซื้อและส่งข้อความ',
    page_view_pay_popup_text5: 'ผู้เขียนทุ่มเททั้งเวลาและความพยายามอย่างมากในการเขียนนี้\n\nกรุณาตอบกลับด้วยของขวัญเล็กๆ',
    page_view_pay_popup_placeholder2: 'ฉันเชื่อมั่นในประสบการณ์และความรู้สึกของผู้เขียน',
    page_view_pay_popup_text6: 'ไม่สนใจที่จะส่งของขวัญใช่ไหม?',
    page_view_pay_popup_text7: 'อยากดูโฆษณาแทนหรือไม่?',
    page_view_pay_popup_button2: 'ดูโฆษณาเพื่ออ่าน',
    page_sort_title: 'การจัดตำแหน่งหน้า',
    page_sort_subtitle: 'ลากหน้าเพื่อเปลี่ยนลำดับ',
    page_sort_text: 'แหล่งที่มา',
    pay_button: 'ซื้อตอนนี้',
    pay_price: 'ราคา',
    pay_vat_excluded: '(ไม่รวมภาษีมูลค่าเพิ่ม)',
    pay_message_success: 'ซื้อแล้ว',
    pay_message_fail: 'ล้มเหลว',
    pay_currency: 'บาท',
    pay_button_paid: 'ชำระเงินแล้ว',
    pay_button_view_price: 'ดูราคา',
    pay_total: 'รวมทั้งหมด',
    pay_methods: 'วิธีการชำระเงิน',
    pay_methods_creditcard: 'บัตรเครดิต',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'ดำเนินการต่อ',
    pay_text1: 'กรุณาเลือกชา',
    pay_text2: 'กรุณากรอกข้อความ',
    advertisement_button: 'อ่านเพิ่มเติม',
    advertisement_text1: 'คุณสามารถดูเนื้อหาได้หลังจากดูโฆษณา',
    advertisement_text2: 'หน้านี้เป็นของหนังสือเล่มเล็กที่ต้องชำระเงิน <br />ไปที่หน้าปกแล้วกด \'อ่าน\' เพื่อซื้อ <br />',
    advertisement_text3: 'คุณสามารถดูเนื้อหาได้หลังจากดูโฆษณา โฆษณาสามารถดูได้เฉพาะในแอปเท่านั้น',
    together_title: 'อีเวนต์',
    together_subtitle: 'พบและพูดคุยกับผู้อ่าน',
    together_subtitle_text1: 'พบผู้อ่านทางออนไลน์',
    together_subtitle_text2: 'สร้างห้องและเชิญคนเข้ามา',
    together_button: 'สร้างพื้นที่อีเวนต์',
    together_case: 'กรณี',
    together_case1: 'ฉันพยายามที่จะให้ แต่ฉันก็ยังได้รับอยู่',
    together_case2: 'ไม่เคยรู้เลยว่าตัวอย่างสถานการณ์จริงช่วยได้มากขนาดนี้',
    together_subtitle2: 'พื้นที่ที่ฉันสร้าง',
    together_category1: 'ล่าสุด',
    together_category2: 'ที่ชื่นชอบที่สุด',
    together_button_viewmore: 'เพิ่มเติม',
    together_list_date: 'YYYY. MM.DD',
    together_list_date2: 'YYYY.MM.DD. A hh:mm',
    together_subtitle3: 'พื้นที่แบบนี้',
    together_subtitle3_1: 'กรุณาสร้างให้หน่อย',
    together_subtitle_text3: 'ใครก็ตามที่เริ่มต้น ฉันจะเข้าร่วมด้วย',
    together_create_title: 'สร้างพื้นที่อีเวนต์',
    together_create_title2: 'แก้ไขพื้นที่อีเวนต์',
    together_create_button1: 'เลือก',
    together_create_subtitle: 'ชื่อเรื่อง',
    together_create_placeholder1: 'ระบุชื่อ',
    together_create_subtitle1: 'บทนำอย่างย่อ',
    together_create_placeholder2: 'ระบุบทนำอย่างย่อ',
    together_create_subtitle2: 'เลือกเครื่องมือที่จะใช้',
    together_create_text1: 'ลิงก์สำหรับการประชุมออนไลน์ (เช่น ลิงก์ Zoom)',
    together_create_placeholder3: 'กรุณาใส่ลิงก์สำหรับการประชุมออนไลน์',
    together_create_question1: 'ไม่ทราบลิงก์ Zoom?',
    together_create_q1_a_title: 'ค้นหาลิงก์เพื่อเข้าร่วม Zoom',
    together_create_text2: 'ใช้เมทาเวิร์ส',
    together_create_placeholder4: 'เลือกอันที่เหมาะสมกับร่วมกัน',
    together_create_question2: 'ไม่รู้จักเมทาเวิร์ส?',
    together_create_text3: 'เลือกแหล่งที่เปิด',
    together_create_dropmenu1: 'เปิดที่มุมผู้ที่ได้รับเชิญจาก YB',
    together_create_dropmenu2: 'เปิดที่มุมผู้เขียนและผู้อ่าน',
    together_create_button2: 'บันทึก',
    together_create_button3: 'สร้าง',
    together_create_popup_title: 'เลือกอันที่เหมาะสมกับร่วมกัน',
    together_create_popup_alert: 'เลือกแล้ว',
    together_create_button4: 'เลือก',
    together_create_alert: 'กรุณาใส่ลิงก์สำหรับการประชุมออนไลน์',
    together_create_alert1: 'ระบุชื่อเรื่อง',
    together_create_alert2: 'เลือกเมทาเวิร์สที่จะใช้',
    together_create_alert3: 'ไม่สามารถแก้ไขได้',
    together_create_alert4: 'สร้างพื้นที่อีเวนต์เรียบร้อยแล้ว',
    together_create_alert5: 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',
    together_create_alert6: 'การสร้างพื้นที่อีเวนต์ล้มเหลว...',
    together_qa_popup_title1: 'ค้าหาลิงก์เพื่อเข้าร่วม Zoom',
    together_qa_popup_btext1: 'คอมพิวเตอร์',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'เปิดโปรแกรม Zoom - หลังจากเข้าสู่ระบบ - คลิกเมนูการประชุมด้านบน - รหัสการประชุมส่วนตัวของฉัน - คลิกแสดงคำเชิญการประชุม - จะปรากฏลิงก์เข้าร่วมการประชุม Zoom และคัดลอกไว้',
    together_qa_popup_btext2: 'สมาร์ทโฟน',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'เปิดโปรแกรม Zoom - หลังจากเข้าสู่ระบบ - กดปุ่ม i ที่มุมบนขวา - ส่งคำเชิญ - หลังจากกดข้อความ - ใส่หมายเลขโทรศัพท์ของคุณ - ลิงก์จะปรากฏ และคัดลอกไว้',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'เมทาเวิร์สคืออะไร?',
    together_qa_popup_text3: 'นี่คือห้องประชุมเสมือนจริง',
    together_qa_popup_text4: 'ปรากฏในรูปแบบของอวาตาร์',
    together_qa_popup_text5: 'คุณได้เข้าร่วม - พูดคุยกับเพื่อนของคุณแบบตัวต่อตัว - คุณยังสามารถแชร์หน้าจอของคุณได้',
    together_qa_popup_text7: 'ในห้องประชุมหนึ่ง',
    together_qa_popup_text8: '- สามารถเข้าประชุมได้ 10 คนในเวลาเดียวกัน',
    together_qa_popup_text9: 'ไม่จำเป็นต้องติดตั้งโปรแกรมเพิ่มเติม',
    together_qa_popup_text10: 'หรือไม่ต้องสมัครสมาชิก',
    together_more_list_title: 'พื้นที่อีเวนต์',
    together_more_list_date: 'YYYY.MM.DD',
    together_request_list_title: 'กรุณาสร้างให้หน่อย',
    together_request_list_category1: 'ที่ชื่นชอบที่สุด',
    together_request_list_category2: 'ล่าสุด',
    together_request_list_button: 'เสนอพื้นที่ใหม่',
    together_request_popup_title: 'ข้อเสนอพื้นที่ใหม่',
    together_request_popup_alert1: 'ระบุชื่อเรื่อง',
    together_request_popup_alert2: 'ระบุบทนำอย่างย่อ',
    together_request_popup_placeholder1: 'ระบุชื่อเรื่อง',
    together_request_popup_placeholder2: 'ระบุบทนำอย่างย่อ',
    together_request_popup_button: 'บันทึก',
    together_request_detail_button: 'สร้างพื้นที่นี้',
    together_detail_sns: 'แชร์',
    together_detail_enterbtn: 'เข้าสู่',
    together_detail_btn1: 'รายการอีเวนต์',
    together_detail_btn2: 'ข้อความ',
    together_detail_subtitle: 'หนังสือเล่มเล็กเกี่ยวกับหัวข้อ',
    together_detail_alert: 'รอสักครู่..',
    together_detail_alert1: 'เสนอพื้นที่อีเวนต์สำเร็จแล้ว!',
    together_detail_alert2: 'การเสนอพื้นที่อีเวนต์ล้มเหลว…',
    together_detail_alert3: 'ที่ชื่นชอบ / ยกเลิกที่ชื่นชอบสำเร็จ',
    together_detail_alert4: 'ที่ชื่นชอบ / ยกเลิกที่ชื่นชอบไม่สำเร็จ',
    together_detail_alert5: 'มีปัญหาในเซิร์ฟเวอร์ โปรดลองใหม่ภายหลัง',
    together_detail_alert6: 'มีปัญหากับลิงก์สำหรับการประชุมออนไลน์',
    together_detail_alert7: 'ไม่สามารถลบได้',
    together_notice_alert: 'ต้องการลบประกาศหรือไม่?',
    together_notice_list_title: 'ประกาศ',
    together_button_addtopic: 'เพิ่มสิ่งนี้เป็นหัวข้อในพื้นที่อีเวนต์',
    together_add_alert: 'เพิ่มไปยังพื้นที่อีเวนต์เรียบร้อยแล้ว',
    together_text1: 'มีรสนิยมคล้ายกับคุณ',
    together_text2: 'คุณต้องการลบพื้นที่อีเวนต์นี้หรือไม่?',
    together_event_btn: 'สร้างอีเวนต์ใหม่',
    together_event_title: 'อีเวนต์ใหม่',
    together_event_placeholder: 'กรุณาใส่คำแนะนำ',
    together_event_text1: 'กำหนดตารางเวลา',
    together_event_text2: 'กำหนดค่าธรรมเนียมเข้าชม',
    together_event_text3: 'กำหนดจำนวนคนสูงสุด',
    together_event_text4: 'ตารางเวลา',
    together_event_text5: 'ค่าธรรมเนียมเข้าชม',
    together_event_text6: 'จำนวนคนสูงสุด',
    together_event_text7: 'แจ้งเตือนผู้ติดตามของฉัน',
    together_event_text8: 'คุณต้องการลบอีเวนต์หรือไม่?',
    together_event_text9: 'โปรดตั้งเวลาเริ่มต้นหลังเวลาปัจจุบัน',
    together_event_text10: 'โปรดตั้งเวลาสิ้นสุดหลังเวลาเริ่มต้น',
    together_event_text11: 'เวลาเริ่มต้นและเวลาสิ้นสุดต้องไม่เหมือนกัน',
    together_event_text12: 'เพิ่มเป็นหัวข้ออีเวนต์นี้',
    together_event_text13: 'เพิ่มในอีเวนต์แล้ว',
    together_event_text14: 'จำนวนคนสูงสุดของอีเวนต์ถูกเกินกำหนดแล้ว',
    together_event_text15: 'ปุ่มจะเปิดใช้งานก่อนเริ่มอีเวนต์ 1 ชั่วโมง \n(หากฟรีไม่จำเป็นต้องซื้อตอนนี้)',
    together_event_text16: 'ปุ่มจะเปิดใช้งานก่อนเริ่มอีเวนต์ 1 ชั่วโมง',
    together_event_text17: 'ไม่มีอีเวนต์',
    together_event_text18: 'ไม่สามารถลบได้หากมีผู้ซื้ออีเวนต์',
    together_event_text19: 'คุณต้องการส่งการแจ้งเตือนหรือไม่?',
    together_event_text20: 'ส่งแล้ว',
    together_event_text21: ' รายการอีเวนต์',
    together_event_text22: 'ดูรายละเอียด',
    together_event_text23: 'หลังจากสมัครสมาชิก กรุณาเข้าสู่ระบบ',
    together_event_text24: 'วิธีเข้าร่วม',
    together_event_text25: 'เข้าร่วมกิจกรรมเสร็จสิ้น',
    together_event_text26: 'ผู้เขียนใช้เวลาและความตั้งใจอย่างมากในกิจกรรมนี้\n\nโปรดตอบกลับด้วยของขวัญเล็กๆ',
    together_event_text27: 'ความรู้จากประสบการณ์ของผู้เขียนและการสื่อสารอย่างลึกซึ้งน่าประทับใจมาก',
    together_event_text28: 'แบ่งปันกิจกรรมนี้ให้โลกได้รับรู้',
    together_event_text29: 'การจัดกิจกรรมนี้ไม่ง่ายเลย แต่ฉันทำได้',
    together_event_text30: 'ไม่ว่าอีเวนต์จะดีแค่ไหน การเผยแพร่คนเดียวก็เป็นเรื่องยาก',
    together_event_text31: 'ผู้สนับสนุนคือผู้ที่เผยแพร่อีเวนต์ของผู้เขียนไปยังโลก เป็นผู้ที่ให้กำลังใจซึ่งกันและกัน',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'พบปะผู้คนจากทั่วโลก',
    youbooker_case: 'กรณี',
    youbooker_case_text1: 'เป็นคนที่เริ่มต้นก่อนเสมอ',
    youbooker_case_text2: 'ผลลัพธ์ของดอกเบี้ยทบต้นกับองค์ความรู้?',
    youbooker_translation: 'อยากพบกันตอนนี้เลยไหม?',
    youbooker_translation_text1: 'ทุกภาษา',
    youbooker_category: 'ผู้ติดตาม / กำลังติดตาม',
    youbooker_subcategory1: 'ผู้ติดตามของฉัน',
    youbooker_subcategory2: 'ฉันกำลังติดตาม',
    youbooker_subtitle2: 'พวกเขากำลังติดตามฉัน',
    youbooker_button_follow: 'ติดตาม',
    youbooker_message_follow: 'ติดตาม',
    youbooker_button_follow_cancel: 'เลิกติดตาม',
    youbooker_subtitle3: 'ผู้ใช้ที่คุณรู้จัก',
    youbooker_subtitle4: 'ฉันกำลังติดตามพวกเขา',
    youbooker_subtitle5: 'พวกเขายังไม่รู้จัก YB',
    youbooker_button_invite: 'เชิญ',
    youbooker_alert_invite: 'การเชิญได้เฉพาะผ่านแอปพลิเคชันเท่านั้น โปรดดาวน์โหลดแอปพลิเคชัน',
    youbooker_alert: 'เฉพาะในแอปพลิเคชันเท่านั้น ทำไมไม่ดาวน์โหลดแอปพลิเคชัน?',
    youbooker_alert2: 'รีเฟรชสำเร็จ!',
    youbooker_alert3: 'คุณสามารถค้นหาในแท็บ youBooker',
    home_page_text1: 'ล่าสุด',
    home_page_text2: 'อิทธิพล',
    home_page_today_title: 'หัวข้อวันนี้',
    home_page_today_subtitle: 'เกี่ยวข้องกับข่าวสำคัญ',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: 'หัวข้อวันนี้',
    home_page_today_detail_sns: 'แชร์',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: 'หน้าเพจที่เกี่ยวข้อง',
    home_page_explor_title: 'การสำรวจหน้าเพจ',
    home_page_explor_subtitle: 'ถ้าคลิกสองครั้งจะเกิดอะไรขึ้น?',
    home_page_recommend_title: 'คำแนะนำ',
    home_page_recommend_subtitle: 'หน้าเพจที่คุณอาจสนใจ',
    home_page_theysee_title: 'พวกเขาเห็นอะไร',
    home_page_theysee_subtitle: 'หน้าเพจที่ผู้อ่านส่วนใหญ่เห็น',
    home_page_common_title: 'ความเข้าใจทั่วไป',
    home_page_common_subtitle: 'คุณควรรู้เรื่องนี้',
    home_page_keyw_title: 'หน้าเพจตามคำหลัก',
    home_page_keyw_subtitle: 'ค้นหาหน้าเพจที่เกี่ยวข้องทั้งหมด',
    home_page_random_title: 'ไปแบบสุ่ม',
    home_page_random_subtitle: 'กดเมื่อสงสัย แล้วเรียนรู้บางอย่างที่ไม่คาดคิด',
    home_page_about_title: 'เกี่ยวกับ YouBook',
    home_page_about_detail: 'Corporation: NICK syndicate<br />ศูนย์ธุรกิจในประเทศไทย: กรุงเทพมหานคร<br />ศูนย์ประเทศอื่นๆ: ซีแอตเทิล โตเกียว เซี่ยงไฮ้ โซล<br />ติดต่อ: joa@academy-connect.net<br />DUNS 695937905',
    settlement_title: 'การซื้อและ & การชำระเงิน',
    settlement_tab1: 'บันทึกการสั่งซื้อ',
    settlement_tab2: 'ข้อมูลบัญชี',
    settlement_tab3: 'บันทึกการชำระเงิน',
    settlement_category1: 'บันทึกการซื้อของฉัน',
    settlement_category2: 'การแบ่งปันสิทธิ์ของผู้เขียน',
    settlement_category3: 'บันทึกรายได้จากหนังสือเล่มเล็ก',
    settlement_category4: 'บันทึกรายได้จากอีเวนต์',
    settlement_category5: 'จัดการบัญชี',
    settlement_text1: 'แสดงบันทึกการซื้อ',
    settlement_text2: 'คุณสามารถแบ่งปันสิทธิ์ของผู้เขียนของหนังสือเล่มเล็ก',
    settlement_text3: 'คุณตรวจสอบบันทึกการชำระเงินของหนังสือเล่มเล็กที่คุณจ่ายแล้ว',
    settlement_text4: 'หากคุณมีคำถามเพิ่มเติม คลิก',
    settlement_text5: 'ที่นี่',
    settlement_text6: 'หรือโปรดติดต่อเราที่ด้านล่าง',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'อยากบอกอะไรไหม',
    settlement_text9: 'หากมีรายได้ คุณต้องจัดการบัญชีเพื่อรับเงิน',
    settlement_text10: 'รายได้จากอีเวนต์จะถูกคำนวณ',
    settlement_purchase_text1: 'บันทึกการซื้อ',
    settlement_purchase_text2: 'วันที่',
    settlement_purchase_text3: 'ยอดซื้อ',
    settlement_purchase_text4: 'ชื่อ',
    settlement_purchase_text5: 'หนังสือเล่มเล็ก',
    settlement_purchase_text6: 'อีเวนต์',
    settlement_accountInfo_text1: 'สิทธิ์ของผู้เขียนของหนังสือเล่มเล็ก',
    settlement_accountInfo_text2: 'หนังสือเล่มเล็ก',
    settlement_accountInfo_text3: 'ภาษา',
    settlement_accountInfo_text4: 'สิทธิ์ของผู้เขียน',
    settlement_accountInfo_text5: 'ผู้เขียน',
    settlement_accountInfo_text6: 'บุคคลที่สาม',
    settlement_accountInfo_text7: 'ส่วนบุคคลหรือไม่?',
    settlement_accountInfo_text8: 'ส่วนบุคคล',
    settlement_accountInfo_text9: 'บริษัท',
    settlement_accountInfo_text10: 'ชื่อธนาคาร',
    settlement_accountInfo_text10_message: 'เลือกชื่อธนาคาร',
    settlement_accountInfo_text11: 'ชื่อเจ้าของบัญชี',
    settlement_accountInfo_text11_message: 'ใส่ชื่อเจ้าของบัญชี',
    settlement_accountInfo_text12: 'หมายเลขบัญชี',
    settlement_accountInfo_text12_message: 'ใส่หมายเลขบัญชี',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'หมายเลขประจำตัวประชาชน',
    settlement_accountInfo_text13_message: 'ใส่หมายเลขประจำตัวประชาชน',
    settlement_accountInfo_text13_placeholder: '1-2345-12345-67-8',
    settlement_accountInfo_text14: 'ที่อยู่ส่วนบุคคล',
    settlement_accountInfo_text14_message: 'ใส่ที่อยู่ส่วนบุคคล',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'อีเมล',
    settlement_accountInfo_text15_message: 'ใส่อีเมล',
    settlement_accountInfo_text16: 'บันทึก',
    settlement_accountInfo_text17: 'หมายเลขประจำตัวผู้เสียภาษีนิติบุคคล',
    settlement_accountInfo_text17_message: 'ใส่หมายเลขประจำผู้เสียภาษีนิติบุคคล',
    settlement_accountInfo_text17_placeholder: '1-2345-12345-67-8',
    settlement_accountInfo_text18: 'ที่อยู่บริษัท',
    settlement_accountInfo_text18_message: 'ใส่ที่อยู่บริษัท',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'ชื่อบริษัท',
    settlement_accountInfo_text19_message: 'ใส่ชื่อบริษัท',
    settlement_accountInfo_text20: 'โทรศัพท์บริษัท',
    settlement_accountInfo_text20_message: 'ใส่รายละเอียดการติดต่อบริษัท',
    settlement_accountInfo_text21: 'หมายเลขบุคคลที่สาม',
    settlement_accountInfo_text21_placeholder: 'อีเมลของบุคคลที่สาม',
    settlement_accountInfo_text22: 'หมายเลขบัญชีรับเงิน',
    settlement_accountInfo_text23: 'ประเทศ',
    settlement_accountInfo_message1: 'ไม่พบอีเมล',
    settlement_accountInfo_message2: 'คุณไม่สามารถแบ่งปันสิทธิ์ของผู้เขียนกับตัวเองได้',
    settlement_accountInfo_message3: 'ไม่มีหนังสือเล่มเล็กที่สร้างขึ้น',
    settlement_accountInfo_text24: 'การแบ่งปันสิทธิ์ของผู้เขียน',
    settlement_accountInfo_text25: 'หากคุณแบ่งปันสิทธิ์ของผู้เขียนกับบุคคลที่สาม คุณจะไม่สามารถเรียกคืนได้',
    settlement_accountInfo_text26: 'คุณต้องการแบ่งปันสิทธิ์ของผู้เขียนหรือไม่?',
    settlement_accountInfo_text27: 'ใช่ ฉันแบ่งปัน',
    settlement_accountInfo_text28: 'ในกรณีที่แบ่งปันสิทธิ์ของผู้เขียน <br /> 1) หน้าเพจในหนังสือเล่มเล็กต้องเป็นของคุณเอง และ <br /> 2) ไม่เคยแบ่งปันกับบุคคลที่สามมาก่อน',
    settlement_accountInfo_text29: 'ตกลง ฉันจะแก้ไข',
    settlement_accountInfo_text30: 'คุณได้แบ่งปันสิทธิ์ของผู้เขียนหนังสือเล่มเล็กนี้กับบุคคลที่สามแล้ว',
    settlement_accountInfo_text31: 'ผู้เขียน',
    settlement_accountInfo_text32: 'บุคคลที่สาม',
    settlement_accountInfo_text33: 'คุณได้รับสิทธิ์ของผู้เขียนหนังสือเล่มเล็กนี้จากผู้เขียน',
    settlement_accountInfo_text34: 'นี่คือหนังสือเล่มเล็กฟรี ไม่จำเป็นต้องมีบัญชี',
    settlement_accountInfo_text35: 'การแบ่งปันรายได้',
    settlement_accountInfo_text36: '(ฉัน)',
    settlement_accountInfo_text37: '(สำนักพิมพ์ ฯลฯ)',
    settlement_accountInfo_text38: 'บัญชีส่วนบุคคล',
    settlement_accountInfo_text39: 'บัญชีบริษัท',
    settlement_accountInfo_text40: 'การจัดการบัญชี',
    settlement_accountInfo_text41: 'บันทึก',
    settlement_accountInfo_text42: 'ธนาคาร',
    settlement_accountInfo_text43: 'การเลือกบัญชี',
    settlement_accountInfo_text44: 'กำหนดวิธีแบ่งรายได้',
    settlement_accountInfo_text45: 'อัตรารายได้ (%)',
    settlement_accountInfo_text46: 'ID ของฉัน (email)',
    settlement_accountInfo_text47: 'ID ของบุคคลที่สาม (email)',
    settlement_accountInfo_text48: 'ปรับรวมให้ตรง',
    settlement_accountInfo_text49: 'กรุณากรอกข้อมูลของผู้รับสิทธิ์',
    settlement_accountInfo_text50: 'อัตรารายได้ต้องไม่เกิน 100',
    settlement_accountInfo_text51: 'ผู้มอบสิทธิ์ ID(email)',
    settlement_accountInfo_text52: 'ผู้รับสิทธิ์ ID(email)',
    settlement_earnings_text1: 'บันทึกการชำระเงิน',
    settlement_earnings_text2: 'ระยะเวลาการชำระเงิน',
    settlement_earnings_text3: 'ราคาหนังสือเล่มเล็ก',
    settlement_earnings_text4: 'จำนวนการขาย',
    settlement_earnings_text5: 'ยอดขาย',
    settlement_earnings_text6: 'รวมรายการหักรวมภาษี',
    settlement_earnings_text7: 'จำนวนเงินฝาก',
    settlement_earnings_text8: 'วันที่ฝากเงิน',
    settlement_earnings_text9: 'ยอดเข้าชมโฆษณา',
    settlement_earnings_text10: 'ยอดรวม',
    settlement_earnings_text11: 'เรียนรู้เพิ่มเติม',
    settlement_earnings_text12: 'ราคาค่าโฆษณา',
    settlement_earnings_text13: 'รายได้',
    settlement_earnings_text14: 'หนังสือเล่มเล็กทั้งหมด',
    settlement_earnings_text15: 'เลือกอีเวนต์',
    settlement_earnings_text16: 'อีเวนต์ทั้งหมด',
    settlement_statistics_text1: 'ปริมาณการขาย',
    settlement_statistics_text2: 'จำนวนผู้อ่าน',
    settlement_statistics_text3: '(ที่ผ่านมา)',
    settlement_statistics_text4: '1 เดือน',
    settlement_statistics_text5: '6 เดือน',
    settlement_statistics_text6: '1 ปี',
    settlement_statistics_text7: 'ไม่พบข้อมูล',
    settlement_statistics_text8: 'การวิเคราะห์การขาย',
    settlement_statistics_text9: 'จำนวนการดูโฆษณา',
    settlement_statistics_text10: 'ทุกภาษา',
    terms_title: 'เงื่อนไขการให้บริการ',
    terms_text: '',
    privacy_title: 'นโยบายความเป็นส่วนตัว',
    privacy_text: ' ',
    // common text
    message_save: 'บันทึกแล้ว',
    message_fail: 'ล้มเหลว',
    message_delete: 'ลบแล้ว',
    message_report: 'รายงานแล้ว',
    message_search_no_result: 'ไม่พบผลการค้นหา',
    message_search_enter: 'โปรดใส่คำค้นหา',
    message_error1: 'เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ',
    message_save2: 'บันทึกแล้ว',
    message_fail2: 'ล้มเหลว',
    message_login: 'คุณต้องเข้าสู่ระบบ',
    name: 'ชื่อ',
    email: 'อีเมล',
    mobile: 'มือถือ',
    list: 'รายการ',
    edit: 'แก้ไข',
    delete: 'ลบ',
    search: 'ค้นหา',
    report: 'รายงานเนื้อหา',
    user: 'ผู้ใช้',
    report_type: 'ประเภทของรายงาน',
    report_type1: 'คำหยาบ/หมิ่นประมาท',
    report_type2: 'โฆษณา',
    report_type3: 'ลามก/เนื้อหาทางเพศชัดเจน',
    report_type4: 'ซ้ำเนื้อหาเดิม',
    report_type5: 'อื่นๆ',
    search_book: 'ค้นหาหนังสือเล่มเล็ก',
    serch_placeholder: 'ค้นหาด้วยชื่อหรืออีเมล',
    search_keyword: 'คำหลัก',
    search_reference: 'อ้างอิง',
    search_author: 'ผู้เขียน',
    search_result: 'พบแล้ว',
    button_report: 'รายงานไปยัง YouBook',
    button_write: 'บันทึก',
    button_login: 'เข้าสู่ระบบ',
    button_more: 'เพิ่มเติม',
    button_confirm: 'ยืนยันแล้ว',
    button_save: 'บันทึก',
    button_crop: 'ครอบตัด',
    button_delete: 'ลบ',
    button_complete: 'สมบูรณ์',
    colorbox_background_text1: 'เลือกสีพื้นหลัง',
    colorbox_font_text1: 'เลือกสีข้อความ',
    menu_home: 'หน้าหลัก',
    menu_page: 'หน้าเพจ',
    menu_book: 'หนังสือเล่มเล็ก',
    menu_memo: 'บันทึก',
    menu_together: 'อีเวนต์',
    login_button: 'เข้าสู่ระบบ',
    message_text1: 'ตอบกลับ',
    message_text2: 'มีคนตอบคอมเมนต์ของเราแล้วนะ',
  },
  vi: {
    home_banner_title1: 'Sách nhỏ mới',
    home_banner_title2: 'Sự kiện mới',
    home_slide_title1: 'Đang thịnh hành',
    home_slide_title2: 'Gu của tôi',
    home_slide_title3: 'Đang hot',
    home_slide_title4: 'Rất phổ biến',
    home_detail_title1: 'Ký ức đời thường',
    home_detail_title2: 'Video được đề xuất',
    home_detail_title3: 'Nếu bạn muốn biết thêm',
    home_detail_text1: 'Ghi chú sách nhỏ',
    home_detail_text2: 'Ghi chú hàng ngày',
    home_setting_title: 'Cài đặt',
    home_setting_text1: 'Trang đã xem trong 30 ngày qua',
    home_setting_text2: 'Đăng xuất',
    home_setting_text3: 'Xóa tài khoản',
    home_book_banner_question: 'Tôi có thắc mắc',
    home_book_banner_write_placeholder1: 'Nhập tiêu đề',
    home_book_banner_write_placeholder2: 'Nhập nội dung',
    home_book_banner_write_button: 'Lưu',
    home_book_banner_detail_text1: 'Câu trả lời của người cố vấn YouBook',
    home_book_banner_detail_text2: 'Có một số kiến ​​thức về YouBook',

    home_book_create_button: 'Sách Nhỏ - Hãy Tạo Ngay',
    home_book_create_text1: 'Sách nhỏ là một cuốn sách ngắn khoảng 10 trang. Được thiết kế phù hợp với xu hướng đọc nhanh, nội dung ngắn gọn nhưng vẫn đầy đủ ý chính.',
    home_book_create_text2: 'Cách chỉnh sửa sau khi xuất bản',
    home_book_create_text3: 'Sách nhỏ, cách tạo dễ dàng',
    home_book_create_text4: 'Tác giả có thể kiếm được bao nhiêu?',
    home_book_create_text5: 'Làm thế nào để gặp gỡ độc giả?',
    home_book_create_text6: '5 lý do bạn nên sử dụng YouBook',
    home_book_create_text7: 'Còn thắc mắc nào khác không?',
    home_book_create_text8: 'Tôi có thể theo dõi doanh số theo thời gian thực không?',
    home_book_create_text9: 'Hãy viết mỗi ngày một cách đều đặn!',
    home_book_create_text10: 'Bắt đầu ngay bây giờ!',

    home_book_category_title1: 'Vấn đề hôm nay và sách nhỏ',
    home_book_category_title2: 'Sách nhỏ được chú ý',
    home_book_category_title3: 'Sách nhỏ của Giáo sư S-class',
    home_book_category_title4: 'Gợi ý cá nhân',
    home_book_category_title5: 'Sách nhỏ tinh túy từ sách bán chạy',
    home_book_category_title6: 'Cùng Mèo Sách',
    home_book_category_title6_text1: 'Xem',
    home_book_category_title6_text2: 'Thu gọn',
    home_book_category_title7: 'Khám phá trang trong mạng nơ-ron',
    home_book_category_title8: 'Lễ hội nghệ thuật và cảm xúc',
    home_book_category_title8_text1: 'Thế giới trong phim và kịch',
    home_book_category_title8_text2: 'Giai điệu và động tác chạm đến tâm hồn',
    home_book_category_title8_text3: 'Nghệ thuật không biên giới',
    home_book_category_title8_text4: 'Mặc cá tính: Trang phục và phong cách',
    home_book_category_title9: 'Văn hóa ẩm thực và sự thư giãn',
    home_book_category_title9_text1: 'Khám phá ẩm thực, tìm hiểu món địa phương',
    home_book_category_title9_text2: 'Câu chuyện về rượu và cuộc sống',
    home_book_category_title9_text3: 'Sức hút của đồ ăn vặt và tráng miệng',
    home_book_category_title9_text4: 'Sức mạnh từ thiên nhiên, bí mật của thực vật',
    home_book_category_title10: 'Trí tuệ cuộc sống và tự khám phá',
    home_book_category_title10_text1: 'Cách quản lý tiền độc đáo',
    home_book_category_title10_text2: 'Công thức phát triển cá nhân',
    home_book_category_title10_text3: 'Vấn đề và giải pháp trong mối quan hệ',
    home_book_category_title10_text4: 'Khám phá và tri thức mới',
    home_book_category_title11: 'Đa dạng giá trị và tình yêu',
    home_book_category_title11_text1: 'Câu chuyện cuộc sống của họ',
    home_book_category_title11_text2: 'Triết lý và giá trị khác biệt',
    home_book_category_title11_text3: 'Niềm tin tôn giáo và truyền thống',
    home_book_category_title11_text4: 'Bí ẩn của tình yêu',
    home_book_category_title12: 'Một ngày đầy ắp du lịch và sở thích',
    home_book_category_title12_text1: 'Điểm đến ẩn giấu cần ghé thăm',
    home_book_category_title12_text2: 'Niềm vui cuộc sống qua sở thích',
    home_book_category_title12_text3: 'Văn hóa độc đáo qua trò chơi',
    home_book_category_title13: 'Sự phong phú của truyền thống và câu chuyện',
    home_book_category_title13_text1: 'Thần thoại và câu chuyện anh hùng địa phương',
    home_book_category_title13_text2: 'Hành trình văn học toàn cầu',
    home_book_category_title13_text3: 'Lịch sử và trí tuệ của các nơi',
    home_book_category_title13_text4: 'Câu chuyện xã hội đa sắc',

    home_book_category_title1_text2: 'Suy nghĩ của Mèo Sách – Muốn xem thử không?',
    home_book_category_title1_text3: 'Đang băn khoăn? Tò mò?',
    home_book_category_title1_text4: 'Bạn có muốn gợi ý sách nhỏ không?',
    home_book_search_placeholder1: 'Hãy nói ở đây',
    home_book_search_placeholder2: 'Từ khóa là gì?',

    home_book_search_message1: 'Nhập câu hỏi của bạn',
    home_book_search_message2: 'Nhập lại câu hỏi của bạn',
    home_book_search_text1: 'Thảo luận với tôi về trang này nhé?',
    home_book_search_text2: 'Thảo luận với tôi về Sách nhỏ này nhé?',
    home_book_search_text3: 'Hỏi',
    home_book_search_text4: 'Bạn có thể lưu nội dung trên',
    home_book_search_text5: '(Hãy thêm từ khóa)',
    home_book_search_text6: 'Tìm kiếm',

    home_book_theme_title: 'Sách theo chủ đề',
    home_instant_text1: 'Nhập từ khóa',
    home_instant_text2: 'Nhập ngẫu nhiên',
    home_book_company_info: 'Nếu có thêm thắc mắc, hãy liên hệ với chúng tôi dưới đây. Chúng tôi sẽ hỗ trợ bạn.',
    home_page_search_text1: 'Tìm kiếm trang',
    home_page_search_text2: 'Có thể xem dưới dạng video ngay lập tức',
    home_page_search_text3: 'Tìm kiếm nâng cao',
    home_page_search_text4: 'Xem dạng danh sách',
    home_page_search_text5: 'Xem dạng mạng',
    home_page_explor_alert: 'Không có trang nào được chọn',
    home_page_explor_alert2: 'Bạn đã vượt quá số trang tối đa có thể xem được trên một màn hình (150). Vui lòng bỏ những trang không cần thiết vào thùng rác.',
    home_page_explor_alert3: 'Không còn thông tin nào để tải',
    my_login_title: 'CỦA TÔI',
    my_login_text1: 'Trang trí hồ sơ của tôi thật phong cách',
    my_login_text2: 'Đăng nhập ngay và trở nên thông minh hơn',
    my_login_text3: 'với YouBook',
    my_login_find_password: 'Tìm mật khẩu',
    my_guide_minibook: 'Làm sao để tạo Sách nhỏ',
    my_password_reset: 'Đặt lại mật khẩu',
    my_password_reset_text1: 'Nhập địa chỉ email đã sử dụng khi đăng ký',
    my_password_reset_button1: 'Gửi liên kết để đặt lại',
    my_password_reset_button2: 'Đặt lại',
    my_password_reset_message1: 'Không thể tìm thấy email của bạn',
    my_password_reset_message2: 'Đã gửi liên kết đặt lại mật khẩu đến email đã nhập.',
    my_password_reset_message3: 'Vui lòng đặt lại mật khẩu bằng liên kết đã gửi đến email và đăng nhập.',
    my_password_reset_placeholder1: 'Nhập email',
    my_password_reset_placeholder2: 'Nhập mật khẩu',
    my_password_reset_placeholder3: 'Nhập lại mật khẩu',
    my_password_reset_message4: 'Mật khẩu không khớp',
    my_password_reset_message5: 'Mật khẩu phải có ít nhất 8 ký tự và bao gồm ít nhất một chữ cái viết hoa, một chữ cái viết thường, một số và một ký tự đặc biệt',
    my_password_reset_message6: 'Mật khẩu đã được đặt lại',
    my_memo_list_placeholder: 'Bạn có ý tưởng? Viết nó xuống ngay bây giờ',
    my_profile_placehoder1: 'Sở thích của tôi',
    my_profile_placehoder2: 'Tên của tôi',
    my_profile_placehoder3: 'Giới thiệu ngắn gọn về bản thân',
    my_profile_placehoder4: 'Giới thiệu bổ sung',
    my_profile_text1: 'Quốc tịch',
    my_profile_text2: 'Ngôn ngữ',
    my_profile_text3: 'Thay đổi ID',
    my_profile_text4: 'ID hiện tại',
    my_profile_text5: 'ID mới để thay đổi',
    my_profile_text6: 'Chỉ có thể thay đổi ID một lần duy nhất',
    my_menu_text1: 'Hành trình \ncủa tôi',
    my_menu_text2: 'Tin nhắn',
    my_menu_text3: 'Mua hàng & Thanh toán',
    my_menu_text4: 'Thông báo mới',
    my_menu_text5: 'Làm một Sách nhỏ',
    my_menu_text6: 'Sách nhỏ đã tạo',
    my_menu_text7: 'Bạn muốn nhập bài viết từ ứng dụng khác?',
    my_menu_text8: 'Bạn có thể nhập tự động và chuyển thành trang',
    my_menu_text9: 'Nhập',
    my_import_book_text1: 'Chuyển thành trang',
    my_import_book_text2: 'Đang chuyển đổi tệp ZIP thành các trang. Mỗi bài viết có thể mất tối đa 5 giây để chuyển đổi. Khoảng 1 phút cho 10 bài viết, 8 phút cho 100 bài. Sẽ có cửa sổ bật lên khi hoàn tất.',
    my_import_book_text3: 'Đã hiểu',
    my_import_book_text4: 'Chuyển đổi thành trang hoàn tất',
    my_import_book_text5: 'Tất cả bài viết trong tệp ZIP đã được chuyển thành trang. Mỗi bài viết trở thành một trang riêng biệt. Bạn có thể kiểm tra tại Hành trình của tôi - Trang đã tạo. Các trang được lưu tạm thời và có thể chỉnh sửa',
    my_import_book_text6: 'Bạn có thể nhập bài viết từ các ứng dụng khác và tự động chuyển đổi thành trang. Sau đó có thể gom lại thành sách nhỏ.',
    my_import_book_text7: 'Cách nhập bài viết từ ứng dụng khác bằng tệp ZIP',
    my_import_book_text8: 'Vui lòng tải lên tệp ZIP',
    my_import_book_text9: 'Tải tệp từ Substack',
    my_import_book_text10: 'Tải tệp từ Medium',
    my_import_book_text11: 'Tìm',
    my_import_book_text12: '* Mỗi bài viết sẽ được chuyển thành một trang riêng',
    my_import_book_text13: '* Bạn có thể kiểm tra tại Trang của tôi - Cài đặt - Trang đã tạo',
    my_import_book_text14: '* Trang được lưu tạm thời và có thể chỉnh sửa',
    my_import_book_text15: '* Chỉ có thể nhập bài viết do bạn viết',
    my_import_book_text16: 'Xuất bản sách nhỏ từ các trang đã chuyển đổi',
    my_import_book_text17: 'Tạo bìa sách nhỏ',
    my_import_book_text18: 'Chọn các trang để thêm vào sách',
    my_import_book_text19: 'Xuất bản sách nhỏ',
    my_import_book_text20: 'Hãy đọc kỹ hướng dẫn',
    my_import_book_text21: 'Tệp không phải định dạng ZIP',
    my_import_book_text22: 'Vui lòng tải tệp lên',
    my_journey_title: 'Hành trình của tôi',
    my_journey_button_message: 'Tin nhắn',
    my_journey_button_memo: 'Ghi chú',
    my_journey_button_record: 'Hành trình',
    my_journey_button_follow: 'Theo dõi',
    my_journey_button_follow_cancel: 'Bỏ theo dõi',
    my_journey_message_text1: 'Để lại tin nhắn',
    my_journey_message_placeholder: 'Nhập tin nhắn của bạn',
    my_journey_message_message1: 'Không thể phản hồi',
    my_journey_message_message2: 'Đang gửi',
    my_journey_message_message3: 'Nhập tin nhắn của bạn',
    my_journey_memo_total: 'Tổng số',
    my_journey_record_overall: 'Bảng xếp hạng ảnh hưởng',
    my_journey_record_text1: 'Trang đã xem',
    my_journey_record_text2: 'Sách nhỏ yêu thích',
    my_journey_record_text3: 'Không gian sự kiện yêu thích',
    my_journey_record_text4: 'Trang đã tạo',
    my_journey_record_text5: 'Sách nhỏ đã tạo',
    my_journey_record_text6: 'Không gian sự kiện tôi đã tạo',
    my_journey_record_text7: 'Tháng này',
    my_journey_record_text8: 'Sách nhỏ đã mua',
    my_journey_record_text9: 'Công khai',
    my_journey_record_text10: 'Riêng tư',
    my_journey_record_text11: 'Sự kiện đã mua',
    my_journey_record_text12: 'Sự kiện tôi đã tạo',
    my_journey_record_text13: 'Xếp hạng #{userRank} trong danh mục {userLanguage}',
    my_journey_record_text14: 'Sách nhỏ có quyền xuất bản',
    my_journey_record_text15: 'Bạn có muốn người đọc theo thứ tự nhất định không? Nếu có, hãy kéo bìa để thay đổi thứ tự.',
    my_journey_record_text16: 'Hãy ủng hộ sách nhỏ mới',
    my_journey_record_text17: 'Tin nhắn cổ vũ từ độc giả',
    my_journey_record_text18: 'Hãy để lại lời nhắn động viên cho tác giả',
    my_journey_record_text19: 'Cấp độ người ủng hộ',
    my_journey_record_text20: 'Cấp độ {cheeringLevel} trên 10',
    my_journey_record_text21: 'Người tôi đang ủng hộ',
    my_journey_record_text22: 'Người ủng hộ của tôi',
    my_journey_record_text23: 'Bạn có muốn xóa không?',
    my_journey_record_text24: 'người ủng hộ {userName}',
    my_journey_record_text25: 'Được {userName} ủng hộ',
    my_notice_title: 'Thông báo',
    my_notice_message1: 'Không có thông báo mới',
    my_notice_text1: 'Một số mới của Sách nhỏ đã đến',
    my_notice_text2: 'Một số mới của Chủ đề hôm nay đã đến',
    my_notice_text3: 'Một tin nhắn mới đến Hành trình tri thức của tôi',
    my_notice_text4: 'Một bình luận mới trong Ghi chú tôi đã chia sẻ',
    my_notice_text5: 'Có bình luận mới trong không gian sự kiện của tôi',
    my_notice_text6: 'Một bình luận mới trong Sách nhỏ của tôi',
    my_notice_text7: 'Một bình luận mới đến trong Trang của tôi',
    my_notice_text8: 'đã đăng một Ghi chú mới',
    my_notice_text9: '{userName} đã tạo một không gian sự kiện mới',
    my_notice_text10: 'xuất bản một Sách nhỏ mới',
    my_notice_text11: 'đã mua minibook của tôi',
    my_notice_text12: '{userName} đã tạo <b>sự kiện mới</b>',
    my_notice_text13: '{userName} đã đặc biệt mời bạn tham gia <b>sự kiện mới</b>. Đừng bỏ lỡ! ',
    my_notice_text14: '{userName} đã <b>mua sự kiện của tôi</b>',
    my_notice_text15: '{userName} đã đăng ký làm đồng tác giả',
    my_notice_text16: 'Yêu cầu đồng tác giả cho sách nhỏ mở đã được phê duyệt',
    my_notice_text17: 'Bình luận mới đã được đăng bởi đồng tác giả',
    my_notice_text18: 'Một tin nhắn đã đến để ủng hộ sách nhỏ mới',
    my_notice_text19: '{userName} đã tài trợ <b>Sách nhỏ của tôi</b>',
    my_marketing_banner_title: 'Cổ vũ chính mình',
    my_marketing_banner_text1: 'Bạn đã vượt qua khó khăn, hãy cổ vũ bản thân',
    my_marketing_banner_btn: 'Cổ vũ ngay',
    my_marketing_title: 'Cổ vũ ngay',
    my_marketing_text1: 'Gắn hai cánh là sách nhỏ và sự kiện – dùng quảng bá theo từng bước làm nhiên liệu – trở thành người ảnh hưởng',
    my_marketing_text2: 'Gửi email cho độc giả phổ thông',
    my_marketing_text3: 'Gửi tin nhắn cho độc giả phổ thông',
    my_marketing_text4: 'Gửi email cho bạn bè',
    my_marketing_text5: 'Gửi tin nhắn cho bạn bè',
    my_marketing_text6: 'Liên kết trên mạng xã hội',
    my_marketing_btn: 'Bắt đầu ngay',
    my_marketing_minibook_step1_title: 'Cổ vũ sách nhỏ',
    my_marketing_step1_subtitle: 'Liên kết trên mạng xã hội',
    my_marketing_minibook_step1_text1: 'Gắn liên kết sách nhỏ lên mạng xã hội của bạn và thêm mô tả hấp dẫn',
    my_marketing_minibook_text1: 'Tìm sách nhỏ',
    my_marketing_step1_text1: 'Sao chép liên kết',
    my_marketing_step1_btn: 'Sao chép',
    my_marketing_step1_text2: 'Dán vào mạng xã hội và thêm mô tả',
    my_marketing_step1_sns1: 'Facebook',
    my_marketing_step1_sns2: 'Instagram',
    my_marketing_step1_sns3: 'LinkedIn',
    my_marketing_step1_sns4: 'KakaoStory',
    my_marketing_step1_sns5: 'Naver Band',
    my_marketing_step1_sns6: 'Naver Blog',
    my_marketing_step1_sns7: 'Twitter(X)',
    my_marketing_step1_sns8: 'Reddit',
    my_marketing_step1_sns9: 'Medium',
    my_marketing_step1_sns10: 'Substack',
    my_marketing_step1_sns11: 'Weibo(微博)',
    my_marketing_step1_sns12: 'Xiaohongshu(小红书)',
    my_marketing_step1_sns13: 'WeChat(微信)',
    my_marketing_step1_text3: 'Vui lòng chọn sách nhỏ để chia sẻ',
    my_marketing_step1_text4: 'Liên kết đã được sao chép',
    my_marketing_step1_text5: 'Vui lòng chọn sự kiện để chia sẻ',
    my_marketing_step1_text6: 'Tìm mạng xã hội',
    my_marketing_event_step1_title: 'Cổ vũ sự kiện',
    my_marketing_event_step1_text1: 'Gắn liên kết sự kiện lên mạng xã hội của bạn và thêm mô tả hấp dẫn',
    my_marketing_event_text1: 'Tìm sự kiện',
    my_marketing_event_search_title: 'Tìm kiếm sự kiện',
    my_marketing_minibook_step2_title: 'Tiếp thị sách nhỏ: Giai đoạn 2',
    my_marketing_step2_subtitle: 'Gửi tin nhắn cho bạn bè',
    my_marketing_minibook_step2_text1: 'Gửi liên kết sách nhỏ và lời giới thiệu chân thành cho bạn bè của bạn',
    my_marketing_step2_text2: 'Gửi lời giới thiệu kèm liên kết cho bạn',
    my_marketing_step2_placeholder: 'Nhập lời giới thiệu',
    my_marketing_tab_text1: 'Bạn bè của tôi',
    my_marketing_event_step2_title: 'Tiếp thị sự kiện: Giai đoạn 2',
    my_marketing_event_step2_text1: 'Gửi liên kết sự kiện và lời giới thiệu chân thành cho bạn bè của bạn',
    my_marketing_minibook_step3_title: 'Tiếp thị sách nhỏ: Giai đoạn 3',
    my_marketing_step3_subtitle: 'Gửi email cho bạn bè',
    my_marketing_minibook_step3_text1: 'Gửi liên kết sách nhỏ và câu chuyện hậu trường cho bạn bè của bạn',
    my_marketing_step3_text1: 'Nhập danh sách liên hệ',
    my_marketing_step3_placeholder: 'Tải lên tệp csv hoặc vcf',
    my_marketing_step3_text2: 'Gửi câu chuyện và liên kết cho bạn bè',
    my_marketing_step3_text3: 'Nhập danh sách số điện thoại của bạn',
    my_marketing_step3_placeholder2: 'Kể câu chuyện',
    my_marketing_event_step3_title: 'Tiếp thị sự kiện: Giai đoạn 3',
    my_marketing_event_step3_text1: 'Gửi liên kết sự kiện và câu chuyện hậu trường cho bạn bè của bạn',
    my_marketing_text7: 'Nhập số điện thoại',
    my_marketing_title2: 'Quản lý số điện thoại',
    my_marketing_text8: 'Điện thoại',
    my_marketing_text9: 'Số lần',
    my_marketing_text10: 'Nhập danh bạ',
    my_marketing_text11: 'Vui lòng tải lên tệp csv hoặc vcf',
    my_marketing_text12: 'Cách nhập',
    my_marketing_text13: 'Nhập',
    my_marketing_title3: 'Quản lý danh bạ',
    contact_manage: 'Quản lý danh bạ',
    my_marketing_text14: 'Xóa đã chọn',
    my_marketing_text15: 'Vui lòng chọn bạn',
    my_marketing_text16: 'Bạn có thể chọn tối đa 100 người bạn',
    my_marketing_text17: 'Tải lên đã hoàn tất',
    my_marketing_text18: 'Vượt quá số ký tự cho phép',
    contact_phone: 'Điện thoại',
    contact_organization: 'Tổ chức',
    contact_title: 'Chức vụ',
    contact_memo: 'Ghi chú',
    my_marketing_text19: 'Chỉnh sửa lựa chọn',
    my_marketing_text20: 'Chọn nhãn',
    my_marketing_text21: 'Thêm nhãn mới',
    my_marketing_text22: 'Xóa nhãn đã chọn',
    my_marketing_text23: 'Thêm',
    my_marketing_btn2: 'Hoàn tất chỉnh sửa',
    my_marketing_text24: 'Vui lòng chọn liên hệ để chỉnh sửa',
    my_marketing_text25: 'Vui lòng chọn nhãn để xóa',
    my_marketing_text26: 'Vui lòng nhập tên nhãn',
    my_marketing_text27: 'Nhãn này đã tồn tại',
    my_marketing_text28: 'Thêm nhãn',
    my_marketing_text29: 'Hủy',
    my_marketing_text30: 'Đã thêm',
    my_benefit_text1: 'Bạn đã thu được cho đến nay',
    my_benefit_text2: 'Bạn sẽ thu được trong một năm',
    my_benefit_text3: '',
    my_benefit_text4: 'lợi nhuận đã thu được',
    my_benefit_text5: 'lợi nhuận sẽ thu được',
    my_benefit_text6: 'Kiểm tra',
    my_benefit_modal_text1: 'cho đến nay',
    my_benefit_modal_text2: 'đ',
    my_benefit_modal_text3: 'Bạn đã thu được',
    my_benefit_modal_text4: 'Hãy tiến hành một phép tính rất đơn giản',
    my_benefit_modal_text5: 'Số trang đã đọc cho đến nay',
    my_benefit_modal_text6: 'Chi phí để tạo một trang',
    my_benefit_modal_text7: 'đ',
    my_benefit_modal_text8: 'Vậy lợi nhuận của bạn là',
    my_benefit_modal_text9: 'Bây giờ nếu thêm lợi ích của các cuộc thảo luận với AI',
    my_benefit_modal_text10: 'lợi nhuận của bạn sẽ còn lớn hơn',
    my_benefit_modal_text11: 'Hãy sử dụng hàng ngày và thu được lợi nhuận to lớn',
    my_benefit_modal_text12: 'Vâng, tôi đã hiểu',
    my_story_text1: 'Câu chuyện của các thành viên',
    my_story_text2: 'Sự thật là sách không phải để đọc mà để trải nghiệm',
    my_story_text3: 'Nếu học kiến ​​thức mới mỗi ngày, điều bất ngờ sẽ xảy ra',
    my_story_text4: 'Những cạm bẫy tiềm ẩn người thông minh đều gặp phải, có lẽ bạn cũng vậy?',
    my_story_text5: 'Tìm hiểu thêm câu chuyện của các thành viên',
    my_go_blog_text1: 'YouBook, Tin tức và Câu chuyện Khách hàng',
    my_go_blog_text2: 'Khám phá tin tức mới nhất và câu chuyện từ khách hàng của YouBook',
    my_go_blog_text3: 'Tìm hiểu thêm',
    my_channel_text1: 'Bạn cảm thấy thế nào khi sử dụng YouBook?',
    my_channel_text2: 'Hãy cho chúng tôi biết điều gì tốt và điều gì cần cải thiện',
    my_channel_text3: 'Và cho chúng tôi biết nếu bạn có bất kỳ câu hỏi nào',
    my_channel_text4: 'Nói một lời',
    my_about_youbook_text1: 'Tại sao nên sử dụng YouBook',
    my_about_youbook_text2: 'Mọi thứ bạn muốn biết đều ở đây',
    my_about_youbook_text3: 'Điều khoản dịch vụ Youbook',
    my_app_text1: 'YouBook là ứng dụng có lợi 100%.',
    my_app_text2: 'Tải xuống ngay bây giờ và tích luỹ kiến thức',
    my_app_text3: 'Tải xuống ứng dụng',
    login_title: 'Đăng nhập',
    login_text1: 'Đăng nhập bằng email',
    login_text2: 'Chưa đăng ký?',
    login_text3: 'Quên mật khẩu?',
    login_text4: 'hoặc Đăng nhập bằng tài khoản SNS',
    login_text5: 'Đồng ý',
    login_placeholder1: 'Email đăng nhập',
    login_placeholder2: 'Mật khẩu',
    login_placeholder3: 'ID',
    login_message1: 'Vui lòng nhập email đăng nhập',
    login_message2: 'Nhập mật khẩu',
    login_message3: 'Đăng nhập thành công',
    login_message4: 'Vui lòng nhập ID của bạn',
    logout_message1: 'Bạn muốn đăng xuất?',
    login_link1: 'Đăng ký',
    login_link2: 'Tìm mật khẩu',
    login_link3: 'Điều khoản dịch vụ',
    register_title: 'Đăng ký',
    register_text1: 'Đăng ký bằng email',
    register_text2: 'Chọn loại đăng ký thành viên',
    register_text3: 'Cá nhân',
    register_text4: 'Tổ chức',
    register_text5: 'Nhập thông tin của bạn',
    register_text6: 'Bạn đã đăng ký chưa?',
    register_text7: 'Mã số doanh nghiệp',
    register_text8: 'Số đăng ký kinh doanh',
    register_text9: 'Tên tổ chức',
    register_placeholder1: 'Số điện thoại (không nhập dấu -)',
    register_placeholder2: '(không nhập dấu -)',
    register_placeholder_repassword: 'Nhập lại mật khẩu',
    register_message1: 'Nhập số điện thoại của bạn',
    register_message2: 'Nhập mã số doanh nghiệp',
    register_message3: 'Nhập số đăng ký kinh doanh',
    register_message4: 'Nhập tên tổ chức',
    register_message5: 'Định dạng email không hợp lệ',
    register_message6: 'Email này đã được đăng ký',
    register_message7: 'Vui lòng xác minh email của bạn',
    register_message8: 'Vui lòng chọn quốc tịch của bạn',
    register_message9: 'Định dạng ID không hợp lệ',
    register_message10: 'ID bạn nhập không khả dụng. Hãy dùng ID được gợi ý hoặc nhập ID khác',
    register_message11: 'Vui lòng xác minh ID của bạn',
    register_message12: 'ID này đã được sử dụng. Vui lòng dùng ID được đề xuất hoặc nhập ID khác',
    register_button_verify: 'Xác minh',
    register_button_verify_fail: 'Không thể xác minh',
    register_button_verify_success: 'Đã xác minh',
    register_welcome_message: 'Chào mừng bạn trở thành thành viên',
    withdraw_text1: 'Hủy Tư Cách Hội Viên',
    withdraw_text2: 'Hủy Tư Cách Hội Viên YouBook',
    withdraw_text3: 'Bạn có chắc chắn muốn hủy không?',
    withdraw_text4: 'Không',
    withdraw_text5: 'Có',
    withdraw_text6: 'Quý vị đã hủy tư cách hội viên thành công',
    home_memo_title: 'Ghi chú',
    home_memo_subtitle: 'Nếu không ghi chú bạn sẽ quên',
    home_memo_text1: 'Được chia sẻ cùng nhau bởi mọi người',
    home_memo_text2: 'Kiến thức và câu chuyện hàng ngày',
    home_memo_button: 'Để lại ghi chú',
    home_memo_create_text1: 'Bạn có sách nhỏ muốn liên kết không?',
    home_memo_create_button: 'Tìm sách nhỏ',
    home_memo_create_button2: 'Chọn',
    home_memo_click: 'Nhấp',
    home_memo_date: 'DD.MM.YYYY',
    home_memo_button_askai: 'Bình luận / Suy nghĩ của Mèo Sách',
    home_memo_view_detail: 'Xem chi tiết',
    home_memo_view_placeholder: 'Nhập bài đăng',
    home_memo_view_button1: 'Bình luận',
    home_memo_view_button2: 'Suy nghĩ của Mèo Sách',
    home_memo_view_errormessage: 'Nhập tin nhắn',

    memo_create_title: 'Ghi chú',
    memo_create_category1: 'Ghi chú',
    memo_create_category2: 'Ghi chú',
    memo_create_private: 'Riêng tư',
    memo_create_public: 'Chia sẻ',
    memo_create_placeholder1: 'Bạn có ý tưởng?',
    memo_create_placeholder2: 'Ghi chú ngay bây giờ',
    memo_create_placeholder3: 'Từ khóa (khoảng trắng giữa các từ)',
    memo_create_button: 'Lưu',
    memo_create_error: 'Nhập nội dung',
    memo_attach_img: 'Tải ảnh lên',
    memo_alert_rate: 'Vui lòng xếp hạng',
    memo_alert_save: 'Đã lưu. Bạn có thể kiểm tra trong Hồ sơ của tôi - Hành trình của tôi',
    memo_input_placeholder: 'Bạn đã học được gì?',
    memo_input_placeholder2: 'Bạn nghĩ gì?',
    memo_input_placeholder3: 'Chia sẻ với độc giả ngay bây giờ~',
    memo_input_placeholder4: 'Kỷ niệm từ cuộc sống thường nhật, ghi lại nhé?',
    memo_alert_keywords: 'Nhập từ khóa',
    memo_related_text: 'Ghi chú',
    memo_related_date: 'DD.MM.YYYY',
    memo_popup_text1: 'Giới thiệu một câu chuyện khó tin đã xảy ra với nhà xã hội học người Đức Niklas Luhmann',
    memo_popup_text3: 'Luhmann là một thanh niên bình thường làm việc tại văn phòng hành chính của một công ty.',
    memo_popup_text4: 'Ông ấy thích đọc sách và thường ghi chú ngắn gọn về những gì đọc hàng ngày.',
    memo_popup_text5: 'Ông sắp xếp các nội dung đó và nộp bài nghiên cứu cho một nhà xã hội học nổi tiếng người Đức, và nhờ nhân duyên đó ông được mời trở thành giáo sư tại Đại học Bielefeld.',
    memo_popup_text6: 'Luhmann sau đó trở thành giáo sư toàn thời gian và cho đến khi nghỉ hưu ông đã xuất bản 60 cuốn sách và hàng trăm bài báo. Ông đã trở thành bậc thầy về xã hội học.',
    memo_popup_text7: 'Luhmann nói, "Tôi chỉ ghi chú đều đặn, thỉnh thoảng suy ngẫm về chúng và sắp xếp suy nghĩ của mình".',
    memo_popup_text8: 'Bạn tin tưởng trí nhớ của mình đến mức nào?',
    memo_popup_text9: 'Trí nhớ của bạn có giới hạn.',
    memo_popup_text10: 'Cho dù kiến ​​thức có hay đến đâu, cũng sẽ biến mất sau vài ngày.',
    memo_popup_text11: 'Chỉ có thói quen ghi chú đều đặn và ngẫm nghĩ thường xuyên mới có thể biến kiến ​​thức thành của bạn.',
    memo_popup_btn: 'Vâng, tôi đồng ý với bạn',
    memo_text1: 'Bạn có thể lưu nội dung trên',
    memo_text2: '(Chỉ thêm từ khóa)',
    memo_text3: 'Những điều cần kiểm tra khi viết',
    memo_text4: 'Bài viết của bạn vi phạm quy định về nội dung trong Điều 2, Khoản 1 của Điều khoản dịch vụ. Nó sẽ không được công khai.',
    memo_text5: 'Xem Điều khoản dịch vụ',
    memo_text6: 'Để ghi chú bằng ngôn ngữ khác, ',
    memo_text7: 'vui lòng viết bằng ngôn ngữ đó (không hỗ trợ dịch tự động)',
    book_create_button: 'Làm một Sách nhỏ',
    book_create_title: 'Làm một Bìa',
    book_create_cover: 'Bìa',
    book_create_text1: 'Các bước tạo bìa cho Sách nhỏ',
    book_create_text1_pc: 'Nhập tiêu đề và tên tác giả',
    book_create_text2: 'Khi không có ảnh bìa do chính bạn tạo',
    book_create_text3: '',
    book_create_text4: 'Khi có ảnh bìa do chính bạn tạo',
    book_create_text5: 'Bạn đã tự tạo bìa của mình chưa?',
    book_create_text6: 'Vui lòng tải lên bằng nút bên dưới',
    book_create_text7: '(định dạng jpg, kích thước dưới 20M)',
    book_create_text8: 'Quyền thêm trang',
    book_create_text9: 'chỉ mình tôi',
    book_create_text10: 'bất kỳ ai',
    book_create_text11: 'Hiển thị tiêu đề trên hình ảnh',
    book_create_text12: 'Đã hiển thị',
    book_create_text13: 'Không hiển thị',
    book_create_text14: 'Vui lòng chọn ngôn ngữ bạn muốn dịch',
    book_create_text15: 'Chọn tất cả',
    book_create_text16: 'Tải lên hình ảnh bìa',
    book_create_text17: 'Có thể sửa đổi',
    book_create_text18: 'Sau khi sửa đổi, nhấn vào biểu tượng ở góc trên bên phải để dịch lại',
    book_create_text19: 'Nếu bạn muốn dịch lại theo nguyên bản, hãy nhấn vào biểu tượng ở góc trên bên phải',
    book_create_text20: 'Dịch lại',
    book_create_text21: 'Hình ảnh',
    book_create_text22: 'Tiêu đề',
    book_create_text23: 'Từ khóa',
    book_create_text24: 'Nội dung',
    book_create_text25: 'Chỉ dịch lại nếu hình ảnh bị xóa và tải lên mới',
    book_create_text26: '(Trang sẽ không bị xóa)',
    book_create_text27: 'Hãy viết một phần giới thiệu ngắn',
    book_create_text28: 'Lưu tạm thời',
    book_create_text29: 'Đã lưu tạm thời',
    book_create_text30: 'Những điều cần kiểm tra',
    book_create_text31: 'Nội dung văn bản là phiên bản cuối cùng và không cần chỉnh sửa thêm',
    book_create_text32: 'Không sử dụng từ ngữ hoặc ký hiệu mà AI dịch không thể hiểu được',
    book_create_text33: 'Hình ảnh không được sao chép và dán mà được nhập dưới dạng tệp riêng biệt',
    book_create_text34: 'Mở đơn đăng ký? (Sách nhỏ mở)',
    book_create_text35: 'Đồng tác giả',
    book_create_text36: 'Bạn muốn thêm thủ công?',
    book_create_text37: 'Thêm',
    book_create_text38: 'Sách nhỏ lan tỏa rộng hơn khi viết cùng nhau',
    book_create_text39: 'Sức mạnh của đồng tác giả mà bạn chưa biết',
    book_create_text40: 'Mở đơn đăng ký',
    book_create_text41: 'Hủy',
    book_create_text43: 'Ý tưởng?',
    book_create_text44: 'Sao chép và dán nội dung',
    book_create_text45: 'Bạn cần ý tưởng không?',
    book_create_text46: 'Tùy chọn bán hàng',
    book_create_text47: 'Miễn phí',
    book_create_text48: 'Nhà tài trợ',
    book_create_text49: 'Mua',
    book_create_text50: 'Giá hiện tại',
    book_create_text51: 'Chỉnh sửa giá',
    book_create_text52: 'Không thể đặt giá là 0',
    book_create_text53: 'Không thể thay đổi giá hoặc tùy chọn bán đối với sách nhỏ đã được mua hoặc tài trợ',
    book_create_text54: 'Chỉ tác giả của sách nhỏ mới có thể trả lời tin nhắn',
    book_create_button_upload: 'Tải lên',
    book_create_button_make: 'Tạo',
    book_create_cover_topic_placeholder: 'Tiêu đề sẽ như thế này',
    book_create_topic_placeholder: 'Nhập tiêu đề',
    book_create_keyword_placeholder: 'Nhập từ khóa (trên 3 từ, khoảng trắng giữa các từ)',
    book_create_category_placeholder: 'Chọn danh mục',
    book_create_knowledge_placeholder: 'Viết giới thiệu về Sách nhỏ này ** Lưu ý - Viết nội dung chi tiết ở bước tạo trang',
    book_create_category_option1: 'Phim và Kịch',
    book_create_category_option2: 'Âm nhạc và Múa',
    book_create_category_option3: 'Nghệ thuật khác',
    book_create_category_option4: 'Trang phục và Phong cách',
    book_create_category_option5: 'Ẩm thực và Nấu ăn',
    book_create_category_option6: 'Rượu và Đồ uống',
    book_create_category_option7: 'Đồ ăn nhẹ và Tráng miệng',
    book_create_category_option8: 'Thực vật và Sức khỏe',
    book_create_category_option9: 'Trở nên giàu có',
    book_create_category_option10: 'Phát triển bản thân',
    book_create_category_option11: 'Quan hệ',
    book_create_category_option12: 'Kiến thức mới',
    book_create_category_option13: 'Câu chuyện cuộc sống',
    book_create_category_option14: 'Triết lý và Giá trị',
    book_create_category_option15: 'Tôn giáo và Truyền thống',
    book_create_category_option16: 'Tình yêu',
    book_create_category_option17: 'Du lịch và Điểm đến',
    book_create_category_option18: 'Sở thích',
    book_create_category_option19: 'Văn hóa trò chơi',
    book_create_category_option20: 'Thần thoại và Anh hùng',
    book_create_category_option21: 'Hành trình văn học',
    book_create_category_option22: 'Lịch sử và Trí tuệ',
    book_create_category_option23: 'Câu chuyện xã hội',
    book_create_category_option24: 'Kiến Thức Chung',
    book_create_message1: 'Nhập tiêu đề',
    book_create_message2: 'Nhập tên tác giả',
    book_create_message3: 'Nhập từ khóa',
    book_create_message4: 'Nhập nhiều hơn 3 từ khóa',
    book_create_message5: 'Chọn danh mục',
    book_create_message6: 'Tạo hình ảnh bìa',
    book_create_message7: 'Không thể nhập ký tự đặc biệt. Cách giữa các từ khóa',
    book_create_message8: 'Bạn muốn xóa Sách nhỏ?',
    book_create_message9: 'Bạn không có quyền xuất bản bằng ngôn ngữ này',
    book_create_message10: 'Sách nhỏ đã mua không thể bị xóa',
    book_create_modal_text1: 'Vui lòng chờ một chút..',
    book_create_modal_text2: 'AI đang xem xét nội dung, dịch ngôn ngữ nước ngoài và kết nối mạng lưới tri thứ',
    book_create_modal_text3: 'Kết nối với mạng kiến thức để tìm kiếm từng trang',
    book_create_modal_text4: 'Tiêu đề không xuất hiện trên hình ảnh bìa',
    book_create_modal_text5: '(Điều này cũng áp dụng cho bìa được dịch sang ngôn ngữ khác)',
    book_view_title: 'Giới thiệu Sách nhỏ',
    book_view_share: 'Chia sẻ',
    book_view_event_topic: 'Chủ đề sự kiện',
    book_view_together_suggest: 'Đề xuất không gian sự kiện',
    book_view_together_message: 'Bạn chưa có mục Cùng nhau yêu thích,<br />hãy vào menu Cùng nhau và chọn một mục',
    book_view_event_message: 'Tôi chưa tạo sự kiện nào',
    book_view_text1: 'Không có trang nào được lưu.',
    book_view_text2: 'Thêm trang ngay bây giờ.',
    book_view_text3: 'Sách nhỏ không tồn tại. Vui lòng thử lại.',
    book_view_text4: 'Các trang của Sách nhỏ',
    book_view_text5: 'Bạn nghĩ sao về việc cải thiện bản dịch của sách nhỏ này hoặc quảng bá nó và chia sẻ lợi nhuận?',
    book_view_text6: 'Danh sách trang',
    book_view_text7: 'Chỉnh sửa giá',
    book_view_text8: 'Không thể chỉnh sửa vì đã có người mua',
    book_view_text9: 'Món quà từ độc giả',
    book_view_text10: 'Chỉ tác giả của sách nhỏ mới có thể trả lời tin nhắn',
    book_view_modal_title: 'Cải thiện bản dịch & Quảng bá',
    book_view_modal_text1: 'Bạn có thể tự mình cải thiện bản dịch của sách nhỏ này không? Hoặc quảng bá nó?',
    book_view_modal_text2: 'Để lại tin nhắn cho tác giả',
    book_view_modal_text3: 'Nếu tác giả đồng ý, bạn có thể chia sẻ doanh thu',

    book_view_write_share_title: 'Sách nhỏ mở',
    book_view_write_share_text1: 'Bạn có muốn trở thành đồng tác giả của sách nhỏ này không?',
    book_view_write_share_text2: 'Đăng ký tác giả',
    book_view_write_share_text3: 'Hãy để lại yêu cầu đơn giản',
    book_view_write_share_text4: 'Gửi',
    book_view_write_share_list_title: 'Đồng tác giả',
    book_view_write_share_text5: 'Quản lý đồng tác giả của sách nhỏ',
    book_view_write_share_text6: 'Quản lý tác giả',
    book_view_write_share_text7: 'Chấp nhận',
    book_view_write_share_text8: 'Đã chấp nhận',
    book_view_write_share_text9: 'Người dùng đã được đăng ký làm tác giả',
    book_view_write_share_text10: 'Thêm tác giả thủ công',
    book_view_write_share_text11: 'Người dùng đã đăng ký rồi',
    book_view_publish_text1: 'Bạn có muốn xuất bản Sách nhỏ này không?',
    book_view_publish_text2: 'Xuất bản sẽ công khai cho mọi người và có thể kiếm tiền từ nó',
    book_view_publish_text3: '(Nếu bạn xuất bản để bán, bạn không thể bao gồm trang của tác giả khác)',
    book_view_publish_text4: 'Đặt giá',
    book_view_publish_text5: 'Ngày xuất bản',
    book_view_publish_text6: 'Yêu cầu xuất bản',
    book_view_publish_text7: 'Xuất bản ngay',
    book_view_publish_text8: 'Đặt lịch',
    book_view_publish_text9: 'Chưa xuất bản',
    book_view_publish_text10: 'Đang xuất bản',
    book_view_publish_text11: 'Đã xuất bản',
    book_view_publish_text12: 'Những điều cần kiểm tra khi xuất bản',
    book_view_publish_text13: 'Sách nhỏ này chưa bao giờ được xuất bản trên YouBook trước đây',
    book_view_publish_text14: 'Sách nhỏ này và các trang của nó không sao chép nội dung hoặc tài sản trí tuệ của người khác',
    book_view_publish_text15: 'Cuốn sách nhỏ này không chứa lời lẽ thô tục, nội dung tình dục quá mức, phỉ báng người khác hoặc quảng cáo thương mại và tuân thủ Điều 2, Khoản 1 của Điều khoản Sử dụng',
    book_view_publish_text16: 'Có',
    book_view_publish_text17: 'Tình hình xuất bản',
    book_view_publish_text18: 'Đã xuất bản',
    book_view_publish_text19: 'Thời gian xuất bản',
    book_view_publish_text20: 'Giá xuất bản',
    book_view_publish_text21: 'Xác định giai đoạn mở',
    book_view_publish_text22: 'Giai đoạn mở',
    book_view_publish_text23: 'Giai đoạn mở là gì',
    book_view_publish_text24: 'Giai đoạn mở là thời gian mà độc giả có thể xem nội dung',
    book_view_publish_text25: 'Sách nhỏ này có hơn 3 trang',
    book_view_publish_text26: 'Sách nhỏ này không có hơn 3 trang',
    book_view_publish_text27: 'Nếu có vi phạm, thuật toán có thể điều chỉnh thứ hạng tìm kiếm. Trong trường hợp nghiêm trọng, cuốn sách nhỏ sẽ bị xóa tự động',
    book_view_publish_text28: 'Đặt tùy chọn bán',
    book_view_publish_text29: 'Phương thức mua',
    book_view_publish_text30: 'Phương thức hỗ trợ',
    book_view_publish_message1: 'Nếu xuất bản để bán, hãy đảm bảo rằng 1) các trang trong Sách nhỏ do chính bạn tạo và 2) bạn chưa từng xuất bản chúng để bán',
    book_view_publish_message2: 'Không ở trạng thái có thể xuất bản. Vui lòng liên hệ với quản trị viên để được trợ giúp',
    book_view_publish_message3: 'Sách nhỏ này đã được xuất bản',
    book_view_publish_message4: 'Vui lòng chọn giai đoạn mở sau thời gian hiện tại',
    book_view_publish_message5: 'Vui lòng chọn cả ngày và giờ',
    book_view_publish_message6: 'Xuất bản đã được phê duyệt. Cảm ơn bạn',
    book_view_publish_message7: 'Vui lòng kiểm tra các mục xác nhận',
    book_view_publish_message8: 'Ngày kết thúc không thể sớm hơn ngày bắt đầu',
    book_view_publish_message9: 'Sách nhỏ được lưu tạm thời không thể xuất bản',
    book_view_publish_message10: 'Sách nhỏ này đã được chuyển nhượng. Quyền xuất bản ban đầu thuộc về tác giả.',
    book_view_publish_message11: 'Vui lòng nhập số tiền tối thiểu là {minPrice}',
    book_view_button_confirm: 'Đã xác nhận',
    book_view_button_publish: 'Xuất bản',
    book_view_button_order: 'Căn chỉnh trang',
    book_view_button_add: 'Thêm trang',
    book_view_button_video: 'Phát video',
    book_view_button_read: 'Đọc',
    book_view_button_lecture: 'Xem video bài giảng',
    book_view_page_add_title: 'Thêm trang',
    book_view_page_add_text1: 'Sau khi tìm kiếm trang của Bên thứ ba',
    book_view_page_add_text2: 'Trên màn hình Xem nội dung trang',
    book_view_page_add_text3: 'Thêm vào Sách nhỏ của tôi',
    book_view_page_add_text4: 'Bạn có muốn tự tạo trang không?',
    book_view_page_add_text5: 'Tạo trang chỉ dành cho các tác giả đã đăng ký. Nếu bạn muốn đăng ký làm tác giả, vui lòng liên hệ với chúng tôi ở dưới.',
    book_view_page_add_text6: 'Bạn có muốn thêm trang của Bên thứ ba không?',
    book_view_page_add_text7: '* Nếu bạn thêm trang do Bên thứ ba tạo, \nsẽ không thể xuất bản dưới dạng Sách nhỏ có tính phí',
    book_view_page_add_text8: 'Bạn đã từng tạo trang trước đó chưa?',
    book_view_page_add_button1: 'Làm ngay bây giờ',
    book_view_page_add_button2: 'Xem Trang đã tạo',
    book_view_reference_text1: 'Đa dạng',
    book_view_reference_text2: 'Nhiều',
    book_view_reference_text3: 'Tác giả Sách nhỏ',
    book_view_reference_text4: 'Tạo trực tiếp',
    book_view_support_text1: 'Tôi ủng hộ bạn',
    book_view_support_modal_title: 'Hãy trở thành người ủng hộ',
    book_view_support_modal_text1: 'Ngay cả một bài viết hay cũng khó lan tỏa nếu chỉ có một mình.',
    book_view_support_modal_text2: 'Người ủng hộ là người chia sẻ sách nhỏ của tác giả đến thế giới và cùng nhau động viên nhau.',
    book_view_support_modal_text3: 'Hãy cùng nhau lan tỏa câu chuyện này xa hơn nữa.',
    book_view_support_modal_text4: 'Hãy ủng hộ tác giả nhé',
    book_view_support_modal_btn1: 'Tôi hiểu rồi',
    book_view_support_modal_text5: '"Sự ủng hộ của bạn rất có ý nghĩa với tôi. Cảm ơn bạn. Tôi cũng sẽ hết lòng ủng hộ hành trình của bạn."',
    book_view_support_modal_text6: 'Hãy chia sẻ sách nhỏ này đến thế giới',
    book_view_support_modal_btn2: 'Tôi cần làm gì?',
    book_view_support_modal_title2: 'Tôi đã cố gắng đến tận đây, thật tuyệt',
    book_view_support_modal_text7: 'Viết không hề dễ dàng, nhưng tôi đã làm được.',
    book_view_support_modal_text8: 'Giờ là lúc tin tưởng bản thân và tiến thêm một bước nữa.',
    book_view_support_modal_text9: 'Dù có chút ngại ngùng hay do dự, tôi vẫn lựa chọn tin vào bản thân và lan toả điều mình muốn nói đến thế giới.',
    book_view_support_modal_text10: 'Vì tôi tin rằng điều này có thể mang ý nghĩa với ai đó.',
    book_view_support_modal_text11: 'Hãy trở thành người ủng hộ của tôi nhé',
    book_view_support_modal_text12: 'Dù viết bài hay tổ chức sự kiện không hề dễ, tôi vẫn đã dám thử.',
    book_view_support_modal_btn3: 'Tôi sẽ thử!',
    book_view_support_modal_title3: 'Xin chào, người ủng hộ',
    book_view_open_minibook_text1: 'Đăng ký sách nhỏ mở đã được hoàn tất',
    book_view_open_minibook_text2: 'Đăng ký sách nhỏ mở đã bị hủy',
    page_create_title: 'Tạo một trang',
    page_create_text1: 'Khi không có ảnh trang do chính bạn tạo',
    page_create_text2: '',
    page_create_text3: 'trang',
    page_create_text4: 'Khi có ảnh trang do chính bạn tạo',
    page_create_text5: 'Bạn đã tạo hình ảnh trang chưa?',
    page_create_text6: 'Nhập nội dung của bạn.\nKhông nên quá một tờ A4.',
    page_create_text7: 'Byte hiện tại',
    page_create_text8: 'Kích thước đề xuất',
    page_create_text9: 'Có tài liệu tham khảo của trang này không?',
    page_create_text10: 'Được tạo bởi bạn',
    page_create_text11: 'Tham khảo sách',
    page_create_text12: 'Tham khảo blog',
    page_create_text13: 'AI tham khảo',
    page_create_text14: 'Đây là các bước để tạo trang cho Sách nhỏ. Chỉ cần nhập từng mục',
    page_create_text15: 'Tải lên hình ảnh trang',
    page_create_text16: 'Bạn có muốn dịch lại không?',
    page_create_text17: 'Nếu bạn muốn dịch lại, vui lòng chọn đối tượng và ngôn ngữ (nếu không chọn, nội dung sẽ được lưu mà không dịch)',
    page_create_text18: 'Đối tượng dịch',
    page_create_text19: 'Ngôn ngữ dịch',
    page_create_message1: 'Không thể sửa đổi',
    page_create_message2: 'Nhập nội dung của bạn',
    page_create_message3: 'Bạn muốn xóa trang?',
    page_create_message4: 'Nội dung vượt quá kích thước tối đa',
    page_create_reference_book: 'sách',
    page_create_reference_blog: 'blog',
    page_create_reference_placeholder1: 'Nhập tiêu đề của',
    page_create_reference_placeholder2: 'Liên kết liên quan (ví dụ https://www.kyobo.com/books/11223344)',
    page_create_reference_placeholder3: 'Nhập năm xuất bản của',
    page_create_reference_placeholder4: 'Nhập tác giả của',
    page_create_title_placeholder: 'Tiêu đề sẽ như thế này',
    page_create_message5: 'Đang dịch',
    page_create_message6: 'Sau khi tạo bìa, bạn có thể tạo trang',
    page_create_modal_text1: 'Tiêu đề không xuất hiện trên hình ảnh trang',
    page_create_modal_text2: '(Điều này cũng áp dụng cho trang được dịch sang ngôn ngữ khác)',
    page_create_modal_text3: 'Vui lòng kiểm tra lại!',
    page_create_modal_text4: 'Nếu nội dung đã thay đổi, bạn cần lưu tạm thời.',
    page_create_modal_text5: 'Bạn đã làm vậy chưa?',
    page_create_modal_text6: 'Nếu nội dung đã thay đổi, bạn cần tạo.',
    page_view_title: 'Xem nội dung',
    page_view_button_video: 'Phát video',
    page_view_button_read: 'Đọc',
    page_view_text1: 'Thêm vào Sách nhỏ của tôi',
    page_view_text2: 'Tự động phát lại toàn bộ',
    page_view_text3: 'Lượt đọc',
    page_view_text4: 'Trang liên quan',
    page_view_text5: 'Sách nhỏ liên quan',
    page_view_text6: 'Bạn thắc mắc về tài liệu tham khảo?',
    page_view_text7: 'Tài liệu tham khảo',
    page_view_text8: 'Năm xuất bản',
    page_view_text9: 'Tác giả',
    page_view_text10: 'Tiêu đề',
    page_view_text11: 'Trang liên quan',
    page_view_text12: 'Tìm kiếm liên quan',
    page_view_text13: 'Tác giả trang',
    page_view_text14: 'Gặp gỡ tác giả',
    page_view_text15: 'Thêm vào',
    page_view_reference_text1: 'Sách',
    page_view_reference_text2: 'Blog',
    page_view_popup: 'Không có Sách nhỏ nào do bạn tạo. Hãy tạo một trang trong trang của tôi',
    page_view_pay_popup_text1: 'Bạn có nhận được điều gì sau khi đọc không? \nHãy gửi một món quà nhỏ cho tác giả nhé.',
    page_view_pay_popup_title: 'Tặng quà',
    page_view_pay_popup_text2: 'Chọn loại trà để tặng',
    page_view_pay_popup_text3: 'Viết lời nhắn từ trái tim',
    page_view_pay_popup_placeholder1: 'Những lời viết từ trải nghiệm và cảm xúc của tác giả thật sự giúp ích cho tôi.',
    page_view_pay_popup_text4: 'Số tiền',
    page_view_pay_popup_button1: 'Mua và gửi tin nhắn',
    page_view_pay_popup_text5: 'Tác giả đã dành rất nhiều thời gian và tâm huyết cho bài viết này.\n\nHãy hồi đáp bằng một món quà nhỏ.',
    page_view_pay_popup_placeholder2: 'Tôi đặt niềm tin vào sự từng trải và cảm xúc của tác giả.',
    page_view_pay_popup_text6: 'Bạn không muốn tặng quà?',
    page_view_pay_popup_text7: 'Bạn muốn xem quảng cáo để đọc?',
    page_view_pay_popup_button2: 'Xem quảng cáo để đọc',
    page_sort_title: 'Căn chỉnh trang',
    page_sort_subtitle: 'Kéo trang để thay đổi thứ tự',
    page_sort_text: 'Nguồn',
    pay_button: 'Mua',
    pay_price: 'Giá mua',
    pay_vat_excluded: '(Chưa bao gồm VAT)',
    pay_message_success: 'Đã mua hoàn tất',
    pay_message_fail: 'Mua thất bại',
    pay_currency: 'đ',
    pay_button_paid: 'Mua hoàn tất',
    pay_button_view_price: 'Xem giá',
    pay_total: 'Tổng cộng',
    pay_methods: 'Phương thức thanh toán',
    pay_methods_creditcard: 'Thẻ tín dụng',
    pay_methods_paypal: 'PayPal',
    pay_button_continue: 'Tiếp tục',
    pay_text1: 'Vui lòng chọn một loại trà',
    pay_text2: 'Vui lòng nhập tin nhắn',
    advertisement_button: 'Đọc thêm',
    advertisement_text1: 'Bạn có thể xem nội dung sau khi xem quảng cáo.',
    advertisement_text2: 'Đây là trang của sách nhỏ trả phí. <br />Đi đến bìa và nhấn \'Đọc\' để mua. <br />',
    advertisement_text3: 'Bạn có thể xem nội dung sau khi xem quảng cáo. Quảng cáo chỉ có thể được xem trong ứng dụng.',
    together_title: 'Sự kiện',
    together_subtitle: 'Gặp gỡ và trò chuyện với độc giả',
    together_subtitle_text1: 'Gặp độc giả trực tuyến',
    together_subtitle_text2: 'Tạo phòng và mời mọi người',
    together_button: 'Tạo không gian sự kiện',
    together_case: 'Trường hợp',
    together_case1: 'Tôi cố gắng cho nhưng tôi vẫn nhận được',
    together_case2: 'Không bao giờ biết một ví dụ thực sự hữu ích',
    together_subtitle2: 'Không gian tôi đã tạo',
    together_category1: 'Mới nhất',
    together_category2: 'Yêu thích nhất',
    together_button_viewmore: 'Thêm',
    together_list_date: 'DD.MM.YYYY',
    together_list_date2: 'hh:mm A DD.MM.YYYY',
    together_subtitle3: 'Không gian như thế này',
    together_subtitle3_1: 'Làm giúp tôi nhé',
    together_subtitle_text3: 'Nếu ai đó bắt đầu, tôi muốn tham gia',
    together_create_title: 'Tạo không gian sự kiện',
    together_create_title2: 'Chỉnh sửa không gian sự kiện',
    together_create_button1: 'Chọn',
    together_create_subtitle: 'Tiêu đề',
    together_create_placeholder1: 'Nhập tiêu đề (Tối đa 20 chữ)',
    together_create_subtitle1: 'Giới thiệu ngắn gọn',
    together_create_placeholder2: 'Nhập giới thiệu ngắn gọn',
    together_create_subtitle2: 'Sử dụng Cùng nhau với công cụ nào',
    together_create_text1: 'Liên kết cuộc họp trực tuyến (ví dụ: liên kết Zoom)',
    together_create_placeholder3: 'Vui lòng nhập liên kết cuộc họp trực tuyến',
    together_create_question1: 'Không biết liên kết Zoom?',
    together_create_q1_a_title: 'Tìm liên kết tham gia cuộc họp Zoom',
    together_create_text2: 'Hoặc sử dụng metaverse',
    together_create_placeholder4: 'Chọn cái phù hợp với Cùng nhau',
    together_create_question2: 'Không biết metaverse là gì?',
    together_create_text3: 'Mở Cùng nhau ở đâu',
    together_create_dropmenu1: 'Mở tại góc kiến thức uỷ quyền YouBook',
    together_create_dropmenu2: 'Mở tại góc tác giả và độc giả',
    together_create_button2: 'Sửa',
    together_create_button3: 'Tạo',
    together_create_popup_title: 'Chọn hoạt động metaverse',
    together_create_popup_alert: 'Đã chọn',
    together_create_button4: 'Chọn',
    together_create_alert: 'Vui lòng nhập liên kết cho cuộc họp trực tuyếnm',
    together_create_alert1: 'Nhập tiêu đề',
    together_create_alert2: 'Chọn metaverse để sử dụng',
    together_create_alert3: 'Không thể chỉnh sửa',
    together_create_alert4: 'Không gian sự kiện đã được tạo',
    together_create_alert5: 'Lỗi. Vui lòng thử lại',
    together_create_alert6: 'Tạo không gian sự kiện thất bại...',
    together_qa_popup_title1: 'Tìm liên kết tham gia cuộc họp Zoom',
    together_qa_popup_btext1: 'Máy tính',
    together_qa_popup_text1: ' : ',
    together_qa_popup_text1_1: 'Mở chương trình Zoom - Sau khi đăng nhập - Nhấn vào menu cuộc họp ở trên cùng - ID cuộc họp cá nhân của tôi - Nhấn hiển thị lời mời cuộc họp - Liên kết tham gia cuộc họp Zoom sẽ xuất hiện. Sao chép liên kết đó.',
    together_qa_popup_btext2: 'Điện thoại thông minh',
    together_qa_popup_text2: ' : ',
    together_qa_popup_text2_1: 'Mở chương trình Zoom - Sau khi đăng nhập - Nhấn nút i ở góc trên bên phải - Gửi lời mời - Sau khi nhấn vào tin nhắn - Nhập số điện thoại của bạn - Một liên kết sẽ xuất hiện. Sao chép nó.',
    together_qa_popup_text2_2: '',
    together_qa_popup_text2_3: '',
    together_qa_popup_title2: 'Metaverse là gì?',
    together_qa_popup_text3: 'Đây là không gian họp ảo.',
    together_qa_popup_text4: 'Xuất hiện dưới dạng avatar',
    together_qa_popup_text5: 'Có thể nói chuyện trực tiếp với bạn bè và chia sẻ màn hình',
    together_qa_popup_text7: 'Trong một không gian họp',
    together_qa_popup_text8: '10 người có thể vào cùng một lúc.',
    together_qa_popup_text9: 'Không cần cài đặt chương trình riêng',
    together_qa_popup_text10: 'hoặc đăng ký thành viên.',
    together_more_list_title: 'Không gian sự kiện',
    together_more_list_date: 'DD.MM.YYYY',
    together_request_list_title: 'Làm giúp tôi nhé',
    together_request_list_category1: 'Yêu thích nhất',
    together_request_list_category2: 'Mới nhất',
    together_request_list_button: 'Đề xuất không gian mới',
    together_request_popup_title: 'Gợi ý không gian mới',
    together_request_popup_alert1: 'Nhập tiêu đề',
    together_request_popup_alert2: 'Nhập nội dung',
    together_request_popup_placeholder1: 'Nhập tiêu đề',
    together_request_popup_placeholder2: 'Nhập giới thiệu nội dung',
    together_request_popup_button: 'Đăng ký',
    together_request_detail_button: 'Tạo không gian này',
    together_detail_sns: 'Mời bạn bè',
    together_detail_enterbtn: 'Tham gia',
    together_detail_btn1: 'Danh sách sự kiện',
    together_detail_btn2: 'Tin nhắn',
    together_detail_subtitle: 'Sách nhỏ về chủ đề',
    together_detail_alert: 'Chờ một chút..',
    together_detail_alert1: 'Đề xuất không gian sự kiện thành công!',
    together_detail_alert2: 'Đề xuất không gian sự kiện thất bại…',
    together_detail_alert3: 'Yêu thích / Hủy yêu thích thành công',
    together_detail_alert4: 'Yêu thích / Hủy yêu thích thất bại',
    together_detail_alert5: 'Phát sinh sự cố trên máy chủ, vui lòng thử lại sau',
    together_detail_alert6: 'Có vấn đề với liên kết cuộc họp trực tuyến',
    together_detail_alert7: 'Xoá thất bại',
    together_notice_alert: 'Bạn có muốn xóa thông báo không?',
    together_notice_list_title: 'Thông báo',
    together_button_addtopic: 'Thêm mục này làm chủ đề cho không gian sự kiện',
    together_add_alert: 'Đã thêm vào không gian sự kiện',
    together_text1: 'Sở thích tương tự như của bạn',
    together_text2: 'Bạn có muốn xóa không gian sự kiện này không?',
    together_event_btn: 'Tạo sự kiện mới',
    together_event_title: 'Sự kiện mới',
    together_event_placeholder: 'Nhập mô tả',
    together_event_text1: 'Đặt lịch trình',
    together_event_text2: 'Đặt phí vào cửa',
    together_event_text3: 'Đặt số lượng tối đa',
    together_event_text4: 'Lịch trình',
    together_event_text5: 'Phí vào cửa',
    together_event_text6: 'Số lượng tối đa',
    together_event_text7: 'Thông báo cho người theo dõi của tôi',
    together_event_text8: 'Bạn có muốn xóa sự kiện không?',
    together_event_text9: 'Vui lòng đặt thời gian bắt đầu sau thời gian hiện tại',
    together_event_text10: 'Vui lòng đặt thời gian kết thúc sau thời gian bắt đầu',
    together_event_text11: 'Thời gian bắt đầu và thời gian kết thúc không thể giống nhau',
    together_event_text12: 'Thêm điều này vào chủ đề sự kiện',
    together_event_text13: 'Đã thêm vào sự kiện',
    together_event_text14: 'Sự kiện đã vượt quá số lượng tối đa',
    together_event_text15: 'Nút sẽ được kích hoạt trước Sự kiện 1 giờ \n(nếu miễn phí không cần Mua)',
    together_event_text16: 'Nút sẽ được kích hoạt trước Sự kiện 1 giờ',
    together_event_text17: 'Không có sự kiện nào tồn tại',
    together_event_text18: 'Không thể xóa nếu có người mua sự kiện',
    together_event_text19: 'Bạn có muốn gửi thông báo không?',
    together_event_text20: 'Đã gửi',
    together_event_text21: 'Danh sách sự kiện',
    together_event_text22: 'Xem chi tiết',
    together_event_text23: 'Sau khi Đăng ký vui lòng đăng nhập',
    together_event_text24: 'Cách tham gia',
    together_event_text25: 'Hoàn tất tham gia sự kiện',
    together_event_text26: 'Tác giả đã dành rất nhiều thời gian và tâm huyết cho sự kiện này.\n\nHãy hồi đáp bằng một món quà nhỏ.',
    together_event_text27: 'Sự khôn ngoan từ kinh nghiệm của tác giả và sự giao tiếp sâu sắc thật ấn tượng',
    together_event_text28: 'Hãy chia sẻ sự kiện này với thế giới',
    together_event_text29: 'Không dễ để mở sự kiện này, nhưng tôi đã làm được.',
    together_event_text30: 'Dù sự kiện có tuyệt vời đến đâu, cũng rất khó để lan tỏa nó một mình.',
    together_event_text31: 'Người ủng hộ là người giúp lan tỏa sự kiện của tác giả đến thế giới. Họ là những người ủng hộ lẫn nhau.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'Gặp gỡ mọi người từ khắp nơi trên thế giới',
    youbooker_case: 'Ý tưởng YouBooker',
    youbooker_case_text1: 'Là người luôn bắt đầu',
    youbooker_case_text2: 'Hiệu ứng lãi kép của kiến thức, ngày mai tôi sẽ tốt hơn nhiều',
    youbooker_translation: 'Bạn có muốn gặp ngay bây giờ không?',
    youbooker_translation_text1: 'Tất cả các ngôn ngữ',
    youbooker_category: 'Người theo dõi / Đang theo dõi',
    youbooker_subcategory1: 'Người theo dõi của tôi',
    youbooker_subcategory2: 'Tôi đang theo dõi',
    youbooker_subtitle2: 'Người đang theo dõi tôi',
    youbooker_button_follow: 'Theo dõi',
    youbooker_message_follow: 'Theo dõi',
    youbooker_button_follow_cancel: 'Bỏ theo dõi',
    youbooker_subtitle3: 'Đây là người dùng bạn biết. Hãy theo dõi',
    youbooker_subtitle4: 'Người tôi đang theo dõi',
    youbooker_subtitle5: 'Những người bạn biết chưa biết tới YouBook',
    youbooker_button_invite: 'Mời',
    youbooker_alert_invite: 'Chỉ có thể mời qua ứng dụng. Hãy tải ứng dụng',
    youbooker_alert: 'Chỉ khả dụng trong ứng dụng. Hãy tải ứng dụng',
    youbooker_alert2: 'Làm mới thành công!',
    youbooker_alert3: 'Bạn có thể tìm kiếm trên tab YouBooker',
    home_page_text1: 'Mới nhất',
    home_page_text2: 'Ảnh hưởng',
    home_page_today_title: 'Vấn đề hôm nay',
    home_page_today_subtitle: 'Liên quan đến tin tức hàng đầu',
    home_page_slider_date: 'DD.MM.YYYY',
    home_page_today_list_title: 'Vấn đề hôm nay',
    home_page_today_detail_sns: 'Chia sẻ',
    home_page_today_detail_date: 'DD.MM.YYYY',
    home_page_today_detail_subtitle: 'Trang liên quan',
    home_page_explor_title: 'Khám phá trang',
    home_page_explor_subtitle: 'Nếu nhấn đúp thì sao?',
    home_page_recommend_title: 'Gợi ý',
    home_page_recommend_subtitle: 'Các trang có thể bạn quan tâm',
    home_page_theysee_title: 'Họ thấy gì',
    home_page_theysee_subtitle: 'Các trang độc giả chắc chắn xem',
    home_page_common_title: 'Những thường thức này thì sao?',
    home_page_common_subtitle: 'Sức mạnh của thường thức rất mạnh mẽ. Nó giúp chúng ta nhìn nhận chính xác',
    home_page_keyw_title: 'Các trang theo từ khóa',
    home_page_keyw_subtitle: 'Tìm tất cả các kiến thức liên quan',
    home_page_random_title: 'Đi ngẫu nhiên',
    home_page_random_subtitle: 'Nhấn khi bạn trống rỗng, để học điều gì đó một cách tình cờ.',
    home_page_about_detail: 'Tập đoàn: NICK syndicate<br />Trung tâm thương mại Việt Nam: Hà Nội<br />Trung tâm quốc gia khác: LA Tokyo Thượng Hải Seoul<br />Liên hệ: joa@academy-connect.net',
    settlement_title: 'Mua hàng & Thanh toán',
    settlement_tab1: 'Hồ sơ đơn hàng',
    settlement_tab2: 'Thông tin tài khoản',
    settlement_tab3: 'Chi tiết thanh toán',
    settlement_category1: 'Hồ sơ mua hàng của tôi',
    settlement_category2: 'Chia sẻ quyền tác giả',
    settlement_category3: 'Hồ sơ thanh toán doanh thu sách nhỏ',
    settlement_category4: 'Hồ sơ thanh toán doanh thu sự kiện',
    settlement_category5: 'Quản lý tài khoản',
    settlement_text1: 'Hiển thị hồ sơ mua hàng',
    settlement_text2: 'Bạn có thể chia sẻ quyền tác giả của sách nhỏ',
    settlement_text3: 'Kiểm tra lợi nhuận thu được từ bán Sách nhỏ.',
    settlement_text4: 'Nếu có câu hỏi nào khác nhấn',
    settlement_text5: 'vào đây',
    settlement_text6: 'Hoặc liên hệ với chúng tôi như bên dưới.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'Hãy nói gì đó',
    settlement_text9: 'Nếu có doanh thu, bạn cần quản lý tài khoản để nhận thanh toán',
    settlement_text10: 'Thanh toán doanh thu từ sự kiện',
    settlement_purchase_text1: 'Hồ sơ mua hàng',
    settlement_purchase_text2: 'Ngày',
    settlement_purchase_text3: 'Số tiền mua',
    settlement_purchase_text4: 'Tiêu đề',
    settlement_purchase_text5: 'Sách nhỏ',
    settlement_purchase_text6: 'Sự kiện',
    settlement_accountInfo_text1: 'Quyền tác giả của sách nhỏ',
    settlement_accountInfo_text2: 'Chọn Sách nhỏ',
    settlement_accountInfo_text3: 'Chọn ngôn ngữ',
    settlement_accountInfo_text4: 'Quyền tác giả',
    settlement_accountInfo_text5: 'Tác giả',
    settlement_accountInfo_text6: 'Bên thứ ba',
    settlement_accountInfo_text7: 'Cá nhân?',
    settlement_accountInfo_text8: 'Cá nhân',
    settlement_accountInfo_text9: 'Công ty',
    settlement_accountInfo_text10: 'Tên ngân hàng',
    settlement_accountInfo_text10_message: 'Chọn tên ngân hàng',
    settlement_accountInfo_text11: 'Tên chủ tài khoản',
    settlement_accountInfo_text11_message: 'Nhập tên chủ tài khoản',
    settlement_accountInfo_text12: 'Số tài khoản',
    settlement_accountInfo_text12_message: 'Nhập số tài khoản',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'Số căn cước công dân',
    settlement_accountInfo_text13_message: 'Nhập số căn cước công dân',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'Địa chỉ',
    settlement_accountInfo_text14_message: 'Nhập địa chỉ',
    settlement_accountInfo_text14_placeholder: 'Điạ chỉ trên thẻ căn cước công dân',
    settlement_accountInfo_text15: 'Email',
    settlement_accountInfo_text15_message: 'Nhập email',
    settlement_accountInfo_text16: 'Hoàn tất nhập',
    settlement_accountInfo_text17: 'Số đăng ký kinh doanh',
    settlement_accountInfo_text17_message: 'Nhập số đăng ký kinh doanh',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'Địa chỉ công ty',
    settlement_accountInfo_text18_message: 'Nhập địa chỉ công ty',
    settlement_accountInfo_text18_placeholder: 'Địa chỉ đăng kí kinh doanh',
    settlement_accountInfo_text19: 'Tên công ty',
    settlement_accountInfo_text19_message: 'Nhập tên công ty',
    settlement_accountInfo_text20: 'Điện thoại công ty',
    settlement_accountInfo_text20_message: 'Nhập điện thoại công ty',
    settlement_accountInfo_text21: 'ID bên thứ ba',
    settlement_accountInfo_text21_placeholder: 'Email của bên thứ ba',
    settlement_accountInfo_text22: 'Tài khoản nhận thanh toán',
    settlement_accountInfo_text23: 'Chọn quốc gia',
    settlement_accountInfo_message1: 'Không tìm thấy email',
    settlement_accountInfo_message2: 'Bạn không thể chia sẻ quyền tác giả với chính mình',
    settlement_accountInfo_message3: 'Không có Sách nhỏ nào được tạo',
    settlement_accountInfo_text24: 'Chia sẻ quyền tác giả',
    settlement_accountInfo_text25: 'Nếu bạn chia sẻ quyền tác giả với bên thứ ba, sẽ không thể thu hồi lại được',
    settlement_accountInfo_text26: 'Bạn có muốn chia sẻ quyền tác giả không?',
    settlement_accountInfo_text27: 'Vâng, tôi muốn chia sẻ',
    settlement_accountInfo_text28: 'Để chia sẻ quyền tác giả,<br /> 1) các trang trong sách nhỏ phải do bạn tạo ra và <br /> 2) chưa từng được chia sẻ với bên thứ ba',
    settlement_accountInfo_text29: 'Được, tôi sẽ sửa',
    settlement_accountInfo_text30: 'Bạn đã chia sẻ quyền tác giả sách nhỏ này cho bên thứ ba',
    settlement_accountInfo_text31: 'Tác giả',
    settlement_accountInfo_text32: 'Bên thứ ba',
    settlement_accountInfo_text33: 'Bạn đã nhận quyền tác giả sách nhỏ này từ tác giả',
    settlement_accountInfo_text34: 'Đây là Sách nhỏ miễn phí. Không cần tài khoản thanh toán.',
    settlement_accountInfo_text35: 'Chia sẻ doanh thu',
    settlement_accountInfo_text36: '(tôi)',
    settlement_accountInfo_text37: '(các nhà xuất bản, v.v.)',
    settlement_accountInfo_text38: 'Tài khoản cá nhân',
    settlement_accountInfo_text39: 'Tài khoản công ty',
    settlement_accountInfo_text40: 'Quản lý tài khoản',
    settlement_accountInfo_text41: 'Lưu',
    settlement_accountInfo_text42: 'Ngân hàng',
    settlement_accountInfo_text43: 'Lựa chọn tài khoản',
    settlement_accountInfo_text44: 'Xác định cách chia sẻ doanh thu',
    settlement_accountInfo_text45: 'Tỷ lệ doanh thu (%)',
    settlement_accountInfo_text46: 'ID của tôi (email)',
    settlement_accountInfo_text47: 'ID của bên thứ ba (email)',
    settlement_accountInfo_text48: 'Khớp Tổng cộng',
    settlement_accountInfo_text49: 'Vui lòng nhập thông tin người nhận quyền',
    settlement_accountInfo_text50: 'Tỷ lệ doanh thu không được vượt quá 100',
    settlement_accountInfo_text51: 'Người chuyển nhượng ID(email)',
    settlement_accountInfo_text52: 'Người nhận quyền ID(email)',
    settlement_earnings_text1: 'Kiểm tra chi tiết thanh toán',
    settlement_earnings_text2: 'Kì hạn thanh toán',
    settlement_earnings_text3: 'Giá Sách nhỏ',
    settlement_earnings_text4: 'Số lượng bán',
    settlement_earnings_text5: 'Doanh thu bán hàng',
    settlement_earnings_text6: 'Các khoản khấu trừ thuế...',
    settlement_earnings_text7: 'Số tiền gửi',
    settlement_earnings_text8: 'Ngày gửi tiền',
    settlement_earnings_text9: 'Lượt xem quảng cáo',
    settlement_earnings_text10: 'Tổng số tiền',
    settlement_earnings_text11: 'Tìm hiểu thêm',
    settlement_earnings_text12: 'Giá quảng cáo',
    settlement_earnings_text13: 'Doanh thu',
    settlement_earnings_text14: 'Tất cả sách nhỏ',
    settlement_earnings_text15: 'Chọn sự kiện',
    settlement_earnings_text16: 'Tất cả sự kiện',
    settlement_statistics_text1: 'Lượng bán hàng',
    settlement_statistics_text2: 'Số lượng độc giả',
    settlement_statistics_text3: '(quá khứ)',
    settlement_statistics_text4: '1 tháng',
    settlement_statistics_text5: '6 tháng',
    settlement_statistics_text6: '1 năm',
    settlement_statistics_text7: 'Không có dữ liệu',
    settlement_statistics_text8: 'Phân tích bán hàng',
    settlement_statistics_text9: 'Xem quảng cáo',
    settlement_statistics_text10: 'Tất cả các ngôn ngữ',
    terms_title: 'Điều khoản dịch vụ',
    terms_text: '',
    privacy_title: 'Chính sách bảo mật',
    privacy_text: '',
    // common text
    message_save: 'Đã đăng ký',
    message_fail: 'Đăng ký thất bại',
    message_delete: 'Đã xóa',
    message_report: 'Đã báo cáo',
    message_search_no_result: 'Không tìm thấy kết quả tìm kiếm',
    message_search_enter: 'Vui lòng nhập từ khóa tìm kiếm',
    message_error1: 'Đã xảy ra lỗi. Vui lòng liên hệ với quản trị viên',
    message_save2: 'Đã lưu',
    message_fail2: 'Lưu thất bại',
    message_login: 'Bạn cần Đăng nhập',
    name: 'Tên',
    email: 'Email',
    mobile: 'Di động',
    list: 'Danh sách',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    search: 'Tìm kiếm',
    report: 'Báo cáo nội dung',
    user: 'Người dùng',
    report_type: 'Chọn lí do báo cáo',
    report_type1: 'Tục tĩu/ Phỉ báng',
    report_type2: 'Quảng cáo',
    report_type3: 'Khiêu dâm/ Nội dung nhạy cảm',
    report_type4: 'Lặp lại nội dung giống nhau',
    report_type5: 'Khác',
    search_book: 'Tìm kiếm Sách nhỏ',
    serch_placeholder: 'Tìm kiếm theo tên hoặc email',
    search_keyword: 'Từ khóa',
    search_reference: 'Tài liệu tham khảo',
    search_author: 'Tác giả',
    search_result: 'Đã tìm thấy',
    button_report: 'Báo cáo',
    button_write: 'Đăng ký',
    button_login: 'Đăng nhập',
    button_more: 'Thêm',
    button_confirm: 'Xác nhận',
    button_save: 'Lưu',
    button_crop: 'Chọn',
    button_delete: 'Xóa',
    button_complete: 'hoàn thành',
    colorbox_background_text1: 'Chọn màu nền',
    colorbox_font_text1: 'Chọn màu tiêu đề',
    menu_home: 'Trang chủ',
    menu_page: 'Trang',
    menu_book: 'Sách nhỏ',
    menu_memo: 'Ghi chú',
    menu_together: 'Sự kiện',
    login_button: 'Đăng nhập',
    message_text1: 'Trả lời',
    message_text2: 'Có người trả lời bình luận của mình rồi nè',
  },
  ar: {
    home_banner_title1: 'الكتاب الصغير الجديد',
    home_banner_title2: ' حدث جديد',
    home_slide_title1: 'رائج الآن',
    home_slide_title2: 'ذوقي',
    home_slide_title3: 'الأكثر سخونة الآن',
    home_slide_title4: 'شائع جدًا',
    home_detail_title1: 'ذكريات الحياة اليومية',
    home_detail_title2: 'فيديوهات موصى بها',
    home_detail_title3: 'إذا أردت أن تعرف أكثر',
    home_detail_text1: 'كتاب صغير كتاب صغير',
    home_detail_text2: 'كتاب صغير يومي',
    home_setting_title: 'إعدادات',
    home_setting_text1: 'الصفحات التي تمت مشاهدتها خلال آخر 30 يومًا',
    home_setting_text2: 'تسجيل الخروج',
    home_setting_text3: 'حذف الحساب',
    home_book_banner_question: 'أنا مهتم بمعرفة المزيد',
    home_book_banner_write_placeholder1: 'أدخل عنوانًا',
    home_book_banner_write_placeholder2: 'إنشاء منشور',
    home_book_banner_write_button: 'حفظ',
    home_book_banner_detail_text1: 'إجابة مرشد YouBook',
    home_book_banner_detail_text2: 'الكتب المصغرة ذات الصلة',
    home_book_create_button: 'الكتاب الصغير، قم بإنشائه',
    home_book_create_text1: 'الكتاب الصغير هو كتاب قصير يتكون من حوالي 10 صفحات. إنه كتاب يناسب الاتجاه السائد في قراءة النصوص المختصرة التي تحتوي على الفكرة الأساسية بسرعة.',
    home_book_create_text2: 'كيفية تحرير بعد النشر',
    home_book_create_text3: 'الكتاب الصغير، طريقة إنشاء سهلة',
    home_book_create_text4: 'كم ستكون أرباح الكاتب؟',
    home_book_create_text5: 'كيف يمكنني الوصول إلى القراء؟',
    home_book_create_text6: '5 أسباب لاستخدام YouBook',
    home_book_create_text7: 'أي أسئلة أخرى؟',
    home_book_create_text8: 'هل يمكنني معرفة المبيعات في الوقت الفعلي؟',
    home_book_create_text9: 'لنواصل الكتابة يوميًا!',
    home_book_create_text10: 'ابدأ الآن، فورًا!',
    home_book_category_title1: 'قضايا اليوم والكتاب الصغير',
    home_book_category_title2: 'الكتب المصغرة الرائجة',
    home_book_category_title3: 'كتب مصغرة لأستاذ S-class',
    home_book_category_title4: 'اقتراحات مخصصة لك',
    home_book_category_title5: 'كتب مصغرة مستخرجة من جوهر الكتب الأكثر مبيعاً',
    home_book_category_title6: 'مع قطوبي',
    home_book_category_title6_text1: 'عرض',
    home_book_category_title6_text2: 'إغلاق',
    home_book_category_title7: 'استكشاف صفحات الشبكات العصبية',
    home_book_category_title8: 'عرض الفن والعاطفة',
    home_book_category_title8_text1: 'العوالم في الأفلام والدراما',
    home_book_category_title8_text2: 'موسيقى واستعراضات تخاطب الوجدان',
    home_book_category_title8_text3: 'الفن بلا حدود',
    home_book_category_title8_text4: 'شخصيتك من ملابسك: الأزياء والموضة',
    home_book_category_title9: 'ثقافة وفن الطهي: مذاق ورفاهية',
    home_book_category_title9_text1: 'استكشاف المأكولات المحلية',
    home_book_category_title9_text2: 'حكايات عن تجارب الحياة والمشروبات الكحولية ',
    home_book_category_title9_text3: 'سحر الوجبات الخفيفة والحلويات',
    home_book_category_title9_text4: 'قوة الطبيعة، أسرار النباتات',
    home_book_category_title10: 'الحكمة واكتشاف الذات',
    home_book_category_title10_text1: 'إدارة مالية مبتكرة',
    home_book_category_title10_text2: 'أسرار تطوير الذات',
    home_book_category_title10_text3: 'مفاتيح لحل الخلافات في العلاقات',
    home_book_category_title10_text4: 'اكتشافات ومعرفة جديدة',
    home_book_category_title11: 'تنوع الآراء والحب',
    home_book_category_title11_text1: 'قصص من حياتهم',
    home_book_category_title11_text2: 'فلسفات وقيم متنوعة',
    home_book_category_title11_text3: 'المعتقدات والتقاليد الدينية',
    home_book_category_title11_text4: 'ألغاز الحب',
    home_book_category_title12: 'أيام حافلة بالسفر والهوايات',
    home_book_category_title12_text1: 'وجهات مخفية تستحق الزيارة',
    home_book_category_title12_text2: 'متعة الحياة عبر الهوايات',
    home_book_category_title12_text3: 'اكتشاف الثقافات الفريدة من خلال اللعب',
    home_book_category_title13: 'ثراء التقاليد والحكايات',
    home_book_category_title13_text1: 'الأساطير الشعبية والأبطال',
    home_book_category_title13_text2: 'رحلات في الأدب العالمي',
    home_book_category_title13_text3: 'حكمة الأماكن وتاريخها',
    home_book_category_title13_text4: 'قصص اجتماعية غنية بالألوان',
    home_book_category_title1_text2: 'أفكار قطوبي - هل ترغب في إلقاء نظرة سريعة؟',
    home_book_category_title1_text3: 'هل لديك سؤال أو قلق؟',
    home_book_category_title1_text4: 'هل ترغب في توصية بالكتاب الصغير؟',
    home_book_search_placeholder1: 'تفضل بالتحدث هنا',
    home_book_search_placeholder2: 'الكلمة الرئيسية؟',
    home_book_search_message1: 'اطرح أسئلتك هنا',
    home_book_search_message2: 'قم بطرح أسئلتك مرة أخرى',
    home_book_search_text1: 'لماذا لا تشاركني رأيك؟',
    home_book_search_text2: 'لماذا لا تناقش معي؟',
    home_book_search_text3: 'اسأل',
    home_book_search_text4: 'مكنك حفظ ما سبق',
    home_book_search_text5: '(قم بإضافة الكلمات المفتاحية فقط)',
    home_book_search_text6: 'ابحث',
    home_book_theme_title: 'كتب مقسمة حسب الموضوعات',
    home_instant_text1: 'أدخل كلمة مفتاحية',
    home_instant_text2: 'أدخل بشكل عشوائي',
    home_book_company_info: 'إذا كان لديك أي استفسارات إضافية، فلا تتردد في التواصل معنا عبر معلومات الاتصال أدناه. نحن هنا لمساعدتك.',
    home_page_search_text1: 'بحث الصفحة',
    home_page_search_text2: 'تشغيل كفيديو تلقائيا',
    home_page_search_text3: 'بحث متقدم',
    home_page_search_text4: 'عرض كقائمة',
    home_page_search_text5: 'عرض الشبكة',
    home_page_explor_alert: 'لم يتم اختيار أي صفحات',
    home_page_explor_alert2: 'لقد تجاوزت الحد الأقصى لعدد الصفحات التي يمكن عرضها في شاشة واحدة (150). يرجى وضع الصفحات غير الضرورية في سلة المهملات',
    home_page_explor_alert3: 'لا توجد معلومات إضافية للتحميل',
    my_login_title: 'MY',
    my_login_text1: 'اجعل ملفك الشخصي أنيقًا',
    my_login_text2: 'سجل الدخول الآن وابدأ في التميز',
    my_login_text3: 'مع YouBook',
    my_login_find_password: 'استرجع كلمة المرور',
    my_guide_minibook: 'كيف تصنع كتابًا مصغرًا',
    my_password_reset: 'إعادة تعيين كلمة المرور',
    my_password_reset_text1: 'أدخل بريدك الإلكتروني السابق لتسجيل الدخول',
    my_password_reset_button1: 'إرسال رابط لإعادة التعيين',
    my_password_reset_button2: 'إعادة التعيين',
    my_password_reset_message1: 'تعذر العثور على بريدك الإلكتروني',
    my_password_reset_message2: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى البريد الإلكتروني الذي أدخلته',
    my_password_reset_message3: 'يرجى إعادة تعيين كلمة المرور الخاصة بك باستخدام الرابط المرسل إلى بريدك الإلكتروني.',
    my_password_reset_placeholder1: 'بريدك الإلكتروني',
    my_password_reset_placeholder2: 'قم بإدخال كلمة المرور الجديدة',
    my_password_reset_placeholder3: 'أعد كتابة كلمة المرور الجديدة',
    my_password_reset_message4: 'كلمات المرور غير متطابقة',
    my_password_reset_message5: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل وتحتوي على حرف كبير، حرف صغير، رقم، ورمز خاص.',
    my_password_reset_message6: 'تم إعادة تعيين كلمة المرور',
    my_memo_list_placeholder: 'هل لديك فكرة؟ قم بكتابتها الآن',
    my_profile_placehoder1: 'اهتماماتي',
    my_profile_placehoder2: 'اسمي',
    my_profile_placehoder3: 'تعريف مختصر عني',
    my_profile_placehoder4: 'مزيد من التعريف عن النفس',
    my_profile_text1: 'الجنسية',
    my_profile_text2: 'اللغة',
    my_profile_text3: 'تغيير معرّف الحساب',
    my_profile_text4: 'معرّف الحساب الحالي',
    my_profile_text5: 'معرّف الحساب الجديد',
    my_profile_text6: 'يمكنك تغيير معرّف الحساب مرة واحدة فقط',
    my_menu_text1: 'رحلتي',
    my_menu_text2: 'رسالة',
    my_menu_text3: 'الشراء والتسوية',
    my_menu_text4: 'إشعار جديد',
    my_menu_text5: 'قم بإنشاء كتاب مصغر',
    my_menu_text6: 'الكتب المصغرة التي تم إنشاؤها',
    my_menu_text7: 'هل ترغب في استيراد منشورات من تطبيقات أخرى؟',
    my_menu_text8: 'يمكنك استيرادها تلقائيًا وتحويلها إلى صفحة',
    my_menu_text9: 'استيراد',
    my_import_book_text1: 'تحويل إلى صفحة',
    my_import_book_text2: 'يتم الآن تحويل محتوى ملف ZIP إلى صفحة. قد يستغرق تحويل منشور واحد ما يصل إلى 5 ثوانٍ. قد يستغرق تحويل 10 منشورات دقيقة تقريبًا، و100 منشور حوالي 8 دقائق. عند اكتمال التحويل، ستظهر نافذة منبثقة للإعلام.',
    my_import_book_text3: 'حسنًا',
    my_import_book_text4: 'تم التحويل إلى صفحة',
    my_import_book_text5: 'تم تحويل جميع المنشورات داخل ملف ZIP إلى صفحات. تم تحويل كل منشور إلى صفحة منفصلة. يمكنك التحقق منها في "رحلتي - الصفحات التي تم إنشاؤها". تم حفظ الصفحات كحفظ مؤقت، ويمكن تعديلها.',
    my_import_book_text6: 'يمكنك استيراد المنشورات من تطبيقات أخرى وتحويلها تلقائيًا إلى صفحات. بعد ذلك، يمكنك تجميع الصفحات في كتاب صغير.',
    my_import_book_text7: 'كيفية استيراد منشورات من تطبيق آخر بصيغة ZIP',
    my_import_book_text8: 'يرجى رفع ملف ZIP',
    my_import_book_text9: 'رفع ملف Substack',
    my_import_book_text10: 'رفع ملف Medium',
    my_import_book_text11: 'بحث',
    my_import_book_text12: '* يتم تحويل كل منشور إلى صفحة منفصلة  ',
    my_import_book_text13: '* يمكنك التحقق من ذلك في صفحتي - الإعدادات - الصفحات التي تم إنشاؤها',
    my_import_book_text14: '* الصفحات محفوظة كحفظ مؤقت ويمكن تعديلها  ',
    my_import_book_text15: '* يمكن استيراد المنشورات التي قمت بكتابتها فقط  ',
    my_import_book_text16: 'نشر كتاب صغير باستخدام الصفحات المحوّلة',
    my_import_book_text17: 'أنشئ غلاف الكتاب الصغير  ',
    my_import_book_text18: 'اختر الصفحات التي تريد إضافتها إلى الكتاب الصغير  ',
    my_import_book_text19: 'انشر الكتاب الصغير  ',
    my_import_book_text20: 'يرجى قراءة التعليمات بعناية',
    my_import_book_text21: 'الملف ليس بصيغة ZIP',
    my_import_book_text22: 'يرجى رفع الملف',
    my_journey_title: 'رحلتي',
    my_journey_button_message: 'رسالة',
    my_journey_button_memo: 'مذكرة',
    my_journey_button_record: 'سجل',
    my_journey_button_follow: 'متابعة',
    my_journey_button_follow_cancel: 'إلغاء المتابعة',
    my_journey_message_text1: 'اترك رسالة',
    my_journey_message_placeholder: 'أدخل رسالتك',
    my_journey_message_message1: 'غير قادر على الرد',
    my_journey_message_message2: 'جارٍ الإرسال',
    my_journey_message_message3: 'اكتب نص رسالتك',
    my_journey_memo_total: 'الإجمالي',
    my_journey_record_overall: 'ترتيب التأثير',
    my_journey_record_text1: 'الصفحات التي تم عرضها',
    my_journey_record_text2: 'الكتب المصغرة المفضلة',
    my_journey_record_text3: 'فضاء الحدث المفضل',
    my_journey_record_text4: 'الصفحات التي تم إنشاؤها',
    my_journey_record_text5: 'الكتب المصغرة التي تم إنشاؤها',
    my_journey_record_text6: 'فضاء الحدث الذي أنشأته',
    my_journey_record_text7: 'هذا الشهر',
    my_journey_record_text8: 'الكتاب الصغير الذي تم شراؤه',
    my_journey_record_text9: 'عام',
    my_journey_record_text10: 'خاص',
    my_journey_record_text11: 'الأحداث المشتراة',
    my_journey_record_text12: 'الحدث الذي أنشأته',
    my_journey_record_text13: 'المرتبة {userRank} في تصنيف {userLanguage}',
    my_journey_record_text14: 'الكتاب الصغير لمشاركة حقوق النشر',
    my_journey_record_text15: 'هل هناك ترتيب ترغب في أن يقرأ به القراء؟ إذا كان الأمر كذلك، اسحب الغلاف لتغيير الترتيب.',
    my_journey_record_text16: 'شجع الكتاب الصغير الجديد',
    my_journey_record_text17: 'رسائل دعم من القراء',
    my_journey_record_text18: 'اترك رسالة دعم للمؤلف',
    my_journey_record_text19: 'مستوى الداعمًا',
    my_journey_record_text20: 'المستوى {cheeringLevel} من 10',
    my_journey_record_text21: 'الأشخاص الذين أدعمهم',
    my_journey_record_text22: 'الداعمون الخاصون بي',
    my_journey_record_text23: 'هل تريد الحذف؟',
    my_journey_record_text24: 'داعمًا لـ {userName}',
    my_journey_record_text25: 'بدعم من {userName}',
    my_notice_title: 'الإشعارات',
    my_notice_message1: 'الكتب المصغرة',
    my_notice_text1: 'وصل العدد الجديد من الكتاب المصغر',
    my_notice_text2: 'تم إصدار عدد اليوم الجديد',
    my_notice_text3: 'رسالة جديدة إلى رحلتي',
    my_notice_text4: 'تعليق جديد على مذكرتي',
    my_notice_text5: 'تعليق جديد على فضاء الحدث الخاص بي',
    my_notice_text6: 'تعليق جديد على غلاف كتابي المصغر',
    my_notice_text7: 'تعليق جديد على صفحة كتابي المصغر',
    my_notice_text8: 'نشر مذكرة جديدة',
    my_notice_text9: 'قام {userName} بإنشاء فضاء حدث جديد',
    my_notice_text10: 'تم نشر كتاب مصغر جديد',
    my_notice_text11: 'قام بشراء كتابي الصغير',
    my_notice_text12: 'قام {userName} بإنشاء <b>حدث جديد</b>',
    my_notice_text13: 'لقد دعاك {userName} خصيصًا إلى <b>الحدث الجديد</b>. لا تفوت الفرصة!',
    my_notice_text14: 'قام {userName} بـ<b>شراء الحدث الخاص بي</b>',
    my_notice_text15: 'قدم {userName} طلبًا ليكون مؤلفًا مشاركًا',
    my_notice_text16: 'تمت الموافقة على طلب المؤلف المشارك في الكتاب الصغير المفتوح',
    my_notice_text17: 'تمت إضافة تعليق جديد من قبل المؤلف المشارك',
    my_notice_text18: 'وصلتنا رسالة لدعم الكتاب الصغير الجديد',
    my_notice_text19: 'قام {userName} برعاية <b>كتابي الصغير</b>',
    my_marketing_banner_title: 'شجع نفسك',
    my_marketing_banner_text1: 'لقد تغلبت على الصعوبات، فادعم نفسك الآن',
    my_marketing_banner_btn: 'شجع الآن',
    my_marketing_title: 'شجع الآن',
    my_marketing_text1: 'اركب جناحي الكتاب الصغير والحدث - واجعل الترويج المرحلي هو الوقود - وكن مؤثرًا',
    my_marketing_text2: 'البريد الإلكتروني إلى القراء العاديين',
    my_marketing_text3: 'رسالة نصية إلى القراء العاديين',
    my_marketing_text4: 'البريد الإلكتروني إلى الأصدقاء',
    my_marketing_text5: 'رسالة نصية إلى الأصدقاء',
    my_marketing_text6: 'رابط على وسائل التواصل الاجتماعي',
    my_marketing_btn: 'ابدأ الآن',
    my_marketing_minibook_step1_title: 'دعم الكتاب الصغير',
    my_marketing_step1_subtitle: 'رابط على وسائل التواصل الاجتماعي',
    my_marketing_minibook_step1_text1: 'اربط الكتاب الصغير على وسائل التواصل الاجتماعي الخاصة بك وأضف وصفًا جذابًا',
    my_marketing_minibook_text1: 'ابحث عن الكتاب الصغير',
    my_marketing_step1_text1: 'انسخ الرابط',
    my_marketing_step1_btn: 'نسخ',
    my_marketing_step1_text2: 'الصق على وسائل التواصل الاجتماعي وأضف وصفًا',
    my_marketing_step1_sns1: 'فيسبوك',
    my_marketing_step1_sns2: 'إنستغرام',
    my_marketing_step1_sns3: 'لينكدإن',
    my_marketing_step1_sns4: 'كاكاو ستوري',
    my_marketing_step1_sns5: 'فرقة نافر',
    my_marketing_step1_sns6: 'مدونة نافر',
    my_marketing_step1_sns7: 'تويتر (X)',
    my_marketing_step1_sns8: 'ريديت',
    my_marketing_step1_sns9: 'ميديوم',
    my_marketing_step1_sns10: 'سابستاك',
    my_marketing_step1_sns11: 'Weibo (微博)',
    my_marketing_step1_sns12: 'Xiaohongshu (小红书)',
    my_marketing_step1_sns13: 'WeChat (微信)',
    my_marketing_step1_text3: 'يرجى اختيار الكتاب الصغير للمشاركة',
    my_marketing_step1_text4: 'تم نسخ الرابط',
    my_marketing_step1_text5: 'يرجى اختيار الحدث للمشاركة',
    my_marketing_step1_text6: 'البحث في وسائل التواصل الاجتماعي',
    my_marketing_event_step1_title: 'دعم الحدث',
    my_marketing_event_step1_text1: 'اربط الحدث على وسائل التواصل الاجتماعي الخاصة بك وأضف وصفًا جذابًا',
    my_marketing_event_text1: 'ابحث عن الحدث',
    my_marketing_event_search_title: 'بحث عن حدث',
    my_marketing_minibook_step2_title: 'تسويق الكتاب الصغير المرحلة 2',
    my_marketing_step2_subtitle: 'رسالة نصية إلى الأصدقاء',
    my_marketing_minibook_step2_text1: 'أرسل لأصدقائك رابط الكتاب الصغير مع مقدمة دافئة',
    my_marketing_step2_text2: 'أرسل لأصدقائك المقدمة مع الرابط',
    my_marketing_step2_placeholder: 'يرجى إدخال المقدمة',
    my_marketing_tab_text1: 'أصدقائي',
    my_marketing_event_step2_title: 'تسويق الحدث المرحلة 2',
    my_marketing_event_step2_text1: 'أرسل لأصدقائك رابط الحدث مع مقدمة دافئة',
    my_marketing_minibook_step3_title: 'تسويق الكتاب الصغير المرحلة 3',
    my_marketing_step3_subtitle: 'البريد الإلكتروني إلى الأصدقاء',
    my_marketing_minibook_step3_text1: 'أرسل لأصدقائك رابط الكتاب الصغير مع القصة الخلفية',
    my_marketing_step3_text1: 'استيراد قائمة جهات الاتصال',
    my_marketing_step3_placeholder: 'رفع ملف csv أو vcf',
    my_marketing_step3_text2: 'أرسل لأصدقائك القصة مع الرابط',
    my_marketing_step3_text3: 'استيراد قائمة أرقام هاتفك',
    my_marketing_step3_placeholder2: 'انقل القصة',
    my_marketing_event_step3_title: 'تسويق الحدث المرحلة 3',
    my_marketing_event_step3_text1: 'أرسل لأصدقائك رابط الحدث مع القصة الخلفية',
    my_marketing_text7: 'استيراد أرقام الهاتف',
    my_marketing_title2: 'إدارة أرقام الهاتف',
    my_marketing_text8: 'الهاتف',
    my_marketing_text9: 'عدد المرات',
    my_marketing_text10: 'استيراد جهات الاتصال',
    my_marketing_text11: 'يرجى رفع ملف csv أو vcf',
    my_marketing_text12: 'طريقة الاستيراد',
    my_marketing_text13: 'استيراد',
    my_marketing_title3: 'إدارة جهات الاتصال',
    contact_manage: 'إدارة جهات الاتصال',
    my_marketing_text14: 'حذف المحدد',
    my_marketing_text15: 'يرجى اختيار صديق',
    my_marketing_text16: 'يمكنك اختيار ما يصل إلى 100 صديق',
    my_marketing_text17: 'اكتمل التحميل',
    my_marketing_text18: 'تم تجاوز الحد الأقصى للأحرف',
    contact_phone: 'الهاتف',
    contact_organization: 'المنظمة',
    contact_title: 'المنصب',
    contact_memo: 'مذكرة',
    my_marketing_text19: 'تعديل التحديد',
    my_marketing_text20: 'اختيار التصنيف',
    my_marketing_text21: 'إضافة تصنيف جديد',
    my_marketing_text22: 'حذف التصنيف المحدد',
    my_marketing_text23: 'إضافة',
    my_marketing_btn2: 'تم التعديل',
    my_marketing_text24: 'يرجى اختيار جهة الاتصال لتحريرها',
    my_marketing_text25: 'يرجى اختيار التصنيف الذي تريد حذفه',
    my_marketing_text26: 'يرجى إدخال اسم التصنيف',
    my_marketing_text27: 'هذا التصنيف موجود بالفعل',
    my_marketing_text28: 'أضف التصنيف',
    my_marketing_text29: 'إلغاء',
    my_marketing_text30: 'تمت الإضافة',
    my_benefit_text1: 'لقد حصلت على حتى الآن',
    my_benefit_text2: 'ستحصل في عام',
    my_benefit_text3: 'أكثر من',
    my_benefit_text4: 'حساب المكاسب',
    my_benefit_text5: 'حساب المكاسب',
    my_benefit_text6: 'تحقق من',
    my_benefit_modal_text1: 'لقد حصلت على حتى الآن',
    my_benefit_modal_text2: 'دولار أمريكي',
    my_benefit_modal_text3: 'لقد ربحت',
    my_benefit_modal_text4: 'لنقم بحساب بسيط للغاية',
    my_benefit_modal_text5: 'عدد الصفحات التي تمت قراءتها حتى الآن',
    my_benefit_modal_text6: 'سعر إنشاء صفحة',
    my_benefit_modal_text7: 'دولار أمريكي',
    my_benefit_modal_text8: 'إذًا، مكاسبك هي',
    my_benefit_modal_text9: 'الآن، أضف فوائد المناقشات مع',
    my_benefit_modal_text10: 'الذكاء الاصطناعي، وستكون مكاسبك أكبر',
    my_benefit_modal_text11: 'استخدمه يوميًا واجنِ المكاسب',
    my_benefit_modal_text12: 'حسنًا، فهمت',
    my_story_text1: 'ما يقوله الأعضاء',
    my_story_text2: 'ندرك أن الكتب تُعاش وليست تُقرأ',
    my_story_text3: 'مذهل ما يحدث عند التعلم كل يوم',
    my_story_text4: 'الفخاخ المخفية للأذكياء، هل أنت منهم؟',
    my_story_text5: 'تحقق من المزيد من قصص الأعضاء',
    my_go_blog_text1: 'Youbook، آخر الأخبار وقصص من العملاء',
    my_go_blog_text2: 'اكتشف آخر الأخبار وتجارب المستخدمين من YouBook',
    my_go_blog_text3: 'تعرف على المزيد',
    my_channel_text1: 'ما رأيك في YouBook؟',
    my_channel_text2: 'شاركنا آرائك حول ما هو جيد وما يحتاج للتطوير',
    my_channel_text3: 'وأخبرنا إذا كان لديك أي أسئلة',
    my_channel_text4: 'شارك بكلمة',
    my_about_youbook_text1: 'لماذا يجب عليك استخدام YouBook',
    my_about_youbook_text2: 'جميع استفساراتك وإجاباتها هنا',
    my_about_youbook_text3: 'شروط الخدمة',
    my_app_text1: 'YouBook هو تطبيق مفيد بنسبة 100%',
    my_app_text2: 'قم بتحميله الآن واكتسب المعرفة',
    my_app_text3: 'تنزيل التطبيق',
    login_title: 'تسجيل الدخول',
    login_text1: 'تسجيل الدخول بالبريد الإلكتروني',
    login_text2: 'لم تسجل بعد؟',
    login_text3: 'نسيت كلمة المرور؟',
    login_text4: 'أو تسجيل الدخول بواسطة',
    login_text5: 'أوافق',
    login_placeholder1: 'البريد الإلكتروني لتسجيل الدخول',
    login_placeholder2: 'كلمة المرور',
    login_placeholder3: 'معرّف الحساب',
    login_message1: 'يرجى إدخال البريد الإلكتروني لتسجيل الدخول',
    login_message2: 'أدخل كلمة المرور الخاصة بك',
    login_message3: 'تم تسجيل الدخول بنجاح',
    login_message4: 'يرجى إدخال معرّف الحساب',
    logout_message1: 'هل تريد تسجيل الخروج؟',
    login_link1: 'التسجيل',
    login_link2: 'ابحث',
    login_link3: 'شروط الخدمة',
    register_title: 'التسجيل',
    register_text1: 'سجل بالبريد الإلكتروني',
    register_text2: 'اختر نوع العضوية',
    register_text3: 'شخصي',
    register_text4: 'مؤسسي',
    register_text5: 'أدخل معلوماتك',
    register_text6: 'هل سجلت بالفعل؟',
    register_text7: 'رقم التسجيل المؤسسي',
    register_text8: 'رقم تسجيل النشاط التجاري',
    register_text9: 'اسم المنظمة',
    register_placeholder1: 'رقم هاتفك متضمنًا رمز المنطقة',
    register_placeholder2: '( بدون - )',
    register_placeholder_repassword: 'أعد إدخال كلمة المرور',
    register_message1: 'أدخل رقم هاتفك',
    register_message2: 'أدخل رقم التسجيل المؤسسي',
    register_message3: 'يرجى إدخال رقم السجل التجاري',
    register_message4: 'يرجى إدخال اسم المنظمة',
    register_message5: 'تنسيق البريد الإلكتروني غير صالح',
    register_message6: 'هذا البريد الإلكتروني مسجل بالفعل',
    register_message7: 'يرجى التحقق من بريدك الإلكتروني',
    register_message8: 'يرجى اختيار جنسيتك',
    register_message9: 'تنسيق معرّف الحساب غير صحيح',
    register_message10: 'لا يمكن استخدام معرّف الحساب الذي أدخلته. الرجاء استخدام معرّف موصى به أو إدخال معرّف مختلف',
    register_message11: 'يرجى تأكيد معرّف الحساب',
    register_message12: 'هذا المعرّف مستخدم بالفعل. يرجى استخدام المعرّف المقترح أو إدخال معرّف آخر',
    register_button_verify: 'تحقق',
    register_button_verify_fail: 'لم يتم التحقق',
    register_button_verify_success: 'تم التحقق',
    register_welcome_message: 'نرحب بك في عضويتنا',
    withdraw_text1: 'إلغاء العضوية',
    withdraw_text2: 'إلغاء عضوية YouBook',
    withdraw_text3: 'هل أنت متأكد من أنك تريد الإلغاء؟',
    withdraw_text4: 'لا',
    withdraw_text5: 'نعم',
    withdraw_text6: 'لقد تم إلغاء عضويتك بنجاح',
    home_memo_title: 'مذكرة',
    home_memo_subtitle: 'إذا لم تدون مذكرتك، فقد تنساها',
    home_memo_text1: 'يتشاركها الجميع معًا',
    home_memo_text2: 'المعرفة وقصص الحياة اليومية',
    home_memo_button: 'أضف كتاب صغير',
    home_memo_create_text1: 'هل لديك كتاب صغير تريد ربطه؟',
    home_memo_create_button: 'ابحث عن الكتاب الصغير',
    home_memo_create_button2: 'اختر',
    home_memo_click: 'اضغط',
    home_memo_date: 'YYYY. M. D',
    home_memo_button_askai: 'تعليق / أفكار قطوبي',
    home_memo_view_detail: 'عرض التفاصيل',
    home_memo_view_placeholder: 'أدخل منشورًا',
    home_memo_view_button1: 'تعليق',
    home_memo_view_button2: 'أفكار قطوبي',
    home_memo_view_errormessage: 'أدخل منشورًا',

    memo_create_title: 'مذكرة',
    memo_create_category1: 'مذكرة',
    memo_create_category2: 'مذكرة',
    memo_create_private: 'خاص',
    memo_create_public: 'عام',
    memo_create_placeholder1: 'هل لديك فكرة؟',
    memo_create_placeholder2: 'اكتبها الآن',
    memo_create_placeholder3: 'الكلمات المفتاحية (مُفصولة بمسافة)',
    memo_create_button: 'حفظ',
    memo_create_error: 'أدخل مذكرتك',
    memo_attach_img: 'تحميل الصورة',
    memo_alert_rate: 'فضلاً حدد تقييمك باستخدام النجوم',
    memo_alert_save: 'تم الحفظ. يمكنك التحقق منه في ملفي الشخصي - رحلتي',
    memo_input_placeholder: 'ماذا تعلمت؟',
    memo_input_placeholder2: 'ما هي أفكارك؟',
    memo_input_placeholder3: 'شاركها مع القراء الآن~',
    memo_input_placeholder4: 'ذكرى من الحياة اليومية، هل نُسجلها؟',
    memo_alert_keywords: 'أدخل الكلمات المفتاحية',
    memo_related_text: 'مذكرة',
    memo_related_date: 'YYYY. M. D',
    memo_popup_text1: 'قصة نيكولاس لوهمان تبدو كحكاية عصرية تُظهر القوة التحويلية لعادة بسيطة.',
    memo_popup_text3: 'في البداية، كان لوهمان موظفًا شابًا في بيئة عمل مكتبية، بعيدًا عن عالم الأكاديميا.',
    memo_popup_text4: 'ومع ذلك، أدى شغفه الكبير بالقراءة إلى ممارسة غير عادية: تدوين ملاحظات يومية عن قراءاته.',
    memo_popup_text5: 'أدت هذه العادة إلى كتابة ورقة لفتت انتباه عالم اجتماع ألماني مرموق، مما أدى إلى تحول غير متوقع في مسيرته المهنية.',
    memo_popup_text6: 'تمت دعوة لوهمان للانضمام إلى هيئة التدريس في جامعة بيليفيلد، حيث ارتقى في النهاية إلى رتبة أستاذ كامل.',
    memo_popup_text7: 'خلال مسيرته، ألف 60 كتابًا وعددًا كبيرًا من المقالات، مما عزز مكانته كأحد أبرز علماء الاجتماع.',
    memo_popup_text8: 'عزا لوهمان قوته الفكرية إلى طريقته المنهجية في تدوين الملاحظات، قائلاً،',
    memo_popup_text9: '"لقد استمريت في تدوين الملاحظات فقط"،',
    memo_popup_text10: 'مما ساعده على تنظيم أفكاره وتعميق فهمه.',
    memo_popup_text11: 'تعد هذه القصة تذكيرًا بحدود الذاكرة وقيمة التقاط المعرفة بشكل منهجي ومراجعتها لجعلها ملكًا خاصًا.',
    memo_popup_btn: 'نعم، أستطيع أن أفهم ذلك',
    memo_text1: 'يمكنك حفظ ما سبق',
    memo_text2: '(أضف الكلمات المفتاحية فقط)',
    memo_text3: 'الأمور التي يجب التحقق منها عند الكتابة',
    memo_text4: 'مشاركتك تنتهك لوائح المحتوى الواردة في المادة 2، الفقرة 1 من شروط الخدمة. لن يتم نشرها.',
    memo_text5: 'عرض شروط الخدمة',
    memo_text6: 'لترك كتاب صغير بلغة أخرى،',
    memo_text7: 'يرجى الكتابة بهذه اللغة (لن تتم الترجمة تلقائيًا)',
    book_create_button: 'قم بإنشاء كتاب مصغر',
    book_create_title: 'قم بإنشاء غلاف',
    book_create_cover: 'الغلاف',
    book_create_text1: 'خطوة لإنشاء غلاف لكتاب مصغر',
    book_create_text1_pc: 'أدخل العنوان واسم المؤلف',
    book_create_text2: 'لا توجد صورة غلاف أنشأتها',
    book_create_text3: '',
    book_create_text4: 'هل لديك صورة غلاف قمت بإنشائها؟',
    book_create_text5: 'هل أنشأت غلافًا خاصًا بك؟',
    book_create_text6: 'يرجى التحميل باستخدام الزر أدناه',
    book_create_text7: '(صيغة jpg، بحجم أقل من 20 ميجابايت)',
    book_create_text8: 'صلاحية إضافة صفحات',
    book_create_text9: 'أنا فقط',
    book_create_text10: 'أي شخص',
    book_create_text11: 'عرض العنوان على الصورة',
    book_create_text12: 'عرض',
    book_create_text13: 'لا تعرض',
    book_create_text14: 'حدد لغة الترجمة',
    book_create_text15: 'اختر الكل',
    book_create_text16: 'تحميل صورة الغلاف',
    book_create_text17: 'يمكنك التعديل',
    book_create_text18: 'أعد الترجمة من خلال النقر على الأيقونة في أعلى اليمين بعد التعديل.',
    book_create_text19: 'لإعادة الترجمة وفقًا للنص الأصلي، اضغط على الأيقونة في أعلى اليمين',
    book_create_text20: 'إعادة الترجمة',
    book_create_text21: 'صورة',
    book_create_text22: 'العنوان',
    book_create_text23: 'كلمة مفتاحية',
    book_create_text24: 'المحتوى',
    book_create_text25: 'سيتم تحديث الترجمة فقط إذا تم حذف الصورة وإعادة تحميلها',
    book_create_text26: '(لن يتم حذف الصفحة)',
    book_create_text27: 'يرجى كتابة مقدمة مختصرة',
    book_create_text28: 'حفظ مؤقت',
    book_create_text29: 'تم الحفظ مؤقتًا',
    book_create_text30: 'أمور يجب التحقق منها',
    book_create_text31: 'محتوى النص هو النسخة النهائية ولا يحتاج إلى أي تعديل إضافي',
    book_create_text32: 'لم يتم استخدام كلمات أو رموز غير مفهومة للذكاء الاصطناعي المترجم',
    book_create_text33: 'لم يتم نسخ الصورة ولصقها، بل تم إدخالها كملف منفصل',
    book_create_text34: 'هل نفتح باب التقديم؟ (كتاب صغير مفتوح)',
    book_create_text35: 'المؤلفون المشاركون',
    book_create_text36: 'هل تريد الإضافة يدويًا؟',
    book_create_text37: 'أضف',
    book_create_text38: 'الكتاب الصغير الذي ينتشر أكثر عندما نكتبه معًا',
    book_create_text39: 'قوة المؤلفين المشاركين التي لا تعرفها',
    book_create_text40: 'فتح باب التقديم',
    book_create_text41: 'إلغاء',
    book_create_text43: 'فكرة؟',
    book_create_text44: 'نسخ المحتوى ولصقه',
    book_create_text45: 'هل تحتاج إلى فكرة؟',
    book_create_text46: 'خيارات البيع',
    book_create_text47: 'مجاني',
    book_create_text48: 'راعٍ',
    book_create_text49: 'شراء',
    book_create_text50: 'السعر الحالي',
    book_create_text51: 'تعديل السعر',
    book_create_text52: 'لا يمكن التعديل إلى 0',
    book_create_text53: 'لا يمكن تغيير السعر أو خيارات البيع للكتاب الصغير الذي تم شراؤه أو رعايته',
    book_create_text54: 'يمكن فقط لمؤلف الكتاب الصغير الرد على الرسائل',
    book_create_button_upload: 'تحميل',
    book_create_button_make: 'إنشاء',
    book_create_cover_topic_placeholder: 'سيظهر العنوان بهذا الشكل',
    book_create_topic_placeholder: 'أدخل عنوانًا',
    book_create_keyword_placeholder: 'الكلمات المفتاحية (ضع مسافة بين كل كلمة)',
    book_create_category_placeholder: 'اختر الفئة',
    book_create_knowledge_placeholder: 'اكتب مقدمة لكتابك المصغر<br/>** تنبيه - اكتب التفاصيل في خطوة إنشاء الصفحات',
    book_create_category_option1: 'أفلام ومسلسلات',
    book_create_category_option2: 'الموسيقى والاستعراضات',
    book_create_category_option3: 'فنون أخرى',
    book_create_category_option4: 'الموضة والأناقة',
    book_create_category_option5: 'المأكولات والطهي',
    book_create_category_option6: 'الخمور والمشروبات',
    book_create_category_option7: 'وجبات خفيفة وحلويات',
    book_create_category_option8: 'النباتات والصحة',
    book_create_category_option9: 'تحقيق الثراء',
    book_create_category_option10: 'تطوير الذات',
    book_create_category_option11: 'علاقات',
    book_create_category_option12: 'معارف جديدة',
    book_create_category_option13: 'قصص من الحياة',
    book_create_category_option14: 'الفلسفة والمبادئ',
    book_create_category_option15: 'الدين والتقاليد',
    book_create_category_option16: 'الحب ',
    book_create_category_option17: 'السفر والمعالم السياحية',
    book_create_category_option18: 'الهوايات ',
    book_create_category_option19: 'ثقافة الألعاب والترفيه',
    book_create_category_option20: 'الأساطير والأبطال',
    book_create_category_option21: 'الرحلات الأدبية',
    book_create_category_option22: 'التاريخ والحكمة',
    book_create_category_option23: 'قصص اجتماعية',
    book_create_message1: 'أدخل عنوانًا',
    book_create_message2: 'أدخل اسم المؤلف',
    book_create_message3: 'أدخل الكلمات المفتاحية',
    book_create_message4: 'أدخل أكثر من 3 كلمات مفتاحية',
    book_create_message5: 'اختر الفئة',
    book_create_message6: 'أنشئ صورة الغلاف',
    book_create_message7: 'لا يمكنك إدخال أحرف خاصة. يجب وضع مسافة بين الكلمات المفتاحية',
    book_create_message8: 'هل ترغب في حذف الكتاب المصغر؟',
    book_create_message9: 'ليس لديك حق النشر لهذه اللغة',
    book_create_message10: 'لا يمكن حذف الكتاب الصغير الذي تم شراؤه',
    book_create_modal_text1: 'يرجى الانتظار لحظة..',
    book_create_modal_text2: 'يقوم الذكاء الاصطناعي بمراجعة المحتوى، وترجمة اللغات الأجنبية، وربط شبكة المعرفة',
    book_create_modal_text3: 'الاتصال بقاعدة المعرفة للبحث في  الصفحات واحدة تلو الأخرى',
    book_create_modal_text4: 'العنوان لا يظهر على صورة الغلاف',
    book_create_modal_text5: '(ينطبق هذا أيضًا على الأغلفة المترجمة إلى لغات أجنبية)',
    book_view_title: 'عرض عام للكتاب المصغر',
    book_view_share: 'مشاركة',
    book_view_event_topic: 'موضوع الحدث',
    book_view_together_suggest: 'اقتراح فضاء الحدث',
    book_view_together_message: 'ليس لديك أي ملتقى جماعى مفضل. انتقل إلى قائمة الملتقيات الجماعية واختر',
    book_view_event_message: 'لا يوجد حدث قمت بإنشائه',
    book_view_text1: 'لم تتم إضافة أي صفحات.',
    book_view_text2: 'لماذا لا تضيفها الآن؟',
    book_view_text3: 'الكتاب المصغر غير موجود. يرجى المحاولة مرة أخرى',
    book_view_text4: 'جدول الصفحات',
    book_view_text5: 'ما رأيك في تحسين ترجمة هذا الكتاب الصغير أو الترويج له ومشاركة الأرباح؟',
    book_view_text6: 'قائمة الصفحات',
    book_view_text7: 'تعديل السعر',
    book_view_text8: 'لا يمكن تعديله لوجود مشتري',
    book_view_text9: 'هدية القارئ',
    book_view_text10: 'يمكن فقط لمؤلف الكتاب الصغير الرد على الرسائل',
    book_view_modal_title: 'تحسين الترجمة والترويج',
    book_view_modal_text1: 'هل يمكنك تحسين ترجمة هذا الكتاب الصغير بنفسك؟ أو الترويج له؟',
    book_view_modal_text2: 'اترك رسالة للمؤلف',
    book_view_modal_text3: 'إذا وافق المؤلف، يمكنكم مشاركة الأرباح',

    book_view_write_share_title: 'كتاب صغير مفتوح',
    book_view_write_share_text1: 'هل تريد أن تصبح مؤلفًا مشاركًا لهذا الكتاب الصغير؟',
    book_view_write_share_text2: 'قدم طلب المؤلف',
    book_view_write_share_text3: 'يرجى ترك طلب بسيط',
    book_view_write_share_text4: 'إرسال',
    book_view_write_share_list_title: 'المؤلفون المشاركون',
    book_view_write_share_text5: 'قم بإدارة المؤلفين المشاركين في الكتاب الصغير',
    book_view_write_share_text6: 'إدارة المؤلفين',
    book_view_write_share_text7: 'قبول',
    book_view_write_share_text8: 'تم القبول',
    book_view_write_share_text9: 'المستخدم مسجل بالفعل كمؤلف',
    book_view_write_share_text10: 'إضافة المؤلف يدويًا',
    book_view_write_share_text11: 'المستخدم قد قدم الطلب بالفعل',
    book_view_publish_text1: 'هل ترغب في نشر هذا الكتاب المصغر؟',
    book_view_publish_text2: 'عند النشر، يصبح الكتاب متاحًا للجميع، ويمنحك فرصة لجني الأرباح',
    book_view_publish_text3: '(إذا كنت ستنشر للبيع، لا يمكنك إضافة صفحات من مؤلفين آخرين)',
    book_view_publish_text4: 'قُم بتحديد السعر',
    book_view_publish_text5: 'تاريخ النشر',
    book_view_publish_text6: 'طلب النشر',
    book_view_publish_text7: 'النشر الفوري',
    book_view_publish_text8: 'نشر الكتاب',
    book_view_publish_text9: 'لم يتم بعد',
    book_view_publish_text10: 'قيد التنفيذ',
    book_view_publish_text11: 'تم النشر',
    book_view_publish_text12: 'الأمور التي يجب التحقق منها عند النشر',
    book_view_publish_text13: 'هذا الكتاب المصغر لم يُنشر من قبل في YouBook',
    book_view_publish_text14: 'لم يتم انتحال أي محتوى أو حقوق ملكية فكرية خاصة بالآخرين في هذا الكتاب الصغير أو صفحاته',
    book_view_publish_text15: 'هذا الكتاب المصغر لا يحتوي على ألفاظ نابية، محتوى جنسي غير لائق، تشويه لسمعة الآخرين، أو إعلانات تجارية، ولا يخالف المادة 2، الفقرة 1 من شروط الاستخدام.',
    book_view_publish_text16: 'نعم',
    book_view_publish_text17: 'تقرير النشر',
    book_view_publish_text18: 'تم النشر',
    book_view_publish_text19: 'التاريخ',
    book_view_publish_text20: 'السعر',
    book_view_publish_text21: 'تحديد فترة عرض المحتوى',
    book_view_publish_text22: 'فترة عرض المحتوى',
    book_view_publish_text23: 'ما هي فترة عرض المحتوى',
    book_view_publish_text24: 'فترة عرض المحتوى تشير إلى الوقت الذي يمكن للقراء فيه الاطلاع على المحتوى',
    book_view_publish_text25: 'هذا الكتاب المصغر يحتوي على أكثر من 3 صفحات',
    book_view_publish_text26: 'هذا الكتاب المصغر لا يحتوي على أكثر من 3 صفحات',
    book_view_publish_text27: 'إذا تم رصد أي انتهاكات، قد يقوم النظام بتعديل ترتيب البحث الخاص بكِ. في حال وجود انتهاكات جسيمة، سيتم حذف الكتاب المصغر بشكل تلقائي',
    book_view_publish_text28: 'تعيين خيارات البيع',
    book_view_publish_text29: 'طريقة الشراء',
    book_view_publish_text30: 'طريقة الدعم',
    book_view_publish_message1: 'إذا قمت بالنشر للبيع، تأكد من أن\n1) الصفحات في الكتاب المصغر من إعدادك و\n2) أنك لم تقم بنشرها مقابل أجر من قبل',
    book_view_publish_message2: 'لا يمكن نشره في حالته الحالية. يرجى التواصل مع المدير للحصول على الدعم',
    book_view_publish_message3: 'تم نشر هذا الكتاب المصغر بالفعل',
    book_view_publish_message4: 'يرجى اختيار فترة عرض المحتوى بعد الوقت الحالي',
    book_view_publish_message5: 'يرجى اختيار كل من التاريخ والوقت',
    book_view_publish_message6: 'تمت الموافقة على النشر. شكرًا لك',
    book_view_publish_message7: 'يرجى التحقق من عناصر التأكيد',
    book_view_publish_message8: 'لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء',
    book_view_publish_message9: 'لا يمكن نشر الكتاب الصغير الذي هو في حفظ مؤقت.',
    book_view_publish_message10: 'هذا الكتاب الصغير مُحوّل. حقوق النشر الأصلية تخص المؤلف',
    book_view_publish_message11: 'يرجى إدخال مبلغ لا يقل عن {minPrice}',
    book_view_button_confirm: 'تم التأكيد',
    book_view_button_publish: 'انشره',
    book_view_button_order: 'تنسيق الصفحة',
    book_view_button_add: 'أضف صفحة',
    book_view_button_video: 'تشغيل الفيديو',
    book_view_button_read: 'اقرأ',
    book_view_button_lecture: 'شاهد فيديو المحاضرة',
    book_view_page_add_title: 'أضف صفحة',
    book_view_page_add_text1: 'بعد البحث عن صفحة طرف ثالث',
    book_view_page_add_text2: 'في شاشة عرض الصفحة',
    book_view_page_add_text3: 'أضف إلى كتابي المصغر',
    book_view_page_add_text4: 'ماذا إذا أردت إنشاء صفحتك الخاصة؟',
    book_view_page_add_text5: 'إنشاء الصفحات متاح فقط للمؤلفين المسجلين. <br/> إذا كنت ترغب في التسجيل كمؤلف، <br/> يرجى الاتصال بنا أدناه.',
    book_view_page_add_text6: 'هل ترغب في إضافة صفحة طرف ثالث؟',
    book_view_page_add_text7: '* إذا تمت إضافة صفحة أنشأها طرف ثالث\nلا يمكن نشرها ككتاب صغير مدفوع',
    book_view_page_add_text8: 'هل لديك صفحات قمت بإنشائها من قبل؟',
    book_view_page_add_button1: 'أنشئه الآن',
    book_view_page_add_button2: 'عرض الصفحات التي تم إنشاؤها',
    book_view_reference_text1: 'التنوع',
    book_view_reference_text2: 'متعدد',
    book_view_reference_text3: 'مؤلف الكتاب المصغر',
    book_view_reference_text4: 'أنشئ بواسطة المؤلف',
    book_view_support_text1: 'ادعمك',
    book_view_support_modal_title: 'كن داعمًا',
    book_view_support_modal_text1: 'بغض النظر عن جودة الكتابة، من الصعب نشرها في العالم بمفردك.',
    book_view_support_modal_text2: 'الداعم هو من يشارك كتاب المؤلف الصغير مع العالم. هو شخص يدعم الآخرين.',
    book_view_support_modal_text3: 'ننضم معًا لننشر القصة أبعد.',
    book_view_support_modal_text4: 'كن داعمًا للمؤلف من فضلك',
    book_view_support_modal_btn1: 'فهمت',
    book_view_support_modal_text5: '"دعمك يعني لي الكثير. شكرًا لك. سأدعم رحلتك أيضًا بكل قلبي."',
    book_view_support_modal_text6: 'رجاءً شارك الكتاب الصغير مع العالم',
    book_view_support_modal_btn2: 'كيف أفعل ذلك؟',
    book_view_support_modal_title2: 'لقد وصلت إلى هنا، أحسنت',
    book_view_support_modal_text7: 'لم يكن من السهل الكتابة، لكنني فعلت ذلك.',
    book_view_support_modal_text8: 'حان الوقت الآن لأثق بنفسي وأتقدم خطوة أخرى.',
    book_view_support_modal_text9: 'حتى إن شعرت بالخجل أو التردد، سأكون أول داعم لي وأشارك مع العالم.',
    book_view_support_modal_text10: 'لأني أؤمن أنه قد يعني شيئًا لشخص ما.',
    book_view_support_modal_text11: 'كن داعمي من فضلك',
    book_view_support_modal_text12: 'كتابة النص أو تنظيم الحدث لم يكن سهلاً، لكنني خضت التحدي.',
    book_view_support_modal_btn3: 'سأجرب!',
    book_view_support_modal_title3: 'مرحبًا أيها الداعمًا',
    book_view_open_minibook_text1: 'تم إكمال طلب فتح الكتاب الصغير',
    book_view_open_minibook_text2: 'تم إلغاء طلب فتح الكتاب الصغير',
    page_create_title: 'إنشاء صفحة',
    page_create_text1: 'لا توجد صورة صفحة أنشأتها',
    page_create_text2: '',
    page_create_text3: 'صفحة',
    page_create_text4: 'هل لديك صورة صفحة أنشأتها',
    page_create_text5: 'هل قمت بإنشاء صورة للصفحة؟',
    page_create_text6: 'ضع محتواك هنا.\nيفضل أن لا يتجاوز محتواك ورقة A4 واحدة',
    page_create_text7: 'الحجم الحالي بالبايت',
    page_create_text8: 'موصى به',
    page_create_text9: 'هل هناك مراجع في هذه الصفحة؟',
    page_create_text10: 'أنشئت بواسطتك',
    page_create_text11: 'كتاب مرجعي',
    page_create_text12: 'مدونة مرجعية',
    page_create_text13: 'تم الرجوع إلى AI',
    page_create_text14: 'هذه هي الخطوة لإنشاء الصفحات للكتاب المصغر',
    page_create_text15: 'تحميل صورة الصفحة',
    page_create_text16: 'هل تريد إعادة الترجمة؟',
    page_create_text17: 'إذا كنت ترغب في إعادة الترجمة، يرجى اختيار الهدف واللغة (إذا لم تختر، سيتم الحفظ بدون ترجمة)',
    page_create_text18: 'الهدف المراد ترجمته',
    page_create_text19: 'اللغة المراد الترجمة إليها',
    page_create_message1: 'لا يمكن تعديله',
    page_create_message2: 'أدخل المحتوى الخاص بك',
    page_create_message3: 'هل تريد حذف الصفحة؟',
    page_create_message4: 'حجم المحتوى يتجاوز الحد المسموح به',
    page_create_reference_book: 'كتاب',
    page_create_reference_blog: 'مدونة',
    page_create_reference_placeholder1: 'أدخل عنوان الـ',
    page_create_reference_placeholder2: 'رابط ذو صلة (مثل https://www.amazon.com/dp…)',
    page_create_reference_placeholder3: 'سنة نشر الـ',
    page_create_reference_placeholder4: 'مؤلف هذا الـ',
    page_create_title_placeholder: 'سيبدو العنوان هكذا',
    page_create_message5: 'جاري الترجمة',
    page_create_message6: 'بعد إنشاء الغلاف، يمكنك إنشاء صفحة',
    page_create_modal_text1: 'العنوان لا يظهر على صورة الصفحة',
    page_create_modal_text2: '(ينطبق هذا أيضًا على الصفحات المترجمة إلى لغات أجنبية)',
    page_create_modal_text3: 'يرجى التأكد من التحقق!',
    page_create_modal_text4: 'إذا كان هناك المحتوى مُعدَّلاً، يجب حفظ مؤقت.',
    page_create_modal_text5: 'هل قمت بذلك؟',
    page_create_modal_text6: 'إذا كان هناك المحتوى مُعدَّلاً، يجب إنشاء.',
    page_view_title: 'عرض الصفحة',
    page_view_button_video: 'تشغيل الفيديو',
    page_view_button_read: 'اقرأ',
    page_view_text1: 'اضف في كتابي المصغر ',
    page_view_text2: 'تشغيل تلقائي',
    page_view_text3: 'مقروءات',
    page_view_text4: 'صفحة ذات صلة',
    page_view_text5: 'الكتاب المصغر المرتبط',
    page_view_text6: 'مرجع',
    page_view_text7: 'مرجع',
    page_view_text8: 'النشر',
    page_view_text9: 'المؤلف',
    page_view_text10: 'العنوان',
    page_view_text11: 'جميع الصفحات الخاصة بهذا المرجع',
    page_view_text12: 'بحث ذو صلة',
    page_view_text13: 'مؤلف الصفحة',
    page_view_text14: 'قابل المؤلف',
    page_view_text15: 'ضع في',
    page_view_reference_text1: 'كتاب',
    page_view_reference_text2: 'مدونة',
    page_view_popup: 'لا تمتلك أي كتب مصغرة <br /> من إنشائك. <br /><br /> من فضلك، قم بإنشاء كتاب مصغر جديد على صفحتك <br /> "ملفي الشخصي"',
    page_view_pay_popup_text1: 'هل استفدت من القراءة؟ \nردّ على الكاتب بهدية صغيرة.',
    page_view_pay_popup_title: 'إرسال هدية',
    page_view_pay_popup_text2: 'اختر نوع الشاي لإرساله كهدية',
    page_view_pay_popup_text3: 'اكتب رسالة من القلب',
    page_view_pay_popup_placeholder1: 'كانت كلمات الكاتب وحكمته مصدر إلهام حقيقي.',
    page_view_pay_popup_text4: 'المبلغ',
    page_view_pay_popup_button1: 'اشترِ وأرسل الرسالة',
    page_view_pay_popup_text5: 'خصص الكاتب وقتًا وجهدًا كبيرين لكتابة هذا. \n\nردّ بهدية صغيرة.',
    page_view_pay_popup_placeholder2: 'أعتمد على حكمة وتجربة الكاتب.',
    page_view_pay_popup_text6: 'لست مهتمًا بإرسال هدية؟',
    page_view_pay_popup_text7: 'تفضل مشاهدة إعلان بدلاً من ذلك؟',
    page_view_pay_popup_button2: 'شاهد إعلانًا للقراءة',
    page_sort_title: 'تنسيق الصفحة',
    page_sort_subtitle: 'اسحب الصفحة لتغيير الترتيب',
    page_sort_text: 'المصدر',
    pay_button: 'اشتري الآن',
    pay_price: 'السعر',
    pay_vat_excluded: '(لا يشمل ضريبة القيمة المضافة)',
    pay_message_success: 'تم الشراء',
    pay_message_fail: 'فشل',
    // pay_currency: 'دولار أمريكي',
    pay_currency: 'USD',
    pay_button_paid: 'مدفوع',
    pay_button_view_price: 'عرض السعر',
    pay_total: 'الإجمالي',
    pay_methods: 'طرق الدفع',
    pay_methods_creditcard: 'بطاقة ائتمان',
    pay_methods_paypal: 'باي بال',
    pay_button_continue: 'متابعة',
    pay_text1: 'يرجى اختيار الشاي',
    pay_text2: 'يرجى إدخال رسالة',
    advertisement_button: 'اقرأ المزيد',
    advertisement_text1: 'يمكنك عرض المحتوى بعد مشاهدة الإعلان.',
    advertisement_text2: 'هذه صفحة من كتاب صغير مدفوع. <br />اذهب إلى الغلاف واضغط على "اقرأ" للشراء. <br />',
    advertisement_text3: 'يمكنك عرض المحتوى بعد مشاهدة الإعلان. يمكن مشاهدة الإعلان في التطبيق.',
    together_title: 'حدث',
    together_subtitle: 'التقِ بالقراء وتحدث معهم',
    together_subtitle_text1: 'التقِ بالقراء عبر الإنترنت',
    together_subtitle_text2: 'أنشئ غرفة ووجه الدعوات للآخرين',
    together_button: 'أنشئ فضاء الحدث',
    together_case: 'حالة',
    together_case1: 'ما تقدمه يعود إليك أضعافًا',
    together_case2: 'لم أعرف مثالًا حقيقيًا مفيدًا بهذا الشكل من قبل',
    together_subtitle2: 'الفضاء الذي أنشأته',
    together_category1: 'الأحدث',
    together_category2: 'الأكثر تفضيلاً',
    together_button_viewmore: 'المزيد',
    together_list_date: 'YYYY. MM. DD',
    together_list_date2: 'YYYY. MM. DD A hh:mm  ',
    together_subtitle3: 'مثل هذا الفضاء',
    together_subtitle3_1: 'أنشئه من فضلك',
    together_subtitle_text3: 'سأشارك مع من يبدأ',
    together_create_title: 'إنشاء فضاء الحدث',
    together_create_title2: 'تحرير فضاء الحدث',
    together_create_button1: 'اختر',
    together_create_subtitle: 'العنوان',
    together_create_placeholder1: 'أدخل عنوانًا',
    together_create_subtitle1: 'مقدمة مختصرة',
    together_create_placeholder2: 'أدخل مقدمة مختصرة',
    together_create_subtitle2: 'اختر الأداة التي تريد استخدامها',
    together_create_text1: 'رابط الاجتماع عبر الإنترنت (مثل رابط Zoom)',
    together_create_placeholder3: 'أدخل رابط الاجتماع عبر الإنترنت هنا من فضلك',
    together_create_question1: 'لا تعرف رابط Zoom؟',
    together_create_q1_a_title: 'ابحث عن رابط للانضمام إلى Zoom',
    together_create_text2: 'استخدام عالم الميتافيرس',
    together_create_placeholder4: 'اختر ما يناسب الملتقى الجماعي',
    together_create_question2: 'لا تعرف الميتافيرس؟',
    together_create_text3: 'اختر مكان الفتح',
    together_create_dropmenu1: 'فتح في ركن الدعوات الفكرية على YouBook ',
    together_create_dropmenu2: 'افتح في ركن الكُتّاب والقراء',
    together_create_button2: 'حفظ',
    together_create_button3: 'إنشاء',
    together_create_popup_title: 'اختر ما يناسب الملتقى الجماعي',
    together_create_popup_alert: 'تم الاختيار بالفعل',
    together_create_button4: 'اختر',
    together_create_alert: 'يرجى إدخال رابط الاجتماع عبر الإنترنت',
    together_create_alert1: 'أدخل عنوانًا',
    together_create_alert2: 'اختر الميتافيرس للاستخدام',
    together_create_alert3: 'لا يمكن التعديل',
    together_create_alert4: 'تم إنشاء فضاء الحدث',
    together_create_alert5: 'خطأ. يرجى المحاولة مرة أخرى',
    together_create_alert6: 'فشل في إنشاء فضاء الحدث...',
    together_qa_popup_title1: 'ابحث عن رابط للانضمام إلى Zoom',
    together_qa_popup_btext1: 'كمبيوتر',
    together_qa_popup_text1: ' : افتح برنامج Zoom - بعد تسجيل الدخول -',
    together_qa_popup_text1_1: 'انقر على قائمة الاجتماعات في الأعلى - معرف الاجتماع الشخصي - انقر على "إظهار دعوة الاجتماع" - سيظهر رابط للانضمام إلى اجتماع Zoom. قم بنسخه.',
    together_qa_popup_btext2: 'هاتف ذكي',
    together_qa_popup_text2: ': افتح برنامج Zoom - بعد تسجيل الدخول -',
    together_qa_popup_text2_1: 'اضغط على زر i في أعلى اليمين - أرسل الدعوة',
    together_qa_popup_text2_2: 'بعد الضغط على الرسالة - أدخل رقم هاتفك -',
    together_qa_popup_text2_3: 'سيظهر رابط. انسخه.',
    together_qa_popup_title2: 'ما هو الميتافيرس؟',
    together_qa_popup_text3: 'هذا هو مساحة اجتماعات افتراضية.',
    together_qa_popup_text4: 'يظهر على شكل صورة رمزية',
    together_qa_popup_text5: 'قمت بإنشائها - تتحدث إلى أصدقائك وجهًا لوجه - يمكنك أيضًا مشاركة شاشتك.',
    together_qa_popup_text7: 'في مساحة اجتماع واحدة',
    together_qa_popup_text8: '- يمكن أن يدخل 10 أشخاص في نفس الوقت.',
    together_qa_popup_text9: 'لا حاجة لتثبيت برنامج منفصل',
    together_qa_popup_text10: 'ولا يتطلب تسجيل عضوية.',
    together_more_list_title: 'فضاء الحدث',
    together_more_list_date: 'YYYY. M. D',
    together_request_list_title: 'أنشئه من فضلك',
    together_request_list_category1: 'الأكثر تفضيلاً',
    together_request_list_category2: 'الأحدث',
    together_request_list_button: 'اقتراح فضاء جديد',
    together_request_popup_title: 'اقتراح جديد لفضاء',
    together_request_popup_alert1: 'أدخل عنوانًا',
    together_request_popup_alert2: 'أدخل مقدمة مختصرة',
    together_request_popup_placeholder1: 'أدخل عنوانًا',
    together_request_popup_placeholder2: 'أدخل مقدمة مختصرة',
    together_request_popup_button: 'حفظ',
    together_request_detail_button: 'أنشئ هذا الفضاء',
    together_detail_sns: 'مشاركة',
    together_detail_enterbtn: 'ادخل',
    together_detail_btn1: 'قائمة الأحداث',
    together_detail_btn2: 'رسالة',
    together_detail_subtitle: 'الكتاب المصغر المتعلق بالموضوع',
    together_detail_alert: 'انتظر لحظة..',
    together_detail_alert1: 'تم اقتراح فضاء الحدث بنجاح!',
    together_detail_alert2: 'فشل في اقتراح فضاء الحدث…',
    together_detail_alert3: 'المفضلة / تم إلغاء المفضلة بنجاح',
    together_detail_alert4: 'المفضلة / فشل إلغاء المفضلة',
    together_detail_alert5: 'مشكلة في الخادم، يرجى المحاولة لاحقًا',
    together_detail_alert6: 'هناك مشكلة في رابط الاجتماع عبر الإنترنت',
    together_detail_alert7: 'فشل في الحذف',
    together_notice_alert: 'هل ترغب في حذف الإعلان؟',
    together_notice_list_title: 'إعلان',
    together_button_addtopic: 'أضف هذا إلى موضوع فضاء الحدث',
    together_add_alert: 'تمت الإضافة إلى فضاء الحدث',
    together_text1: 'أذواق مشابهة لذوقك.',
    together_text2: 'هل تريد حذف فضاء الحدث؟',
    together_event_btn: 'إنشاء حدث جديد',
    together_event_title: 'حدث جديد',
    together_event_placeholder: 'أدخل المقدمة',
    together_event_text1: 'حدد الجدول الزمني',
    together_event_text2: 'حدد رسوم الدخول',
    together_event_text3: 'حدد الحد الأقصى للأفراد',
    together_event_text4: 'جدول',
    together_event_text5: 'رسوم الدخول',
    together_event_text6: 'الحد الأقصى للأفراد',
    together_event_text7: 'إخطار المتابِعين',
    together_event_text8: 'هل تريد حذف الحدث؟',
    together_event_text9: 'يرجى ضبط وقت البدء بعد الوقت الحالي',
    together_event_text10: 'يرجى ضبط وقت الانتهاء بعد وقت البدء',
    together_event_text11: 'لا يمكن أن يكون وقت البدء ووقت الانتهاء متطابقين',
    together_event_text12: 'أضف هذا إلى موضوع الحدث',
    together_event_text13: 'تمت الإضافة إلى الحدث',
    together_event_text14: 'تم تجاوز الحد الأقصى للأفراد في الحدث',
    together_event_text15: 'زر يكون نشطًا قبل حدث بساعة\n (في حالة المجانية اشتري الآن حاجة لا)',
    together_event_text16: 'زر يكون نشطًا قبل حدث بساعة',
    together_event_text17: 'لا يوجد حدث',
    together_event_text18: 'لا يمكن حذفه إذا كان هناك مشترٍ للحدث',
    together_event_text19: 'هل تريد إرسال إشعار؟',
    together_event_text20: 'تم الإرسال',
    together_event_text21: 'قائمة الحدث',
    together_event_text22: 'عرض التفاصيل',
    together_event_text23: 'التسجيل بعد تسجيل الدخول',
    together_event_text24: 'طريقة الحضور',
    together_event_text25: 'اكتمل الانضمام إلى الحدث',
    together_event_text26: 'خصص المؤلف الكثير من الوقت والاهتمام لهذا الحدث.\n\nيرجى الرد بهدية صغيرة.',
    together_event_text27: 'كانت الحكمة المتأتية من تجربة المؤلف والتواصل العميق مؤثرة للغاية',
    together_event_text28: 'انشر هذا الحدث للعالم',
    together_event_text29: 'لم يكن فتح هذا الحدث سهلاً، لكنني فعلت ذلك.',
    together_event_text30: 'بغض النظر عن روعة الحدث، من الصعب نشره في العالم بمفردك.',
    together_event_text31: 'الـ داعم هو الشخص الذي ينشر حدث المؤلف إلى العالم. إنه شخص يشجع الآخرين ويدعمهم.',
    youbooker_title: 'YouBooker',
    youbooker_subtitle: 'التقِ بأشخاص من جميع أنحاء العالم',
    youbooker_case: 'حالة',
    youbooker_case_text1: 'كون الشخص الذي يبدأ دائمًا',
    youbooker_case_text2: 'تأثير الفائدة المركبة للمعرفة؟',
    youbooker_translation: 'هل تريد الالتقاء الآن فورًا؟',
    youbooker_translation_text1: 'جميع اللغات',
    youbooker_category: 'المتابِعون / المتابَعون',
    youbooker_subcategory1: 'متابعيني',
    youbooker_subcategory2: 'أتابع',
    youbooker_subtitle2: 'هؤلاء يتابعونني',
    youbooker_button_follow: 'تابع',
    youbooker_message_follow: 'تابع',
    youbooker_button_follow_cancel: 'إلغاء المتابعة',
    youbooker_subtitle3: 'هؤلاء هم المستخدمون الذين تعرفهم',
    youbooker_subtitle4: 'أنا أتابعهم',
    youbooker_subtitle5: 'هؤلاء لا يعرفون YouBook بعد',
    youbooker_button_invite: 'دعوة',
    youbooker_alert_invite: 'الدعوة ممكنة فقط من خلال التطبيق. يرجى تحميل التطبيق',
    youbooker_alert: 'متاح فقط في التطبيق. لماذا لا تقوم بتحميل التطبيق؟',
    youbooker_alert2: 'تم التحديث بنجاح!',
    youbooker_alert3: 'يمكنك استخدام علامة تبويب YouBooker للبحث',
    home_page_text1: 'الأحدث',
    home_page_text2: 'التأثير',
    home_page_today_title: 'قضايا اليوم',
    home_page_today_subtitle: 'مرتبط بالأخبار الأكثر تداولًا',
    home_page_slider_date: 'YYYY.MM.DD',
    home_page_today_list_title: 'قضايا اليوم',
    home_page_today_detail_sns: 'مشاركة',
    home_page_today_detail_date: 'YYYY.MM.DD',
    home_page_today_detail_subtitle: 'صفحات ذات صلة',
    home_page_explor_title: 'استكشاف الصفحات',
    home_page_explor_subtitle: 'ماذا لو نقرت مرتين؟',
    home_page_recommend_title: 'اقتراحات مخصصة لك',
    home_page_recommend_subtitle: 'صفحات قد تهمك',
    home_page_theysee_title: 'ما الذي يشاهدونه؟',
    home_page_theysee_subtitle: 'الصفحات الأكثر مشاهدة من القراء',
    home_page_common_title: 'المنطق السليم',
    home_page_common_subtitle: 'من الأفضل أن تعرف هذا',
    home_page_keyw_title: 'الصفحات حسب الكلمات المفتاحية',
    home_page_keyw_subtitle: 'ابحث عن جميع الصفحات ذات الصلة',
    home_page_random_title: 'انتقل عشوائيًا',
    home_page_random_subtitle: 'في حيرة؟ <br />اضغط لتتعلم شيئًا جديدًا',
    home_page_about_title: 'حول YouBook',

    home_page_about_detail: 'الشركة: NICK syndicate<br />المركز التجاري العربي: دبي<br />مراكز أخرى في الدول: طوكيو، شنغهاي، سيول<br />التواصل: joa@academy-connect.net<br />DUNS 695937905',
    settlement_title: 'الشراء والتسوية',
    settlement_tab1: 'سجل الطلب',
    settlement_tab2: 'معلومات الحساب',
    settlement_tab3: 'سجل التسوية',
    settlement_category1: 'سجل الشراء الخاص بي',
    settlement_category2: 'مشاركة حقوق النشر',
    settlement_category3: 'سجل تسوية إيرادات الكتاب الصغير',
    settlement_category4: 'سجل تسوية إيرادات الحدث',
    settlement_category5: 'إدارة الحساب',
    settlement_text1: 'يتم عرض سجل الشراء',
    settlement_text2: 'يمكن مشاركة حقوق النشر للكتاب الصغير',
    settlement_text3: 'أنت تتحقق من سجل تسوية الكتاب المصغر المدفوع الخاص بك',
    settlement_text4: 'إذا كان لديك أي أسئلة إضافية، انقر',
    settlement_text5: 'هنا',
    settlement_text6: 'أو يرجى الاتصال بنا أدناه.',
    settlement_text7: 'joa@academy-connect.net /',
    settlement_text8: 'قل كلمة',
    settlement_text9: 'في حالة وجود إيرادات، يجب إدارة الحساب لاستلام الأرباح',
    settlement_text10: 'يتم تسوية الإيرادات المكتسبة من الحدث',
    settlement_purchase_text1: 'سجل الشراء',
    settlement_purchase_text2: 'التاريخ',
    settlement_purchase_text3: 'مبلغ الشراء',
    settlement_purchase_text4: 'العنوان',
    settlement_purchase_text5: 'الكتاب الصغير',
    settlement_purchase_text6: 'الحدث',
    settlement_accountInfo_text1: 'حقوق النشر للكتاب الصغير',
    settlement_accountInfo_text2: 'الكتاب المصغر',
    settlement_accountInfo_text3: 'اللغة',
    settlement_accountInfo_text4: 'حقوق النشر',
    settlement_accountInfo_text5: 'المؤلف (أنا)',
    settlement_accountInfo_text6: 'الطرف الثالث (الناشرون، وما إلى ذلك)',
    settlement_accountInfo_text7: 'شخصي؟',
    settlement_accountInfo_text8: 'شخصي',
    settlement_accountInfo_text9: 'شركة',
    settlement_accountInfo_text10: 'اسم البنك',
    settlement_accountInfo_text10_message: 'اختر اسم البنك',
    settlement_accountInfo_text11: 'اسم صاحب الحساب',
    settlement_accountInfo_text11_message: 'أدخل اسم صاحب الحساب',
    settlement_accountInfo_text12: 'رقم الحساب',
    settlement_accountInfo_text12_message: 'أدخل رقم الحساب',
    settlement_accountInfo_text12_placeholder: '123456789000',
    settlement_accountInfo_text13: 'رقم الضمان الاجتماعي',
    settlement_accountInfo_text13_message: 'أدخل رقم الضمان الاجتماعي',
    settlement_accountInfo_text13_placeholder: '123-12-1234',
    settlement_accountInfo_text14: 'العنوان الشخصي',
    settlement_accountInfo_text14_message: 'أدخل العنوان الشخصي',
    settlement_accountInfo_text14_placeholder: '',
    settlement_accountInfo_text15: 'البريد الإلكتروني',
    settlement_accountInfo_text15_message: 'أدخل البريد الإلكتروني',
    settlement_accountInfo_text16: 'حفظ',
    settlement_accountInfo_text17: 'رقم تعريف صاحب العمل (EIN)',
    settlement_accountInfo_text17_message: 'أدخل رقم EIN',
    settlement_accountInfo_text17_placeholder: '12-3456789',
    settlement_accountInfo_text18: 'عنوان الشركة',
    settlement_accountInfo_text18_message: 'أدخل عنوان الشركة',
    settlement_accountInfo_text18_placeholder: '',
    settlement_accountInfo_text19: 'اسم الشركة',
    settlement_accountInfo_text19_message: 'أدخل اسم الشركة',
    settlement_accountInfo_text20: 'هاتف الشركة',
    settlement_accountInfo_text20_message: 'أدخل جهات اتصال الشركة',
    settlement_accountInfo_text21: 'معرف الطرف الثالث',
    settlement_accountInfo_text21_placeholder: 'بريد إلكتروني للطرف الثالث',
    settlement_accountInfo_text22: 'حساب لاستلام الدفع',
    settlement_accountInfo_text23: 'الدولة',
    settlement_accountInfo_message1: 'لا يمكن العثور على البريد الإلكتروني',
    settlement_accountInfo_message2: 'لا يمكن مشاركة حقوق النشر مع نفسك',
    settlement_accountInfo_message3: 'لا توجد كتب صغيرة تم إنشاؤها',
    settlement_accountInfo_text24: 'مشاركة حقوق النشر',
    settlement_accountInfo_text25: 'إذا قمت بمشاركة حقوق النشر مع طرف ثالث، فلن تتمكن من استعادتها',
    settlement_accountInfo_text26: 'هل ترغب في مشاركة حقوق النشر؟',
    settlement_accountInfo_text27: 'نعم، أشارك',
    settlement_accountInfo_text28: 'في حالة مشاركة حقوق النشر، 1) <br />يجب أن تكون الصفحات في الكتاب الصغير من إنشائك، و2) <br />لم يتم مشاركتها مسبقًا مع طرف ثالث',
    settlement_accountInfo_text29: 'حسنًا، سأقوم بإصلاح ذلك',
    settlement_accountInfo_text30: 'لقد قمت بتعيين حقوق النشر لهذا الكتاب المصغر إلى طرف ثالث',
    settlement_accountInfo_text31: 'المؤلف',
    settlement_accountInfo_text32: 'الطرف الثالث (أنا)',
    settlement_accountInfo_text33: 'لقد قمت بنقل حقوق النشر لهذا الكتاب المصغر من المؤلف',
    settlement_accountInfo_text34: 'هذا كتاب مصغر مجاني. لا يتطلب حسابًا',
    settlement_accountInfo_text35: 'تقاسم الإيرادات',
    settlement_accountInfo_text36: '(أنا)',
    settlement_accountInfo_text37: '(الناشرون، إلخ.)',
    settlement_accountInfo_text38: 'حساب شخصي',
    settlement_accountInfo_text39: 'حساب الشركة',
    settlement_accountInfo_text40: 'إدارة الحساب',
    settlement_accountInfo_text41: 'حفظ',
    settlement_accountInfo_text42: 'بنك',
    settlement_accountInfo_text43: 'اختيار الحساب',
    settlement_accountInfo_text44: 'حدد كيفية توزيع الإيرادات',
    settlement_accountInfo_text45: 'نسبة الإيرادات (%)',
    settlement_accountInfo_text46: 'معرفي (email)',
    settlement_accountInfo_text47: 'معرف الطرف الثالث (email)',
    settlement_accountInfo_text48: 'مطابقة المجموع',
    settlement_accountInfo_text49: 'يرجى إدخال معلومات الطرف الثالث',
    settlement_accountInfo_text50: 'لا يمكن أن تتجاوز نسبة الإيرادات 100',
    settlement_accountInfo_text51: 'تمنح (email)',
    settlement_accountInfo_text52: 'الطرف الثالث (email)',
    settlement_earnings_text1: 'سجل التسوية',
    settlement_earnings_text2: 'فترة التسوية',
    settlement_earnings_text3: 'سعر الكتاب المصغر ',
    settlement_earnings_text4: 'كمية المبيعات',
    settlement_earnings_text5: 'قيمة المبيعات',
    settlement_earnings_text6: 'الخصومات بما في ذلك الضرائب',
    settlement_earnings_text7: 'مبلغ الإيداع',
    settlement_earnings_text8: 'تاريخ الإيداع',
    settlement_earnings_text9: 'عدد مشاهدات الإعلان',
    settlement_earnings_text10: 'المبلغ الإجمالي',
    settlement_earnings_text11: 'المزيد من المعلومات',
    settlement_earnings_text12: 'سعر الإعلان',
    settlement_earnings_text13: 'الإيرادات',
    settlement_earnings_text14: 'جميع الكتب الصغيرة',
    settlement_earnings_text15: 'اختر حدثًا',
    settlement_earnings_text16: 'جميع الأحداث',
    settlement_statistics_text1: 'حجم المبيعات',
    settlement_statistics_text2: 'عدد القراء',
    settlement_statistics_text3: '(آخر)',
    settlement_statistics_text4: 'شهر ',
    settlement_statistics_text5: '6 أشهر',
    settlement_statistics_text6: 'سنة',
    settlement_statistics_text7: 'لا توجد بيانات متاحة',
    settlement_statistics_text8: 'تحليل المبيعات',
    settlement_statistics_text9: 'عدد مشاهدات الإعلانات',
    settlement_statistics_text10: 'جميع اللغات',
    terms_title: 'شروط الخدمة',
    terms_text: '',
    privacy_title: 'سياسة الخصوصية',
    privacy_text: '',
    // common text
    message_save: 'تم الحفظ',
    message_fail: 'فشل',
    message_delete: 'تم الحذف',
    message_report: 'تم الإبلاغ',
    message_search_no_result: 'لم يتم العثور على نتائج بحث',
    message_search_enter: 'يرجى إدخال مصطلح بحث',
    message_error1: 'حدث خطأ. يرجى الاتصال بالمسؤول',
    message_save2: 'تم الحفظ',
    message_fail2: 'فشل',
    message_login: 'تحتاج إلى تسجيل الدخول',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    mobile: 'الهاتف المحمول',
    list: 'القائمة',
    edit: 'تحرير',
    delete: 'حذف',
    search: 'بحث',
    report: 'الإبلاغ عن المحتوى',
    user: 'المستخدم',
    report_type: 'نوع البلاغ',
    report_type1: 'ألفاظ نابية / تشهير',
    report_type2: 'إعلان',
    report_type3: 'المحتوى الفاحش / الجنسي الصريح',
    report_type4: 'تكرار نفس المحتوى',
    report_type5: 'أخرى',
    search_book: 'البحث عن كتاب مصغر',
    serch_placeholder: 'البحث بالاسم أو البريد الإلكتروني',
    search_keyword: 'الكلمة المفتاحية',
    search_reference: 'مرجع',
    search_author: 'المؤلف',
    search_result: 'تم العثور عليه',
    button_report: 'الإبلاغ إلى YouBook',
    button_write: 'حفظ',
    button_login: 'تسجيل الدخول',
    button_more: 'المزيد',
    button_confirm: 'تم التأكيد',
    button_save: 'حفظ',
    button_crop: 'قص',
    button_delete: 'حذف',
    button_complete: 'تم',
    colorbox_background_text1: 'اختر لون الخلفية',
    colorbox_font_text1: 'اختر لون النص',
    menu_home: 'الرئيسية',
    menu_page: 'صفحة',
    menu_book: 'كتاب مصغر',
    menu_memo: 'مذكرة',
    menu_together: 'حدث',
    login_button: 'تسجيل الدخول',
    message_text1: 'الرد',
    message_text2: 'الرد جاء على تعليقي',
  },
};

export default translations;
